(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["argoseeker-activity-entry-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('argoseeker-activity-entry-v2')) {
      customElements.define(
        'argoseeker-activity-entry-v2',
        class ArgoseekerActivityEntryV2 extends HTMLElement {
          connectedCallback() {
            // 纯展示入口卡，预留扩展
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argoseeker-narrative-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('argoseeker-narrative-v2')) {
      customElements.define(
        'argoseeker-narrative-v2',
        class BrandNarrativeV2 extends HTMLElement {
          connectedCallback() {
            this._swiperEl = this.querySelector('.argoseeker-narrative-v2__swiper');
            if (!this._swiperEl || typeof Swiper === 'undefined') return;

            this._slideCount = this._swiperEl.querySelectorAll(
              '.swiper-wrapper > .argoseeker-narrative-v2__slide'
            ).length;

            // 仅 577–1200 挂载横滑（对齐 Figma 7310:7623）
            this._mqMid = window.matchMedia('(min-width: 577px) and (max-width: 1200px)');
            this._onMqChange = () => this._syncSwiper();
            if (this._mqMid.addEventListener) {
              this._mqMid.addEventListener('change', this._onMqChange);
            } else if (this._mqMid.addListener) {
              this._mqMid.addListener(this._onMqChange);
            }
            this._syncSwiper();
          }

          disconnectedCallback() {
            if (this._mqMid) {
              if (this._mqMid.removeEventListener) {
                this._mqMid.removeEventListener('change', this._onMqChange);
              } else if (this._mqMid.removeListener) {
                this._mqMid.removeListener(this._onMqChange);
              }
            }
            this._destroySwiper();
          }

          _syncSwiper() {
            const shouldEnable = this._mqMid && this._mqMid.matches && this._slideCount > 0;
            if (shouldEnable) {
              this._initSwiper();
            } else {
              this._destroySwiper();
            }
          }

          // 对齐 brand-song-video-v2
          _initSwiper() {
            if (!this._swiperEl) return;

            if (this._swiper) {
              this._swiper.update();
              return;
            }

            this._swiper = new Swiper(this._swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              slidesPerGroup: 1,
              watchOverflow: true,
              breakpoints: {
                0: { spaceBetween: 16 },
                577: { spaceBetween: 24 },
              },
            });
          }

          _destroySwiper() {
            if (!this._swiper) return;
            this._swiper.destroy(true, true);
            this._swiper = null;
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argoseeker-scenarios-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('argoseeker-scenarios-v2')) {
      customElements.define(
        'argoseeker-scenarios-v2',
        class ArgoseekerScenariosV2 extends HTMLElement {
          connectedCallback() {
            this.desktopMq = window.matchMedia('(min-width: 1201px)');
            this.items = this.querySelectorAll('.argoseeker-scenarios-v2__item');
            this.slides = this.querySelectorAll('.argoseeker-scenarios-v2__stage-slide');
            this._onClick = this.onClick.bind(this);
            this._onKeydown = this.onKeydown.bind(this);
            this.addEventListener('click', this._onClick);
            this.addEventListener('keydown', this._onKeydown);
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._onClick);
            this.removeEventListener('keydown', this._onKeydown);
          }

          onClick(event) {
            if (!this.desktopMq.matches) return;

            const item = event.target.closest('.argoseeker-scenarios-v2__item');
            if (!item || !this.contains(item)) return;

            this.setActive(item.getAttribute('data-index'));
          }

          onKeydown(event) {
            if (!this.desktopMq.matches) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;

            const item = event.target.closest('.argoseeker-scenarios-v2__item');
            if (!item || !this.contains(item)) return;

            event.preventDefault();
            this.setActive(item.getAttribute('data-index'));
          }

          setActive(index) {
            this.items.forEach((item) => {
              const isActive = item.getAttribute('data-index') === index;
              item.setAttribute('data-active', isActive ? 'true' : 'false');
              item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            this.slides.forEach((slide) => {
              const isActive = slide.getAttribute('data-index') === index;
              slide.setAttribute('data-active', isActive ? 'true' : 'false');
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argoseeker-sticky-bar-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('argoseeker-sticky-bar-v2')) {
      customElements.define('argoseeker-sticky-bar-v2', class ArgoseekerStickyBarV2 extends HTMLElement {});
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argoseeker-user-value-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('argoseeker-user-value-v2')) {
      customElements.define(
        'argoseeker-user-value-v2',
        class ArgoseekerUserValueV2 extends HTMLElement {
          connectedCallback() {
            this._swiperEl = this.querySelector('.argoseeker-user-value-v2__swiper');
            if (!this._swiperEl || typeof Swiper === 'undefined') return;

            const slideCount = this.querySelectorAll(
              '.argoseeker-user-value-v2__swiper > .swiper-wrapper > .argoseeker-user-value-v2__slide'
            ).length;
            this._slideCount = slideCount;
            this._progressEl = this.querySelector('[data-progress]');
            this._progressSegments = Array.from(this.querySelectorAll('[data-progress-segment]'));

            if (slideCount <= 1) {
              this.querySelectorAll('.argoseeker-user-value-v2__nav-btn').forEach((btn) => {
                btn.style.display = 'none';
              });
              if (this._progressEl) {
                this._progressEl.style.visibility = 'hidden';
              }
            }

            this._onProgressClick = this._handleProgressClick.bind(this);
            this._progressSegments.forEach((segment) => {
              segment.addEventListener('click', this._onProgressClick);
            });

            const autoplayConfig =
              slideCount > 1
                ? {
                    delay: 5000,
                    disableOnInteraction: false,
                    stopOnLastSlide: false,
                  }
                : false;

            // 仅 ≤576 与 ≥1201 自动播；577–1200 关闭，避免 auto slides 抖动
            const shouldAutoplayNow = () => {
              if (slideCount <= 1) return false;
              const width = window.innerWidth;
              return width <= 576 || width >= 1201;
            };

            this._swiper = new Swiper(this._swiperEl, {
              // ≤576 默认：单卡
              slidesPerView: 1,
              spaceBetween: 16,
              centeredSlides: false,
              initialSlide: 0,
              loop: false,
              watchOverflow: slideCount <= 1,
              autoplay: shouldAutoplayNow() ? autoplayConfig : false,
              navigation: {
                prevEl: this.querySelector('.argoseeker-user-value-v2__nav-btn--prev'),
                nextEl: this.querySelector('.argoseeker-user-value-v2__nav-btn--next'),
              },
              breakpoints: {
                // 577–1200：左对齐横滑，关闭自动播
                577: {
                  slidesPerView: 'auto',
                  spaceBetween: 24,
                  centeredSlides: false,
                  autoplay: false,
                },
                // >1200：居中 + 自动播
                1201: {
                  slidesPerView: 'auto',
                  spaceBetween: 32,
                  centeredSlides: true,
                  autoplay: autoplayConfig,
                },
              },
              on: {
                init: (swiper) => {
                  this._syncAutoplay(swiper);
                  this._syncActiveSegment();
                },
                breakpoint: (swiper) => {
                  this._syncAutoplay(swiper);
                },
                resize: (swiper) => {
                  this._syncAutoplay(swiper);
                },
                slideChange: () => {
                  this._syncActiveSegment();
                },
                // percentage：剩余比例 1→0；填充进度用 1 - percentage
                autoplayTimeLeft: (swiper, _timeLeft, percentage) => {
                  if (!swiper.autoplay?.running) return;
                  this._setActiveFill(1 - percentage);
                },
              },
            });
          }

          _syncAutoplay(swiper = this._swiper) {
            if (!swiper || this._slideCount <= 1) return;

            const width = window.innerWidth;
            const enableAutoplay = width <= 576 || width >= 1201;

            if (enableAutoplay) {
              if (swiper.params.autoplay === false) {
                swiper.params.autoplay = {
                  delay: 5000,
                  disableOnInteraction: false,
                  stopOnLastSlide: false,
                };
              }
              if (swiper.autoplay && !swiper.autoplay.running) {
                swiper.autoplay.start();
              }
              return;
            }

            // 577–1200：强制停止自动播，避免频繁切页抖动
            if (swiper.autoplay?.running) {
              swiper.autoplay.stop();
            }
            this._setActiveFill(0);
          }

          _getActiveIndex() {
            if (!this._swiper || this._slideCount <= 1) return 0;
            return Math.max(0, Math.min(this._slideCount - 1, this._swiper.activeIndex));
          }

          _syncActiveSegment() {
            if (!this._progressSegments.length) return;

            const activeIndex = this._getActiveIndex();
            this._progressSegments.forEach((segment, index) => {
              const isActive = index === activeIndex;
              segment.classList.toggle('is-active', isActive);

              const fill = segment.querySelector('[data-progress-fill]');
              if (fill && !isActive) {
                fill.style.transform = 'scaleX(0)';
              }
            });
          }

          _setActiveFill(ratio) {
            const segment = this._progressSegments[this._getActiveIndex()];
            const fill = segment?.querySelector('[data-progress-fill]');
            if (!fill) return;
            fill.style.transform = `scaleX(${Math.max(0, Math.min(1, ratio))})`;
          }

          _handleProgressClick(event) {
            if (!this._swiper || this._slideCount <= 1) return;

            const index = Number(event.currentTarget.getAttribute('data-index'));
            if (Number.isNaN(index) || index === this._getActiveIndex()) return;

            this._swiper.slideTo(index);
          }

          disconnectedCallback() {
            if (this._progressSegments?.length && this._onProgressClick) {
              this._progressSegments.forEach((segment) => {
                segment.removeEventListener('click', this._onProgressClick);
              });
            }

            if (this._swiper?.destroy) {
              this._swiper.destroy(true, true);
              this._swiper = null;
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argoseeker-video-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('argoseeker-video-v2')) {
      customElements.define(
        'argoseeker-video-v2',
        class ArgoseekerVideoV2 extends HTMLElement {
          constructor() {
            super();
            this._swipers = new WeakMap();
            this._onCardClick = this._handleCardClick.bind(this);
            this._onCardKeydown = this._handleCardKeydown.bind(this);
          }

          connectedCallback() {
            this._panels = Array.from(this.querySelectorAll('argoseeker-video-v2-week-panel'));

            this.querySelectorAll('.argoseeker-video-v2__card[data-modal-id]').forEach((card) => {
              card.addEventListener('click', this._onCardClick);
              card.addEventListener('keydown', this._onCardKeydown);
            });

            if (this._panels.length > 0) {
              this._panels.forEach((panel, i) => panel.classList.toggle('hidden', i !== 0));
              this._initSwiperForPanel(this._panels[0]);
            }
          }

          disconnectedCallback() {
            this.querySelectorAll('.argoseeker-video-v2__card[data-modal-id]').forEach((card) => {
              card.removeEventListener('click', this._onCardClick);
              card.removeEventListener('keydown', this._onCardKeydown);
            });
            this._panels.forEach((panel) => {
              const swiper = this._swipers.get(panel);
              if (swiper) {
                swiper.destroy(true, true);
                this._swipers.delete(panel);
              }
            });
          }

          _toggleSwiperCenter(swiperEl, slideCount) {
            if (!swiperEl) return;
            swiperEl.classList.toggle('argoseeker-video-v2__swiper--few-slides', slideCount > 0 && slideCount < 5);
          }

          _initSwiperForPanel(panel) {
            if (!panel || panel.classList.contains('hidden')) return;

            const swiperEl = panel.querySelector('.argoseeker-video-v2__swiper');
            if (!swiperEl || typeof Swiper === 'undefined') return;

            const prevEl = panel.querySelector('.argoseeker-video-v2__nav-btn--prev');
            const nextEl = panel.querySelector('.argoseeker-video-v2__nav-btn--next');
            const slideCount = panel.querySelectorAll('.argoseeker-video-v2__slide').length;
            const centerSlides = slideCount > 0 && slideCount < 5;

            this._toggleSwiperCenter(swiperEl, slideCount);

            // 显示/隐藏只靠 CSS：.swiper-button-disabled { display:none }
            // 清掉可能残留的 inline display，避免挡住左侧按钮
            if (prevEl) prevEl.style.removeProperty('display');
            if (nextEl) nextEl.style.removeProperty('display');

            if (this._swipers.has(panel)) {
              const inst = this._swipers.get(panel);
              if (inst?.params) {
                inst.params.centerInsufficientSlides = centerSlides;
              }
              if (inst?.update) inst.update();
              if (inst?.navigation?.update) inst.navigation.update();
              return;
            }

            const swiper = new Swiper(swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              slidesPerGroup: 1,
              centerInsufficientSlides: centerSlides,
              watchOverflow: true,
              navigation: {
                prevEl,
                nextEl,
                disabledClass: 'swiper-button-disabled',
              },
              breakpoints: {
                0: { spaceBetween: 16 },
                577: { spaceBetween: 24 },
              },
            });

            this._swipers.set(panel, swiper);
          }

          _handleCardKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this._openModal(event.currentTarget.dataset.modalId);
          }

          _handleCardClick(event) {
            this._openModal(event.currentTarget.dataset.modalId);
          }

          _getModalManager() {
            window.litime = window.litime || {};
            if (!window.litime.ModalControllerState) {
              window.litime.ModalControllerState = new ModalController();
            }
            return window.litime.ModalControllerState;
          }

          _openModal(modalId) {
            if (!modalId) return;

            const manager = this._getModalManager();
            if (!manager) return;

            if (!manager.getModal(modalId)) {
              manager.register(modalId, {
                onOpen: (container) => this._onModalOpen(container),
                onClose: (container) => this._onModalClose(container),
              });
            }

            manager.open(modalId);
          }

          _onModalOpen(container) {
            const embed = container?.querySelector('.social-video-embed');
            const video = embed?.querySelector('.social-video-embed__video');

            if (video) {
              video.currentTime = 0;
              video.play().catch(() => {});
              return;
            }

            const iframe = embed?.querySelector('.social-video-embed__iframe');
            if (!iframe) return;

            const platform = embed?.dataset.platform;
            if (!iframe.dataset.originalSrc) {
              iframe.dataset.originalSrc = iframe.getAttribute('src') || '';
            }

            let src = iframe.dataset.originalSrc;
            if (!src) return;

            if (platform === 'youtube' && !src.includes('autoplay=1')) {
              src = `${src}${src.includes('?') ? '&' : '?'}autoplay=1&mute=1&enablejsapi=1`;
            }

            if (platform === 'facebook' && !src.includes('autoplay=true')) {
              src = `${src}&autoplay=true`;
            }

            iframe.setAttribute('src', src);
          }

          _onModalClose(container) {
            const embed = container?.querySelector('.social-video-embed');
            const video = embed?.querySelector('.social-video-embed__video');

            if (video) {
              video.pause();
              video.currentTime = 0;
              return;
            }

            const iframe = embed?.querySelector('.social-video-embed__iframe');
            if (!iframe) return;
            iframe.setAttribute('src', '');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-discounts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('benefits-discounts')) {
      customElements.define(
        'benefits-discounts',
        class BenefitsDiscounts extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initTabs();
            this.initCountdown();
            this.initCopy();
            this.initMore();
          }
          initTabs() {
            this.tabs = this.querySelectorAll('.benefits-discounts_tab');
            this.contents = this.querySelectorAll('.benefits-discounts_content_tabs');
            this.tabs.forEach((tab) => {
              tab.addEventListener('click', () => this.setActiveTab(tab));
            });
          }
          setActiveTab(tab) {
            this.tabs.forEach((tab) => tab.classList.remove('benefits-discounts_tab_active'));
            tab.classList.add('benefits-discounts_tab_active');
            this.setActiveContent(tab.dataset.tabIndex);
          }
          setActiveContent(contentIndex) {
            this.contents.forEach((content) => content.classList.remove('benefits-discounts_content_tabs_active'));
            this.contents[contentIndex - 1].classList.add('benefits-discounts_content_tabs_active');
          }
          initCountdown() {
            this.countdownInterval = setInterval(() => this.updateCountdown(), 1000);
            this.updateCountdown();
          }
          updateCountdown() {
            // 查找所有倒计时容器
            const countdownContainers = this.querySelectorAll('.benefits-discounts_content_tab_content_item_countdown');

            countdownContainers.forEach((container) => {
              const timeElement = container.querySelector('.countdown-time');
              if (!timeElement) return;

              let time = container.dataset.time;
              if (!time) return;

              // 先统一转换格式
              time = time.trim().replace(/\//g, '-');
              const timeFormat = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

              if (!timeFormat.test(time)) {
                container.style.display = 'none';
                return;
              }

              const endTime = new Date(time).getTime();
              const now = new Date().getTime();
              const timeDifference = endTime - now;

              if (timeDifference > 0) {
                if (container.style.display !== 'flex') {
                  container.style.display = 'flex';
                }
              } else {
                container.style.display = 'none';
                return;
              }

              const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
              const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
              const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

              // 更新各个时间元素
              const daysElement = timeElement.querySelector('.days');
              const hrsElement = timeElement.querySelector('.hrs');
              const minElement = timeElement.querySelector('.min');
              const secElement = timeElement.querySelector('.sec');

              if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
              if (hrsElement) hrsElement.textContent = hours.toString().padStart(2, '0');
              if (minElement) minElement.textContent = minutes.toString().padStart(2, '0');
              if (secElement) secElement.textContent = seconds.toString().padStart(2, '0');
            });
          }
          initCopy() {
            this.copyButtons = this.querySelectorAll('.benefits-discounts_content_tab_content_item_discount_copy');
            this.copyButtons.forEach((btn) => {
              btn.addEventListener('click', () => this.copyDiscountCode(btn));
            });
          }
          copyDiscountCode(btn) {
            const codeTrim = btn.getAttribute('data-code').trim();
            // 兼容safri浏览器 谷歌浏览器
            if (navigator.clipboard) {
              navigator.clipboard.writeText(codeTrim);
            } else {
              const textarea = document.createElement('textarea');
              textarea.value = codeTrim;
              document.body.appendChild(textarea);
              textarea.select();
              document.execCommand('copy');
              document.body.removeChild(textarea);
            }
            const copyText = this.getAttribute('data-copy-text');
            const copiedText = this.getAttribute('data-copied-text');
            btn.textContent = copiedText;
            btn.setAttribute('data-copied', 'true');
            setTimeout(() => {
              btn.textContent = copyText;
              btn.setAttribute('data-copied', 'false');
            }, 2000);
          }
          initMore() {
            // 根据行数来确定渲染item的个数，超出部分隐藏
            // 如果宽度大于1200，一行4个，区间在小于等于1200到960，一行2个，等于小于960到576，一行1个；小于等于576以下，一行一个
            let count;
            if (window.innerWidth > 1200) {
              const length = this.getAttribute('data-pc-count');
              count = 4 * length;
            } else if (window.innerWidth <= 1200 && window.innerWidth > 960) {
              const length = this.getAttribute('data-pad-count');
              count = 2 * length;
            } else if (window.innerWidth <= 960 && window.innerWidth > 576) {
              const length = this.getAttribute('data-small-pad-count');
              count = 1 * length;
            } else {
              const length = this.getAttribute('data-mobile-count');
              count = 1 * length;
            }
            const contents = this.querySelectorAll('.benefits-discounts_content_tabs');
            contents.forEach((content) => {
              const learnMore = content.querySelector('.benefits-discounts_content_tabs_more');
              const size = content.getAttribute('data-size');

              // 前面count个item显示
              content.querySelectorAll('.benefits-discounts_content_tab_content_item').forEach((item, index) => {
                if (index < count) {
                  item.classList.add('benefits-discounts_content_tab_content_item_active');
                }
              });
              // size> count，则显示learnMore
              if (size > count) {
                learnMore.style.display = 'block';
              } else {
                learnMore.style.display = 'none';
              }
              learnMore.addEventListener('click', () => {
                content.querySelectorAll('.benefits-discounts_content_tab_content_item').forEach((item, index) => {
                  item.classList.add('benefits-discounts_content_tab_content_item_active');
                  learnMore.style.display = 'none';
                });
              });
            });
          }

          disconnectedCallback() {
            clearInterval(this.countdownInterval);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-classification"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('article-classification')) {
      customElements.define(
        'article-classification',
        class ArticleClassification extends HTMLElement {
          constructor() {
            super();
            this._grid = null;
            this._viewMore = null;
            this._revealMedia = null;
            this._revealedCount = 0;
            this._blogUrl = null;
            this._activeTag = '';
          }

          connectedCallback() {
            this._grid = this.querySelector('.article-classification__grid');
            this._viewMore = this.querySelector('.article-classification__view-more');
            this._blogUrl = this.dataset.blogUrl || window.location.pathname;
            if (!this._grid) return;

            this._revealMedia = window.matchMedia('(min-width: 1201px)');
            this._applyReveal();

            // Activate tab from URL on initial load (must run after _applyReveal)
            this._activateTabFromUrl();

            this._onRevealMediaChange = () => this._applyReveal();
            if (this._revealMedia.addEventListener) {
              this._revealMedia.addEventListener('change', this._onRevealMediaChange);
            } else if (this._revealMedia.addListener) {
              this._revealMedia.addListener(this._onRevealMediaChange);
            }

            this.initCardNavigation();

            this._boundClick = (e) => {
              const more = e.target.closest('.article-classification__view-more');
              if (more) {
                e.preventDefault();
                this._onViewMoreClick();
                return;
              }
              const tab = e.target.closest('[data-tab-tag]');
              if (tab) {
                this._onTabClick(tab);
                return;
              }
            };
            this.addEventListener('click', this._boundClick);

            this._scrollActiveTabToCenter();
          }

          disconnectedCallback() {
            if (this._boundCardClick) {
              this.removeEventListener('click', this._boundCardClick);
            }
            if (this._boundClick) {
              this.removeEventListener('click', this._boundClick);
            }
            if (this._revealMedia && this._onRevealMediaChange) {
              if (this._revealMedia.removeEventListener) {
                this._revealMedia.removeEventListener('change', this._onRevealMediaChange);
              } else if (this._revealMedia.removeListener) {
                this._revealMedia.removeListener(this._onRevealMediaChange);
              }
            }
          }

          initCardNavigation() {
            this._cardClickMedia = window.matchMedia('(min-width: 1201px)');
            this._boundCardClick = (e) => {
              if (!this._cardClickMedia.matches) return;

              const card = e.target.closest('.article-classification__card');
              if (!card || !this.contains(card)) return;
              if (e.target.closest('a')) return;

              const url = card.dataset.cardUrl;
              if (!url || url === 'javascript:;' || url === '#') return;

              window.location.assign(url);
            };
            this.addEventListener('click', this._boundCardClick);
          }

          _currentStep() {
            const isDesktop = this._revealMedia && this._revealMedia.matches;
            return isDesktop ? 6 : 2;
          }

          _applyReveal() {
            if (!this._grid) return;
            this._revealedCount = 0;
            const allItems = [...this._grid.querySelectorAll('.article-classification__grid-item')];
            const activeTag = this._activeTag;
            const step = this._currentStep();

            const matchingItems = allItems.filter((item) => {
              const itemTags = (item.dataset.tags || '').split(',').filter(Boolean);
              return activeTag === '' || itemTags.includes(activeTag);
            });

            const visibleCount = this._revealedCount > 0 ? this._revealedCount : step;

            allItems.forEach((item) => {
              const itemTags = (item.dataset.tags || '').split(',').filter(Boolean);
              const match = activeTag === '' || itemTags.includes(activeTag);
              if (!match) {
                item.classList.add('article-classification__grid-item--hidden');
                return;
              }
              const matchIndex = matchingItems.indexOf(item);
              item.classList.toggle('article-classification__grid-item--hidden', matchIndex >= visibleCount);
            });

            this._revealedCount = visibleCount;
            if (this._viewMore) {
              this._viewMore.hidden = matchingItems.length <= visibleCount;
            }
          }

          _onViewMoreClick() {
            if (!this._grid) return;

            const allItems = [...this._grid.querySelectorAll('.article-classification__grid-item')];
            const activeTag = this._activeTag;
            const step = this._currentStep();

            const matchingItems = allItems.filter((item) => {
              if (activeTag === '') return true;
              const itemTags = (item.dataset.tags || '').split(',').filter(Boolean);
              return itemTags.includes(activeTag);
            });

            const hiddenMatching = matchingItems.filter((item) =>
              item.classList.contains('article-classification__grid-item--hidden')
            );

            if (hiddenMatching.length === 0) return;

            const currentRevealed = matchingItems.filter((item) =>
              !item.classList.contains('article-classification__grid-item--hidden')
            ).length;

            const targetRevealed = Math.min(currentRevealed + step, matchingItems.length);

            allItems.forEach((item) => {
              const itemTags = (item.dataset.tags || '').split(',').filter(Boolean);
              const match = activeTag === '' || itemTags.includes(activeTag);
              if (!match) return;

              const matchIndex = matchingItems.indexOf(item);
              item.classList.toggle('article-classification__grid-item--hidden', matchIndex >= targetRevealed);
            });

            this._revealedCount = targetRevealed;
            const remainingHidden = matchingItems.length - targetRevealed;
            if (this._viewMore) {
              this._viewMore.hidden = remainingHidden === 0;
            }
          }

          _activateTabFromUrl() {
            const match = window.location.pathname.match(/\/tagged\/([^/]+)/);
            const urlTag = match ? match[1] : '';
            this._activeTag = urlTag;
            const tabs = this.querySelectorAll('[data-tab-tag]');
            const targetTab = [...tabs].find((tab) => tab.dataset.tabTag === urlTag) || tabs[0];
            if (!targetTab) return;

            const isAll = targetTab.dataset.tabTag === '';
            this.querySelectorAll('[data-tab-tag]').forEach((tab) => {
              const isActive = tab === targetTab;
              tab.classList.toggle('article-classification__tab--active', isActive);
              tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            const activeTag = urlTag;
            const allItems = [...this._grid.querySelectorAll('.article-classification__grid-item')];
            const step = this._currentStep();
            let revealedCount = 0;
            let hiddenCount = 0;

            allItems.forEach((item) => {
              const itemTags = (item.dataset.tags || '').split(',').filter(Boolean);
              const match2 = isAll || itemTags.includes(urlTag);

              if (match2) {
                if (revealedCount < step) {
                  item.classList.remove('article-classification__grid-item--hidden');
                  revealedCount++;
                } else {
                  item.classList.add('article-classification__grid-item--hidden');
                }
              } else {
                item.classList.add('article-classification__grid-item--hidden');
                hiddenCount++;
              }
            });

            this._revealedCount = revealedCount;
            if (this._viewMore) {
              this._viewMore.hidden = revealedCount >= (allItems.length - hiddenCount);
            }

            this._scrollActiveTabToCenter();
          }

          _onTabClick(clickedTab) {
            const activeTag = clickedTab.dataset.tabTag || '';
            this._activeTag = activeTag;

            // Update URL without page reload
            const newUrl = activeTag
              ? `${this._blogUrl}/tagged/${activeTag}`
              : this._blogUrl;
            history.replaceState({ tag: activeTag }, '', newUrl);

            // Update tab active state
            this.querySelectorAll('[data-tab-tag]').forEach((tab) => {
              const isActive = tab === clickedTab;
              tab.classList.toggle('article-classification__tab--active', isActive);
              tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            // Get all items, filter by tag, and reset revealed count
            const allItems = [...this._grid.querySelectorAll('.article-classification__grid-item')];
            const step = this._currentStep();

            let revealedCount = 0;
            let hiddenCount = 0;

            allItems.forEach((item) => {
              const itemTags = (item.dataset.tags || '').split(',').filter(Boolean);
              const match = activeTag === '' || itemTags.includes(activeTag);

              if (match) {
                if (revealedCount < step) {
                  item.classList.remove('article-classification__grid-item--hidden');
                  revealedCount++;
                } else {
                  item.classList.add('article-classification__grid-item--hidden');
                }
              } else {
                item.classList.add('article-classification__grid-item--hidden');
                hiddenCount++;
              }
            });

            this._revealedCount = revealedCount;

            // Show/hide "View More" based on visible (matching) items
            if (this._viewMore) {
              this._viewMore.hidden = revealedCount >= (allItems.length - hiddenCount);
            }

            this._scrollActiveTabToCenter();
          }

          _scrollActiveTabToCenter() {
            const wrap = this.querySelector('.article-classification__tabs-wrapper');
            const tab = this.querySelector('.article-classification__tab--active');
            if (!wrap || !tab) return;
            const maxScroll = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
            if (maxScroll === 0) return;
            const wrapRect = wrap.getBoundingClientRect();
            const tabRect = tab.getBoundingClientRect();
            const tabCenter = wrap.scrollLeft + (tabRect.left - wrapRect.left) + tabRect.width / 2;
            let targetScroll = tabCenter - wrap.clientWidth / 2;
            targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
            wrap.scrollTo({ left: targetScroll, behavior: 'auto' });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-song-award-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('brand-song-award-v2')) {
      customElements.define(
        'brand-song-award-v2',
        class BrandSongAwardV2 extends HTMLElement {
          constructor() {
            super();
            this._onMediaClick = this._handleMediaClick.bind(this);
            this._onMediaKeydown = this._handleMediaKeydown.bind(this);
            this._statFieldMap = {
              views: 'view_count',
              likes: 'like_count',
              comments: 'comment_count',
              shares: 'share_count',
            };
          }

          connectedCallback() {
            this._initMedia();
            this._fetchSocialStats();
          }

          disconnectedCallback() {
            if (this._mediaTrigger) {
              this._mediaTrigger.removeEventListener('click', this._onMediaClick);
              this._mediaTrigger.removeEventListener('keydown', this._onMediaKeydown);
            }
          }

          _initMedia() {
            this._mediaTrigger = this.querySelector('.brand-song-award-v2__media-trigger[data-modal-id]');
            if (!this._mediaTrigger) return;

            this._mediaTrigger.addEventListener('click', this._onMediaClick);
            this._mediaTrigger.addEventListener('keydown', this._onMediaKeydown);
          }

          _getSocialMetricsApiBase() {
            const shopUrl = window.base_info?.url || window.Shopify?.shop || '';
            if (shopUrl === 'dev-askstarry.myshopify.com') {
              return 'https://dev-server.askstarry.com';
            }
            return 'https://server.askstarry.com';
          }

          _formatCompactNumber(value) {
            const num = Number(value);
            if (!Number.isFinite(num)) return String(value);

            if (num >= 1000000) {
              const scaled = Math.trunc((num * 10) / 1000000);
              const intPart = Math.trunc(scaled / 10);
              const decPart = scaled % 10;
              return `${intPart}.${decPart}M`;
            }

            if (num >= 1000) {
              const scaled = Math.trunc((num * 10) / 1000);
              const intPart = Math.trunc(scaled / 10);
              const decPart = scaled % 10;
              return `${intPart}.${decPart}K`;
            }

            return String(num);
          }

          _applySocialStats(data) {
            if (!data) return;

            this.querySelectorAll('.brand-song-award-v2__stat[data-type]').forEach((stat) => {
              const field = this._statFieldMap[stat.dataset.type];
              if (!field) return;

              const apiValue = data[field];
              if (apiValue === null || apiValue === undefined) return;

              const valueEl = stat.querySelector('.brand-song-award-v2__stat-value');
              if (!valueEl) return;

              valueEl.textContent = this._formatCompactNumber(apiValue);
            });
          }

          async _fetchSocialStats() {
            const statsUrl = this.dataset.creatorUrl?.trim();
            if (!statsUrl) return;

            const endpoint = `${this._getSocialMetricsApiBase()}/py/shopify/social-metrics/stats?url=${encodeURIComponent(
              statsUrl
            )}`;

            try {
              const response = await fetch(endpoint, {
                method: 'GET',
                headers: {
                  Accept: 'application/json',
                  shop: window.Shopify?.shop || '',
                },
              });

              if (!response.ok) return;

              const result = await response.json();
              if (result?.code !== 200 || !result?.data) return;

              this._applySocialStats(result.data);
            } catch (_error) {
              /* 接口失败时保留后台配置值 */
            }
          }

          _handleMediaKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this._openModal(this._mediaTrigger.dataset.modalId);
          }

          _handleMediaClick() {
            this._openModal(this._mediaTrigger.dataset.modalId);
          }

          _getModalManager() {
            window.litime = window.litime || {};
            if (!window.litime.ModalControllerState) {
              window.litime.ModalControllerState = new ModalController();
            }
            return window.litime.ModalControllerState;
          }

          _openModal(modalId) {
            if (!modalId) return;

            const manager = this._getModalManager();
            if (!manager) return;

            if (!manager.getModal(modalId)) {
              manager.register(modalId, {
                onOpen: (container) => this._onModalOpen(container),
                onClose: (container) => this._onModalClose(container),
              });
            }

            manager.open(modalId);
          }

          _onModalOpen(container) {
            const iframe = container?.querySelector('.social-video-embed__iframe');
            if (!iframe) return;

            const platform = iframe.closest('.social-video-embed')?.dataset.platform;
            if (!iframe.dataset.originalSrc) {
              iframe.dataset.originalSrc = iframe.getAttribute('src') || '';
            }

            let src = iframe.dataset.originalSrc;
            if (!src) return;

            if (platform === 'youtube' && !src.includes('autoplay=1')) {
              src = `${src}${src.includes('?') ? '&' : '?'}autoplay=1&mute=1&enablejsapi=1`;
            }

            if (platform === 'facebook' && !src.includes('autoplay=true')) {
              src = `${src}&autoplay=true`;
            }

            iframe.setAttribute('src', src);
          }

          _onModalClose(container) {
            const iframe = container?.querySelector('.social-video-embed__iframe');
            if (!iframe) return;
            iframe.setAttribute('src', '');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-song-banner-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!customElements.get('brand-song-banner-v2')) {
      customElements.define(
        'brand-song-banner-v2',
        class BrandSongBanner extends HTMLElement {
          constructor() {
            super();
            this._onPlayClick = this._handlePlayClick.bind(this);
          }

          connectedCallback() {
            this._playBtn = this.querySelector('.brand-song-banner-v2__play');
            this._playBtn?.addEventListener('click', this._onPlayClick);
            this._initThemeStyles();
          }

          disconnectedCallback() {
            this._playBtn?.removeEventListener('click', this._onPlayClick);
          }

          _initThemeStyles() {
            const defaultStyle = this.getAttribute('data-default-style');
            this._setHeaderStyle(defaultStyle);
            this._setFooterStyle(defaultStyle);
          }

          _setHeaderStyle(defaultStyle) {
            const header = document.querySelector('#header-01');
            if (!header) return;

            header.classList.remove('theme-dark', 'theme-light', 'light-default');
            if (defaultStyle === 'dark') {
              header.classList.add('theme-dark');
            } else {
              header.classList.add('theme-light');
            }
          }

          _setFooterStyle(defaultStyle) {
            const footer = document.querySelector('.main-footer');
            if (!footer) return;

            footer.style.backgroundColor = defaultStyle === 'dark' ? '#181818' : '';

            footer.querySelectorAll('.main-footer__input').forEach((input) => {
              input.style.backgroundColor = defaultStyle === 'dark' ? '#111111' : '';
              input.style.color = defaultStyle === 'dark' ? '#FFFFFF' : '';
              input.style.setProperty('--placeholder-color', defaultStyle === 'dark' ? '#fff' : '#737373');
            });

            footer.querySelectorAll('.footer-sub-title').forEach((subTitle) => {
              subTitle.style.color = defaultStyle === 'dark' ? '#FFFFFF' : '#737373';
            });

            const footerTextColor = defaultStyle === 'dark' ? '#FFFFFF' : '#191919';
            document.documentElement.style.setProperty('--footer-item-text-color', footerTextColor);

            if (defaultStyle === 'dark') {
              document.documentElement.style.setProperty('--footer-item-text-color-80', 'rgba(255, 255, 255, 0.8)');
              document.documentElement.style.setProperty('--footer-item-text-color-20', 'rgba(255, 255, 255, 0.2)');
            } else {
              document.documentElement.style.setProperty('--footer-item-text-color-80', 'rgba(25, 25, 25, 0.8)');
              document.documentElement.style.setProperty('--footer-item-text-color-20', 'rgba(25, 25, 25, 0.2)');
            }

            const logoListDark = document.querySelector('.logo-list-dark');
            const logoListLight = document.querySelector('.logo-list-light');

            if (logoListDark && logoListLight) {
              if (defaultStyle === 'dark') {
                logoListDark.classList.remove('hidden');
                logoListDark.classList.add('flex');
                logoListLight.classList.remove('flex');
                logoListLight.classList.add('hidden');
              } else {
                logoListLight.classList.remove('hidden');
                logoListLight.classList.add('flex');
                logoListDark.classList.remove('flex');
                logoListDark.classList.add('hidden');
              }
            }
          }

          _handlePlayClick() {
            const modalId = this._playBtn?.dataset.modalId;
            if (!modalId) return;

            window.litime = window.litime || {};
            window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
            const manager = window.litime.ModalControllerState;

            if (!manager.getModal(modalId)) {
              manager.register(modalId);
            }

            manager.open(modalId);
          }
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-song-community"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('brand-song-community')) {
      customElements.define(
        'brand-song-community',
        class BrandSongCommunity extends HTMLElement {
          constructor() {
            super();
            this._statObserver = null;
          }

          connectedCallback() {
            this._initStatCountUp();
          }

          disconnectedCallback() {
            this._statObserver?.disconnect();
            this._statObserver = null;
          }

          _initStatCountUp() {
            const statValues = this.querySelectorAll('.brand-song-community__stat-value[data-stat-value]');
            if (!statValues.length) return;

            this._statObserver = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;

                  const el = entry.target;
                  if (el.dataset.animated === 'true') return;

                  el.dataset.animated = 'true';
                  this._animateStatValue(el);
                  this._statObserver.unobserve(el);
                });
              },
              { threshold: 0.3 }
            );

            statValues.forEach((el) => this._statObserver.observe(el));
          }

          _parseStatValue(text) {
            const raw = String(text || '').trim();
            const match = raw.match(/^([^0-9]*)([0-9]+(?:\.[0-9]+)?)([KMBkmb]?)(.*)$/);
            if (!match) return null;

            const [, prefix, numStr, unit, suffix] = match;
            const target = parseFloat(numStr.replace(/,/g, ''));
            if (Number.isNaN(target)) return null;

            return {
              prefix: prefix || '',
              unit: (unit || '').toUpperCase(),
              suffix: suffix || '',
              target,
              decimals: (numStr.split('.')[1] || '').length,
              raw,
            };
          }

          _formatStatValue(current, parsed) {
            const value = parsed.decimals > 0 ? current.toFixed(parsed.decimals) : String(Math.floor(current));

            return `${parsed.prefix}${value}${parsed.unit}${parsed.suffix}`;
          }

          _animateStatValue(el) {
            const parsed = this._parseStatValue(el.dataset.statValue);
            if (!parsed) {
              el.textContent = el.dataset.statValue;
              return;
            }

            const duration = 1200;
            const startTime = performance.now();

            el.textContent = this._formatStatValue(0, parsed);

            const step = (now) => {
              const progress = Math.min((now - startTime) / duration, 1);
              const eased = 1 - Math.pow(1 - progress, 3);
              const current = parsed.target * eased;

              el.textContent = this._formatStatValue(current, parsed);

              if (progress < 1) {
                requestAnimationFrame(step);
              } else {
                el.textContent = parsed.raw;
              }
            };

            requestAnimationFrame(step);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-song-intro-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // brand-song-intro-v2
    if (!customElements.get('brand-song-intro-v2')) {
      customElements.define(
        'brand-song-intro-v2',
        class BrandSongIntroV2 extends HTMLElement {
          constructor() {
            super();
            this._onRulesClick = this._handleRulesClick.bind(this);
          }

          connectedCallback() {
            this._rulesTrigger = this.querySelector('.brand-song-intro-v2__rules-trigger[data-rules-open]');
            this._modal = this.querySelector('brand-song-intro-v2-modal');
            if (!this._rulesTrigger || !this._modal) return;

            this._rulesTrigger.addEventListener('click', this._onRulesClick);
          }

          disconnectedCallback() {
            if (!this._rulesTrigger) return;
            this._rulesTrigger.removeEventListener('click', this._onRulesClick);
          }

          _handleRulesClick() {
            this._modal?.setAttribute('data-show', 'true');
          }
        }
      );
    }

    // brand-song-intro-v2-modal
    if (!customElements.get('brand-song-intro-v2-modal')) {
      customElements.define(
        'brand-song-intro-v2-modal',
        class BrandSongIntroV2Modal extends HTMLElement {
          constructor() {
            super();
            this._onCloseClick = this._handleCloseClick.bind(this);
            this._onCloseKeydown = this._handleCloseKeydown.bind(this);
            this._onTabClick = this._handleTabClick.bind(this);
            this._onKeydown = this._handleKeydown.bind(this);
          }

          connectedCallback() {
            this._closeEls = this.querySelectorAll('[data-modal-close]');
            this._closeBtns = this.querySelectorAll('.brand-song-intro-v2-modal__close[data-modal-close]');
            this._tabs = this.querySelectorAll('.brand-song-intro-v2-modal__tab[data-tab]');
            this._panels = this.querySelectorAll('.brand-song-intro-v2-modal__panel[data-panel]');

            this._closeEls.forEach((el) => el.addEventListener('click', this._onCloseClick));
            this._closeBtns.forEach((el) => el.addEventListener('keydown', this._onCloseKeydown));
            this._tabs.forEach((tab) => tab.addEventListener('click', this._onTabClick));
            document.addEventListener('keydown', this._onKeydown);
          }

          disconnectedCallback() {
            this._closeEls?.forEach((el) => el.removeEventListener('click', this._onCloseClick));
            this._closeBtns?.forEach((el) => el.removeEventListener('keydown', this._onCloseKeydown));
            this._tabs?.forEach((tab) => tab.removeEventListener('click', this._onTabClick));
            document.removeEventListener('keydown', this._onKeydown);
            if (this.dataset.show === 'true') {
              window.litime?.enableScroll?.();
            }
          }

          static get observedAttributes() {
            return ['data-show'];
          }

          attributeChangedCallback(name, _oldValue, newValue) {
            if (name !== 'data-show') return;

            if (newValue === 'true') {
              window.litime?.disableScroll?.();
              return;
            }

            window.litime?.enableScroll?.();
            this._resetScroll();
          }

          _handleCloseClick(event) {
            event.preventDefault();
            event.stopPropagation();
            this.setAttribute('data-show', 'false');
          }

          _handleCloseKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this.setAttribute('data-show', 'false');
          }

          _handleKeydown(event) {
            if (this.dataset.show !== 'true' || event.key !== 'Escape') return;
            this.setAttribute('data-show', 'false');
          }

          _handleTabClick(event) {
            const tab = event.currentTarget;
            const panelName = tab?.dataset.tab;
            if (!panelName) return;

            this._tabs.forEach((item) => {
              const isActive = item === tab;
              item.setAttribute('data-active', isActive ? 'true' : 'false');
              item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            this._panels.forEach((panel) => {
              panel.setAttribute('data-show', panel.dataset.panel === panelName ? 'true' : 'false');
            });
          }

          _resetScroll() {
            const content = this.querySelector('.brand-song-intro-v2-modal__content');
            const panels = this.querySelector('.brand-song-intro-v2-modal__panels');
            if (content) content.scrollTop = 0;
            if (panels) panels.scrollTop = 0;
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-song-video-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('brand-song-video-v2')) {
      customElements.define(
        'brand-song-video-v2',
        class BrandSongVideoV2 extends HTMLElement {
          constructor() {
            super();
            this._swipers = new WeakMap();
            this._onCardClick = this._handleCardClick.bind(this);
            this._onCardKeydown = this._handleCardKeydown.bind(this);
            this._onDocumentClick = this._handleDocumentClick.bind(this);
            this._onKeydown = this._handleKeydown.bind(this);
          }

          connectedCallback() {
            this._select = this.querySelector('brand-song-video-v2-select');
            this._trigger = this._select?.querySelector('[data-select-trigger]');
            this._label = this._select?.querySelector('[data-select-label]');
            this._menu = this._select?.querySelector('[data-select-menu]');
            this._options = Array.from(this.querySelectorAll('.brand-song-video-v2__select-option'));
            this._panels = Array.from(this.querySelectorAll('brand-song-video-v2-week-panel'));

            this.querySelectorAll('.brand-song-video-v2__card[data-modal-id]').forEach((card) => {
              card.addEventListener('click', this._onCardClick);
              card.addEventListener('keydown', this._onCardKeydown);
            });

            if (this._trigger) {
              this._trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                this._toggleSelect();
              });
            }

            this._options.forEach((option, index) => {
              option.addEventListener('click', (e) => {
                e.stopPropagation();
                this._selectWeek(index);
              });
            });

            document.addEventListener('click', this._onDocumentClick);
            document.addEventListener('keydown', this._onKeydown);

            if (this._options.length > 0 && this._panels.length > 0) {
              this._selectWeek(this._getDefaultWeekIndex(), false);
            } else if (this._panels.length > 0) {
              const defaultIndex = this._getDefaultWeekIndex();
              this._panels.forEach((panel, i) => panel.classList.toggle('hidden', i !== defaultIndex));
              this._initSwiperForPanel(this._panels[defaultIndex]);
            }

            this._applyVideoRanks();
          }

          disconnectedCallback() {
            this.querySelectorAll('.brand-song-video-v2__card[data-modal-id]').forEach((card) => {
              card.removeEventListener('click', this._onCardClick);
              card.removeEventListener('keydown', this._onCardKeydown);
            });
            document.removeEventListener('click', this._onDocumentClick);
            document.removeEventListener('keydown', this._onKeydown);
            this._panels.forEach((panel) => {
              const swiper = this._swipers.get(panel);
              if (swiper) {
                swiper.destroy(true, true);
                this._swipers.delete(panel);
              }
            });
          }

          _getDefaultWeekIndex() {
            if (this.dataset.defaultLastWeek !== 'true') return 0;

            const panelCount = this._panels.length;
            const optionCount = this._options.length;
            const matchCount = optionCount > 0 ? Math.min(panelCount, optionCount) : panelCount;
            return Math.max(matchCount - 1, 0);
          }

          _toggleSelect() {
            if (!this._select || !this._menu) return;
            const isOpen = this._select.classList.toggle('brand-song-video-v2__select--open');
            this._menu.hidden = !isOpen;
          }

          _closeSelect() {
            if (!this._select || !this._menu) return;
            this._select.classList.remove('brand-song-video-v2__select--open');
            this._menu.hidden = true;
          }

          _handleDocumentClick() {
            this._closeSelect();
          }

          _handleKeydown(event) {
            if (event.key === 'Escape') {
              this._closeSelect();
            }
          }

          _selectWeek(index, closeMenu = true) {
            if (index < 0 || index >= this._panels.length) return;

            this._options.forEach((option, i) => {
              option.classList.toggle('brand-song-video-v2__select-option--active', i === index);
            });

            if (this._label && this._options[index]) {
              this._label.textContent = this._options[index].textContent.trim();
            }

            this._panels.forEach((panel, i) => {
              panel.classList.toggle('hidden', i !== index);
            });

            this._initSwiperForPanel(this._panels[index]);
            this._applyVideoRanks(this._panels[index]);

            if (closeMenu) {
              this._closeSelect();
            }
          }

          _toggleSwiperCenter(swiperEl, slideCount) {
            if (!swiperEl) return;
            swiperEl.classList.toggle('brand-song-video-v2__swiper--few-slides', slideCount > 0 && slideCount < 5);
          }

          _initSwiperForPanel(panel) {
            if (!panel || panel.classList.contains('hidden')) return;

            const swiperEl = panel.querySelector('.brand-song-video-v2__swiper');
            if (!swiperEl) return;

            const prevEl = panel.querySelector('.brand-song-video-v2__nav-btn--prev');
            const nextEl = panel.querySelector('.brand-song-video-v2__nav-btn--next');
            const scrollbarEl = panel.querySelector('.brand-song-video-v2__scrollbar');
            const slideCount = panel.querySelectorAll('.brand-song-video-v2__slide').length;
            const centerSlides = slideCount > 0 && slideCount < 5;

            this._toggleSwiperCenter(swiperEl, slideCount);

            if (this._swipers.has(panel)) {
              const inst = this._swipers.get(panel);
              if (inst?.params) {
                inst.params.centerInsufficientSlides = centerSlides;
              }
              if (inst?.update) inst.update();
              return;
            }

            const toggleNav = (swiper) => {
              if (!prevEl || !nextEl || slideCount <= 5) {
                if (prevEl) prevEl.style.display = 'none';
                if (nextEl) nextEl.style.display = 'none';
                return;
              }
              prevEl.style.display = swiper.isBeginning ? 'none' : 'flex';
              nextEl.style.display = swiper.isEnd ? 'none' : 'flex';
            };

            const swiper = new Swiper(swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              slidesPerGroup: 1,
              centerInsufficientSlides: centerSlides,
              breakpoints: {
                0: { spaceBetween: 16 },
                961: { spaceBetween: 24 },
              },
              on: {
                init: (sw) => toggleNav(sw),
                slideChange: (sw) => toggleNav(sw),
              },
            });

            this._swipers.set(panel, swiper);
          }

          _getAmountDisplayText(value) {
            return (value || '').trim();
          }

          _syncRankWidths(panel) {
            if (!panel) return;

            const allRanks = Array.from(panel.querySelectorAll('.brand-song-video-v2__card-rank'));
            const visibleRanks = allRanks.filter(
              (rank) => !rank.classList.contains('brand-song-video-v2__card-rank--hidden')
            );

            allRanks.forEach((rank) => {
              rank.style.removeProperty('width');
            });

            if (visibleRanks.length === 0) return;

            let maxWidth = 44;
            visibleRanks.forEach((rank) => {
              maxWidth = Math.max(maxWidth, Math.ceil(rank.getBoundingClientRect().width));
            });

            const unifiedWidth = `${maxWidth}px`;
            visibleRanks.forEach((rank) => {
              rank.style.width = unifiedWidth;
            });
          }

          _applyVideoRanks(scope = this) {
            if (this.dataset.showVideoRank !== 'true') return;

            const sortMode = this.dataset.rankSortMode || 'order';
            const panels =
              scope instanceof Element && scope.matches('brand-song-video-v2-week-panel')
                ? [scope]
                : Array.from(this.querySelectorAll('brand-song-video-v2-week-panel'));

            panels.forEach((panel) => {
              const slides = panel.querySelectorAll(
                '.brand-song-video-v2__swiper .swiper-wrapper > .brand-song-video-v2__slide'
              );

              slides.forEach((slide, index) => {
                const rankWrap = slide.querySelector('.brand-song-video-v2__card-rank');
                const rankNum = slide.querySelector('.brand-song-video-v2__card-rank-num');
                if (!rankWrap || !rankNum) return;

                rankWrap.classList.remove('brand-song-video-v2__card-rank--first');

                if (sortMode === 'amount') {
                  const amountText = this._getAmountDisplayText(slide.dataset.amount);

                  if (amountText) {
                    rankNum.textContent = amountText;
                    rankWrap.classList.remove('brand-song-video-v2__card-rank--hidden');
                    if (index === 0) {
                      rankWrap.classList.add('brand-song-video-v2__card-rank--first');
                    }
                  } else {
                    rankNum.textContent = '';
                    rankWrap.classList.add('brand-song-video-v2__card-rank--hidden');
                  }
                  return;
                }

                if (index < 5) {
                  rankNum.textContent = String(index + 1).padStart(2, '0');
                  rankWrap.classList.remove('brand-song-video-v2__card-rank--hidden');
                } else {
                  rankNum.textContent = '';
                  rankWrap.classList.add('brand-song-video-v2__card-rank--hidden');
                }
              });

              requestAnimationFrame(() => {
                this._syncRankWidths(panel);
              });
            });
          }

          _handleCardKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this._openModal(event.currentTarget.dataset.modalId);
          }

          _handleCardClick(event) {
            this._openModal(event.currentTarget.dataset.modalId);
          }

          _getModalManager() {
            window.litime = window.litime || {};
            if (!window.litime.ModalControllerState) {
              window.litime.ModalControllerState = new ModalController();
            }
            return window.litime.ModalControllerState;
          }

          _openModal(modalId) {
            if (!modalId) return;

            const manager = this._getModalManager();
            if (!manager) return;

            if (!manager.getModal(modalId)) {
              manager.register(modalId, {
                onOpen: (container) => this._onModalOpen(container),
                onClose: (container) => this._onModalClose(container),
              });
            }

            manager.open(modalId);
          }

          _onModalOpen(container) {
            const embed = container?.querySelector('.social-video-embed');
            const video = embed?.querySelector('.social-video-embed__video');

            if (video) {
              video.currentTime = 0;
              video.play().catch(() => {});
              return;
            }

            const iframe = embed?.querySelector('.social-video-embed__iframe');
            if (!iframe) return;

            const platform = embed?.dataset.platform;
            if (!iframe.dataset.originalSrc) {
              iframe.dataset.originalSrc = iframe.getAttribute('src') || '';
            }

            let src = iframe.dataset.originalSrc;
            if (!src) return;

            if (platform === 'youtube' && !src.includes('autoplay=1')) {
              src = `${src}${src.includes('?') ? '&' : '?'}autoplay=1&mute=1&enablejsapi=1`;
            }

            if (platform === 'facebook' && !src.includes('autoplay=true')) {
              src = `${src}&autoplay=true`;
            }

            iframe.setAttribute('src', src);
          }

          _onModalClose(container) {
            const embed = container?.querySelector('.social-video-embed');
            const video = embed?.querySelector('.social-video-embed__video');

            if (video) {
              video.pause();
              video.currentTime = 0;
              return;
            }

            const iframe = embed?.querySelector('.social-video-embed__iframe');
            if (!iframe) return;
            iframe.setAttribute('src', '');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  $(function () {
    // 统一的购物车气泡HTML生成方法
    window.createCartBubbleHTML = function (itemCount) {
      if (itemCount === 0) {
        return '';
      }
      const displayText = itemCount >= 99 ? '99+' : itemCount.toString();
      return `<div class="cart-icon-bubble-count" style="position: absolute; top: -12px; right: -12px; min-width: 20px; height: 20px; text-align: center; font-size: 14px; border-radius: 9999px; background-color: #ea5504; color: #fff; padding: 6px;">
        <div style="line-height: 8px;">${displayText}</div>
      </div>`;
    };

    // 统一的购物车气泡更新方法
    window.updateCartBubble = function (cartIconElement, itemCount) {
      if (!cartIconElement) return;

      // 更新隐藏的数量元素
      const hiddenCount = cartIconElement.querySelector('.cart-icon-bubble-hidden-count');
      if (hiddenCount) {
        hiddenCount.textContent = itemCount.toString();
      }

      // 获取购物车气泡元素
      const bubble = cartIconElement.querySelector('.cart-icon-bubble-count');

      if (itemCount === 0) {
        if (bubble) {
          bubble.classList.add('cart-drawer--collapsed');
          bubble.innerHTML = '';
        }
      } else {
        if (bubble) {
          bubble.classList.remove('cart-drawer--collapsed');
          const displayText = itemCount >= 99 ? '99+' : itemCount.toString();
          bubble.innerHTML = `<div style="line-height: 8px;">${displayText}</div>`;
        } else {
          // 创建新的购物车气泡
          const bubbleHTML = window.createCartBubbleHTML(itemCount);
          cartIconElement.insertAdjacentHTML('beforeend', bubbleHTML);
        }
      }
    };
    // 购物车弹窗
    let CartDrawer = class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.cartItemCount = 0;
        this.removeEventId = null;
        this.$body = $('body');
        this.isOpen = false;
        this.isClosing = false; // 防止重复关闭的标志
        this.drawerContainer = this.querySelector('.cart-drawer__container');
        window.globalMiniCartV2 = this;
        window.globalMiniCartV2.id = this.getAttribute('data-section-id');

        this.init();
        // 监听点击背景关闭事件
        this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close);
        this.setHeaderCartIconAccessibility();

        // 初始设置高度
        this.updateDrawerHeight();

        // 监听窗口大小变化和方向变化
        window.addEventListener('resize', this.updateDrawerHeight);
        window.addEventListener('orientationchange', this.updateDrawerHeight);
      }
      connectedCallback() {
        this.pageshowHandler = (event) => {
          requestAnimationFrame(() => {
            this.initGetCartContent();
          });
        };

        // 绑定 pageshow 事件
        window.addEventListener('pageshow', this.pageshowHandler);
      }

      async initGetCartContent() {
        const sectionId = this.dataset.sectionId;
        const sectionsRes = await fetch('/?sections=' + sectionId + ',cart-icon-bubble&t=' + Date.now(), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const sectionsData = await sectionsRes.json();
        // 重新渲染购物车内容
        await this.renderCartFromSections(sectionsData, sectionId);
      }

      /**
       * 从 sections 数据重新渲染购物车
       */
      async renderCartFromSections(sectionsData) {
        if (!sectionsData || !sectionsData['cart-drawer']) {
          return;
        }

        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');
          const newCartDrawerContent = doc.querySelector('cart-drawer');

          if (newCartDrawerContent) {
            // 保存当前的打开状态
            const wasOpen = this.hasAttribute('open');

            // 更新购物车内容
            this.innerHTML = newCartDrawerContent.innerHTML;

            // 恢复打开状态
            if (wasOpen) {
              this.setAttribute('open', 'true');
            }

            // 重新绑定事件
            this.bindCloseButton();
            this.bindRemoveButtons();
            this.initCartConnt();
            this.initCartPopupInfo();
            this.initSubtotalToggle();

            // 购物车 DOM 更新后，重新扫描全局下拉，避免引用到旧的 trigger / dropdown
            if (window.GlobalSelectManager && typeof window.GlobalSelectManager.scan === 'function') {
              setTimeout(function () {
                window.GlobalSelectManager.scan();
              }, 0);
            }
          }

          // 同时更新购物车图标 - 手动更新避免嵌套问题
          this.updateCartIconSafely(sectionsData['cart-icon-bubble']);

          // ✅ 发布事件：购物车内容渲染完成，通知推荐组件恢复内容
          if (window.litime && window.litime.eventBus) {
            window.litime.eventBus.publish('CART_DRAWER_RENDERED');
          }
        } catch (error) {
          throw error;
        }
      }

      disconnectedCallback() {
        window.overlayManager.hide(); // 组件销毁时清理遮罩层
        window.removeEventListener('cartquantityChange2', this.handlequantityChange2);
        window.removeEventListener('resize', this.updateDrawerHeight);
        window.removeEventListener('orientationchange', this.updateDrawerHeight);

        // 清理 subtotal toggle 事件监听器
        if (this.subtotalToggleHandler) {
          this.removeEventListener('click', this.subtotalToggleHandler);
        }

        this.checkoutLoading = false;
      }
      getSectionsToRender() {
        const sectionId = this.dataset.sectionId;
        return [
          {
            id: sectionId,
            section: sectionId,
            selector: '.shopify-section',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
        ];
      }
      renderContents(parsedState) {
        if (!parsedState?.sections) return;

        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
          const targetElement = document.getElementById(section.id);
          if (targetElement) {
            // 特殊处理 cart-icon-bubble，避免嵌套问题
            if (section.id === 'cart-icon-bubble') {
              this.updateCartIconSafely(parsedState.sections[section.id]);
            } else {
              const newContent = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              // 内容缺失时保留原 DOM，避免写入 undefined 清空抽屉
              if (newContent != null) {
                targetElement.innerHTML = newContent;
              }
            }

            // 优惠码入口固定显示 Apply Code，不在这里覆盖
          }
        });

        // DOM 内容更新后需要重新绑定事件
        this.bindCloseButton();
        this.bindRemoveButtons();

        this.open();
      }
      getSectionInnerHTML(html, selector = '.shopify-section') {
        if (typeof html !== 'string' || !html) {
          return null;
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const element = doc.querySelector(selector);

        if (!element) {
          return null;
        }

        // 检查元素内容是否包含 cart-drawer
        const innerHTML = element.innerHTML;
        const tempDoc = new DOMParser().parseFromString(innerHTML, 'text/html');
        const cartDrawerInside = tempDoc.querySelector('cart-drawer');

        if (cartDrawerInside) {
          return cartDrawerInside.innerHTML; // 返回 cart-drawer 内部的内容，不包含 cart-drawer 标签本身
        }

        return innerHTML;
      }

      /**
       * 安全更新购物车图标，完全避免嵌套问题
       */
      updateCartIconSafely(html) {
        try {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const iconBubble = document.querySelector('cart-icon-bubble');

          if (!iconBubble) {
            console.warn('🛒 未找到 cart-icon-bubble 元素');
            return;
          }

          // 从新数据中提取购物车数量 - 从隐藏的数量元素获取
          const newCartCountElement = doc.querySelector('.cart-icon-bubble-hidden-count');
          const newCartCountText = newCartCountElement?.textContent?.trim();

          if (newCartCountText !== undefined) {
            // 手动更新购物车数量显示
            const currentBubble = iconBubble.querySelector('.cart-icon-bubble-count');

            const itemCount = parseInt(newCartCountText) || 0;
            window.updateCartBubble(iconBubble, itemCount);
          }
        } catch (error) {
          console.error('🛒 更新购物车图标失败:', error);
        }
      }

      initCartPopupInfo() {
        const discountPopupIcon = document.querySelectorAll('.discount-popup-icon');
        const discountCodeInput = document.querySelector('#discount-code');
        const tagsContainer = document.querySelector('.cart-drawer__popup-tags');
        const appliedDiscounts = tagsContainer?.dataset.appliedDiscounts || '';

        if (appliedDiscounts) {
          discountPopupIcon.forEach((icon) => {
            icon.classList.add('active-icon');
          });
        }

        // 输入框保持空白，已应用优惠码只展示在标签区
        if (discountCodeInput) {
          discountCodeInput.value = '';
        }
      }
      initCartConnt() {
        const cartIconElement = document.querySelector('#cart-icon-bubble');
        if (cartIconElement) {
          // 优先从隐藏的数量元素获取准确的购物车数量
          const hiddenCountElement = cartIconElement.querySelector('.cart-icon-bubble-hidden-count');
          let cartCount = 0;

          if (hiddenCountElement) {
            cartCount = parseInt(hiddenCountElement.textContent.trim()) || 0;
          } else {
            // 如果没有隐藏元素，尝试从显示的气泡中获取
            const cartIconBubble = cartIconElement.querySelector('.cart-icon-bubble-count');
            if (cartIconBubble) {
              // 查找内部的数量显示 div
              const countDiv = cartIconBubble.querySelector('div');
              if (countDiv) {
                const countText = countDiv.textContent.trim();
                if (countText === '99+') {
                  cartCount = 99;
                } else {
                  cartCount = parseInt(countText) || 0;
                }
              }
            }
          }

          // 使用统一的方法更新购物车气泡
          window.updateCartBubble(cartIconElement, cartCount);
        }
      }

      // 使用箭头函数自动绑定 this
      handlequantityChange2 = (event) => {
        this.updateCartQuantity(event.detail);
      };

      handleRemoveItem = (event) => {
        const button = event.currentTarget;
        const itemId = button.closest('[data-id]')?.dataset.id;
        const itemKey = button.closest('[data-key]')?.dataset.key;

        if (itemId) {
          // 触发数量更新事件，设置数量为0来删除商品
          const removeEvent = {
            id: itemId,
            key: itemKey,
            value: 0,
          };

          this.updateCartQuantity(removeEvent, 'remove');
        }
      };

      updateCartQuantity = async (event, type = 'update') => {
        const flowItem = this.querySelector('.flow-item-' + event.id);
        if (flowItem && type === 'remove') {
          this.cartInputNumberLoading(flowItem, false, 'remove');
        }
        try {
          let productElement = this.querySelector('.product-' + event.id);
          this.removeEventId = event.id;
          const response = await fetch(`/cart/change.js`, {
            body: JSON.stringify({
              id: event.key,
              quantity: event.value,
              sections: this.dataset.sectionId + ',cart-icon-bubble',
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          });
          if (event.$blurContainer) {
            this.removeCartInputNumberLoading(event.$blurContainer);
          }
          const cartContent = await response.json();
          if (event.$input) {
            if (response.status == 200) {
              event.$input.val(event.value);
            } else {
              event.$input.val(event.defaultVal);
              window.litime.showToast('error', cartContent.message);
            }
          }
          await updateCartComponents(cartContent);
        } catch (error) {
          console.error('error', error);
        }
      };
      removeCartInputNumberLoading(className) {
        const cartInputNumberContainer = className;
        const existingLoading = cartInputNumberContainer.querySelector('.loading-container');
        if (existingLoading) {
          existingLoading.remove();
        }
      }

      cartInputNumberLoading(className, flag, type = 'dalte') {
        const cartInputNumberContainer = className;
        const loadingContainer = document.createElement('div');

        if (flag) {
          loadingContainer.className = 'loading-container';
          loadingContainer.innerHTML = `
             <div class="loading-container-unshadow">
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <div
                  class="loader-animation"
                  style="border:2px solid #191919; border-left-color: transparent;width:12px;height:12px;"
                ></div>
              </div>
            </div>
        `;
        } else {
          loadingContainer.className = 'loading-container';
          loadingContainer.innerHTML = `
          <div class="loading-container-shadow"></div>
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
          <div class="loader-animation" style="border:2px solid #191919; border-left-color: transparent;"></div>
          </div>
        `;
        }
        cartInputNumberContainer.appendChild(loadingContainer);
      }
      async getCartContent() {}
      showMessage(message) {
        const toast = document.createElement('div');
        toast.innerText = message;
        toast.style.visibility = 'hidden';
        toast.style.minWidth = '120px';
        toast.style.backgroundColor = '#666666';
        toast.style.color = '#fff';
        toast.style.textAlign = 'center';
        toast.style.borderRadius = '8px';
        toast.style.padding = '10px 24px';
        toast.style.position = 'fixed';
        toast.style.zIndex = '900';
        toast.style.left = '50%';
        toast.style.top = '50%';
        toast.style.fontSize = '16px';
        toast.style.transform = 'translate(-50%, -50%)';

        // 添加到文档中
        document.body.appendChild(toast);

        // 显示吐司
        toast.style.visibility = 'visible';

        // 2秒后隐藏并移除吐司
        setTimeout(() => {
          toast.style.visibility = 'hidden';
          document.body.removeChild(toast);
        }, 2000);
      }

      /**
       * 显示错误信息
       */
      showError(message) {
        console.error('❌ [CartDrawer] 错误:', message);

        // 使用现有的 showMessage 方法显示错误
        this.showMessage(message);

        // 也可以使用全局 toast 显示错误
        if (window.litime && window.litime.showToast) {
          window.litime.showToast('error', message);
        }
      }

      setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        if (!cartLink) return;
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        // 点击触发显示购物车
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          if (window.location.pathname === '/cart') {
            window.location.href = '/cart';
          } else {
            this.open(cartLink);
          }
        });
        // 注意：closeButton 的事件绑定已在 bindCloseButton() 中处理，避免重复绑定
      }
      async open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        // 打开时更新高度
        this.updateDrawerHeight();
        // 移除隐藏类并添加 open 属性
        this.classList.remove('cart-drawer-close');
        this.setAttribute('open', 'true');
        this.overlayMask(true);
        this.$body.addClass('drawer-body-no-scroll');

        window.customGATracker?.trackEvent('lt_view', {
          module: 'cart-drawer',
          section_id: this.dataset.sectionId,
          element: 'open',
          trigger_type: 'view',
        });
      }

      overlayMask(flag) {
        requestAnimationFrame(() => {
          if (flag) {
            // 使用全局遮罩层管理器
            this.$overlay = window.overlayManager.show();
            // 使用 jQuery 绑定点击事件
            this.$overlay.on('click', (event) => {
              event.preventDefault();
              this.close();
            });
          } else {
            window.overlayManager.hide(); // 使用全局遮罩层管理器
          }
        });
      }

      close = () => {
        // 防止重复执行
        if (this.isClosing) {
          return;
        }
        this.isClosing = true;

        // 移除 open 属性
        this.removeAttribute('open');
        this.classList.add('cart-drawer-close');
        this.$body.removeClass('drawer-body-no-scroll');
        this.overlayMask(false);
        window.overlayManager.hide(); // 确保关闭时也清理遮罩层

        // 重置关闭状态标志
        setTimeout(() => {
          this.isClosing = false;
        }, 100);
      };

      getSectionDOM(html, selector = '.shopify-section') {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector(selector);
      }

      setActiveElement(element) {
        this.activeElement = element;
      }

      initSubtotalToggle() {
        // 移除可能存在的旧事件监听器
        if (this.subtotalToggleHandler) {
          this.removeEventListener('click', this.subtotalToggleHandler);
        }

        // 使用事件委托，在整个购物车抽屉上监听点击事件
        this.subtotalToggleHandler = (event) => {
          // 检查点击的是否是 subtotal-container 或其子元素
          const subtotalContainer = event.target.closest('.subtotal-container');
          if (!subtotalContainer) return;

          // 防止事件冒泡
          event.stopPropagation();

          // 重新查找元素，确保是最新的DOM
          const arrowIcon = subtotalContainer.querySelector('.arrow-icon-cart');
          const detailsPanel = subtotalContainer.querySelector('.subtotal-details');

          if (!arrowIcon) {
            return;
          }

          if (!detailsPanel) {
            return;
          }

          detailsPanel.classList.toggle('cart-drawer--collapsed');
          arrowIcon.classList.toggle('rotate-180');
        };

        // 在整个购物车抽屉上绑定事件监听器，使用事件委托
        this.addEventListener('click', this.subtotalToggleHandler);
      }

      init = () => {
        this.bindEvents();
        this.initSubtotalToggle();
        this.initCartConnt();
        this.initCartPopupInfo();
        this.bindRemoveButtons();
        this.bindCloseButton();
      };

      bindEvents = () => {
        window.addEventListener('cartquantityChange2', this.handlequantityChange2);
      };

      bindCloseButton = () => {
        const closeButton = this.querySelector('#closeButton');
        if (closeButton) {
          // 移除可能存在的旧事件监听器
          closeButton.removeEventListener('click', this.close);
          // 绑定新的事件监听器
          closeButton.addEventListener('click', this.close);
        }
      };

      bindRemoveButtons = () => {
        // 先移除所有旧的事件监听器
        this.querySelectorAll('.icon-close').forEach((button) => {
          button.removeEventListener('click', this.handleRemoveItem);
          button.addEventListener('click', this.handleRemoveItem);
        });
      };

      updateDrawerHeight = () => {
        if (!this.drawerContainer) return;

        // 获取视口的实际高度
        const viewportHeight = window.innerHeight;
        // 设置容器高度
        this.drawerContainer.style.height = `${viewportHeight}px`;
      };
    };

    let CartInputNumber = class CartInputNumber extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initInputNumber();
      }

      initInputNumber() {
        const $input = $(this.querySelector('input'));
        const $input_number_minus = $(this.querySelector('.input-number_minus'));
        const $input_number_plus = $(this.querySelector('.input-number_plus'));

        // 处理输入
        $input.on('blur', () => {
          const max = $input.attr('max');
          const id = $input.attr('id');
          const key = $input.attr('key');
          let defaultVal = $input.prop('defaultValue');
          let value = parseInt($input.val());
          if (value < 1) value = 1;
          if (value > max) value = max;
          if (value == 0 || value == null || value == undefined || isNaN(value) || value == '') {
            value = 1;
          }
          const flowItem = document.querySelector('.flow-item-' + id);
          this.cartInputNumberLoading(flowItem.querySelector('.cart-input-number-container'), true);
          this.triggerquantityChange2(
            value,
            id,
            key,
            $input,
            flowItem.querySelector('.cart-input-number-container'),
            defaultVal
          );
        });

        // 减少数量
        $input_number_minus.on('click', () => {
          const id = $input.attr('id');
          const key = $input.attr('key');
          if ($input.val() > 1) {
            this.cartInputNumberLoading(this.querySelector('.input-number_minus-main'), true);

            const newValue = +$input.val() - 1;
            let defaultVal = $input.prop('defaultValue');

            this.triggerquantityChange2(
              newValue,
              id,
              key,
              $input,
              this.querySelector('.input-number_minus-main'),
              defaultVal
            );
          }
        });

        // 增加数量
        $input_number_plus.on('click', () => {
          const id = $input.attr('id');
          const key = $input.attr('key');
          const max = $input.attr('max');

          if ($input.val() < +max) {
            const newValue = +$input.val() + 1;
            this.cartInputNumberLoading(this.querySelector('.input-number_plus-main'), true);
            let defaultVal = $input.prop('defaultValue');

            this.triggerquantityChange2(
              newValue,
              id,
              key,
              $input,
              this.querySelector('.input-number_plus-main'),
              defaultVal
            );
            const event = new CustomEvent('quantityChange2', { detail: $input.val() });
            window.dispatchEvent(event); // 触发事件
          } else {
            // 获取data-message
            const message = $input.attr('data-message');
            window.litime.showToast('error', message);
          }
        });
      }
      cartInputNumberLoading(className, flag) {
        const cartInputNumberContainer = className;
        if (!cartInputNumberContainer) return;
        const loadingContainer = document.createElement('div');

        if (flag) {
          loadingContainer.className = 'loading-container';
          loadingContainer.innerHTML = `
             <div class="loading-container-unshadow">
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <div
                  class="loader-animation"
                  style="border:2px solid #191919; border-left-color: transparent;width:12px;height:12px;"
                ></div>
              </div>
            </div>
        `;
        } else {
          loadingContainer.className = 'loading-container';
          loadingContainer.innerHTML = `
          <div class="loading-container-shadow"></div>
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
          <div class="loader-animation" style="border:2px solid #191919; border-left-color: transparent;"></div>
          </div>
        `;
        }
        cartInputNumberContainer.appendChild(loadingContainer);
      }

      triggerquantityChange2(value, id, key, $input, blurContainer, defaultVal) {
        const event = new CustomEvent('cartquantityChange2', {
          bubbles: true,
          detail: {
            id: id,
            key: key,
            value: value,
            $input: $input,
            $blurContainer: blurContainer,
            defaultVal: defaultVal,
          },
        });
        window.dispatchEvent(event);
      }
    };
    let CartPopupMessage = class CartPopupMessage extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initCartPopupMessage();
        this.bindEvents();
      }

      initCartPopupMessage() {
        const messagePopup = this.querySelector('.message-popup');
        const messageTextarea = messagePopup.querySelector('#special-instructions');
        const charCount = messagePopup.querySelector('#char-count');
        const maxLength = messageTextarea.getAttribute('maxlength');

        // 初始化字符计数
        const currentLength = messageTextarea.value.length;
        // charCount.textContent = `${currentLength}/${maxLength}`;

        // 监听输入事件
        messageTextarea.addEventListener('input', () => {
          const currentLength = messageTextarea.value.length;
          // charCount.textContent = `${currentLength}/${maxLength}`;
        });
      }

      bindEvents() {
        // 打开留言弹窗
        const messagePopupBtns = document.querySelectorAll('#message-popup');
        const messageContentContainer = document.querySelector('.message-content');
        const messagePopup = this.querySelector('.message-popup');
        const cancelBtn = this.querySelector('.cancel-btn');
        const saveBtn = this.querySelector('.save-btn');
        const $textarea = $(this.querySelector('#special-instructions'));
        if ($textarea.val() == '') {
          saveBtn.disabled = true;
        } else {
          saveBtn.disabled = false;
        }
        messagePopupBtns.forEach((button) => {
          button.addEventListener('click', () => {
            messagePopup.setAttribute('open', '');
            messagePopup.classList.remove('cart-drawer-close');
            //收回subtotal-details
            const subtotalContainer = document.querySelector('.subtotal-container');
            const subtotalDetails = subtotalContainer.querySelector('.subtotal-details');
            subtotalDetails.classList.add('cart-drawer--collapsed');
            subtotalContainer?.querySelector('.arrow-icon-cart')?.classList.remove('rotate-180');

            $textarea.on('input', () => {
              if ($textarea.val() == '') {
                saveBtn.disabled = true;
              } else {
                saveBtn.disabled = false;
              }
            });
          });
        });

        // 关闭留言弹窗
        cancelBtn?.addEventListener('click', () => {
          messagePopup.removeAttribute('open');

          messagePopup.classList.add('cart-drawer-close');
          setTimeout(() => {
            document.querySelector('.cart-popup-discount').style.zIndex = '-1';
          }, 700);
        });

        saveBtn?.addEventListener('click', async () => {
          const $textarea = $(this.querySelector('#special-instructions'));
          const messageContent = $textarea.val();
          const response = await fetch(`/cart/update`, {
            body: JSON.stringify({ note: messageContent }),
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          });
          if (response.ok) {
            messagePopup.removeAttribute('open');
            messagePopup.setAttribute('data-note', messageContent);
            messageContentContainer.innerHTML = messageContent;
            messagePopup.classList.add('cart-drawer-close');

            const messagePopupIcon = document.querySelectorAll('.message-popup-icon');
            messagePopupIcon.forEach((icon) => {
              icon.classList.add('active-icon');
            });
          }
        });
      }
    };

    let CartPopupDiscount = class CartPopupDiscount extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        window.addEventListener('pagehide', () => {
          this.checkoutLoading = false;
          const buyNowBtn = document.querySelector('.buy-now-btn');
          const rotateIcon = buyNowBtn?.querySelector('.rotate_icon');
          if (rotateIcon) rotateIcon.style.display = 'none';
          const buttonText = buyNowBtn?.querySelector('.loading-button-text');
          if (buttonText) buttonText.style.display = 'block';
        });
        this.bindEvents();
        this.buyNowBtn();
        this.observeBottomHeight();
        this.checkoutLoading = false;
      }

      disconnectedCallback() {
        this.bottomResizeObserver?.disconnect();
        this.bottomResizeObserver = null;
      }

      get cartDrawer() {
        return this.closest('cart-drawer') || document.querySelector('cart-drawer');
      }

      syncBottomHeight() {
        const bottomContainer = this.parentElement?.querySelector('.cart-drawer__bottom');
        if (!bottomContainer) return;

        const bottomHeight = bottomContainer.getBoundingClientRect().height;
        const popupContentHeight = this.querySelector('.cart-drawer__popup-content')?.scrollHeight || 0;
        const targetHeight = Math.max(bottomHeight, popupContentHeight);

        if (targetHeight > 0) {
          this.style.height = `${targetHeight}px`;
        }
      }

      observeBottomHeight() {
        const bottomContainer = this.parentElement?.querySelector('.cart-drawer__bottom');
        if (!bottomContainer) return;

        this.syncBottomHeight();
        this.bottomResizeObserver?.disconnect();
        this.bottomResizeObserver = new ResizeObserver(() => this.syncBottomHeight());
        this.bottomResizeObserver.observe(bottomContainer);
      }

      getTagsContainer() {
        return this.querySelector('.cart-drawer__popup-tags');
      }

      getAppliedDiscountCodes() {
        const tagsContainer = this.getTagsContainer();
        const attr = tagsContainer?.dataset.appliedDiscounts || '';
        return attr
          ? attr
              .split(',')
              .map((code) => code.trim())
              .filter(Boolean)
          : [];
      }

      closePopup() {
        const discountPopup = this.querySelector('.cart-popup');
        if (!discountPopup) return;
        // 已经在关闭动画中，避免重复触发
        if (discountPopup.classList.contains('cart-drawer-close-2')) return;

        // 关键：不立刻 remove open，只靠 CSS transform 下滑收回
        discountPopup.classList.add('cart-drawer-close-2');

        const finishClose = () => {
          discountPopup.removeAttribute('open');
          const popupHost = document.querySelector('.cart-popup-discount');
          if (popupHost) popupHost.style.zIndex = '-1';
        };

        const onTransitionEnd = (event) => {
          if (event.target !== discountPopup || event.propertyName !== 'transform') return;
          discountPopup.removeEventListener('transitionend', onTransitionEnd);
          finishClose();
        };

        discountPopup.addEventListener('transitionend', onTransitionEnd);
        // 兜底：防止 transitionend 未触发
        setTimeout(() => {
          discountPopup.removeEventListener('transitionend', onTransitionEnd);
          if (discountPopup.classList.contains('cart-drawer-close-2')) {
            finishClose();
          }
        }, 700);
      }

      openPopup() {
        const discountPopup = this.querySelector('.cart-popup');
        const popupHost = document.querySelector('.cart-popup-discount');
        if (!discountPopup || !popupHost) return;

        this.syncBottomHeight();
        popupHost.style.zIndex = '500';
        discountPopup.classList.remove('cart-drawer-close');
        discountPopup.classList.remove('cart-drawer-close-2');

        const subtotalContainer = document.querySelector('.subtotal-container');
        if (subtotalContainer) {
          const subtotalDetails = subtotalContainer.querySelector('.subtotal-details');
          subtotalDetails?.classList.add('cart-drawer--collapsed');
          subtotalContainer?.querySelector('.arrow-icon-cart')?.classList.remove('rotate-180');
        }

        // 强制回流后再打开，确保每次都能重新触发 transition
        void discountPopup.offsetHeight;
        discountPopup.setAttribute('open', '');
        const discountCodeInput = this.querySelector('#discount-code');
        if (discountCodeInput) discountCodeInput.value = '';
      }

      async updateCartDiscounts(discountCodes, { render = true } = {}) {
        // section id 由主题动态生成，必须按实际 id 请求，否则拿不到对应 section 内容
        const sectionId = this.cartDrawer?.dataset.sectionId || 'cart-drawer';
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            discount: discountCodes.join(','),
            sections: `${sectionId},cart-icon-bubble`,
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to update discount codes');
        }

        const cartData = await response.json();
        const cartDrawer = this.cartDrawer;
        if (render && cartDrawer && typeof cartDrawer.renderContents === 'function' && cartData.sections) {
          cartDrawer.renderContents(cartData);
        }
        return cartData;
      }

      bindEvents() {
        const self = this;
        const discountPopupBtns = document.querySelectorAll('#discount-popup');
        const cancelBtn = this.querySelector('.cart-drawer__popup-cancel-btn');
        const saveBtn = this.querySelector('.save-btn-discount');
        const discountCodeInput = this.querySelector('#discount-code');

        discountPopupBtns.forEach((button) => {
          if (button.dataset.bound === 'true') return;
          button.dataset.bound = 'true';
          button.addEventListener('click', () => {
            self.openPopup();
          });
        });

        cancelBtn?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          self.closePopup();
        });

        // 删除可移除优惠码：自动折扣没有删除按钮
        this.addEventListener('click', async (e) => {
          const removeBtn = e.target.closest('.cart-drawer__popup-tag-remove');
          if (!removeBtn) return;
          e.preventDefault();
          e.stopPropagation();

          const removeCode = (removeBtn.dataset.discountCode || '').trim();
          if (!removeCode || removeBtn.disabled) return;

          const remainingDiscounts = self
            .getAppliedDiscountCodes()
            .filter((code) => code.toLowerCase() !== removeCode.toLowerCase());

          removeBtn.disabled = true;
          try {
            await self.updateCartDiscounts(remainingDiscounts);
            // 刷新后重新打开弹窗，方便继续管理优惠码
            requestAnimationFrame(() => {
              const popup = document.querySelector('cart-popup-discount');
              if (popup && typeof popup.openPopup === 'function') {
                popup.openPopup();
              }
            });
          } catch (error) {
            console.error('Failed to remove discount:', error);
            removeBtn.disabled = false;
            if (window.litime?.showToast) {
              window.litime.showToast('error', 'Failed to remove discount');
            }
          }
        });

        saveBtn?.addEventListener('click', async () => {
          const code = (discountCodeInput?.value || '').trim();
          const existingDiscounts = self.getAppliedDiscountCodes();

          // 没有输入新码时只关闭弹窗，不发起请求
          if (!code) {
            self.closePopup();
            return;
          }

          window.customGATracker?.trackEvent('lt_click', {
            module: 'cart-drawer',
            element: 'apply_discount',
            discount_code: code,
            trigger_type: 'click',
          });

          // 已存在的优惠码保持不变，仅追加本次输入的新码
          const allDiscounts = existingDiscounts.some((item) => item.toLowerCase() === code.toLowerCase())
            ? existingDiscounts
            : [...existingDiscounts, code];

          saveBtn.disabled = true;
          try {
            // 应用后刷新购物车，并保持优惠码弹窗打开，方便继续添加
            await self.updateCartDiscounts(allDiscounts);
            requestAnimationFrame(() => {
              const popup = document.querySelector('cart-popup-discount');
              if (popup && typeof popup.openPopup === 'function') {
                popup.openPopup();
              }
            });
          } catch (error) {
            console.error('Failed to apply discount:', error);
            if (window.litime?.showToast) {
              window.litime.showToast('error', 'Failed to apply discount');
            }
          } finally {
            saveBtn.disabled = false;
          }
        });

        discountCodeInput?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            saveBtn?.click();
          }
        });
      }

      buyNowBtn() {
        const buyNowBtn = document.querySelector('.buy-now-btn');
        if (!buyNowBtn || buyNowBtn.dataset.bound === 'true') return;
        buyNowBtn.dataset.bound = 'true';

        buyNowBtn.addEventListener('click', async () => {
          const tagsContainer = document.querySelector('.cart-drawer__popup-tags');
          const contentContainer = document.querySelector('.cart-drawer-content-container');
          const discountCode =
            tagsContainer?.dataset.appliedDiscounts ||
            contentContainer?.getAttribute('data-discount-code') ||
            contentContainer?.dataset.discountCode ||
            '';

          this.checkoutLoading = true;
          const rotateIcon = buyNowBtn.querySelector('.rotate_icon');
          if (rotateIcon) rotateIcon.style.display = 'flex';
          const buttonText = buyNowBtn.querySelector('.loading-button-text');
          if (buttonText) buttonText.style.display = 'none';

          if (window.gtag) {
            gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
          }

          requestAnimationFrame(() => {
            const codes = discountCode
              ? discountCode
                  .split(',')
                  .map((code) => code.trim())
                  .filter(Boolean)
              : [];

            // 多张优惠码已在购物车，直接走 /checkout，避免 ?discount= 只带进一张
            if (codes.length > 1) {
              window.location.href = '/checkout';
            } else if (codes.length === 1) {
              window.location.href = `/checkout?discount=${encodeURIComponent(codes[0])}`;
            } else {
              window.location.href = '/checkout';
            }
          });
        });
      }
    };

    // 注册自定义元素
    window.customElements.define('cart-drawer', CartDrawer);
    window.customElements.define('cart-input-number', CartInputNumber);
    window.customElements.define('cart-popup-message', CartPopupMessage);
    window.customElements.define('cart-popup-discount', CartPopupDiscount);
    window.customElements.define(
      'cart-icon-bubble',
      class CartIconBubble extends HTMLElement {
        constructor() {
          super();
        }

        updateBubble(itemCount) {
          // 使用统一的方法更新购物车气泡
          window.updateCartBubble(this, itemCount);
        }
      }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-product-recommendation-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('cart-product-recommendation-v2')) {
      customElements.define(
        'cart-product-recommendation-v2',
        class CartProductRecommendationV2 extends HTMLElement {
          constructor() {
            super();
            this._swiperObserver = null;
          }

          connectedCallback() {
            this.wrapper = this.querySelector('#cart-product-recommendation-v2-wrapper');
            if (this.wrapper) {
              const url = this.wrapper.dataset.url;
              if (url) {
                this.loadRecommendations(url);
                return;
              }
            }

            this.initSwiper();
            this.initJoinCartButton();
          }

          disconnectedCallback() {
            this._destroySwiper();
          }

          _destroySwiper() {
            if (this._swiperObserver) {
              this._swiperObserver.disconnect();
              this._swiperObserver = null;
            }
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
          }

          async loadRecommendations(url) {
            this._destroySwiper();
            try {
              const response = await fetch(url);
              const text = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const recommendationsContainer = doc.querySelector('.cart-recommendations');

              if (recommendationsContainer?.innerHTML.trim()) {
                this.wrapper.innerHTML = recommendationsContainer.innerHTML;
              }
            } catch (error) {
              console.error('Failed to load recommendations:', error);
            }

            this._observeAndInitSwiper();
          }

          reloadWithNewProductId(productId) {
            if (!this.wrapper) return;
            const baseUrl = this.wrapper.dataset.url;
            if (!baseUrl) return;
            const newUrl = baseUrl.replace(/product_id=\d+/, `product_id=${productId}`);
            this.loadRecommendations(newUrl);
          }

          _observeAndInitSwiper() {
            const swiperEl = this.querySelector('.cart-product-recommendation-v2__swiper .swiper');

            if (swiperEl) {
              this._initSwiperWhenReady(swiperEl);
              return;
            }

            this._swiperObserver = new MutationObserver(() => {
              const el = this.querySelector('.cart-product-recommendation-v2__swiper .swiper');
              if (el) {
                this._swiperObserver.disconnect();
                this._swiperObserver = null;
                this._initSwiperWhenReady(el);
              }
            });

            this._swiperObserver.observe(this, { childList: true, subtree: true });
          }

          _initSwiperWhenReady(swiperEl) {
            const tryInit = () => {
              if (typeof Swiper !== 'undefined') {
                if (this.swiper) {
                  this.swiper.destroy(true, true);
                  this.swiper = null;
                }

                const prevEl = this.querySelector('.cart-product-recommendation-v2__nav-btn--prev');
                const nextEl = this.querySelector('.cart-product-recommendation-v2__nav-btn--next');
                const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
                if (slideCount <= 1) return;

                this.swiper = new Swiper(swiperEl, {
                  slidesPerView: 'auto',
                  spaceBetween: 16,
                  watchOverflow: true,
                  navigation: { prevEl, nextEl },
                  breakpoints: {
                    961: {
                      spaceBetween: 24,
                    },
                  },
                });
              } else {
                requestAnimationFrame(tryInit);
              }
            };
            tryInit();
          }

          initSwiper() {
            const swiperEl = this.querySelector('.cart-product-recommendation-v2__swiper .swiper');
            if (!swiperEl) return;

            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }

            const prevEl = this.querySelector('.cart-product-recommendation-v2__nav-btn--prev');
            const nextEl = this.querySelector('.cart-product-recommendation-v2__nav-btn--next');
            const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
            if (slideCount <= 1) return;

            this.swiper = new Swiper(swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              watchOverflow: true,
              navigation: { prevEl, nextEl },
              breakpoints: {
                961: {
                  spaceBetween: 24,
                },
              },
            });
          }

          initJoinCartButton() {
            const joinCartBtns = this.querySelectorAll('.join-cart-btn');
            if (!joinCartBtns.length) return;

            const miniCart = this.closest('global-mini-cart-v2');
            const miniCartId = miniCart?.id;

            joinCartBtns.forEach((joinCartBtn) => {
              joinCartBtn.addEventListener('click', async () => {
                try {
                  const card = joinCartBtn.closest('.cart-recommend-item-v2');
                  const variantId = parseInt(
                    joinCartBtn.getAttribute('data-variant-id') || card?.getAttribute('data-variant-id'),
                    10
                  );

                  if (!variantId || Number.isNaN(variantId)) {
                    window.litime.showToast('error', 'Please select a variant');
                    return;
                  }

                  const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      items: [{ id: variantId, quantity: 1 }],
                      sections: `${getMiniCartSectionId()},cart-icon-bubble`,
                    }),
                  });

                  if (window.gtag) {
                    gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
                  }

                  if (response.ok) {
                    const cartContent = await response.json();
                    await updateCartComponents(cartContent);
                  } else {
                    const errorData = await response.json();
                    window.litime.showToast('error', errorData.description || 'Failed to Add to Cart');
                  }
                } catch (error) {
                  window.litime.showToast('error', 'Failed to Add to Cart');
                }
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-article-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('collection-article-v2')) {
      customElements.define(
        'collection-article-v2',
        class CollectionArticleV2 extends HTMLElement {
          connectedCallback() {
            this.initSwiper();
          }

          disconnectedCallback() {
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
          }

          initSwiper() {
            const swiperEl = this.querySelector('.collection-article-v2__swiper');
            if (!swiperEl) return;

            const prevEl = this.querySelector('.collection-article-v2__nav-btn--prev');
            const nextEl = this.querySelector('.collection-article-v2__nav-btn--next');
            const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
            if (slideCount <= 1) return;

            this.swiper = new Swiper(swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              watchOverflow: true,
              navigation: {
                prevEl,
                nextEl,
              },
              breakpoints: {
                1201: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
                577: {
                  slidesPerView: 'auto',
                  spaceBetween: 24,
                },
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["common-anchor-nav-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('common-anchor-nav-v2')) {
      customElements.define(
        'common-anchor-nav-v2',
        class CommonAnchorNavV2 extends HTMLElement {
          connectedCallback() {
            this._bar = this.querySelector('[data-bar]');
            this._placeholder = this.querySelector('[data-placeholder]');
            this._track = this.querySelector('[data-track]');
            this._items = Array.from(this.querySelectorAll('[data-jump]'));
            if (!this._bar || !this._track || !this._items.length) return;

            this._isFixed = false;
            this._stickyStart = 0;
            this._locked = false;
            this._lockTimer = null;
            this._onScroll = this._handleScroll.bind(this);
            this._onResize = this._handleResize.bind(this);
            this._onItemClick = this._handleItemClick.bind(this);

            this._items.forEach((item) => {
              customEventListener(item, 'click', this._onItemClick);
            });

            window.addEventListener('scroll', this._onScroll, { passive: true });
            window.addEventListener('resize', this._onResize, { passive: true });

            this._observeHeader();
            this._measureStickyStart();
            this._updateFixedState();
            this._updateActiveFromScroll();
          }

          disconnectedCallback() {
            window.removeEventListener('scroll', this._onScroll);
            window.removeEventListener('resize', this._onResize);
            if (this._headerObserver) {
              this._headerObserver.disconnect();
              this._headerObserver = null;
            }
            if (this._lockTimer) {
              clearTimeout(this._lockTimer);
              this._lockTimer = null;
            }
          }

          _getHeader() {
            return document.getElementById('lt-header');
          }

          _getHeaderOffset() {
            const header = this._getHeader();
            if (!header) return 0;
            if (header.getAttribute('data-scrollshow') === 'true') {
              return header.offsetHeight || 0;
            }
            return 0;
          }

          _getNavHeight() {
            return this._bar ? this._bar.offsetHeight || 0 : 0;
          }

          _getScrollOffset() {
            return this._getHeaderOffset() + this._getNavHeight();
          }

          _measureStickyStart() {
            const el = this._isFixed ? this._placeholder : this._bar;
            if (!el) return;
            this._stickyStart = el.getBoundingClientRect().top + window.pageYOffset;
          }

          _observeHeader() {
            const header = this._getHeader();
            if (!header || typeof MutationObserver === 'undefined') return;
            this._headerObserver = new MutationObserver(() => {
              this._updateFixedState();
            });
            this._headerObserver.observe(header, {
              attributes: true,
              attributeFilter: ['data-scrollshow', 'class', 'style'],
            });
          }

          _updateFixedState() {
            if (!this._bar || !this._placeholder) return;

            const scrollTop = window.pageYOffset;
            const headerOffset = this._getHeaderOffset();

            if (!this._isFixed && scrollTop > this._stickyStart - 10) {
              this._isFixed = true;
              this._placeholder.style.height = `${this._getNavHeight()}px`;
              this._bar.setAttribute('data-fixed', 'true');
              this._bar.style.top = `${headerOffset}px`;
            } else if (this._isFixed && scrollTop < this._stickyStart - 10) {
              this._isFixed = false;
              this._placeholder.style.height = '0px';
              this._bar.setAttribute('data-fixed', 'false');
              this._bar.style.top = '0px';
            } else if (this._isFixed) {
              this._bar.style.top = `${headerOffset}px`;
            }
          }

          _resolveTarget(jumpPoint) {
            if (!jumpPoint) return null;
            return document.getElementById(jumpPoint);
          }

          _scrollItemIntoTrack(item) {
            if (!this._track || !item) return;
            const tabRect = item.getBoundingClientRect();
            const boxRect = this._track.getBoundingClientRect();
            const targetScroll =
              this._track.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;
            this._track.scrollTo({
              left: Math.max(0, targetScroll),
              behavior: 'smooth',
            });
          }

          _setActive(jumpPoint, { scrollTrack = true } = {}) {
            let activeItem = null;
            this._items.forEach((item) => {
              const isActive = item.getAttribute('data-jump') === jumpPoint;
              item.setAttribute('data-active', isActive ? 'true' : 'false');
              if (isActive) activeItem = item;
            });
            if (scrollTrack && activeItem) {
              this._scrollItemIntoTrack(activeItem);
            }
          }

          _lockSpy(duration = 900) {
            this._locked = true;
            if (this._lockTimer) clearTimeout(this._lockTimer);
            this._lockTimer = setTimeout(() => {
              this._locked = false;
              this._lockTimer = null;
              this._updateActiveFromScroll();
            }, duration);
          }

          _handleItemClick(event) {
            const item = event.currentTarget;
            const jumpPoint = item.getAttribute('data-jump');
            const target = this._resolveTarget(jumpPoint);
            if (!target) return;

            this._setActive(jumpPoint);
            this._lockSpy();

            const top = target.getBoundingClientRect().top + window.pageYOffset - this._getScrollOffset();
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'smooth',
            });
          }

          _updateActiveFromScroll() {
            if (this._locked) return;

            const offset = this._getScrollOffset();
            const marker = window.pageYOffset + offset + 4;
            let activeJump = null;

            this._items.forEach((item) => {
              const jumpPoint = item.getAttribute('data-jump');
              const target = this._resolveTarget(jumpPoint);
              if (!target) return;
              const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
              if (targetTop <= marker) {
                activeJump = jumpPoint;
              }
            });

            if (!activeJump && this._items[0]) {
              activeJump = this._items[0].getAttribute('data-jump');
            }

            if (activeJump) {
              const current = this.querySelector('[data-jump][data-active="true"]');
              if (!current || current.getAttribute('data-jump') !== activeJump) {
                this._setActive(activeJump);
              }
            }
          }

          _handleScroll() {
            this._updateFixedState();
            this._updateActiveFromScroll();
          }

          _handleResize() {
            this._measureStickyStart();
            this._updateFixedState();
            if (this._isFixed && this._placeholder) {
              this._placeholder.style.height = `${this._getNavHeight()}px`;
            }
            this._updateActiveFromScroll();
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["common-faqs-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('common-faqs-v2')) {
      customElements.define(
        'common-faqs-v2',
        class CommonFaqsV2 extends HTMLElement {
          connectedCallback() {
            this._handleClick = this.handleClick.bind(this);
            this.addEventListener('click', this._handleClick);
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._handleClick);
          }

          get isAccordion() {
            return this.dataset.isAccordion === 'true';
          }

          handleClick(event) {
            const item = event.target.closest('.common-faqs-v2__content-item');
            if (!item || !this.contains(item)) return;

            const isActive = item.getAttribute('data-active') === 'true';

            if (this.isAccordion && !isActive) {
              this.querySelectorAll('.common-faqs-v2__content-item[data-active="true"]').forEach((openItem) => {
                openItem.setAttribute('data-active', 'false');
              });
            }

            item.setAttribute('data-active', isActive ? 'false' : 'true');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["common-subscribe-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('common-subscribe-v2')) {
    customElements.define(
      'common-subscribe-v2',
      class CommonSubscribeV2 extends HTMLElement {
        static EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        constructor() {
          super();
          this._onInput = this._onInput.bind(this);
          this._onFocus = this._onFocus.bind(this);
          this._onBlur = this._onBlur.bind(this);
          this._onSubmit = this._onSubmit.bind(this);
          this._onPrivacyClick = this._onPrivacyClick.bind(this);
          this._onPrivacyKeydown = this._onPrivacyKeydown.bind(this);
        }

        connectedCallback() {
          this._formRow = this.querySelector('.common-subscribe-v2__form-row');
          this._inputWrap = this.querySelector('.common-subscribe-input-v2-wrap');
          this._inputBox = this.querySelector('.common-subscribe-input-v2');
          this._input = this.querySelector('.common-subscribe-input-v2__field');
          this._errorEl = this.querySelector('.common-subscribe-input-v2__error');
          this._submitBtn = this.querySelector('.common-subscribe-v2__submit');
          this._privacy = this.querySelector('.common-subscribe-v2__privacy');

          if (this._input) {
            this._input.addEventListener('input', this._onInput);
            this._input.addEventListener('focus', this._onFocus);
            this._input.addEventListener('blur', this._onBlur);
          }

          if (this._submitBtn) {
            this._submitBtn.addEventListener('click', this._onSubmit);
          }

          if (this._privacy) {
            this._privacy.addEventListener('click', this._onPrivacyClick);
            this._privacy.addEventListener('keydown', this._onPrivacyKeydown);
          }
        }

        disconnectedCallback() {
          if (this._input) {
            this._input.removeEventListener('input', this._onInput);
            this._input.removeEventListener('focus', this._onFocus);
            this._input.removeEventListener('blur', this._onBlur);
          }
          if (this._submitBtn) {
            this._submitBtn.removeEventListener('click', this._onSubmit);
          }
          if (this._privacy) {
            this._privacy.removeEventListener('click', this._onPrivacyClick);
            this._privacy.removeEventListener('keydown', this._onPrivacyKeydown);
          }
        }

        _onFocus() {
          if (this._inputBox) this._inputBox.dataset.focused = 'true';
        }

        _onBlur() {
          if (this._inputBox) this._inputBox.dataset.focused = 'false';
        }

        _onInput() {
          const value = (this._input?.value || '').trim();
          if (value && CommonSubscribeV2.EMAIL_REGEXP.test(value)) {
            this._clearError();
          }
        }

        _onPrivacyClick() {
          if (!this._privacy || this._privacy.dataset.disabled === 'true') return;
          const checked = this._privacy.dataset.checked === 'true';
          const next = checked ? 'false' : 'true';
          this._privacy.dataset.checked = next;
          this._privacy.setAttribute('aria-pressed', next);
        }

        _onPrivacyKeydown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this._onPrivacyClick();
          }
        }

        _setError(message) {
          if (!this._inputWrap || !this._inputBox || !this._errorEl) return;
          this._inputWrap.dataset.error = 'true';
          this._inputBox.dataset.error = 'true';
          this._errorEl.textContent = message;
        }

        _clearError() {
          if (!this._inputWrap || !this._inputBox || !this._errorEl) return;
          this._inputWrap.dataset.error = 'false';
          this._inputBox.dataset.error = 'false';
          this._errorEl.textContent = '';
        }

        _validate() {
          const value = (this._input?.value || '').trim();
          const tipEmpty = this._inputBox?.dataset.tipEmpty || '';
          const tipFormat = this._inputBox?.dataset.tipFormat || '';

          if (!value) {
            this._setError(tipEmpty);
            return false;
          }

          if (!CommonSubscribeV2.EMAIL_REGEXP.test(value)) {
            this._setError(tipFormat);
            return false;
          }

          this._clearError();
          return true;
        }

        _setLoading(loading) {
          if (this._formRow) {
            this._formRow.dataset.loading = loading ? 'true' : 'false';
            this._formRow.setAttribute('aria-busy', loading ? 'true' : 'false');
          }
          if (this._submitBtn) {
            this._submitBtn.dataset.loading = loading ? 'true' : 'false';
            this._submitBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
          }
          if (this._input) {
            this._input.readOnly = loading;
          }
          if (this._inputBox) {
            this._inputBox.dataset.loading = loading ? 'true' : 'false';
          }
          if (this._privacy) this._privacy.dataset.disabled = loading ? 'true' : 'false';
        }

        async _subscribe(email, acceptsMarketing, tag) {
          const url = '/shopify/user/point/subscribe';
          const timestamp = typeof getEncryptTimestamp === 'function' ? getEncryptTimestamp() : '';
          const headers = {
            nonce: typeof litime_nonce !== 'undefined' ? litime_nonce : '',
            ticket: typeof litime_ticket !== 'undefined' ? litime_ticket : '',
            timestamp,
          };
          const data = { email, acceptsMarketing };
          if (tag) {
            data.tag = tag;
          }
          const res = await window.litime.http.post(url, {
            data,
            headers,
          });

          if (res.code === 200) {
            return res.data;
          }

          const errorText = this.dataset.errorText || 'Subscribe failed';
          if (window.litime?.showToast) {
            window.litime.showToast('error', errorText);
          }
          throw new Error(errorText);
        }

        async _onSubmit(event) {
          event.preventDefault();
          if (!this._validate()) return;

          const email = (this._input?.value || '').trim();
          const acceptsMarketing = this._privacy && this._privacy.dataset.checked === 'true' ? '1' : '0';
          const tag = this.dataset.subscribeTag;

          this._setLoading(true);

          try {
            await this._subscribe(email, acceptsMarketing, tag);
            const successText = this.dataset.successText || 'Subscribe successfully';
            if (window.litime?.showToast) {
              window.litime.showToast('success', successText);
            }
            if (this._input) this._input.value = '';
            this._clearError();
            if (this._privacy) {
              this._privacy.dataset.checked = 'false';
              this._privacy.setAttribute('aria-pressed', 'false');
            }
          } catch (error) {
            console.error('[common-subscribe-v2] Subscribe failed:', error);
          } finally {
            this._setLoading(false);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-drawer"]) return;
  try {
    
  window.addEventListener('load', () => {
    if (!customElements.get('compare-drawer')) {
      customElements.define(
        'compare-drawer',
        class CompareDrawer extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            // 初始化
            this.init();
          }

          init() {
            // 是否显示对比弹窗
            this.initCompareActive();
            // 外部点击对比按钮初始化
            this.initCompareButton();
            // 初始化隐藏事件
            this.initHideEvent();
            // 初始化ltCompareData
            this.initltCompareData();
            // 初始化删除事件
            this.initDeleteEvent();
            // 初始化按钮点击事件
            this.initCompareButtonClickEvent();
            // 初始化url监听
            this.initCompareUrlListener();
          }
          initCompareActive() {
            if (window.litime && window.litime.getLocalStorage('ltCompareActive')) {
              const ltCompareActive = window.litime.getLocalStorage('ltCompareActive');
              // 同时判断当前路径是否包含this.getAttribute('data-jump-path')
              if (ltCompareActive) {
                let jumpPath = this.getAttribute('data-jump-path') || '';
                if (jumpPath && !window.location.href.includes(jumpPath) && ltCompareActive) {
                  console.log('show');
                  this.show();
                }
              }
            }
          }
          initCompareUrlListener() {
            let previousUrl = window.location.href;
            const observer = new MutationObserver((mutations) => {
              if (window.location.href !== previousUrl) {
                previousUrl = window.location.href;
                // URL参数发生变化，执行相应的处理逻辑
                this.initCompareButton();
              }
            });
            // 配置MutationObserver实例以观察value属性变化
            observer.observe(document, { subtree: true, childList: true });
          }
          initHideEvent() {
            this.querySelector('.compare-drawer-content-header-hide').addEventListener('click', (event) => {
              this.hide();
            });
          }
          initCompareButtonClickEvent() {
            this.querySelector('.compare-drawer-content-footer-compare').addEventListener('click', (event) => {
              event.preventDefault();
              if (event.target.getAttribute('data-disabled') == 'true') {
                return;
              }
              const ltCompareData = window.litime.getLocalStorage('ltCompareData');
              const ids = ltCompareData.map((item) => item.id).join(',');

              // window.open(`${window.location.origin}${this.getAttribute('data-jump-path')}?ids=${ids}`, '_self');
              // 测试新开页面
              window.open(`${window.location.origin}${this.getAttribute('data-jump-path')}?ids=${ids}`);
            });
            this.querySelector('.compare-drawer-content-footer-clear').addEventListener('click', (event) => {
              window.litime.setLocalStorage('ltCompareData', []);
              let handleBtns = document.querySelectorAll(`.extension-compare`);
              handleBtns.forEach((item) => {
                item.setAttribute('data-compare-active', 'false');
              });
              this.initltCompareData();
            });
          }
          initDeleteEvent() {
            const deleteDoms = this.querySelectorAll('.compare-drawer-content-body-item-default-delete');
            const compareDoms = document.querySelectorAll('.extension-compare');
            deleteDoms.forEach((deleteDom) => {
              deleteDom.addEventListener('click', (event) => {
                const index = deleteDom.getAttribute('data-index');
                const ltCompareData = window.litime.getLocalStorage('ltCompareData');

                if (ltCompareData) {
                  let ltCompareDataList = ltCompareData || [];

                  compareDoms.forEach((compareDom) => {
                    if (compareDom.getAttribute('data-compare-id') == ltCompareDataList[index].id) {
                      compareDom.setAttribute('data-compare-active', 'false');
                    }
                  });
                  ltCompareDataList.splice(index, 1);
                  window.litime.setLocalStorage('ltCompareData', ltCompareDataList);
                  this.initltCompareData();
                }
              });
            });
          }
          initltCompareData() {
            const ltCompareData = window.litime.getLocalStorage('ltCompareData') || [];
            console.log(ltCompareData);
            if (ltCompareData.length >= 2) {
              this.querySelector('.compare-drawer-content-footer-compare').setAttribute('data-disabled', 'false');
            } else {
              this.querySelector('.compare-drawer-content-footer-compare').setAttribute('data-disabled', 'true');
            }
            const itemDoms = this.querySelectorAll('.compare-drawer-content-body-item');
            itemDoms.forEach((item, index) => {
              item.setAttribute('data-empty', 'true');
            });
            // 根据索引把数据填充到对应的dom中
            ltCompareData.forEach((item, index) => {
              const compareDom = this.querySelector(`.compare-drawer-content-body-item[data-index="${index}"]`);
              if (compareDom) {
                compareDom.setAttribute('data-empty', 'false');
                compareDom.querySelector('.compare-drawer-content-body-item-default-image').src = item.image;
                compareDom.querySelector('.compare-drawer-content-body-item-default-content-title').innerHTML =
                  item.title;
                compareDom.querySelector('.compare-drawer-content-body-item-default-content-price-new').innerHTML =
                  item.newPrice;
                compareDom.querySelector('.compare-drawer-content-body-item-default-content-price-old').innerHTML =
                  item.oldPrice;
              }
            });
            // 由于移动compare-drawer-content-body 出现左右滚动条，希望滚动到新增的位置，如何解决这个问题
            const compareDrawerContentBody = this.querySelector('.compare-drawer-content-body');
            const newItemDom = this.querySelector(
              `.compare-drawer-content-body-item[data-index="${ltCompareData.length - 1}"]`
            );
            if (newItemDom) {
              compareDrawerContentBody.scrollTo({
                left: newItemDom.offsetLeft - 16,
                behavior: 'smooth',
              });
            }
          }

          initCompareButton() {
            // 只绑定一次
            if (this._compareDelegated) return;
            this._compareDelegated = true;

            document.body.addEventListener('click', (event) => {
              const compareDom = event.target.closest('.extension-compare');
              if (!compareDom) return;

              this.handleCompareClick(event, compareDom);
            });
          }
          handleCompareClick(event, compareDom) {
            event.preventDefault();

            this.show();

            let ltCompareData = window.litime.getLocalStorage('ltCompareData') || [];

            const compareData = {
              id: compareDom.getAttribute('data-compare-id'),
              variantId: compareDom.getAttribute('data-compare-variant-id'),
              handle: compareDom.getAttribute('data-compare-handle'),
              title: compareDom.getAttribute('data-compare-title'),
              image: compareDom.getAttribute('data-compare-image'),
              newPrice: compareDom.getAttribute('data-compare-new-price'),
              oldPrice: compareDom.getAttribute('data-compare-old-price'),
            };

            const index = ltCompareData.findIndex((item) => item.id === compareData.id);

            if (index !== -1) {
              compareDom.setAttribute('data-compare-active', 'false');
              ltCompareData.splice(index, 1);
            } else {
              if (ltCompareData.length >= 4) {
                window.litime.showToast('error', this.getAttribute('data-limit-message'));
                return;
              }
              if (!compareData.id) {
                return;
              }
              ltCompareData.push(compareData);
              compareDom.setAttribute('data-compare-active', 'true');
            }

            window.litime.setLocalStorage('ltCompareData', ltCompareData);
            this.initltCompareData();
          }

          hide() {
            this.setAttribute('data-show', 'false');
            window.litime.setLocalStorage('ltCompareActive', 'false');
          }
          show() {
            this.setAttribute('data-show', 'true');
            window.litime.setLocalStorage('ltCompareActive', 'true');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-main"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('compare-main')) {
      customElements.define(
        'compare-main',
        class CompareMain extends HTMLElement {
          constructor() {
            super();
            this.productIds = [];
            this.collectionId = '';
            this.type = '';
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initData();
            this.bindEvents();
          }
          initData() {
            // 判断url中是否携带了ids，如果是ids参数，那就是自选产品对比，如果没有配置参数就是系列中产品对比
            const ids = new URLSearchParams(window.location.search).get('ids');
            if (ids) {
              this.type = 'custom';
              this.productIds = ids.split(',');
            } else {
              this.type = 'series';
              this.collectionId = this.getAttribute('data-collection-id');
              this.productIds = this.getAttribute('data-series-ids')?.split(',') || [];
            }
            this.initPageData();
          }
          async initPageData() {
            if (this.productIds.length <= 1) {
              return;
            }
            // 设置对比数量css变量
            this.style.setProperty('--compare-size', this.productIds.length);
            try {
              this.setAttribute('data-loading', 'true');
              this.querySelectorAll('.compare-main__custom-checkbox-item').forEach((item) => {
                item.setAttribute('data-value', 'false');
              });
              // 并行调用两个接口
              const [listRes, compareRes, selectionRes] = await Promise.all([
                window.litime.request(
                  '/shopify/product/compare/list',
                  {
                    data: {
                      shopifyProductIds: this.productIds,
                    },
                    method: 'GET',
                  },
                  'business-api'
                ),
                window.litime.request(
                  '/shopify/product/compare',
                  {
                    data: {
                      productIds: this.productIds,
                    },
                    method: 'GET',
                  },
                  'business-api'
                ),
                this.type === 'series'
                  ? window.litime.request(
                      `/shopify/product/compare/selection/${this.collectionId}`,
                      {
                        method: 'GET',
                      },
                      'business-api'
                    )
                  : null,
              ]);

              if (listRes.code === 200) {
                // 根据现在this.productIds的顺序，调整this.productDataList的顺序
                this.productDataList = listRes.data.sort((a, b) => {
                  return this.productIds.indexOf(a.shopifyProductId) - this.productIds.indexOf(b.shopifyProductId);
                });

                // 处理 compare 接口返回的数据
                if (compareRes.code === 200) {
                  this.specData = compareRes.data;
                }
                if (selectionRes && selectionRes.code === 200) {
                  this.selectionData = selectionRes.data;
                }
                const stickyTopElement =
                  this.querySelector('compare-main-sticky-top') || document.querySelector('compare-main-sticky-top');
                if (stickyTopElement) {
                  stickyTopElement.init(this.productDataList || []);
                }
                this.initProductData();
                this.initSpecData();
                this.initCustomSelect();
                this.initProductButtonEvent();
              }
            } catch (error) {
              console.log(error, 'error');
              this.setAttribute('data-show', 'false');
            } finally {
              this.setAttribute('data-loading', 'false');
            }
          }
          // 参数dom生成
          initSpecData() {
            const specDom = this.querySelector('.compare-main__content-spec');
            let startDom = '<div class="compare-main__content-spec">';
            let endDom = '</div>';
            let specDomList = '';
            this.specData.forEach((item) => {
              specDomList += `
              <div class="compare-main__content-spec-group" id="${item.name}">
                  ${this.initSpecGroupHeader(item)}
                  ${this.initSpecGroupRows(item)}
               </div>
              `;
            });
            let newEl = startDom + specDomList + endDom;
            specDom.outerHTML = newEl;
          }
          initSpecGroupHeader(item) {
            let startDom = '<div class="compare-main__content-spec-group-header">';
            let endDom = '</div>';
            let specGroupHeaderDom = `
              <div class="compare-main__content-spec-group-header-title">
                ${item.name}
              </div>
            `;
            return startDom + specGroupHeaderDom + endDom;
          }
          initSpecGroupRows(item) {
            let startDom = '<div class="compare-main__content-spec-rows">';
            let endDom = '</div>';
            let specGroupRowsDom = `
              ${item.items.map((row) => this.initSpecRow(row)).join('')}
            `;
            return startDom + specGroupRowsDom + endDom;
          }
          initSpecRow(item) {
            let startDom = `<div class="compare-main__content-spec-row" data-same="${item.isSame}">`;
            let endDom = '</div>';
            let specRowDom = `
              ${this.initSpecRowHeader(item)}
              ${this.initSpecRowValues(item)}
            `;
            return startDom + specRowDom + endDom;
          }
          initSpecRowHeader(item) {
            let startDom = '<div class="compare-main__content-spec-row-header">';
            let endDom = '</div>';
            let specRowHeaderDom = `
              <div class="compare-main__content-spec-row-header-title">
              ${item.name}
              </div>
            `;
            return startDom + specRowHeaderDom + endDom;
          }
          initSpecRowValues(item) {
            let startDom = '<div class="compare-main__content-spec-row-values">';
            let endDom = '</div>';
            // 根据 this.productIds 的顺序对 item.products 进行排序
            const sortedProducts = this.productIds.map((productId) => {
              const product = item.products.find((p) => p.id === productId);
              // 如果找不到对应的产品，返回一个默认值
              return product || { id: productId, value: 'N/A' };
            });
            let specRowValuesDom = `
              ${sortedProducts.map((product) => this.initSpecRowValue(product)).join('')}
            `;
            return startDom + specRowValuesDom + endDom;
          }
          initSpecRowValue(item) {
            let startDom = '<div class="compare-main__content-spec-row-value">';
            let endDom = '</div>';
            let specRowValueDom = `
              ${item.value}
            `;
            return startDom + specRowValueDom + endDom;
          }
          // 产品dom生成
          initProductData() {
            const productDom = this.querySelector('.compare-main__content-product');
            let startDom = '<div class="compare-main__content-product" id="productMain">';
            let endDom = '</div>';
            let productDomList = '';
            this.productDataList.forEach((item) => {
              productDomList += `
                <div  class="compare-main__content-product-item">
                ${this.initProductHeader(item)}
                ${this.initProductContent(item)}
                </div>
              `;
            });
            let newEl = startDom + productDomList + endDom;
            productDom.outerHTML = newEl;
          }
          initProductHeader(item) {
            let startDom = `<a href="/products/${item.handle}" class="compare-main__content-product-item-header">`;
            let endDom = '</a>';
            let productHeaderDom = `
              ${this.initProductHeaderProductSelect(item)}
              ${this.initProductHeaderImage(item)}
            `;
            return startDom + productHeaderDom + endDom;
          }
          initProductHeaderProductSelect(item) {
            let startDom =
              '<div class="compare-main__custom-select compare-main__content-product-item-product-select" data-active="false">';
            let endDom = '</div>';
            let productHeaderProductSelectDom = `
            `;
            if (this.type === 'custom') {
              return '';
            } else {
              let productHeaderProductSelectDom = `
                ${this.initProductHeaderProductSelectTrigger(item)}
                ${this.initProductHeaderProductSelectOptions(item)}
              `;
              return startDom + productHeaderProductSelectDom + endDom;
            }
          }

          initProductHeaderProductSelectTrigger(item) {
            let startDom = '<div class="compare-main__custom-select-trigger">';
            let endDom = '</div>';
            let productHeaderProductSelectTriggerDom = `
              ${this.initProductHeaderProductSelectTriggerTitle(item)}
              ${this.initProductHeaderProductSelectTriggerIcon(item)}
            `;
            return startDom + productHeaderProductSelectTriggerDom + endDom;
          }
          initProductHeaderProductSelectTriggerTitle(item) {
            let startDom = '<div class="compare-main__custom-select-trigger-title">';
            let endDom = '</div>';
            let productHeaderProductSelectTriggerTitleDom = `
              ${item.shortTitle || item.title}
            `;
            return startDom + productHeaderProductSelectTriggerTitleDom + endDom;
          }
          initProductHeaderProductSelectTriggerIcon(item) {
            return `
                <svg
                  class="compare-main__custom-select-trigger-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  fill="none"
                  version="1.1"
                  width="14"
                  height="14.232421875"
                  viewBox="0 0 14 14.232421875"
                >
                  <g><g><rect x="0" y="0.232421875" width="14" height="14" rx="0" fill="#D9D9D9" fill-opacity="0"/></g><g transform="matrix(-0.7071067094802856,-0.7071067094802856,-0.7071067094802856,0.7071067094802856,22.47805441892706,9.310715064639226)"><path d="" fill="#D9D9D9" fill-opacity="0"/><path d="M10.30013996,5.232421875Q10.30014002,5.163491681,10.31358761,5.095885965Q10.32703525,5.028280245,10.3534137,4.964597045Q10.37979209,4.900913835,10.41808772,4.843600485Q10.45638323,4.786287125,10.50512424,4.737546115Q10.55386525,4.688805105,10.61117864,4.650509535Q10.66849196,4.6122139650000005,10.73217517,4.585835575Q10.79585837,4.559457125,10.86346409,4.546009485Q10.931069806,4.532561895,11,4.532561835Q11.068930194,4.532561895,11.13653591,4.546009485Q11.20414163,4.559457125,11.26782483,4.585835575Q11.33150804,4.6122139650000005,11.38882139,4.650509595Q11.44613475,4.688805105,11.49487576,4.737546115Q11.54361677,4.786287125,11.58191234,4.843600515Q11.62020791,4.900913835,11.6465863,4.964597045Q11.67296475,5.028280245,11.68641239,5.095885965Q11.69985998,5.163491681,11.69986004,5.232421875L11.69999999,5.232421875L11.69999999,10.532422075L17,10.532422075L17,10.532561775Q17.068929699999998,10.532561775,17.1365352,10.546009075Q17.2041407,10.559456875,17.2678242,10.585834975000001Q17.3315067,10.612213175,17.388820199999998,10.650509375Q17.4461336,10.688804675,17.494875,10.737545975Q17.5436158,10.786286375,17.581911599999998,10.843600275Q17.6202068,10.900913275,17.6465855,10.964596775Q17.6729641,11.028279775,17.6864119,11.095885775Q17.6998596,11.163491275,17.699860100000002,11.232421875Q17.6998596,11.301351575,17.6864123,11.368957075Q17.6729641,11.436562575,17.646585899999998,11.500246075Q17.6202078,11.563928575,17.581912,11.621242075Q17.5436168,11.678555475,17.4948759,11.727296875Q17.4461346,11.776037675000001,17.3888211,11.814333475Q17.3315077,11.852628675,17.2678242,11.879007375Q17.2041407,11.905385975,17.1365352,11.918833775Q17.068929699999998,11.932281475,17,11.932281975L17,11.932421675L11,11.932421675Q10.931056023,11.932421175,10.86343679,11.918970575Q10.79581757,11.905520475,10.73212165,11.879136575Q10.66842571,11.852752675,10.61110088,11.814450274999999Q10.55377603,11.776146875,10.50502527,11.727395975Q10.45627457,11.678645175,10.41797137,11.621320675Q10.37966812,11.563995875,10.35328442,11.500299975Q10.32690072,11.436603975,10.31345034,11.368984675Q10.30000007,11.301365875,10.30000001,11.232421875L10.30000001,5.232421875L10.30013996,5.232421875Z" fill-rule="evenodd" fill="#191919" fill-opacity="1"/></g></g>
                </svg>
            `;
          }

          initProductHeaderProductSelectOptions(item) {
            let startDom = '<div class="compare-main__custom-select-options">';
            let endDom = '</div>';
            let productHeaderProductSelectOptionsDom = `
              ${this.initProductHeaderProductSelectOptionsItems(item)}
            `;
            return startDom + productHeaderProductSelectOptionsDom + endDom;
          }
          initProductHeaderProductSelectOptionsItems(item) {
            let productHeaderProductSelectOptionsItemsDom = `
              ${this.selectionData
                .map(
                  (selection) => `
                <div class="compare-main__custom-select-option" data-product-id="${
                  item.shopifyProductId
                }" data-value="${selection.shopifyProductId}" data-selected="${
                    selection.shopifyProductId === item.shopifyProductId ? 'true' : 'false'
                  }" data-disabled="${
                    this.productIds.includes(selection.shopifyProductId) &&
                    selection.shopifyProductId !== item.shopifyProductId
                      ? 'true'
                      : 'false'
                  }">
                  ${selection.shortTitle || selection.title}
                </div>
              `
                )
                .join('')}
            `;
            return productHeaderProductSelectOptionsItemsDom;
          }
          initProductHeaderImage(item) {
            // 先取guideImageSrc，如果没有就取imageSrc
            let imageSrc = item.guideImageSrc || item.imageSrc;
            let startDom =
              '<img class="compare-main__content-product-item-image" src="' + imageSrc + '" width="140" height="140">';
            let endDom = '</img>';
            return startDom + endDom;
          }
          initProductContent(item) {
            let startDom = '<div class="compare-main__content-product-item-content">';
            let productContentDom = `
              ${this.initProductContentInfo(item)}
              ${this.initProductContentVariant(item)}
              ${this.initProductContentButton(item)}
            `;
            let endDom = '</div>';
            return startDom + productContentDom + endDom;
          }
          initProductContentInfo(item) {
            let startDom = `<a href="/products/${item.handle}" class="compare-main__content-product-item-info">`;
            let productContentInfoDom = `
              ${this.initProductContentInfoTitle(item)}
              ${this.initProductContentInfoPrice(item)}
            `;
            let endDom = '</a>';
            return startDom + productContentInfoDom + endDom;
          }
          initProductContentInfoTitle(item) {
            let startDom = '<div class="compare-main__content-product-item-info-title">';
            let productContentInfoTitleDom = `
              ${item.shortTitle || item.title}
            `;
            let endDom = '</div>';
            return startDom + productContentInfoTitleDom + endDom;
          }
          initProductContentInfoPrice(item) {
            let startDom = '<div class="compare-main__content-product-item-info-price">';
            let defaultVariant = this.getDefaultVariant(item);
            let newPrice = this.getDiscountPrice(defaultVariant.price, defaultVariant.discount) * 100;
            let oldPrice = defaultVariant.compareAtPrice * 100;
            let productContentInfoPriceDom = `
              ${this.initProductContentInfoPriceNew(item, newPrice)}
              ${this.initProductContentInfoPriceOld(item, newPrice, oldPrice)}
            `;
            let endDom = '</div>';
            return startDom + productContentInfoPriceDom + endDom;
          }
          initProductContentInfoPriceNew(item, price) {
            let startDom = `<div class="compare-main__content-product-item-info-price-new" data-product-id="${item.shopifyProductId}">`;
            let productContentInfoPriceNewDom = `
              ${window.Shopify.formatMoney(price, window.shopMoneyFormat)}
            `;
            let endDom = '</div>';
            return startDom + productContentInfoPriceNewDom + endDom;
          }
          initProductContentInfoPriceOld(item, price, oldPrice) {
            let stauts = 'true';
            if (oldPrice < price) {
              stauts = 'false';
            }
            let startDom = `<div class="compare-main__content-product-item-info-price-old" data-show="${stauts}" data-product-id="${item.shopifyProductId}">`;
            let productContentInfoPriceOldDom = `
              ${window.Shopify.formatMoney(oldPrice, window.shopMoneyFormat)}
            `;
            let endDom = '</div>';

            return startDom + productContentInfoPriceOldDom + endDom;
          }
          initProductContentVariant(item) {
            if (this.getAttribute('data-show-sku') === 'false' || item.variants.length <= 1) {
              return '';
            } else {
              let startDom =
                '<div class="compare-main__custom-select compare-main__content-product-item-variant" data-active="false">';
              let endDom = '</div>';
              let productContentVariantDom = `
                ${this.initProductContentVariantTrigger(item)}
                ${this.initProductContentVariantOptions(item)}
              `;
              return startDom + productContentVariantDom + endDom;
            }
          }
          initProductContentVariantTrigger(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let startDom = '<div class="compare-main__custom-select-trigger">';
            let endDom = '</div>';
            let productContentVariantTriggerDom = `
              ${this.initProductContentVariantTriggerTitle(item)}
              ${this.initProductContentVariantTriggerIcon(item)}
            `;
            return startDom + productContentVariantTriggerDom + endDom;
          }
          initProductContentVariantTriggerTitle(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let startDom = '<div class="compare-main__custom-select-trigger-title">';
            let endDom = '</div>';
            let productContentVariantTriggerTitleDom = `
              ${defaultVariant.title}
            `;
            return startDom + productContentVariantTriggerTitleDom + endDom;
          }
          initProductContentVariantTriggerIcon(item) {
            return `
                <svg
                  class="compare-main__custom-select-trigger-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  fill="none"
                  version="1.1"
                  width="14"
                  height="14.232421875"
                  viewBox="0 0 14 14.232421875"
                >
                  <g><g><rect x="0" y="0.232421875" width="14" height="14" rx="0" fill="#D9D9D9" fill-opacity="0"/></g><g transform="matrix(-0.7071067094802856,-0.7071067094802856,-0.7071067094802856,0.7071067094802856,22.47805441892706,9.310715064639226)"><path d="" fill="#D9D9D9" fill-opacity="0"/><path d="M10.30013996,5.232421875Q10.30014002,5.163491681,10.31358761,5.095885965Q10.32703525,5.028280245,10.3534137,4.964597045Q10.37979209,4.900913835,10.41808772,4.843600485Q10.45638323,4.786287125,10.50512424,4.737546115Q10.55386525,4.688805105,10.61117864,4.650509535Q10.66849196,4.6122139650000005,10.73217517,4.585835575Q10.79585837,4.559457125,10.86346409,4.546009485Q10.931069806,4.532561895,11,4.532561835Q11.068930194,4.532561895,11.13653591,4.546009485Q11.20414163,4.559457125,11.26782483,4.585835575Q11.33150804,4.6122139650000005,11.38882139,4.650509595Q11.44613475,4.688805105,11.49487576,4.737546115Q11.54361677,4.786287125,11.58191234,4.843600515Q11.62020791,4.900913835,11.6465863,4.964597045Q11.67296475,5.028280245,11.68641239,5.095885965Q11.69985998,5.163491681,11.69986004,5.232421875L11.69999999,5.232421875L11.69999999,10.532422075L17,10.532422075L17,10.532561775Q17.068929699999998,10.532561775,17.1365352,10.546009075Q17.2041407,10.559456875,17.2678242,10.585834975000001Q17.3315067,10.612213175,17.388820199999998,10.650509375Q17.4461336,10.688804675,17.494875,10.737545975Q17.5436158,10.786286375,17.581911599999998,10.843600275Q17.6202068,10.900913275,17.6465855,10.964596775Q17.6729641,11.028279775,17.6864119,11.095885775Q17.6998596,11.163491275,17.699860100000002,11.232421875Q17.6998596,11.301351575,17.6864123,11.368957075Q17.6729641,11.436562575,17.646585899999998,11.500246075Q17.6202078,11.563928575,17.581912,11.621242075Q17.5436168,11.678555475,17.4948759,11.727296875Q17.4461346,11.776037675000001,17.3888211,11.814333475Q17.3315077,11.852628675,17.2678242,11.879007375Q17.2041407,11.905385975,17.1365352,11.918833775Q17.068929699999998,11.932281475,17,11.932281975L17,11.932421675L11,11.932421675Q10.931056023,11.932421175,10.86343679,11.918970575Q10.79581757,11.905520475,10.73212165,11.879136575Q10.66842571,11.852752675,10.61110088,11.814450274999999Q10.55377603,11.776146875,10.50502527,11.727395975Q10.45627457,11.678645175,10.41797137,11.621320675Q10.37966812,11.563995875,10.35328442,11.500299975Q10.32690072,11.436603975,10.31345034,11.368984675Q10.30000007,11.301365875,10.30000001,11.232421875L10.30000001,5.232421875L10.30013996,5.232421875Z" fill-rule="evenodd" fill="#191919" fill-opacity="1"/></g></g>
                </svg>
            `;
          }

          initProductContentVariantOptions(item) {
            let startDom = '<div class="compare-main__custom-select-options">';
            let endDom = '</div>';
            let productContentVariantOptionsDom = `
              ${this.initProductContentVariantOptionsItems(item)}
            `;
            return startDom + productContentVariantOptionsDom + endDom;
          }
          initProductContentVariantOptionsItems(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let productContentVariantOptionsItemsDom = `
              ${item.variants
                .map((variant) => {
                  let newPrice = this.getDiscountPrice(variant.price, variant.discount);
                  return `
                <div class="compare-main__custom-select-option" 
                  data-price="${newPrice}" 
                  data-compare-price="${variant.compareAtPrice}" 
                  data-title="${variant.title}"
                  data-product-id="${item.shopifyProductId}"
                  data-product-title="${item.shortTitle || item.title}"
                  data-value="${variant.id}" 
                  data-inventory-quantity="${variant.inventoryQuantity}"
                  data-inventory-policy="${variant.inventoryPolicy}"
                  data-selected="${variant.id === defaultVariant.id ? 'true' : 'false'}"
                >
                  ${variant.title}
                </div>
              `;
                })
                .join('')}
            `;
            return productContentVariantOptionsItemsDom;
          }
          initProductContentButton(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let noStockout = defaultVariant.inventoryQuantity > 0 || defaultVariant.inventoryPolicy === 'continue';
            return `          
             <div class="compare-main__content-product-item-buttons" data-stockout="${noStockout ? 'false' : 'true'}">
                <div class="compare-main__content-product-item-add" 
                  data-product-id="${item.shopifyProductId}" 
                  data-action="add" 
                  data-loading="false" 
                  data-variant-id="${defaultVariant.id}"
                >
                  <div class="compare-main__content-product-item-add-text">${this.getAttribute(
                    'data-i18n-add-to-cart'
                  )}</div>
                  <div class="compare-main__content-product-item-add-icon">
                    <i class="items-center justify-center rotate_icon">
                      <div
                        class="loader-animation"
                        style="border:2px solid #fff; border-left-color: transparent;"
                      ></div>
                    </i>
                  </div>
                </div>
                <div class="compare-main__content-product-item-stockout">
                  <div class="compare-main__content-product-item-stockout-text">${this.getAttribute(
                    'data-i18n-stockout'
                  )}</div>
                  <klaviyo-bis-trigger class="w-full h-full left-0 top-0 absolute">
                    <div
                      class="klaviyo-bis-wrapper w-full h-full flex items-center justify-center text-[14px] transition-colors duration-300"
                      data-product="${item.shopifyProductId}"
                      data-variant="${defaultVariant.id}"
                      data-product-title="${item.shortTitle || item.title}"
                    >
                      <div class="add-to-cart-text w-full h-full flex items-center justify-center  text-[14px]   transition-colors duration-300">
                      </div>
                    </div>
                  </klaviyo-bis-trigger>
                </div>
              </div>
            `;
          }

          // 获取默认变体
          getDefaultVariant(item) {
            if (this.type === 'custom') {
              const ltCompareData = window.litime.getLocalStorage('ltCompareData') || [];
              // 找到对应的 compare 项
              const compareItem = ltCompareData.find((compareItem) => compareItem.id === item.shopifyProductId);

              // 如果 localstorage 里有记录的默认变体
              if (compareItem && compareItem.variantId) {
                const matchVariant = item.variants.find((variant) => variant.id == compareItem.variantId);
                if (matchVariant) return matchVariant;
              }

              // 否则返回第一个
              return item.variants[0];
            }

            // 非 custom
            const availableVariant = item.variants.find(
              (variant) => variant.inventoryQuantity > 0 || variant.inventoryPolicy === 'continue'
            );

            return availableVariant || item.variants[0];
          }

          initCustomSelect() {
            this.customSelectItems = [...this.querySelectorAll('.compare-main__custom-select')];

            this.customSelectItems.forEach((item) => {
              const trigger = item.querySelector('.compare-main__custom-select-trigger');
              const options = item.querySelector('.compare-main__custom-select-options');
              trigger.addEventListener('click', (e) => {
                e.preventDefault(); // 阻止跳转
                e.stopPropagation();
                this.customSelectItems.forEach((itemItem) => {
                  if (itemItem !== item && itemItem.getAttribute('data-active') === 'true') {
                    itemItem.setAttribute('data-active', 'false');
                  }
                });
                item.setAttribute('data-active', item.getAttribute('data-active') === 'true' ? 'false' : 'true');
              });
            });
            // 点击外部时
            this.addEventListener('click', (e) => {
              if (!this.customSelectItems.some((itemItem) => itemItem.contains(e.target))) {
                this.customSelectItems.forEach((item) => {
                  if (item.getAttribute('data-active') === 'true') {
                    item.setAttribute('data-active', 'false');
                  }
                });
              }
            });
            // 给compare-main__content-product-item-product-select下面的compare-main__custom-select-optionz增加点击事件
            this.querySelectorAll(
              '.compare-main__content-product-item-product-select .compare-main__custom-select-option'
            ).forEach((item) => {
              item.addEventListener('click', (e) => {
                e.preventDefault(); // 阻止跳转
                e.stopPropagation();
                if (item.getAttribute('data-disabled') == 'true') {
                  return;
                }
                let productId = item.getAttribute('data-value');
                let oldProductId = item.getAttribute('data-product-id');
                if (productId === oldProductId) {
                  return;
                }
                // 替换原本的productId
                this.productIds = this.productIds.map((item) => {
                  if (item === oldProductId) {
                    return productId;
                  }
                  return item;
                });

                this.initPageData();
              });
            });
            // 给变体选择框增加点击事件
            this.querySelectorAll(
              '.compare-main__content-product-item-variant .compare-main__custom-select-option'
            ).forEach((item) => {
              item.addEventListener('click', (e) => {
                e.preventDefault(); // 阻止跳转
                e.stopPropagation();
                if (item.getAttribute('data-disabled') == 'true') {
                  return;
                }
                // 找到父级，把active属性设置为false
                let parent = item.closest('.compare-main__content-product-item-variant');
                parent.setAttribute('data-active', 'false');
                // 将同级的option的selected属性设置为false
                parent.querySelectorAll('.compare-main__custom-select-option').forEach((itemItem) => {
                  itemItem.setAttribute('data-selected', 'false');
                });
                // 将当前option的selected属性设置为true
                item.setAttribute('data-selected', 'true');
                // 将当前option的title设置为触发器的文案
                let title = item.getAttribute('data-title');
                let productTitle = item.getAttribute('data-product-title');
                let trigger = parent.querySelector('.compare-main__custom-select-trigger-title');
                trigger.innerHTML = title;
                // 加购按钮需要修改变体,productId相同并且action为add的进行修改
                let variantId = item.getAttribute('data-value');
                let productId = item.getAttribute('data-product-id');
                this.querySelectorAll('[data-product-id="' + productId + '"][data-action="add"]').forEach(
                  (itemItem) => {
                    // 判断当前的变体库存，进行切换按钮的显示隐藏
                    let inventoryQuantity = item.getAttribute('data-inventory-quantity');
                    let inventoryPolicy = item.getAttribute('data-inventory-policy');
                    let noStockout = inventoryQuantity > 0 || inventoryPolicy === 'continue';
                    if (noStockout) {
                      itemItem
                        .closest('.compare-main__content-product-item-buttons')
                        ?.setAttribute('data-stockout', 'false');
                      itemItem
                        .closest('.compare-main-sticky-top__content-product-item-buttons')
                        ?.setAttribute('data-stockout', 'false');
                    } else {
                      itemItem
                        .closest('.compare-main__content-product-item-buttons')
                        ?.setAttribute('data-stockout', 'true');
                      itemItem
                        .closest('.compare-main-sticky-top__content-product-item-buttons')
                        ?.setAttribute('data-stockout', 'true');
                    }
                    itemItem.setAttribute('data-variant-id', variantId);
                    const stockoutDom = itemItem.parentElement.querySelector(
                      '.compare-main__content-product-item-stockout'
                    );

                    if (stockoutDom) {
                      stockoutDom.querySelector('.klaviyo-bis-wrapper').setAttribute('data-variant', variantId);
                      stockoutDom.querySelector('.klaviyo-bis-wrapper').setAttribute('data-product', productId);
                      stockoutDom
                        .querySelector('.klaviyo-bis-wrapper')
                        .setAttribute('data-product-title', productTitle);
                    }
                    const stockoutStickyDom = itemItem.parentElement.querySelector(
                      '.compare-main-sticky-top__content-product-item-stockout'
                    );
                    if (stockoutStickyDom) {
                      stockoutStickyDom.querySelector('.klaviyo-bis-wrapper').setAttribute('data-variant', variantId);
                      stockoutStickyDom.querySelector('.klaviyo-bis-wrapper').setAttribute('data-product', productId);
                      stockoutStickyDom
                        .querySelector('.klaviyo-bis-wrapper')
                        .setAttribute('data-product-title', productTitle);
                    }
                  }
                );
                // 价格变化compare-main__content-product-item-info-price-new 和compare-main__content-product-item-info-price-old
                let price = item.getAttribute('data-price');
                let comparePrice = item.getAttribute('data-compare-price');
                // 修改新价格
                this.querySelector(
                  `.compare-main__content-product-item-info-price-new[data-product-id="${productId}"]`
                ).innerHTML = window.Shopify.formatMoney(price * 100, window.shopMoneyFormat);
                // 修改旧价格
                this.querySelector(
                  `.compare-main__content-product-item-info-price-old[data-product-id="${productId}"]`
                ).innerHTML = window.Shopify.formatMoney(comparePrice * 100, window.shopMoneyFormat);
                // 判断是否显示旧价格，如果旧价格小于新价格，则显示旧价格
                if (comparePrice > price) {
                  this.querySelector(
                    `.compare-main__content-product-item-info-price-old[data-product-id="${productId}"]`
                  ).setAttribute('data-show', 'true');
                } else {
                  this.querySelector(
                    `.compare-main__content-product-item-info-price-old[data-product-id="${productId}"]`
                  ).setAttribute('data-show', 'false');
                }
                // 价格变化compare-main-sticky-top__content-product-item-price-new 和compare-main-sticky-top__content-product-item-price-old
                this.querySelector(
                  `.compare-main-sticky-top__content-product-item-price-new[data-product-id="${productId}"]`
                ).innerHTML = window.Shopify.formatMoney(price * 100, window.shopMoneyFormat);
                // 修改旧价格
                this.querySelector(
                  `.compare-main-sticky-top__content-product-item-price-old[data-product-id="${productId}"]`
                ).innerHTML = window.Shopify.formatMoney(comparePrice * 100, window.shopMoneyFormat);
                // 判断是否显示旧价格，如果旧价格小于新价格，则显示旧价格
                if (comparePrice > price) {
                  this.querySelector(
                    `.compare-main-sticky-top__content-product-item-price-old[data-product-id="${productId}"]`
                  ).setAttribute('data-show', 'true');
                } else {
                  this.querySelector(
                    `.compare-main-sticky-top__content-product-item-price-old[data-product-id="${productId}"]`
                  ).setAttribute('data-show', 'false');
                }
              });
            });
          }
          initProductButtonEvent() {
            this.querySelectorAll('[data-action="add"]').forEach((item) => {
              item.addEventListener('click', async (e) => {
                e.preventDefault(); // 阻止跳转
                e.stopPropagation();
                try {
                  if (item.getAttribute('data-loading') === 'true') {
                    return;
                  }
                  item.setAttribute('data-loading', 'true');
                  let params = [
                    {
                      id: item.getAttribute('data-variant-id'),
                      quantity: 1,
                    },
                  ];
                  await window.litime.addCart(params);
                } catch (error) {
                  console.log(error, 'error');
                } finally {
                  item.setAttribute('data-loading', 'false');
                }
              });
            });
          }
          bindEvents() {
            this.customCheckboxItems = this.querySelectorAll('.compare-main__custom-checkbox-item');
            this.customCheckboxItems.forEach((item) => {
              item.addEventListener('click', () => {
                this.toggleCustomCheckbox(item);
              });
            });
          }
          toggleCustomCheckbox(item) {
            const option = item.getAttribute('data-option');
            const value = item.getAttribute('data-value');
            const options = this.querySelectorAll(`[data-option="${option}"]`);
            // 如果是勾选上才走这个逻辑，取消勾选，则恢复默认
            if (value == 'true') {
              options.forEach((optionItem) => {
                optionItem.setAttribute('data-value', 'false');
              });
              if (option === 'highlight') {
                this.querySelectorAll('.compare-main__content-spec-row').forEach((item) => {
                  item.removeAttribute('data-highlight');
                });
              }
              if (option === 'hide') {
                this.querySelectorAll('.compare-main__content-spec-row').forEach((item) => {
                  item.removeAttribute('data-show');
                });
              }
            } else {
              options.forEach((optionItem) => {
                optionItem.setAttribute('data-value', 'true');
              });
              if (option === 'highlight') {
                this.querySelectorAll('.compare-main__content-spec-row').forEach((item) => {
                  if (item.getAttribute('data-same') == 'true') {
                    item.setAttribute('data-highlight', 'false');
                  } else {
                    item.setAttribute('data-highlight', 'true');
                  }
                });
              }
              if (option === 'hide') {
                this.querySelectorAll('.compare-main__content-spec-row').forEach((item) => {
                  if (item.getAttribute('data-same') == 'true') {
                    item.setAttribute('data-show', 'false');
                  } else {
                    item.setAttribute('data-show', 'true');
                  }
                });
              }
            }
          }
          getDiscountPrice(price, discount) {
            if (!discount) return price;

            // 安全兜底
            const percentageArr = Array.isArray(discount.percentage) ? discount.percentage : [];

            const amountArr = Array.isArray(discount.amount) ? discount.amount : [];

            // 拿最大折扣 quota
            const percentageMax = percentageArr.reduce((max, item) => Math.max(max, item.discountQuota || 0), 0);

            const amountMax = amountArr.reduce((max, item) => Math.max(max, item.discountQuota || 0), 0);

            // 计算两种折扣后的价格
            const p1 = price - amountMax; // 减金额
            const p2 = price * (1 - percentageMax / 100); // 按百分比
            return this.ceilToTwo(Math.min(p1, p2));
          }
          ceilToTwo(num) {
            return Math.ceil(num * 100) / 100;
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exhibition-activity"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('exhibition-activity')) {
      customElements.define(
        'exhibition-activity',
        class ExhibitionActivity extends HTMLElement {
          constructor() {
            super();
            this.fillterData = {
              scene: [],
              type: [],
              year: [],
              month: [],
              country: [],
              page: 1,
              page_size: 9,
              sort: 'all',
              activities: [], // 当前页数据，用于 DOM 渲染
              totalList: [], // 筛选+排序后的全量数据（未分页）
            };

            // All Events：按开始时间倒叙
            // Upcoming：取进行中和未开始的活动，按开始时间升序
            // Past：取已结束活动，按结束时间倒数
            // 默认值为Upcoming
          }
          connectedCallback() {
            this.subscribeEvent();
            this.init();
            this._boundPopState = this._onPopState.bind(this);
            window.addEventListener('popstate', this._boundPopState);
          }
          disconnectedCallback() {
            this.removeEventListener('click', this._onPaginationClick);
            if (this._boundCloseSortDropdown) {
              document.removeEventListener('click', this._boundCloseSortDropdown);
            }
            if (this._boundPopState) {
              window.removeEventListener('popstate', this._boundPopState);
            }
          }
          _onPopState() {
            this._applyFilterFromUrl();
          }
          _applyFilterFromUrl() {
            const params = new URLSearchParams(window.location.search);
            const fd = this.fillterData;
            const arrayKeys = ['scene', 'type', 'year', 'month', 'country'];
            arrayKeys.forEach((key) => {
              const value = params.get(key);
              if (value != null && value !== '') {
                fd[key] = value
                  .split(',')
                  .map((s) => s.trim())
                  .filter(Boolean);
              } else {
                fd[key] = [];
              }
            });
            const sortParam = params.get('sort');
            fd.sort = sortParam === 'all' || sortParam === 'upcoming' || sortParam === 'past' ? sortParam : 'upcoming';
            const pageParam = params.get('page');
            const page = pageParam != null ? parseInt(pageParam, 10) : 1;
            fd.page = !isNaN(page) && page >= 1 ? page : 1;
            this.getActivityList();
          }
          subscribeEvent() {
            window.litime.eventBus.subscribe('exhibition-activity:change-filter', (data) => {
              const fd = this.fillterData;
              if (Array.isArray(data.scene)) fd.scene = data.scene;
              if (Array.isArray(data.type)) fd.type = data.type;
              if (Array.isArray(data.year)) fd.year = data.year;
              if (Array.isArray(data.month)) fd.month = data.month;
              if (Array.isArray(data.country)) fd.country = data.country;
              if (data.page != null) fd.page = data.page;
              if (data.needFullRefresh !== false) {
                this.getActivityList();
              } else {
                this.applyPagination();
              }
            });
            // 左侧筛选组件就绪后请求初始状态时，回填当前 fillterData，避免刷新时时序导致回填失败
            window.litime.eventBus.subscribe('exhibition-activity:request-initial-filter', () => {
              if (window.litime.eventBus.publish) {
                window.litime.eventBus.publish('exhibition-activity:render-filter', {
                  filterData: this.fillterData,
                });
              }
            });
          }
          init() {
            this.activities = window.ACTIVITIES;
            // 初始化筛选数据
            this.initFilterData();
            // 初始化排序数据
            this.getActivityList();
            this._onPaginationClick = this._onPaginationClick.bind(this);
            this.addEventListener('click', this._onPaginationClick);
            this._initSortSelect();

            // 打开弹窗事件
            this.openFilterDialog();
          }

          openFilterDialog() {
            const filterButton = this.querySelector('.exhibition-activity__content-right-header-filter');
            if (!filterButton) return;
            filterButton.addEventListener('click', () => {
              window.litime.eventBus.publish('exhibition-activity:open-filter-dialog', {
                filterData: this.fillterData,
              });
            });
          }

          _initSortSelect() {
            const sortSelect = this.querySelector('.exhibition-activity__content-right-header-sort-select');
            if (!sortSelect) return;

            const closeDropdown = () => sortSelect.setAttribute('data-visible', 'false');

            sortSelect.addEventListener('click', (e) => {
              e.stopPropagation();
              const trigger = e.target.closest('.exhibition-activity__content-right-header-sort-select-trigger');
              const option = e.target.closest('.exhibition-activity__content-right-header-sort-select-option');
              if (trigger) {
                const visible = sortSelect.getAttribute('data-visible') === 'true';
                sortSelect.setAttribute('data-visible', visible ? 'false' : 'true');
              } else if (option) {
                const value = option.getAttribute('data-value');
                if (value == null) return;
                const options = sortSelect.querySelectorAll(
                  '.exhibition-activity__content-right-header-sort-select-option'
                );
                options.forEach((o) =>
                  o.setAttribute('data-selected', o.getAttribute('data-value') === value ? 'true' : 'false')
                );
                const triggerText = sortSelect.querySelector(
                  '.exhibition-activity__content-right-header-sort-select-trigger-text'
                );
                if (triggerText) triggerText.textContent = option.textContent.trim();
                this.fillterData.sort = value;
                this.fillterData.page = 1;
                this.getActivityList();
                closeDropdown();
              }
            });

            this._boundCloseSortDropdown = (e) => {
              if (!sortSelect.contains(e.target)) closeDropdown();
            };
            document.addEventListener('click', this._boundCloseSortDropdown);
          }

          initFilterData() {
            const fd = this.fillterData;
            const arrayKeys = ['scene', 'type', 'year', 'month', 'country'];
            arrayKeys.forEach((key) => {
              if (!Array.isArray(fd[key])) fd[key] = [];
            });
            // 给每条数据增加 status 属性
            this.activities.forEach((item) => {
              if (item.start_date_time >= Date.now()) {
                item.status = 'not_started';
              } else if (item.end_date_time < Date.now()) {
                item.status = 'ended';
              } else {
                item.status = 'active';
              }
            });
            // 从 URL 参数回填到 fillterData
            const params = new URLSearchParams(window.location.search);
            arrayKeys.forEach((key) => {
              const value = params.get(key);
              if (value != null && value !== '') {
                fd[key] = value
                  .split(',')
                  .map((s) => s.trim())
                  .filter(Boolean);
              }
            });
            const sortParam = params.get('sort');
            if (sortParam === 'all' || sortParam === 'upcoming' || sortParam === 'past') {
              fd.sort = sortParam;
            }
            const pageParam = params.get('page');
            if (pageParam != null) {
              const page = parseInt(pageParam, 10);
              if (!isNaN(page) && page >= 1) fd.page = page;
            }
            // 左侧筛选栏由 exhibition-activity-filter 组件订阅 exhibition-activity:render-filter 自行同步
          }

          // 从引用中取出 unique_id（格式为 { name, unique_id }）
          getRefId(ref) {
            if (ref == null || ref === '') return null;
            if (ref.unique_id != null) return String(ref.unique_id);
            return null;
          }

          matchRef(activityRef, selectedIds) {
            if (!selectedIds || selectedIds.length === 0) return true;
            const id = this.getRefId(activityRef);
            return id != null && selectedIds.some((s) => String(s) === id);
          }

          matchSceneList(activitySceneList, selectedIds) {
            if (!selectedIds || selectedIds.length === 0) return true;
            if (!activitySceneList || !Array.isArray(activitySceneList)) return false;
            return activitySceneList.some((ref) => this.matchRef(ref, selectedIds));
          }

          getActivityList() {
            // 筛选 + 排序，得到 totalList；仅筛选/排序变化时调用
            const activities = JSON.parse(JSON.stringify(this.activities));
            const fd = this.fillterData;

            let list = activities.filter((activity) => {
              if (!this.matchSceneList(activity.scene, fd.scene)) return false;
              if (!this.matchRef(activity.type, fd.type)) return false;
              if (!this.matchRef(activity.year, fd.year)) return false;
              if (!this.matchRef(activity.month, fd.month)) return false;
              if (!this.matchRef(activity.country, fd.country)) return false;
              return true;
            });

            const sortBy = fd.sort || 'upcoming';
            if (sortBy === 'all') {
              list.sort((a, b) => (b.start_date_time || 0) - (a.start_date_time || 0));
            } else if (sortBy === 'upcoming') {
              list = list.filter((a) => a.status === 'not_started' || a.status === 'active');
              list.sort((a, b) => (a.start_date_time || 0) - (b.start_date_time || 0));
            } else if (sortBy === 'past') {
              list = list.filter((a) => a.status === 'ended');
              list.sort((a, b) => (b.end_date_time || 0) - (a.end_date_time || 0));
            }

            fd.total = list.length;
            fd.totalList = list;

            this.applyPagination();
          }

          applyPagination() {
            // 仅根据 totalList + page/page_size 切当前页；仅翻页时调用，不重算 totalList
            const fd = this.fillterData;
            const list = fd.totalList || [];
            const page = Math.max(1, fd.page || 1);
            const pageSize = Math.max(1, fd.page_size || 9);
            const start = (page - 1) * pageSize;
            fd.activities = list.slice(start, start + pageSize);
            this.renderActivity();
          }
          renderActivity() {
            this.setUrlParams();
            this.renderNumber();
            this.renderActivityList();
            this.renderPagination();
            this.setAttribute('data-loading', 'false');
            const hasData = (this.fillterData.totalList && this.fillterData.totalList.length) > 0;
            this.setAttribute('data-empty', hasData ? 'false' : 'true');
            const self = this;
            setTimeout(function () {
              if (window.litime && window.litime.eventBus && window.litime.eventBus.publish) {
                window.litime.eventBus.publish('exhibition-activity:render-filter', {
                  filterData: self.fillterData,
                });
              }
            }, 0);
          }
          setUrlParams() {
            const fd = this.fillterData;
            const url = new URL(window.location.href);
            const arrayKeys = ['scene', 'type', 'year', 'month', 'country'];
            arrayKeys.forEach((key) => {
              const arr = Array.isArray(fd[key]) ? fd[key] : [];
              const value = arr.join(',');
              if (value) url.searchParams.set(key, value);
              else url.searchParams.delete(key);
            });
            if (fd.sort && fd.sort !== 'upcoming') {
              url.searchParams.set('sort', fd.sort);
            } else {
              url.searchParams.delete('sort');
            }
            const page = Math.max(1, parseInt(fd.page, 10) || 1);
            if (page > 1) url.searchParams.set('page', String(page));
            else url.searchParams.delete('page');
            const newUrl = url.pathname + (url.search || '') + (url.hash || '');
            if (window.history && window.history.replaceState) {
              window.history.replaceState({}, '', newUrl);
            }
          }
          renderPrevSvg() {
            return `
                  <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                fill="none"
                version="1.1"
                width="10.666666030883789"
                height="10.666666030883789"
                viewBox="0 0 10.666666030883789 10.666666030883789"
              >
                <g><path d="M5.80474,0.195262C6.06509,0.455611,6.06509,0.87772,5.80474,1.13807C5.80474,1.13807,2.27614,4.66667,2.27614,4.66667C2.27614,4.66667,10,4.66667,10,4.66667C10.3682,4.66667,10.6667,4.96515,10.6667,5.33333C10.6667,5.70152,10.3682,6,10,6C10,6,2.27614,6,2.27614,6C2.27614,6,5.80474,9.5286,5.80474,9.5286C6.06509,9.78893,6.06509,10.2111,5.80474,10.4714C5.54439,10.7317,5.12228,10.7317,4.86193,10.4714C4.86193,10.4714,0.195262,5.80474,0.195262,5.80474C-0.0650874,5.54439,-0.0650874,5.12228,0.195262,4.86193C0.195262,4.86193,4.86193,0.195262,4.86193,0.195262C5.12228,-0.0650874,5.54439,-0.0650874,5.80474,0.195262C5.80474,0.195262,5.80474,0.195262,5.80474,0.195262Z" fill-rule="evenodd" fill="#181818" fill-opacity="1"/></g>
              </svg>
            `;
          }
          renderNextSvg() {
            return `
                 <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                fill="none"
                version="1.1"
                width="10.666667938232422"
                height="10.666666030883789"
                viewBox="0 0 10.666667938232422 10.666666030883789"
              >
                <g><path d="M4.86193,0.195262C5.12228,-0.0650874,5.54439,-0.0650874,5.80474,0.195262C5.80474,0.195262,10.4714,4.86193,10.4714,4.86193C10.5964,4.98695,10.6667,5.15652,10.6667,5.33333C10.6667,5.51015,10.5964,5.67971,10.4714,5.80474C10.4714,5.80474,5.80474,10.4714,5.80474,10.4714C5.54439,10.7317,5.12228,10.7317,4.86193,10.4714C4.60158,10.2111,4.60158,9.78893,4.86193,9.5286C4.86193,9.5286,8.39053,6,8.39053,6C8.39053,6,0.666667,6,0.666667,6C0.298477,6,0,5.70152,0,5.33333C0,4.96515,0.298477,4.66667,0.666667,4.66667C0.666667,4.66667,8.39053,4.66667,8.39053,4.66667C8.39053,4.66667,4.86193,1.13807,4.86193,1.13807C4.60158,0.87772,4.60158,0.455612,4.86193,0.195262C4.86193,0.195262,4.86193,0.195262,4.86193,0.195262Z" fill-rule="evenodd" fill="#181818" fill-opacity="1"/></g>
              </svg>
            `;
          }
          renderNumber() {
            const fd = this.fillterData;
            const countEl = this.querySelector('.exhibition-activity__content-right-header-count-number');
            if (countEl) countEl.textContent = (fd.totalList && fd.totalList.length) || 0;
            const filterCountEl = this.querySelector('.exhibition-activity__content-right-header-filter-count');
            if (filterCountEl) {
              const filterTotal =
                ((fd.scene && fd.scene.length) || 0) +
                ((fd.type && fd.type.length) || 0) +
                ((fd.year && fd.year.length) || 0) +
                ((fd.month && fd.month.length) || 0) +
                ((fd.country && fd.country.length) || 0);
              filterCountEl.textContent = filterTotal;
            }
            const sortSelect = this.querySelector('.exhibition-activity__content-right-header-sort-select');
            if (sortSelect) {
              const sortBy = fd.sort || 'upcoming';
              const options = sortSelect.querySelectorAll(
                '.exhibition-activity__content-right-header-sort-select-option'
              );
              const triggerText = sortSelect.querySelector(
                '.exhibition-activity__content-right-header-sort-select-trigger-text'
              );
              options.forEach((o) => {
                const isSelected = o.getAttribute('data-value') === sortBy;
                o.setAttribute('data-selected', isSelected ? 'true' : 'false');
                if (isSelected && triggerText) triggerText.textContent = o.textContent.trim();
              });
            }
          }
          getLocationSvg() {
            return `
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
                  <defs><clipPath id="a"><rect width="20" height="20" rx="0"/></clipPath></defs><g ><path fill="#737373" fill-rule="evenodd" d="M5.751 2.785Q3.984 4.509 3.984 6.95q0 2.8 2.877 5.768 1.4 1.445 2.811 2.367h.657q1.41-.922 2.81-2.367 2.878-2.967 2.878-5.768 0-2.442-1.768-4.166Q12.49 1.067 10 1.067T5.751 2.785m1.972 9.099q-2.54-2.619-2.54-4.933 0-1.936 1.406-3.307Q8.001 2.267 10 2.267t3.411 1.377q1.406 1.37 1.406 3.307 0 2.314-2.54 4.933-1.142 1.178-2.277 1.975-1.135-.797-2.277-1.975m.379-6.698q-.786.785-.786 1.897 0 1.111.786 1.897.785.786 1.897.786 1.111 0 1.897-.786t.786-1.897-.786-1.897T10 4.4t-1.897.786m.848 2.946q-.434-.435-.434-1.05 0-.613.434-1.048Q9.385 5.6 10 5.6t1.049.434.434 1.049-.434 1.049q-.435.434-1.049.434t-1.05-.434m-4.244 5.516a.6.6 0 0 1-.427.575q-1.06.317-1.611.71-.402.284-.402.483 0 .198.402.484.552.391 1.61.709 2.357.707 5.721.707t5.72-.707q1.06-.318 1.611-.71.402-.285.402-.483 0-.199-.402-.484-.552-.392-1.61-.71a.6.6 0 0 1 .344-1.149q2.868.86 2.868 2.343 0 1.482-2.868 2.342-2.525.758-6.065.758t-6.065-.758q-2.868-.86-2.868-2.342t2.868-2.343a.6.6 0 0 1 .772.575"/></g>
              </svg>
            `;
          }
          getTimeSvg() {
            return `
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
                  <defs><clipPath id="a"><rect width="20" height="20" rx="0"/></clipPath></defs><g ><path fill="#737373" fill-rule="evenodd" d="M12.734 1.667a.6.6 0 0 1 1.2 0v.65h3.15q.593 0 1.013.42t.42 1.013v12.917q0 .593-.42 1.013t-1.013.42H2.917q-.594 0-1.014-.42t-.42-1.013V3.75q0-.594.42-1.013.42-.42 1.014-.42h3.149v-.65a.6.6 0 0 1 1.2 0v.65h5.468zm-6.668 1.85V5a.6.6 0 0 0 1.2 0V3.517h5.468V5a.6.6 0 0 0 1.2 0V3.517h3.15q.233 0 .233.233v3.567H2.684V3.75q0-.233.233-.233zm-3.382 5v8.15q0 .233.233.233h14.167q.233 0 .233-.233v-8.15zm3.15 2.916h2.5a.6.6 0 0 0 0-1.2h-2.5a.6.6 0 0 0 0 1.2m5.832 0h2.5a.6.6 0 0 0 0-1.2h-2.5a.6.6 0 0 0 0 1.2m-5.832 3.334h2.5a.6.6 0 0 0 0-1.2h-2.5a.6.6 0 0 0 0 1.2m5.832 0h2.5a.6.6 0 0 0 0-1.2h-2.5a.6.6 0 0 0 0 1.2"/></g>
              </svg>
            `;
          }
          renderActivityList() {
            const fd = this.fillterData;
            const list = fd.activities || [];
            const listEl = this.querySelector('.exhibition-activity__list');
            if (listEl) listEl.innerHTML = '';
            list.forEach((item) => {
              listEl.appendChild(this.renderActivityItem(item));
            });
          }

          _getPaginationPages(totalPages, current) {
            if (totalPages <= 0) return [];
            if (totalPages <= 7) {
              return Array.from({ length: totalPages }, (_, i) => i + 1);
            }
            if (current <= 4) {
              return [1, 2, 3, 4, 5, 'ellipsis', totalPages - 1, totalPages];
            }
            if (current >= totalPages - 3) {
              return [1, 'ellipsis', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
            }
            return [1, 'ellipsis', current - 1, current, current + 1, 'ellipsis', totalPages];
          }

          renderPagination() {
            const fd = this.fillterData;
            const total = (fd.totalList && fd.totalList.length) || 0;
            const pageSize = Math.max(1, fd.page_size || 9);
            const totalPages = Math.max(1, Math.ceil(total / pageSize));
            const current = Math.max(1, Math.min(fd.page || 1, totalPages));

            const listEl = this.querySelector('.exhibition-activity__pagination');
            if (!listEl) return;

            const prevDisabled = current <= 1;
            const nextDisabled = current >= totalPages;
            const prevHtml = `
              <div class="exhibition-activity__pagination-prev exhibition-activity__pagination-item-custom" data-disabled="${prevDisabled}" data-action="prev">
                ${this.renderPrevSvg()}
              </div>`;
            const pages = this._getPaginationPages(totalPages, current);
            const pagesHtml = pages
              .map((p) => {
                if (p === 'ellipsis') {
                  return '<span class="exhibition-activity__pagination-ellipsis exhibition-activity__pagination-item-custom">...</span>';
                }
                const active = p === current;
                return `<div class="exhibition-activity__pagination-item exhibition-activity__pagination-item-custom" data-active="${active}" data-page="${p}" data-action="page">${p}</div>`;
              })
              .join('');
            const nextHtml = `
              <div class="exhibition-activity__pagination-next exhibition-activity__pagination-item-custom" data-disabled="${nextDisabled}" data-action="next">
                ${this.renderNextSvg()}
              </div>`;
            listEl.innerHTML = prevHtml + pagesHtml + nextHtml;
          }

          _onPaginationClick(e) {
            const btn = e.target.closest('.exhibition-activity__pagination-item-custom[data-action]');
            if (!btn || !this.contains(btn)) return;
            if (btn.getAttribute('data-disabled') === 'true') return;

            const action = btn.getAttribute('data-action');
            const fd = this.fillterData;
            const total = (fd.totalList && fd.totalList.length) || 0;
            const pageSize = Math.max(1, fd.page_size || 9);
            const totalPages = Math.max(1, Math.ceil(total / pageSize));
            const current = fd.page || 1;

            if (action === 'prev') {
              if (current > 1) {
                fd.page = current - 1;
                this.applyPagination();
              }
              return;
            }
            if (action === 'next') {
              if (current < totalPages) {
                fd.page = current + 1;
                this.applyPagination();
              }
              return;
            }
            if (action === 'page') {
              const page = parseInt(btn.getAttribute('data-page'), 10);
              if (!isNaN(page) && page >= 1 && page <= totalPages && page !== current) {
                fd.page = page;
                this.applyPagination();
              }
            }
          }

          isExternalUrl(url) {
            if (!url || typeof url !== 'string' || !url.trim()) return false;
            try {
              const u = url.trim();
              const full = /^https?:\/\//i.test(u) ? u : window.location.origin + (u.startsWith('/') ? u : '/' + u);
              return new URL(full).origin !== window.location.origin;
            } catch {
              return false;
            }
          }
          renderActivityItem(item) {
            const urlStr = item.url != null ? String(item.url) : '';
            const hasUrl = urlStr.trim() !== '';
            const href = hasUrl ? urlStr : 'javascript:;';
            const targetAttr = hasUrl && this.isExternalUrl(urlStr) ? ' target="_blank"' : '';
            const sceneNames =
              item.scene && Array.isArray(item.scene)
                ? item.scene
                    .map((s) => (s && s.name) || '')
                    .filter(Boolean)
                    .join(', ')
                : '';
            const typeName = (item.type && item.type.name) || '';
            const sceneHtml = sceneNames
              ? `<div class="exhibition-activity__item-image-scene">${sceneNames}</div>`
              : '';

            const html = `
              <a class="exhibition-activity__item" href="${href}"${targetAttr}>
                <div class="exhibition-activity__item-image-wrapper">
                  <img
                    src="${item.cover_img || ''}"
                    alt="${(item.name || '').replace(/"/g, '&quot;')}"
                    loading="lazy"
                    width="319"
                    height="199"
                    class="exhibition-activity__item-image"
                  >
                  ${sceneHtml}
                </div>
                <div class="exhibition-activity__item-content">
                  <div class="exhibition-activity__item-content-top">
                    <div class="exhibition-activity__item-content-type">${typeName}</div>
                    <div class="exhibition-activity__item-content-name">${item.name || ''}</div>
                  </div>
                  <div class="exhibition-activity__item-content-bottom">
                    <div class="exhibition-activity__item-content-location">
                      ${this.getLocationSvg()}
                      ${item.location || ''}
                    </div>
                    <div class="exhibition-activity__item-content-time">
                      ${this.getTimeSvg()}
                      ${item.start_date || ''} - ${item.end_date || ''}
                    </div>
                  </div>
                </div>
              </a>
            `;
            const wrap = document.createElement('div');
            wrap.innerHTML = html.trim();
            return wrap.firstElementChild;
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-old-users-stories-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('find-old-users-stories-v2')) {
    customElements.define(
      'find-old-users-stories-v2',
      class FindOldUsersStoriesV2 extends HTMLElement {
        connectedCallback() {
          this._swiperEl = this.querySelector('.find-old-users-stories-v2__swiper');
          if (!this._swiperEl || typeof Swiper === 'undefined') return;

          const slideCount = this.querySelectorAll(
            '.find-old-users-stories-v2__swiper > .swiper-wrapper > .find-old-users-stories-v2__slide'
          ).length;
          this._slideCount = slideCount;
          this._progressEl = this.querySelector('[data-progress]');
          this._progressSegments = Array.from(this.querySelectorAll('[data-progress-segment]'));
          this._onProgressClick = this._handleProgressClick.bind(this);

          if (slideCount <= 1) {
            this.querySelectorAll('.find-old-users-stories-v2__nav-btn').forEach((btn) => {
              btn.style.display = 'none';
            });
            if (this._progressEl) {
              this._progressEl.style.visibility = 'hidden';
            }
          }

          this._progressSegments.forEach((segment) => {
            segment.addEventListener('click', this._onProgressClick);
          });

          this._compactMediaQuery = window.matchMedia('(max-width: 960px)');

          const autoplayConfig =
            slideCount > 1
              ? {
                  delay: 5000,
                  disableOnInteraction: false,
                  stopOnLastSlide: false,
                }
              : false;

          this._swiper = new Swiper(this._swiperEl, {
            // ≤960：单卡；>960：居中 auto 宽卡（布局与原先一致）
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
            loop: false,
            watchOverflow: slideCount <= 1,
            autoplay: autoplayConfig,
            navigation: {
              prevEl: this.querySelector('.find-old-users-stories-v2__nav-btn--prev'),
              nextEl: this.querySelector('.find-old-users-stories-v2__nav-btn--next'),
            },
            breakpoints: {
              961: {
                slidesPerView: 'auto',
                spaceBetween: 24,
                centeredSlides: true,
              },
            },
            on: {
              init: () => {
                this._syncActiveSegment();
                this._equalizeCardHeights();
                this._bindCardHeightEvents();
              },
              slideChange: () => {
                this._syncActiveSegment();
              },
              autoplayTimeLeft: (_swiper, _timeLeft, percentage) => {
                this._setActiveFill(1 - percentage);
              },
              resize: () => {
                this._equalizeCardHeights();
              },
            },
          });

          if (!this._cardHeightMediaQueryHandler) {
            this._cardHeightMediaQueryHandler = () => this._equalizeCardHeights();
            this._compactMediaQuery.addEventListener('change', this._cardHeightMediaQueryHandler);
          }

          this._resizeObserver = new ResizeObserver(() => {
            this._equalizeCardHeights();
          });
          this._resizeObserver.observe(this._swiperEl);
        }

        _getActiveIndex() {
          if (!this._swiper || this._slideCount <= 1) return 0;
          return Math.max(0, Math.min(this._slideCount - 1, this._swiper.activeIndex));
        }

        _syncActiveSegment() {
          if (!this._progressSegments.length) return;

          const activeIndex = this._getActiveIndex();
          this._progressSegments.forEach((segment, index) => {
            const isActive = index === activeIndex;
            segment.classList.toggle('is-active', isActive);

            const fill = segment.querySelector('[data-progress-fill]');
            if (fill && !isActive) {
              fill.style.transform = 'scaleX(0)';
            }
          });
        }

        _setActiveFill(ratio) {
          const segment = this._progressSegments[this._getActiveIndex()];
          const fill = segment?.querySelector('[data-progress-fill]');
          if (!fill) return;
          fill.style.transform = `scaleX(${Math.max(0, Math.min(1, ratio))})`;
        }

        _handleProgressClick(event) {
          if (!this._swiper || this._slideCount <= 1) return;

          const index = Number(event.currentTarget.getAttribute('data-index'));
          if (Number.isNaN(index) || index === this._getActiveIndex()) return;

          this._swiper.slideTo(index);
        }

        _bindCardHeightEvents() {
          this.querySelectorAll(
            '.find-old-users-stories-v2__card-media-image, .find-old-users-stories-v2__card-avatar-image'
          ).forEach((image) => {
            if (image.complete) return;
            image.addEventListener('load', () => this._equalizeCardHeights(), { once: true });
          });
        }

        _equalizeCardHeights() {
          const cards = this.querySelectorAll('.find-old-users-stories-v2__card');

          cards.forEach((card) => {
            card.style.minHeight = '';
          });

          if (cards.length === 0) return;

          let maxHeight = 0;
          cards.forEach((card) => {
            maxHeight = Math.max(maxHeight, card.offsetHeight);
          });

          if (maxHeight <= 0) return;

          cards.forEach((card) => {
            card.style.minHeight = `${maxHeight}px`;
          });
        }

        disconnectedCallback() {
          if (this._compactMediaQuery && this._cardHeightMediaQueryHandler) {
            this._compactMediaQuery.removeEventListener('change', this._cardHeightMediaQueryHandler);
            this._cardHeightMediaQueryHandler = null;
          }

          if (this._progressSegments?.length && this._onProgressClick) {
            this._progressSegments.forEach((segment) => {
              segment.removeEventListener('click', this._onProgressClick);
            });
          }

          if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            this._resizeObserver = null;
          }

          if (this._swiper?.destroy) {
            this._swiper.destroy(true, true);
            this._swiper = null;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-old-users-thank-you-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('find-old-users-thank-you-v2')) {
    customElements.define(
      'find-old-users-thank-you-v2',
      class FindOldUsersThankYouV2 extends HTMLElement {
        constructor() {
          super();
          this._onVideoItemClick = this._handleVideoItemClick.bind(this);
          this._onVideoItemKeydown = this._handleVideoItemKeydown.bind(this);
          this._handleVisibilityChange = this._onVisibilityChange.bind(this);
          this._handleResize = this._onResize.bind(this);
          this._videoItems = [];
        }

        connectedCallback() {
          this._track = this.querySelector('[data-track]');
          if (!this._track) return;

          this._speed = parseFloat(this.dataset.speed) || 40;
          this._pauseOnHover = true;
          this._canPauseOnHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          this._offset = 0;
          this._paused = false;
          this._loopWidth = 0;
          this._lastFrame = null;

          this._cloneTrackItems();
          this._bindEvents();
          this._bindVideoModals();
          this._measureAndStart();
          this._watchMediaLoad();
        }

        disconnectedCallback() {
          this._stop();
          window.clearTimeout(this._startFallbackTimer);
          this._startFallbackTimer = null;
          document.removeEventListener('visibilitychange', this._handleVisibilityChange);
          window.removeEventListener('resize', this._handleResize);
          if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            this._resizeObserver = null;
          }
          if (this._pauseOnHover && this._marqueeEl) {
            this._marqueeEl.removeEventListener('mouseenter', this._handleMouseEnter);
            this._marqueeEl.removeEventListener('mouseleave', this._handleMouseLeave);
          }
          this._videoItems.forEach((item) => {
            item.removeEventListener('click', this._onVideoItemClick);
            item.removeEventListener('keydown', this._onVideoItemKeydown);
          });
          this._videoItems = [];
        }

        _cloneTrackItems() {
          if (this._track.dataset.cloned === 'true') return;
          const originalHtml = this._track.innerHTML.trim();
          if (!originalHtml) return;
          this._track.insertAdjacentHTML('beforeend', originalHtml);
          this._track.dataset.cloned = 'true';
        }

        _measureLoopWidth() {
          const children = Array.from(this._track.children);
          if (children.length < 2) {
            this._loopWidth = 0;
            return;
          }

          const root = this.querySelector('.find-old-users-thank-you-v2');
          const fallbackItemSize = parseFloat(window.getComputedStyle(root).getPropertyValue('--item-size')) || 346;
          const halfCount = children.length / 2;
          const gap = parseFloat(getComputedStyle(this._track).gap) || 0;

          this._loopWidth = children.slice(0, halfCount).reduce((total, item, index) => {
            const measuredWidth = item.getBoundingClientRect().width;
            const itemWidth = measuredWidth > 0 ? measuredWidth : fallbackItemSize;
            const gapSize = index < halfCount - 1 ? gap : 0;
            return total + itemWidth + gapSize;
          }, 0);
        }

        _measureAndStart() {
          this._measureLoopWidth();
          this._start();
        }

        _onVisibilityChange() {
          if (document.hidden || !this._track) return;
          this._paused = false;
          this._measureLoopWidth();
          this._lastFrame = null;
          this._start();
        }

        _onResize() {
          if (!this._track) return;
          this._measureLoopWidth();
          this._lastFrame = null;
          this._start();
        }

        _watchMediaLoad() {
          const images = Array.from(this._track.querySelectorAll('img'));
          const remeasure = () => {
            this._measureLoopWidth();
            this._start();
          };

          images.forEach((image) => {
            if (image.complete) return;
            image.addEventListener('load', remeasure, { once: true });
            image.addEventListener('error', remeasure, { once: true });
          });

          this._startFallbackTimer = window.setTimeout(() => {
            this._measureLoopWidth();
            this._start();
          }, 1500);
        }

        _bindEvents() {
          this._marqueeEl = this.querySelector('.find-old-users-thank-you-v2__marquee');
          this._handleMouseEnter = () => {
            this._paused = true;
          };
          this._handleMouseLeave = () => {
            this._paused = false;
          };

          if (this._pauseOnHover && this._canPauseOnHover && this._marqueeEl) {
            this._marqueeEl.addEventListener('mouseenter', this._handleMouseEnter);
            this._marqueeEl.addEventListener('mouseleave', this._handleMouseLeave);
          }

          this._resizeObserver = new ResizeObserver(() => {
            this._measureLoopWidth();
            this._start();
          });
          this._resizeObserver.observe(this._track);

          document.addEventListener('visibilitychange', this._handleVisibilityChange);
          window.addEventListener('resize', this._handleResize, { passive: true });
        }

        _bindVideoModals() {
          this._videoItems = Array.from(
            this.querySelectorAll('.find-old-users-thank-you-v2__item--video[data-modal-id]')
          );
          this._videoItems.forEach((item) => {
            item.addEventListener('click', this._onVideoItemClick);
            item.addEventListener('keydown', this._onVideoItemKeydown);
          });
        }

        _getModalController() {
          if (typeof ModalController === 'undefined') return null;
          if (!window.litime.ModalControllerState) {
            window.litime.ModalControllerState = new ModalController();
          }
          return window.litime.ModalControllerState;
        }

        _openModal(modalId) {
          if (!modalId) return;
          this._getModalController()?.open(modalId);
        }

        _handleVideoItemClick(event) {
          this._openModal(event.currentTarget?.dataset?.modalId);
        }

        _handleVideoItemKeydown(event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this._handleVideoItemClick(event);
        }

        _start() {
          if (this._raf) return;
          this._lastFrame = null;
          this._raf = requestAnimationFrame(this._tick);
        }

        _stop() {
          if (this._raf) {
            cancelAnimationFrame(this._raf);
            this._raf = null;
          }
          this._lastFrame = null;
        }

        _tick = (timestamp) => {
          if (!this._lastFrame) {
            this._lastFrame = timestamp;
          }

          const delta = timestamp - this._lastFrame;
          this._lastFrame = timestamp;

          if (!this._paused && this._loopWidth > 0) {
            this._offset -= (this._speed * delta) / 1000;
            if (Math.abs(this._offset) >= this._loopWidth) {
              this._offset += this._loopWidth;
            }
            this._track.style.transform = `translate3d(${this._offset}px, 0, 0)`;
          }

          this._raf = requestAnimationFrame(this._tick);
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fisher-man-anglers-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fisher-man-anglers-v2')) {
    customElements.define(
      'fisher-man-anglers-v2',
      class FisherManAnglersV2 extends HTMLElement {
        connectedCallback() {
          this.cards = Array.from(this.querySelectorAll('[data-card]'));
          this.paginationEl = this.querySelector('[data-pagination]');
          this.perPageMobile = 10;
          this.page = 1;

          this._mq = window.matchMedia('(max-width: 960px)');
          this._onPaginationClick = this._handlePaginationClick.bind(this);
          this._onMediaChange = this._handleMediaChange.bind(this);

          if (this.paginationEl) {
            this.paginationEl.addEventListener('click', this._onPaginationClick);
          }
          this._mq.addEventListener('change', this._onMediaChange);

          this.render();
        }

        disconnectedCallback() {
          if (this.paginationEl) {
            this.paginationEl.removeEventListener('click', this._onPaginationClick);
          }
          if (this._mq) {
            this._mq.removeEventListener('change', this._onMediaChange);
          }
        }

        _isMobileView() {
          return this._mq.matches;
        }

        _getTotalPages() {
          if (!this._isMobileView() || !this.cards.length) return 0;
          return Math.ceil(this.cards.length / this.perPageMobile);
        }

        _handleMediaChange() {
          const totalPages = this._getTotalPages();
          if (this.page > totalPages) this.page = totalPages || 1;
          this.render();
        }

        _scrollToTop() {
          const top = this.getBoundingClientRect().top + window.scrollY - 30;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }

        _handlePaginationClick(event) {
          const btn = event.target.closest('[data-page]');
          if (!btn || btn.getAttribute('data-disabled') === 'true') return;

          const page = parseInt(btn.getAttribute('data-page'), 10);
          if (!page || page === this.page) return;

          this.page = page;
          this.render();
          this._scrollToTop();
        }

        render() {
          if (!this.cards.length) return;

          if (!this._isMobileView()) {
            this.page = 1;
            this.cards.forEach((card) => {
              card.hidden = false;
            });
            this.renderPagination(0);
            return;
          }

          const totalPages = this._getTotalPages();
          const start = (this.page - 1) * this.perPageMobile;
          const end = start + this.perPageMobile;

          this.cards.forEach((card, index) => {
            card.hidden = index < start || index >= end;
          });

          this.renderPagination(totalPages);
        }

        renderPagination(totalPages) {
          if (!this.paginationEl) return;

          if (totalPages <= 1) {
            this.paginationEl.hidden = true;
            this.paginationEl.innerHTML = '';
            return;
          }

          this.paginationEl.hidden = false;
          const page = this.page;
          let html = `<button type="button" class="fisher-man-anglers-v2__page-btn fisher-man-anglers-v2__page-btn--nav" data-dir="prev" data-page="${
            page - 1
          }" data-disabled="${
            page <= 1
          }" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none" aria-hidden="true"><path d="M6 1L1 6.5L6 12" stroke="#181818" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`;

          for (let i = 1; i <= totalPages; i++) {
            html += `<button type="button" class="fisher-man-anglers-v2__page-btn" data-page="${i}" data-active="${
              i === page
            }">${i}</button>`;
          }

          html += `<button type="button" class="fisher-man-anglers-v2__page-btn fisher-man-anglers-v2__page-btn--nav" data-dir="next" data-page="${
            page + 1
          }" data-disabled="${
            page >= totalPages
          }" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none" aria-hidden="true"><path d="M6 1L1 6.5L6 12" stroke="#181818" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`;

          this.paginationEl.innerHTML = html;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('main-footer')) {
      customElements.define(
        'main-footer',
        class ProductForm extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            const _this = this;
            this.serviceBtn();
            // 初始检测
            if (window.innerWidth <= 1200) {
              this.init();
              this.logoCarousel();
            }
            const form = $(this.querySelector('#footer_subscribe'));
            const submitBtn = form.find('button[type="submit"]');
            submitBtn.on('click', function (e) {
              e.preventDefault();
              const email = form.find('input[name="contact[email]"]').val();

              _this.handleSubmit(email, $(this));
            });

            // 添加resize监听
            this.resizeObserver = new ResizeObserver((entries) => {
              const width = entries[0].contentRect.width;
              if (width <= 1200 && !this.carouselInitialized) {
                this.logoCarousel();
                this.carouselInitialized = true;
              } else if (width > 1200 && this.carouselInitialized) {
                this.destroyCarousel();
                this.carouselInitialized = false;
              }
            });

            this.resizeObserver.observe(document.documentElement);
          }
          serviceBtn() {
            const serviceBtn = this.querySelector('.service-btn');
            serviceBtn.addEventListener('click', () => {
              // 调用客服
              window.litime.openChatApp();
            });
          }
          init() {
            const _this = this;
            const $footerMenuTitle = $('.footer_menu_title');
            $footerMenuTitle.on('click', function () {
              // 获取this同级的footer_menu_content
              const $footerMenuContent = $(this.nextElementSibling);
              const status = $(this).attr('data-status');
              if (status === 'close') {
                $footerMenuTitle.each(function () {
                  if ($(this).attr('data-status') === 'open') {
                    $(this).attr('data-status', 'close');
                    const footerMenuItem = $(this.nextElementSibling);
                    footerMenuItem.css('height', 0);
                    $(this).find('.link_add').removeClass('main-footer--hidden');
                    $(this).find('.link_remove').addClass('main-footer--hidden');
                  }
                });
                $(this).attr('data-status', 'open');
                $footerMenuContent.css('height', 'auto');
                const newHeight = $footerMenuContent.height();
                $footerMenuContent.css('height', 0);
                setTimeout(() => {
                  $(this).find('.link_add').addClass('main-footer--hidden');
                  $(this).find('.link_remove').removeClass('main-footer--hidden');
                  $footerMenuContent.css('height', newHeight + 'px');
                }, 0);
              } else {
                $(this).attr('data-status', 'close');
                $footerMenuContent.css('height', 0);
                $(this).find('.link_add').removeClass('main-footer--hidden');
                $(this).find('.link_remove').addClass('main-footer--hidden');
              }
            });
          }
          logoCarousel() {
            try {
              const shouldInit = window.matchMedia('(max-width: 1200px)').matches;
              if (!shouldInit) {
                return;
              }

              const container = this.querySelector('.carousel-container');
              const footer_slider = this.querySelector('.footer_slider');

              // 先清理所有旧的克隆元素，避免重复累积
              const existingClones = footer_slider.querySelectorAll('[data-cloned]');
              existingClones.forEach((clone) => clone.remove());

              // 添加安全宽度限制
              if (container.offsetWidth >= 1200) {
                return;
              }

              if (footer_slider.offsetParent === null) {
                setTimeout(() => this.logoCarousel(), 300);
                return;
              }

              // 获取当前可见的 logo 列表（非 hidden 的）
              const visibleLogoList = footer_slider.querySelector(
                '.logo-list-light:not(.main-footer--hidden), .logo-list-dark:not(.main-footer--hidden)'
              );
              if (!visibleLogoList) {
                return;
              }

              // 只选择当前可见列表中的非克隆logo容器div
              const logoContainers = Array.from(
                visibleLogoList.querySelectorAll('div.w-\\[180px\\]:not([data-cloned])')
              ).filter((container) => container.offsetWidth > 0);

              if (logoContainers.length === 0) {
                return;
              }

              const gapString = window.getComputedStyle(visibleLogoList).gap || '0';
              const gap = parseInt(gapString.replace('px', '')) || 0;

              // 计算总宽度，注意每个logo容器宽度加gap，最后一个不加gap
              const totalWidth = logoContainers.reduce((acc, container, index) => {
                const width = container.offsetWidth || 0;
                // 最后一个不加gap
                return acc + width + (index < logoContainers.length - 1 ? gap : 0);
              }, 0);
              if (totalWidth > container.offsetWidth) {
                // 双倍宽度用于无限滚动
                const actualTotalWidth = totalWidth * 2;

                if (actualTotalWidth > 1e6 || actualTotalWidth <= 0) {
                  return;
                }

                footer_slider.style.width = `${actualTotalWidth}px`;
                footer_slider.style.animation = `footer_slider ${logoContainers.length * 3}s linear infinite`;

                // 克隆完整的logo容器div，且标记data-cloned
                const cloneNodes = logoContainers.map((container) => {
                  const clone = container.cloneNode(true);
                  clone.setAttribute('data-cloned', 'true');
                  return clone;
                });
                cloneNodes.forEach((clone) => visibleLogoList.appendChild(clone));

                // 强制重绘
                void footer_slider.offsetHeight;
              } else {
                footer_slider.style.animation = 'none';
                footer_slider.style.removeProperty('width');
              }

              // 只绑定一次resize事件
              if (!this.resizeHandlerBound) {
                this.resizeHandlerBound = true;
                window.addEventListener('resize', () => {
                  clearTimeout(this.resizeTimer);
                  this.resizeTimer = setTimeout(() => this.logoCarousel(), 100);
                });
              }
            } catch (error) {
              console.error('Carousel initialization failed:', error);
            }
          }

          async subscribe(data, $button) {
            // 显示加载状态
            $button.find('.rotate_icon').removeClass('main-footer--hidden').addClass('main-footer--flex');
            $button.find('.loading-button-text').addClass('main-footer--hidden').removeClass('main-footer--flex');

            try {
              const url = `/shopify/user/point/subscribe`;
              const timestamp = getEncryptTimestamp();
              const headers = {
                nonce: litime_nonce,
                ticket: litime_ticket,
                timestamp,
              };
              const res = await window.litime.http.post(url, {
                data,
                headers,
              });

              if (res.code === 200) {
                window.litime.showToast('success', `${this.dataset.subscribeSuccessText}`);
                return res.data;
              } else {
                window.litime.showToast('error', `${this.dataset.subscribeErrorText}`);
                throw new Error(window.i18n.request_failed);
              }
            } catch (error) {
              throw error;
            } finally {
              // 恢复按钮状态
              $button.find('.rotate_icon').addClass('main-footer--hidden').removeClass('main-footer--flex');
              $button.find('.loading-button-text').removeClass('main-footer--hidden').addClass('main-footer--flex');
            }
          }
          async handleSubmit(email, $button) {
            try {
              await this.subscribe(
                {
                  email,
                },
                $button
              );
              // 订阅成功后清空输入框
              this.querySelector('input[name="contact[email]"]').value = '';
            } catch (error) {
              console.error('订阅失败:', error);
            }
          }

          destroyCarousel() {
            const footer_slider = this.querySelector('.footer_slider');
            if (footer_slider) {
              footer_slider.style.animation = 'none';
              footer_slider.style.width = 'auto';
              // 移除克隆元素
              const clones = footer_slider.querySelectorAll('[data-cloned]');
              clones.forEach((clone) => clone.remove());
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-compare-drawer-v2"]) return;
  try {
    
  $(function () {
    if (!customElements.get('global-compare-drawer-v2')) {
      customElements.define(
        'global-compare-drawer-v2',
        class GlobalCompareDrawerV2 extends HTMLElement {
          static DESKTOP_MAX = 4;
          static SMALL_MAX = 3;
          static MIN_COMPARE = 2;
          static SMALL_BREAKPOINT = 576;
          static TABLET_BREAKPOINT = 1200;

          connectedCallback() {
            this.hintEl = this.querySelector('[data-hint]');
            this.compareBtn = this.querySelector('[data-compare-submit]');
            this.productsEl = this.querySelector('[data-compare-products]');
            this.compareUrl = this.getAttribute('data-compare-url') || '';
            this.removeIconTemplate = this.querySelector('[data-remove-icon-template]');
            this._compareDelegated = false;
            this._productsClickBound = false;

            this.updateHint();
            this.initCompareActive();
            this.bindEvents();
            this.initDomObserver();
            this.syncCompareButtons();
            this.refreshProducts();
          }

          disconnectedCallback() {
            this._domObserver?.disconnect();
            this._domObserver = null;
            clearTimeout(this._syncDebounceTimer);
          }

          getMaxLimit() {
            return window.innerWidth <= GlobalCompareDrawerV2.SMALL_BREAKPOINT
              ? GlobalCompareDrawerV2.SMALL_MAX
              : GlobalCompareDrawerV2.DESKTOP_MAX;
          }

          formatTemplate(template, replacements) {
            let text = template || '';
            Object.entries(replacements).forEach(([key, value]) => {
              text = text.split(`{${key}}`).join(String(value));
            });
            return text;
          }

          getMaxLimitTip() {
            return this.formatTemplate(this.getAttribute('data-max-tip-template') || '', {
              MAX: this.getMaxLimit(),
            });
          }

          getMinLimitTip() {
            return this.formatTemplate(this.getAttribute('data-min-tip-template') || '', {
              MIN: GlobalCompareDrawerV2.MIN_COMPARE,
            });
          }

          updateHint() {
            const text = this.formatTemplate(this.getAttribute('data-hint-template') || '', {
              MAX: this.getMaxLimit(),
            });
            if (this.hintEl) {
              this.hintEl.textContent = text;
            }
          }

          initCompareActive() {
            if (this.isOnComparePage()) {
              this.hide();
              return;
            }

            this.clearCompareData();
            this.hide();
          }

          isOnComparePage() {
            const comparePath = this.getAttribute('data-compare-url') || '/pages/compare';
            try {
              const path = new URL(comparePath, window.location.origin).pathname.replace(/\/$/, '') || '/';
              const current = window.location.pathname.replace(/\/$/, '') || '/';
              return current === path;
            } catch {
              return window.location.href.includes(comparePath);
            }
          }

          bindEvents() {
            this.querySelector('[data-close-pc]')?.addEventListener('click', () => this.handleClose());
            this.querySelector('[data-close-mobile]')?.addEventListener('click', () => this.handleClose());
            this.compareBtn?.addEventListener('click', (e) => this.handleCompareSubmit(e));
            this.initCompareDelegate();

            if (!this._productsClickBound) {
              this._productsClickBound = true;
              this.productsEl?.addEventListener('click', (e) => {
                const removeBtn = e.target.closest('[data-product-remove]');
                if (!removeBtn) return;
                const index = Number(removeBtn.dataset.index);
                if (Number.isNaN(index)) return;
                this.removeProductAt(index);
              });
            }

            window.addEventListener('resize', () => {
              this.updateHint();
              this.enforceMaxOnResize();
            });
          }

          initDomObserver() {
            if (this._domObserver || typeof MutationObserver === 'undefined') return;

            this._domObserver = new MutationObserver((mutations) => {
              if (!this.mutationsIncludeCompareButtons(mutations)) return;
              this.scheduleSyncCompareButtons();
            });

            this._domObserver.observe(document.body, {
              childList: true,
              subtree: true,
            });
          }

          mutationsIncludeCompareButtons(mutations) {
            return mutations.some((mutation) => {
              if (mutation.type !== 'childList') return false;

              const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
              return nodes.some((node) => {
                if (node.nodeType !== Node.ELEMENT_NODE) return false;
                return node.matches?.('.extension-compare') || Boolean(node.querySelector?.('.extension-compare'));
              });
            });
          }

          scheduleSyncCompareButtons() {
            clearTimeout(this._syncDebounceTimer);
            this._syncDebounceTimer = setTimeout(() => {
              this.syncCompareButtons();
            }, 50);
          }

          initCompareDelegate() {
            if (this._compareDelegated) return;
            this._compareDelegated = true;

            document.body.addEventListener('click', (event) => {
              const compareDom = event.target.closest('.extension-compare');
              if (!compareDom) return;
              event.preventDefault();
              this.handleCompareClick(compareDom);
            });
          }

          enforceMaxOnResize() {
            let ltCompareData = window.litime?.getLocalStorage('ltCompareData') || [];
            const max = this.getMaxLimit();
            if (ltCompareData.length <= max) return;

            const removed = ltCompareData.splice(max);
            window.litime?.setLocalStorage('ltCompareData', ltCompareData);
            removed.forEach((item) => {
              document.querySelectorAll('.extension-compare').forEach((btn) => {
                if (String(btn.getAttribute('data-compare-id')) === String(item.id)) {
                  btn.setAttribute('data-compare-active', 'false');
                  btn.setAttribute('aria-pressed', 'false');
                }
              });
            });
            this.syncCompareButtons();
            this.refreshProducts();
          }

          syncCompareButtons() {
            const ltCompareData = window.litime?.getLocalStorage('ltCompareData') || [];
            const activeIds = new Set(ltCompareData.map((item) => String(item.id)));

            document.querySelectorAll('.extension-compare').forEach((btn) => {
              const id = btn.getAttribute('data-compare-id');
              const isActive = activeIds.has(String(id));
              btn.setAttribute('data-compare-active', isActive ? 'true' : 'false');
              btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
          }

          handleCompareClick(compareDom) {
            let ltCompareData = window.litime?.getLocalStorage('ltCompareData') || [];
            const compareData = {
              id: compareDom.getAttribute('data-compare-id'),
              variantId: compareDom.getAttribute('data-compare-variant-id'),
              handle: compareDom.getAttribute('data-compare-handle'),
              title: compareDom.getAttribute('data-compare-title'),
              image: compareDom.getAttribute('data-compare-image'),
              newPrice: compareDom.getAttribute('data-compare-new-price'),
              oldPrice: compareDom.getAttribute('data-compare-old-price'),
            };

            const index = ltCompareData.findIndex((item) => String(item.id) === String(compareData.id));

            if (index !== -1) {
              compareDom.setAttribute('data-compare-active', 'false');
              compareDom.setAttribute('aria-pressed', 'false');
              ltCompareData.splice(index, 1);
              if (ltCompareData.length === 0) {
                this.hide();
              }
            } else {
              if (!compareData.id) return;

              const max = this.getMaxLimit();
              if (ltCompareData.length >= max) {
                this.show();
                window.litime?.showToast?.('error', this.getMaxLimitTip());
                return;
              }

              ltCompareData.push(compareData);
              compareDom.setAttribute('data-compare-active', 'true');
              compareDom.setAttribute('aria-pressed', 'true');
              this.show();
            }

            window.litime?.setLocalStorage('ltCompareData', ltCompareData);
            this.syncCompareButtons();
            this.refreshProducts();
          }

          removeProductAt(index) {
            const ltCompareData = window.litime?.getLocalStorage('ltCompareData') || [];
            const removed = ltCompareData[index];
            if (!removed) return;

            ltCompareData.splice(index, 1);
            window.litime?.setLocalStorage('ltCompareData', ltCompareData);

            document.querySelectorAll('.extension-compare').forEach((btn) => {
              if (String(btn.getAttribute('data-compare-id')) === String(removed.id)) {
                btn.setAttribute('data-compare-active', 'false');
                btn.setAttribute('aria-pressed', 'false');
              }
            });

            this.syncCompareButtons();
            this.refreshProducts();

            if (ltCompareData.length === 0) {
              this.hide();
            }
          }

          createProductElement(item, index) {
            const product = document.createElement('div');
            product.className = 'global-compare-drawer-v2__product';
            product.dataset.index = String(index);

            const removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'global-compare-drawer-v2__product-remove';
            removeBtn.dataset.productRemove = '';
            removeBtn.dataset.index = String(index);
            if (this.removeIconTemplate?.content) {
              removeBtn.appendChild(this.removeIconTemplate.content.cloneNode(true));
            }

            const imageWrap = document.createElement('div');
            imageWrap.className = 'global-compare-drawer-v2__product-image';

            const img = document.createElement('img');
            img.src = item.image || '';
            img.alt = item.title || '';
            img.width = 56;
            img.height = 56;
            img.loading = 'lazy';
            img.setAttribute('fetchpriority', 'low');
            imageWrap.appendChild(img);

            const title = document.createElement('p');
            title.className = 'global-compare-drawer-v2__product-title';
            title.textContent = item.title || '';

            product.append(removeBtn, imageWrap, title);
            return product;
          }

          refreshProducts() {
            const ltCompareData = window.litime?.getLocalStorage('ltCompareData') || [];

            if (!this.productsEl) return;

            this.productsEl.innerHTML = '';
            ltCompareData.forEach((item, index) => {
              this.productsEl.appendChild(this.createProductElement(item, index));
            });
          }

          handleCompareSubmit(event) {
            event.preventDefault();
            const ltCompareData = window.litime?.getLocalStorage('ltCompareData') || [];

            if (ltCompareData.length < GlobalCompareDrawerV2.MIN_COMPARE) {
              window.litime?.showToast?.('error', this.getMinLimitTip());
              return;
            }

            const ids = ltCompareData.map((item) => item.id).join(',');
            const baseUrl = this.compareUrl || '/pages/compare';
            const separator = baseUrl.includes('?') ? '&' : '?';
            window.location.href = `${baseUrl}${separator}ids=${ids}`;
          }

          show() {
            this.setAttribute('data-show', 'true');
            window.litime?.setLocalStorage('ltCompareActive', 'true');
          }

          clearCompareData() {
            window.litime?.setLocalStorage('ltCompareData', []);
            document.querySelectorAll('.extension-compare').forEach((btn) => {
              btn.setAttribute('data-compare-active', 'false');
              btn.setAttribute('aria-pressed', 'false');
            });
            this.refreshProducts();
          }

          handleClose() {
            this.clearCompareData();
            this.hide();
          }

          hide() {
            this.setAttribute('data-show', 'false');
            window.litime?.setLocalStorage('ltCompareActive', 'false');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-footer-subscribe"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('global-footer-subscribe')) {
      customElements.define(
        'global-footer-subscribe',
        class GlobalFooterSubscribe extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initCheckbox();
            this.initSubmit();
          }
          initCheckbox() {
            const wrap = this.querySelector('.global-footer-subscribe__checkbox-wrap');
            if (!wrap) return;
            wrap.addEventListener('click', function () {
              const checked = wrap.getAttribute('data-checked') === 'true';
              wrap.setAttribute('data-checked', checked ? 'false' : 'true');
            });
          }
          initSubmit() {
            const self = this;
            const submitEl = this.querySelector('.global-footer-subscribe__submit');
            const inputEl = this.querySelector('input[name="contact[email]"]');
            if (!submitEl || !inputEl) return;
            submitEl.addEventListener('click', function (e) {
              e.preventDefault();
              const email = (inputEl.value || '').trim();
              const wrap = self.querySelector('.global-footer-subscribe__checkbox-wrap');
              const acceptsMarketing = wrap && wrap.getAttribute('data-checked') === 'true' ? '1' : '0';
              self.handleSubmit(email, acceptsMarketing, submitEl);
            });
          }
          async subscribe(data, buttonEl) {
            buttonEl.setAttribute('data-loading', 'true');
            try {
              const url = '/shopify/user/point/subscribe';
              const timestamp = typeof getEncryptTimestamp === 'function' ? getEncryptTimestamp() : '';
              const headers = {
                nonce: typeof litime_nonce !== 'undefined' ? litime_nonce : '',
                ticket: typeof litime_ticket !== 'undefined' ? litime_ticket : '',
                timestamp: timestamp,
              };
              const res = await window.litime.http.post(url, { data, headers });
              if (res.code === 200) {
                window.litime.showToast('success', this.dataset.subscribeSuccessText || 'Subscribe successfully');
                return res.data;
              } else {
                window.litime.showToast('error', this.dataset.subscribeErrorText || 'Subscribe failed');
                throw new Error(
                  window.i18n && window.i18n.request_failed ? window.i18n.request_failed : 'Request failed'
                );
              }
            } catch (error) {
              throw error;
            } finally {
              buttonEl.setAttribute('data-loading', 'false');
            }
          }
          async handleSubmit(email, acceptsMarketing, buttonEl) {
            try {
              await this.subscribe({ email, acceptsMarketing, tag: this.dataset.tag }, buttonEl);
              const inputEl = this.querySelector('input[name="contact[email]"]');
              if (inputEl) inputEl.value = '';
              const wrap = this.querySelector('.global-footer-subscribe__checkbox-wrap');
              if (wrap) wrap.setAttribute('data-checked', 'false');
            } catch (error) {
              console.error('Subscribe failed:', error);
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-footer-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('global-footer-v2')) {
      customElements.define(
        'global-footer-v2',
        class GlobalFooterV2 extends HTMLElement {
          constructor() {
            super();
            this._onAccordionClick = this._onAccordionClick.bind(this);
          }

          connectedCallback() {
            this._bindAccordion();
          }

          disconnectedCallback() {
            this._unbindAccordion();
          }

          _bindAccordion() {
            const headers = this.querySelectorAll('.global-footer-v2__accordion-header');
            headers.forEach((header) => {
              header.addEventListener('click', this._onAccordionClick);
            });
          }

          _unbindAccordion() {
            const headers = this.querySelectorAll('.global-footer-v2__accordion-header');
            headers.forEach((header) => {
              header.removeEventListener('click', this._onAccordionClick);
            });
          }

          _onAccordionClick(event) {
            const header = event.currentTarget;
            const item = header.closest('.global-footer-v2__accordion-item');
            const content = item.querySelector('.global-footer-v2__accordion-content');
            const isOpen = item.classList.contains('is-open');

            this.querySelectorAll('.global-footer-v2__accordion-item.is-open').forEach((openItem) => {
              if (openItem !== item) {
                this._closeAccordionItem(openItem);
              }
            });

            if (isOpen) {
              this._closeAccordionItem(item);
            } else {
              this._openAccordionItem(item, content, header);
            }
          }

          _openAccordionItem(item, content, header) {
            item.classList.add('is-open');
            item.setAttribute('data-status', 'open');
            header.setAttribute('aria-expanded', 'true');
            content.style.height = 'auto';
            const height = content.scrollHeight;
            content.style.height = '0';
            requestAnimationFrame(() => {
              content.style.height = height + 'px';
            });
          }

          _closeAccordionItem(item) {
            const content = item.querySelector('.global-footer-v2__accordion-content');
            const header = item.querySelector('.global-footer-v2__accordion-header');
            item.classList.remove('is-open');
            item.setAttribute('data-status', 'close');
            header.setAttribute('aria-expanded', 'false');
            content.style.height = '0';
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-header-v2"]) return;
  try {
    
  $(function () {
    if (!customElements.get('lt-header-v2')) {
      customElements.define(
        'lt-header-v2',
        class LtHeaderV2 extends HTMLElement {
          constructor() {
            super();
            this.$ltHeader = null;
            this.$headerContainer = null;
            this.$header = null;
            this.$announcement = null;
            this.$announcementHeight = null;
            this.$scrollThreshold = 50; // 设置滚动阈值
            this.$scrollShow = true;
            this.$loginButton = null;
            this.$body = null;
            this.$lastScrollTop = 0;
            this.$screen = null;
            this.$theme = null;
            this.$currentInfo = {};
            this.$defaultScreen = null;
            this.$scrollBtnContainer = null;
            this.country = null;
            this.$stickies = null; // tab-sticky 元素列表
            this.$navHoverItems = [];
            this._onNavItemEnter = this._onNavItemEnter.bind(this);
            this._onNavItemLeave = this._onNavItemLeave.bind(this);
            this._onNavLinkEnter = this._onNavLinkEnter.bind(this);
            this._onNavLinkLeave = this._onNavLinkLeave.bind(this);
            this._onSharedDropdownEnter = this._onSharedDropdownEnter.bind(this);
            this._onSharedDropdownLeave = this._onSharedDropdownLeave.bind(this);
            this._onOverlayEnter = this._onOverlayEnter.bind(this);
            this._$navDropdownShared = document.getElementById('nav-dropdown-shared');
            this._activeSource = null;
            this._closeTimer = null;
            this._lastSyncedDataScreen = null;
            this._lastHeaderBgAtTop = null;
            this._scrollStateReady = false;
          }

          connectedCallback() {
            // this.initCountry(); // 初始化切换站点
            window.addEventListener('pagehide', () => {
              this.clearLoadingButtons();
            });
            document.addEventListener('visibilitychange', () => {
              if (document.visibilityState === 'visible') {
                this.clearLoadingButtons();
              }
            });

            this.$body = $('body');
            this.$header = this.querySelector('#header-v2');
            this.$ltHeader = this;
            this._categorySourceAnchor = null;
            this.$headerLayout = this.querySelector('.nav-layout');
            this.$defaultScreen = this.$ltHeader.getAttribute('data-defaultScreen'); //是否开启
            this.announcement = $('#announcement');
            this.globalHeaderEnsign = $('.global-header-ensign-root');
            this.$headerSection = this.closest('.shopify-section.header-v2');
            this.$headerContainer = this.$headerSection ? $(this.$headerSection) : $('.shopify-section.header-v2');
            this.$stickies = document.querySelectorAll('.tab-sticky'); // 获取所有 tab-sticky 元素

            const bootstrap = window.__headerV2ScrollBootstrap;
            const initialScrollTop =
              bootstrap && typeof bootstrap.getLastScrollTop === 'function'
                ? bootstrap.getLastScrollTop()
                : window.scrollY || document.documentElement.scrollTop || 0;
            this.$lastScrollTop = initialScrollTop;

            if (bootstrap && typeof bootstrap.syncHeaderHeightVar === 'function') {
              bootstrap.syncHeaderHeightVar();
            }

            this.init();
            this.currentScreen();
            this.$prevBtn = this.querySelector('.scroll-btn-container .swiper-button-prev');
            this.$nextBtn = this.querySelector('.scroll-btn-container .swiper-button-next');
            this.$scroller = this.querySelector('.nav-layout__list');
            this.$navHoverItems = Array.from(this.querySelectorAll('.header__nav-content .nav-layout__list > li'));

            this.$scrollBtnContainer = this.querySelector('.scroll-btn-container');
            if (this.$scroller && this.$prevBtn && this.$nextBtn) {
              this.$prevBtn.addEventListener('click', () => this.scrollTo('swiper-button-prev'));
              this.$nextBtn.addEventListener('click', () => this.scrollTo('swiper-button-next'));
              this.$scroller.addEventListener('scroll', () => this.updateButtons());
            }

            // 添加鼠标悬浮事件
            if (this.$scrollBtnContainer) {
              this.$scrollBtnContainer.addEventListener('mouseenter', () => {
                const marketingBanner = document.querySelector('marketing-banner[data-default-style="dark"]');
                if (marketingBanner) {
                  this._setDataScreen(true, 'scrollBtnContainer:mouseenter:has-marketing-banner');
                } else {
                  this._setDataScreen(false, 'scrollBtnContainer:mouseenter:no-marketing-banner');
                }
              });
            }

            this.$navHoverItems.forEach((item) => {
              item.addEventListener('mouseenter', this._onNavItemEnter);
              item.addEventListener('mouseleave', this._onNavItemLeave);
              const categoryNav = item.querySelector('.category-nav.link-nav.menu-list__item');
              const menuNavItem = item.querySelector('.menu-nav.link-nav.nav-item.menu-list__item');
              if (categoryNav) {
                categoryNav.addEventListener('mouseenter', this._onNavLinkEnter);
                categoryNav.addEventListener('mouseleave', this._onNavLinkLeave);
              }
              if (menuNavItem) {
                menuNavItem.addEventListener('mouseenter', this._onNavLinkEnter);
                menuNavItem.addEventListener('mouseleave', this._onNavLinkLeave);
              }
            });

            if (this._$navDropdownShared) {
              this._$navDropdownShared.addEventListener('mouseenter', this._onSharedDropdownEnter);
              this._$navDropdownShared.addEventListener('mouseleave', this._onSharedDropdownLeave);
            }

            const $overlay = this.querySelector('.header-v2-nav-overlay');
            if ($overlay) {
              $overlay.addEventListener('mouseenter', this._onOverlayEnter);
            }

            const debouncedNavResize = debounce(() => {
              requestAnimationFrame(() => {
                if (this._$navDropdownShared.classList.contains('is-open')) {
                  this._calcNavDropdownMaxHeight();
                }
              });
            }, 100);
            window.addEventListener('resize', debouncedNavResize);

            // 使用防抖处理 resize 事件
            const debouncedUpdate = debounce(() => {
              requestAnimationFrame(() => {
                if (this.$scroller) {
                  this.updateButtons();
                }
              });
            }, 100);

            window.addEventListener('resize', debouncedUpdate);

            // 初始化时就设置按钮状态
            requestAnimationFrame(() => {
              if (this.$scroller) {
                this.updateButtons();
              }
            });

            this.mobilePopupLogin();
            this.initMobileNav();
          }
          static get observedAttributes() {
            return ['data-theme', 'data-screen'];
          }

          attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue === newValue) return;

            if (name === 'data-screen') {
              if (newValue == 'false') {
                // 确保处理布尔值或字符串
                if (this.$header) {
                  this.$header.classList.add('theme-light-current');
                }

                this.$screen = false;
                return; // 直接退出，不执行后续逻辑
              } else if (newValue == 'true' || newValue == true) {
                this.$screen = true;
                if (this.$header) {
                  this.$header.classList.remove('theme-light-current');
                }
              }
            }

            if ((this.$screen === true || this.$screen === 'true') && name === 'data-theme') {
              if (this.$header) {
                if (name === 'data-theme' && newValue === 'light') {
                  this.$header.classList.remove('theme-dark');
                  this.$header.classList.add('theme-light');
                } else if (name === 'data-theme' && newValue === 'dark' && this.$defaultScreen == 'true') {
                  this.$header.classList.remove('theme-light');
                  this.$header.classList.add('theme-dark');
                }
              }
            } else if (name === 'data-screen' && (this.$screen === true || this.$screen === 'true')) {
              if (this.$currentInfo.name === 'data-theme' && this.$currentInfo.value === 'light') {
                this.$header.classList.remove('theme-dark');
                this.$header.classList.add('theme-light');
              } else if (this.$currentInfo.name === 'data-theme' && this.$currentInfo.value === 'dark') {
                this.$header.classList.remove('theme-light');
                this.$header.classList.add('theme-dark');
              }
            }
            if (name == 'data-theme') {
              this.$currentInfo = { name: name, value: newValue };
            }
          }
          clearLoadingButtons() {
            const buyNowBtns = document.querySelectorAll('.loading-button');
            buyNowBtns.forEach((btn) => {
              const rotateIcon = btn.querySelector('.rotate_icon');
              if (rotateIcon) {
                rotateIcon.classList.remove('flex');
                rotateIcon.classList.add('hidden');
              }
            });
          }

          currentScreen() {
            this.$screen = this.$ltHeader.getAttribute('data-screen');
            this.$theme = this.$ltHeader.getAttribute('data-theme');
            if (window.location.pathname !== '/') {
              this.$screen = false;
              this.$theme = 'light';
              this._setDataScreen(false, 'currentScreen:non-home');
              this.$ltHeader.setAttribute('data-theme', 'light');
            }
            if (this.$screen != 'false' || this.$screen == true) {
              if (this.$theme == 'light') {
                this.$header.classList.remove('theme-dark');
                this.$header.classList.add('theme-light');
              } else if (this.$theme == 'dark') {
                this.$header.classList.remove('theme-light');
                this.$header.classList.add('theme-dark');
              }
            } else {
              this.$screen = false;
              this.$header.classList.add('theme-light');
              this._setDataScreen(false, 'currentScreen:screen-false-branch');
              this.$ltHeader.setAttribute('data-theme', 'light');
            }
          }

          /**
           * 统一设置 data-screen，值未变时不写 DOM
           */
          _setDataScreen(nextValue, source = 'unknown') {
            if (!this.$ltHeader) return;

            const normalized = nextValue === true || nextValue === 'true' ? 'true' : 'false';
            const current = this.$ltHeader.getAttribute('data-screen');
            if (current === normalized) {
              this._lastSyncedDataScreen = normalized;
              return;
            }

            this.$ltHeader.setAttribute('data-screen', normalized);
            this._lastSyncedDataScreen = normalized;
          }

          _getAtTopSafeDistance() {
            let topElementsHeight = 0;
            document.querySelectorAll('.global-top-banner-v2').forEach((el) => {
              const style = window.getComputedStyle(el);
              if (style.display !== 'none' && style.visibility !== 'hidden') {
                topElementsHeight += el.offsetHeight || 0;
              }
            });
            const baseHeight = window.innerWidth >= 1200 ? 74 : 52;
            return baseHeight + topElementsHeight;
          }

          _isAtTop(scrollTop) {
            return scrollTop <= this._getAtTopSafeDistance();
          }

          _getDataScreenScrollThreshold() {
            return this._getAtTopSafeDistance();
          }

          _shouldDataScreenBeTrue(scrollTop) {
            if (this.$defaultScreen != true && this.$defaultScreen != 'true') {
              return null;
            }
            return this._isAtTop(scrollTop);
          }

          _syncDataScreenFromScroll(scrollTop, source = 'scroll') {
            const shouldBeTrue = this._shouldDataScreenBeTrue(scrollTop);
            if (shouldBeTrue === null) return;

            const next = shouldBeTrue ? 'true' : 'false';
            if (this._lastSyncedDataScreen === next) return;

            const current = this.$ltHeader?.getAttribute('data-screen');
            if (current === next) {
              this._lastSyncedDataScreen = next;
              return;
            }

            this._setDataScreen(shouldBeTrue, source);
            this.$scrollShow = shouldBeTrue;
          }

          _syncDataAtTopFromScroll(scrollTop) {
            const atTop = this._isAtTop(scrollTop) ? 'true' : 'false';
            if (this.$ltHeader?.getAttribute('data-at-top') !== atTop) {
              this.$ltHeader.setAttribute('data-at-top', atTop);
            }
          }

          _applyHeaderBackground(scrollTop) {
            const isAtTop = this._isAtTop(scrollTop);
            if (this._lastHeaderBgAtTop === isAtTop) return;
            this._lastHeaderBgAtTop = isAtTop;

            if (!isAtTop) {
              this.$header.classList.remove('bg-transparent', 'border-transparent', 'theme-dark');
              this.$header.classList.add('bg-white', 'header-light');
              this.$headerLayout?.classList.remove('text-white');
              return;
            }

            const canBeTransparent =
              this.$ltHeader?.getAttribute('data-defaultscreen') === 'true' &&
              !this.$header?.classList.contains('header__main--solid');

            if (!canBeTransparent) {
              this.$header.classList.remove('bg-transparent', 'border-transparent');
              this.$header.classList.add('bg-white', 'header-light');
              this.$headerLayout?.classList.remove('text-white');
              return;
            }

            if (this.announcement.length > 0) {
              this.$header.classList.remove('bg-white', 'header-light', 'light-default');
              this.$header.classList.add('bg-transparent');
              this.$theme = this.$ltHeader.getAttribute('data-theme');
              return;
            }

            this.$theme = this.$ltHeader.getAttribute('data-theme');
            this.$headerLayout?.classList.remove('text-white');
            this.$header.classList.remove('bg-white', 'header-light');
            this.$header.classList.add('bg-transparent', 'border-transparent');
          }

          _setScrollShow(show) {
            const bootstrap = window.__headerV2ScrollBootstrap;
            if (bootstrap && typeof bootstrap.setScrollShow === 'function') {
              bootstrap.setScrollShow(show);
              return;
            }

            if (this.$ltHeader) {
              this.$ltHeader.setAttribute('data-scrollshow', show ? 'true' : 'false');
            }
          }

          _applyHeaderVisibilityFromScroll(currentScrollTop) {
            let anyStickyAtTop = false;
            if (this.$stickies && this.$stickies.length > 0) {
              this.$stickies.forEach((sticky) => {
                const rect = sticky.getBoundingClientRect();
                if (rect.top <= 0 && rect.bottom > 0) {
                  anyStickyAtTop = true;
                }
              });
            }
            if (this._isHeaderPinnedTop() || this._shouldKeepHeaderPinned()) {
              this._pinHeaderSectionTop();
              return;
            }

            if (currentScrollTop > this.$lastScrollTop) {
              this._setScrollShow(false);
              return;
            }

            if (currentScrollTop < this.$lastScrollTop) {
              if (!anyStickyAtTop) {
                this._setScrollShow(true);
              } else {
                this._setScrollShow(false);
              }
            }
          }

          _applyScrollState(scrollTop, source = 'scroll') {
            this._syncDataAtTopFromScroll(scrollTop);
            this._applyHeaderBackground(scrollTop);
            this._syncDataScreenFromScroll(scrollTop, source);
          }

          disconnectedCallback() {
            if (this.$header) {
              this.$header.classList.remove('header__main--nav-hover');
            }
            if (this.$navHoverItems.length > 0) {
              this.$navHoverItems.forEach((item) => {
                item.removeEventListener('mouseenter', this._onNavItemEnter);
                item.removeEventListener('mouseleave', this._onNavItemLeave);
                const categoryNav = item.querySelector('.category-nav.link-nav.menu-list__item');
                const menuNav = item.querySelector('.menu-nav.link-nav.nav-item.menu-list__item');
                if (categoryNav) {
                  categoryNav.removeEventListener('mouseenter', this._onNavLinkEnter);
                  categoryNav.removeEventListener('mouseleave', this._onNavLinkLeave);
                  const dropdown = categoryNav.querySelector('.category-nav__dropdown');
                  if (dropdown) {
                    dropdown.removeEventListener('mouseenter', this._onDropdownEnter);
                    dropdown.removeEventListener('mouseleave', this._onDropdownLeave);
                  }
                }
                if (menuNav) {
                  menuNav.removeEventListener('mouseenter', this._onNavLinkEnter);
                  menuNav.removeEventListener('mouseleave', this._onNavLinkLeave);
                }
              });
            }
            if (this._$navDropdownShared) {
              this._$navDropdownShared.removeEventListener('mouseenter', this._onSharedDropdownEnter);
              this._$navDropdownShared.removeEventListener('mouseleave', this._onSharedDropdownLeave);
            }
            const $overlay = this.querySelector('.header-v2-nav-overlay');
            if ($overlay) {
              $overlay.removeEventListener('mouseenter', this._onOverlayEnter);
            }
            clearTimeout(this._closeTimer);
            if (this._onWindowScroll) {
              $(window).off('scroll', this._onWindowScroll);
            }
            if (this._onWindowScrollRestore) {
              window.removeEventListener('pageshow', this._onWindowScrollRestore);
            }
            window.__headerV2ScrollManaged = false;
            if (this._onMobileNavResize) {
              window.removeEventListener('resize', this._onMobileNavResize);
            }
            if (this._onMobileMenuOpen && this.$mobileMenu) {
              this.$mobileMenu.removeEventListener('click', this._onMobileMenuOpen);
            }
            if (this._onMobileMenuClose && this.$mobileMenuClose) {
              this.$mobileMenuClose.removeEventListener('click', this._onMobileMenuClose);
            }
            if (this._onMobileNavPanelClick && this.$mobileNavPanel) {
              this.$mobileNavPanel.removeEventListener('click', this._onMobileNavPanelClick, true);
            }
            if (this._onMobileCountrySheetClick && this.$mobileCountrySheet) {
              this.$mobileCountrySheet.removeEventListener('click', this._onMobileCountrySheetClick);
            }
            if (this._onMobileCountryKeydown) {
              document.removeEventListener('keydown', this._onMobileCountryKeydown);
            }
            this.closeMobileCountrySheet(true);
            this.closeMobileNav();
            window.overlayManager.hide('header');
          }

          _onNavItemEnter() {
            // CSS :has() handles background-color & z-index on hover/active
          }

          _onNavItemLeave() {
            // CSS :has() handles background-color & z-index on hover/active
          }

          _clearNavLinkActive(exceptLink = null) {
            const navList = this.querySelector('.nav-layout__list');
            if (!navList) return;

            navList
              .querySelectorAll('.category-nav.link-nav.menu-list__item, .menu-nav.link-nav.nav-item.menu-list__item')
              .forEach((el) => {
                if (el !== exceptLink) {
                  el.classList.remove('is-active');
                }
              });
          }

          _onNavLinkEnter(e) {
            const enteringLink = e.target.closest(
              '.category-nav.link-nav.menu-list__item, .menu-nav.link-nav.nav-item.menu-list__item'
            );
            if (!enteringLink) return;

            clearTimeout(this._closeTimer);
            this._clearNavLinkActive(enteringLink);

            const source = enteringLink.querySelector('[data-dropdown-source]');
            if (!source) return;

            const $shared = this._$navDropdownShared;
            const enteringSource = $shared.querySelector('[data-dropdown-source]');

            if (enteringSource !== source) {
              $shared.innerHTML = '';
              $shared.appendChild(source.cloneNode(true));
            }
            enteringLink.classList.add('is-active');
            $shared.classList.add('is-open');
            if (window.litime && window.litime.disableScroll) {
              window.litime.disableScroll();
            }
            this._calcNavDropdownMaxHeight();
            this._activeSource = source;
          }

          _calcNavDropdownMaxHeight() {
            if (!this._$navDropdownShared) return;
            const headerEl = document.getElementById('header-v2');
            if (!headerEl) return;
            const headerHeight = headerEl.getBoundingClientRect().bottom;
            const maxH = window.innerHeight - headerHeight - 24;
            this._$navDropdownShared.style.maxHeight = maxH > 0 ? maxH + 'px' : 'none';
            this._$navDropdownShared.style.overflow = maxH > 0 ? 'auto' : 'visible';
          }

          _onNavLinkLeave(e) {
            const leavingLink = e.target.closest(
              '.category-nav.link-nav.menu-list__item, .menu-nav.link-nav.nav-item.menu-list__item'
            );
            if (!leavingLink) return;

            const related = e.relatedTarget;
            const $shared = this._$navDropdownShared;

            if ($shared.contains(related) || related === $shared) return;

            leavingLink.classList.remove('is-active');
            $shared.classList.remove('is-open');
            if (window.litime && window.litime.enableScroll) {
              window.litime.enableScroll();
            }
            this._closeTimer = setTimeout(() => {
              $shared.innerHTML = '';
              $shared.style.maxHeight = '';
              $shared.style.overflow = '';
              this._activeSource = null;
            }, 300);
          }

          _onSharedDropdownEnter() {
            clearTimeout(this._closeTimer);
          }

          _onOverlayEnter() {
            this._clearNavLinkActive();
          }

          _onSharedDropdownLeave(e) {
            const related = e.relatedTarget;
            const navItem = this._activeSource?.closest('.menu-list__item');

            if (navItem && (navItem.contains(related) || navItem === related)) return;

            const $shared = this._$navDropdownShared;
            const activeLink = navItem?.querySelector(
              '.category-nav.link-nav.menu-list__item, .menu-nav.link-nav.nav-item.menu-list__item'
            );
            if (activeLink) activeLink.classList.remove('is-active');

            $shared.classList.remove('is-open');
            if (window.litime && window.litime.enableScroll) {
              window.litime.enableScroll();
            }
            this._closeTimer = setTimeout(() => {
              $shared.innerHTML = '';
              $shared.style.maxHeight = '';
              $shared.style.overflow = '';
              this._activeSource = null;
            }, 300);
          }

          init() {
            if (this.$header && this.$header.classList.contains('bg-transparent')) {
            }
            this.scroll();
          }

          _isHeaderPinnedTop() {
            return Boolean(this.$headerSection?.classList.contains('header-v2--pinned-top'));
          }

          _pinHeaderSectionTop() {
            if (!this.$headerSection) return;
            this.$headerSection.classList.add('header-v2--pinned-top');
            if (this.$headerContainer?.length) {
              this.$headerContainer.addClass('header-v2--pinned-top');
            }
            if (this.$ltHeader) {
              this._setScrollShow(true);
            }
          }

          _unpinHeaderSectionTop() {
            if (!this.$headerSection) return;
            this.$headerSection.classList.remove('header-v2--pinned-top');
            if (this.$headerContainer?.length) {
              this.$headerContainer.removeClass('header-v2--pinned-top');
            }
          }

          _shouldKeepHeaderPinned() {
            return (
              document.body.classList.contains('body-mobile-menu-open-V2') ||
              this.$ltHeader?.classList.contains('is-mobile-nav-open') ||
              (this.$mobileCountrySheet && this.$mobileCountrySheet.classList.contains('is-open'))
            );
          }

          scroll() {
            if (this._onWindowScroll) {
              $(window).off('scroll', this._onWindowScroll);
            }
            if (this._onWindowScrollRestore) {
              window.removeEventListener('pageshow', this._onWindowScrollRestore);
            }

            this._scrollStateReady = false;

            const initialScrollTop = $(window).scrollTop();
            this.$lastScrollTop = initialScrollTop;

            if (this.announcement.length > 0) {
              this.$headerContainer.addClass('header-v2-sticky');

              if (initialScrollTop > this.announcement.height()) {
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white', 'header-light', 'light-default');
              } else if (initialScrollTop > this.$scrollThreshold) {
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white');
              }
            } else if (initialScrollTop > this.announcement.height()) {
              this.$headerContainer.addClass('header-v2-sticky');
              this.$header.classList.remove('bg-transparent', 'border-transparent');
              this.$header.classList.add('bg-white', 'header-light', 'light-default');
            }

            this._applyScrollState(initialScrollTop, 'scroll:init');

            this._onWindowScroll = () => {
              const currentScrollTop = $(window).scrollTop();
              if (!this._scrollStateReady) {
                return;
              }
              const delta = currentScrollTop - this.$lastScrollTop;
              if (Math.abs(delta) < 5) {
                return;
              }

              this._applyScrollState(currentScrollTop, 'scroll');

              requestAnimationFrame(() => {
                this._applyHeaderVisibilityFromScroll(currentScrollTop);
                this.$lastScrollTop = currentScrollTop;
                if (window.__headerV2ScrollBootstrap?.setLastScrollTop) {
                  window.__headerV2ScrollBootstrap.setLastScrollTop(currentScrollTop);
                }
              });
            };

            const bindScrollListener = () => {
              window.__headerV2ScrollManaged = true;

              const restoredScrollTop = $(window).scrollTop();
              this.$lastScrollTop = restoredScrollTop;
              this._applyScrollState(restoredScrollTop, 'scroll:restore');
              this._applyHeaderVisibilityFromScroll(restoredScrollTop);
              this._scrollStateReady = true;
              $(window).on('scroll', this._onWindowScroll);
            };

            this._onWindowScrollRestore = (event) => {
              if (!event.persisted) return;
              requestAnimationFrame(bindScrollListener);
            };
            window.addEventListener('pageshow', this._onWindowScrollRestore);

            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(bindScrollListener), {
                once: true,
              });
            } else {
              requestAnimationFrame(bindScrollListener);
            }
          }

          // 左右切换菜单逻辑
          // 显示/隐藏滚动按钮
          updateButtons() {
            if (!this.$scroller || !this.$scrollBtnContainer || !this.$prevBtn || !this.$nextBtn) {
              return;
            }
            const scrollLeft = this.$scroller.scrollLeft;
            const maxScroll = this.$scroller.scrollWidth - this.$scroller.clientWidth;
            // 检查是否需要滚动（内容宽度是否大于容器宽度）
            const needsScroll = this.$scroller.scrollWidth > this.$scroller.clientWidth;

            if (needsScroll) {
              // 显示按钮容器
              this.$scrollBtnContainer.classList.add('show');

              // 先显示两个按钮
              this.$prevBtn.classList.add('show-btn');
              this.$nextBtn.classList.add('show-btn');

              // 检查是否到达边界
              const isAtStart = scrollLeft <= 0;
              const isAtEnd = scrollLeft >= maxScroll;

              // 更新左按钮状态（到达左边界时设置半透明）
              if (isAtStart) {
                this.$prevBtn.style.opacity = '0.4';
                this.$prevBtn.style.pointerEvents = 'none';
              } else {
                this.$prevBtn.style.opacity = '1';
                this.$prevBtn.style.pointerEvents = 'auto';
              }

              // 更新右按钮状态（到达右边界时设置半透明）
              if (isAtEnd) {
                this.$nextBtn.style.opacity = '0.4';
                this.$nextBtn.style.pointerEvents = 'none';
              } else {
                this.$nextBtn.style.opacity = '1';
                this.$nextBtn.style.pointerEvents = 'auto';
              }
            } else {
              // 如果不需要滚动，隐藏整个按钮容器
              this.$scrollBtnContainer.classList.remove('show');
              this.$prevBtn.classList.remove('show-btn');
              this.$nextBtn.classList.remove('show-btn');
              this.$prevBtn.style.pointerEvents = 'none';
              this.$nextBtn.style.pointerEvents = 'none';
            }
          }

          // 滚动处理
          scrollTo(direction) {
            if (!this.$scroller) {
              return;
            }
            const scrollAmount = 300;
            this.$scroller.scrollBy({
              left: direction === 'swiper-button-prev' ? -scrollAmount : scrollAmount,
              behavior: 'smooth',
            });
          }
          // 左右切换菜单逻辑 end

          isMobileNavViewport() {
            return window.innerWidth <= 1200;
          }

          resetMobileNavPanels() {
            if (!this.$mobileNavPanel) return;
            this.closeMobileOverlaySources();
            this.$mobileNavPanel.querySelectorAll('.header-v2-mobile-nav__subpanel').forEach((panel) => {
              panel.classList.remove('header-v2-mobile-nav__subpanel--active');
              panel.setAttribute('hidden', '');
            });
            if (this.$mobileNavContent) {
              this.$mobileNavContent.classList.remove('is-subpanel-open');
            }
            if (this.$mobileNavCloseRow) {
              this.$mobileNavCloseRow.classList.remove('is-subpanel');
            }
            if (this.$mobileNavHeaderTitle) {
              this.$mobileNavHeaderTitle.textContent = '';
            }
          }

          closeMobileOverlaySources() {
            if (!this.$mobileNavPanel) return;

            this.$mobileNavPanel.querySelectorAll('.header-v2-mobile-category-source.is-open').forEach((el) => {
              el.classList.remove('is-open');
              el.classList.add('header-v2-mobile-category-source--hidden');
            });

            this.$mobileNavPanel.querySelectorAll('.header-v2-mobile-menu-source.is-open').forEach((el) => {
              el.classList.remove('is-open');
              el.classList.add('header-v2-mobile-category-source--hidden');
            });

            if (this._categorySourceAnchor) {
              const { source, parent, next } = this._categorySourceAnchor;
              if (source && parent) {
                if (next) {
                  parent.insertBefore(source, next);
                } else {
                  parent.appendChild(source);
                }
              }
              this._categorySourceAnchor = null;
            }

            if (this._menuSourceAnchor) {
              const { source, parent, next } = this._menuSourceAnchor;
              if (source && parent) {
                if (next) {
                  parent.insertBefore(source, next);
                } else {
                  parent.appendChild(source);
                }
              }
              this._menuSourceAnchor = null;
            }

            if (this.$mobileNavContent) {
              this.$mobileNavContent.classList.remove('is-category-open');
            }
          }

          closeMobileCategorySources() {
            this.closeMobileOverlaySources();
          }

          _findMobileCategorySource(target) {
            if (!this.$mobileNavPanel || !target) return null;
            const escaped = this._escapeAttrSelector(target);
            return this.$mobileNavPanel.querySelector(`[data-mobile-category-content][data-block-id="${escaped}"]`);
          }

          _openMobileOverlaySource(source, title, anchorKey) {
            if (!source || !this.$mobileNavContent) return;

            this.resetMobileNavPanels();

            source.classList.remove('header-v2-mobile-category-source--hidden');
            source.classList.add('is-open');

            if (source.parentElement !== this.$mobileNavContent) {
              this[anchorKey] = {
                source,
                parent: source.parentElement,
                next: source.nextElementSibling,
              };
              this.$mobileNavContent.appendChild(source);
            }

            this.$mobileNavContent.classList.add('is-category-open');

            if (this.$mobileNavCloseRow) {
              this.$mobileNavCloseRow.classList.add('is-subpanel');
            }
            if (this.$mobileNavHeaderTitle) {
              this.$mobileNavHeaderTitle.textContent = title || '';
            }
          }

          openMobileCategorySource(target, title) {
            const source = this._findMobileCategorySource(target);
            this._openMobileOverlaySource(source, title, '_categorySourceAnchor');
          }

          _findMobileMenuSource(target) {
            if (!this.$mobileNavPanel || !target) return null;
            const escaped = this._escapeAttrSelector(target);
            return this.$mobileNavPanel.querySelector(`[data-mobile-menu-content][data-block-id="${escaped}"]`);
          }

          openMobileMenuSource(target, title) {
            const source = this._findMobileMenuSource(target);
            this._openMobileOverlaySource(source, title, '_menuSourceAnchor');
          }

          _escapeAttrSelector(value) {
            if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
              return CSS.escape(String(value));
            }
            return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
          }

          _findMobileSubpanel(target, trigger) {
            if (!this.$mobileNavPanel || !target) return null;

            const escaped = this._escapeAttrSelector(target);
            let panel =
              this.$mobileNavPanel.querySelector(`[data-subpanel="${escaped}"]`) ||
              this.$mobileNavPanel.querySelector(`#mobile-subpanel-${escaped}`);

            if (!panel && trigger) {
              const controlsId = trigger.getAttribute('aria-controls');
              if (controlsId) {
                panel =
                  this.$mobileNavPanel.querySelector(`#${this._escapeAttrSelector(controlsId)}`) ||
                  document.getElementById(controlsId);
              }
            }

            return panel;
          }

          _hydrateMobileSubpanel(target, panel) {
            const body = panel.querySelector('.header-v2-mobile-nav__subpanel-body');
            if (!body) return;

            const escaped = this._escapeAttrSelector(target);
            const source = this.$mobileNavPanel.querySelector(
              `[data-mobile-category-content][data-block-id="${escaped}"]`
            );
            if (source) {
              body.innerHTML = source.innerHTML;
            }
          }

          openMobileNavSubpanel(target, title, trigger) {
            const panel = this._findMobileSubpanel(target, trigger);
            if (!panel) {
              console.warn('[header-v2] mobile subpanel not found:', target);
              return;
            }

            this.resetMobileNavPanels();

            this._hydrateMobileSubpanel(target, panel);

            const panelTitle = title || panel.getAttribute('data-subpanel-title') || '';
            panel.classList.add('header-v2-mobile-nav__subpanel--active');
            panel.removeAttribute('hidden');

            if (this.$mobileNavContent) {
              this.$mobileNavContent.classList.add('is-subpanel-open');
            }
            if (this.$mobileNavCloseRow) {
              this.$mobileNavCloseRow.classList.add('is-subpanel');
            }
            if (this.$mobileNavHeaderTitle) {
              this.$mobileNavHeaderTitle.textContent = panelTitle;
            }
          }

          closeMobileNavSubpanel() {
            if (this.$mobileNavContent?.classList.contains('is-category-open')) {
              this.closeMobileOverlaySources();
              if (this.$mobileNavCloseRow) {
                this.$mobileNavCloseRow.classList.remove('is-subpanel');
              }
              if (this.$mobileNavHeaderTitle) {
                this.$mobileNavHeaderTitle.textContent = '';
              }
              return;
            }
            this.resetMobileNavPanels();
          }

          openMobileNav() {
            if (!this.isMobileNavViewport() || !this.$mobileNavPanel) return;

            this.closeMobileNavSubpanel();
            this._pinHeaderSectionTop();

            document.body.classList.add('body-mobile-menu-open-V2');
            if (window.litime && window.litime.disableScroll) {
              window.litime.disableScroll('header-v2-mobile-nav');
            }

            this.$mobileNavPanel.style.display = '';
            this.$mobileNavPanel.classList.remove('is-closing');
            this.$mobileNavPanel.classList.add('is-open');
            this.$mobileNavPanel.setAttribute('aria-hidden', 'false');
            if (this.$ltHeader) {
              this.$ltHeader.classList.add('is-mobile-nav-open');
            }
          }

          openMobileCountrySheet() {
            if (!this.$mobileCountrySheet) return;

            this._pinHeaderSectionTop();

            this.$mobileCountrySheet.removeAttribute('hidden');
            this.$mobileCountrySheet.setAttribute('aria-hidden', 'false');
            if (this.$mobileCountryOpen) {
              this.$mobileCountryOpen.setAttribute('aria-expanded', 'true');
            }

            requestAnimationFrame(() => {
              this.$mobileCountrySheet.classList.add('is-open');
            });

            if (window.litime && window.litime.disableScroll) {
              window.litime.disableScroll('header-v2-country-sheet');
            }
          }

          closeMobileCountrySheet(force = false) {
            const sheet = this.$mobileCountrySheet;
            if (!sheet) return;
            if (!sheet.classList.contains('is-open') && !force) return;

            sheet.classList.remove('is-open');
            sheet.setAttribute('aria-hidden', 'true');
            if (this.$mobileCountryOpen) {
              this.$mobileCountryOpen.setAttribute('aria-expanded', 'false');
            }

            const finishClose = () => {
              sheet.setAttribute('hidden', '');
              if (window.litime && window.litime.enableScroll) {
                window.litime.enableScroll('header-v2-country-sheet');
              }
              if (!this._shouldKeepHeaderPinned()) {
                this._unpinHeaderSectionTop();
              }
            };

            if (force) {
              finishClose();
              return;
            }

            const panel = sheet.querySelector('.header-v2-mobile-country-sheet__panel');
            let done = false;
            const onEnd = (event) => {
              if (event.target !== panel || done) return;
              done = true;
              finishClose();
            };

            panel?.addEventListener('transitionend', onEnd, { once: true });
            window.setTimeout(() => {
              if (!done) {
                done = true;
                finishClose();
              }
            }, 350);
          }

          initMobileCountrySheet() {
            this.$mobileCountrySheet = document.querySelector('[data-mobile-country-sheet]');
            this.$mobileCountryOpen = document.querySelector('[data-mobile-country-open]');
            this.$mobileCountryPanel = this.$mobileCountrySheet?.querySelector(
              '.header-v2-mobile-country-sheet__panel'
            );

            if (!this.$mobileCountrySheet) return;

            this._onMobileCountrySheetClick = (event) => {
              if (event.target.closest('[data-mobile-country-close]')) {
                event.preventDefault();
                this.closeMobileCountrySheet();
              }
            };

            this._onMobileCountryKeydown = (event) => {
              if (event.key === 'Escape' && this.$mobileCountrySheet.classList.contains('is-open')) {
                event.preventDefault();
                this.closeMobileCountrySheet();
              }
            };

            this.$mobileCountrySheet.addEventListener('click', this._onMobileCountrySheetClick);
            document.addEventListener('keydown', this._onMobileCountryKeydown);

            const countryList = this.$mobileCountrySheet.querySelector('.header-v2-mobile-country-sheet__list');
            const customerEmail = countryList?.dataset.customerEmail;
            const countryLinks = countryList?.querySelectorAll('a[data-action="switch-site"]');

            countryLinks?.forEach((link) => {
              link.addEventListener('click', (event) => {
                if (customerEmail) {
                  event.preventDefault();
                  const href = link.getAttribute('href');
                  if (href) {
                    window.location.href = href;
                  }
                }
              });
            });
          }

          closeMobileNav() {
            if (!this.$mobileNavPanel) return;

            this.closeMobileCountrySheet(true);

            document.body.classList.remove('body-mobile-menu-open-V2');
            if (window.litime && window.litime.enableScroll) {
              window.litime.enableScroll();
            }

            this.$mobileNavPanel.classList.remove('is-open');
            this.$mobileNavPanel.style.display = 'none';
            this.$mobileNavPanel.setAttribute('aria-hidden', 'true');
            if (this.$ltHeader) {
              this.$ltHeader.classList.remove('is-mobile-nav-open');
            }
            this._unpinHeaderSectionTop();
            this.resetMobileNavPanels();
          }

          initMobileNav() {
            this.$mobileMenu = this.querySelector('.header__mobile-menu-icon.mobileMenu');
            this.$mobileNavPanel = this.querySelector('.header-v2-mobile-nav-panel');
            this.$mobileMenuClose = this.querySelector('.header-v2-mobile-nav-panel .mobileMenuShow');
            this.$mobileNavContent = this.$mobileNavPanel?.querySelector('[data-mobile-nav-content]');
            this.$mobileNavCloseRow = this.$mobileNavPanel?.querySelector('[data-mobile-nav-close-row]');
            this.$mobileNavHeaderTitle = this.$mobileNavPanel?.querySelector('[data-mobile-nav-header-title]');

            if (!this.$mobileNavPanel) return;

            this._onMobileMenuOpen = (event) => {
              if (!this.isMobileNavViewport()) return;
              event.preventDefault();
              event.stopPropagation();
              this.openMobileNav();
            };

            this._onMobileMenuClose = (event) => {
              if (!this.isMobileNavViewport()) return;
              event.preventDefault();
              event.stopPropagation();
              this.closeMobileNav();
            };

            this._onMobileNavPanelClick = (event) => {
              const backBtn = event.target.closest('[data-mobile-nav-back]');
              if (backBtn && this.$mobileNavPanel.contains(backBtn)) {
                event.preventDefault();
                this.closeMobileNavSubpanel();
                return;
              }

              const countryOpenBtn = event.target.closest('[data-mobile-country-open]');
              if (countryOpenBtn && this.$mobileNavPanel.contains(countryOpenBtn)) {
                event.preventDefault();
                event.stopPropagation();
                this.openMobileCountrySheet();
                return;
              }

              const trigger = event.target.closest('[data-mobile-nav-target]');
              if (!trigger || !this.$mobileNavPanel.contains(trigger)) return;

              const target = trigger.getAttribute('data-mobile-nav-target');
              if (!target) return;

              event.preventDefault();
              event.stopPropagation();

              const title = trigger.getAttribute('data-mobile-nav-title') || '';

              if (this._findMobileCategorySource(target)) {
                this.openMobileCategorySource(target, title);
                return;
              }

              if (this._findMobileMenuSource(target)) {
                this.openMobileMenuSource(target, title);
                return;
              }

              this.openMobileNavSubpanel(target, title, trigger);
            };

            if (this.$mobileMenu) {
              this.$mobileMenu.addEventListener('click', this._onMobileMenuOpen);
            }
            if (this.$mobileMenuClose) {
              this.$mobileMenuClose.addEventListener('click', this._onMobileMenuClose);
            }

            this.$mobileNavPanel.addEventListener('click', this._onMobileNavPanelClick, true);

            this._onMobileNavResize = () => {
              if (!this.isMobileNavViewport()) {
                this.closeMobileNav();
              }
            };
            window.addEventListener('resize', this._onMobileNavResize);
            this.initMobileCountrySheet();
          }

          // 移动端弹出登录弹窗
          mobilePopupLogin() {
            const $headerNotLoggedIn = $('#header-not-logged-in');
            const $headerLoggedIn = $('#header-logged-in');
            $headerNotLoggedIn.on('click', (e) => {
              // 获取浏览器宽度
              const viewportWidth = window.innerWidth;
              if (viewportWidth < 1200) {
                e.stopPropagation();
                e.preventDefault();
                const $headerUserIcon = $headerNotLoggedIn.closest('.header-user-icon');
                if ($headerUserIcon.attr('data-show-modal') === 'true') {
                  $headerUserIcon.attr('data-show-modal', 'false');
                } else {
                  $headerUserIcon.attr('data-show-modal', 'true');
                }
              }
            });
            $headerLoggedIn.on('click', (e) => {
              // 获取浏览器宽度
              const viewportWidth = window.innerWidth;
              if (viewportWidth < 1200) {
                e.stopPropagation();
                e.preventDefault();
                const $headerUserIcon = $headerLoggedIn.closest('.header-user-icon');
                if ($headerUserIcon.attr('data-show-modal') === 'true') {
                  $headerUserIcon.attr('data-show-modal', 'false');
                } else {
                  $headerUserIcon.attr('data-show-modal', 'true');
                }
              }
            });
            // 点击其他区域关闭（仅移动端）
            $(document).on('click', (e) => {
              const viewportWidth = window.innerWidth;
              if (viewportWidth < 1200) {
                const function_menu_mobile = $('.function_menu_mobile');
                const $headerUserIcon = function_menu_mobile.closest('.header-user-icon');
                if ($headerUserIcon.attr('data-show-modal') === 'true') {
                  if (
                    e.target.className !== 'function_menu_mobile' &&
                    function_menu_mobile.find(e.target).length === 0
                  ) {
                    $headerUserIcon.attr('data-show-modal', 'false');
                  }
                }
              }
            });
          }

          // 切换站点
          async switchSite(params) {
            const url = '/shopify/auth/change/shop';
            window.litime.showLoading();
            try {
              const res = await window.litime.http.get(url, {
                data: params,
              });
              window.litime.hideLoading();
              if (res.code === 200 && res.data?.mutilpass) {
                window.litime.setLocalStorage('ltToken', res.data.token);
                window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
                window.location.href = res.data.mutilpass;
              }
            } catch (error) {
              window.litime.hideLoading();
              window.litime.showToast('error', window.i18n.request_failed);
            }
          }

          async initCountry() {
            const _this = this;
            const function_menu_country = $(this.querySelector('.function_menu_country'));
            const jump_another_site_modal = $(this.querySelector('.jump-another-site-modal'));
            const customerEmail = function_menu_country.data('customer-email');
            const countryItem = function_menu_country.find('a');
            countryItem.on('click', function (e) {
              if (customerEmail) {
                e.stopPropagation();
                e.preventDefault();
                _this.country = $(this).attr('href');
                window.location.href = _this.country;
              }
            });
            jump_another_site_modal.find('.modal-close').on('click', (e) => {
              jump_another_site_modal.addClass('hidden');
            });
            jump_another_site_modal.find('.modal-confirm').on('click', (e) => {
              jump_another_site_modal.addClass('hidden');
              this.switchSite({
                domain: _this.country,
              });
            });
            jump_another_site_modal.find('.modal-cancel').on('click', (e) => {
              // jump_another_site_modal.addClass('hidden');
              window.litime.setLocalStorage('registe_anther', 1);
              window.location.href = _this.country + '?register=true';
            });

            // 获取logged-login-out
            const loggedLoginOut = $(this.querySelectorAll('.logged-login-out')).find('a');
            loggedLoginOut.on('click', (e) => {
              window.litime.clearLocalStorage('ltToken');
              window.litime.clearLocalStorage('ltUserInfo');
            });

            // 获取url参数
            const urlParams = new URLSearchParams(window.location.search);
            const register = urlParams.get('register');
            if (register) {
              window.litime.eventBus.publish('REGISTER');
              // 不刷新页面清空url参数
              window.history.replaceState({}, '', window.location.pathname);
            }
            const token = urlParams.get('ts');
            if (token) {
              const url = '/shopify/auth/change/shop/info';
              try {
                const res = await window.litime.http.get(url, {
                  data: {
                    ts: token,
                  },
                });
                if (res.code === 200) {
                  window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
                  window.litime.setLocalStorage('ltToken', res.data.token);
                  window.history.replaceState({}, '', window.location.pathname);
                }
              } catch (error) {
                const res = await window.litime.http.get(url, {
                  data: {
                    ts: token,
                  },
                });
                if (res.code === 200) {
                  window.litime.setLocalStorage('ltToken', res.data.token);
                  window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
                  window.history.replaceState({}, '', window.location.pathname);
                }
              }
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-mini-cart-v2"]) return;
  try {
    
  $(function () {
    // 统一的购物车气泡HTML生成方法
    window.createCartBubbleHTML = function (itemCount) {
      if (itemCount === 0) {
        return '';
      }
      const displayText = itemCount >= 99 ? '99+' : itemCount.toString();
      return `<div class="cart-icon-bubble-count" style="position: absolute; top: -12px; right: -12px; min-width: 20px; height: 20px; text-align: center; font-size: 14px; border-radius: 9999px; background-color: #ea5504; color: #fff; padding: 6px;">
        <div style="line-height: 8px;">${displayText}</div>
      </div>`;
    };

    // 统一的购物车气泡更新方法
    window.updateCartBubble = function (cartIconElement, itemCount) {
      if (!cartIconElement) return;

      // 更新隐藏的数量元素
      const hiddenCount = cartIconElement.querySelector('.cart-icon-bubble-hidden-count');
      if (hiddenCount) {
        hiddenCount.textContent = itemCount.toString();
      }

      // 获取购物车气泡元素
      const bubble = cartIconElement.querySelector('.cart-icon-bubble-count');

      if (itemCount === 0) {
        if (bubble) {
          bubble.classList.add('global-mini-cart-v2--collapsed');
          bubble.innerHTML = '';
        }
      } else {
        if (bubble) {
          bubble.classList.remove('global-mini-cart-v2--collapsed');
          const displayText = itemCount >= 99 ? '99+' : itemCount.toString();
          bubble.innerHTML = `<div style="line-height: 8px;">${displayText}</div>`;
        } else {
          // 创建新的购物车气泡
          const bubbleHTML = window.createCartBubbleHTML(itemCount);
          cartIconElement.insertAdjacentHTML('beforeend', bubbleHTML);
        }
      }
    };
    // 购物车弹窗
    let CartDrawer = class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.cartItemCount = 0;
        this.removeEventId = null;
        this.$body = $('body');
        this.isOpen = false;
        this.isClosing = false; // 防止重复关闭的标志
        this._renderToken = 0; // 用于让旧的渲染请求失效
        this.drawerContainer = this.querySelector('.global-mini-cart-v2__container');
        window.globalMiniCartV2 = this;
        window.globalMiniCartV2.id = this.getAttribute('data-section-id');

        this.init();
        // 使用 document 事件委托监听遮罩点击，避免动态创建的遮罩层丢失绑定
        this.handleOverlayMaskClick = (event) => {
          if (!this.hasAttribute('open') || this.isClosing) return;
          if (event.target.classList.contains('drawer-overlay-mask')) {
            event.preventDefault();
            this.close();
          }
        };
        document.addEventListener('click', this.handleOverlayMaskClick);
        this.setHeaderCartIconAccessibility();

        // 初始设置高度
        this.updateDrawerHeight();

        // 监听窗口大小变化和方向变化
        window.addEventListener('resize', this.updateDrawerHeight);
        window.addEventListener('orientationchange', this.updateDrawerHeight);
      }
      connectedCallback() {
        this.pageshowHandler = (event) => {
          requestAnimationFrame(() => {
            this.initGetCartContent();
          });
        };

        // 绑定 pageshow 事件
        window.addEventListener('pageshow', this.pageshowHandler);
      }

      async initGetCartContent() {
        // 如果购物车已经被打开(由 renderContents 触发),跳过本次初始化,
        // 避免与 add-to-cart 流程产生竞争,导致 children 被错误覆盖
        if (this.hasAttribute('open')) {
          return;
        }
        const sectionId = this.dataset.sectionId;
        const sectionsRes = await fetch('/?sections=' + sectionId + ',cart-icon-bubble&t=' + Date.now(), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const sectionsData = await sectionsRes.json();
        await this.renderCartFromSections(sectionsData, sectionId);
      }

      /**
       * 从 sections 数据重新渲染购物车
       */
      async renderCartFromSections(sectionsData, sectionId) {
        if (!sectionsData || !sectionsData[sectionId]) {
          return;
        }

        // 抢占 token,后续的 renderContents 不会被打断
        const myToken = ++this._renderToken;

        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sectionsData[sectionId], 'text/html');
          const newCartDrawerContent = doc.querySelector('#' + sectionId);

          if (newCartDrawerContent) {
            // 保存当前的打开状态
            const wasOpen = this.hasAttribute('open');

            // 更新购物车内容
            this.innerHTML = newCartDrawerContent.innerHTML;

            // 内部 children 替换后,刷新缓存的 DOM 引用
            this.drawerContainer = this.querySelector('.global-mini-cart-v2__container');

            // 恢复打开状态，并重新创建遮罩层（内容刷新后遮罩可能被移除）
            if (wasOpen) {
              this.setAttribute('open', 'true');
              this.overlayMask(true);
            }

            // 重新绑定事件
            this.bindCloseButton();
            this.bindRemoveButtons();
            this.initCartConnt();
            this.initCartPopupInfo();

            // 购物车 DOM 更新后，重新扫描全局下拉，避免引用到旧的 trigger / dropdown
            if (window.GlobalSelectManager && typeof window.GlobalSelectManager.scan === 'function') {
              setTimeout(function () {
                window.GlobalSelectManager.scan();
              }, 0);
            }
          }

          // 同时更新购物车图标 - 手动更新避免嵌套问题
          this.updateCartIconSafely(sectionsData['cart-icon-bubble']);

          // 发布事件：购物车内容渲染完成，通知推荐组件恢复内容
          if (window.litime && window.litime.eventBus) {
            window.litime.eventBus.publish('CART_DRAWER_RENDERED');
          }
        } catch (error) {
          throw error;
        }
      }

      disconnectedCallback() {
        window.overlayManager.hide();
        document.removeEventListener('click', this.handleOverlayMaskClick);
        window.removeEventListener('cartquantityChange2', this.handlequantityChange2);
        window.removeEventListener('resize', this.updateDrawerHeight);
        window.removeEventListener('orientationchange', this.updateDrawerHeight);
        this.checkoutLoading = false;
      }

      getSectionsToRender() {
        const sectionId = this.dataset.sectionId;
        return [
          {
            id: sectionId,
            section: sectionId,
            selector: '.shopify-section',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
        ];
      }

      /**
       * 用 cart/update.js / change.js 返回的 sections 刷新迷你购物车 DOM
       * 与 updateCartComponents 一致：按 section id 定位，避免 .shopify-section 解析失败导致不更新
       */
      renderContents(parsedState) {
        if (!parsedState?.sections) return;

        this.productId = parsedState.id;
        const sectionId = this.dataset.sectionId;
        const sectionHtml = sectionId ? parsedState.sections[sectionId] : null;

        if (sectionHtml) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sectionHtml, 'text/html');
          // 优先按 id 取（与 global.js updateCartComponents 相同）
          let newContentEl = doc.getElementById(sectionId);
          if (!newContentEl) {
            newContentEl = doc.querySelector('global-mini-cart-v2');
          }

          if (newContentEl) {
            const wasOpen = this.hasAttribute('open');
            this.innerHTML = newContentEl.innerHTML;
            this.drawerContainer = this.querySelector('.global-mini-cart-v2__container');
            this.bindCloseButton();
            this.bindRemoveButtons();
            this.init();
            if (wasOpen && typeof this.overlayMask === 'function') {
              this.overlayMask(true);
            }
          } else {
            // 兜底：旧的 .shopify-section 解析路径
            const newContent = this.getSectionInnerHTML(sectionHtml, '.shopify-section');
            if (newContent) {
              this.innerHTML = newContent;
              this.drawerContainer = this.querySelector('.global-mini-cart-v2__container');
              this.bindCloseButton();
              this.bindRemoveButtons();
              this.init();
            }
          }

          const discountContent = this.querySelector('.discount-content');
          if (discountContent) {
            const discount =
              this.querySelector('.global-mini-cart-v2-content-container')?.getAttribute('data-discount-code') ||
              this.querySelector('.global-mini-cart-v2-content-container')?.dataset.discountCode;
            if (discount) {
              discountContent.innerHTML = discount;
            }
          }
        }

        if (parsedState.sections['cart-icon-bubble']) {
          this.updateCartIconSafely(parsedState.sections['cart-icon-bubble']);
        }

        this.open();

        // DOM 替换后恢复折扣区展开状态（应用 / 删除优惠码）
        if (this._keepDiscountExpanded) {
          this.expandDiscountToggle();
          this._keepDiscountExpanded = false;
        }
      }

      /**
       * sections 为空时，用 Section Rendering API 拉最新 HTML 再刷新
       */
      async refreshFromSectionsApi() {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        try {
          const sectionsRes = await fetch('/?sections=' + sectionId + ',cart-icon-bubble&t=' + Date.now(), {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
          });
          if (!sectionsRes.ok) return;
          const sectionsData = await sectionsRes.json();
          this.renderContents({ sections: sectionsData });
        } catch (error) {
          console.error('[global-mini-cart-v2] refreshFromSectionsApi failed:', error);
        }
      }
      getSectionInnerHTML(html, selector = '.shopify-section') {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const element = doc.querySelector(selector);

        if (!element) {
          return;
        }

        // 检查元素内容是否包含 global-mini-cart-v2
        const innerHTML = element.innerHTML;
        const tempDoc = new DOMParser().parseFromString(innerHTML, 'text/html');
        const cartDrawerInside = tempDoc.querySelector('global-mini-cart-v2');

        if (cartDrawerInside) {
          return cartDrawerInside.innerHTML; // 返回 global-mini-cart-v2 内部的内容，不包含 global-mini-cart-v2 标签本身
        }

        return innerHTML;
      }

      /**
       * 安全更新购物车图标，完全避免嵌套问题
       */
      updateCartIconSafely(html) {
        try {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const iconBubble = document.querySelector('cart-icon-bubble');

          if (!iconBubble) {
            console.warn('🛒 未找到 cart-icon-bubble 元素');
            return;
          }

          // 从新数据中提取购物车数量 - 从隐藏的数量元素获取
          const newCartCountElement = doc.querySelector('.cart-icon-bubble-hidden-count');
          const newCartCountText = newCartCountElement?.textContent?.trim();

          if (newCartCountText !== undefined) {
            // 手动更新购物车数量显示
            const currentBubble = iconBubble.querySelector('.cart-icon-bubble-count');

            const itemCount = parseInt(newCartCountText) || 0;
            window.updateCartBubble(iconBubble, itemCount);
          }
        } catch (error) {
          console.error('🛒 更新购物车图标失败:', error);
        }
      }

      initCartPopupInfo() {
        let discount =
          document.querySelector('.global-mini-cart-v2-content-container')?.getAttribute('data-discount-code') ||
          document.querySelector('.global-mini-cart-v2-content-container')?.dataset.discountCode;
        if (!discount) return;

        const discountContent = document.querySelector('.discount-content');
        if (discountContent) {
          discountContent.innerHTML = discount;
        }
      }
      initCartConnt() {
        const cartIconElement = document.querySelector('#cart-icon-bubble');
        if (cartIconElement) {
          // 优先从隐藏的数量元素获取准确的购物车数量
          const hiddenCountElement = cartIconElement.querySelector('.cart-icon-bubble-hidden-count');
          let cartCount = 0;

          if (hiddenCountElement) {
            cartCount = parseInt(hiddenCountElement.textContent.trim()) || 0;
          } else {
            // 如果没有隐藏元素，尝试从显示的气泡中获取
            const cartIconBubble = cartIconElement.querySelector('.cart-icon-bubble-count');
            if (cartIconBubble) {
              // 查找内部的数量显示 div
              const countDiv = cartIconBubble.querySelector('div');
              if (countDiv) {
                const countText = countDiv.textContent.trim();
                if (countText === '99+') {
                  cartCount = 99;
                } else {
                  cartCount = parseInt(countText) || 0;
                }
              }
            }
          }

          // 使用统一的方法更新购物车气泡
          window.updateCartBubble(cartIconElement, cartCount);
        }
      }

      // 使用箭头函数自动绑定 this
      handlequantityChange2 = (event) => {
        this.updateCartQuantity(event.detail);
      };

      handleRemoveItem = (event) => {
        const button = event.currentTarget;
        const itemId = button.closest('[data-id]')?.dataset.id;
        const itemKey = button.closest('[data-key]')?.dataset.key;

        if (itemId) {
          // 触发数量更新事件，设置数量为0来删除商品
          const removeEvent = {
            id: itemId,
            key: itemKey,
            value: 0,
          };

          this.updateCartQuantity(removeEvent, 'remove');
        }
      };

      updateCartQuantity = async (event, type = 'update') => {
        const flowItem = this.querySelector('.flow-item-' + event.id);
        if (flowItem && type === 'remove') {
          this.cartInputNumberLoading(flowItem, false, 'remove');
        }
        try {
          let productElement = this.querySelector('.product-' + event.id);
          this.removeEventId = event.id;
          const response = await fetch(`/cart/change.js`, {
            body: JSON.stringify({
              id: event.key,
              quantity: event.value,
              sections: this.dataset.sectionId + ',cart-icon-bubble',
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          });
          if (event.$blurContainer) {
            this.removeCartInputNumberLoading(event.$blurContainer);
          }
          const cartContent = await response.json();
          if (event.$input) {
            if (response.status == 200) {
              event.$input.val(event.value);
            } else {
              event.$input.val(event.defaultVal);
              window.litime.showToast('error', cartContent.message);
            }
          }
          await updateCartComponents(cartContent);
        } catch (error) {
          console.error('error', error);
        } finally {
          // 请求完成后调用回调，启用所有控件
          if (event.onComplete) {
            event.onComplete();
          }
        }
      };
      removeCartInputNumberLoading(className) {
        const cartInputNumberContainer = className;
        const existingLoading = cartInputNumberContainer.querySelector('.loading-container');
        if (existingLoading) {
          existingLoading.remove();
        }
      }
      cartInputNumberLoading(className, flag, type = 'dalte') {
        const cartInputNumberContainer = className;
        const loadingContainer = document.createElement('div');

        if (flag) {
          loadingContainer.className = 'loading-container';
          loadingContainer.innerHTML = `
             <div class="loading-container-unshadow">
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <div
                  class="loader-animation"
                  style="border:2px solid #181818; border-left-color: transparent;width:12px;height:12px;"
                ></div>
              </div>
            </div>
        `;
        } else {
          loadingContainer.className = 'loading-container';
          loadingContainer.innerHTML = `
          <div class="loading-container-shadow"></div>
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
          <div class="loader-animation" style="border:2px solid #181818; border-left-color: transparent;"></div>
          </div>
        `;
        }
        cartInputNumberContainer.appendChild(loadingContainer);
      }
      async getCartContent() {}
      showMessage(message) {
        const toast = document.createElement('div');
        toast.innerText = message;
        toast.style.visibility = 'hidden';
        toast.style.minWidth = '120px';
        toast.style.backgroundColor = '#666666';
        toast.style.color = '#fff';
        toast.style.textAlign = 'center';
        toast.style.borderRadius = '8px';
        toast.style.padding = '10px 24px';
        toast.style.position = 'fixed';
        toast.style.zIndex = '900';
        toast.style.left = '50%';
        toast.style.top = '50%';
        toast.style.fontSize = '16px';
        toast.style.transform = 'translate(-50%, -50%)';

        // 添加到文档中
        document.body.appendChild(toast);

        // 显示吐司
        toast.style.visibility = 'visible';

        // 2秒后隐藏并移除吐司
        setTimeout(() => {
          toast.style.visibility = 'hidden';
          document.body.removeChild(toast);
        }, 2000);
      }

      setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        if (!cartLink) return;
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        // 点击触发显示购物车
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          if (window.location.pathname === '/cart') {
            window.location.href = '/cart';
          } else {
            this.open(cartLink);
          }
        });
        // 注意：closeButton 的事件绑定已在 bindCloseButton() 中处理，避免重复绑定
      }
      async open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        this.updateDrawerHeight();
        this.classList.remove('global-mini-cart-v2-close');
        this.setAttribute('open', 'true');
        requestAnimationFrame(() => {
          if (!this.hasAttribute('open')) this.setAttribute('open', 'true');
        });
        try {
          this.overlayMask(true);
        } catch (e) {
          console.error('[global-mini-cart-v2] overlayMask error:', e);
        }
        this.$body.addClass('drawer-body-no-scroll');

        window.customGATracker?.trackEvent('lt_view', {
          module: 'global-mini-cart-v2',
          section_id: this.dataset.sectionId,
          element: 'open',
          trigger_type: 'view',
        });
      }

      overlayMask(flag) {
        try {
          requestAnimationFrame(() => {
            if (flag) {
              this.$overlay = window.overlayManager.show();
              this.$overlay.on('click', (event) => {
                event.preventDefault();
                this.close();
              });
            } else {
              window.overlayManager.hide();
            }
          });
        } catch (e) {
          console.error('[global-mini-cart-v2] overlayMask error:', e);
        }
      }

      close = () => {
        // 防止重复执行
        if (this.isClosing) {
          return;
        }
        this.isClosing = true;

        // 移除 open 属性
        this.removeAttribute('open');
        this.classList.add('global-mini-cart-v2-close');
        this.$body.removeClass('drawer-body-no-scroll');
        this.overlayMask(false);
        window.overlayManager.hide(); // 确保关闭时也清理遮罩层

        // 重置关闭状态标志
        setTimeout(() => {
          this.isClosing = false;
        }, 100);
      };

      getSectionDOM(html, selector = '.shopify-section') {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector(selector);
      }

      setActiveElement(element) {
        this.activeElement = element;
      }

      init = () => {
        this.bindEvents();
        this.initCartConnt();
        this.initCartPopupInfo();
        this.bindRemoveButtons();
        this.bindCloseButton();
      };

      bindEvents = () => {
        window.addEventListener('cartquantityChange2', this.handlequantityChange2);
      };

      bindCloseButton = () => {
        const closeButton = this.querySelector('#closeButton');
        if (closeButton) {
          // 移除可能存在的旧事件监听器
          closeButton.removeEventListener('click', this.close);
          // 绑定新的事件监听器
          closeButton.addEventListener('click', this.close);
        }
      };

      bindRemoveButtons = () => {
        // 先移除所有旧的事件监听器
        this.querySelectorAll('.icon-close').forEach((button) => {
          button.removeEventListener('click', this.handleRemoveItem);
          button.addEventListener('click', this.handleRemoveItem);
        });
      };

      expandDiscountToggle = () => {
        const discountToggle = this.querySelector('.global-mini-cart-v2__discount-toggle');
        const discountFormContainer = this.querySelector('.global-mini-cart-v2__discount-form-container');
        const toggleIcon = this.querySelector('.global-mini-cart-v2__discount-toggle-icon');
        if (discountToggle) discountToggle.setAttribute('aria-expanded', 'true');
        discountFormContainer?.classList.remove('is-collapsed');
        toggleIcon?.classList.add('mini-cart-v2-rotate-arrow');
      };

      updateDrawerHeight = () => {
        if (!this.drawerContainer) return;

        // 获取视口的实际高度
        const viewportHeight = window.innerHeight;
        // 设置容器高度
        this.drawerContainer.style.height = `${viewportHeight}px`;
      };
    };

    let CartInputNumber = class CartInputNumber extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initInputNumber();
      }

      initInputNumber() {
        const $input = $(this.querySelector('input'));
        const $input_number_minus = $(this.querySelector('.input-number_minus'));
        const $input_number_plus = $(this.querySelector('.input-number_plus'));
        const $globalNumberInput = $(this).closest('.global-number-input-v2');
        // 禁用/启用加减按钮和输入框
        const disableControls = () => {
          $input_number_minus.prop('disabled', true).css('pointer-events', 'none');
          $input_number_plus.prop('disabled', true).css('pointer-events', 'none');
          $input.prop('disabled', true).css('pointer-events', 'none');
        };
        const enableControls = () => {
          $input_number_minus.prop('disabled', false).css('pointer-events', '');
          $input_number_plus.prop('disabled', false).css('pointer-events', '');
          $input.prop('disabled', false).css('pointer-events', '');
          clearLoading();
          updateButtonStates();
        };
        const setLoading = (source, isLoading) => {
          const loadingValue = isLoading ? 'true' : 'false';
          const $wrap = $input.closest('.quick-number-input__wrap');

          if (source === 'minus') {
            $input_number_minus.attr('data-loading', loadingValue);
            if ($globalNumberInput.length) {
              $globalNumberInput.attr('data-minus-loading', loadingValue);
            }
          } else if (source === 'plus') {
            $input_number_plus.attr('data-loading', loadingValue);
            if ($globalNumberInput.length) {
              $globalNumberInput.attr('data-plus-loading', loadingValue);
            }
          } else if (source === 'input') {
            $wrap.attr('data-loading', loadingValue);
            if ($globalNumberInput.length) {
              $globalNumberInput.attr('data-input-loading', loadingValue);
            }
          }
        };
        const clearLoading = () => {
          setLoading('minus', false);
          setLoading('plus', false);
          setLoading('input', false);
        };
        const updateButtonStates = () => {
          const val = parseInt($input.val(), 10) || 1;
          const max = parseInt($input.data('max'), 10) || 999;
          if (val >= max) {
            $input_number_plus.css('pointer-events', 'none');
            $input_number_plus.find('.quick-number-input__icon').css('opacity', '0.3');
            $input_number_plus.find('.input-number_plus-main').css('opacity', '0.3');
          } else {
            $input_number_plus.css('pointer-events', '');
            $input_number_plus.find('.quick-number-input__icon').css('opacity', '');
            $input_number_plus.find('.input-number_plus-main').css('opacity', '');
          }
          if (val <= 1) {
            $input_number_minus.css('pointer-events', 'none');
            $input_number_minus.find('.quick-number-input__icon').css('opacity', '0.3');
            $input_number_minus.find('.input-number_minus-main').css('opacity', '0.3');
          } else {
            $input_number_minus.css('pointer-events', '');
            $input_number_minus.find('.quick-number-input__icon').css('opacity', '');
            $input_number_minus.find('.input-number_minus-main').css('opacity', '');
          }
        };
        // 实时拦截非法输入，只允许数字（blur 时才做边界值修正）
        $input.on('input', () => {
          const val = $input.val();
          // 过滤掉所有非数字字符
          const digitsOnly = val.replace(/\D/g, '');
          if (digitsOnly === '') {
            return;
          }
          let parsed = parseInt(digitsOnly);
          if (digitsOnly !== String(parsed)) {
            $input.val(parsed);
          }
          updateButtonStates();
        });

        $input.on('blur', () => {
          const max = parseInt($input.data('max')) || 999;
          const id = $input.attr('id');
          const key = $input.attr('key');
          let defaultVal = $input.prop('defaultValue');
          let value = parseInt($input.val());
          if (value < 1) value = 1;
          if (value > max) value = max;
          if (value == 0 || value == null || value == undefined || isNaN(value) || value == '') {
            value = 1;
          }
          $input.val(value);

          // 只有值发生变化才请求接口
          if (+value === +defaultVal) {
            $input_number_minus.prop('disabled', false);
            $input_number_plus.prop('disabled', false);
            $input.prop('disabled', false);
            clearLoading();
            updateButtonStates();
            return;
          }

          const flowItem = document.querySelector('.flow-item-' + id);
          setLoading('input', true);
          $input_number_minus.prop('disabled', true);
          $input_number_plus.prop('disabled', true);
          $input.prop('disabled', true);
          this.triggerquantityChange2(
            value,
            id,
            key,
            $input,
            flowItem.querySelector('.cart-input-number-container'),
            defaultVal,
            () => {
              $input_number_minus.prop('disabled', false);
              $input_number_plus.prop('disabled', false);
              $input.prop('disabled', false);
              clearLoading();
              updateButtonStates();
            }
          );
        });

        // 减少数量
        $input_number_minus.on('click', () => {
          if ($input_number_minus.attr('data-loading') === 'true') return;
          const id = $input.attr('id');
          const key = $input.attr('key');
          if ($input.val() > 1) {
            setLoading('minus', true);
            disableControls();
            const newValue = +$input.val() - 1;
            let defaultVal = $input.prop('defaultValue');

            this.triggerquantityChange2(
              newValue,
              id,
              key,
              $input,
              this.querySelector('.input-number_minus-main'),
              defaultVal,
              () => {
                enableControls();
                clearLoading();
              }
            );
          }
        });

        // 增加数量
        $input_number_plus.on('click', () => {
          if ($input_number_plus.attr('data-loading') === 'true') return;
          const id = $input.attr('id');
          const key = $input.attr('key');
          const max = parseInt($input.data('max')) || 999;
          if ($input.val() < +max) {
            setLoading('plus', true);
            disableControls();

            const newValue = +$input.val() + 1;
            let defaultVal = $input.prop('defaultValue');

            this.triggerquantityChange2(
              newValue,
              id,
              key,
              $input,
              this.querySelector('.input-number_plus-main'),
              defaultVal,
              () => {
                enableControls();
                clearLoading();
              }
            );
            const event = new CustomEvent('quantityChange2', { detail: $input.val() });
            window.dispatchEvent(event);
          } else {
            const message = $input.attr('data-message');
            window.litime.showToast('error', window.i18n.quantityErrorV2);
          }
        });
        updateButtonStates();
      }

      triggerquantityChange2(value, id, key, $input, blurContainer, defaultVal, onComplete) {
        const event = new CustomEvent('cartquantityChange2', {
          bubbles: true,
          detail: {
            id: id,
            key: key,
            value: value,
            $input: $input,
            $blurContainer: blurContainer,
            defaultVal: defaultVal,
            onComplete: onComplete,
          },
        });
        window.dispatchEvent(event);
      }
    };
    let CartPopupMessage = class CartPopupMessage extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initCartPopupMessage();
        this.bindEvents();
      }

      initCartPopupMessage() {
        const messagePopup = this.querySelector('.message-popup');
        const messageTextarea = messagePopup.querySelector('#special-instructions');
        const charCount = messagePopup.querySelector('#char-count');
        const maxLength = messageTextarea.getAttribute('maxlength');

        // 初始化字符计数
        const currentLength = messageTextarea.value.length;
        // charCount.textContent = `${currentLength}/${maxLength}`;

        // 监听输入事件
        messageTextarea.addEventListener('input', () => {
          const currentLength = messageTextarea.value.length;
          // charCount.textContent = `${currentLength}/${maxLength}`;
        });
      }

      bindEvents() {
        // 打开留言弹窗
        const messagePopupBtns = document.querySelectorAll('#message-popup');
        const messageContentContainer = document.querySelector('.message-content');
        const messagePopup = this.querySelector('.message-popup');
        const cancelBtn = this.querySelector('.cancel-btn');
        const saveBtn = this.querySelector('.save-btn');
        const $textarea = $(this.querySelector('#special-instructions'));
        if ($textarea.val() == '') {
          saveBtn.disabled = true;
        } else {
          saveBtn.disabled = false;
        }
        messagePopupBtns.forEach((button) => {
          button.addEventListener('click', () => {
            messagePopup.setAttribute('open', '');
            messagePopup.classList.remove('global-mini-cart-v2-close');

            $textarea.on('input', () => {
              if ($textarea.val() == '') {
                saveBtn.disabled = true;
              } else {
                saveBtn.disabled = false;
              }
            });
          });
        });

        // 关闭留言弹窗
        cancelBtn?.addEventListener('click', () => {
          messagePopup.removeAttribute('open');

          messagePopup.classList.add('global-mini-cart-v2-close');
        });

        saveBtn?.addEventListener('click', async () => {
          const $textarea = $(this.querySelector('#special-instructions'));
          const messageContent = $textarea.val();
          const response = await fetch(`/cart/update`, {
            body: JSON.stringify({ note: messageContent }),
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          });
          if (response.ok) {
            messagePopup.removeAttribute('open');
            messagePopup.setAttribute('data-note', messageContent);
            messageContentContainer.innerHTML = messageContent;
            messagePopup.classList.add('global-mini-cart-v2-close');

            const messagePopupIcon = document.querySelectorAll('.message-popup-icon');
            messagePopupIcon.forEach((icon) => {
              icon.classList.add('active-icon');
            });
          }
        });
      }
    };

    let CartPopupDiscount = class CartPopupDiscount extends HTMLElement {
      constructor() {
        super();
        const discountSection = this.querySelector('.global-mini-cart-v2__discount-section');
        this.i18nInvalidDiscount = discountSection?.dataset.i18nInvalidDiscount;
      }

      /**
       * 折扣组件是独立的自定义元素，data-section-id 挂在外层迷你购物车上，
       * 必须向上查找宿主元素才能取到 section id
       */
      get miniCart() {
        return this.closest('global-mini-cart-v2');
      }

      /**
       * 购物车接口需要刷新的 section 列表，取不到 section id 时只刷新购物车图标
       */
      get cartSections() {
        const sectionId = this.miniCart?.dataset.sectionId;
        return sectionId ? sectionId + ',cart-icon-bubble' : 'cart-icon-bubble';
      }

      connectedCallback() {
        window.addEventListener('pagehide', (event) => {
          this.checkoutLoading = false;
          const buyNowBtn = document.querySelector('.buy-now-btn');

          // 隐藏 loading 图标
          const rotateIcon = buyNowBtn?.querySelector('.rotate_icon');
          if (rotateIcon) {
            rotateIcon.style.display = 'none';
          }
          // 显示按钮文字
          const buttonText = buyNowBtn?.querySelector('.loading-button-text');
          if (buttonText) {
            buttonText.style.display = 'block';
          }
        });
        this.bindEvents();
        this.buyNowBtn();
        this.checkoutLoading = false;
      }

      bindEvents() {
        const self = this;

        // 事件委托：监听 tag remove 按钮（两个 web component 隔离，用事件冒泡）
        self.addEventListener('click', (e) => {
          const removeBtn = e.target.closest('.main-cart-discount-input-v2__tag-remove');
          if (!removeBtn) return;
          e.preventDefault();
          const removeCode = removeBtn.dataset.discountCode;
          if (!removeCode) return;

          const tagsContainer = self.querySelector('.main-cart-discount-input-v2__tags');
          const currentDiscountsAttr = tagsContainer?.dataset.appliedDiscounts || '';
          const currentDiscounts = currentDiscountsAttr ? currentDiscountsAttr.split(',') : [];
          const remainingDiscounts = currentDiscounts.filter((code) => code.trim() !== removeCode);

          const tag = removeBtn.closest('.main-cart-discount-input-v2__tag');
          if (!tag) return;

          self._removeDiscountCode = removeCode;
          self._remainingDiscountCodes = remainingDiscounts;

          // 请求期间禁用按钮
          const removeIcon = removeBtn.querySelector('svg');
          if (removeIcon) removeIcon.style.opacity = '0.3';
          removeBtn.disabled = true;

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              discount: remainingDiscounts.join(','),
              sections: self.cartSections,
            }),
          })
            .then((response) => {
              if (!response.ok) throw new Error('Failed to remove discount');
              return response.json();
            })
            .then(async (cart) => {
              self._appliedDiscountCodes = remainingDiscounts;
              // 标记：renderContents 替换 DOM 后仍保持折扣区展开
              if (self.miniCart) self.miniCart._keepDiscountExpanded = true;

              const hasSectionHtml =
                cart.sections && self.miniCart?.dataset.sectionId && cart.sections[self.miniCart.dataset.sectionId];

              if (hasSectionHtml) {
                self.miniCart.renderContents(cart);
              } else if (self.miniCart) {
                // 接口返回了空 sections：回退拉 Section Rendering API
                await self.miniCart.refreshFromSectionsApi();
              }
            })
            .catch((error) => {
              console.error('Failed to remove discount:', error);
              if (removeIcon) removeIcon.style.opacity = '1';
              removeBtn.disabled = false;
            });
        });

        const discountToggle = self.querySelector('.global-mini-cart-v2__discount-toggle');
        const discountForm = self.querySelector('.global-mini-cart-v2__discount-form');
        const toggleIcon = self.querySelector('.global-mini-cart-v2__discount-toggle-icon');
        const discountContentContainer = self.querySelector('.discount-content');
        const discountInput = self.querySelector('#mini-cart-discount-code');
        const discountError = self.querySelector('.main-cart-discount-input-v2__error');

        const getStoredDiscount = () => {
          let discount =
            document.querySelector('.global-mini-cart-v2-content-container')?.getAttribute('data-discount-code') ||
            document.querySelector('.global-mini-cart-v2-content-container')?.dataset.discountCode;
          return discount || '';
        };

        const storedDiscount = getStoredDiscount();
        if (storedDiscount && discountContentContainer) {
          discountContentContainer.innerHTML = storedDiscount;
        } else if (!self.miniCart?._keepDiscountExpanded) {
          // 默认收起折扣输入框（删除优惠码后需要保持展开时跳过）
          const discountFormContainer = self.querySelector('.global-mini-cart-v2__discount-form-container');
          discountFormContainer?.classList.add('is-collapsed');
          discountToggle?.setAttribute('aria-expanded', 'false');
          toggleIcon?.classList.remove('mini-cart-v2-rotate-arrow');
        }

        discountToggle?.addEventListener('click', () => {
          const isExpanded = discountToggle.getAttribute('aria-expanded') === 'true';
          discountToggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
          const discountFormContainer = self.querySelector('.global-mini-cart-v2__discount-form-container');
          discountFormContainer?.classList.toggle('is-collapsed', isExpanded);
          toggleIcon?.classList.toggle('mini-cart-v2-rotate-arrow', !isExpanded);
        });

        discountInput?.addEventListener('discount:apply:success', (e) => {
          const newCode = (e.detail?.code || '').trim();
          if (!newCode) return;

          const appendDiscountCode = (codesStr, code) => {
            const codes = codesStr
              ? codesStr
                  .split(',')
                  .map((c) => c.trim())
                  .filter(Boolean)
              : [];
            if (codes.some((c) => c.toLowerCase() === code.toLowerCase())) {
              return codes.join(',');
            }
            return [...codes, code].join(',');
          };

          const tagsContainer = self.querySelector('.main-cart-discount-input-v2__tags');
          const existingAppliedDiscounts = tagsContainer?.dataset.appliedDiscounts || '';
          const updatedAppliedDiscounts = appendDiscountCode(existingAppliedDiscounts, newCode);

          if (discountContentContainer) {
            discountContentContainer.innerHTML = appendDiscountCode(
              discountContentContainer.textContent.trim(),
              newCode
            );
          }
          self.setAttribute('data-discount', updatedAppliedDiscounts);

          const contentContainer = document.querySelector('.global-mini-cart-v2-content-container');
          if (contentContainer) {
            const existingDataCode = contentContainer.getAttribute('data-discount-code') || '';
            contentContainer.setAttribute('data-discount-code', appendDiscountCode(existingDataCode, newCode));
          }

          const discountContainer = self.querySelector('.main-cart-discount-input-v2');
          const inputWrap = self.querySelector('.main-cart-discount-input-v2__input-wrap');
          const errorEl = self.querySelector('.main-cart-discount-input-v2__error');
          if (discountContainer) discountContainer.dataset.error = 'false';
          if (inputWrap) inputWrap.dataset.error = 'false';
          if (errorEl) errorEl.textContent = '';

          if (tagsContainer) {
            tagsContainer.dataset.appliedDiscounts = updatedAppliedDiscounts;
            tagsContainer.style.display = 'flex';

            const alreadyExists = Array.from(tagsContainer.querySelectorAll('.main-cart-discount-input-v2__tag')).some(
              (tag) =>
                tag.querySelector('.discount-code-title')?.textContent?.trim().toLowerCase() === newCode.toLowerCase()
            );

            if (!alreadyExists) {
              tagsContainer.insertAdjacentHTML(
                'beforeend',
                `
                <span class="main-cart-discount-input-v2__tag">
                  <span class="discount-code-title">${newCode}</span>
                  <button type="button" class="main-cart-discount-input-v2__tag-remove" data-discount-code="${newCode}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <path d="M7.09968 0.5L3.79981 3.79981M3.79981 3.79981L0.5 7.09967M3.79981 3.79981L7.09968 7.09967M3.79981 3.79981L0.5 0.5" stroke="#181818" stroke-linecap="round"/>
                    </svg>
                  </button>
                </span>
              `
              );
            }
          }
        });

        discountInput?.addEventListener('discount:apply:error', (e) => {
          if (discountContentContainer) {
            discountContentContainer.innerHTML = '';
          }
          self.setAttribute('data-discount', '');
          const discountContainer = self.querySelector('.main-cart-discount-input-v2');
          const inputWrap = self.querySelector('.main-cart-discount-input-v2__input-wrap');
          const errorEl = self.querySelector('.main-cart-discount-input-v2__error');
          const message = e.detail?.message || self.i18nInvalidDiscount;
          if (discountContainer) discountContainer.dataset.error = 'true';
          if (inputWrap) inputWrap.dataset.error = 'true';
          if (errorEl) errorEl.textContent = message;
        });

        discountInput?.addEventListener('input', () => {
          if (discountContentContainer) {
            discountContentContainer.innerHTML = '';
          }
          const discountContainer = self.querySelector('.main-cart-discount-input-v2');
          const inputWrap = self.querySelector('.main-cart-discount-input-v2__input-wrap');
          const errorEl = self.querySelector('.main-cart-discount-input-v2__error');
          if (discountContainer) discountContainer.dataset.error = 'false';
          if (inputWrap) inputWrap.dataset.error = 'false';
          if (errorEl) errorEl.textContent = '';
        });

        discountInput?.addEventListener('focus', () => {
          const inputWrap = self.querySelector('.main-cart-discount-input-v2__input-wrap');
          if (inputWrap) inputWrap.dataset.focused = 'true';
        });

        discountInput?.addEventListener('blur', () => {
          const inputWrap = self.querySelector('.main-cart-discount-input-v2__input-wrap');
          if (inputWrap) inputWrap.dataset.focused = 'false';
        });

        // 绑定按钮点击事件
        const applyBtn = self.querySelector('.save-btn-discount');
        if (applyBtn && !applyBtn.dataset.bound) {
          applyBtn.dataset.bound = 'true';

          applyBtn.addEventListener('click', async () => {
            const code = (discountInput?.value || '').trim();
            const discountSection = self.querySelector('.global-mini-cart-v2__discount-section');
            const i18nInvalidDiscount = discountSection?.dataset.i18nInvalidDiscount || self.i18nInvalidDiscount;

            window.customGATracker?.trackEvent('lt_click', {
              module: 'global-mini-cart-v2',
              element: 'apply_discount',
              discount_code: code,
              trigger_type: 'click',
            });
            if (!code) {
              discountInput?.dispatchEvent(
                new CustomEvent('discount:apply:error', {
                  detail: { message: i18nInvalidDiscount },
                })
              );
              return;
            }

            const tagsContainer = self.querySelector('.main-cart-discount-input-v2__tags');
            const existingDiscountsAttr = tagsContainer?.dataset.appliedDiscounts || '';
            const existingDiscounts = existingDiscountsAttr
              ? existingDiscountsAttr
                  .split(',')
                  .map((c) => c.trim())
                  .filter(Boolean)
              : [];
            const allDiscounts = existingDiscounts.some((d) => d.toLowerCase() === code.toLowerCase())
              ? existingDiscounts
              : [...existingDiscounts, code];

            applyBtn.disabled = true;
            applyBtn.dataset.loading = 'true';

            try {
              const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  discount: allDiscounts.join(','),
                  sections: self.cartSections,
                }),
              });

              const data = await response.json();

              const matchedCode = data.discount_codes?.find((d) => d.code.toLowerCase() === code.toLowerCase());

              if (response.ok && matchedCode?.applicable === true) {
                discountInput.value = '';
                // 用返回的 sections 刷新整车 DOM（价格、折扣金额、标签）
                if (self.miniCart) self.miniCart._keepDiscountExpanded = true;

                const hasSectionHtml =
                  data.sections && self.miniCart?.dataset.sectionId && data.sections[self.miniCart.dataset.sectionId];

                if (hasSectionHtml) {
                  self.miniCart.renderContents(data);
                } else if (self.miniCart) {
                  await self.miniCart.refreshFromSectionsApi();
                } else {
                  // 找不到宿主时仍走本地标签更新兜底
                  discountInput?.dispatchEvent(
                    new CustomEvent('discount:apply:success', {
                      detail: { code: matchedCode.code },
                    })
                  );
                }
              } else {
                const discountContainer = self.querySelector('.main-cart-discount-input-v2');
                const inputWrap = self.querySelector('.main-cart-discount-input-v2__input-wrap');
                const errorEl = self.querySelector('.main-cart-discount-input-v2__error');
                if (discountContainer) discountContainer.dataset.error = 'true';
                if (inputWrap) inputWrap.dataset.error = 'true';
                if (errorEl) errorEl.textContent = i18nInvalidDiscount;
              }
            } catch (error) {
              console.error('Failed to apply discount:', error);
              const discountContainer = self.querySelector('.main-cart-discount-input-v2');
              const inputWrap = self.querySelector('.main-cart-discount-input-v2__input-wrap');
              const errorEl = self.querySelector('.main-cart-discount-input-v2__error');
              if (discountContainer) discountContainer.dataset.error = 'true';
              if (inputWrap) inputWrap.dataset.error = 'true';
              if (errorEl) errorEl.textContent = 'Failed to apply discount';
            } finally {
              applyBtn.disabled = false;
              applyBtn.dataset.loading = 'false';
            }
          });

          discountInput?.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              applyBtn.click();
            }
          });
        }
      }
      buyNowBtn() {
        const buyNowBtn = document.querySelector('.buy-now-btn');

        buyNowBtn.addEventListener('click', async () => {
          // 从 discount-content 中读取优惠码
          const discountContent = document.querySelector('.discount-content');
          let discountCode = discountContent ? discountContent.textContent.trim() : '';

          // 如果 discount-content 为空，尝试从 input 输入框读取
          if (!discountCode) {
            const discountCodeInput = document.querySelector('#mini-cart-discount-code');
            if (discountCodeInput) {
              discountCode = discountCodeInput.value.trim();
            }
          }

          this.checkoutLoading = true;
          if (this.checkoutLoading) {
            // 显示 loading 图标
            const rotateIcon = buyNowBtn.querySelector('.rotate_icon');
            if (rotateIcon) {
              rotateIcon.style.display = 'flex';
            }
            // 隐藏按钮文字
            const buttonText = buyNowBtn.querySelector('.loading-button-text');
            if (buttonText) {
              buttonText.style.display = 'none';
            }
          }

          requestAnimationFrame(() => {
            const appliedAttr =
              document.querySelector('.main-cart-discount-input-v2__tags')?.dataset.appliedDiscounts || '';
            const codesFromAttr = appliedAttr
              ? appliedAttr
                  .split(',')
                  .map((code) => code.trim())
                  .filter(Boolean)
              : [];
            const codesFromText = discountCode
              ? discountCode
                  .split(',')
                  .map((code) => code.trim())
                  .filter(Boolean)
              : [];
            const codes = codesFromAttr.length ? codesFromAttr : codesFromText;
            // 多张优惠码已在购物车，直接走 else，避免 ?discount= 只带进一张
            if (codes.length > 1) {
              window.location.href = '/checkout';
            } else if (codes.length === 1) {
              window.location.href = `/checkout?discount=${encodeURIComponent(codes[0])}`;
            } else {
              window.location.href = '/checkout';
            }
          });
        });
      }
    };

    // 注册自定义元素
    window.customElements.define('global-mini-cart-v2', CartDrawer);
    window.customElements.define('cart-input-number', CartInputNumber);
    window.customElements.define('cart-popup-message', CartPopupMessage);
    window.customElements.define('cart-popup-discount', CartPopupDiscount);
    window.customElements.define(
      'cart-icon-bubble',
      class CartIconBubble extends HTMLElement {
        constructor() {
          super();
        }

        updateBubble(itemCount) {
          // 使用统一的方法更新购物车气泡
          window.updateCartBubble(this, itemCount);
        }
      }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-recommended-articles"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('global-recommended-articles')) {
      customElements.define(
        'global-recommended-articles',
        class GlobalRecommendedArticles extends HTMLElement {
          constructor() {
            super();
            this.swiper = null;
            this._cardClickMedia = null;
          }

          connectedCallback() {
            this.initSwiper();
            this.initCardNavigation();
          }

          disconnectedCallback() {
            if (this._boundCardClick) {
              this.removeEventListener('click', this._boundCardClick);
            }
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
          }

          initCardNavigation() {
            this._cardClickMedia = window.matchMedia('(min-width: 1201px)');
            this._boundCardClick = (e) => {
              if (!this._cardClickMedia.matches) return;

              const card = e.target.closest('.global-recommended-articles__card');
              if (!card || !this.contains(card)) return;
              if (e.target.closest('.global-recommended-articles__card-link')) return;

              const url = card.dataset.cardUrl;
              if (!url || url === 'javascript:;' || url === '#') return;

              window.location.assign(url);
            };
            this.addEventListener('click', this._boundCardClick);
          }

          initSwiper() {
            const $swiperEl = this.querySelector('.global-recommended-articles__swiper');
            if (!$swiperEl) return;

            const slideCount = $swiperEl.querySelectorAll('.swiper-slide').length;
            if (slideCount <= 1) return;

            const $prev = this.querySelector('.swiper-button-prev');
            const $next = this.querySelector('.swiper-button-next');
            const $progressFill = this.querySelector('.global-recommended-articles__progress-fill');
            const $progressBar = this.querySelector('.global-recommended-articles__progress');

            const updateProgress = (swiper) => {
              if (!$progressFill || !swiper) return;
              const snapCount = swiper.snapGrid?.length || slideCount;
              const currentIndex = typeof swiper.snapIndex === 'number' ? swiper.snapIndex : swiper.activeIndex;
              const segmentWidth = 100 / snapCount;
              $progressFill.style.width = `${segmentWidth}%`;
              $progressFill.style.transform = `translateX(${currentIndex * 100}%)`;
              if ($progressBar) {
                $progressBar.setAttribute('aria-valuemax', String(snapCount));
                $progressBar.setAttribute('aria-valuenow', String(currentIndex + 1));
              }
            };

            this.swiper = new Swiper($swiperEl, {
              slidesPerView: 1,
              spaceBetween: 0,
              speed: 400,
              watchOverflow: true,
              navigation: {
                nextEl: $next,
                prevEl: $prev,
              },
              on: {
                init: (swiper) => {
                  updateProgress(swiper);
                },
                slideChange: (swiper) => {
                  updateProgress(swiper);
                },
                resize: (swiper) => {
                  updateProgress(swiper);
                },
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-sticky"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('laboratory-adsorption')) {
      customElements.define(
        'laboratory-adsorption',
        class ProductForm extends HTMLElement {
          sticky_start = 0;
          changeStatus = false;
          _this = null;
          clickPoint = false;
          constructor() {
            super();
          }
          connectedCallback() {
            const _this = this;
            this.init();

            $(window).on('scroll', _this.scrollHandler.bind(_this));
          }
          disconnectedCallback() {
            const _this = this;
            $(window).off('scroll', _this.scrollHandler.bind(_this));
          }

          scrollHandler() {
            if (this.clickPoint) {
              return;
            }
            const adsorption = $('#adsorption');
            const Points = $(`[data-jump]`);
            let sticky = adsorption.offset().top;
            const scrollTop = $(window).scrollTop();
            if (scrollTop > sticky && !this.changeStatus) {
              this.changeStatus = true;
              this.sticky_start = sticky;
              adsorption.addClass('adsorption_sticky');
              adsorption.css('top', '0');
            }
            if (this.changeStatus && $(window).scrollTop() < this.sticky_start - 10) {
              this.changeStatus = false;
              adsorption.removeClass('adsorption_sticky');
              adsorption.css('top', '0');
            } else if (this.changeStatus) {
              adsorption.css('top', '0');
            }
            Points.each(function () {
              const targetPoint = $(this).attr('data-jump');
              if (!targetPoint) return;
              const $targetElement = $(`#${targetPoint}`);
              // const $targetElement = $(targetElement);
              if (!$targetElement.length) return;
              var targetOffset = $targetElement.offset().top; // 获取目标元素的顶部位置
              var targetHeight = $targetElement.outerHeight(); // 获取目标元素的高度

              // 判断锚点元素是否进入视口
              if (
                $(window).scrollTop() >= targetOffset - 50 &&
                $(window).scrollTop() < targetOffset + targetHeight - 50
              ) {
                console.log('可以进来6');
                // 当目标元素在视口中时，给对应的链接添加 'active' 类
                Points.removeClass('adsorption_active'); // 移除所有链接的 'active' 类
                $(this).addClass('adsorption_active'); // 给当前链接添加 'active' 类
                // 添加滚动到居中的逻辑
                const tabBox = $(this).closest('.point_wrapper')[0];
                if (tabBox) {
                  const tab = this;
                  const tabRect = tab.getBoundingClientRect();
                  const boxRect = tabBox.getBoundingClientRect();
                  const targetScroll =
                    tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;
                  tabBox.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth',
                  });
                }
              }
            });
          }

          init() {
            const _this = this;
            let adsorption = $('#adsorption');
            this.sticky_start = adsorption.offset().top;
            const Points = $(`[data-jump]`);
            Points.on('click', function (e) {
              e.preventDefault(); // 阻止默认跳转行为
              Points.removeClass('adsorption_active'); // 移除所有链接的 'active' 类
              $(this).addClass('adsorption_active'); // 给当前链接添加 'active' 类
            });
            // 为每个 jumpPoint 元素添加点击事件
            Points.each(function () {
              $(this).on('click', function () {
                if (_this.clickPoint) {
                  return;
                }
                _this.clickPoint = true;

                // 获取当前点击元素的 data-jump 属性值
                const dataPoint = $(this).data('jump');
                if (!dataPoint) return;
                // 根据 data-jump 获取对应的 id 元素
                const $markerPoint = $(`#${dataPoint}`);
                // 如果找到了对应的 marker-point 元素，则滚动到该元素
                if ($markerPoint.length) {
                  $('html, body').animate(
                    {
                      scrollTop: $($markerPoint[0]).offset().top + 30,
                    },
                    300,
                    function () {
                      _this.clickPoint = false;
                      _this.scrollHandler();
                    }
                  );
                } else {
                  _this.clickPoint = false;
                }
                // 添加滚动到居中的逻辑
                const tabBox = $(this).closest('.point_wrapper')[0];
                if (tabBox) {
                  const tab = this;
                  const tabRect = tab.getBoundingClientRect();
                  const boxRect = tabBox.getBoundingClientRect();
                  const targetScroll =
                    tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;
                  tabBox.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth',
                  });
                }
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-youtube"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('global-youtube')) {
    customElements.define(
      'global-youtube',
      class globalYoutube extends HTMLElement {
        connectedCallback() {
          this.initVideo();
        }

        initVideo() {
          const videoContainer = this.querySelector('.global-youtube__video');
          const playButton = this.querySelector('.play-button');
          const iframe = videoContainer?.querySelector('iframe');

          if (!videoContainer || !playButton || !iframe) {
            return;
          }

          // 处理 YouTube 缩略图加载失败的情况
          try {
            const youtubeCoverImage = videoContainer.querySelector('img[src*="youtube.com/vi/"]');
            if (youtubeCoverImage) {
              youtubeCoverImage.addEventListener('error', function () {
                const youtubeId = videoContainer.getAttribute('data-youtube-id');
                if (youtubeId && this.src && this.src.includes('maxresdefault.jpg')) {
                  // 如果高分辨率缩略图加载失败，尝试标准分辨率
                  this.src = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
                } else if (youtubeId && this.src && this.src.includes('hqdefault.jpg')) {
                  // 如果标准分辨率也失败，使用默认缩略图
                  this.src = `https://img.youtube.com/vi/${youtubeId}/default.jpg`;
                }
              });
            }
          } catch (error) {}

          // 点击播放按钮时播放视频
          const playVideo = (e) => {
            e.preventDefault();
            e.stopPropagation();

            // 防止重复点击
            if (videoContainer.classList.contains('playing')) {
              return;
            }

            // 检查是否有有效的 YouTube ID
            const youtubeId = videoContainer.getAttribute('data-youtube-id');
            if (!youtubeId || youtubeId.trim() === '') {
              alert('请先添加有效的 YouTube 视频链接');
              return;
            }

            // 添加加载状态
            playButton.style.opacity = '0.5';
            playButton.style.pointerEvents = 'none';

            // 设置 iframe src 以触发自动播放
            const youtubeSrc = iframe.getAttribute('data-youtube-src');
            if (youtubeSrc) {
              iframe.src = youtubeSrc;
            } else {
              // 备用方案：使用 data-youtube-id
              if (youtubeId) {
                const newSrc = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&controls=1&enablejsapi=1&modestbranding=1&playsinline=1&rel=0`;
                iframe.src = newSrc;
              }
            }

            // 立即切换到播放状态
            videoContainer.classList.add('playing');
          };

          // 绑定播放按钮点击事件
          playButton.addEventListener('click', playVideo);

          // 也可以点击封面图来播放
          const clickableCover = videoContainer.querySelector('.global-youtube__cover, img');
          if (clickableCover) {
            clickableCover.addEventListener('click', playVideo);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["handwritten-letter-center"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('handwritten-letter-center')) {
      customElements.define(
        'handwritten-letter-center',
        class HandwrittenLetterCenter extends HTMLElement {
          connectedCallback() {
            this.init();
          }

          init() {
            const prevButton = this.querySelector('.handwritten-letter-center__prev');
            if (!prevButton) return;

            prevButton.addEventListener('click', () => {
              const prevId = prevButton.getAttribute('data-id');
              if (!prevId) return;
              document.querySelector(`#${prevId}`)?.setAttribute('data-show', 'true');
              this.setAttribute('data-show', 'false');
              const urlParams = new URLSearchParams(window.location.search);
              urlParams.set('currentId', prevId);
              window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["handwritten-letter-matched"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('handwritten-letter-matched')) {
      customElements.define(
        'handwritten-letter-matched',
        class HandwrittenLetterMatched extends HTMLElement {
          static get observedAttributes() {
            return ['data-show'];
          }

          connectedCallback() {
            this._onResize = () => {
              this.syncFooterScrollStyle();
            };

            this.init();
            this.syncNumber();
            this.syncFooterScrollStyle();
            this.observeUnmatchedNumber();
            this.observePanelResize();
            window.addEventListener('resize', this._onResize);
          }

          disconnectedCallback() {
            this._unmatchedObserver?.disconnect();
            this._unmatchedObserver = null;
            this._panelResizeObserver?.disconnect();
            this._panelResizeObserver = null;
            if (this._onResize) {
              window.removeEventListener('resize', this._onResize);
              this._onResize = null;
            }
          }

          attributeChangedCallback(name) {
            if (name === 'data-show') {
              this.syncNumber();
              this.syncFooterScrollStyle();
            }
          }

          init() {
            const nextButton = this.querySelector('.handwritten-letter-matched__next');
            if (!nextButton) return;

            nextButton.addEventListener('click', () => {
              const nextId = nextButton.getAttribute('data-id');
              if (!nextId) return;
              document.querySelector(`#${nextId}`)?.setAttribute('data-show', 'true');
              this.setAttribute('data-show', 'false');
              const urlParams = new URLSearchParams(window.location.search);
              urlParams.set('currentId', nextId);
              window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
            });
          }

          /**
           * 监听 unmatched 的 data-number 变化（逻辑只在 matched 内）
           */
          observeUnmatchedNumber() {
            const unmatched = document.querySelector('handwritten-letter-unmatched');
            if (!unmatched) return;

            this._unmatchedObserver?.disconnect();
            this._unmatchedObserver = new MutationObserver(() => {
              this.syncNumber();
            });
            this._unmatchedObserver.observe(unmatched, {
              attributes: true,
              attributeFilter: ['data-number'],
            });
          }

          /**
           * 会员编号：从 handwritten-letter-unmatched 的 data-number 读取，原样展示
           */
          syncNumber() {
            const numberEl = this.querySelector('.handwritten-letter-matched__number');
            if (!numberEl) return;

            const unmatched = document.querySelector('handwritten-letter-unmatched');
            numberEl.textContent = (unmatched?.getAttribute('data-number') || '').trim();
          }

          /**
           * 监听面板尺寸变化（图片加载等导致高度变化）
           */
          observePanelResize() {
            const panel = this.querySelector('.handwritten-letter-matched');
            if (!panel || typeof ResizeObserver === 'undefined') return;

            this._panelResizeObserver?.disconnect();
            this._panelResizeObserver = new ResizeObserver(() => {
              this.syncFooterScrollStyle();
            });
            this._panelResizeObserver.observe(panel);
          }

          /**
           * html / body / 当前面板出现滚动条时，给 footer 加背景和阴影
           */
          syncFooterScrollStyle() {
            const footer = this.querySelector('.handwritten-letter-matched__footer');
            if (!footer) return;

            const html = document.documentElement;
            const body = document.body;
            const panel = this.querySelector('.handwritten-letter-matched');

            const htmlHasScroll = html.scrollHeight > html.clientHeight;
            const bodyHasScroll = body.scrollHeight > body.clientHeight;
            const panelHasScroll = panel ? panel.scrollHeight > panel.clientHeight : false;

            footer.classList.toggle('is-scroll', htmlHasScroll || bodyHasScroll || panelHasScroll);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["handwritten-letter-unmatched"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('handwritten-letter-unmatched')) {
      customElements.define(
        'handwritten-letter-unmatched',
        class HandwrittenLetterUnmatched extends HTMLElement {
          connectedCallback() {
            this.init();
            this.bindLoginSuccessLoading();
            this.checkMatchIfLogined();
            this.openLoginIfNeeded();
            this.initFooterShadow();
          }

          disconnectedCallback() {
            this._unsubLoginSuccess?.();
            this._unsubLoginSuccess = null;
          }

          init() {
            const loginBtn = this.querySelector('.handwritten-letter-unmatched__login-btn');
            if (loginBtn) {
              loginBtn.addEventListener('click', () => {
                window.litime.eventBus.publish('LOGIN');
              });
            }

            const chatBtn = this.querySelector('.handwritten-letter-unmatched__chat-btn');
            if (chatBtn) {
              chatBtn.addEventListener('click', () => {
                if (window.litime && window.litime.openChatApp) {
                  window.litime.openChatApp();
                }
              });
            }
          }

          /**
           * 订阅登录成功：关弹窗到刷新之间盖骨架，避免闪旧账号；仅成功时触发，关弹窗不会一直骨架
           */
          bindLoginSuccessLoading() {
            this._unsubLoginSuccess?.();
            this._unsubLoginSuccess = window.litime?.eventBus?.subscribe('LOGIN_SUCCESS', () => {
              document.querySelectorAll('[data-type="handwritten-letter"]').forEach((el) => {
                el.setAttribute('data-show', el === this ? 'true' : 'false');
              });
              this.setAttribute('data-loading', 'true');

              const url = new URL(window.location.href);
              url.searchParams.delete('currentId');
              window.history.replaceState({}, '', url.pathname + url.search);
            });
          }

          goNext() {
            this.goTo(this.getAttribute('data-next-id'));
          }

          setCurrentId(id) {
            if (!id) return;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('currentId', id);
            window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
          }

          goTo(targetId) {
            if (!targetId) return;
            const target = Array.from(document.querySelectorAll('[data-type="handwritten-letter"]')).find(
              (el) => el.getAttribute('id') === targetId
            );
            if (!target) return;

            document.querySelectorAll('[data-type="handwritten-letter"]').forEach((el) => {
              el.setAttribute('data-show', 'false');
            });
            target.setAttribute('data-show', 'true');
            this.setCurrentId(targetId);
          }

          /**
           * 接口已确认可进后续后：按 URL currentId 决定 matched / center
           * 非法或为空时默认进 data-next-id（matched）
           */
          resolvePostMatchTarget() {
            const matchedId = this.getAttribute('data-next-id');
            const currentId = new URLSearchParams(window.location.search).get('currentId');
            if (!currentId || currentId === this.getAttribute('id')) return matchedId;

            const target = Array.from(document.querySelectorAll('[data-type="handwritten-letter"]')).find(
              (el) => el.getAttribute('id') === currentId
            );
            if (!target || target === this) return matchedId;
            return currentId;
          }

          initFooterShadow() {
            const scrollEl = this.querySelector('.handwritten-letter-unmatched__scroll');
            const footerEl = this.querySelector('.handwritten-letter-unmatched__footer');
            if (!scrollEl || !footerEl) return;

            const update = () => {
              const hasScroll = scrollEl.scrollHeight > scrollEl.clientHeight + 1;
              footerEl.setAttribute('data-shadow', hasScroll ? 'true' : 'false');
            };

            update();
            scrollEl.querySelectorAll('img').forEach((img) => {
              if (!img.complete) img.addEventListener('load', update, { once: true });
            });
            window.addEventListener('resize', update);
            if (window.ResizeObserver) {
              new ResizeObserver(update).observe(scrollEl);
            }
          }

          hideLoading() {
            this.setAttribute('data-loading', 'false');
            requestAnimationFrame(() => {
              const scrollEl = this.querySelector('.handwritten-letter-unmatched__scroll');
              const footerEl = this.querySelector('.handwritten-letter-unmatched__footer');
              if (!scrollEl || !footerEl) return;
              const hasScroll = scrollEl.scrollHeight > scrollEl.clientHeight + 1;
              footerEl.setAttribute('data-shadow', hasScroll ? 'true' : 'false');
            });
          }

          // 已登录：query → 无记录则 save → 按 code 决定页
          // 可进后续时再看 currentId，决定落地 matched 或 center
          // 未登录：保持 data-loading，仅弹强制登录（骨架垫在弹窗后）
          async checkMatchIfLogined() {
            if (this.getAttribute('data-logined') !== 'true') return;
            if (this.getAttribute('data-show') !== 'true') return;

            try {
              const result = await this.fetchMatchStatus();
              if (result === 'matched') {
                this.goTo(this.resolvePostMatchTarget());
              } else if (result === 'login') {
                // 保持骨架，等登录成功刷新
              } else {
                this.hideLoading();
              }
            } catch (error) {
              console.warn('[handwritten-letter-unmatched] match check failed', error);
              this.hideLoading();
            }
          }

          hasFormRecord(data) {
            return data != null && (data.recordId != null || data.sequenceNo != null);
          }

          openLoginFromApi() {
            window.litime?.eventBus?.publish('LOGIN');
          }

          applyFormSuccess(data) {
            const raw = data?.sequenceNo;
            if (raw == null || raw === '') return;

            const num = Math.min(Math.max(Number(raw), 0), 999);
            if (Number.isNaN(num)) return;

            this.setAttribute('data-number', String(Math.floor(num)).padStart(3, '0'));
          }

          /**
           * 处理表单接口响应
           * @returns {'matched'|'unmatched'|'login'}
           */
          handleFormResponse(res) {
            if (!res) return 'unmatched';
            if (res.code === 100720000) {
              this.openLoginFromApi();
              return 'login';
            }
            if (res.code === 200) {
              this.applyFormSuccess(res.data);
              return 'matched';
            }
            return 'unmatched';
          }

          postForm(path) {
            return window.litime.http.post(
              path,
              {
                data: { code: 'handwritten_letter' },
                headers: { brand: 'LiTime' },
              },
              'business-api'
            );
          }

          /**
           * query 有 recordId/sequenceNo 则用其结果；否则 save 再判断
           * @returns {Promise<'matched'|'unmatched'|'login'>}
           */
          async fetchMatchStatus() {
            const queryRes = await this.postForm('/shopify-form/query');

            if (queryRes?.code === 100720000) {
              this.openLoginFromApi();
              return 'login';
            }

            const res = this.hasFormRecord(queryRes?.data) ? queryRes : await this.postForm('/shopify-form/save');

            return this.handleFormResponse(res);
          }

          // 当前页展示且未登录时，自动打开登录弹窗
          openLoginIfNeeded() {
            if (this.getAttribute('data-show') !== 'true') return;
            if (this.getAttribute('data-logined') !== 'false') return;
            setTimeout(() => {
              window.litime?.eventBus?.publish('LOGIN');
            }, 0);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-02"]) return;
  try {
    
  $(function () {
    if (!customElements.get('lt-header-02')) {
      customElements.define(
        'lt-header-02',
        class ltHeader02 extends HTMLElement {
          constructor() {
            super();
            this.$ltHeader = null;
            this.$headerContainer = null;
            this.$header = null;
            this.$announcement = null;
            this.$announcementHeight = null;
            this.$scrollThreshold = 50; // 设置滚动阈值
            this.$menuContainer = null; //菜单列表
            this.$MainContent = null;
            this.$overlay = null;
            this.$hasMenuFunctionBeenCalled = false;
            this.$mobileMenu = null;
            this.$mobileMenuShow = null;
            this.$mobilePopup = null;
            this.$header01 = null;
            this.$scrollShow = true;
            this.$loginButton = null;
            this.$body = null;
            this.$bubbleContainerList = null;
            this.$lastScrollTop = 0;
            this.$navHeader = null;
            this.$navflag = false; // 导航是否开启
            this.$observer = null;
            this.$screen = null;
            this.$theme = null;
            this.$currentInfo = {};
            this.$defaultScreen = null;
            this.$scrollBtnContainer = null;
            this.country = null;
          }

          connectedCallback() {
            this.initCountry(); // 初始化切换站点

            this.$body = $('body');
            this.$header = this.querySelector('#header-01');
            this.$ltHeader = $('#lt-header')[0];
            this.$headerLayout = this.querySelector('.nav-layout');
            this.$defaultScreen = this.$ltHeader.getAttribute('data-defaultScreen'); //是否开启
            this.$bubbleContainerList = this.querySelectorAll('.bubble-container');
            this.announcement = $('#announcement');
            this.$headerContainer = $('.header-01');
            this.$menuContainer = this.querySelector('.header-container');
            this.$MainContent = $('#MainContent');

            // 在初始化之前就检查滚动位置，如果不在顶部则直接隐藏 header
            const initialScrollTop = $(window).scrollTop();
            if (initialScrollTop > 0) {
              // 直接隐藏 header，避免任何闪现
              this.$headerContainer.css('top', '-300px');
              this.$headerContainer.css('position', 'sticky');
              this.$ltHeader.setAttribute('data-scrollShow', false);
              this.$headerLayout.classList.remove('text-white');

              // 检查 data-screen 和 data-defaultscreen 属性
              const dataScreen = this.$ltHeader.getAttribute('data-screen');
              const dataDefaultScreen = this.$ltHeader.getAttribute('data-defaultscreen');

              // 如果 data-screen="true" 和 data-defaultscreen="true" 都为 true，则设置 sticky 定位
              if (dataScreen === 'true' && dataDefaultScreen === 'true') {
                this.$headerContainer.css('position', 'sticky');
              }
            }

            this.init();
            this.currentScreen();
            this.$prevBtn = this.querySelector('.scroll-btn-container .swiper-button-prev');
            this.$nextBtn = this.querySelector('.scroll-btn-container .swiper-button-next');
            this.$scroller = this.querySelector('.nav-scroller');

            // 添加鼠标悬浮事件
            if (this.$scrollBtnContainer) {
              this.$scrollBtnContainer.addEventListener('mouseenter', () => {
                this.$ltHeader.setAttribute('data-screen', false);
                this.$headerLayout.classList.remove('text-white');
              });
            }
            // 添加header-right-container的鼠标事件
            const headerRightContainer = this.querySelector('.header-right-container');
            if (headerRightContainer) {
              headerRightContainer.addEventListener('mouseenter', () => {
                window.overlayManager.hide('header');
                this.$navflag = false;

                if (window.innerWidth > 1200 && window.location.pathname === '/') {
                  if (this.$scrollShow == true) {
                    if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                      this.$ltHeader.setAttribute('data-screen', true);
                    }
                  }
                  this.$theme = this.$ltHeader.getAttribute('data-theme');
                  if (this.$theme == 'dark') {
                    if (this.$ltHeader.getAttribute('data-screen') == true) {
                      this.$headerLayout.classList.add('text-white');
                    } else {
                      this.$headerLayout.classList.remove('text-white');
                    }
                  } else {
                    this.$headerLayout.classList.remove('text-white');
                  }
                }

                const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
                navItems.forEach((item) => {
                  item.classList.remove('nav-item-active');
                  const targetSelector = item.querySelector('.nav-launch');
                  if (targetSelector) {
                    targetSelector.classList.remove('nav-hover-active');
                  }
                });
                const navLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
                navLaunches.forEach((launch) => {
                  launch.classList.remove('navLaunchShow');
                  launch.classList.add('navLaunchNo');
                });
              });
            }

            if (this.$menuContainer && this.$menuContainer.querySelectorAll('li[data-target]').length > 0)
              this.mouseLeaveHandler();

            this.mobilePopupLogin();
          }
          static get observedAttributes() {
            return ['data-theme', 'data-screen'];
          }

          attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue === newValue) return;

            if (name === 'data-screen') {
              if (newValue == 'false') {
                // 确保处理布尔值或字符串
                if (this.$header) {
                  this.$header.classList.add('theme-light-current');
                }

                this.$screen = false;
                return; // 直接退出，不执行后续逻辑
              } else if (newValue == 'true' || newValue == true) {
                this.$screen = true;
                if (this.$header) {
                  this.$header.classList.remove('theme-light-current');
                }
              }
            }

            if ((this.$screen === true || this.$screen === 'true') && name === 'data-theme') {
              if (this.$header) {
                if (name === 'data-theme' && newValue === 'light') {
                  this.$header.classList.remove('theme-dark');
                  this.$header.classList.add('theme-light');
                  this.$headerLayout.classList.remove('text-white');
                  this.$bubbleContainerList.forEach((res) => {
                    const dataLightColor = res.getAttribute('data-light-color').split(',');
                    res.style.background = dataLightColor[0];
                    res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                    res.querySelector('span').style.color = dataLightColor[1];
                  });
                } else if (name === 'data-theme' && newValue === 'dark' && this.$defaultScreen == 'true') {
                  this.$header.classList.remove('theme-light');
                  this.$header.classList.add('theme-dark');
                  this.$headerLayout.classList.add('text-white');
                  this.$bubbleContainerList.forEach((res) => {
                    const dataDarkColor = res.getAttribute('data-dark-color').split(',');
                    res.style.background = dataDarkColor[0];
                    res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataDarkColor[0]}`;
                    res.querySelector('span').style.color = dataDarkColor[1];
                  });
                }
              }
            } else if (name === 'data-screen' && (this.$screen === true || this.$screen === 'true')) {
              if (this.$currentInfo.name === 'data-theme' && this.$currentInfo.value === 'light') {
                this.$header.classList.remove('theme-dark');
                this.$header.classList.add('theme-light');
                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                  res.querySelector('span').style.color = dataLightColor[1];
                });
              } else if (this.$currentInfo.name === 'data-theme' && this.$currentInfo.value === 'dark') {
                this.$header.classList.remove('theme-light');
                this.$header.classList.add('theme-dark');
                this.$bubbleContainerList.forEach((res) => {
                  const dataDarkColor = res.getAttribute('data-dark-color').split(',');
                  res.style.background = dataDarkColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataDarkColor[0]}`;
                  res.querySelector('span').style.color = dataDarkColor[1];
                });
              }
            }
            if (name == 'data-theme') {
              this.$currentInfo = { name: name, value: newValue };
            }
          }

          currentScreen() {
            this.$screen = this.$ltHeader.getAttribute('data-screen');
            this.$theme = this.$ltHeader.getAttribute('data-theme');
            if (window.location.pathname !== '/') {
              this.$screen = false;
              this.$theme = 'light';
              this.$ltHeader.setAttribute('data-screen', false);
              this.$ltHeader.setAttribute('data-theme', 'light');
            }

            if (this.$screen != 'false' || this.$screen == true) {
              if (this.$theme == 'light') {
                this.$header.classList.remove('theme-dark');
                this.$header.classList.add('theme-light');
                this.$headerLayout.classList.remove('text-white');
                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                  res.querySelector('span').style.color = dataLightColor[1];
                });
              } else if (this.$theme == 'dark') {
                this.$header.classList.remove('theme-light');
                this.$header.classList.add('theme-dark');
                this.$headerLayout.classList.add('text-white');
                this.$bubbleContainerList.forEach((res) => {
                  const dataDarkColor = res.getAttribute('data-dark-color').split(',');
                  res.style.background = dataDarkColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataDarkColor[0]}`;
                  res.querySelector('span').style.color = dataDarkColor[1];
                });
              }
            } else {
              this.$screen = false;
              this.$header.classList.add('theme-light');
              this.$ltHeader.setAttribute('data-screen', false);
              this.$ltHeader.setAttribute('data-theme', 'light');
            }
          }

          disconnectedCallback() {
            window.overlayManager.hide('header'); // 确保清理遮罩层
            // 监听窗口大小变化事件
            window.removeEventListener('resize', this.handleResize);
            // 移除事件监听
            this.removeHoverMenuListeners();
            if (this.$observer) {
              this.$observer.disconnect(); // 停止监听
            }
          }

          init() {
            this.mobilePopupFunction();
            // 开启了通屏为透明导航得时候才可以进来
            if (this.$header && this.$header.classList.contains('bg-transparent')) {
            }
            this.scroll();
            this.handleResize();
            this.mobileMenuClick();
            this.updateHeaderHeight(); // 添加初始高度获取

            // 监听窗口大小变化
            window.addEventListener('resize', () => {
              this.updateHeaderHeight(); // 在窗口大小改变时更新高度

              // 当窗口尺寸改变时，重新检查并执行
              if (window.innerWidth >= 1200) {
                // 如果已经执行过 hoverMenuFunction，则不再重复执行
                if (!this.$hasMenuFunctionBeenCalled) {
                  this.handleResize();
                  this.$hasMenuFunctionBeenCalled = true; // 设置标志
                }
              } else {
                window.removeEventListener('resize', this.handleResize);
                this.removeHoverMenuListeners();
                // 如果窗口小于 1200px，可以重置标志，以便窗口重新变大时再次执行
                this.$hasMenuFunctionBeenCalled = false;
              }
            });
          }

          handleResize() {
            if (window.innerWidth >= 1200 && !this.$hasMenuFunctionBeenCalled) {
              this.hoverMenuFunction();
              this.$hasMenuFunctionBeenCalled = true;
            } else {
              this.$hasMenuFunctionBeenCalled = false;
            }
          }

          hoverMenuFunction() {
            const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
            this.eventHandlers = []; // 存储事件处理程序

            navItems.forEach((item) => {
              const targetSelector = item.querySelector('.nav-launch');
              const mouseEnterHandler = () => {
                // 确保每次触发前清除所有存在的遮罩层
                this.clearExistingOverlays();

                navItems.forEach((res) => {
                  res.classList.remove('nav-item-active');
                });
                item.classList.add('nav-item-active');

                // 移入进来将设置的当前通屏颜色关闭
                this.$ltHeader.setAttribute('data-screen', false);
                this.$headerLayout.classList.remove('text-white');
                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                  res.querySelector('span').style.color = dataLightColor[1];
                });
                const dataTarget = item.getAttribute('data-target');
                if (dataTarget !== '.menu-plan-3') {
                  if (this.$MainContent.length > 0) {
                    // 使用全局遮罩层管理器
                    this.$overlay = window.overlayManager.show('header');
                  }

                  // 获取所有的 .nav-launch 元素，并将其全部隐藏
                  const allNavLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
                  allNavLaunches.forEach((launch) => {
                    launch.classList.add('navLaunchNo');
                    launch.classList.remove('navLaunchShow');
                  });
                  if (!this.$navflag) {
                    // 显示当前菜单项的 .nav-launch
                    if (targetSelector) {
                      this.$navflag = true;
                      targetSelector.classList.add('navLaunchShow');
                      targetSelector.classList.remove('navLaunchNo');
                    }
                  } else {
                    if (targetSelector) {
                      // 平级切换
                      targetSelector.classList.add('navLaunchShow');
                      targetSelector.classList.remove('navLaunchNo');
                    }
                  }
                } else if (dataTarget === '.menu-plan-3') {
                  window.overlayManager.hide('header'); // 使用全局遮罩层管理器隐藏遮罩层
                  const navLaunch = $('.nav-launch');
                  this.$navflag = false;
                  navItems.forEach((item) => {
                    item.classList.remove('nav-item-active');
                    const targetSelector = item.querySelector('.nav-launch');
                    if (targetSelector) {
                      targetSelector.classList.remove('nav-hover-active');
                    }
                  });
                  navLaunch.each((index, element) => {
                    element.classList.remove('navLaunchShow');
                    element.classList.add('navLaunchNo');
                  });
                }
              };
              item.addEventListener('mouseenter', mouseEnterHandler);
              this.eventHandlers.push({ item, mouseEnterHandler });
            });
          }
          closePopup() {
            window.overlayManager.hide('header');
            this.$navflag = false;

            if (window.innerWidth > 1200 && window.location.pathname === '/') {
              if (this.$scrollShow == true) {
                if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                  this.$ltHeader.setAttribute('data-screen', true);
                }
              }
            }
            const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
            navItems.forEach((item) => {
              item.classList.remove('nav-item-active');
            });
            const navLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
            navLaunches.forEach((launch) => {
              launch.classList.remove('navLaunchShow');
              launch.classList.add('navLaunchNo');
            });
          }
          // 移出事件
          mouseLeaveHandler() {
            customEventListener(this.$headerContainer[0], 'mouseleave', () => {
              window.overlayManager.hide('header');
              this.$navflag = false;

              if (window.innerWidth > 1200 && window.location.pathname === '/') {
                if (this.$scrollShow == true) {
                  if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                    this.$ltHeader.setAttribute('data-screen', true);
                  }
                }
                this.$theme = this.$ltHeader.getAttribute('data-theme');
                if (this.$theme == 'dark') {
                  if (
                    this.$ltHeader.getAttribute('data-screen') == true ||
                    this.$ltHeader.getAttribute('data-screen') == 'true'
                  ) {
                    this.$headerLayout.classList.add('text-white');
                  } else {
                    this.$headerLayout.classList.remove('text-white');
                  }
                } else {
                  this.$headerLayout.classList.remove('text-white');
                }
              }

              const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
              navItems.forEach((item) => {
                item.classList.remove('nav-item-active');
                const targetSelector = item.querySelector('.nav-launch');
                if (targetSelector) {
                  targetSelector.classList.remove('nav-hover-active');
                }
              });
              const navLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
              navLaunches.forEach((launch) => {
                launch.classList.remove('navLaunchShow');
                launch.classList.add('navLaunchNo');
              });
            });
          }

          // 用于移除事件监听器
          removeHoverMenuListeners() {
            if (this.eventHandlers) {
              this.eventHandlers.forEach(({ item, mouseEnterHandler }) => {
                item.removeEventListener('mouseenter', mouseEnterHandler);
              });
            }
          }

          scroll() {
            // 监听滚动事件
            $(window).on('scroll', () => {
              // 如果购物车抽屉或其他抽屉打开时，忽略滚动事件
              if (document.body.classList.contains('drawer-body-no-scroll')) {
                return;
              }

              const currentScrollTop = $(window).scrollTop();

              // 使用 requestAnimationFrame 优化动画性能
              requestAnimationFrame(() => {
                if (currentScrollTop > this.$lastScrollTop) {
                  // 向下滚动 - 隐藏 header
                  this.$headerContainer.css('top', '-300px');
                  this.$headerContainer.css('position', 'sticky');
                  this.$ltHeader.setAttribute('data-scrollShow', false);
                  this.$headerLayout.classList.remove('text-white');

                  // 检查 data-screen 和 data-defaultscreen 属性
                  const dataScreen = this.$ltHeader.getAttribute('data-screen');
                  const dataDefaultScreen = this.$ltHeader.getAttribute('data-defaultscreen');

                  // 如果 data-screen="true" 和 data-defaultscreen="true" 都为 true，则设置 sticky 定位
                  if (dataScreen === 'true' && dataDefaultScreen === 'true') {
                    this.$headerContainer.css('position', 'sticky');
                  }
                } else if (currentScrollTop < this.$lastScrollTop) {
                  // 向上滚动 - 显示并保持吸附
                  this.$headerContainer.css('top', '0px');
                  this.$headerContainer.css('position', 'sticky');
                  this.$ltHeader.setAttribute('data-scrollShow', true);
                  this.$headerLayout.classList.remove('text-white');
                }
                this.$lastScrollTop = currentScrollTop; // 更新上一次的滚动位置
              });

              // 公告栏存在超出公告栏的高度时显示背景颜色
              if (this.announcement.length > 0) {
                if ($(window).scrollTop() > this.announcement.height()) {
                  this.$header.classList.remove('bg-transparent', 'border-transparent');
                  this.$header.classList.add('bg-white', 'header-light');

                  this.$bubbleContainerList.forEach((res) => {
                    const dataLightColor = res.getAttribute('data-light-color').split(',');
                    res.style.background = dataLightColor[0];
                    res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                    res.querySelector('span').style.color = dataLightColor[1];
                  });

                  if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                    this.$ltHeader.setAttribute('data-screen', false);
                    this.$scrollShow = false;
                  }
                  this.$headerLayout.classList.remove('text-white');
                } else {
                  // 如果滚动距离小于阈值，则恢复透明背景
                  this.$header.classList.remove('bg-white', 'header-light', 'light-default');
                  this.$header.classList.add('bg-transparent');
                  if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                    this.$ltHeader.setAttribute('data-screen', true);
                    this.$scrollShow = true;
                  }
                  this.$theme = this.$ltHeader.getAttribute('data-theme');
                  if (this.$theme == 'dark') {
                    if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                      this.$headerLayout.classList.add('text-white');
                    } else {
                      this.$headerLayout.classList.remove('text-white');
                    }
                  } else {
                    this.$headerLayout.classList.remove('text-white');
                  }
                }
              } else if (currentScrollTop > this.$scrollThreshold) {
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white', 'header-light');
                if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                  this.$scrollShow = false;
                  this.$ltHeader.setAttribute('data-screen', false);
                }
                this.$headerLayout.classList.remove('text-white');

                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                  res.querySelector('span').style.color = dataLightColor[1];
                });
              } else {
                if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                  this.$scrollShow = true;
                  this.$ltHeader.setAttribute('data-screen', true);
                }
                this.$theme = this.$ltHeader.getAttribute('data-theme');

                this.$headerLayout.classList.remove('text-white');
                // 如果滚动距离小于阈值，则恢复透明背景
                this.$header.classList.remove('bg-white', 'header-light');
                this.$header.classList.add('bg-transparent');
                this.$header.classList.add('border-transparent');
              }
            });

            // 初始状态设置
            if (this.announcement.length > 0) {
              this.$headerContainer.addClass('header-01-sticky');

              if ($(window).scrollTop() > this.announcement.height()) {
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white', 'header-light', 'light-default');
                this.$ltHeader.setAttribute('data-screen', true);
              } else if ($(window).scrollTop() > this.$scrollThreshold) {
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white');
              }
            } else {
              if ($(window).scrollTop() > this.announcement.height()) {
                this.$headerContainer.addClass('header-01-sticky');
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white', 'header-light', 'light-default');
              }
              this.$ltHeader.setAttribute('data-screen', true);
            }
          }

          // 打开移动端菜单
          mobileMenuClick() {
            this.$mobileMenu = this.querySelector('.mobileMenu');
            this.$header01 = this.querySelector('#header-01');
            this.$mobileMenuShow = this.querySelector('.mobileMenuShow');
            this.$mobilePopup = this.querySelector('.mobilePopup');
            this.$navHeader = $('.nav-header')[0];
            customEventListener(this.$mobileMenu, 'click', () => {
              if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                this.$screen = false;
                this.$ltHeader.setAttribute('data-screen', false);
              }
              this.$body.addClass('body-no-scroll');
              this.$header.classList.add('theme-light-current');
              //首先判断            this.announcement有没有并且他的宽度需要大于0之后因为他的高度也是js计算的可能没那么快然后在添加this.announcement.addClass('hidden');
              if (this.announcement && this.announcement.height() > 0) {
                this.announcement.addClass('hidden');
              }
              this.$mobileMenu.classList.remove('flex');
              this.$mobileMenu.classList.add('hidden');
              this.$mobileMenuShow.classList.remove('hidden');
              this.$mobileMenuShow.classList.add('flex');
              this.$mobilePopup.classList.remove('hidden');
              this.$mobilePopup.classList.add('block');
              this.$header01.classList.add('mobile-dark');
              this.$body.add('body-no-scroll');

              this.$navHeader.classList.add('bg-white');
              const ellipse = this.$navHeader.querySelectorAll('.svg-light svg ellipse');
              const svgPath = this.$navHeader.querySelectorAll('.svg-path');
              if (ellipse) {
                ellipse.forEach((res) => {
                  res.style.stroke = '#191919'; // 使用 style 修改 stroke 颜色
                });
              }
              if (svgPath) {
                svgPath.forEach((res) => {
                  res.style.stroke = '#191919'; // 使用 style 修改 stroke 颜色
                });
              }
              this.$header01.classList.add('fixed', 'top-0', 'left-0', 'w-full', 'h-full');
            });
            customEventListener(this.$mobileMenuShow, 'click', () => {
              if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                this.$screen = true;
                this.$ltHeader.setAttribute('data-screen', true);
              }

              this.announcement.removeClass('hidden');
              this.$body.removeClass('body-no-scroll');
              this.$mobileMenu.classList.remove('hidden');
              this.$mobileMenu.classList.add('flex');
              this.$navHeader.classList.remove('bg-white');
              this.$mobileMenuShow.classList.remove('flex');
              this.$mobileMenuShow.classList.add('hidden');
              this.$mobilePopup.classList.remove('block');
              this.$mobilePopup.classList.add('hidden');
              this.$header01.classList.remove('mobile-dark');
              this.$header01.classList.remove('fixed', 'top-0', 'left-0', 'h-full');
              const ellipse = this.$navHeader.querySelectorAll('.svg-light svg ellipse');
              const svgPath = this.$navHeader.querySelectorAll('.svg-path');
              if (ellipse) {
                ellipse.forEach((res) => {
                  res.style.stroke = ''; // 使用 style 修改 stroke 颜色
                });
              }
              if (svgPath) {
                svgPath.forEach((res) => {
                  res.style.stroke = ''; // 使用 style 修改 stroke 颜色
                });
              }
            });
          }
          mobilePopupFunction() {
            // 获取 mobilePopup 元素

            // 定义 resize 事件处理逻辑
            const resizeHandler = () => {
              // 检查窗口宽度
              if (window.innerWidth > 1200) {
                // 如果宽度大于 1200px，隐藏 mobilePopup
                if (this.$mobilePopup) {
                  this.$mobilePopup.classList.remove('block');
                  this.$mobilePopup.classList.add('hidden');
                }
                // 移除 resize 事件监听器，因为已经满足了条件
                window.removeEventListener('resize', resizeHandler);
              }
            };
            // 初始调用 resizeHandler，确保页面加载时正确设置
            resizeHandler();
            // 监听 window 的 resize 事件
            window.addEventListener('resize', resizeHandler);
          }

          // 滚动处理
          scrollTo(direction) {
            const scrollAmount = 300;
            this.$scroller.scrollBy({
              left: direction === 'swiper-button-prev' ? -scrollAmount : scrollAmount,
              behavior: 'smooth',
            });
          }
          // 左右切换菜单逻辑 end
          // 清除遮罩层的方法
          clearExistingOverlays() {
            window.overlayManager.hide('header'); // 使用全局遮罩层管理器清除遮罩层
          }

          // 添加新方法来更新header高度
          updateHeaderHeight() {
            if (this.$menuContainer) {
              const headerHeight = this.$menuContainer.offsetHeight;
              const navHeaderHeight = this.$navHeader ? this.$navHeader.offsetHeight : 0;

              // 获取所有带有nav-item类的li元素
              const listItems = this.$menuContainer.querySelectorAll('li.nav-item');
              if (listItems.length === 0) return;

              // 获取第一个li元素的offsetTop作为基准
              const firstItemOffsetTop = listItems[0].offsetTop;

              // 检查每个li元素
              listItems.forEach((item, index) => {
                // 如果当前元素的offsetTop大于第一个元素的offsetTop，说明换行了
                const currentOffsetTop = item.offsetTop;
                const isSecondRow = currentOffsetTop > firstItemOffsetTop;

                // 获取nav-launch元素
                const navLaunch = item.querySelector('.nav-launch');
                if (navLaunch) {
                  if (isSecondRow) {
                    item.classList.add('second-row');
                    item.classList.remove('first-row');
                    // 设置第二行nav-launch的top值为nav-header的高度
                    navLaunch.style.top = `${navHeaderHeight}px`;
                  } else {
                    item.classList.add('first-row');
                    item.classList.remove('second-row');
                    // 设置第一行nav-launch的top值为70px
                    navLaunch.style.top = '69px';
                  }
                }
              });
            }
          }
          // 移动端弹出登录弹窗
          mobilePopupLogin() {
            const $headerNotLoggedIn = $('#header-not-logged-in');
            const $headerLoggedIn = $('#header-logged-in');
            $headerNotLoggedIn.on('click', (e) => {
              // 获取浏览器宽度
              const viewportWidth = window.innerWidth;
              if (viewportWidth < 1200) {
                e.stopPropagation();
                e.preventDefault();
                const $headerUserIcon = $headerNotLoggedIn.closest('.header-user-icon');
                if ($headerUserIcon.attr('data-show-modal') === 'true') {
                  $headerUserIcon.attr('data-show-modal', 'false');
                } else {
                  $headerUserIcon.attr('data-show-modal', 'true');
                }
              }
            });
            $headerLoggedIn.on('click', (e) => {
              // 获取浏览器宽度
              const viewportWidth = window.innerWidth;
              if (viewportWidth < 1200) {
                e.stopPropagation();
                e.preventDefault();
                const $headerUserIcon = $headerLoggedIn.closest('.header-user-icon');
                if ($headerUserIcon.attr('data-show-modal') === 'true') {
                  $headerUserIcon.attr('data-show-modal', 'false');
                } else {
                  $headerUserIcon.attr('data-show-modal', 'true');
                }
              }
            });
            // 点击其他区域关闭
            $(document).on('click', (e) => {
              const function_menu_mobile = $('.function_menu_mobile');
              if (e.target.className !== 'function_menu_mobile' && function_menu_mobile.find(e.target).length === 0) {
                function_menu_mobile.closest('.header-user-icon').attr('data-show-modal', 'false');
              }
            });
          }

          // 切换站点
          async switchSite(params) {
            const url = '/shopify/auth/change/shop';
            window.litime.showLoading();
            try {
              const res = await window.litime.http.get(url, {
                data: params,
              });
              window.litime.hideLoading();
              if (res.code === 200 && res.data?.mutilpass) {
                window.location.href = res.data.mutilpass;
              }
            } catch (err) {
              window.litime.hideLoading();
              window.litime.showToast('error', window.i18n.request_failed);
            }
          }

          async initCountry() {
            const _this = this;
            const function_menu_country = $(this.querySelector('.function_menu_country'));
            const jump_another_site_modal = $(this.querySelector('.jump-another-site-modal'));
            const customerEmail = function_menu_country.data('customer-email');
            const countryItem = function_menu_country.find('a');
            countryItem.on('click', function (e) {
              if (customerEmail) {
                e.stopPropagation();
                e.preventDefault();
                _this.country = $(this).attr('href');
                window.location.href = _this.country;

                // const site = $(this).data('country');
                // if (site === 'US' || site === 'CA') {
                //   const countryModalText = jump_another_site_modal.find('.country-modal-title').text();
                //   let newCountryModalText = countryModalText;
                //   if (countryModalText.includes('$site$')) {
                //     newCountryModalText = countryModalText.replace('$site$', `<span>${site}</span>`);
                //     jump_another_site_modal.find('.country-modal-title').html(newCountryModalText);
                //   } else {
                //     jump_another_site_modal.find('.country-modal-title').find('span').text(site);
                //   }
                //   jump_another_site_modal.removeClass('hidden');
                // } else {
                //   window.location.href = _this.country;
                // }
              }
            });
            jump_another_site_modal.find('.modal-close').on('click', (e) => {
              jump_another_site_modal.addClass('hidden');
            });
            jump_another_site_modal.find('.modal-confirm').on('click', (e) => {
              jump_another_site_modal.addClass('hidden');
              this.switchSite({
                domain: _this.country,
              });
            });
            jump_another_site_modal.find('.modal-cancel').on('click', (e) => {
              // jump_another_site_modal.addClass('hidden');
              window.litime.setLocalStorage('registe_anther', 1);
              window.location.href = _this.country + '?register=true';
            });

            // 获取logged-login-out
            const loggedLoginOut = $(this.querySelectorAll('.logged-login-out')).find('a');
            loggedLoginOut.on('click', (e) => {
              window.litime.clearLocalStorage('ltToken');
              window.litime.clearLocalStorage('ltUserInfo');
            });

            // 获取url参数
            const urlParams = new URLSearchParams(window.location.search);
            const register = urlParams.get('register');
            if (register) {
              window.litime.eventBus.publish('REGISTER');
              // 不刷新页面清空url参数
              window.history.replaceState({}, '', window.location.pathname);
            }
            const token = urlParams.get('ts');
            if (token) {
              const url = '/shopify/auth/change/shop/info';
              try {
                const res = await window.litime.http.get(url, {
                  data: {
                    ts: token,
                  },
                });
                if (res.code === 200) {
                  window.litime.setLocalStorage('ltToken', res.data.token);
                  window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
                  window.history.replaceState({}, '', window.location.pathname);
                }
              } catch (error) {
                const res = await window.litime.http.get(url, {
                  data: {
                    ts: token,
                  },
                });
                if (res.code === 200) {
                  window.litime.setLocalStorage('ltToken', res.data.token);
                  window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
                  window.history.replaceState({}, '', window.location.pathname);
                }
              }
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  $(function () {
    if (!customElements.get('lt-header')) {
      customElements.define(
        'lt-header',
        class ltHeader extends HTMLElement {
          constructor() {
            super();
            this.$ltHeader = null;
            this.$headerContainer = null;
            this.$header = null;
            this.$announcement = null;
            this.$announcementHeight = null;
            this.$scrollThreshold = 50; // 设置滚动阈值
            this.$menuContainer = null; //菜单列表
            this.$MainContent = null;
            this.$overlay = null;
            this.$hasMenuFunctionBeenCalled = false;
            this.$mobileMenu = null;
            this.$mobileMenuShow = null;
            this.$mobilePopup = null;
            this.$header01 = null;
            this.$scrollShow = true;
            this.$loginButton = null;
            this.$body = null;
            this.$bubbleContainerList = null;
            this.$lastScrollTop = 0;
            this.$navHeader = null;
            this.$navflag = false; // 导航是否开启
            this.$observer = null;
            this.$screen = null;
            this.$theme = null;
            this.$currentInfo = {};
            this.$defaultScreen = null;
            this.$scrollBtnContainer = null;
            this.country = null;
            this.$stickies = null; // tab-sticky 元素列表
          }

          connectedCallback() {
            // this.initCountry(); // 初始化切换站点
            window.addEventListener('pagehide', () => {
              this.clearLoadingButtons();
            });
            document.addEventListener('visibilitychange', () => {
              if (document.visibilityState === 'visible') {
                this.clearLoadingButtons();
              }
            });

            this.$body = $('body');
            this.$header = this.querySelector('#header-01');
            this.$ltHeader = $('#lt-header')[0];
            this.$headerLayout = this.querySelector('.nav-layout');
            this.$defaultScreen = this.$ltHeader.getAttribute('data-defaultScreen'); //是否开启
            this.$bubbleContainerList = this.querySelectorAll('.bubble-container');
            this.announcement = $('#announcement');
            this.globalHeaderEnsign = $('.global-header-ensign-root');
            this.$headerContainer = $('.header-01');
            this.$menuContainer = this.querySelector('.header-container');
            this.$MainContent = $('#MainContent');
            this.$stickies = document.querySelectorAll('.tab-sticky'); // 获取所有 tab-sticky 元素

            // 在初始化之前就检查滚动位置，如果不在顶部则直接隐藏 header
            const initialScrollTop = $(window).scrollTop();
            if (initialScrollTop > 0) {
              // 直接隐藏 header，避免任何闪现
              const headerHeight = this.$header ? this.$header.offsetHeight : 0;
              const topValue = headerHeight > 0 ? `-${headerHeight}px` : '-100px';
              this.$headerContainer.css('top', topValue);
              this.$headerContainer.css('position', 'sticky');
              this.$ltHeader.setAttribute('data-scrollShow', false);
              this.$headerLayout.classList.remove('text-white');

              // 检查 data-screen 和 data-defaultscreen 属性
              const dataScreen = this.$ltHeader.getAttribute('data-screen');
              const dataDefaultScreen = this.$ltHeader.getAttribute('data-defaultscreen');

              // 如果 data-screen="true" 和 data-defaultscreen="true" 都为 true，则设置 sticky 定位
              if (dataScreen === 'true' && dataDefaultScreen === 'true') {
                this.$headerContainer.css('position', 'sticky');
              }
            }

            this.init();
            this.currentScreen();
            this.$prevBtn = this.querySelector('.scroll-btn-container .swiper-button-prev');
            this.$nextBtn = this.querySelector('.scroll-btn-container .swiper-button-next');
            this.$scroller = this.querySelector('.menu-list--header-01');

            this.$scrollBtnContainer = this.querySelector('.scroll-btn-container');
            this.$prevBtn.addEventListener('click', () => this.scrollTo('swiper-button-prev'));
            this.$nextBtn.addEventListener('click', () => this.scrollTo('swiper-button-next'));
            if (this.$scroller) {
              this.$scroller.addEventListener('scroll', () => this.updateButtons());
            }

            // 添加鼠标悬浮事件
            if (this.$scrollBtnContainer) {
              this.$scrollBtnContainer.addEventListener('mouseenter', () => {
                const marketingBanner = document.querySelector('marketing-banner[data-default-style="dark"]');
                if (marketingBanner) {
                  this.$ltHeader.setAttribute('data-screen', true);
                } else {
                  this.$ltHeader.setAttribute('data-screen', false);
                }
                this.$headerLayout.classList.remove('text-white');
              });
            }

            // 使用防抖处理 resize 事件
            const debouncedUpdate = debounce(() => {
              requestAnimationFrame(() => {
                if (this.$scroller) {
                  this.updateButtons();
                }
              });
            }, 100);

            window.addEventListener('resize', debouncedUpdate);

            // 初始化时就设置按钮状态
            requestAnimationFrame(() => {
              if (this.$scroller) {
                this.updateButtons();
              }
            });

            // 获取所有导航项
            const navItems = this.querySelectorAll('[data-nav-type]');

            // 为每个导航项添加hover监听
            navItems.forEach((item) => {
              let isInitialized = false;
              const navType = item.dataset.navType;
              const jsUrl = item.dataset.jsUrl;
              const navLaunch = item.querySelector('.nav-launch');

              item.addEventListener('mouseenter', () => {
                // 对于需要加载JS的导航类型
                if (!isInitialized && jsUrl && navLaunch) {
                  litime.initWhenVisible({
                    element: navLaunch,
                    callback: () => {
                      // 动态加载对应的JS文件
                      const script = document.createElement('script');
                      script.src = jsUrl;
                      script.onload = () => {
                        loadNavImages(navType, navLaunch, item);
                      };
                      document.head.appendChild(script);
                    },
                    threshold: 0,
                  });
                  isInitialized = true;
                }
                // 对于不需要加载JS的导航类型
                else if (!isInitialized && navLaunch) {
                  litime.initWhenVisible({
                    element: navLaunch,
                    callback: () => {
                      loadNavImages(navType, navLaunch, item);
                    },
                    threshold: 0,
                  });
                  isInitialized = true;
                }
              });
            });

            // 抽取图片加载逻辑为单独的函数
            const loadNavImages = (navType, navLaunch, currentItem) => {
              // 加载当前导航中的图片
              const lazyImages = navLaunch.querySelectorAll('.nav-lazy-image');
              lazyImages.forEach((img) => {
                if (img.dataset.src) {
                  img.src = img.dataset.src;
                  img.removeAttribute('data-src');
                }
              });
            };

            if (this.$menuContainer && this.$menuContainer.querySelectorAll('li[data-target]').length > 0)
              this.mouseLeaveHandler();

            this.mobilePopupLogin();
          }
          static get observedAttributes() {
            return ['data-theme', 'data-screen'];
          }

          attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue === newValue) return;

            if (name === 'data-screen') {
              if (newValue == 'false') {
                // 确保处理布尔值或字符串
                if (this.$header) {
                  this.$header.classList.add('theme-light-current');
                }

                this.$screen = false;
                return; // 直接退出，不执行后续逻辑
              } else if (newValue == 'true' || newValue == true) {
                this.$screen = true;
                if (this.$header) {
                  this.$header.classList.remove('theme-light-current');
                }
              }
            }

            if ((this.$screen === true || this.$screen === 'true') && name === 'data-theme') {
              if (this.$header) {
                if (name === 'data-theme' && newValue === 'light') {
                  this.$header.classList.remove('theme-dark');
                  this.$header.classList.add('theme-light');
                  this.$headerLayout.classList.remove('text-white');
                  this.$bubbleContainerList.forEach((res) => {
                    const dataLightColor = res.getAttribute('data-light-color').split(',');
                    res.style.background = dataLightColor[0];
                    const leftTriangle = res.querySelector('.left-triangle');
                    const span = res.querySelector('span');
                    if (leftTriangle) {
                      leftTriangle.style.borderRight = `6px solid ${dataLightColor[0]}`;
                    }
                    if (span) {
                      span.style.color = dataLightColor[1];
                    }
                  });
                } else if (name === 'data-theme' && newValue === 'dark' && this.$defaultScreen == 'true') {
                  this.$header.classList.remove('theme-light');
                  this.$header.classList.add('theme-dark');
                  this.$headerLayout.classList.add('text-white');
                  this.$bubbleContainerList.forEach((res) => {
                    const dataDarkColor = res.getAttribute('data-dark-color').split(',');
                    res.style.background = dataDarkColor[0];
                    const leftTriangle = res.querySelector('.left-triangle');
                    const span = res.querySelector('span');
                    if (leftTriangle) {
                      leftTriangle.style.borderRight = `6px solid ${dataDarkColor[0]}`;
                    }
                    if (span) {
                      span.style.color = dataDarkColor[1];
                    }
                  });
                }
              }
            } else if (name === 'data-screen' && (this.$screen === true || this.$screen === 'true')) {
              if (this.$currentInfo.name === 'data-theme' && this.$currentInfo.value === 'light') {
                this.$header.classList.remove('theme-dark');
                this.$header.classList.add('theme-light');
                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  const leftTriangle = res.querySelector('.left-triangle');
                  const span = res.querySelector('span');
                  if (leftTriangle) {
                    leftTriangle.style.borderRight = `6px solid ${dataLightColor[0]}`;
                  }
                  if (span) {
                    span.style.color = dataLightColor[1];
                  }
                });
              } else if (this.$currentInfo.name === 'data-theme' && this.$currentInfo.value === 'dark') {
                this.$header.classList.remove('theme-light');
                this.$header.classList.add('theme-dark');
                this.$bubbleContainerList.forEach((res) => {
                  const dataDarkColor = res.getAttribute('data-dark-color').split(',');
                  res.style.background = dataDarkColor[0];
                  const leftTriangle = res.querySelector('.left-triangle');
                  const span = res.querySelector('span');
                  if (leftTriangle) {
                    leftTriangle.style.borderRight = `6px solid ${dataDarkColor[0]}`;
                  }
                  if (span) {
                    span.style.color = dataDarkColor[1];
                  }
                });
              }
            }
            if (name == 'data-theme') {
              this.$currentInfo = { name: name, value: newValue };
            }
          }
          clearLoadingButtons() {
            const buyNowBtns = document.querySelectorAll('.loading-button');
            buyNowBtns.forEach((btn) => {
              const rotateIcon = btn.querySelector('.rotate_icon');
              if (rotateIcon) {
                rotateIcon.classList.remove('flex');
                rotateIcon.classList.add('hidden');
              }
            });
          }

          currentScreen() {
            this.$screen = this.$ltHeader.getAttribute('data-screen');
            this.$theme = this.$ltHeader.getAttribute('data-theme');
            if (window.location.pathname !== '/') {
              this.$screen = false;
              this.$theme = 'light';
              this.$ltHeader.setAttribute('data-screen', false);
              this.$ltHeader.setAttribute('data-theme', 'light');
            }
            if (this.$screen != 'false' || this.$screen == true) {
              if (this.$theme == 'light') {
                this.$header.classList.remove('theme-dark');
                this.$header.classList.add('theme-light');
                this.$headerLayout.classList.remove('text-white');
                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  const leftTriangle = res.querySelector('.left-triangle');
                  const span = res.querySelector('span');
                  if (leftTriangle) {
                    leftTriangle.style.borderRight = `6px solid ${dataLightColor[0]}`;
                  }
                  if (span) {
                    span.style.color = dataLightColor[1];
                  }
                });
              } else if (this.$theme == 'dark') {
                this.$header.classList.remove('theme-light');
                this.$header.classList.add('theme-dark');
                this.$headerLayout.classList.add('text-white');
                this.$bubbleContainerList.forEach((res) => {
                  const dataDarkColor = res.getAttribute('data-dark-color').split(',');
                  res.style.background = dataDarkColor[0];
                  const leftTriangle = res.querySelector('.left-triangle');
                  const span = res.querySelector('span');
                  if (leftTriangle) {
                    leftTriangle.style.borderRight = `6px solid ${dataDarkColor[0]}`;
                  }
                  if (span) {
                    span.style.color = dataDarkColor[1];
                  }
                });
              }
            } else {
              this.$screen = false;
              this.$header.classList.add('theme-light');
              this.$ltHeader.setAttribute('data-screen', false);
              this.$ltHeader.setAttribute('data-theme', 'light');
              this.$bubbleContainerList.forEach((res) => {
                const dataLightColor = res.getAttribute('data-light-color').split(',');
                res.style.background = dataLightColor[0];
                const leftTriangle = res.querySelector('.left-triangle');
                const span = res.querySelector('span');
                if (leftTriangle) {
                  leftTriangle.style.borderRight = `6px solid ${dataLightColor[0]}`;
                }
                if (span) {
                  span.style.color = dataLightColor[1];
                }
              });
            }
          }

          disconnectedCallback() {
            window.overlayManager.hide('header'); // 确保清理遮罩层
            // 监听窗口大小变化事件
            window.removeEventListener('resize', this.handleResize);
            // 移除事件监听
            this.removeHoverMenuListeners();
            if (this.$observer) {
              this.$observer.disconnect(); // 停止监听
            }
          }

          init() {
            this.mobilePopupFunction();
            // 开启了通屏为透明导航得时候才可以进来
            if (this.$header && this.$header.classList.contains('bg-transparent')) {
            }
            this.scroll();
            this.handleResize();
            this.mobileMenuClick();
            if (this.$ltHeader.getAttribute('data-default-header') == 'header-02') {
              this.updateHeaderHeight(); // 添加初始高度获取
            }
            // 添加header-right-container的鼠标事件
            const headerRightContainer = this.querySelector('.header-right-container');
            if (headerRightContainer) {
              headerRightContainer.addEventListener('mouseenter', () => {
                window.overlayManager.hide('header');
                this.$navflag = false;

                if (window.innerWidth > 1200 && window.location.pathname === '/') {
                  if (this.$scrollShow == true) {
                    if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                      this.$ltHeader.setAttribute('data-screen', true);
                    }
                  }
                  this.$theme = this.$ltHeader.getAttribute('data-theme');
                }
                const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
                navItems.forEach((item) => {
                  item.classList.remove('nav-item-active');
                  const targetSelector = item.querySelector('.nav-launch');
                  if (targetSelector) {
                    targetSelector.classList.remove('nav-hover-active');
                  }
                });
                const navLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
                navLaunches.forEach((launch) => {
                  this.hideNavLaunch(launch);
                });
              });
            }

            if (this.$menuContainer && this.$menuContainer.querySelectorAll('li[data-target]').length > 0) {
              this.mouseLeaveHandler();
            }

            // 监听窗口大小变化
            window.addEventListener('resize', () => {
              if (this.$ltHeader.getAttribute('data-default-header') == 'header-02') {
                this.updateHeaderHeight(); // 添加初始高度获取
              }
              // 当窗口尺寸改变时，重新检查并执行
              if (window.innerWidth >= 1200) {
                // 如果已经执行过 hoverMenuFunction，则不再重复执行
                if (!this.$hasMenuFunctionBeenCalled) {
                  this.handleResize();
                  this.$hasMenuFunctionBeenCalled = true; // 设置标志
                }
              } else {
                window.removeEventListener('resize', this.handleResize);
                this.removeHoverMenuListeners();
                // 如果窗口小于 1200px，可以重置标志，以便窗口重新变大时再次执行
                this.$hasMenuFunctionBeenCalled = false;
              }
            });
          }
          // 添加新方法来更新header高度
          updateHeaderHeight() {
            if (this.$menuContainer) {
              const headerHeight = this.$menuContainer.offsetHeight;
              const navHeaderHeight = this.$navHeader ? this.$navHeader.offsetHeight : 0;

              // 获取所有带有nav-item类的li元素
              const listItems = this.$menuContainer.querySelectorAll('li.nav-item');
              if (listItems.length === 0) return;

              // 获取第一个li元素的offsetTop作为基准
              const firstItemOffsetTop = listItems[0].offsetTop;

              // 检查每个li元素
              listItems.forEach((item, index) => {
                // 如果当前元素的offsetTop大于第一个元素的offsetTop，说明换行了
                const currentOffsetTop = item.offsetTop;
                const isSecondRow = currentOffsetTop > firstItemOffsetTop;

                // 获取nav-launch元素
                const navLaunch = item.querySelector('.nav-launch');
                if (navLaunch) {
                  if (isSecondRow) {
                    item.classList.add('second-row');
                    item.classList.remove('first-row');
                    // 设置第二行nav-launch的top值为nav-header的高度
                    navLaunch.style.top = `${navHeaderHeight}px`;
                  } else {
                    item.classList.add('first-row');
                    item.classList.remove('second-row');
                    // 设置第一行nav-launch的top值为70px
                    navLaunch.style.top = '69px';
                  }
                }
              });
            }
          }
          handleResize() {
            if (window.innerWidth > 1024 && !this.$hasMenuFunctionBeenCalled) {
              this.hoverMenuFunction();
              this.$hasMenuFunctionBeenCalled = true;
            } else {
              this.$hasMenuFunctionBeenCalled = false;
            }
          }

          showNavLaunch(launch) {
            if (!launch) return;
            if (launch._navLaunchShowRaf) {
              cancelAnimationFrame(launch._navLaunchShowRaf);
              launch._navLaunchShowRaf = null;
            }
            launch.classList.remove('navLaunchNo');
            launch.classList.add('navLaunchPreShow');
            launch._navLaunchShowRaf = requestAnimationFrame(() => {
              launch._navLaunchShowRaf = requestAnimationFrame(() => {
                launch._navLaunchShowRaf = null;
                if (launch.classList.contains('navLaunchNo')) return;
                launch.classList.remove('navLaunchPreShow');
                launch.classList.add('navLaunchShow');
              });
            });
          }

          hideNavLaunch(launch) {
            if (!launch) return;
            if (launch._navLaunchShowRaf) {
              cancelAnimationFrame(launch._navLaunchShowRaf);
              launch._navLaunchShowRaf = null;
            }
            launch.classList.remove('navLaunchShow', 'navLaunchPreShow');
            launch.classList.add('navLaunchNo');
          }

          hideAllNavLaunches() {
            if (!this.$menuContainer) return;
            this.$menuContainer.querySelectorAll('.nav-launch').forEach((launch) => {
              this.hideNavLaunch(launch);
            });
          }

          hoverMenuFunction() {
            const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
            this.eventHandlers = []; // 存储事件处理程序
            navItems.forEach((item) => {
              const targetSelector = item.querySelector('.nav-launch');
              const mouseEnterHandler = () => {
                // 确保每次触发前清除所有存在的遮罩层
                this.clearExistingOverlays();

                navItems.forEach((res) => {
                  res.classList.remove('nav-item-active');
                });
                item.classList.add('nav-item-active');

                // 检查 marketing-banner 的 data-default-style
                const marketingBanner = document.querySelector('marketing-banner[data-default-style="dark"]');

                // 只有当存在 dark 模式的 marketing-banner 时才设置 data-screen 为 false
                if (marketingBanner) {
                  this.$header.classList.remove('theme-dark');
                  this.$ltHeader.setAttribute('data-screen', true);
                } else {
                  this.$ltHeader.setAttribute('data-screen', false);
                }

                this.$headerLayout.classList.remove('text-white');
                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                  res.querySelector('span').style.color = dataLightColor[1];
                });
                const dataTarget = item.getAttribute('data-target');
                if (dataTarget !== '.menu-plan-3') {
                  if (this.$MainContent.length > 0) {
                    // 使用全局遮罩层管理器
                    this.$overlay = window.overlayManager.show('header');
                  }

                  // 获取所有的 .nav-launch 元素，并将其全部隐藏
                  this.hideAllNavLaunches();
                  if (!this.$navflag) {
                    // 显示当前菜单项的 .nav-launch
                    if (targetSelector) {
                      this.$navflag = true;
                      this.showNavLaunch(targetSelector);
                    }
                  } else {
                    // 平级切换
                    this.showNavLaunch(targetSelector);
                  }
                } else if (dataTarget === '.menu-plan-3') {
                  window.overlayManager.hide('header'); // 使用全局遮罩层管理器隐藏遮罩层
                  const navLaunch = $('.nav-launch');
                  this.$navflag = false;
                  navItems.forEach((item) => {
                    item.classList.remove('nav-item-active');
                    const targetSelector = item.querySelector('.nav-launch');
                    if (targetSelector) {
                      targetSelector.classList.remove('nav-hover-active');
                    }
                  });
                  navLaunch.each((index, element) => {
                    this.hideNavLaunch(element);
                  });
                }
              };
              item.addEventListener('mouseenter', mouseEnterHandler);
              this.eventHandlers.push({ item, mouseEnterHandler });
            });
          }
          closePopup() {
            window.overlayManager.hide('header');
            this.$navflag = false;

            if (window.innerWidth > 1200 && window.location.pathname === '/') {
              if (this.$scrollShow == true) {
                if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                  this.$ltHeader.setAttribute('data-screen', true);
                }
              }
            }
            const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
            navItems.forEach((item) => {
              item.classList.remove('nav-item-active');
            });
            const navLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
            navLaunches.forEach((launch) => {
              this.hideNavLaunch(launch);
            });
          }
          // 移出事件
          mouseLeaveHandler() {
            customEventListener(this.$headerContainer[0], 'mouseleave', () => {
              window.overlayManager.hide('header');
              this.$navflag = false;

              if (window.innerWidth > 1200 && window.location.pathname === '/') {
                if (this.$scrollShow == true) {
                  if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                    this.$ltHeader.setAttribute('data-screen', true);
                  }
                }
                this.$theme = this.$ltHeader.getAttribute('data-theme');
                if (this.$theme == 'dark') {
                  if (
                    this.$ltHeader.getAttribute('data-screen') == true ||
                    this.$ltHeader.getAttribute('data-screen') == 'true'
                  ) {
                    this.$headerLayout.classList.add('text-white');
                  } else {
                    this.$headerLayout.classList.remove('text-white');
                  }
                } else {
                  this.$headerLayout.classList.remove('text-white');
                }
              }

              const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
              navItems.forEach((item) => {
                item.classList.remove('nav-item-active');
                const targetSelector = item.querySelector('.nav-launch');
                if (targetSelector) {
                  targetSelector.classList.remove('nav-hover-active');
                }
              });
              const navLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
              navLaunches.forEach((launch) => {
                this.hideNavLaunch(launch);
              });

              // 检查是否是 dark 类型的 marketingBanner，如果是则恢复 theme-dark 类
              const marketingBanner = document.querySelector('marketing-banner[data-default-style="dark"]');

              if (marketingBanner && this.$header) {
                this.$header.classList.add('theme-dark');
              }
            });
          }

          // 用于移除事件监听器
          removeHoverMenuListeners() {
            if (this.eventHandlers) {
              this.eventHandlers.forEach(({ item, mouseEnterHandler }) => {
                item.removeEventListener('mouseenter', mouseEnterHandler);
              });
            }
          }

          scroll() {
            // 监听滚动事件
            $(window).on('scroll', () => {
              const currentScrollTop = $(window).scrollTop();

              // 使用 requestAnimationFrame 优化动画性能
              requestAnimationFrame(() => {
                // 检查移动菜单是否打开，如果打开则不修改 top 值
                const mobilePopup = this.querySelector('.mobilePopup');
                const isMobileMenuOpen = mobilePopup && !mobilePopup.classList.contains('hidden');

                if (isMobileMenuOpen) {
                  // 移动菜单打开时，保持 top 为 0
                  this.$headerContainer.css('top', '0');
                  this.$headerContainer.css('position', 'sticky');
                  return;
                }

                // 判断是否有任意 tab-sticky 区域占据顶部
                let anyStickyAtTop = false;
                if (this.$stickies && this.$stickies.length > 0) {
                  this.$stickies.forEach((sticky) => {
                    const rect = sticky.getBoundingClientRect();
                    if (rect.top <= 0 && rect.bottom > 0) {
                      anyStickyAtTop = true;
                    }
                  });
                }

                if (currentScrollTop > this.$lastScrollTop) {
                  // 向下滚动 - 隐藏 header
                  const headerHeight = this.$header ? this.$header.offsetHeight : 0;
                  const topValue = headerHeight > 0 ? `-${headerHeight}px` : '-100px';
                  this.$headerContainer.css('top', topValue);
                  this.$headerContainer.css('position', 'sticky');
                  this.$ltHeader.setAttribute('data-scrollShow', false);
                  this.$headerLayout.classList.remove('text-white');

                  // 检查 data-screen 和 data-defaultscreen 属性
                  const dataScreen = this.$ltHeader.getAttribute('data-screen');
                  const dataDefaultScreen = this.$ltHeader.getAttribute('data-defaultscreen');

                  // 如果 data-screen="true" 和 data-defaultscreen="true" 都为 true，则设置 sticky 定位
                  if (dataScreen === 'true' && dataDefaultScreen === 'true') {
                    this.$headerContainer.css('position', 'sticky');
                  }
                } else {
                  // 向上滚动
                  if (!anyStickyAtTop) {
                    // 如果没有 sticky 区域占据顶部，则显示 header
                    this.$headerContainer.css('top', '0px');
                    this.$headerContainer.css('position', 'sticky');
                    this.$ltHeader.setAttribute('data-scrollShow', true);
                    this.$headerLayout.classList.remove('text-white');
                  } else {
                    // 如果有 sticky 区域占据顶部，则隐藏 header
                    const headerHeight = this.$header ? this.$header.offsetHeight : 0;
                    const topValue = headerHeight > 0 ? `-${headerHeight}px` : '-100px';
                    this.$headerContainer.css('top', topValue);
                    this.$headerContainer.css('position', 'sticky');
                    this.$ltHeader.setAttribute('data-scrollShow', false);
                    this.$headerLayout.classList.remove('text-white');
                  }
                }
                this.$lastScrollTop = currentScrollTop; // 更新上一次的滚动位置
              });

              // 公告栏存在超出公告栏的高度时显示背景颜色
              if (this.announcement.length > 0) {
                if ($(window).scrollTop() > this.announcement.height()) {
                  this.$header.classList.remove('bg-transparent', 'border-transparent');
                  this.$header.classList.add('bg-white', 'header-light');

                  this.$bubbleContainerList.forEach((res) => {
                    const dataLightColor = res.getAttribute('data-light-color').split(',');
                    res.style.background = dataLightColor[0];
                    res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                    res.querySelector('span').style.color = dataLightColor[1];
                  });

                  if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                    this.$ltHeader.setAttribute('data-screen', false);
                    this.$scrollShow = false;
                  }
                  this.$headerLayout.classList.remove('text-white');
                } else {
                  // 如果滚动距离小于阈值，则恢复透明背景
                  this.$header.classList.remove('bg-white', 'header-light', 'light-default');
                  this.$header.classList.add('bg-transparent');
                  if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                    this.$ltHeader.setAttribute('data-screen', true);
                    this.$scrollShow = true;
                  }
                  this.$theme = this.$ltHeader.getAttribute('data-theme');
                  if (this.$theme == 'dark') {
                    if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                      this.$headerLayout.classList.add('text-white');
                    } else {
                      this.$headerLayout.classList.remove('text-white');
                    }
                  } else {
                    this.$headerLayout.classList.remove('text-white');
                  }
                }
              } else if ($(window).scrollTop() > this.$scrollThreshold) {
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white', 'header-light');
                if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                  this.$scrollShow = false;
                  this.$ltHeader.setAttribute('data-screen', false);
                }
                this.$headerLayout.classList.remove('text-white');

                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                  res.querySelector('span').style.color = dataLightColor[1];
                });
              } else {
                if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                  this.$scrollShow = true;
                  this.$ltHeader.setAttribute('data-screen', true);
                }
                this.$theme = this.$ltHeader.getAttribute('data-theme');

                this.$headerLayout.classList.remove('text-white');
                // 如果滚动距离小于阈值，则恢复透明背景
                this.$header.classList.remove('bg-white', 'header-light');
                this.$header.classList.add('bg-transparent');
                this.$header.classList.add('border-transparent');
              }
            });

            // 初始状态设置
            if (this.announcement.length > 0) {
              this.$headerContainer.addClass('header-01-sticky');

              if ($(window).scrollTop() > this.announcement.height()) {
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white', 'header-light', 'light-default');
                this.$ltHeader.setAttribute('data-screen', true);
              } else if ($(window).scrollTop() > this.$scrollThreshold) {
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white');
              }
            } else {
              if ($(window).scrollTop() > this.announcement.height()) {
                this.$headerContainer.addClass('header-01-sticky');

                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white', 'header-light', 'light-default');
              }
              this.$ltHeader.setAttribute('data-screen', true);
            }
          }

          // 打开移动端菜单
          mobileMenuClick() {
            this.$mobileMenu = this.querySelector('.mobileMenu');
            this.$header01 = this.querySelector('#header-01');
            this.$mobileMenuShow = this.querySelector('.mobileMenuShow');
            this.$mobilePopup = this.querySelector('.mobilePopup');
            this.$navHeader = $('.nav-header')[0];
            customEventListener(this.$mobileMenu, 'click', () => {
              if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                this.$screen = false;
                this.$ltHeader.setAttribute('data-screen', false);
              }
              document.body.classList.add('body-mobile-menu-open');
              if (window.litime && window.litime.disableScroll) {
                window.litime.disableScroll('header');
              }
              this.$header.classList.add('theme-light-current');
              if (this.announcement && this.announcement.height() > 0) {
                this.announcement.addClass('hidden');
                this.announcement.removeClass('flex');
              }
              /* 不依赖 height()，部分设备上未完成布局时 height 为 0 会导致加不上 hidden */
              if (this.globalHeaderEnsign && this.globalHeaderEnsign.length) {
                this.globalHeaderEnsign.addClass('hidden');
              }
              this.$mobileMenu.classList.remove('flex');
              this.$mobileMenu.classList.add('hidden');
              this.$mobileMenuShow.classList.remove('hidden');
              this.$mobileMenuShow.classList.add('flex');
              this.$mobilePopup.classList.remove('hidden');
              this.$mobilePopup.classList.add('flex');
              this.$header01.classList.add('mobile-dark');

              this.$navHeader.style.backgroundColor = '#fff';
              const ellipse = this.$navHeader.querySelectorAll('.svg-light svg ellipse');
              const svgPath = this.$navHeader.querySelectorAll('.svg-path');
              if (ellipse) {
                ellipse.forEach((res) => {
                  res.style.stroke = '#191919'; // 使用 style 修改 stroke 颜色
                });
              }
              if (svgPath) {
                svgPath.forEach((res) => {
                  res.style.stroke = '#191919'; // 使用 style 修改 stroke 颜色
                });
              }
              // 重置 headerContainer 的 top 值为 0，并确保 position 为 sticky
              if (this.$headerContainer) {
                this.$headerContainer.css('top', '0');
                this.$headerContainer.css('position', 'sticky');
              }
              this.$header01.classList.add('fixed');
            });
            customEventListener(this.$mobileMenuShow, 'click', () => {
              if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                this.$screen = true;
                this.$ltHeader.setAttribute('data-screen', true);
              }
              const marketingBanner = document.querySelector('marketing-banner[data-default-style="dark"]');
              if (marketingBanner) {
                this.$header.classList.remove('theme-light-current');
                this.$header.classList.add('theme-dark');
              } else {
                this.$header.classList.add('theme-light-current');
              }
              document.body.classList.remove('body-mobile-menu-open');
              this.announcement.removeClass('hidden');
              this.announcement.addClass('flex');

              this.globalHeaderEnsign.removeClass('hidden');

              if (window.litime && window.litime.enableScroll) {
                window.litime.enableScroll();
              }
              this.$mobileMenu.classList.remove('hidden');
              this.$mobileMenu.classList.add('flex');
              this.$navHeader.style.backgroundColor = '';
              this.$mobileMenuShow.classList.remove('flex');
              this.$mobileMenuShow.classList.add('hidden');
              this.$mobilePopup.classList.remove('flex');
              this.$mobilePopup.classList.add('hidden');
              this.$header01.classList.remove('mobile-dark');
              this.$header01.classList.remove('fixed');
              const ellipse = this.$navHeader.querySelectorAll('.svg-light svg ellipse');
              const svgPath = this.$navHeader.querySelectorAll('.svg-path');
              if (ellipse) {
                ellipse.forEach((res) => {
                  res.style.stroke = ''; // 使用 style 修改 stroke 颜色
                });
              }
              if (svgPath) {
                svgPath.forEach((res) => {
                  res.style.stroke = ''; // 使用 style 修改 stroke 颜色
                });
              }
            });

            // 监听窗口大小变化，当宽度大于1024px时自动关闭移动端菜单
            const handleMobileMenuResize = () => {
              if (window.innerWidth > 1024) {
                // 检查移动端菜单是否打开
                if (this.$mobilePopup && this.$mobilePopup.classList.contains('flex')) {
                  // 自动关闭移动端菜单
                  if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                    this.$screen = true;
                    this.$ltHeader.setAttribute('data-screen', true);
                  }

                  const marketingBanner = document.querySelector('marketing-banner[data-default-style="dark"]');
                  if (marketingBanner) {
                    this.$header.classList.remove('theme-light-current');
                    this.$header.classList.add('theme-dark');
                  } else {
                    this.$header.classList.add('theme-light-current');
                  }

                  document.body.classList.remove('body-mobile-menu-open');
                  this.announcement.removeClass('hidden');
                  this.announcement.addClass('flex');
                  this.globalHeaderEnsign.removeClass('hidden');
                  if (window.litime && window.litime.enableScroll) {
                    window.litime.enableScroll();
                  }

                  this.$mobileMenu.classList.remove('hidden');
                  this.$mobileMenu.classList.add('flex');
                  this.$navHeader.style.backgroundColor = '';
                  this.$mobileMenuShow.classList.remove('flex');
                  this.$mobileMenuShow.classList.add('hidden');
                  this.$mobilePopup.classList.remove('flex');
                  this.$mobilePopup.classList.add('hidden');
                  this.$header01.classList.remove('mobile-dark');
                  this.$header01.classList.remove('fixed');

                  const ellipse = this.$navHeader.querySelectorAll('.svg-light svg ellipse');
                  const svgPath = this.$navHeader.querySelectorAll('.svg-path');
                  if (ellipse) {
                    ellipse.forEach((res) => {
                      res.style.stroke = ''; // 重置 stroke 颜色
                    });
                  }
                  if (svgPath) {
                    svgPath.forEach((res) => {
                      res.style.stroke = ''; // 重置 stroke 颜色
                    });
                  }
                }
              }
            };

            // 添加 resize 事件监听器
            window.addEventListener('resize', handleMobileMenuResize);
          }
          mobilePopupFunction() {
            // 获取 mobilePopup 元素

            // 定义 resize 事件处理逻辑
            const resizeHandler = () => {
              // 检查窗口宽度
              if (window.innerWidth > 1200) {
                // 如果宽度大于 1200px，隐藏 mobilePopup 并恢复 body 滚动
                if (this.$mobilePopup) {
                  document.body.classList.remove('body-mobile-menu-open');
                  if (window.litime && window.litime.enableScroll) {
                    window.litime.enableScroll();
                  }
                  this.$mobilePopup.classList.remove('flex');
                  this.$mobilePopup.classList.add('hidden');
                }
                // 移除 resize 事件监听器，因为已经满足了条件
                window.removeEventListener('resize', resizeHandler);
              }
            };
            // 初始调用 resizeHandler，确保页面加载时正确设置
            resizeHandler();
            // 监听 window 的 resize 事件
            window.addEventListener('resize', resizeHandler);
          }
          // 左右切换菜单逻辑
          // 显示/隐藏滚动按钮
          updateButtons() {
            // 检查当前视窗宽度
            const viewportWidth = window.innerWidth;
            const scrollLeft = this.$scroller.scrollLeft;
            const maxScroll = this.$scroller.scrollWidth - this.$scroller.clientWidth;
            // 检查是否需要滚动（内容宽度是否大于容器宽度）
            const needsScroll = this.$scroller.scrollWidth > this.$scroller.clientWidth;

            if (needsScroll) {
              // 显示按钮容器
              this.$scrollBtnContainer.classList.add('show');

              // 先显示两个按钮
              this.$prevBtn.classList.add('show-btn');
              this.$nextBtn.classList.add('show-btn');

              // 检查是否到达边界
              const isAtStart = scrollLeft <= 0;
              const isAtEnd = scrollLeft >= maxScroll;

              // 更新左按钮状态（到达左边界时设置半透明）
              if (isAtStart) {
                this.$prevBtn.style.opacity = '0.4';
                this.$prevBtn.style.pointerEvents = 'none';
              } else {
                this.$prevBtn.style.opacity = '1';
                this.$prevBtn.style.pointerEvents = 'auto';
              }

              // 更新右按钮状态（到达右边界时设置半透明）
              if (isAtEnd) {
                this.$nextBtn.style.opacity = '0.4';
                this.$nextBtn.style.pointerEvents = 'none';
              } else {
                this.$nextBtn.style.opacity = '1';
                this.$nextBtn.style.pointerEvents = 'auto';
              }
            } else {
              // 如果不需要滚动，隐藏整个按钮容器
              this.$scrollBtnContainer.classList.remove('show');
              this.$prevBtn.classList.remove('show-btn');
              this.$nextBtn.classList.remove('show-btn');
              this.$prevBtn.style.pointerEvents = 'none';
              this.$nextBtn.style.pointerEvents = 'none';
            }
          }

          // 滚动处理
          scrollTo(direction) {
            const scrollAmount = 300;
            this.$scroller.scrollBy({
              left: direction === 'swiper-button-prev' ? -scrollAmount : scrollAmount,
              behavior: 'smooth',
            });
          }
          // 左右切换菜单逻辑 end
          // 清除遮罩层的方法
          clearExistingOverlays() {
            window.overlayManager.hide('header'); // 使用全局遮罩层管理器清除遮罩层
          }

          // 移动端弹出登录弹窗
          mobilePopupLogin() {
            const $headerNotLoggedIn = $('#header-not-logged-in');
            const $headerLoggedIn = $('#header-logged-in');
            $headerNotLoggedIn.on('click', (e) => {
              // 获取浏览器宽度
              const viewportWidth = window.innerWidth;
              if (viewportWidth < 1200) {
                e.stopPropagation();
                e.preventDefault();
                const $headerUserIcon = $headerNotLoggedIn.closest('.header-user-icon');
                if ($headerUserIcon.attr('data-show-modal') === 'true') {
                  $headerUserIcon.attr('data-show-modal', 'false');
                } else {
                  $headerUserIcon.attr('data-show-modal', 'true');
                }
              }
            });
            $headerLoggedIn.on('click', (e) => {
              // 获取浏览器宽度
              const viewportWidth = window.innerWidth;
              if (viewportWidth < 1200) {
                e.stopPropagation();
                e.preventDefault();
                const $headerUserIcon = $headerLoggedIn.closest('.header-user-icon');
                if ($headerUserIcon.attr('data-show-modal') === 'true') {
                  $headerUserIcon.attr('data-show-modal', 'false');
                } else {
                  $headerUserIcon.attr('data-show-modal', 'true');
                }
              }
            });
            // 点击其他区域关闭（仅移动端）
            $(document).on('click', (e) => {
              const viewportWidth = window.innerWidth;
              if (viewportWidth < 1200) {
                const function_menu_mobile = $('.function_menu_mobile');
                const $headerUserIcon = function_menu_mobile.closest('.header-user-icon');
                if ($headerUserIcon.attr('data-show-modal') === 'true') {
                  if (
                    e.target.className !== 'function_menu_mobile' &&
                    function_menu_mobile.find(e.target).length === 0
                  ) {
                    $headerUserIcon.attr('data-show-modal', 'false');
                  }
                }
              }
            });
          }

          // 切换站点
          async switchSite(params) {
            const url = '/shopify/auth/change/shop';
            window.litime.showLoading();
            try {
              const res = await window.litime.http.get(url, {
                data: params,
              });
              window.litime.hideLoading();
              if (res.code === 200 && res.data?.mutilpass) {
                window.litime.setLocalStorage('ltToken', res.data.token);
                window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
                window.location.href = res.data.mutilpass;
              }
            } catch (error) {
              window.litime.hideLoading();
              window.litime.showToast('error', window.i18n.request_failed);
            }
          }

          async initCountry() {
            const _this = this;
            const function_menu_country = $(this.querySelector('.function_menu_country'));
            const jump_another_site_modal = $(this.querySelector('.jump-another-site-modal'));
            const customerEmail = function_menu_country.data('customer-email');
            const countryItem = function_menu_country.find('a');
            countryItem.on('click', function (e) {
              if (customerEmail) {
                e.stopPropagation();
                e.preventDefault();
                _this.country = $(this).attr('href');
                window.location.href = _this.country;

                // const site = $(this).data('country');
                // if (site === 'US' || site === 'CA') {
                //   const countryModalText = jump_another_site_modal.find('.country-modal-title').text();
                //   let newCountryModalText = countryModalText;
                //   if (countryModalText.includes('$site$')) {
                //     newCountryModalText = countryModalText.replace('$site$', `<span>${site}</span>`);
                //     jump_another_site_modal.find('.country-modal-title').html(newCountryModalText);
                //   } else {
                //     jump_another_site_modal.find('.country-modal-title').find('span').text(site);
                //   }
                //   jump_another_site_modal.removeClass('hidden');
                // } else {
                //   window.location.href = _this.country;
                // }
              }
            });
            jump_another_site_modal.find('.modal-close').on('click', (e) => {
              jump_another_site_modal.addClass('hidden');
            });
            jump_another_site_modal.find('.modal-confirm').on('click', (e) => {
              jump_another_site_modal.addClass('hidden');
              this.switchSite({
                domain: _this.country,
              });
            });
            jump_another_site_modal.find('.modal-cancel').on('click', (e) => {
              // jump_another_site_modal.addClass('hidden');
              window.litime.setLocalStorage('registe_anther', 1);
              window.location.href = _this.country + '?register=true';
            });

            // 获取logged-login-out
            const loggedLoginOut = $(this.querySelectorAll('.logged-login-out')).find('a');
            loggedLoginOut.on('click', (e) => {
              window.litime.clearLocalStorage('ltToken');
              window.litime.clearLocalStorage('ltUserInfo');
            });

            // 获取url参数
            const urlParams = new URLSearchParams(window.location.search);
            const register = urlParams.get('register');
            if (register) {
              window.litime.eventBus.publish('REGISTER');
              // 不刷新页面清空url参数
              window.history.replaceState({}, '', window.location.pathname);
            }
            const token = urlParams.get('ts');
            if (token) {
              const url = '/shopify/auth/change/shop/info';
              try {
                const res = await window.litime.http.get(url, {
                  data: {
                    ts: token,
                  },
                });
                if (res.code === 200) {
                  window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
                  window.litime.setLocalStorage('ltToken', res.data.token);
                  window.history.replaceState({}, '', window.location.pathname);
                }
              } catch (error) {
                const res = await window.litime.http.get(url, {
                  data: {
                    ts: token,
                  },
                });
                if (res.code === 200) {
                  window.litime.setLocalStorage('ltToken', res.data.token);
                  window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
                  window.history.replaceState({}, '', window.location.pathname);
                }
              }
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-advantage"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('home-advantage')) {
      customElements.define(
        'home-advantage',
        class aboutApplicationScenarios extends HTMLElement {
          swiper = null;
          constructor() {
            super();
          }

          connectedCallback() {
            const _this = this;
            this.init();
            const $advantageBtnItem = $(this.querySelectorAll('.advantage-btn_item'));
            // const $advantageSlideContent = $(this.querySelectorAll('.swiper-slide_content'));
            // $advantageSlideContent.first().removeClass('hidden');
            $advantageBtnItem.first().css('color', 'white').css('background-color', 'black');
            $advantageBtnItem.on('click', function () {
              $advantageBtnItem.css('color', '#191919').css('background-color', 'white');
              $(this).css('color', 'white').css('background-color', 'black');
              _this.swiper.slideToLoop(this.dataset.index);
            });
          }

          init() {
            const $mySwiper = this.querySelector('.home-advantage_swiper');
            const advantagePrev = this.querySelector('.home-advantage_prev');
            const advantageNext = this.querySelector('.home-advantage_next');
            const _this = this;

            this.swiper = new Swiper($mySwiper, {
              loop: true,
              slidesPerView: 3,
              centeredSlides: true,
              speed: 600,
              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
              },
              spaceBetween: 24,
              slidesPerView: 'auto',
              navigation: {
                nextEl: advantageNext,
                prevEl: advantagePrev,
              },
              on: {
                slideChangeTransitionStart: function () {
                  const $currentAdvantageBtnItem = $(_this.querySelector(`[data-index='${this.realIndex}']`));
                  const $advantageBtnItem = $(_this.querySelectorAll('.advantage-btn_item'));
                  $advantageBtnItem.css('color', '#191919').css('background-color', 'white');
                  $currentAdvantageBtnItem.css('color', 'white').css('background-color', 'black');
                  // const $advantageBtnContainer = $(_this.querySelector('.advantage-btn_container'));

                  // 当前按钮滚动到可视范围;
                  const $advantageBtnContainer = $(_this.querySelector('.advantage-btn_container'));
                  // 获取滚动容器的滚动位置
                  const scrollLeft = $advantageBtnContainer.scrollLeft();
                  // 获取目标元素的边界矩形
                  const rect = $currentAdvantageBtnItem.offset();
                  // 获取滚动容器的边界矩形
                  const containerRect = $advantageBtnContainer.offset();
                  // 获取滚动容器的padding 去掉px
                  const containerPadding = $advantageBtnContainer.css('padding-left').replace('px', '');

                  // 计算目标滚动位置
                  const targetScrollLeft =
                    rect.left +
                    scrollLeft -
                    $(window).width() / 2 +
                    $currentAdvantageBtnItem.width() / 2 +
                    +containerPadding;
                  // 执行滚动动画
                  $advantageBtnContainer.animate({ scrollLeft: targetScrollLeft }, 100);

                  // const offset = $currentAdvantageBtnItem.offset().left;
                  // const elementWidth = $currentAdvantageBtnItem.width();
                  // const windowWidth = $(window).width();

                  // $currentAdvantageBtnItem.parent().animate(
                  //   {
                  //     scrollLeft: offset - windowWidth / 2 + elementWidth / 2,
                  //   },
                  //   100
                  // );
                },
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-brand-event-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('home-brand-event-v2')) {
      customElements.define(
        'home-brand-event-v2',
        class HomeProductRecommendationV2 extends HTMLElement {
          connectedCallback() {
            this.initSwiper();
          }

          disconnectedCallback() {
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
          }

          initSwiper() {
            const swiperEl = this.querySelector('.home-brand-event-v2__swiper');
            if (!swiperEl) return;

            const prevEl = this.querySelector('.home-brand-event-v2__navigation--prev');
            const nextEl = this.querySelector('.home-brand-event-v2__navigation--next');
            const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
            if (slideCount <= 1) return;

            this.swiper = new Swiper(swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              watchOverflow: true,
              navigation: {
                prevEl,
                nextEl,
              },
              breakpoints: {
                1201: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
                577: {
                  slidesPerView: 'auto',
                  spaceBetween: 24,
                },
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bulletin-board"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('count-down')) {
      customElements.define(
        'count-down',
        class countDown extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.countdownInterval = setInterval(() => this.updateCountdown(), 1000);
            this.updateCountdown();
          }
          updateCountdown() {
            const $time = $(this).find('.time');
            if (!$time.length) return;
            let time = $time.data('time');
            // 先统一转换格式
            time = time.trim().replace(/\//g, '-');
            const timeFormat = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

            if (!timeFormat.test(time)) {
              $(this).css('display', 'none');
              return;
            }

            const endTime = new Date(time).getTime();
            const now = new Date().getTime();
            const timeDifference = endTime - now;
            if (timeDifference > 0) {
              if ($(this).css('display') !== 'block') {
                $(this).css('display', 'block');
              }
            } else {
              $(this).css('display', 'none');
              clearInterval(this.countdownInterval);
              return;
            }
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            $time.find('.days').text(days.toString().padStart(2, '0'));
            $time.find('.hrs').text(hours.toString().padStart(2, '0'));
            $time.find('.min').text(minutes.toString().padStart(2, '0'));
            $time.find('.sec').text(seconds.toString().padStart(2, '0'));
          }
          disconnectedCallback() {
            clearInterval(this.countdownInterval);
          }
        }
      );
    }
  });

  $(function () {
    if (!customElements.get('home-bulletin-board')) {
      customElements.define(
        'home-bulletin-board',
        class homeBulletinBoard extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }

          init() {
            const $root = $(this).find('.home-bulletin-board');
            const storageKey = $root.data('storage-key');
            const EXPIRE_MS = 30 * 60 * 1000; // 30 分钟过期
            // 默认带 is-closed；若 localStorage 无记录或已过期则显示公告栏
            let shouldShow = true;
            if (storageKey) {
              const stored = localStorage.getItem(storageKey);
              if (stored) {
                const closedAt = parseInt(stored, 10);
                if (!isNaN(closedAt) && Date.now() - closedAt < EXPIRE_MS) {
                  shouldShow = false; // 未过期，保持关闭
                }
              }
            }
            if (shouldShow) {
              $root.removeClass('is-closed');
            }

            $(this)
              .find('.home-bulletin-board__close')
              .on('click', function () {
                if (storageKey) {
                  localStorage.setItem(storageKey, String(Date.now()));
                }
                $root.addClass('is-closed');
              });

            const $mySwiper = $(this).find('.mySwiper');
            const $slides = $(this).find('.swiper-slide');

            if ($slides.length > 1) {
              let maxHeight = 0;
              $slides.each(function () {
                const height = $(this).outerHeight();
                maxHeight = Math.max(maxHeight, height);
              });

              $mySwiper.height(maxHeight);

              const swiper = new Swiper($mySwiper[0], {
                loop: true,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                },
                direction: 'vertical',
              });
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-category"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('home-category')) {
      customElements.define(
        'home-category',
        class aboutApplicationScenarios extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
            this.addResizeListener();
          }

          init() {
            const $mySwiper = this.querySelector('.home-category_swiper');
            const $next = this.querySelector('.home-category_next');
            const $prev = this.querySelector('.home-category_prev');
            const $scrollbar = this.querySelector('.swiper-scrollbar');
            const $mySwiperWidth = $($mySwiper).width();

            const swiper = new Swiper($mySwiper, {
              spaceBetween: 0,
              slidesPerView: 'auto',
              scrollbar: {
                el: $scrollbar,
                draggable: true,
              },
              breakpoints: {
                577: {
                  slidesPerView: 'auto',
                  slidesGroup: 1,
                  spaceBetween: 0,
                },

                0: {
                  slidesPerView: 'auto',
                  spaceBetween: 12,
                  grid: {
                    rows: 2,
                  },
                },
              },
              on: {},
              navigation: {
                nextEl: $next,
                prevEl: $prev,
              },
            });
          }
          addResizeListener() {
            window.addEventListener('resize', () => {
              clearTimeout(this.resizeTimer);
              this.resizeTimer = setTimeout(() => {
                this.init(); // 300ms防抖后重新初始化
              }, 300);
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-media-endorsement-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-media-endorsement-v2')) {
    customElements.define(
      'home-media-endorsement-v2',
      class HomeMediaEndorsementV2 extends HTMLElement {
        connectedCallback() {
          if (typeof Swiper === 'undefined') {
            console.error('[home-media-endorsement-v2] Swiper is not loaded.');
            return;
          }

          this._slideCount = Number(this.dataset.slideCount) || 0;
          this._activeIndex = 0;
          this._ignoreLogoSlideChange = false;
          this._ignoreMainSlideChange = false;
          this._logosEl = this.querySelector('.home-media-endorsement-v2__logos');
          this._logoButtons = Array.from(this.querySelectorAll('.home-media-endorsement-v2__logo'));
          this._progressEl = this.querySelector('.home-media-endorsement-v2__progress');
          this._progressFillEl = this.querySelector('.home-media-endorsement-v2__progress-fill');
          this._boundClickHandler = this._handleLogoClick.bind(this);

          this._init();
          this._onResize = () => {
            if (this._logoSwiper) {
              this._logoSwiper.update();
              this._runWithoutLogoSlideHandler(() => {
                this._logoSwiper.slideTo(this._activeIndex, 0);
              });
            }
            this._syncQuoteHeight();
          };
          window.addEventListener('resize', this._onResize);
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this._onResize);
          if (this._logosEl) {
            this._logosEl.removeEventListener('click', this._boundClickHandler);
          }
          this._destroy();
        }

        _destroy() {
          if (this._mainSwiper) {
            this._mainSwiper.destroy(true, true);
            this._mainSwiper = null;
          }
          if (this._logoSwiper) {
            this._logoSwiper.destroy(true, true);
            this._logoSwiper = null;
          }
        }

        _isCenterLayout() {
          return window.matchMedia('(max-width: 960px)').matches;
        }

        _runWithoutLogoSlideHandler(callback) {
          this._ignoreLogoSlideChange = true;
          callback();
          const release = () => {
            this._ignoreLogoSlideChange = false;
          };
          if (this._logoSwiper?.animating) {
            this._logoSwiper.once('transitionEnd', release);
          } else {
            release();
          }
        }

        _runWithoutMainSlideHandler(callback) {
          this._ignoreMainSlideChange = true;
          callback();
          const release = () => {
            this._ignoreMainSlideChange = false;
          };
          if (this._mainSwiper?.animating) {
            this._mainSwiper.once('transitionEnd', release);
          } else {
            release();
          }
        }

        _applyActiveIndex(newIndex, speed, source) {
          const normalized = Math.max(0, Math.min(newIndex, this._slideCount - 1));
          if (normalized === this._activeIndex) return;

          this._activeIndex = normalized;
          this._setActiveLogo(normalized);
          this._resetAutoplayProgress();

          if (source !== 'logo' && this._logoSwiper) {
            this._runWithoutLogoSlideHandler(() => {
              this._logoSwiper.slideTo(normalized, speed ?? this._logoSwiper.params.speed);
            });
          }

          if (source !== 'main' && this._mainSwiper) {
            this._runWithoutMainSlideHandler(() => {
              this._mainSwiper.slideTo(normalized, speed ?? this._mainSwiper.params.speed);
            });
          }
        }

        _setActiveLogo(index) {
          this._logoButtons.forEach((btn) => {
            const isActive = Number(btn.dataset.index) === index;
            btn.classList.toggle('home-media-endorsement-v2__logo--active', isActive);
            btn.dataset.active = isActive ? 'true' : 'false';
          });
        }

        _resetAutoplayProgress() {
          if (!this._progressFillEl) return;
          this._progressFillEl.style.setProperty('--progress-scale', '0');
        }

        _updateAutoplayProgress(progress) {
          if (!this._progressFillEl || !this._isCenterLayout()) return;
          const scale = Math.max(0, Math.min(1, 1 - progress));
          this._progressFillEl.style.setProperty('--progress-scale', String(scale));
        }

        _syncProgressVisibility(autoplayEnabled, hasMultipleSlides) {
          if (!this._progressEl) return;
          this._progressEl.classList.toggle(
            'home-media-endorsement-v2__progress--hidden',
            !autoplayEnabled || !hasMultipleSlides
          );
        }

        _goTo(index) {
          const normalized = Math.max(0, Math.min(index, this._slideCount - 1));
          if (normalized === this._activeIndex) return;

          if (this._mainSwiper) {
            this._mainSwiper.slideTo(normalized);
          }
        }

        _handleLogoClick(event) {
          const btn = event.target.closest('.home-media-endorsement-v2__logo');
          if (!btn) return;
          const index = Number(btn.dataset.index);
          if (Number.isNaN(index) || index === this._activeIndex) return;
          this._goTo(index);
        }

        _syncQuoteHeight() {
          const mainEl = this.querySelector('.home-media-endorsement-v2__main');
          if (!mainEl || this._slideCount <= 0) return;

          const panels = mainEl.querySelectorAll('.home-media-endorsement-v2__panel');
          if (!panels.length) return;

          const measureWidth = mainEl.clientWidth || mainEl.getBoundingClientRect().width;
          let maxHeight = 0;

          panels.forEach((panel) => {
            const measurer = document.createElement('div');
            measurer.style.cssText = [
              'position:absolute',
              'visibility:hidden',
              'pointer-events:none',
              'width:' + measureWidth + 'px',
              'left:-9999px',
              'top:0',
            ].join(';');
            measurer.appendChild(panel.cloneNode(true));
            mainEl.appendChild(measurer);
            maxHeight = Math.max(maxHeight, measurer.offsetHeight);
            mainEl.removeChild(measurer);
          });

          mainEl.style.minHeight = maxHeight + 'px';
          mainEl.style.setProperty('--quote-min-height', maxHeight + 'px');

          if (this._mainSwiper) {
            this._mainSwiper.update();
          }
        }

        _initLogoSwiper(hasMultipleSlides, speed) {
          const logoSwiperEl = this.querySelector('.home-media-endorsement-v2__logos-swiper');
          if (!logoSwiperEl) return;

          this._logoSwiper = new Swiper(logoSwiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            centeredSlides: false,
            speed: speed,
            allowTouchMove: hasMultipleSlides,
            watchOverflow: true,
            breakpoints: {
              961: {
                spaceBetween: 56,
              },
              577: {
                spaceBetween: 32,
              },
              0: {
                spaceBetween: 32,
              },
            },
          });

          this._logoButtons.forEach((btn) => {
            const img = btn.querySelector('img');
            if (!img) return;
            const refreshLogoSwiper = () => {
              if (this._logoSwiper) {
                this._logoSwiper.update();
              }
            };
            if (img.complete) return;
            img.addEventListener('load', refreshLogoSwiper, { once: true });
          });
        }

        _init() {
          this._destroy();

          const mainEl = this.querySelector('.home-media-endorsement-v2__main');
          const prevEl = this.querySelector('.home-media-endorsement-v2__nav-btn--prev');
          const nextEl = this.querySelector('.home-media-endorsement-v2__nav-btn--next');

          if (!mainEl || this._slideCount <= 0) return;

          const hasMultipleSlides = this._slideCount > 1;
          const speed = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400;
          const autoplayEnabled =
            this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const autoplayDelay = Number(this.dataset.autoplayDelay) || 5000;

          this._syncProgressVisibility(autoplayEnabled, hasMultipleSlides);

          this._initLogoSwiper(hasMultipleSlides, speed);

          this._mainSwiper = new Swiper(mainEl, {
            initialSlide: 0,
            loop: false,
            watchOverflow: true,
            speed: speed,
            allowTouchMove: hasMultipleSlides,
            autoplay: autoplayEnabled
              ? {
                  delay: autoplayDelay,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                  stopOnLastSlide: false,
                }
              : false,
            navigation:
              hasMultipleSlides && prevEl && nextEl
                ? {
                    prevEl: prevEl,
                    nextEl: nextEl,
                  }
                : undefined,
            on: {
              slideChange: (swiper) => {
                if (this._ignoreMainSlideChange) return;
                this._applyActiveIndex(swiper.activeIndex, speed, 'main');
              },
              autoplayTimeLeft: (_swiper, _timeLeft, progress) => {
                this._updateAutoplayProgress(progress);
              },
            },
          });

          this._resetAutoplayProgress();

          if (this._logosEl) {
            this._logosEl.removeEventListener('click', this._boundClickHandler);
            this._logosEl.addEventListener('click', this._boundClickHandler);
          }

          this._activeIndex = 0;
          this._setActiveLogo(0);
          this._syncQuoteHeight();
          requestAnimationFrame(() => {
            this._syncQuoteHeight();
            if (this._logoSwiper) {
              this._logoSwiper.update();
              this._runWithoutLogoSlideHandler(() => {
                this._logoSwiper.slideTo(this._activeIndex, 0);
              });
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-media-endorsement"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('home-media-endorsement')) {
      customElements.define(
        'home-media-endorsement',
        class homeMediaEndorsement extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.initSwiper();
          }

          initSwiper() {
            const $this = $(this);
            const $imageContainers = $this.find('.media-logo');
            const $mainSwiper = $this.find('.my-swiper');

            // 如果没有图片或只有一张图片，则不初始化 swiper
            if ($imageContainers.length <= 1) return;

            this.swiper = new Swiper($mainSwiper[0], {
              loop: true,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              navigation: {
                nextEl: $this.find('.swiper-button-next')[0],
                prevEl: $this.find('.swiper-button-prev')[0],
              },
              on: {
                slideChange: (swiper) => {
                  // 重置所有图片容器的背景色
                  $imageContainers.css('backgroundColor', 'transparent');
                  // 设置当前激活slide对应的图片容器背景色
                  $imageContainers.eq(swiper.realIndex).css('backgroundColor', 'var(--theme-color-10)');
                },
                init: function () {
                  // 初始化时设置第一个图片容器的背景色
                  $imageContainers.first().css('backgroundColor', 'var(--theme-color-10)');
                },
              },
            });

            // 添加点击事件
            $imageContainers.on('click', (e) => {
              const index = $(e.currentTarget).index();
              this.swiper.slideToLoop(index);
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-official-welfare-static"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('home-official-welfare')) {
      customElements.define(
        'home-official-welfare',
        class HomeOfficialWelfare extends HTMLElement {
          constructor() {
            super();
            this.init();
          }
          init() {
            const $items = $(this).find('.welfare-item');
            this.$dialog = $(this).find('dialog-simple');
            // 检查每个item的desc属性
            $items.each(function () {
              const $item = $(this);
              if (!$item.attr('data-desc')) {
                $item.css('pointer-events', 'none');
              }
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-official-welfare"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('home-official-welfare')) {
      customElements.define(
        'home-official-welfare',
        class HomeOfficialWelfare extends HTMLElement {
          constructor() {
            super();
            this.init();
          }
          init() {
            const $items = $(this).find('.welfare-item');
            this.$dialog = $(this).find('dialog-simple');
            // 检查每个item的desc属性
            $items.each(function () {
              const $item = $(this);
              if (!$item.attr('data-desc')) {
                $item.css('pointer-events', 'none');
              }
            });
            $items.on('click', (e) => {
              const $item = $(e.currentTarget);
              this.$dialog.attr({
                'data-show': 'true',
                'data-title': $item.attr('data-title'),
                'data-desc': $item.attr('data-desc'),
                'data-button-text': $item.attr('data-button-text'),
                'data-button-link': $item.attr('data-button-link'),
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-list"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('home-product-list')) {
      customElements.define(
        'home-product-list',
        class homeProductList extends HTMLElement {
          productDetailModalBigPictrueSwiper = null;
          productDetailModalSmallPictrueSwiper = null;
          shopMoneyFormat = null;
          productInventoryQuantity = null;
          productDetailModalCopy = null;
          constructor() {
            super();
          }

          connectedCallback() {
            const _this = this;

            this.init();
            this.initPopup();
            this.openQuickViewButton();
            this.initProductGrid();
            const hoverWidth = $(this).find('.hover-width');
            hoverWidth.on('mouseenter', function () {
              const $actionText = $(this).find('.home-product-list__action-text');
              if ($actionText.length > 0) {
                // 显示文本
                $actionText.show();

                // 获取自动宽度
                $(this).css('width', 'auto');
                const autoWidth = $(this).width();
                $(this).css('width', '32px');

                if (window.innerWidth > 1200) {
                  // 动画展开
                  setTimeout(() => {
                    $(this).css('width', `${autoWidth}px`);
                  }, 10);
                }
              }
            });
            hoverWidth.on('mouseout', function () {
              const $actionText = $(this).find('.home-product-list__action-text');
              if ($actionText.length > 0) {
                setTimeout(() => {
                  if (!$(this).is(':hover')) {
                    $actionText.hide();
                    $(this).css('width', '32px');
                  }
                }, 50);
              }
            });

            this.shopMoneyFormat = window.shopMoneyFormat;

            // 获取所有data-product-handle的元素
            const $productHandles = $(this).find('[data-product-handle]');
            let $productDetailModal = $(this).find('.product-detail-modal');
            this.productDetailModalCopy = $productDetailModal.clone();

            $productHandles.on('click', function (event) {
              event.preventDefault();
            });

            const addCartButton = $(this).find('[data-first_variant_id]').find('[type="submit"]');
            addCartButton.on('click', function (event) {
              // 阻止默认事件
              event.preventDefault();
              // 获取index
              const index = $(_this).find('[data-first_variant_id]').find('[type="submit"]').index(this);
              const dataFirstVariantId = $(_this).find('[data-first_variant_id]').eq(index).data('first_variant_id');
              const skuCount = $(_this).find('[data-first_variant_id]').eq(index).data('sku-count');
              const inventoryPolicy = $(_this).find('[data-first_variant_id]').eq(index).data('inventory-policy');
              const view = $(_this).find('[data-first_variant_id]').eq(index).data('view');
              if (skuCount > 1) {
                // 判断预售逻辑  end
                // 找到最外层的swiper-slide
                const $swiperSlide = $(this).closest('.swiper-slide');
                const $productHandle = $swiperSlide.find('[data-product-handle]');
                // _this.openProductDetailModal($productHandle[0], inventoryPolicy, view);
              } else {
                if (view === 'add_to_cart') {
                  $(this).find('i').removeClass('hidden').addClass('flex');
                  $(this).find('.loading-button-text').addClass('hidden').removeClass('flex');
                }
              }
            });
          }
          openQuickViewButton() {
            this.addEventListener('click', (e) => {
              const btn = e.target.closest('.open-product-detail-modal');
              if (!btn) return;

              e.preventDefault();
              e.stopPropagation();

              // 从点击的按钮元素获取相关数据
              const productHandle = btn.getAttribute('data-product-handle');
              const inventoryPolicy = btn.getAttribute('data-inventory-policy');
              const view = btn.getAttribute('data-view');

              this.openProductDetailModal(btn, inventoryPolicy, view);
            });
          }

          openProductDetailModal(element, inventoryPolicy, view) {
            const _this = this;
            const productHandle = $(element).data('product-handle');

            if (
              window.litime.tryOpenProductModalV2?.(productHandle, undefined, {
                onBefore: () => window.litime.showLoading(false),
                onFinally: () => window.litime.hideLoading(false),
              })
            ) {
              return;
            }

            // 禁用浏览器滚动
            window.litime.disableScroll();
            window.litime.showLoading(false);
            // 请求productHandle
            fetch(`/products/${productHandle}?view=modal`)
              .then((response) => {
                if (response.status === 200) {
                  return response.text();
                } else {
                  throw new Error('Network response was not ok');
                }
              })
              .then((responseText) => {
                const html = responseText;
                _this.renderProductDetailModal(html, inventoryPolicy, view, element);
              })
              .finally(() => {
                window.litime.hideLoading(false);
              });
          }

          renderProductDetailModal(html, inventoryPolicy, view, element) {
            const _this = this;
            const quickshopPopup = new DOMParser()
              .parseFromString(html, 'text/html')
              .getElementById('quickshop-popup')?.innerHTML;
            // let app = document.querySelector('.product-detail-modal_wrapper');
            const $productDetailModal = $('#global-product-card-popup');
            $productDetailModal.html(quickshopPopup);
            try {
              const preferType = element && element.getAttribute('data-global-preferential-type');
              const popupEl = $productDetailModal.find('product-detail-data-popup')[0];
              if (popupEl && preferType) {
                popupEl.setAttribute('data-global-preferential-type', preferType);
              }

              if (popupEl && popupEl.applyPreferentialMode) {
                popupEl.applyPreferentialMode();
              }
            } catch (e) {
              console.warn('set data-global-preferential-type failed:', e);
            }
            let modalWrapper = $productDetailModal.find('.product-detail-modal_wrapper');
            // 判断预售逻辑 start
            if (inventoryPolicy === 'continue' && view === 'buy_now_to_cart') {
              let $preOrderButton = modalWrapper
                .find('.product-detail-popup_button')
                .find('.buy-now-btn-card-button-popup');

              $preOrderButton.removeClass('hidden').addClass('flex');
              const $preOrderSubmitButton = modalWrapper
                .find('.product-detail-popup_form_wrapper')
                .find('.buy-now-btn-card-submit-button');
              $preOrderSubmitButton.addClass('hidden').removeClass('flex');
            } else {
              let $preOrderButton = modalWrapper
                .find('.product-detail-popup_form_wrapper')
                .find('.buy-now-btn-card-button-popup');
              $preOrderButton.addClass('hidden').removeClass('flex');
              const $preOrderSubmitButton = modalWrapper
                .find('.product-detail-popup_form_wrapper')
                .find('.buy-now-btn-card-submit-button');
              $preOrderSubmitButton.removeClass('hidden').addClass('flex');
            }

            const priceElsBottom = document.querySelectorAll(
              '.product-detail-popup_footer-price, .product-detail-popup_button .product-detail-popup_price'
            );
            priceElsBottom.forEach((item) => {
              item.setAttribute(
                'data-popup-global-preferential-type',
                element && element.getAttribute('data-global-preferential-type')
              );
            });
          }

          init() {
            const displayMode = this.getAttribute('data-display-mode');

            // 只有在 slid 模式下才初始化 Swiper
            if (displayMode === 'slid') {
              const $mySwiper = this.querySelector('.home-product-list__swiper');
              const $next = this.querySelector('.home-product-list__navigation--next');
              const $prev = this.querySelector('.home-product-list__navigation--prev');
              const $pagination = this.querySelector('.home-product-list__pagination');
              const $scrollbar = this.querySelector('.home-product-list__scrollbar-inner');

              if ($mySwiper) {
                const swiper = new Swiper($mySwiper, {
                  slidesPerView: 'auto',
                  slidesPerGroup: 4,
                  spaceBetween: 24,
                  breakpoints: {
                    1201: {
                      slidesPerView: 'auto',
                      slidesPerGroup: 4,
                    },
                    1200: {
                      slidesPerView: 'auto',
                      slidesPerGroup: 1,
                    },
                    577: {
                      slidesPerView: 'auto',
                      slidesPerGroup: 1,
                    },
                    0: {
                      slidesPerView: 'auto',
                      slidesPerGroup: 1,
                    },
                  },
                  on: {
                    slideChange: function () {
                      if ($prev) {
                        if (this.isBeginning) {
                          $($prev).removeClass('flex').addClass('hidden');
                        } else {
                          $($prev).removeClass('hidden').addClass('flex');
                        }
                      }
                      if ($next) {
                        if (this.isEnd) {
                          $($next).addClass('hidden');
                        } else {
                          $($next).removeClass('hidden');
                        }
                      }
                    },
                  },
                  navigation:
                    $next || $prev
                      ? {
                          nextEl: $next || null,
                          prevEl: $prev || null,
                        }
                      : false,
                  scrollbar: $scrollbar
                    ? {
                        el: $scrollbar,
                        draggable: true,
                      }
                    : false,
                  pagination: $pagination
                    ? {
                        el: $pagination,
                        bulletClass: 'home-product-list__bullet',
                        bulletActiveClass: 'home-product-list__bullet-active',
                      }
                    : false,
                });
              }
            }
          }

          initPopup() {
            const _this = this;
            const submitButton = $(this.querySelector('.product-detail-popup_form_wrapper')).find(
              'button[type="submit"]'
            );
            this.productDetailModalWrapperCopy = $(this).find('.product-detail-modal_wrapper').clone();
            submitButton.on('click', function (event) {
              event.preventDefault();
              const productVariantId = $(_this.querySelector('.product-variant_active')).data('product-variant-id');
              // 获取type为number的input
              const inputNumber = $(_this.querySelector('.global-number_input'));
              const quantity = inputNumber.val();
              $(this).find('i').removeClass('hidden').addClass('flex');
              $(this).find('.loading-button-text').addClass('hidden').removeClass('flex');
            });
          }

          /**
           * 获取响应式网格配置
           * 根据屏幕宽度返回每行显示数量和每次加载数量
           */
          _getGridStep() {
            const w = window.innerWidth;
            const pcRows = parseInt(this.getAttribute('data-pc-count') || '1', 10);
            const padRows = parseInt(this.getAttribute('data-pad-count') || '1', 10);
            const smallPadRows = parseInt(this.getAttribute('data-small-pad-count') || '1', 10);
            const mobileRows = parseInt(this.getAttribute('data-mobile-count') || '1', 10);

            // data-*-count 表示「默认显示行数」，init = 行数 × 每行个数，这样设置 1 时只显示 1 排
            if (w >= 1201) {
              return { perRow: 4, step: 4, init: pcRows * 4 };
            } else if (w >= 961) {
              return { perRow: 3, step: 3, init: padRows * 3 };
            } else if (w >= 577) {
              return { perRow: 2, step: 4, init: smallPadRows * 2 };
            } else {
              return { perRow: 1, step: 4, init: mobileRows * 1 };
            }
          }

          /**
           * 初始化产品网格功能
           * 处理 down 模式下的响应式显示和点击加载更多
           */
          initProductGrid() {
            const displayMode = this.getAttribute('data-display-mode');

            // 只有在 down 模式下才初始化产品网格
            if (displayMode !== 'down') {
              return;
            }

            const grid = this.querySelector('.home-product-list__grid');
            const more = this.querySelector('.home-product__grid_more');

            if (!grid || !more) {
              return;
            }

            const { step, init } = this._getGridStep();
            const total = grid.querySelectorAll('.home-product__grid_item').length;
            const initVisible = Math.min(init, total);

            grid.dataset.visibleCount = String(initVisible);

            // 按 init 数量应用可见性：前 initVisible 个显示，其余隐藏（与 pcRows=1 只显示 1 排一致）
            this._applyGridVisibility(grid, more, false);

            // 移除之前的事件监听器，避免重复绑定
            if (this._handleMoreClick) {
              more.removeEventListener('click', this._handleMoreClick);
            }

            // 绑定点击事件
            this._handleMoreClick = (e) => {
              e.preventDefault();
              const { step } = this._getGridStep();
              const total = grid.querySelectorAll('.home-product__grid_item').length;
              const current = parseInt(grid.dataset.visibleCount || '0', 10) || 0;
              const next = Math.min(current + step, total);
              grid.dataset.visibleCount = String(next);
              this._applyGridVisibility(grid, more, true);
            };

            more.addEventListener('click', this._handleMoreClick);
          }

          /**
           * 确保初始可见性状态正确
           * @param {HTMLElement} grid - 网格容器
           * @param {number} initVisible - 初始可见数量
           */
          _ensureInitialVisibility(grid, initVisible) {
            const items = Array.from(grid.querySelectorAll('.home-product__grid_item'));

            items.forEach((el, idx) => {
              if (idx < initVisible) {
                el.classList.remove('hidden', 'max-lg:hidden', 'max-md:hidden');
                el.classList.add('flex');
              } else {
                el.classList.remove('flex');
              }
            });
          }

          /**
           * 更新"更多"按钮的可见性
           * @param {HTMLElement} grid - 网格容器
           * @param {HTMLElement} more - 更多按钮
           */
          _updateMoreButtonVisibility(grid, more) {
            const total = grid.querySelectorAll('.home-product__grid_item').length;
            const visible = parseInt(grid.dataset.visibleCount || '0', 10) || 0;

            // 控制按钮显隐：隐藏时加 hidden 并去掉 flex，显示时去掉 hidden 并加 flex
            if (visible >= total) {
              more.classList.add('hidden');
              more.classList.remove('flex');
            } else {
              more.classList.remove('hidden');
              more.classList.add('flex');
            }
          }

          /**
           * 应用网格可见性
           * @param {HTMLElement} grid - 网格容器
           * @param {HTMLElement} more - 更多按钮
           * @param {boolean} smooth - 是否平滑过渡
           */
          _applyGridVisibility(grid, more, smooth) {
            const items = Array.from(grid.querySelectorAll('.home-product__grid_item'));
            const total = items.length;
            const visible = Math.min(parseInt(grid.dataset.visibleCount || '0', 10) || 0, total);

            items.forEach((el, idx) => {
              if (idx < visible) {
                el.classList.remove('hidden', 'max-lg:hidden', 'max-md:hidden');
                el.classList.add('flex');
              } else {
                el.classList.add('hidden');
                el.classList.remove('flex');
              }
            });

            // 控制按钮显隐：隐藏时加 hidden 并去掉 flex，显示时去掉 hidden 并加 flex
            if (visible >= total) {
              more.classList.add('hidden');
              more.classList.remove('flex');
            } else {
              more.classList.remove('hidden');
              more.classList.add('flex');
            }
          }

          destroy() {
            // 恢复浏览器滚动
            window.litime.enableScroll();
            if (this.productDetailModalSmallPictrueSwiper) {
              this.productDetailModalSmallPictrueSwiper.destroy();
            }
            if (this.productDetailModalBigPictrueSwiper) {
              this.productDetailModalBigPictrueSwiper.destroy();
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-recommendation-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-product-recommendation-v2')) {
    customElements.define(
      'home-product-recommendation-v2',
      class HomeProductRecommendationV2 extends HTMLElement {
        static MOBILE_HOVER_MQ = '(max-width: 576px)';
        static MOBILE_HOVER_INTERVAL = 3000;

        connectedCallback() {
          this.mobileHoverCarouselItems = [];
          this.initSwiper();
          this.initMobileHoverCarousel();
        }

        disconnectedCallback() {
          this.destroySwiper();
          this.destroyMobileHoverCarousel();
        }

        initSwiper() {
          const swiperEl = this.querySelector('.home-product-recommendation-v2__swiper');
          if (!swiperEl) return;

          const prevEl = this.querySelector('.home-product-recommendation-v2__nav-btn--prev');
          const nextEl = this.querySelector('.home-product-recommendation-v2__nav-btn--next');
          const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
          const $scrollbar = this.querySelector('.home-product-recommendation-v2__scrollbar-inner');
          if (slideCount <= 1) return;

          this.swiper = new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            watchOverflow: true,
            navigation: {
              prevEl,
              nextEl,
            },
            scrollbar: {
              el: $scrollbar,
              draggable: true,
            },
            breakpoints: {
              1201: {
                slidesPerView: 4,
                spaceBetween: 16,
              },
            },
          });
        }

        destroySwiper() {
          if (!this.swiper) return;
          this.swiper.destroy(true, true);
          this.swiper = null;
        }

        initMobileHoverCarousel() {
          this.mobileHoverMq = window.matchMedia(HomeProductRecommendationV2.MOBILE_HOVER_MQ);
          this.onMobileHoverMqChange = () => {
            if (this.mobileHoverMq.matches) {
              this.setupMobileHoverCarousel();
            } else {
              this.teardownMobileHoverCarousel();
            }
          };

          this.mobileHoverMq.addEventListener('change', this.onMobileHoverMqChange);
          if (this.mobileHoverMq.matches) {
            this.setupMobileHoverCarousel();
          }
        }

        setupMobileHoverCarousel() {
          this.teardownMobileHoverCarousel(false);

          const medias = this.querySelectorAll('.home-product-recommendation-v2-card__media--has-hover');
          if (!medias.length) return;

          this.mobileHoverObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const item = this.mobileHoverCarouselItems.find(({ media }) => media === entry.target);
                if (!item) return;

                if (entry.isIntersecting) {
                  item.start();
                } else {
                  item.stop();
                }
              });
            },
            {
              root: null,
              threshold: 0.35,
            }
          );

          medias.forEach((media) => {
            const item = {
              media,
              timer: null,
              showingHover: false,
              start: () => {
                if (item.timer) return;
                item.timer = window.setInterval(() => {
                  item.showingHover = !item.showingHover;
                  media.classList.toggle('home-product-recommendation-v2-card__media--show-hover', item.showingHover);
                }, HomeProductRecommendationV2.MOBILE_HOVER_INTERVAL);
              },
              stop: () => {
                if (item.timer) {
                  window.clearInterval(item.timer);
                  item.timer = null;
                }
                item.showingHover = false;
                media.classList.remove('home-product-recommendation-v2-card__media--show-hover');
              },
            };

            this.mobileHoverCarouselItems.push(item);
            this.mobileHoverObserver.observe(media);
          });
        }

        teardownMobileHoverCarousel(clearMqListener = true) {
          this.mobileHoverCarouselItems.forEach((item) => item.stop());
          this.mobileHoverCarouselItems = [];

          if (this.mobileHoverObserver) {
            this.mobileHoverObserver.disconnect();
            this.mobileHoverObserver = null;
          }

          this.querySelectorAll('.home-product-recommendation-v2-card__media--show-hover').forEach((media) => {
            media.classList.remove('home-product-recommendation-v2-card__media--show-hover');
          });

          if (clearMqListener && this.mobileHoverMq && this.onMobileHoverMqChange) {
            this.mobileHoverMq.removeEventListener('change', this.onMobileHoverMqChange);
            this.mobileHoverMq = null;
            this.onMobileHoverMqChange = null;
          }
        }

        destroyMobileHoverCarousel() {
          this.teardownMobileHoverCarousel(true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-swiper-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('home-swiper-v2')) {
      customElements.define(
        'home-swiper-v2',
        class HomeSwiper extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          animateText($elements) {
            $elements.each(function (index) {
              const $this = $(this);
              setTimeout(function () {
                $this.css({
                  opacity: 1,
                  transform: 'translateY(0) translateZ(0)',
                  transition: 'opacity .6s linear .3s,transform .6s cubic-bezier(.215,.61,.355,1) .3s',
                });
              }, index * 100);
            });
          }
          init() {
            const self = this;
            const root = $(this);
            const $slides = root.find('.swiper-slide');
            if ($slides.length === 0) return;
            if ($slides.length > 1) {
              const initSwiper = () => {
                const swiperEle = root.find('.home-swiper-v2')[0];
                const $pagination = root.find('.swiper-pagination');
                const isAutoplay = swiperEle.getAttribute('data-autoplay') === 'true';
                const autoplayDelay = swiperEle.getAttribute('data-autoplay-delay');
                new Swiper(swiperEle, {
                  loop: true,
                  speed: 600,
                  fadeEffect: {
                    crossFade: true,
                  },
                  autoplay: isAutoplay
                    ? {
                        delay: autoplayDelay,
                        disableOnInteraction: false,
                      }
                    : false,
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                  },
                  preloadImages: false,
                  lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1,
                    loadOnTransitionStart: true,
                  },
                  on: {
                    init: function () {
                      const $elements = $(this.slides[0]).find('.home-swiper-v2__text');
                      self.animateText($elements);

                      setTimeout(() => {
                        $pagination
                          .find('.swiper-pagination-bullet-active')
                          .addClass('home-swiper-v2-pagination-bullet__active');
                      }, 0);
                    },
                    slideChangeTransitionStart: function () {
                      const $previousIndex = $(this.slides[this.previousIndex]);
                      $previousIndex.find('.home-swiper-v2__text').css({
                        opacity: 0,
                        transform: 'translateY(-60px)',
                        transition: 'none',
                      });

                      const $currentIndex = $(this.slides[this.activeIndex]);
                      const $elements = $currentIndex.find('.home-swiper-v2__text');
                      self.animateText($elements);

                      $pagination
                        .find('.swiper-pagination-bullet')
                        .removeClass('home-swiper-v2-pagination-bullet__active');
                      $pagination
                        .find('.swiper-pagination-bullet-active')
                        .addClass('home-swiper-v2-pagination-bullet__active');

                      // 切换头部导航主题
                      const theme = $(this.slides[this.activeIndex]).attr('data-theme');
                      $('#lt-header-v2').attr('data-theme', theme);
                    },
                  },
                });
              };
              initSwiper();
            } else {
              const $elements = $slides.find('.home-swiper-v2__text');
              self.animateText($elements);
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-swiper"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('home-swiper')) {
      customElements.define(
        'home-swiper',
        class HomeSwiper extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          animateText($elements) {
            $elements.each(function (index) {
              const $this = $(this);
              setTimeout(function () {
                $this.css({
                  opacity: 1,
                  transform: 'translateY(0) translateZ(0)',
                  transition: 'opacity .6s linear .3s,transform .6s cubic-bezier(.215,.61,.355,1) .3s',
                });
              }, index * 100);
            });
          }
          init() {
            const self = this;
            const root = $(this);
            const $slides = root.find('.swiper-slide');
            if ($slides.length === 0) return;
            if ($slides.length > 1) {
              const initSwiper = () => {
                const swiperEle = root.find('.home-swiper')[0];
                const $pagination = root.find('.swiper-pagination');
                const isAutoplay = swiperEle.getAttribute('data-autoplay') === 'true';
                const autoplayDelay = swiperEle.getAttribute('data-autoplay-delay');
                new Swiper(swiperEle, {
                  loop: true,
                  speed: 600,
                  fadeEffect: {
                    crossFade: true,
                  },
                  autoplay: isAutoplay
                    ? {
                        delay: autoplayDelay,
                        disableOnInteraction: false,
                      }
                    : false,
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                  },
                  preloadImages: false,
                  lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1,
                    loadOnTransitionStart: true,
                  },
                  on: {
                    init: function () {
                      const $elements = $(this.slides[0]).find('.home-swiper__text');
                      self.animateText($elements);

                      setTimeout(() => {
                        $pagination
                          .find('.swiper-pagination-bullet-active')
                          .addClass('home-swiper-pagination-bullet__active');
                      }, 0);
                    },
                    slideChangeTransitionStart: function () {
                      const $previousIndex = $(this.slides[this.previousIndex]);
                      $previousIndex.find('.home-swiper__text').css({
                        opacity: 0,
                        transform: 'translateY(-60px)',
                        transition: 'none',
                      });

                      const $currentIndex = $(this.slides[this.activeIndex]);
                      const $elements = $currentIndex.find('.home-swiper__text');
                      self.animateText($elements);

                      $pagination
                        .find('.swiper-pagination-bullet')
                        .removeClass('home-swiper-pagination-bullet__active');
                      $pagination
                        .find('.swiper-pagination-bullet-active')
                        .addClass('home-swiper-pagination-bullet__active');

                      // 切换头部导航主题
                      const theme = $(this.slides[this.activeIndex]).attr('data-block-theme');
                      $('#lt-header').attr('data-block-theme', theme);
                    },
                  },
                });
              };
              initSwiper();
            } else {
              const $elements = $slides.find('.home-swiper__text');
              self.animateText($elements);
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-technical-investment-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('home-technical-investment-v2')) {
      customElements.define(
        'home-technical-investment-v2',
        /**
         * 首页-技术投入V2
         * - PC（≥961px）：居中 Swiper 轮播，点击 Tab 或自动轮播切换，联动底部文案。
         * - 移动端（≤960px）：顶部图 + 横向标签 + 当前项内容。
         */
        class HomeTechnicalInvestmentV2 extends HTMLElement {
          constructor() {
            super();
            this.activeIndex = 0;
            this.swiper = null;
            this._mq = null;
            this._skipSlideChange = false;
            this._targetBlockIndex = null;
            this._onSlideTransitionEnd = null;
            this._autoplayTimer = null;
            this._autoplayPaused = false;
          }

          connectedCallback() {
            this.desktopTabs = Array.from(this.querySelectorAll('.home-technical-investment-v2__desktop-tab'));
            this.desktopPanels = Array.from(this.querySelectorAll('.home-technical-investment-v2__desktop-panel-item'));
            this.tabs = Array.from(this.querySelectorAll('.home-technical-investment-v2__mobile-tab'));
            this.tabsEl = this.querySelector('.home-technical-investment-v2__mobile-tabs');
            this.mobileMedia = Array.from(this.querySelectorAll('.home-technical-investment-v2__mobile-media-item'));
            this.mobilePanels = Array.from(this.querySelectorAll('.home-technical-investment-v2__mobile-panel'));

            this._onClick = this.handleClick.bind(this);
            this._onMqChange = this.handleBreakpoint.bind(this);
            this._onAutoplayMouseEnter = () => this._pauseAutoplay();
            this._onAutoplayMouseLeave = () => this._resumeAutoplay();
            this._onAutoplayTouchStart = () => this._pauseAutoplay();
            this._onAutoplayTouchEnd = () => this._resumeAutoplay();
            this.addEventListener('click', this._onClick);

            const autoplayTarget =
              this.querySelector('.home-technical-investment-v2__swiper-wrap') ||
              this.querySelector('.home-technical-investment-v2__mobile');
            if (autoplayTarget) {
              autoplayTarget.addEventListener('mouseenter', this._onAutoplayMouseEnter);
              autoplayTarget.addEventListener('mouseleave', this._onAutoplayMouseLeave);
              autoplayTarget.addEventListener('touchstart', this._onAutoplayTouchStart, { passive: true });
              autoplayTarget.addEventListener('touchend', this._onAutoplayTouchEnd, { passive: true });
            }

            this._mq = window.matchMedia('(min-width: 961px)');
            if (this._mq.addEventListener) {
              this._mq.addEventListener('change', this._onMqChange);
            } else {
              this._mq.addListener(this._onMqChange);
            }

            this.handleBreakpoint();
          }

          disconnectedCallback() {
            if (this._onClick) {
              this.removeEventListener('click', this._onClick);
            }
            if (this._mq) {
              if (this._mq.removeEventListener) {
                this._mq.removeEventListener('change', this._onMqChange);
              } else {
                this._mq.removeListener(this._onMqChange);
              }
            }
            this.destroySwiper();
            this._stopAutoplay();

            const autoplayTarget =
              this.querySelector('.home-technical-investment-v2__swiper-wrap') ||
              this.querySelector('.home-technical-investment-v2__mobile');
            if (autoplayTarget) {
              autoplayTarget.removeEventListener('mouseenter', this._onAutoplayMouseEnter);
              autoplayTarget.removeEventListener('mouseleave', this._onAutoplayMouseLeave);
              autoplayTarget.removeEventListener('touchstart', this._onAutoplayTouchStart);
              autoplayTarget.removeEventListener('touchend', this._onAutoplayTouchEnd);
            }
          }

          handleBreakpoint() {
            if (this._mq && this._mq.matches) {
              this.initSwiper();
            } else {
              this.destroySwiper();
            }
            this._startAutoplay();
          }

          _getAutoplayConfig() {
            return {
              enabled: this.dataset.autoplay === 'true',
              delay: 4000,
            };
          }

          _getBlockCount() {
            return this._originalSlideCount || this.desktopTabs.length || 0;
          }

          _startAutoplay() {
            this._stopAutoplay();

            const config = this._getAutoplayConfig();
            if (!config.enabled || this._getBlockCount() <= 1 || this._autoplayPaused) return;

            this._autoplayTimer = window.setTimeout(() => {
              this._advanceAutoplay();
            }, config.delay);
          }

          _stopAutoplay() {
            if (this._autoplayTimer) {
              window.clearTimeout(this._autoplayTimer);
              this._autoplayTimer = null;
            }
          }

          _pauseAutoplay() {
            this._autoplayPaused = true;
            this._stopAutoplay();
          }

          _resumeAutoplay() {
            this._autoplayPaused = false;
            this._startAutoplay();
          }

          _resetAutoplay() {
            this._autoplayPaused = false;
            this._startAutoplay();
          }

          _advanceAutoplay() {
            if (this._autoplayPaused) return;

            const count = this._getBlockCount();
            if (count <= 1) return;
            if (this.swiper?.animating) return;

            const nextIndex = (this.activeIndex + 1) % count;
            this._targetBlockIndex = nextIndex;

            if (this.swiper) {
              this.slideToBlockIndex(nextIndex);
              return;
            }

            this.activate(nextIndex, false);
            this._startAutoplay();
          }

          initSwiper() {
            if (this.swiper) return;

            const swiperEl = this.querySelector('.home-technical-investment-v2__swiper');
            if (!swiperEl) return;

            const wrapper = swiperEl.querySelector('.swiper-wrapper');
            if (!wrapper) return;

            this._restoreOriginalSlides(wrapper);
            const initialSlide = this._prepareInfiniteSlides(wrapper);
            if (this._originalSlideCount <= 0) return;

            this.swiper = new Swiper(swiperEl, {
              slidesPerView: 'auto',
              centeredSlides: true,
              spaceBetween: 24,
              loop: false,
              initialSlide,
              watchOverflow: false,
              watchSlidesProgress: true,
              allowTouchMove: false,
              simulateTouch: false,
              preventInteractionOnTransition: true,
              speed: 450,
              on: {
                init: () => {
                  this._targetBlockIndex = 0;
                  this._setSkipSlideChange(true);
                  this.activate(0, false);
                  this._syncSlideVisualClasses();
                  requestAnimationFrame(() => {
                    this._setSkipSlideChange(false);
                    this._startAutoplay();
                  });
                },
                setTranslate: () => {
                  this._syncSlideVisualClasses();
                },
                slideChange: () => {
                  this._syncSlideVisualClasses();
                },
                slideChangeTransitionStart: () => {
                  this._syncSlideVisualClasses();
                },
                slideChangeTransitionEnd: () => {
                  this._normalizeLoopPosition();
                  this._syncSlideVisualClasses();
                  this._handleSwiperIndexChange();
                  this._startAutoplay();
                },
              },
            });
          }

          _restoreOriginalSlides(wrapper) {
            if (!wrapper) return;

            this._removeLoopClones(wrapper);
            const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
            slides.sort((a, b) => Number(a.dataset.blockIndex) - Number(b.dataset.blockIndex));
            slides.forEach((slide) => wrapper.appendChild(slide));
          }

          /**
           * 旋转顺序为 [最后一张, 第一张, 第二张...] 并复制一组，实现：
           * 默认第一张居中、第二张在右、第三张在左，且可无缝循环
           */
          _prepareInfiniteSlides(wrapper) {
            const originals = Array.from(wrapper.querySelectorAll('.swiper-slide'));
            const count = originals.length;

            this._originalSlideCount = count;
            this._blockToPrimaryIndex = {};

            if (count <= 1) {
              this._blockToPrimaryIndex[0] = 0;
              return 0;
            }

            const rotated = [originals[count - 1], ...originals.slice(0, count - 1)];
            rotated.forEach((slide) => {
              this._cleanSlideVisualClasses(slide);
              wrapper.appendChild(slide);
            });
            rotated.forEach((slide) => {
              const clonedSlide = slide.cloneNode(true);
              clonedSlide.setAttribute('data-loop-clone', 'duplicate');
              clonedSlide.removeAttribute('data-shopify-editor-block');
              this._cleanSlideVisualClasses(clonedSlide);
              wrapper.appendChild(clonedSlide);
            });

            rotated.forEach((slide, index) => {
              const blockIndex = Number(slide.dataset.blockIndex);
              if (!Number.isNaN(blockIndex)) {
                this._blockToPrimaryIndex[blockIndex] = index;
              }
            });

            return this._blockToPrimaryIndex[0] ?? 0;
          }

          _removeLoopClones(wrapper) {
            if (!wrapper) return;
            wrapper.querySelectorAll('[data-loop-clone]').forEach((node) => node.remove());
          }

          _getSlideIndicesForBlock(blockIndex) {
            const count = this._originalSlideCount || 1;
            const primaryIndex = this._blockToPrimaryIndex?.[blockIndex];

            if (primaryIndex == null) {
              return [blockIndex];
            }

            if (count <= 1) {
              return [primaryIndex];
            }

            return [primaryIndex, primaryIndex + count];
          }

          /**
           * 选取 block 对应的 slide 索引。
           * 过滤掉边界 slide（idx 0 或 idx total-1），避免 active 居中时一侧无 slide 显示。
           */
          _pickNearestSlideIndex(blockIndex) {
            const candidates = this._getSlideIndicesForBlock(blockIndex);
            const activeIndex = this.swiper?.activeIndex ?? 0;
            const count = this._originalSlideCount || 1;
            const total = count * 2;

            // 优先选择非边界 slide，从剩余 candidates 中选最近的
            const safeCandidates = candidates.filter((idx) => idx > 0 && idx < total - 1);
            const pool = safeCandidates.length > 0 ? safeCandidates : candidates;

            return pool.reduce((nearest, candidate) => {
              return Math.abs(candidate - activeIndex) < Math.abs(nearest - activeIndex) ? candidate : nearest;
            }, pool[0]);
          }

          /**
           * 归一化 activeIndex 到非边界位置：
           * - activeIndex === 0（最左边界）→ 跳到克隆区对应位置 (count)
           * - activeIndex === total - 1（最右边界）→ 跳到原图区对应位置 (count - 1)
           * 避免边界 active 居中时一侧无 slide 显示。
           */
          _normalizeLoopPosition() {
            const count = this._originalSlideCount || 1;
            if (!this.swiper || count <= 1) return;

            const activeIndex = this.swiper.activeIndex;
            const total = count * 2;

            if (activeIndex >= total) {
              this._withLoopJump(() => {
                this.swiper.slideTo(activeIndex - count, 0, false);
              });
              return;
            }

            if (activeIndex === total - 1) {
              this._withLoopJump(() => {
                this.swiper.slideTo(activeIndex - 1, 0, false);
              });
            }
          }

          /**
           * 手动同步 active/prev/next 样式到所有 slide（含复制节点），
           * 避免复制 slide 在 active 时未放大或跳转时抖动
           */
          _cleanSlideVisualClasses(slide) {
            if (!slide) return;
            slide.classList.remove(
              'swiper-slide-active',
              'swiper-slide-prev',
              'swiper-slide-next',
              'is-carousel-active',
              'is-carousel-prev',
              'is-carousel-next'
            );
            slide
              .querySelector('.home-technical-investment-v2__slide-inner')
              ?.classList.remove('is-carousel-active', 'is-carousel-prev', 'is-carousel-next');
          }

          _getSwiperSlides() {
            if (!this.swiper?.slides?.length) return [];
            return Array.from(this.swiper.slides);
          }

          _resolveActiveSlideIndex(slides) {
            if (!this.swiper || !slides.length) return 0;

            let activeIndex = this.swiper.activeIndex;

            if (this.swiper.params.watchSlidesProgress) {
              let closestProgress = Infinity;
              slides.forEach((slide, index) => {
                const progress = Math.abs(slide.progress ?? Infinity);
                if (progress < closestProgress) {
                  closestProgress = progress;
                  activeIndex = index;
                }
              });
            }

            return activeIndex;
          }

          _syncSlideVisualClasses() {
            const slides = this._getSwiperSlides();
            if (!slides.length) return;

            const activeIndex = this._resolveActiveSlideIndex(slides);

            slides.forEach((slide, index) => {
              const isActive = index === activeIndex;
              const isPrev = index === activeIndex - 1;
              const isNext = index === activeIndex + 1;
              const inner = slide.querySelector('.home-technical-investment-v2__slide-inner');

              slide.classList.toggle('is-carousel-active', isActive);
              slide.classList.toggle('is-carousel-prev', isPrev);
              slide.classList.toggle('is-carousel-next', isNext);

              if (inner) {
                inner.classList.toggle('is-carousel-active', isActive);
                inner.classList.toggle('is-carousel-prev', isPrev);
                inner.classList.toggle('is-carousel-next', isNext);
              }
            });
          }

          _withLoopJump(callback) {
            const swiperEl = this.querySelector('.home-technical-investment-v2__swiper');
            if (!swiperEl) {
              callback();
              this._syncSlideVisualClasses();
              return;
            }

            swiperEl.classList.add('is-loop-jumping');
            callback();
            this._syncSlideVisualClasses();
            requestAnimationFrame(() => {
              swiperEl.classList.remove('is-loop-jumping');
            });
          }

          /**
           * 从当前激活 slide 的 data-block-index 读取真实 block 下标
           */
          _getActiveBlockIndex() {
            if (!this.swiper) return this.activeIndex;

            const slides = this._getSwiperSlides();
            const activeIndex = this._resolveActiveSlideIndex(slides);
            const activeSlide = slides[activeIndex];
            if (activeSlide) {
              const blockIndex = Number(activeSlide.dataset.blockIndex);
              if (!Number.isNaN(blockIndex)) {
                return blockIndex;
              }
            }

            return this.activeIndex;
          }

          _handleSwiperIndexChange() {
            if (!this.swiper || this._skipSlideChange) return;

            const index = this._getActiveBlockIndex();
            if (Number.isNaN(index)) return;

            if (this._targetBlockIndex != null && index !== this._targetBlockIndex) {
              return;
            }

            this._targetBlockIndex = index;
            this.activate(index, false);
          }

          _setSkipSlideChange(skip) {
            this._skipSlideChange = skip;
          }

          _clearSlideTransitionEnd() {
            if (this.swiper && this._onSlideTransitionEnd) {
              this.swiper.off('slideChangeTransitionEnd', this._onSlideTransitionEnd);
              this._onSlideTransitionEnd = null;
            }
          }

          slideToBlockIndex(blockIndex) {
            if (!this.swiper || Number.isNaN(blockIndex)) return;

            this._targetBlockIndex = blockIndex;
            const targetSlideIndex = this._pickNearestSlideIndex(blockIndex);

            if (targetSlideIndex === this.swiper.activeIndex && !this.swiper.animating) {
              this.activate(blockIndex, false);
              return;
            }

            this._clearSlideTransitionEnd();
            this._setSkipSlideChange(true);

            const requestedIndex = blockIndex;
            this._onSlideTransitionEnd = () => {
              this._clearSlideTransitionEnd();
              this._normalizeLoopPosition();
              this._syncSlideVisualClasses();
              this._setSkipSlideChange(false);

              if (this._targetBlockIndex !== requestedIndex) {
                return;
              }

              const activeIndex = this._getActiveBlockIndex();
              if (activeIndex === requestedIndex) {
                this.activate(requestedIndex, false);
                return;
              }

              if (this._targetBlockIndex != null) {
                this.slideToBlockIndex(this._targetBlockIndex);
              }
            };
            this.swiper.on('slideChangeTransitionEnd', this._onSlideTransitionEnd);

            this.swiper.slideTo(targetSlideIndex, 450);
          }

          destroySwiper() {
            if (!this.swiper) return;
            this._clearSlideTransitionEnd();
            this.swiper.destroy(true, true);
            this.swiper = null;
            this._setSkipSlideChange(false);

            const wrapper = this.querySelector('.home-technical-investment-v2__swiper .swiper-wrapper');
            this._restoreOriginalSlides(wrapper);
          }

          handleClick(event) {
            const desktopTab = event.target.closest('.home-technical-investment-v2__desktop-tab');
            const mobileTab = event.target.closest('.home-technical-investment-v2__mobile-tab');
            if (!desktopTab && !mobileTab) return;
            if (!this.contains(desktopTab || mobileTab)) return;

            const index = Number((desktopTab || mobileTab).dataset.tabIndex);
            if (Number.isNaN(index)) return;

            if (desktopTab) {
              this._targetBlockIndex = index;
              this.activate(index, false);
              if (this.swiper) {
                this.slideToBlockIndex(index);
              }
              this._resetAutoplay();
              return;
            }

            if (index === this.activeIndex) {
              this.centerActiveTab();
              return;
            }

            this.activate(index, false);
            this._resetAutoplay();
          }

          /**
           * 激活指定下标，同步 PC Swiper / Tab / 文案与移动端状态
           * @param {number} index
           * @param {boolean} updateSwiper 是否驱动 Swiper 切换
           */
          activate(index, updateSwiper = true) {
            this.activeIndex = index;

            this.desktopTabs.forEach((tab) => {
              const isActive = Number(tab.dataset.tabIndex) === index;
              tab.classList.toggle('is-active', isActive);
              tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
            this.desktopPanels.forEach((panel) => {
              panel.classList.toggle('is-active', Number(panel.dataset.panelIndex) === index);
            });

            this.tabs.forEach((tab) => {
              const isActive = Number(tab.dataset.tabIndex) === index;
              tab.classList.toggle('is-active', isActive);
              tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
            this.mobileMedia.forEach((media) => {
              media.classList.toggle('is-active', Number(media.dataset.mediaIndex) === index);
            });
            this.mobilePanels.forEach((panel) => {
              panel.classList.toggle('is-active', Number(panel.dataset.panelIndex) === index);
            });

            if (updateSwiper && this.swiper) {
              this.slideToBlockIndex(index);
            }

            this.centerActiveTab();
          }

          centerActiveTab() {
            if (!this.tabsEl) return;
            const activeTab = this.tabs[this.activeIndex];
            if (!activeTab) return;

            const stripRect = this.tabsEl.getBoundingClientRect();
            const tabRect = activeTab.getBoundingClientRect();
            const delta = tabRect.left + tabRect.width / 2 - (stripRect.left + stripRect.width / 2);

            this.tabsEl.scrollBy({ left: delta, behavior: 'smooth' });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-user-backmap"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    const defineHomeUserBackmap = () => {
      customElements.define(
        'home-user-backmap',
        class homeUserBackmap extends HTMLElement {
          constructor() {
            super();
            this._io = null;
          }

          connectedCallback() {
            this.initCountUp();
            this.initMarqueeTracks();
          }

          disconnectedCallback() {
            // 停止数字观察
            if (this._io) {
              this._io.disconnect();
              this._io = null;
            }

            // 清理跑马灯动画和事件
            this.querySelectorAll('.marquee-track').forEach((track) => {
              // 停止动画
              track.style.animationPlayState = 'paused';
              track.style.animation = 'none';

              // 移除事件监听器
              if (track._marqueeMouseEnter) {
                track.removeEventListener('mouseenter', track._marqueeMouseEnter);
              }
              if (track._marqueeMouseLeave) {
                track.removeEventListener('mouseleave', track._marqueeMouseLeave);
              }
            });

            // 清理动态添加的CSS样式
            if (this._marqueeStyles) {
              this._marqueeStyles.forEach((style) => {
                if (style.parentNode) {
                  style.parentNode.removeChild(style);
                }
              });
              this._marqueeStyles = [];
            }
          }

          initMarqueeTracks() {
            this.querySelectorAll('.marquee-track').forEach((track) => {
              // 只 clone 一次
              if (!track.dataset.cloned) {
                track.insertAdjacentHTML('beforeend', track.innerHTML);
                track.dataset.cloned = 'true';
              }

              this.initMarquee(track);
            });
          }

          initMarquee(track) {
            const direction = track.dataset.direction || 'left';
            const pauseType = track.dataset.pauseType || 'smooth';
            const totalTime = track.dataset.totalTime || 15;
            const speed = parseFloat(track.dataset.speed) || 1;
            const itemsLength = track.children.length / 2; // 只计算原始长度

            // 计算动画参数
            requestAnimationFrame(() => {
              const computedGap = getComputedStyle(track);
              const trackGap = parseFloat(computedGap.gap);

              const itemsWidth = Array.from(track.children)
                .slice(0, itemsLength)
                .reduce((total, item) => total + item.offsetWidth + trackGap, 0);

              const duration = (totalTime / speed) * 1000; // 转换为毫秒

              // 创建CSS动画
              const animationName = `marquee-${direction}-${Date.now()}`;
              const keyframes = this.createMarqueeKeyframes(direction, itemsWidth);

              // 动态添加CSS动画
              this.addMarqueeAnimation(animationName, keyframes, duration);

              // 应用动画
              track.style.animation = `${animationName} ${duration}ms linear infinite`;
              track.style.transform = 'translateX(0)';

              // 存储动画信息用于清理
              track._marqueeAnimation = animationName;

              // 鼠标事件处理
              this.addMarqueeMouseEvents(track, pauseType);
            });
          }

          createMarqueeKeyframes(direction, itemsWidth) {
            if (direction === 'right') {
              return `
                0% { transform: translateX(${-itemsWidth}px); }
                100% { transform: translateX(0px); }
              `;
            } else {
              return `
                0% { transform: translateX(0px); }
                100% { transform: translateX(${-itemsWidth}px); }
              `;
            }
          }

          addMarqueeAnimation(name, keyframes, duration) {
            const style = document.createElement('style');
            style.textContent = `
              @keyframes ${name} {
                ${keyframes}
              }
            `;
            document.head.appendChild(style);

            // 存储样式元素用于清理
            if (!this._marqueeStyles) {
              this._marqueeStyles = [];
            }
            this._marqueeStyles.push(style);
          }

          addMarqueeMouseEvents(track, pauseType) {
            const handleMouseEnter = () => {
              if (pauseType === 'immediate') {
                track.style.animationPlayState = 'paused';
              } else {
                // 平滑暂停效果
                track.style.transition = 'animation-play-state 0.3s ease-in-out';
                track.style.animationPlayState = 'paused';
              }
            };

            const handleMouseLeave = () => {
              if (pauseType === 'immediate') {
                track.style.animationPlayState = 'running';
              } else {
                // 平滑恢复效果
                track.style.transition = 'animation-play-state 0.3s ease-in-out';
                track.style.animationPlayState = 'running';
              }
            };

            track.addEventListener('mouseenter', handleMouseEnter);
            track.addEventListener('mouseleave', handleMouseLeave);

            // 存储事件处理器用于清理
            track._marqueeMouseEnter = handleMouseEnter;
            track._marqueeMouseLeave = handleMouseLeave;
          }

          initCountUp() {
            const numberDomList = this.querySelectorAll('.count');
            if (!numberDomList.length) return;

            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;

                  const el = entry.target;
                  if (el.dataset.animated === 'true') {
                    observer.unobserve(el);
                    return;
                  }
                  el.dataset.animated = 'true';

                  const target = Number(el.dataset.number) || 0;
                  const duration = 1200; // ms
                  const startTime = performance.now();

                  const step = (now) => {
                    const progress = Math.min((now - startTime) / duration, 1);
                    const eased = this._easeOutCubic(progress);
                    const current = Math.floor(target * eased);
                    el.textContent = this._formatNumber(current);

                    if (progress < 1) {
                      requestAnimationFrame(step);
                    } else {
                      el.textContent = this._formatNumber(target);
                    }
                  };

                  // 初始化为 0 并开始动画
                  el.textContent = '0';
                  requestAnimationFrame(step);

                  observer.unobserve(el);
                });
              },
              { threshold: 0.3 }
            );

            numberDomList.forEach((el) => observer.observe(el));
            this._io = observer;
          }

          _easeOutCubic(t) {
            return 1 - Math.pow(1 - t, 3);
          }

          _formatNumber(value) {
            if (value >= 1000000) {
              return (value / 1000000).toFixed(1) + 'M';
            } else if (value >= 1000) {
              return (value / 1000).toFixed(1) + 'K';
            } else {
              return value.toString();
            }
          }
        }
      );
    };

    // Shopify 设计模式下使用全局变量防止重复定义
    if (Shopify.designMode) {
      if (!window.__homeUserBackmapInit) {
        window.__homeUserBackmapInit = true;
        defineHomeUserBackmap();
      }
    } else {
      // 正常前台页面
      if (!customElements.get('home-user-backmap')) {
        defineHomeUserBackmap();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-user-story-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-user-story-v2')) {
    customElements.define(
      'home-user-story-v2',
      class HomeUserStoryV2 extends HTMLElement {
        constructor() {
          super();
          this._tabsWrap = null;
          this._tabs = [];
          this._panels = [];
          this._marqueeControllers = new Map();
          this._marqueeDragStates = new WeakMap();
          this._mobileMq = null;
          this._onMobileMqChange = null;
        }

        _isMobileViewport() {
          return window.matchMedia('(max-width: 576px)').matches;
        }

        _isMobileAutoplayEnabled() {
          return this.dataset.mobileAutoplay === 'true';
        }

        _isMarqueeAutoplayActive(marquee) {
          if (!marquee || marquee.dataset.marqueeAutoplay !== 'true') return false;
          if (!this._isMobileViewport()) return true;
          return this._isMobileAutoplayEnabled();
        }

        _pauseMobileAutoplay(marquee) {
          const index = marquee.closest('.home-user-story-v2__panel')?.dataset.index;
          if (!index) return;
          this._marqueeControllers.get(index)?.pauseMobileAutoplay?.();
        }

        _resumeMobileAutoplay(marquee) {
          const index = marquee.closest('.home-user-story-v2__panel')?.dataset.index;
          if (!index) return;
          this._marqueeControllers.get(index)?.resumeMobileAutoplay?.();
        }

        _initMobileDragScroll() {
          this.querySelectorAll('.home-user-story-v2__marquee').forEach((marquee) => {
            if (marquee.dataset.dragScrollBound === 'true') return;
            marquee.dataset.dragScrollBound = 'true';

            const dragState = {
              active: false,
              moved: false,
              isTouchDrag: false,
              pointerId: null,
              startX: 0,
              startScrollLeft: 0,
            };
            this._marqueeDragStates.set(marquee, dragState);

            const markMoved = (deltaX) => {
              if (Math.abs(deltaX) > 8) {
                dragState.moved = true;
              }
            };

            const onDragStart = (clientX, pointerId, isTouchDrag = false) => {
              if (!this._isMobileViewport()) return;
              dragState.active = true;
              dragState.moved = false;
              dragState.isTouchDrag = isTouchDrag;
              dragState.pointerId = pointerId ?? null;
              dragState.startX = clientX;
              dragState.startScrollLeft = marquee.scrollLeft;
              if (!isTouchDrag) {
                marquee.classList.add('is-dragging');
              }
              this._pauseMobileAutoplay(marquee);
            };

            const onDragMove = (clientX) => {
              if (!dragState.active || !this._isMobileViewport()) return;
              const deltaX = clientX - dragState.startX;
              markMoved(deltaX);
              if (dragState.isTouchDrag) return;
              marquee.scrollLeft = dragState.startScrollLeft - deltaX;
            };

            const onDragEnd = () => {
              if (!dragState.active) return;
              dragState.active = false;
              dragState.isTouchDrag = false;
              dragState.pointerId = null;
              marquee.classList.remove('is-dragging');
              if (dragState.moved) {
                window.setTimeout(() => {
                  dragState.moved = false;
                }, 120);
              }
              this._resumeMobileAutoplay(marquee);
            };

            marquee.addEventListener(
              'touchstart',
              (event) => {
                if (event.touches.length !== 1) return;
                onDragStart(event.touches[0].clientX, null, true);
              },
              { passive: true }
            );

            marquee.addEventListener(
              'touchmove',
              (event) => {
                if (event.touches.length !== 1 || !dragState.active) return;
                markMoved(event.touches[0].clientX - dragState.startX);
                this._pauseMobileAutoplay(marquee);
              },
              { passive: true }
            );

            marquee.addEventListener('touchend', onDragEnd, { passive: true });
            marquee.addEventListener('touchcancel', onDragEnd, { passive: true });

            marquee.addEventListener('pointerdown', (event) => {
              if (event.pointerType === 'touch') return;
              if (event.pointerType === 'mouse' && event.button !== 0) return;
              onDragStart(event.clientX, event.pointerId, false);
              marquee.setPointerCapture(event.pointerId);
            });

            marquee.addEventListener('pointermove', (event) => {
              if (dragState.pointerId !== event.pointerId || dragState.isTouchDrag) return;
              onDragMove(event.clientX);
            });

            marquee.addEventListener('pointerup', (event) => {
              if (dragState.pointerId !== event.pointerId) return;
              if (marquee.hasPointerCapture(event.pointerId)) {
                marquee.releasePointerCapture(event.pointerId);
              }
              onDragEnd();
            });

            marquee.addEventListener('pointercancel', (event) => {
              if (dragState.pointerId !== event.pointerId) return;
              onDragEnd();
            });
          });
        }

        connectedCallback() {
          this._tabsWrap = this.querySelector('.home-user-story-v2__tabs-wrapper');
          this._tabs = [...this.querySelectorAll('.home-user-story-v2__tab[data-index]')];
          this._panels = [...this.querySelectorAll('.home-user-story-v2__panel[data-index]')].filter(
            (panel) => panel.dataset.index
          );

          this._boundClick = (e) => {
            const tab = e.target.closest('.home-user-story-v2__tab[data-index]');
            if (tab) {
              this._onTabClick(tab);
              return;
            }
            const card = e.target.closest('.home-user-story-v2__card[data-url]');
            if (card) {
              const marquee = card.closest('.home-user-story-v2__marquee');
              const dragState = marquee ? this._marqueeDragStates.get(marquee) : null;
              if (dragState?.moved) return;

              const url = card.dataset.url;
              if (url) {
                window.location.href = url;
              }
            }
          };
          this.addEventListener('click', this._boundClick);

          this._panels.forEach((panel) => this._initMarquee(panel));
          this._initMobileDragScroll();

          if (this._tabs.length > 0) {
            this.activateByIndex(this._tabs[0].dataset.index);
          }

          this._mobileMq = window.matchMedia('(max-width: 576px)');
          this._onMobileMqChange = () => {
            this._panels.forEach((panel) => {
              const index = panel.dataset.index;
              const controller = this._marqueeControllers.get(index);
              if (!controller || panel.classList.contains('hidden')) return;
              controller.reset();
              controller.start();
            });
          };
          this._mobileMq.addEventListener('change', this._onMobileMqChange);
        }

        disconnectedCallback() {
          if (this._mobileMq && this._onMobileMqChange) {
            this._mobileMq.removeEventListener('change', this._onMobileMqChange);
          }
          if (this._boundClick) {
            this.removeEventListener('click', this._boundClick);
          }
          this._destroyAllMarquees();
        }

        _destroyAllMarquees() {
          this._marqueeControllers.forEach((controller) => controller.destroy());
          this._marqueeControllers.clear();
        }

        _initMarquee(panel) {
          const index = panel.dataset.index;
          const marquee = panel.querySelector('.home-user-story-v2__marquee');
          if (!index || !marquee) return;

          if (this._marqueeControllers.has(index)) {
            this._marqueeControllers.get(index).destroy();
          }

          this._marqueeControllers.set(index, this._createMarqueeController(marquee, panel));
        }

        _createMarqueeController(marquee, panel) {
          const track = marquee.querySelector('.home-user-story-v2__track');
          const isAutoplay = marquee.dataset.marqueeAutoplay === 'true';
          const root = this;
          const state = {
            marquee,
            track,
            panel,
            hoveringMarquee: false,
            abort: null,
            resizeObserver: null,
            mobileAutoplayRaf: null,
            mobileAutoplayPaused: false,
            mobileAutoplayLastTs: 0,
            mobileAutoplayResumeTimer: null,
            lastAutoScrollLeft: 0,
          };

          const isAutoplayActive = () => root._isMarqueeAutoplayActive(state.marquee);
          const isMobileScrollAutoplay = () =>
            root._isMobileViewport() && isAutoplay && root._isMobileAutoplayEnabled();

          const setPaused = (paused) => {
            state.marquee.classList.toggle('is-paused', paused);
          };

          const updatePaused = () => {
            if (isMobileScrollAutoplay()) {
              setPaused(state.mobileAutoplayPaused || state.hoveringMarquee);
              return;
            }
            if (!isAutoplayActive()) {
              setPaused(true);
              return;
            }
            setPaused(state.hoveringMarquee);
          };

          const getMobileAutoplaySpeed = () => {
            const maxScroll = Math.max(0, state.marquee.scrollWidth - state.marquee.clientWidth);
            if (maxScroll <= 0) return 0;
            const durationRaw = getComputedStyle(state.marquee).getPropertyValue('--marquee-duration').trim();
            const durationSec = parseFloat(durationRaw) || 30;
            return maxScroll / (durationSec * 1000);
          };

          const stopMobileScrollAutoplay = () => {
            if (state.mobileAutoplayRaf) {
              cancelAnimationFrame(state.mobileAutoplayRaf);
              state.mobileAutoplayRaf = null;
            }
            state.mobileAutoplayLastTs = 0;
          };

          const clearMobileAutoplayResumeTimer = () => {
            if (state.mobileAutoplayResumeTimer) {
              window.clearTimeout(state.mobileAutoplayResumeTimer);
              state.mobileAutoplayResumeTimer = null;
            }
          };

          const scheduleMobileAutoplayResume = (delay = 2000) => {
            clearMobileAutoplayResumeTimer();
            state.mobileAutoplayResumeTimer = window.setTimeout(() => {
              state.mobileAutoplayResumeTimer = null;
              if (!state.mobileAutoplayPaused && isMobileScrollAutoplay()) {
                state.lastAutoScrollLeft = state.marquee.scrollLeft;
                startMobileScrollAutoplay();
              }
            }, delay);
          };

          const tickMobileScrollAutoplay = (timestamp) => {
            if (!isMobileScrollAutoplay() || state.panel.classList.contains('hidden')) {
              stopMobileScrollAutoplay();
              return;
            }

            if (state.mobileAutoplayPaused || state.hoveringMarquee) {
              state.lastAutoScrollLeft = state.marquee.scrollLeft;
              state.mobileAutoplayLastTs = timestamp;
              state.mobileAutoplayRaf = requestAnimationFrame(tickMobileScrollAutoplay);
              return;
            }

            const currentScrollLeft = state.marquee.scrollLeft;
            if (Math.abs(currentScrollLeft - state.lastAutoScrollLeft) > 2) {
              state.mobileAutoplayPaused = true;
              stopMobileScrollAutoplay();
              state.lastAutoScrollLeft = currentScrollLeft;
              updatePaused();
              scheduleMobileAutoplayResume();
              return;
            }

            if (!state.mobileAutoplayLastTs) {
              state.mobileAutoplayLastTs = timestamp;
            }

            const elapsed = timestamp - state.mobileAutoplayLastTs;
            state.mobileAutoplayLastTs = timestamp;
            const maxScroll = Math.max(0, state.marquee.scrollWidth - state.marquee.clientWidth);
            const speed = getMobileAutoplaySpeed();

            if (maxScroll <= 0 || speed <= 0) {
              state.mobileAutoplayRaf = requestAnimationFrame(tickMobileScrollAutoplay);
              return;
            }

            state.marquee.scrollLeft += elapsed * speed;
            state.lastAutoScrollLeft = state.marquee.scrollLeft;

            if (state.marquee.scrollLeft >= maxScroll - 1) {
              state.marquee.scrollLeft = 0;
              state.lastAutoScrollLeft = 0;
            }

            state.mobileAutoplayRaf = requestAnimationFrame(tickMobileScrollAutoplay);
          };

          const startMobileScrollAutoplay = () => {
            stopMobileScrollAutoplay();
            if (!isMobileScrollAutoplay() || state.mobileAutoplayPaused) return;
            state.lastAutoScrollLeft = state.marquee.scrollLeft;
            state.mobileAutoplayRaf = requestAnimationFrame(tickMobileScrollAutoplay);
          };

          const measureTrack = () => {
            if (!state.track || !isAutoplayActive() || root._isMobileViewport()) return;

            const sourceGroup = state.track.querySelector('.home-user-story-v2__track-group:not([data-clone])');
            if (!sourceGroup) return;

            const groupStyle = getComputedStyle(sourceGroup);
            const distance = sourceGroup.offsetWidth + parseFloat(groupStyle.marginRight || '0');
            if (distance <= 0) return;

            state.track.style.setProperty('--marquee-translate', `${-distance}px`);
          };

          const controller = {
            _activated: false,
            measureTrack() {
              measureTrack();
            },
            start() {
              stopMobileScrollAutoplay();
              if (isMobileScrollAutoplay()) {
                updatePaused();
                startMobileScrollAutoplay();
                return;
              }
              if (!isAutoplayActive()) {
                setPaused(true);
                return;
              }
              updatePaused();
            },
            stop() {
              stopMobileScrollAutoplay();
              setPaused(true);
            },
            reset() {
              stopMobileScrollAutoplay();
              state.marquee.scrollLeft = 0;
              if (!state.track) return;

              state.track.style.animation = 'none';
              void state.track.offsetWidth;
              state.track.style.removeProperty('animation');
              state.track.style.removeProperty('transform');
              measureTrack();
              updatePaused();
              startMobileScrollAutoplay();
            },
            pauseMobileAutoplay() {
              state.mobileAutoplayPaused = true;
              stopMobileScrollAutoplay();
              clearMobileAutoplayResumeTimer();
              state.lastAutoScrollLeft = state.marquee.scrollLeft;
              updatePaused();
            },
            resumeMobileAutoplay() {
              state.mobileAutoplayPaused = false;
              updatePaused();
              scheduleMobileAutoplayResume();
            },
            destroy() {
              stopMobileScrollAutoplay();
              clearMobileAutoplayResumeTimer();
              setPaused(true);
              state.resizeObserver?.disconnect();
              state.resizeObserver = null;
              state.abort?.abort();
            },
          };

          state.abort = new AbortController();
          const { signal } = state.abort;

          if (isAutoplay) {
            marquee.addEventListener(
              'mouseenter',
              () => {
                if (root._isMobileViewport()) return;
                if (!isAutoplayActive()) return;
                state.hoveringMarquee = true;
                updatePaused();
              },
              { signal }
            );
            marquee.addEventListener(
              'mouseleave',
              () => {
                if (root._isMobileViewport()) return;
                if (!isAutoplayActive()) return;
                state.hoveringMarquee = false;
                updatePaused();
              },
              { signal }
            );

            if (typeof ResizeObserver !== 'undefined' && state.track) {
              state.resizeObserver = new ResizeObserver(() => {
                if (!state.panel.classList.contains('hidden') && isAutoplayActive() && !root._isMobileViewport()) {
                  measureTrack();
                }
              });
              state.resizeObserver.observe(state.track);
            }
          }

          panel
            .querySelectorAll('.home-user-story-v2__track-group[data-clone] .home-user-story-v2__card')
            .forEach((card) => {
              card.addEventListener(
                'click',
                (e) => {
                  if (!e.target.closest('.home-user-story-v2__card-btn')) {
                    e.preventDefault();
                  }
                },
                { signal }
              );
            });

          return controller;
        }

        activateByIndex(index) {
          if (!index) return;

          this._tabs.forEach((tab) => {
            const isActive = tab.dataset.index === index;
            tab.classList.toggle('home-user-story-v2__tab--active', isActive);
            tab.dataset.active = isActive ? 'true' : 'false';
          });

          this._panels.forEach((panel) => {
            const isMatch = panel.dataset.index === index;
            panel.classList.toggle('hidden', !isMatch);
          });

          requestAnimationFrame(() => {
            this._marqueeControllers.forEach((controller, panelIndex) => {
              if (panelIndex === index) {
                controller.measureTrack();
                if (!controller._activated) {
                  controller._activated = true;
                  controller.start();
                } else {
                  controller.reset();
                  controller.start();
                }
              } else {
                controller.stop();
              }
            });
          });
        }

        _onTabClick(tab) {
          const index = tab.dataset.index;
          if (!index) return;
          this.activateByIndex(index);
          this._scrollTabToCenter(tab);
        }

        _scrollTabToCenter(tab) {
          const wrap = this._tabsWrap;
          if (!wrap || !tab) return;

          const maxScroll = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
          if (maxScroll === 0) return;

          const wrapRect = wrap.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          const tabCenter = wrap.scrollLeft + (tabRect.left - wrapRect.left) + tabRect.width / 2;
          let targetScroll = tabCenter - wrap.clientWidth / 2;
          targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

          wrap.scrollTo({ left: targetScroll, behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["integrated-service-activity"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('integrated-service-activity')) {
      customElements.define(
        'integrated-service-activity',
        class IntegratedServiceActivity extends HTMLElement {
          constructor() {
            super();
            this.swiper = null;
          }
          connectedCallback() {
            this.initSwiper();
          }
          initSwiper() {
            let root = $(this);
            let $swiperDom = this.querySelector('.integrated-service-activity__swiper');
            let nextDom = this.querySelector('.swiper-button-next');
            let prevDom = this.querySelector('.swiper-button-prev');
            const slidesCount = $swiperDom.querySelectorAll('.swiper-slide').length;
            if (slidesCount <= 3 && window.innerWidth >= 1400) {
              $($swiperDom).find('.swiper-button-next, .swiper-button-prev').hide();
            }

            this.swiper = new Swiper($swiperDom, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              navigation: {
                nextEl: nextDom,
                prevEl: prevDom,
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["integrated-service-banner"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('integrated-service-banner')) {
      customElements.define(
        'integrated-service-banner',
        class IntegratedServiceBanner extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            const nextButton = this.querySelector('.integrated-service-banner__content-next');
            nextButton.addEventListener('click', () => {
              const nextId = nextButton.getAttribute('data-id');
              console.log(nextId, 'nextId');
              document.querySelector(`#${nextId}`)?.setAttribute('data-show', 'true');
              this.setAttribute('data-show', 'false');
              const urlParams = new URLSearchParams(window.location.search);
              urlParams.set('currentId', nextId);
              window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["integrated-service-community"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('integrated-service-community')) {
      customElements.define(
        'integrated-service-community',
        class extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            const mediaBtns = this.querySelectorAll('[data-media="true"]');
            mediaBtns.forEach((mediaBtn) => {
              mediaBtn.addEventListener('click', () => {
                this.followMedia(mediaBtn.dataset.mediaName);
              });
            });
          }

          async followMedia(media) {
            const url = '/shopify/user/point/follow/' + media;
            const res = await window.litime.http.post(url);
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["integrated-service-download"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('integrated-service-download')) {
      customElements.define(
        'integrated-service-download',
        class IntegratedServiceDownload extends HTMLElement {
          constructor() {
            super();
            this.swiper = null;
          }
          connectedCallback() {
            if (window.innerWidth <= 1280) {
              this.initObserver();
            } else {
              this.initSwiper();
            }
            this.init();
          }
          disconnectedCallback() {
            if (this.observer) {
              this.observer.disconnect();
              this.observer = null;
            }
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
          }
          initObserver() {
            if (this.observer) return;
            this.observer = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                  this.initSwiper();
                  this.observer.disconnect();
                  this.observer = null;
                }
              },
              { threshold: 0.2 }
            ); // 例如20%进入视口时触发
            this.observer.observe(this);
          }
          initSwiper() {
            const swiperElement = this.querySelector('.integrated-service-download__swiper');
            const wrapper = swiperElement.querySelector('.swiper-wrapper');
            const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
            const originalCount = originalSlides.length;

            // 确保 size 数字化；如果没有 data-size，回退到 slides 长度
            const sizeAttr = wrapper.getAttribute('data-size');
            const size = Number(sizeAttr) || originalCount;

            // 始终展示 5 个
            const desiredVisible = 5;

            // loop 需要的最少真实 slides
            const loopAdditional = 2;
            const minNeeded = Math.max(originalCount, desiredVisible + loopAdditional + 1); // e.g. 8

            // 复制所有的 slides 一次，确保有足够的 slides 供 loop 使用
            originalSlides.forEach((slide) => {
              const clonedSlide = slide.cloneNode(true); // 克隆每个 slide
              wrapper.appendChild(clonedSlide); // 追加克隆的 slide 到 wrapper
            });

            // 现在可以安全地初始化 Swiper（DOM 已经是完整的）
            this.swiper = new Swiper(swiperElement, {
              effect: 'creative',
              centeredSlides: true,
              slidesPerView: 'auto',
              loop: true,
              loopedSlides: originalCount, // 告诉 Swiper 原始循环单位（可提高稳定性）
              preventInteractionOnTransition: true,
              loopAdditionalSlides: loopAdditional,

              breakpoints: {
                0: {
                  creativeEffect: {
                    limitProgress: 2,
                    prev: { translate: ['-17.2%', 0, 0], origin: 'center center', scale: 0.8 },
                    next: { translate: ['17.2%', 0, 0], origin: 'center center', scale: 0.8 },
                  },
                },
                641: {
                  creativeEffect: {
                    limitProgress: 2,
                    prev: { translate: ['-18.5%', 0, 0], origin: 'center center', scale: 0.8 },
                    next: { translate: ['18.5%', 0, 0], origin: 'center center', scale: 0.8 },
                  },
                },
                1281: {
                  creativeEffect: {
                    limitProgress: 2,
                    prev: { translate: ['-16%', 0, 0], origin: 'center center', scale: 0.8 },
                    next: { translate: ['16%', 0, 0], origin: 'center center', scale: 0.8 },
                  },
                },
              },

              pagination: {
                el: swiperElement.querySelector('.integrated-service-download__swiper-pagination'),
                bulletClass: 'integrated-service-download__swiper-bullet',
                bulletActiveClass: 'integrated-service-download__swiper-bullet_active',
                clickable: true,

                // renderBullet: 确保只渲染与原始 slides 数量对应的分页点
                renderBullet: (index, className) => {
                  // 只渲染原始数量的 bullets
                  if (index >= originalCount) return '';
                  return `<span class="${className}"></span>`;
                },
              },

              on: {
                init: () => {
                  // 初始化时更新右侧内容（使用 realIndex）
                  this.updateRightContent(0);
                },
              },
            });

            // 更新 slideChange 逻辑（用 realIndex 映射 originalCount）
            this.swiper.on('slideChange', () => {
              // realIndex 是基于原始 slides 计数的（由于 loopedSlides 设置，通常代表原始 index）
              const realIndex = this.swiper.realIndex % originalCount;
              this.updateRightContent(realIndex);

              // 手动更新分页点的激活状态（确保分页与真实的 slide 切换同步）
              const pagination = swiperElement.querySelector('.integrated-service-download__swiper-pagination');
              if (pagination) {
                const bullets = pagination.querySelectorAll('.integrated-service-download__swiper-bullet');
                bullets.forEach((bullet, i) => {
                  if (i === realIndex) {
                    bullet.classList.add('integrated-service-download__swiper-bullet_active');
                  } else {
                    bullet.classList.remove('integrated-service-download__swiper-bullet_active');
                  }
                });
              }
            });
          }

          init() {
            const mobileDownloadBtn = this.querySelector('.integrated-service-download__mobile-download-btn');

            if (mobileDownloadBtn) {
              mobileDownloadBtn.addEventListener('click', () => {
                window.litime.openLitimeApp('warrantyPage');
              });
            }
          }

          // 更新右侧内容
          updateRightContent(index) {
            const rightItems = document.querySelectorAll('.integrated-service-download__right-item-top');
            rightItems.forEach((item, i) => {
              if (i === index) {
                item.classList.add('active');
              } else {
                item.classList.remove('active');
              }
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["integrated-service-end"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('integrated-service-end')) {
      customElements.define(
        'integrated-service-end',
        class IntegratedServiceEnd extends HTMLElement {
          constructor() {
            super();
            this.buttonTimer = null;
          }
          connectedCallback() {
            this.init();
            this.initCurrentId();
          }
          init() {
            const header = this.querySelector('.integrated-service-end__header');
            const previousButton = this.querySelector('.integrated-service-end__header i');

            previousButton.addEventListener('click', function () {
              console.log(previousButton, 'previousButton');
              const previousId = header.getAttribute('data-id');
              const moduleId = header.getAttribute('data-module-id');
              console.log(previousId, moduleId);
              document.querySelector(`#${previousId}`)?.setAttribute('data-show', 'true');
              document.querySelector(`#${moduleId}`)?.setAttribute('data-show', 'false');
              const urlParams = new URLSearchParams(window.location.search);
              urlParams.set('currentId', previousId);
              window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
            });

            const mobileDownloadBtn = this.querySelector('.integrated-service-end__app-download-btn');
            const goHomeBtn = this.querySelector('.integrated-service-end__button');

            if (goHomeBtn) {
              goHomeBtn.addEventListener('click', () => {
                // 点击过跳转则不再自动跳转
                clearTimeout(this.buttonTimer);
              });
            }
            if (mobileDownloadBtn) {
              mobileDownloadBtn.addEventListener('click', () => {
                // 点击过下载则不再自动跳转
                clearTimeout(this.buttonTimer);
                window.litime.openLitimeApp('warrantyPage');
              });
            }

            if (window.litime && window.litime.onVisibleOnce) {
              window.litime.onVisibleOnce(this, () => {
                // 礼花效果触发（仅触发一次）
                window.litime.fireworks('integrated-service-end__container', 'integrated-service-end__canvas', [
                  {
                    origin: 'bottom',
                    direction: 'up',
                    count: 50,
                    size: 10,
                    spread: 90,
                    force: 6,
                    // 全局向下重力（小）——可以稍微增大到 0.3 让落得更快
                    globalDown: 0.01,
                    // 推力衰减系数：越接近 1.0 推力衰减越慢，粒子会保持更久的“被推”状态
                    thrustDecay: 0.8,
                  },
                  // {
                  //   origin: 'bottom-left',
                  //   direction: 'up-right',
                  //   count: 40,
                  //   size: 10,
                  //   spread: 50,
                  //   force: 8,
                  //   globalDown: 0.03,
                  //   thrustDecay: 0.85,
                  // },
                ]);

                // 每次标签只执行一次
                const firstIntegratedServiceEnd = window.sessionStorage.getItem('firstIntegratedServiceEnd');
                // 五秒后跳转
                if (window.innerWidth <= 1280 && !firstIntegratedServiceEnd) {
                  window.sessionStorage.setItem('firstIntegratedServiceEnd', true);
                  const button = this.querySelector('.integrated-service-end__button');
                  const link = button.getAttribute('href');
                  this.buttonTimer = setTimeout(() => {
                    window.location.href = link;
                    clearTimeout(this.buttonTimer);
                  }, 5000);
                }
              });
            }
          }
          initCurrentId() {
            const urlParams = new URLSearchParams(window.location.search);
            const currentId = urlParams.get('currentId');
            if (currentId && currentId === this.getAttribute('id')) {
              // 并且将data-type="integrated-service"的dom设置为data-show='false'
              const siblings = document.querySelectorAll(`[data-type="integrated-service"]`);
              siblings.forEach((sibling) => {
                sibling.setAttribute('data-show', 'false');
              });
              document.querySelector(`#${currentId}`)?.setAttribute('data-show', 'true');
              // 清楚URL中currentId参数
              urlParams.delete('currentId');
              window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["integrated-service-member"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('integrated-service-member')) {
      customElements.define(
        'integrated-service-member',
        class integratedServiceMember extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            this.initCurrentId();
          }
          init() {
            const button = this.querySelector('.integrated-service-member__container-content-main-right-button');
            if (button) {
              button.addEventListener('click', () => {
                if (button.getAttribute('data-event') === 'register') {
                  window.litime.eventBus.publish('REGISTER');
                } else {
                  window.litime.eventBus.publish('LOGIN');
                }
              });
            }
          }
          initCurrentId() {
            const urlParams = new URLSearchParams(window.location.search);
            const currentId = urlParams.get('currentId');
            if (currentId && currentId === this.getAttribute('id')) {
              // 并且将data-type="integrated-service"的dom设置为data-show='false'
              const siblings = document.querySelectorAll(`[data-type="integrated-service"]`);
              siblings.forEach((sibling) => {
                sibling.setAttribute('data-show', 'false');
              });
              document.querySelector(`#${currentId}`)?.setAttribute('data-show', 'true');
              // 清楚URL中currentId参数
              urlParams.delete('currentId');
              window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["integrated-service-video"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('integrated-service-video')) {
      customElements.define(
        'integrated-service-video',
        class IntegratedServiceVideo extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initTabs();
            this.initTabsShade();
          }
          initTabs() {
            const tabs = this.querySelectorAll('.integrated-service-video__container-content-tab');
            tabs.forEach((item, index) => {
              item.addEventListener('click', () => this.setActiveTab(item, index));
            });
          }
          setActiveTab(item, index) {
            const tabs = this.querySelectorAll('.integrated-service-video__container-content-tab');
            tabs.forEach((tab) => tab.setAttribute('data-active', 'false'));
            item.setAttribute('data-active', 'true');
            const panels = this.querySelectorAll('.integrated-service-video__container-content-panel-item');
            panels.forEach((panel) => panel.setAttribute('data-active', 'false'));
            panels[index].setAttribute('data-active', 'true');

            this.scrollToLeft(item);
          }
          scrollToLeft(item) {
            const tabs = this.querySelector('.integrated-service-video__container-content-tabs');
            if (!tabs || !item) return;

            // 目标位置 = item 的左侧 offset - 20px
            const targetLeft = item.offsetLeft - 20;

            tabs.scrollTo({
              left: targetLeft,
              behavior: 'smooth',
            });
          }
          initTabsShade() {
            const container = this.querySelector('.integrated-service-video__container-content-tabs-container');
            const tabs = this.querySelectorAll('.integrated-service-video__container-content-tab');
            const lastTab = tabs[tabs.length - 1];

            if (!container || !lastTab) return;

            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  // entry.isIntersecting === true → 最后一个 tab 在视图内 → 隐藏阴影
                  if (entry.isIntersecting) {
                    container.classList.remove('show-right-shade');
                  } else {
                    container.classList.add('show-right-shade');
                  }
                });
              },
              {
                root: container,
                threshold: 1.0,
              }
            );

            observer.observe(lastTab);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ip_verify"]) return;
  try {
    
  $(function () {
    if (!customElements.get('ip-verify')) {
      customElements.define(
        'ip-verify',
        class ipVerify extends HTMLElement {
          constructor() {
            super();
            this.SITE_URL_MAP = {
              US: 'https://www.litime.com/',
              CA: 'https://ca.litime.com/',
              DE: 'https://www.litime.de/',
              UK: 'https://uk.litime.com/',
              JP: 'https://jp.litime.com/',
              AU: 'https://au.litime.com/',
              IT: 'https://litime.it/',
              FR: 'https://fr.litime.com/',
              ES: 'https://litime.es/',
            };

            this.storageKey = 'ip_verify_closed';
          }
          connectedCallback() {
            this.init();
            this.optionClickHandler = this.handleOptionClickBound.bind(this);
            document.addEventListener('global-select:option-click', this.optionClickHandler);
          }

          async init() {
            const isClosed = sessionStorage.getItem(this.storageKey) === 'true';

            if (isClosed) return;

            this.siteOptions = [
              { value: 'US', label: 'United States' },
              { value: 'CA', label: 'Canada' },
              { value: 'DE', label: 'Deutschland' },
              { value: 'UK', label: 'United Kingdom' },
              { value: 'JP', label: '日本' },
              { value: 'AU', label: 'Australia' },
              { value: 'IT', label: 'Italia' },
              { value: 'FR', label: 'France' },
              { value: 'ES', label: 'España' },
            ];

            await this.getCountrySite();
            this.selectedSite = this.countrySite;
            const currentSite = typeof Shopify !== 'undefined' ? Shopify.country : null;
            const shouldShow = this.selectedSite && currentSite !== this.selectedSite;
            if (shouldShow) {
              this.updateDisplay();
              this.showWithAnimation();
              this.bindEvents();
            }
          }

          showWithAnimation() {
            const container = this.querySelector('.ip-verify-container');
            if (container) {
              container.style.display = 'block';
              requestAnimationFrame(() => {
                requestAnimationFrame(() => container.classList.add('show'));
              });
            }
          }

          updateDisplay() {
            const siteOption = this.siteOptions.find((option) => option.value === this.selectedSite);
            const selectValueElement = this.querySelector('.select-value');
            if (siteOption && selectValueElement) {
              selectValueElement.textContent = siteOption.label;
            }
          }

          bindEvents() {
            this.querySelector('button')?.addEventListener('click', () => {
              const url = this.SITE_URL_MAP[this.selectedSite];
              if (url) window.location.href = url;
            });

            this.querySelectorAll('.ip_verify_close').forEach((closeBtn) => {
              closeBtn.addEventListener('click', () => this.hideWithAnimation());
            });
          }

          hideWithAnimation() {
            const container = this.querySelector('.ip-verify-container');
            if (container) {
              sessionStorage.setItem(this.storageKey, 'true');
              container.classList.remove('show');
              setTimeout(() => container.remove(), 400);
            }
          }

          async getCountrySite() {
            try {
              const res = await window.litime.http.get('/shopify/country/get');
              this.countrySite = res.code === 200 && res.data ? res.data : null;
            } catch (error) {
              console.error('[ip_verify] 获取国家站点失败:', error);
              this.countrySite = null;
            }
          }

          handleOptionClickBound(event) {
            const { componentType, data } = event.detail;
            if (componentType !== 'ip_verify' || !data?.value) return;
            this.selectedSite = data.value;
            this.updateDisplay();
          }

          disconnectedCallback() {
            document.removeEventListener('global-select:option-click', this.optionClickHandler);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laboratory-adsorption"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('laboratory-adsorption')) {
      customElements.define(
        'laboratory-adsorption',
        class ProductForm extends HTMLElement {
          sticky_start = 0;
          changeStatus = false;
          _this = null;
          clickPoint = false;
          constructor() {
            super();
          }
          connectedCallback() {
            const _this = this;
            this.init();

            $(window).on('scroll', _this.scrollHandler.bind(_this));
          }
          disconnectedCallback() {
            const _this = this;
            $(window).off('scroll', _this.scrollHandler.bind(_this));
          }

          scrollHandler() {
            if (this.clickPoint) {
              return;
            }
            const adsorption = $(this).find('#adsorption');
            const Points = $(this).find('[data-jump]');
            let sticky = adsorption.offset().top;

            const scrollTop = $(window).scrollTop();
            if (scrollTop > sticky && !this.changeStatus) {
              this.changeStatus = true;
              this.sticky_start = sticky;
              adsorption.addClass('adsorption_sticky');
              adsorption.css('top', '0');
            }
            if (this.changeStatus && $(window).scrollTop() < this.sticky_start - 10) {
              this.changeStatus = false;
              adsorption.removeClass('adsorption_sticky');
              adsorption.css('top', '0');
            } else if (this.changeStatus) {
              adsorption.css('top', '0');
            }
            Points.each(function () {
              const targetPoint = $(this).attr('data-jump');
              if (!targetPoint) return;
              // 兼容两种选择方式：优先尝试 data-point，如果不存在则尝试 ID
              let $targetElement = $(`[data-point="${targetPoint}"]`);
              if (!$targetElement.length) {
                $targetElement = $(`#${targetPoint}`);
              }
              if (!$targetElement.length) return;
              var targetOffset = $targetElement.offset().top; // 获取目标元素的顶部位置
              var targetHeight = $targetElement.outerHeight(); // 获取目标元素的高度

              // 判断锚点元素是否进入视口
              if (
                $(window).scrollTop() >= targetOffset - 50 &&
                $(window).scrollTop() < targetOffset + targetHeight - 50
              ) {
                // 当目标元素在视口中时，给对应的链接添加 'active' 类
                Points.removeClass('adsorption_active'); // 移除所有链接的 'active' 类
                $(this).addClass('adsorption_active'); // 给当前链接添加 'active' 类
                // 添加滚动到居中的逻辑
                const tabBox = $(this).closest('.point_wrapper')[0];
                if (tabBox) {
                  const tab = this;
                  const tabRect = tab.getBoundingClientRect();
                  const boxRect = tabBox.getBoundingClientRect();
                  const targetScroll =
                    tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;
                  tabBox.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth',
                  });
                }
              }
            });
          }

          init() {
            const _this = this;
            let adsorption = $(this).find('#adsorption');
            this.sticky_start = adsorption.offset().top;
            const Points = $(this).find('[data-jump]');
            Points.on('click', function (e) {
              e.preventDefault(); // 阻止默认跳转行为
              Points.removeClass('adsorption_active'); // 移除所有链接的 'active' 类
              $(this).addClass('adsorption_active'); // 给当前链接添加 'active' 类
            });
            // 为每个 jumpPoint 元素添加点击事件
            Points.each(function () {
              $(this).on('click', function () {
                if (_this.clickPoint) {
                  return;
                }
                _this.clickPoint = true;

                // 获取当前点击元素的 data-jump 属性值
                const dataPoint = $(this).data('jump');
                if (!dataPoint) return;
                // 根据 data-jump 获取对应的 marker-point 元素，兼容两种选择方式
                let $markerPoint = $(`[data-point="${dataPoint}"]`);
                if (!$markerPoint.length) {
                  $markerPoint = $(`#${dataPoint}`);
                }
                // 如果找到了对应的 marker-point 元素，则滚动到该元素
                if ($markerPoint.length) {
                  $('html, body').animate(
                    {
                      scrollTop: $($markerPoint[0]).offset().top + 30,
                    },
                    300,
                    function () {
                      _this.clickPoint = false;
                      _this.scrollHandler();
                    }
                  );
                } else {
                  _this.clickPoint = false;
                }
                // 添加滚动到居中的逻辑
                const tabBox = $(this).closest('.point_wrapper')[0];
                if (tabBox) {
                  const tab = this;
                  const tabRect = tab.getBoundingClientRect();
                  const boxRect = tabBox.getBoundingClientRect();
                  const targetScroll =
                    tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;
                  tabBox.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth',
                  });
                }
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-v2"]) return;
  try {
    
  $(function () {
    if (!customElements.get('main-cart-v2')) {
      customElements.define(
        'main-cart-v2',
        class MainCart extends HTMLElement {
          connectedCallback() {
            this.sectionId = this.querySelector('.main-cart-v2-section').getAttribute('data-section-id');
            const buyNowBtn = this.querySelector('.buy-now-btn-cart-main');
            if (buyNowBtn) {
              $(buyNowBtn).find('.rotate_icon').hide();
            }

            this.initInputNumber();
            this.initCartPopupMessage();
            this.initRemoveButtons();
            this.initDiscountApply();
            this.initPaymentIconsToggle();
            this.buyNowBtn();
            this.cacheInvalidDiscountMessage();

            // 事件委托：监听 tag remove 按钮（两个 web component 隔离，用事件冒泡）
            this.addEventListener('click', (e) => {
              const removeBtn = e.target.closest('.main-cart-discount-input-v2__tag-remove');
              if (!removeBtn) return;
              e.preventDefault();
              const removeCode = removeBtn.dataset.discountCode;
              if (!removeCode) return;

              if (removeBtn.dataset.loading) return;
              removeBtn.dataset.loading = 'true';
              const tagEl = removeBtn.closest('.main-cart-discount-input-v2__tag');
              const self = this;
              const tagsContainer = self.querySelector('.main-cart-discount-input-v2__tags');
              const currentDiscountsAttr = tagsContainer?.dataset.appliedDiscounts || '';
              const currentDiscounts = currentDiscountsAttr ? currentDiscountsAttr.split(',') : [];
              const remainingDiscounts = currentDiscounts.filter((code) => code.trim() !== removeCode);
              const sectionId = self.querySelector('.main-cart-v2-section')?.dataset.sectionId || '';

              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  discount: remainingDiscounts.join(','),
                  sections: sectionId,
                }),
              })
                .then((response) => {
                  if (response.ok) {
                    response.json().then((cartData) => {
                      const hasRemainingInvalid = cartData.discount_codes?.some(
                        (discount) => discount.applicable === false
                      );
                      const invalidDiscountMessage = hasRemainingInvalid ? self.getInvalidDiscountMessage() : '';

                      tagEl?.remove();
                      if (tagsContainer) tagsContainer.dataset.appliedDiscounts = remainingDiscounts.join(',');
                      if (tagsContainer && remainingDiscounts.length === 0) tagsContainer.style.display = 'none';

                      if (cartData.sections && cartData.sections[sectionId.trim()]) {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(cartData.sections[sectionId.trim()], 'text/html');
                        const mainCartSection = doc.querySelector('.main-cart-v2-section');
                        if (mainCartSection) {
                          self.querySelector('.main-cart-v2-section').innerHTML = mainCartSection.innerHTML;
                          self.reinitializeAfterUpdate();
                        }
                      }
                    });
                  }
                })
                .catch((error) => {
                  console.error('Failed to remove discount:', error);
                  removeBtn.dataset.loading = 'false';
                });
            });

            this.pageshowHandler = () => {
              // requestAnimationFrame(() => this.initGetCartContent());
            };
            window.addEventListener('pageshow', this.pageshowHandler);
          }

          disconnectedCallback() {
            if (this.pageshowHandler) {
              window.removeEventListener('pageshow', this.pageshowHandler);
            }
            if (this._documentClickHandler) {
              document.removeEventListener('click', this._documentClickHandler);
            }
          }

          cacheInvalidDiscountMessage() {
            const discountSection = this.querySelector('.main-cart-v2__discount-section');
            const container = this.querySelector('.main-cart-discount-input-v2');
            this.i18nInvalidDiscount =
              discountSection?.dataset.i18nInvalidDiscount || container?.dataset.i18nInvalidDiscount || '';
          }

          getInvalidDiscountMessage() {
            const discountSection = this.querySelector('.main-cart-v2__discount-section');
            const container = this.querySelector('.main-cart-discount-input-v2');
            return (
              discountSection?.dataset.i18nInvalidDiscount ||
              container?.dataset.i18nInvalidDiscount ||
              this.i18nInvalidDiscount ||
              ''
            );
          }

          initDiscountApply() {
            const discountInput = this.querySelector('#discount-code');
            const applyBtn = this.querySelector('.save-btn-discount');
            if (!discountInput || !applyBtn || applyBtn.dataset.bound) return;
            applyBtn.dataset.bound = 'true';

            const getContainer = () => this.querySelector('.main-cart-discount-input-v2');
            const getInputWrap = () => this.querySelector('.main-cart-discount-input-v2__input-wrap');
            const getErrorEl = () => {
              const c = getContainer();
              return c?.querySelector('.main-cart-discount-input-v2__error');
            };

            const showError = (message) => {
              const c = getContainer(),
                w = getInputWrap(),
                e = getErrorEl();
              if (c) c.dataset.error = 'true';
              if (w) w.dataset.error = 'true';
              if (e) e.textContent = message;
            };

            const clearError = () => {
              const c = getContainer(),
                w = getInputWrap(),
                e = getErrorEl();
              if (c) c.dataset.error = 'false';
              if (w) w.dataset.error = 'false';
              if (e) e.textContent = '';
            };

            discountInput.addEventListener('focus', () => {
              const inputWrap = getInputWrap();
              if (inputWrap) inputWrap.dataset.focused = 'true';
            });

            discountInput.addEventListener('blur', () => {
              const inputWrap = getInputWrap();
              if (inputWrap) inputWrap.dataset.focused = 'false';
            });

            const applyDiscount = async () => {
              const self = this;
              const code = (discountInput.value || '').trim();
              window.customGATracker?.trackEvent('lt_click', {
                module: 'main-cart-v2',
                element: 'apply_discount',
                discount_code: code,
                trigger_type: 'click',
              });
              clearError();

              if (!code) {
                showError(self.getInvalidDiscountMessage());
                return;
              }

              // 合并已应用的优惠码，避免 cart/update.js 用新码覆盖掉原有优惠码
              const tagsContainer = self.querySelector('.main-cart-discount-input-v2__tags');
              const existingDiscountsAttr = tagsContainer?.dataset.appliedDiscounts || '';
              const existingDiscounts = existingDiscountsAttr
                ? existingDiscountsAttr
                    .split(',')
                    .map((c) => c.trim())
                    .filter(Boolean)
                : [];
              const allDiscounts = existingDiscounts.some((d) => d.toLowerCase() === code.toLowerCase())
                ? existingDiscounts
                : [...existingDiscounts, code];

              applyBtn.disabled = true;
              applyBtn.dataset.loading = 'true';

              try {
                const formData = new FormData();
                formData.append('discount', allDiscounts.join(','));
                const sectionId = self.querySelector('.main-cart-v2-section').dataset.sectionId;
                formData.append('sections', sectionId.trim());

                const response = await fetch('/cart/update.js', {
                  method: 'POST',
                  body: formData,
                });

                if (response.ok) {
                  const cartData = await response.json();
                  const matchedCode = cartData.discount_codes?.find((d) => d.code.toLowerCase() === code.toLowerCase());

                  if (matchedCode?.applicable === true) {
                    discountInput.value = '';
                    clearError();
                    if (cartData.sections && cartData.sections[sectionId.trim()]) {
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(cartData.sections[sectionId.trim()], 'text/html');
                      const mainCartSection = doc.querySelector('.main-cart-v2-section');
                      if (mainCartSection) {
                        self.querySelector('.main-cart-v2-section').innerHTML = mainCartSection.innerHTML;
                        self.reinitializeAfterUpdate();
                      }
                    }
                  } else {
                    showError(self.getInvalidDiscountMessage());
                  }
                } else {
                  showError(self.getInvalidDiscountMessage());
                }
              } catch (error) {
                console.error('Failed to apply discount:', error);
                showError('Failed to apply discount');
              } finally {
                applyBtn.dataset.loading = 'false';
                applyBtn.disabled = false;
              }
            };

            applyBtn.addEventListener('click', applyDiscount);
            discountInput.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                applyDiscount();
              }
            });

            discountInput.addEventListener('input', () => {
              clearError();
            });
          }

          async initGetCartContent() {
            const sectionId = this.querySelector('.main-cart-v2-section').dataset.sectionId;
            try {
              const sectionsRes = await fetch('/cart?sections=' + sectionId + '&t=' + Date.now());
              if (!sectionsRes.ok) return;

              const cartData = await sectionsRes.json();
              if (!cartData[sectionId.trim()]) return;

              const scrollPosition = window.scrollY;
              const parser = new DOMParser();
              const doc = parser.parseFromString(cartData[sectionId.trim()], 'text/html');
              const mainCartSection = doc.querySelector('.main-cart-v2-section');

              if (mainCartSection) {
                this.querySelector('.main-cart-v2-section').innerHTML = mainCartSection.innerHTML;
                this.reinitializeAfterUpdate();
                window.scrollTo(0, scrollPosition);
              }
            } catch (error) {
              console.error('重新加载购物车内容失败:', error);
            }
          }

          initInputNumber() {
            this.querySelectorAll('.option-container').forEach((container) => {
              const input = container.querySelector('.quick-number-input__input');
              if (!input) return;

              const $input = $(input);
              const $wrap = $input.closest('.quick-number-input__wrap');
              const $minus = $(container.querySelector('.input-number_minus'));
              const $plus = $(container.querySelector('.input-number_plus'));

              $input.off('input blur');
              $minus.off('click');
              $plus.off('click');

              const setLoading = (source, isLoading) => {
                const loadingValue = isLoading ? 'true' : 'false';
                if (source === 'minus') {
                  $minus.attr('data-loading', loadingValue);
                } else if (source === 'plus') {
                  $plus.attr('data-loading', loadingValue);
                } else if (source === 'input') {
                  $wrap.attr('data-loading', loadingValue);
                }
              };

              const clearLoading = () => {
                setLoading('minus', false);
                setLoading('plus', false);
                setLoading('input', false);
              };

              const updateButtonStates = () => {
                const val = parseInt($input.val(), 10) || 1;
                const max = parseInt($input.data('max'), 10) || 999;
                if (val >= max) {
                  $plus.css('pointer-events', 'none');
                  $plus.find('.quick-number-input__icon').css('opacity', '0.3');
                } else {
                  $plus.css('pointer-events', '');
                  $plus.find('.quick-number-input__icon').css('opacity', '');
                }
                if (val <= 1) {
                  $minus.css('pointer-events', 'none');
                  $minus.find('.quick-number-input__icon').css('opacity', '0.3');
                } else {
                  $minus.css('pointer-events', '');
                  $minus.find('.quick-number-input__icon').css('opacity', '');
                }
              };

              $input.on('input', () => {
                const digitsOnly = ($input.val() || '').replace(/\D/g, '');
                if (digitsOnly === '') {
                  $input.val('');
                } else {
                  $input.val(parseInt(digitsOnly, 10));
                }
                updateButtonStates();
              });

              $input.on('blur', () => {
                const max = parseInt($input.data('max'), 10) || 999;
                const id = $input.attr('id');
                const key = $input.attr('key');
                const digitsOnly = ($input.val() || '').replace(/\D/g, '');
                let value = parseInt(digitsOnly, 10) || 1;
                if (value < 1) value = 1;
                if (value > max) value = max;
                $input.val(value);
                const defaultVal = $input.prop('defaultValue');
                setLoading('input', true);
                this.triggerQuantityChange(value, id, key, $input, clearLoading, defaultVal, () => {
                  clearLoading();
                  updateButtonStates();
                });
              });

              $minus.on('click', () => {
                if (+$input.val() > 1) {
                  const defaultVal = $input.prop('defaultValue');
                  setLoading('minus', true);
                  this.triggerQuantityChange(
                    +$input.val() - 1,
                    $input.attr('id'),
                    $input.attr('key'),
                    $input,
                    clearLoading,
                    defaultVal,
                    () => {
                      clearLoading();
                      updateButtonStates();
                    }
                  );
                }
              });

              $plus.on('click', (event) => {
                event.preventDefault();
                const max = parseInt($input.data('max'), 10) || 999;
                if (+$input.val() < max) {
                  const defaultVal = $input.prop('defaultValue');
                  setLoading('plus', true);
                  this.triggerQuantityChange(
                    +$input.val() + 1,
                    $input.attr('id'),
                    $input.attr('key'),
                    $input,
                    clearLoading,
                    defaultVal,
                    () => {
                      clearLoading();
                      updateButtonStates();
                    }
                  );
                } else {
                  window.litime.showToast('error', window.i18n.quantityErrorV2);
                }
              });

              updateButtonStates();
            });
          }

          async triggerQuantityChange(newValue, id, key, $input, clearLoading, defaultVal, onComplete) {
            try {
              const sectionId = this.querySelector('.main-cart-v2-section').dataset.sectionId;
              const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: key,
                  quantity: newValue,
                  sections: sectionId.trim() + ',cart-icon-bubble',
                }),
              });

              if (response.ok) {
                const cartData = await response.json();
                if (cartData.sections?.[sectionId.trim()]) {
                  const scrollPosition = window.scrollY;
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(cartData.sections[sectionId.trim()], 'text/html');
                  const mainCartSection = doc.querySelector('.main-cart-v2-section');

                  if (mainCartSection) {
                    this.querySelector('.main-cart-v2-section').innerHTML = mainCartSection.innerHTML;
                    clearLoading?.();
                    this.reinitializeAfterUpdate();
                    window.scrollTo(0, scrollPosition);
                    $input.val(newValue);
                    window.dispatchEvent(new CustomEvent('quantityChange', { detail: $input.val() }));
                    this.updateCartIconBubble(cartData);
                    onComplete?.();
                  }
                }
              } else {
                clearLoading?.();
                const cartData = await response.json();
                $input.val(response.status === 200 ? newValue : defaultVal);
                if (response.status !== 200) {
                  window.litime.showToast('error', cartData.message);
                }
                onComplete?.();
              }
            } catch (error) {
              console.error('更新数量失败:', error);
              clearLoading?.();
              onComplete?.();
            }
          }

          initCartPopupMessage() {
            const $textareas = $(this.querySelectorAll('.special-instructions'));

            $textareas.each((_, textarea) => {
              const $textarea = $(textarea);
              $textarea.off('input keydown blur');

              $textarea.on('keydown', async (e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  await this.saveCartNote($textarea.val(), $textareas, $textarea);
                }
              });

              $textarea.on('blur', async () => {
                await this.saveCartNote($textarea.val(), $textareas, $textarea);
              });
            });
          }

          async saveCartNote(messageContent, $textareas, $textarea) {
            try {
              const response = await fetch('/cart/update', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ note: messageContent }),
              });

              if (response.ok) {
                $textarea.blur();
                $textareas.not($textarea).val(messageContent);
                const cartPopupMessage = document.querySelector('cart-popup-message');
                if (cartPopupMessage) {
                  cartPopupMessage.setAttribute('data-note', messageContent);
                  cartPopupMessage.value = messageContent;
                }
              } else {
                window.litime.showToast('error', window.i18n.noStock);
              }
            } catch (error) {
              console.error('更新留言失败:', error);
            }
          }

          buyNowBtn() {
            const buyNowBtn = this.querySelector('.buy-now-btn-cart-main');
            if (!buyNowBtn || buyNowBtn.dataset.bound) return;
            buyNowBtn.dataset.bound = 'true';

            buyNowBtn.addEventListener('click', async () => {
              const discountCodeInput = this.querySelector('.discount-code-main');
              let discountCode = discountCodeInput?.value?.trim() || '';

              $(buyNowBtn).find('.rotate_icon').show();
              $(buyNowBtn).find('.loading-button-text').hide();

              window.location.href = discountCode
                ? `/checkout?discount=${encodeURIComponent(discountCode)}`
                : '/checkout';
            });
          }

          initRemoveButtons() {
            this.querySelectorAll('.icon-close').forEach((button) => {
              if (button.dataset.bound) return;
              button.dataset.bound = 'true';
              button.addEventListener('click', async (event) => {
                event.preventDefault();
                const cartItem = button.closest('.cart-item');
                const cartItemId = cartItem?.dataset.id;
                const itemKey = cartItem?.dataset.key;
                const sectionId = this.querySelector('.main-cart-v2-section').dataset.sectionId;
                const flowItem = this.querySelector('.flow-item-' + cartItemId);

                if (flowItem) this.cartInputNumberLoading(flowItem, false);
                if (!cartItemId) return;

                try {
                  const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      id: itemKey,
                      quantity: 0,
                      sections: sectionId.trim() + ',cart-icon-bubble',
                    }),
                  });

                  if (response.ok) {
                    const cartData = await response.json();
                    if (cartData.items && cartData.items.length === 0) {
                      window.location.reload();
                      return;
                    }

                    if (cartData.sections?.[sectionId.trim()]) {
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(cartData.sections[sectionId.trim()], 'text/html');
                      const mainCartSection = doc.querySelector('.main-cart-v2-section');
                      if (mainCartSection) {
                        this.querySelector('.main-cart-v2-section').innerHTML = mainCartSection.innerHTML;
                        this.reinitializeAfterUpdate();
                        this.updateCartIconBubble(cartData);
                        this._reloadRecommendation(cartData);
                      }
                    }
                    window.litime.showToast('success', window.i18n.delete_message);
                  }
                } catch (error) {
                  console.error('删除商品失败:', error);
                }
              });
            });
          }

          removeCartInputNumberLoading(className) {
            className?.querySelector('.loading-container')?.remove();
          }

          cartInputNumberLoading(className, flag) {
            if (!className) return;
            const loadingContainer = document.createElement('div');

            if (flag) {
              loadingContainer.className = 'loading-container';
              loadingContainer.innerHTML = `
                 <div class="loading-container-unshadow">
                  <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                    <div
                      class="loader-animation"
                      style="border:2px solid #181818; border-left-color: transparent;width:12px;height:12px;"
                    ></div>
                  </div>
                </div>
            `;
            } else {
              loadingContainer.className = 'loading-container';
              loadingContainer.innerHTML = `
              <div class="loading-container-shadow"></div>
                  <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
              <div class="loader-animation" style="border:2px solid #181818; border-left-color: transparent;"></div>
              </div>
            `;
            }
            className.appendChild(loadingContainer);
          }

          _reloadRecommendation(cartData) {
            const recommendationEl = document.querySelector('cart-product-recommendation-v2');
            if (!recommendationEl) return;
            const firstProductId = cartData.items?.[0]?.product_id;
            if (firstProductId) {
              recommendationEl.reloadWithNewProductId(firstProductId);
            }
          }

          updateCartIconBubble(cartData) {
            if (cartData.sections?.['cart-icon-bubble']) {
              const parser = new DOMParser();
              const iconDoc = parser.parseFromString(cartData.sections['cart-icon-bubble'], 'text/html');
              const iconBubble = document.querySelector('cart-icon-bubble');
              const newIconContent = iconDoc.querySelector('cart-icon-bubble');
              if (iconBubble && newIconContent) {
                iconBubble.innerHTML = newIconContent.innerHTML;
                return;
              }
            }

            if (cartData.item_count !== undefined) {
              const cartIconElement = document.querySelector('#cart-icon-bubble');
              if (cartIconElement && window.updateCartBubble) {
                window.updateCartBubble(cartIconElement, cartData.item_count);
              }
            }
          }

          initPaymentIconsToggle() {
            const container = this.querySelector('[data-payment-icons]');
            if (!container) return;
            if (this._paymentIconsInit) return;
            this._paymentIconsInit = true;

            const iconList = container.querySelector('.main-cart-v2__payment-icon-list');
            const toggleBtn = container.querySelector('[data-toggle-payment]');
            if (!iconList || !toggleBtn) return;
            const spanText = toggleBtn.querySelector('[data-text]');
            const iconExpand = toggleBtn.querySelector('.icon-expand');
            const iconCollapse = toggleBtn.querySelector('.icon-collapse');
            const showMoreText = this.dataset.showMoreText;
            const showLessText = this.dataset.showLessText;

            const lineHeight = 26;

            const checkFit = () => {
              const scrollHeight = iconList.scrollHeight;
              if (scrollHeight > lineHeight) {
                toggleBtn.style.display = '';
                container.classList.add('is-collapsed');
                if (!container.dataset.isExpanded) {
                  container.dataset.isExpanded = 'false';
                }
              } else {
                toggleBtn.style.display = 'none';
                container.dataset.isExpanded = 'false';
              }
            };

            const ro = new ResizeObserver(() => checkFit());
            ro.observe(iconList);

            toggleBtn.addEventListener('click', () => {
              const isExpanded = container.dataset.isExpanded === 'true';
              const next = String(!isExpanded);
              container.dataset.isExpanded = next;
              // container.classList.toggle('is-collapsed', !isExpanded);
              iconList.classList.toggle('is-height-collapsed', !isExpanded);
              spanText.textContent = isExpanded ? showMoreText : showLessText;
              iconExpand.style.display = isExpanded ? '' : 'none';
              iconCollapse.style.display = isExpanded ? 'none' : '';
            });

            checkFit();
          }

          reinitializeAfterUpdate() {
            this.sectionId = this.querySelector('.main-cart-v2-section').getAttribute('data-section-id');
            this.cacheInvalidDiscountMessage();
            this.initInputNumber();
            this.initCartPopupMessage();
            this.initRemoveButtons();
            this.initDiscountApply();
            this.initPaymentIconsToggle();
            this.buyNowBtn();
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('main-collection-v2')) {
      customElements.define(
        'main-collection-v2',
        class MainCollectionV2 extends HTMLElement {
          connectedCallback() {
            this._handleClick = this.handleClick.bind(this);
            this._handlePopState = this.handlePopState.bind(this);

            this.addEventListener('click', this._handleClick);
            window.addEventListener('popstate', this._handlePopState);
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._handleClick);
            window.removeEventListener('popstate', this._handlePopState);
          }

          handleClick(event) {
            const paginationLink = event.target.closest(
              'a.collection-product-list-v2__pagination-page, a.collection-product-list-v2__pagination-arrow'
            );
            if (!paginationLink || !this.contains(paginationLink)) return;

            event.preventDefault();
            this.navigateToUrl(paginationLink.href);
          }

          handlePopState() {
            this.renderSectionFromFetch(window.location.pathname + window.location.search);
          }

          navigateToUrl(url) {
            window.history.pushState({}, '', url);
            this.renderSectionFromFetch(url);

            const content = this.querySelector('.main-collection-v2__content');
            if (content) {
              content.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }

          buildCollectionUrl(params) {
            const query = params.toString();
            return query ? `${window.location.pathname}?${query}` : window.location.pathname;
          }

          applyFilters(filterParams) {
            const params = filterParams instanceof URLSearchParams ? filterParams : new URLSearchParams(filterParams);
            const currentUrlParams = new URLSearchParams(window.location.search);
            const sortByParam = currentUrlParams.get('sort_by');

            if (sortByParam) {
              params.set('sort_by', sortByParam);
            }

            params.delete('page');

            this.navigateToUrl(this.buildCollectionUrl(params));
          }

          renderSectionFromFetch(url) {
            window.litime.showLoading();

            fetch(url)
              .then((response) => {
                if (response.status === 200) {
                  return response.text();
                }
                throw new Error('Network response was not ok');
              })
              .then((responseText) => {
                const doc = new DOMParser().parseFromString(responseText, 'text/html');
                const productGrid = doc.querySelector('#CollectionProductGridV2');
                const filterPc = doc.querySelector('.main-collection-v2__filter-pc');
                const filterMobile = doc.querySelector('.main-collection-v2__content-header-filter-mobile');
                const sortHeader = doc.querySelector('.main-collection-v2__content-header-sort');

                if (productGrid) {
                  const currentGrid = this.querySelector('#CollectionProductGridV2');
                  if (currentGrid) {
                    currentGrid.innerHTML = productGrid.innerHTML;
                  }
                }

                if (filterPc) {
                  const currentFilterPc = this.querySelector('.main-collection-v2__filter-pc');
                  if (currentFilterPc) {
                    currentFilterPc.innerHTML = filterPc.innerHTML;
                  }
                }

                if (filterMobile) {
                  const currentFilterMobile = this.querySelector('.main-collection-v2__content-header-filter-mobile');
                  if (currentFilterMobile) {
                    currentFilterMobile.innerHTML = filterMobile.innerHTML;
                  }
                }

                if (sortHeader) {
                  const currentSortHeader = this.querySelector('.main-collection-v2__content-header-sort');
                  if (currentSortHeader) {
                    currentSortHeader.innerHTML = sortHeader.innerHTML;
                  }
                }

                const openMobileFilter = this.querySelector('collection-filter-mobile-v2[data-open="true"]');
                if (openMobileFilter && window.litime?.enableScroll) {
                  window.litime.enableScroll();
                }

                window.litime.hideLoading();
              })
              .catch((error) => {
                console.error('[main-collection-v2] fetch error:', error);
                window.litime.hideLoading();
              });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('main-collection')) {
      customElements.define(
        'main-collection',
        class mainCollection extends HTMLElement {
          sticky_start = 0;
          sticky_height = 0;
          changeStatus = false;
          constructor() {
            super();
          }

          connectedCallback() {
            const _this = this;
            this.initScroll();
            this.init();
            $(window).scroll(_this.scrollHandler.bind(_this));
          }

          init() {
            const $mySwiper = this.querySelector('.main-collection_swiper');
            const $next = this.querySelector('.main-collection_next');
            const $prev = this.querySelector('.main-collection_prev');
            const $scrollbar = this.querySelector('.main-collection-scrollbar');
            const $mySwiperWidth = $($mySwiper).width();
            if ($mySwiperWidth < $($mySwiper).parent().width()) {
              $($next).addClass('hidden');
            } else {
              $($next).removeClass('hidden').addClass('flex');
            }

            const swiper = new Swiper($mySwiper, {
              spaceBetween: 32,
              slidesPerView: 'auto',
              freeMode: true,
              on: {
                progress: function (swiper, progress) {
                  if (this.isBeginning) {
                    $($prev).addClass('hidden');
                  } else {
                    $($prev).removeClass('hidden').addClass('flex');
                  }

                  if (this.isEnd) {
                    $($next).addClass('hidden');
                  } else {
                    $($next).removeClass('hidden').addClass('flex');
                  }
                },
              },
              navigation: {
                nextEl: $next,
                prevEl: $prev,
              },
              scrollbar: {
                el: $scrollbar,
                draggable: true,
              },
            });
            const allCurrentActive = $(this).find('.collection_link');
            allCurrentActive.each((index, item) => {
              if ($(item).data('current-active') == true) {
                if (index > 0) {
                  swiper.slideTo(index - 1, 300, true);
                }
              }
            });

            const $link = $(this).find('.collection_link');
            $link.on('click', function () {
              // 获取data-current-active
              const dataCurrentActive = $(this).data('current-active');
              if (dataCurrentActive) return;
              // 获取当前点击元素的 data-link 属性值
              const dataLink = $(this).data('link');
              if (!dataLink) return;
              window.open(dataLink, '_self');
            });
          }
          disconnectedCallback() {
            const _this = this;
            $(window).off('scroll', _this.scrollHandler);
          }

          scrollHandler() {
            const adsorption = $('#main-collection-sticky');
            const ltHeader = $('#lt-header');
            let sticky = 0;
            if (adsorption.attr('data-fixed') == 'true') {
              sticky = adsorption.offset().top;
            } else {
              sticky = this.sticky_start;
            }

            const scrollTop = $(window).scrollTop();
            const scrollingDown = scrollTop > (this.lastScrollTop || 0);
            this.lastScrollTop = scrollTop;

            if (scrollTop > sticky && !this.changeStatus) {
              this.changeStatus = true;
              this.sticky_start = sticky;
              adsorption.addClass('fixed');
              adsorption.attr('data-fixed', 'true');
              $(this.querySelector('.fixed_basic')).removeClass('hidden');
              adsorption.css('top', '0');
              if (!scrollingDown) {
                ltHeader.css('display', 'none');
              } else {
                ltHeader.css('display', 'block');
              }
            }
            if (this.changeStatus && $(window).scrollTop() < this.sticky_start - 10) {
              this.changeStatus = false;
              adsorption.removeClass('fixed');
              adsorption.attr('data-fixed', 'false');
              $(this.querySelector('.fixed_basic')).addClass('hidden');
              ltHeader.css('display', 'block');
            } else if (this.changeStatus) {
              adsorption.css('top', '0');
              if (!scrollingDown) {
                ltHeader.css('display', 'none');
              } else {
                ltHeader.css('display', 'block');
              }
            }
          }

          initScroll() {
            const adsorption = $('#main-collection-sticky');
            // 获取collection_name中高度最大值
            const $collectionName = $(this).find('.collection_name');
            const maxHeight = $collectionName
              .map(function () {
                return $(this).height();
              })
              .get();
            // maxHeight最大值
            const maxHeightValue = Math.max(...maxHeight);
            this.sticky_start = adsorption.offset().top + adsorption.height() - 66 - maxHeightValue;
            this.sticky_height = adsorption.height();
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-account-new"]) return;
  try {
    
  $(function () {
    if (!customElements.get('main-customers-account-new')) {
      customElements.define(
        'main-customers-account-new',
        class MainCustomersAccountNew extends HTMLElement {
          constructor() {
            super();
            this.currentPosition = 0;
          }
          connectedCallback() {
            this.init();
            window.litime.eventBus.subscribe('account:switchTab', (res) => {
              this.switchTab(res);
            });
            window.litime.eventBus.subscribe('account:initTask', () => {
              this.initTask();
            });
          }
          init() {
            this.initTabs();
            this.initPage();
            this.initTask();
          }
          initPage() {
            const url = window.location.href;
            const urlObj = new URL(url);
            const type = urlObj.searchParams.get('type');
            if (type) {
              this.switchTab(type);
            }
          }
          switchTab(tab) {
            const tabs = this.querySelectorAll('.main-customers-account-new__left-item');
            const rightItems = this.querySelectorAll('.main-customers-account-new__right-item');
            tabs.forEach((t) => {
              t.setAttribute('data-active', 'false');
            });
            rightItems.forEach((item) => {
              item.setAttribute('data-active', 'false');
            });
            const currentTab = this.querySelector(`.main-customers-account-new__left-item[data-tab="${tab}"]`);
            currentTab.setAttribute('data-active', 'true');
            const currentRightItem = this.querySelector(`.main-customers-account-new__right-item[data-tab="${tab}"]`);
            currentRightItem.setAttribute('data-active', 'true');
            if (tab === 'overview') {
              this.setAttribute('data-type', 'default');
              if (window.innerWidth <= 1200) {
                // ✅ 2. 滚动到记录的位置
                window.scrollTo({
                  top: this.currentPosition || 0,
                  behavior: 'auto', // 或 'smooth'
                });
              }
            } else {
              this.setAttribute('data-type', 'dialog');
            }
            if (tab === 'address') {
              // 只修改地址为/account/addresses，去除参数，不刷新页面
              const url = window.location.href;
              const urlObj = new URL(url);
              urlObj.pathname = '/account/addresses';
              urlObj.searchParams.delete('type');
              window.history.replaceState({}, '', urlObj.toString());
            } else {
              // 修改页面地址为/account?type=currentTab
              const url = window.location.href;
              const urlObj = new URL(url);
              urlObj.pathname = '/account';
              urlObj.searchParams.set('type', tab);
              window.history.replaceState({}, '', urlObj.toString());
            }
          }
          initTabs() {
            const tabs = this.querySelectorAll('.main-customers-account-new__left-item');
            const rightItems = this.querySelectorAll('.main-customers-account-new__right-item');
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                this.currentPosition = window.scrollY || window.pageYOffset;
                if (window.litime && window.litime.eventBus && typeof window.litime.eventBus.publish === 'function') {
                  window.litime.eventBus.publish('account:closeEdit', true);
                }
                const action = tab.getAttribute('data-action');
                const currentTab = tab.getAttribute('data-tab');
                if (action === 'switch') {
                  rightItems.forEach((item) => {
                    item.setAttribute('data-active', 'false');
                  });
                  const currentRightItem = this.querySelector(
                    `.main-customers-account-new__right-item[data-tab="${currentTab}"]`
                  );
                  currentRightItem.setAttribute('data-active', 'true');
                  tabs.forEach((t) => {
                    t.setAttribute('data-active', 'false');
                  });
                  tab.setAttribute('data-active', 'true');
                  // 特殊处理
                  if (currentTab === 'address') {
                    // 只修改地址为/account/addresses，去除参数，不刷新页面
                    const url = window.location.href;
                    const urlObj = new URL(url);
                    urlObj.pathname = '/account/addresses';
                    urlObj.searchParams.delete('type');
                    window.history.replaceState({}, '', urlObj.toString());
                    this.setAttribute('data-type', 'dialog');
                  } else if (currentTab === 'profile') {
                    // 只修改地址为/account/addresses，去除参数，不刷新页面
                    const url = window.location.href;
                    const urlObj = new URL(url);
                    urlObj.pathname = '/account';
                    urlObj.searchParams.set('type', currentTab);
                    window.history.replaceState({}, '', urlObj.toString());
                    this.setAttribute('data-type', 'dialog');
                    const navEditIcon = document.querySelector('.account-profile-nav-right-item');
                    if (navEditIcon) {
                      navEditIcon.classList.remove('hidden');
                    }
                  } else {
                    // 修改页面地址为/account?type=currentTab
                    const url = window.location.href;
                    const urlObj = new URL(url);
                    urlObj.pathname = '/account';
                    urlObj.searchParams.set('type', currentTab);
                    window.history.replaceState({}, '', urlObj.toString());
                    if (currentTab === 'overview') {
                      this.setAttribute('data-type', 'default');
                    } else {
                      this.setAttribute('data-type', 'dialog');
                    }
                  }
                } else if (action === 'jump') {
                  window.location.href = tab.getAttribute('data-url');
                } else if (action === 'contact') {
                  window.litime.openChatApp();
                }
              });
            });
          }
          async initTask() {
            try {
              const res = await this.getMemberRedeem({
                page: 1,
                pageSize: 999,
              });
              const records = res.records;
              window.litime.eventBus.publish('account:updateReviewPoints', records);
              const taskItems = this.querySelectorAll('.main-customers-account-new__left-item[data-taskType]');

              taskItems.forEach((item) => {
                const taskType = item.getAttribute('data-taskType');
                const taskTypeArray = taskType.split(',');
                let isCompletedNum = 0;
                let point = 0;
                taskTypeArray.forEach((type) => {
                  const taskItem = records.find((task) => task.taskType == type);
                  // 多个任务，必须isCompleted同时都是1才算完成
                  // 多个任务，point的积分相加
                  if (taskItem) {
                    if (taskItem.isCompleted == 0) {
                      point += taskItem.point;
                    }
                    if (taskItem.isCompleted == 1) {
                      isCompletedNum++;
                    }
                  } else {
                    // 如果找不到就认为是已完成
                    isCompletedNum++;
                  }
                });
                if (isCompletedNum === taskTypeArray.length || point <= 0) {
                  item.setAttribute('data-isCompleted', 'true');
                } else {
                  item.setAttribute('data-isCompleted', 'false');
                }
                item.querySelector('.main-customers-account-new__left-item-points-value').textContent = point;
              });
            } catch (error) {
              console.log('initTask error', error);
            }
          }
          // 获取兑换列表
          async getMemberRedeem(data) {
            const url = '/shopify/point-task/page';
            const res = await window.litime.http.get(url, {
              data,
            });
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-compare-v2"]) return;
  try {
    
  $(function () {
    if (!customElements.get('main-product-compare-v2')) {
      customElements.define(
        'main-product-compare-v2',
        class MainProductCompareV2 extends HTMLElement {
          static DESKTOP_MAX = 4;
          static SMALL_MAX = 3;
          static SMALL_BREAKPOINT = 576;

          constructor() {
            super();
            this.productIds = [];
            this.collectionId = '';
            this.type = '';
            this.removeIconTemplate = null;
            this.specGroupIconTemplate = null;
          }
          connectedCallback() {
            this.removeIconTemplate = this.querySelector('[data-remove-icon-template]');
            this.specGroupIconTemplate = this.querySelector('[data-spec-group-icon-template]');
            this.init();
          }
          init() {
            this.initData();
            this.bindEvents();
          }
          getMaxLimit() {
            return window.innerWidth <= MainProductCompareV2.SMALL_BREAKPOINT
              ? MainProductCompareV2.SMALL_MAX
              : MainProductCompareV2.DESKTOP_MAX;
          }
          clearCompareLocalStorage() {
            if (!window.litime?.setLocalStorage) return;
            window.litime.setLocalStorage('ltCompareData', []);
            window.litime.setLocalStorage('ltCompareActive', 'false');
          }
          enforceCompareLimit() {
            const max = this.getMaxLimit();
            let ltCompareData = window.litime?.getLocalStorage('ltCompareData') || [];
            let changed = false;

            if (ltCompareData.length > max) {
              const removed = ltCompareData.splice(max);
              window.litime?.setLocalStorage('ltCompareData', ltCompareData);
              removed.forEach((item) => {
                document.querySelectorAll('.extension-compare').forEach((btn) => {
                  if (String(btn.getAttribute('data-compare-id')) === String(item.id)) {
                    btn.setAttribute('data-compare-active', 'false');
                    btn.setAttribute('aria-pressed', 'false');
                  }
                });
              });
              changed = true;
            }

            if (this.productIds.length > max) {
              const removedIds = this.productIds.splice(max);
              removedIds.forEach((id) => {
                const idx = ltCompareData.findIndex((item) => String(item.id) === String(id));
                if (idx !== -1) {
                  ltCompareData.splice(idx, 1);
                  changed = true;
                }
                document.querySelectorAll('.extension-compare').forEach((btn) => {
                  if (String(btn.getAttribute('data-compare-id')) === String(id)) {
                    btn.setAttribute('data-compare-active', 'false');
                    btn.setAttribute('aria-pressed', 'false');
                  }
                });
              });
              if (changed) {
                window.litime?.setLocalStorage('ltCompareData', ltCompareData);
              }
            }

            return changed;
          }
          initData() {
            // 判断url中是否携带了ids，如果是ids参数，那就是自选产品对比，如果没有配置参数就是系列中产品对比
            const ids = new URLSearchParams(window.location.search).get('ids');
            if (ids) {
              this.type = 'custom';
              this.productIds = ids.split(',').filter(Boolean);
            } else {
              this.type = 'series';
              this.collectionId = this.getAttribute('data-collection-id');
              this.productIds = (this.getAttribute('data-series-ids')?.split(',') || []).filter(Boolean);
            }
            this.enforceCompareLimit();
            this.style.setProperty('--compare-size', this.productIds.length);
            this.initPageData();
          }
          async initPageData() {
            this.enforceCompareLimit();
            if (this.productIds.length <= 1) {
              return;
            }
            this.style.setProperty('--compare-size', this.productIds.length);
            try {
              this.setAttribute('data-loading', 'true');
              this.querySelector('main-product-compare-anchor-v2').setAttribute('data-show', 'false');
              this.querySelectorAll('.main-product-compare-v2__custom-checkbox-item').forEach((item) => {
                item.setAttribute('data-value', 'false');
              });
              // 并行调用两个接口
              const [listRes, compareRes] = await Promise.all([
                window.litime.request(
                  '/shopify/product/compare/list',
                  {
                    data: {
                      shopifyProductIds: this.productIds,
                    },
                    method: 'GET',
                  },
                  'business-api'
                ),
                window.litime.request(
                  '/shopify/product/compare',
                  {
                    data: {
                      productIds: this.productIds,
                    },
                    method: 'GET',
                  },
                  'business-api'
                ),
              ]);

              if (listRes.code === 200) {
                // 根据现在this.productIds的顺序，调整this.productDataList的顺序
                this.productDataList = listRes.data.sort((a, b) => {
                  return this.productIds.indexOf(a.shopifyProductId) - this.productIds.indexOf(b.shopifyProductId);
                });

                // 处理 compare 接口返回的数据
                if (compareRes.code === 200) {
                  this.specData = compareRes.data;

                  this.specNameList = ['productMain'];
                  this.specData.forEach((item) => {
                    this.specNameList.push(item.name);
                  });
                  const anchorElement =
                    this.querySelector('main-product-compare-anchor-v2') ||
                    document.querySelector('main-product-compare-anchor-v2');
                  if (anchorElement) {
                    anchorElement.init();
                  }
                }
                const stickyTopElement =
                  this.querySelector('main-product-compare-sticky-top-v2') ||
                  document.querySelector('main-product-compare-sticky-top-v2');
                if (stickyTopElement) {
                  stickyTopElement.init(this.productDataList || []);
                }
                this.initProductData();
                this.initSpecData();
                this.initProductButtonEvent();
                this.bindProductRemove();
                this.bindSpecGroupToggle();
              }
            } catch (error) {
              console.log(error, 'error');
              this.setAttribute('data-show', 'false');
            } finally {
              this.setAttribute('data-loading', 'false');
              this.clearCompareLocalStorage();
            }
          }
          // 参数dom生成
          initSpecData() {
            const specDom = this.querySelector('.main-product-compare-v2__content-spec');
            let startDom = '<div class="main-product-compare-v2__content-spec">';
            let endDom = '</div>';
            let specDomList = '';
            this.specData.forEach((item) => {
              specDomList += `
              <div class="main-product-compare-v2__content-spec-group" id="${item.name}" data-active="true">
                  ${this.initSpecGroupHeader(item)}
                  ${this.initSpecGroupRows(item)}
               </div>
              `;
            });
            let newEl = startDom + specDomList + endDom;
            specDom.outerHTML = newEl;
          }
          initSpecGroupHeader(item) {
            let startDom =
              '<button type="button" class="main-product-compare-v2__content-spec-group-header" aria-expanded="true">';
            let endDom = '</button>';
            let specGroupHeaderDom = `
              <div class="main-product-compare-v2__content-spec-group-header-title">
                ${item.name}
              </div>
              <div class="main-product-compare-v2__content-spec-group-header-icon"></div>
            `;
            return startDom + specGroupHeaderDom + endDom;
          }
          initSpecGroupRows(item) {
            let startDom = '<div class="main-product-compare-v2__content-spec-group-body">';
            let innerStartDom = '<div class="main-product-compare-v2__content-spec-rows-inner">';
            let rowsStartDom = '<div class="main-product-compare-v2__content-spec-rows">';
            let rowsEndDom = '</div>';
            let innerEndDom = '</div>';
            let endDom = '</div>';
            let specGroupRowsDom = `
              ${item.items.map((row) => this.initSpecRow(row)).join('')}
            `;
            return startDom + innerStartDom + rowsStartDom + specGroupRowsDom + rowsEndDom + innerEndDom + endDom;
          }
          fillSpecGroupHeaderIcons() {
            if (!this.specGroupIconTemplate?.content) return;
            this.querySelectorAll('.main-product-compare-v2__content-spec-group-header-icon').forEach((icon) => {
              if (icon.childElementCount > 0) return;
              icon.appendChild(this.specGroupIconTemplate.content.cloneNode(true));
            });
          }
          bindSpecGroupToggle() {
            this.querySelectorAll('.main-product-compare-v2__content-spec-group-header').forEach((header) => {
              if (header.dataset.specToggleBound === 'true') return;
              header.dataset.specToggleBound = 'true';
              header.addEventListener('click', () => {
                const group = header.closest('.main-product-compare-v2__content-spec-group');
                if (!group) return;
                const isActive = group.getAttribute('data-active') === 'true';
                const nextActive = !isActive;
                group.setAttribute('data-active', nextActive ? 'true' : 'false');
                header.setAttribute('aria-expanded', nextActive ? 'true' : 'false');
              });
            });
            this.fillSpecGroupHeaderIcons();
          }
          initSpecRow(item) {
            let startDom = `<div class="main-product-compare-v2__content-spec-row" data-same="${item.isSame}">`;
            let endDom = '</div>';
            let specRowDom = `
              ${this.initSpecRowHeader(item)}
              ${this.initSpecRowValues(item)}
            `;
            return startDom + specRowDom + endDom;
          }
          initSpecRowHeader(item) {
            let startDom = '<div class="main-product-compare-v2__content-spec-row-header">';
            let endDom = '</div>';
            let specRowHeaderDom = `
              <div class="main-product-compare-v2__content-spec-row-header-title">
              ${item.name}
              </div>
            `;
            return startDom + specRowHeaderDom + endDom;
          }
          initSpecRowValues(item) {
            let startDom = '<div class="main-product-compare-v2__content-spec-row-values">';
            let endDom = '</div>';
            // 根据 this.productIds 的顺序对 item.products 进行排序
            const sortedProducts = this.productIds.map((productId) => {
              const product = item.products.find((p) => p.id === productId);
              // 如果找不到对应的产品，返回一个默认值
              return product || { id: productId, value: 'N/A' };
            });
            let specRowValuesDom = `
              ${sortedProducts.map((product) => this.initSpecRowValue(product)).join('')}
            `;
            return startDom + specRowValuesDom + endDom;
          }
          initSpecRowValue(item) {
            let startDom = '<div class="main-product-compare-v2__content-spec-row-value">';
            let endDom = '</div>';
            let specRowValueDom = `
              ${item.value}
            `;
            return startDom + specRowValueDom + endDom;
          }
          // 产品dom生成
          initProductData() {
            const productDom = this.querySelector('.main-product-compare-v2__content-product');
            let startDom = '<div class="main-product-compare-v2__content-product" id="productMain">';
            let endDom = '</div>';
            let productDomList = '';
            this.productDataList.forEach((item) => {
              productDomList += `
                <div class="main-product-compare-v2__content-product-item">
                ${this.initProductMedia(item)}
                ${this.initProductBody(item)}
                </div>
              `;
            });
            let newEl = startDom + productDomList + endDom;
            productDom.outerHTML = newEl;
          }
          canShowRemoveButton() {
            return this.productIds.length > 2;
          }
          initProductMedia(item) {
            const productId = item.shopifyProductId;
            let startDom = '<div class="main-product-compare-v2__content-product-item-media">';
            let removeBtn = this.canShowRemoveButton()
              ? `
              <button
                type="button"
                class="main-product-compare-v2__content-product-item-remove"
                data-action="remove"
                data-product-id="${productId}"
              ></button>
            `
              : '';
            let imageLink = `
              <a href="/products/${item.handle}" class="main-product-compare-v2__content-product-item-image-link">
                ${this.initProductImage(item)}
              </a>
            `;
            let endDom = '</div>';
            return startDom + removeBtn + imageLink + endDom;
          }
          initProductImage(item) {
            const imageSrc = item.guideImageSrc || item.imageSrc;
            const alt = item.shortTitle || item.title || '';
            return `<img class="main-product-compare-v2__content-product-item-image" src="${imageSrc}" width="133" height="133" alt="${alt}">`;
          }
          initProductBody(item) {
            let startDom = '<div class="main-product-compare-v2__content-product-item-body">';
            let productBodyDom = `
              ${this.initProductContentInfo(item)}
              ${this.initProductContentButton(item)}
            `;
            let endDom = '</div>';
            return startDom + productBodyDom + endDom;
          }
          fillRemoveButtonIcons() {
            if (!this.removeIconTemplate?.content) return;
            this.querySelectorAll('.main-product-compare-v2__content-product-item-remove').forEach((btn) => {
              if (btn.childElementCount > 0) return;
              btn.appendChild(this.removeIconTemplate.content.cloneNode(true));
            });
          }
          initProductContentInfo(item) {
            let startDom = `<a href="/products/${item.handle}" class="main-product-compare-v2__content-product-item-info">`;
            let productContentInfoDom = `
              ${this.initProductContentInfoTitle(item)}
              ${this.initProductContentInfoPrice(item)}
            `;
            let endDom = '</a>';
            return startDom + productContentInfoDom + endDom;
          }
          initProductContentInfoTitle(item) {
            let startDom = '<div class="main-product-compare-v2__content-product-item-info-title">';
            let productContentInfoTitleDom = `
              ${item.shortTitle || item.title}
            `;
            let endDom = '</div>';
            return startDom + productContentInfoTitleDom + endDom;
          }
          initProductContentInfoPrice(item) {
            let startDom = '<div class="main-product-compare-v2__content-product-item-info-price">';
            let defaultVariant = this.getDefaultVariant(item);
            let newPrice = this.getDiscountPrice(defaultVariant.price, defaultVariant.discount) * 100;
            let oldPrice = defaultVariant.compareAtPrice * 100;
            let productContentInfoPriceDom = `
              ${this.initProductContentInfoPriceNew(item, newPrice)}
              ${this.initProductContentInfoPriceOld(item, newPrice, oldPrice)}
            `;
            let endDom = '</div>';
            return startDom + productContentInfoPriceDom + endDom;
          }
          initProductContentInfoPriceNew(item, price) {
            let startDom = `<div class="main-product-compare-v2__content-product-item-info-price-new" data-product-id="${item.shopifyProductId}">`;
            let productContentInfoPriceNewDom = `
              ${window.Shopify.formatMoney(price, window.shopMoneyFormat)}
            `;
            let endDom = '</div>';
            return startDom + productContentInfoPriceNewDom + endDom;
          }
          initProductContentInfoPriceOld(item, price, oldPrice) {
            let stauts = 'true';
            if (oldPrice < price) {
              stauts = 'false';
            }
            let startDom = `<div class="main-product-compare-v2__content-product-item-info-price-old" data-show="${stauts}" data-product-id="${item.shopifyProductId}">`;
            let productContentInfoPriceOldDom = `
              ${window.Shopify.formatMoney(oldPrice, window.shopMoneyFormat)}
            `;
            let endDom = '</div>';

            return startDom + productContentInfoPriceOldDom + endDom;
          }
          initProductContentButton(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let noStockout = defaultVariant.inventoryQuantity > 0 || defaultVariant.inventoryPolicy === 'continue';
            return `          
             <div class="main-product-compare-v2__content-product-item-buttons" data-stockout="${
               noStockout ? 'false' : 'true'
             }">
                <div class="main-product-compare-v2__content-product-item-add" 
                  data-product-id="${item.shopifyProductId}" 
                  data-action="add" 
                  data-loading="false" 
                  data-variant-id="${defaultVariant.id}"
                >
                  <div class="main-product-compare-v2__content-product-item-add-text">${this.getAttribute(
                    'data-i18n-add-to-cart'
                  )}</div>
                  <div class="main-product-compare-v2__content-product-item-add-icon">
                    <i class="items-center justify-center rotate_icon">
                      <div
                        class="loader-animation"
                        style="border:2px solid #fff; border-left-color: transparent;"
                      ></div>
                    </i>
                  </div>
                </div>
                <div class="main-product-compare-v2__content-product-item-stockout">
                  <div class="main-product-compare-v2__content-product-item-stockout-text">${this.getAttribute(
                    'data-i18n-stockout'
                  )}</div>
                  <klaviyo-bis-trigger class="w-full h-full left-0 top-0 absolute">
                    <div
                      class="klaviyo-bis-wrapper w-full h-full flex items-center justify-center text-[14px] transition-colors duration-300"
                      data-product="${item.shopifyProductId}"
                      data-variant="${defaultVariant.id}"
                      data-product-title="${item.shortTitle || item.title}"
                    >
                      <div class="add-to-cart-text w-full h-full flex items-center justify-center  text-[14px]   transition-colors duration-300">
                      </div>
                    </div>
                  </klaviyo-bis-trigger>
                </div>
              </div>
            `;
          }

          // 获取默认变体
          getDefaultVariant(item) {
            if (this.type === 'custom') {
              const ltCompareData = window.litime.getLocalStorage('ltCompareData') || [];
              // 找到对应的 compare 项
              const compareItem = ltCompareData.find((compareItem) => compareItem.id === item.shopifyProductId);

              // 如果 localstorage 里有记录的默认变体
              if (compareItem && compareItem.variantId) {
                const matchVariant = item.variants.find((variant) => variant.id == compareItem.variantId);
                if (matchVariant) return matchVariant;
              }

              // 否则返回第一个
              return item.variants[0];
            }

            // 非 custom
            const availableVariant = item.variants.find(
              (variant) => variant.inventoryQuantity > 0 || variant.inventoryPolicy === 'continue'
            );

            return availableVariant || item.variants[0];
          }

          bindProductRemove() {
            this.querySelectorAll('[data-action="remove"]').forEach((btn) => {
              if (btn.dataset.removeBound === 'true') return;
              btn.dataset.removeBound = 'true';
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const productId = btn.getAttribute('data-product-id');
                if (!productId || String(productId).startsWith('placeholder')) return;
                this.removeProduct(productId);
              });
            });
            this.fillRemoveButtonIcons();
          }
          removeProduct(productId) {
            const id = String(productId);
            const index = this.productIds.findIndex((pid) => String(pid) === id);
            if (index === -1) return;

            this.productIds.splice(index, 1);

            let ltCompareData = window.litime?.getLocalStorage('ltCompareData') || [];
            const dataIndex = ltCompareData.findIndex((item) => String(item.id) === id);
            if (dataIndex !== -1) {
              ltCompareData.splice(dataIndex, 1);
              window.litime?.setLocalStorage('ltCompareData', ltCompareData);
            }

            document.querySelectorAll('.extension-compare').forEach((btn) => {
              if (String(btn.getAttribute('data-compare-id')) === id) {
                btn.setAttribute('data-compare-active', 'false');
                btn.setAttribute('aria-pressed', 'false');
              }
            });

            if (this.type === 'custom') {
              const url = new URL(window.location.href);
              if (this.productIds.length > 0) {
                url.searchParams.set('ids', this.productIds.join(','));
              } else {
                url.searchParams.delete('ids');
              }
              window.history.replaceState({}, '', url.toString());
            }

            if (this.productIds.length <= 1) {
              this.setAttribute('data-show', 'false');
              return;
            }

            this.style.setProperty('--compare-size', this.productIds.length);
            this.initPageData();
          }
          initProductButtonEvent() {
            this.querySelectorAll('[data-action="add"]').forEach((item) => {
              item.addEventListener('click', async (e) => {
                e.preventDefault(); // 阻止跳转
                e.stopPropagation();
                try {
                  if (item.getAttribute('data-loading') === 'true') {
                    return;
                  }
                  item.setAttribute('data-loading', 'true');
                  let params = [
                    {
                      id: item.getAttribute('data-variant-id'),
                      quantity: 1,
                    },
                  ];
                  await window.litime.addCart(params);
                } catch (error) {
                  console.log(error, 'error');
                } finally {
                  item.setAttribute('data-loading', 'false');
                }
              });
            });
          }
          bindEvents() {
            this.bindSpecGroupToggle();
            this.customCheckboxItems = this.querySelectorAll('.main-product-compare-v2__custom-checkbox-item');
            this.customCheckboxItems.forEach((item) => {
              item.addEventListener('click', () => {
                this.toggleCustomCheckbox(item);
              });
            });
            window.addEventListener('resize', () => {
              const prevCount = this.productIds.length;
              const dataChanged = this.enforceCompareLimit();
              this.style.setProperty('--compare-size', this.productIds.length);
              if (this.productIds.length <= 1) {
                this.setAttribute('data-show', 'false');
                return;
              }
              if (dataChanged || this.productIds.length !== prevCount) {
                this.initPageData();
              }
            });
          }
          elevateStickyTopTemporarily(duration = 400) {
            const stickyTop =
              this.querySelector('main-product-compare-sticky-top-v2') ||
              document.querySelector('main-product-compare-sticky-top-v2');
            if (!stickyTop) return;

            stickyTop.setAttribute('data-elevated', 'true');
            if (this.stickyTopElevateTimer) {
              clearTimeout(this.stickyTopElevateTimer);
            }
            this.stickyTopElevateTimer = setTimeout(() => {
              stickyTop.removeAttribute('data-elevated');
              this.stickyTopElevateTimer = null;
            }, duration);
          }
          toggleCustomCheckbox(item) {
            const value = item.getAttribute('data-value');
            const options = this.querySelectorAll('[data-option="hide"]');
            const isChecking = value !== 'true';

            this.elevateStickyTopTemporarily();

            options.forEach((optionItem) => {
              optionItem.setAttribute('data-value', isChecking ? 'true' : 'false');
            });

            this.querySelectorAll('.main-product-compare-v2__content-spec-row').forEach((row) => {
              if (!isChecking) {
                row.removeAttribute('data-show');
                return;
              }
              if (row.getAttribute('data-same') === 'true') {
                row.setAttribute('data-show', 'false');
              } else {
                row.setAttribute('data-show', 'true');
              }
            });

            requestAnimationFrame(() => {
              window.hideSiteHeader();
            });
          }
          getDiscountPrice(price, discount) {
            if (!discount) return price;

            // 安全兜底
            const percentageArr = Array.isArray(discount.percentage) ? discount.percentage : [];

            const amountArr = Array.isArray(discount.amount) ? discount.amount : [];

            // 拿最大折扣 quota
            const percentageMax = percentageArr.reduce((max, item) => Math.max(max, item.discountQuota || 0), 0);

            const amountMax = amountArr.reduce((max, item) => Math.max(max, item.discountQuota || 0), 0);

            // 计算两种折扣后的价格
            const p1 = price - amountMax; // 减金额
            const p2 = price * (1 - percentageMax / 100); // 按百分比
            return this.ceilToTwo(Math.min(p1, p2));
          }
          ceilToTwo(num) {
            return Math.ceil(num * 100) / 100;
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-modal-v2"]) return;
  try {
    
  // 需要将js代码集成到main-product-modal-v2.js文件中
  $(function () {
    if (!customElements.get('main-product-modal-v2')) {
      customElements.define(
        'main-product-modal-v2',
        class MainProductModalV2 extends HTMLElement {
          static get SLIDE_DURATION() {
            return 300;
          }

          static get FADE_DURATION() {
            return 200;
          }

          static get FADE_DELAY() {
            return 300;
          }

          static get CLOSE_DURATION() {
            return MainProductModalV2.FADE_DELAY + MainProductModalV2.FADE_DURATION;
          }

          connectedCallback() {
            this.onCloseClick = this.onCloseClick.bind(this);
            this.onBackdropClick = this.onBackdropClick.bind(this);
            this.onCloseKeydown = this.onCloseKeydown.bind(this);

            this.closeBtn = this.querySelector('[data-action="close"]');
            this.backdropEl = this.querySelector('.main-product-modal-v2');
            this.wrapperEl = this.querySelector('.main-product-modal-v2__wrapper');

            this.closeBtn?.addEventListener('click', this.onCloseClick);
            this.closeBtn?.addEventListener('keydown', this.onCloseKeydown);
            this.backdropEl?.addEventListener('click', this.onBackdropClick);
            this.bindAddToCartSuccess();
          }

          disconnectedCallback() {
            this.closeBtn?.removeEventListener('click', this.onCloseClick);
            this.closeBtn?.removeEventListener('keydown', this.onCloseKeydown);
            this.backdropEl?.removeEventListener('click', this.onBackdropClick);
            this.unsubscribeAddToCartSuccess?.();
            this.unsubscribeAddToCartSuccess = null;
            window.clearTimeout(this._closeTimer);
          }

          bindAddToCartSuccess() {
            if (this.unsubscribeAddToCartSuccess || !window.litime?.eventBus) return;

            this.unsubscribeAddToCartSuccess = window.litime.eventBus.subscribe(
              'main-product-modal-v2:add-to-cart-success',
              (payload) => {
                if (payload?.sourceRoot !== this) return;
                this.close();
              }
            );
          }

          onCloseKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this.close();
          }

          onCloseClick(event) {
            event.preventDefault();
            event.stopPropagation();
            this.close();
          }

          onBackdropClick(event) {
            if (this.wrapperEl?.contains(event.target)) return;
            this.close();
          }

          open() {
            if (this.getAttribute('data-show') === 'true') return;

            this._isClosing = false;
            window.clearTimeout(this._closeTimer);
            window.litime?.disableScroll?.();

            const popupHost = document.getElementById('global-product-card-popup');
            popupHost?.setAttribute('aria-hidden', 'false');

            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                this.setAttribute('data-show', 'true');
              });
            });
          }

          close() {
            if (this._isClosing || this.getAttribute('data-show') === 'false') return;
            this._isClosing = true;

            this.setAttribute('data-show', 'false');

            const popupHost = document.getElementById('global-product-card-popup');
            popupHost?.setAttribute('aria-hidden', 'true');

            window.clearTimeout(this._closeTimer);
            this._closeTimer = window.setTimeout(() => {
              this._isClosing = false;
              if (popupHost) {
                popupHost.innerHTML = '';
              }
              window.litime?.enableScroll?.();
              window.litime?.eventBus?.publish('main-product-modal-v2:close');
            }, MainProductModalV2.CLOSE_DURATION);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-advantages"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('marketing-advantages')) {
      customElements.define(
        'marketing-advantages',
        class referralBanner extends HTMLElement {
          constructor() {
            super();
            this.marqueeSpeed = 0.6;
            this._marqueeStyles = [];
          }
          async connectedCallback() {
            this.initMarquee();
          }

          disconnectedCallback() {
            // 清理定时器和样式
            this.querySelectorAll('.starry_marquee_container').forEach((container) => {
              const track = container.querySelector('.starry_marquee');
              if (track) {
                track.style.animation = 'none';
              }
            });

            if (this._marqueeStyles) {
              this._marqueeStyles.forEach((style) => {
                if (style.parentNode) {
                  style.parentNode.removeChild(style);
                }
              });
              this._marqueeStyles = [];
            }
          }

          initMarquee() {
            const marqueeContainers = this.querySelectorAll('.starry_marquee_container');
            marqueeContainers.forEach((marqueeContainer) => {
              const direction = marqueeContainer.dataset.direction || 'left';
              const marquee = marqueeContainer.querySelector('.starry_marquee');

              // 只 clone 一次
              if (!marquee.dataset.cloned) {
                marquee.insertAdjacentHTML('beforeend', marquee.innerHTML);
                marquee.dataset.cloned = 'true';
              }

              requestAnimationFrame(() => {
                const computedStyle = getComputedStyle(marquee);
                const gap = parseFloat(computedStyle.gap) || 0;
                const itemsLength = marquee.children.length / 2;

                const itemsWidth = Array.from(marquee.children)
                  .slice(0, itemsLength)
                  .reduce((total, item) => total + item.offsetWidth + gap, 0);

                // 根据宽度计算持续时间，保持速度一致
                const duration = (itemsWidth / (this.marqueeSpeed * 60)) * 1000;

                const animationName = `marquee-${direction}-${Math.random().toString(36).substr(2, 9)}`;
                const keyframes =
                  direction === 'right'
                    ? `0% { transform: translateX(${-itemsWidth}px); } 100% { transform: translateX(0px); }`
                    : `0% { transform: translateX(0px); } 100% { transform: translateX(${-itemsWidth}px); }`;

                const style = document.createElement('style');
                style.textContent = `@keyframes ${animationName} { ${keyframes} }`;
                document.head.appendChild(style);
                this._marqueeStyles.push(style);

                marquee.style.animation = `${animationName} ${duration}ms linear infinite`;

                // 鼠标悬停事件
                marqueeContainer.addEventListener('mouseenter', () => {
                  marquee.style.animationPlayState = 'paused';
                });
                marqueeContainer.addEventListener('mouseleave', () => {
                  marquee.style.animationPlayState = 'running';
                });
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-banner"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('marketing-banner')) {
      customElements.define(
        'marketing-banner',
        class referralBanner extends HTMLElement {
          constructor() {
            super();
            this.isLoading = false;
          }
          async connectedCallback() {
            this.initThemeStyles();
            const marketingBannerSubscribe = $(this).find('.marketing-banner__subscribe');
            const marketingBannerSubscribeButton = $(this).find('.marketing-banner__subscribe-button button');
            const marketingBannerSubscribeInput = $(this).find('.marketing-banner__subscribe input');
            const emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            marketingBannerSubscribeButton.on('click', async (event) => {
              if (this.isLoading) {
                return;
              }
              const email = marketingBannerSubscribeInput.val();
              marketingBannerSubscribe.attr('data-status', '');
              if (!emailRegexp.test(email)) {
                marketingBannerSubscribe.attr('data-status', 'format');
                return;
              }
              if (email) {
                this.showButtonLoading(marketingBannerSubscribeButton);
                try {
                  const tag = $(this).find('.marketing-banner').attr('data-tag');
                  const subscribeData = { email };
                  if (tag) {
                    subscribeData.tag = tag;
                  }
                  const res = await this.subscribe(subscribeData);
                  if (res.code === 200) {
                    marketingBannerSubscribe.attr('data-status', 'success');
                    marketingBannerSubscribe.find('input').val('');
                  } else {
                    marketingBannerSubscribe.attr('data-status', 'error');
                  }
                } catch (error) {
                  marketingBannerSubscribe.attr('data-status', 'error');
                }

                this.hideButtonLoading(marketingBannerSubscribeButton);
              }
            });
            marketingBannerSubscribeInput.on('input', () => {
              if (emailRegexp.test(marketingBannerSubscribeInput.val())) {
                marketingBannerSubscribe.attr('data-status', '');
              }
            });
          }

          /**
           * 初始化主题样式
           */
          initThemeStyles() {
            const defaultStyle = this.getAttribute('data-default-style');
            console.log('defaultStyle', defaultStyle);
            this.setHeaderStyle(defaultStyle); //设置头部样式
            this.setFooterStyle(defaultStyle); //设置底部样式
          }
          showButtonLoading(button) {
            this.isLoading = true;
            button.attr('data-show-loading', 'true');
          }

          hideButtonLoading(button) {
            this.isLoading = false;
            button.attr('data-show-loading', 'false');
          }

          async subscribe(data, $button) {
            try {
              const url = `/shopify/user/point/subscribe`;
              const timestamp = getEncryptTimestamp();
              const headers = {
                nonce: litime_nonce,
                ticket: litime_ticket,
                timestamp,
              };
              const res = await window.litime.http.post(url, {
                data,
                headers,
              });

              if (res.code === 200) {
                return res;
              } else {
                throw new Error(window.i18n.request_failed);
              }
            } catch (error) {
              throw error;
            }
          }
          setHeaderStyle(defaultStyle) {
            const header = document.querySelector('#header-01');
            const ltHeader = document.querySelector('lt-header');
            if (header) {
              header.classList.remove('theme-dark', 'theme-light');
              if (defaultStyle === 'dark') {
                header.classList.add('theme-dark');
              } else {
                header.classList.add('theme-light');
              }
            }
            setTimeout(() => {
              if (ltHeader) {
                if (defaultStyle === 'dark') {
                  ltHeader.setAttribute('data-screen', 'true');
                  ltHeader.setAttribute('data-theme', 'dark');
                  if (header) {
                    header.classList.add('theme-dark');
                    header.classList.remove('theme-light');
                    header.classList.remove('light-default');
                  }
                } else {
                  ltHeader.setAttribute('data-screen', 'true');
                  ltHeader.setAttribute('data-theme', 'light');
                }
              }
            }, 100);
          }
          setFooterStyle(defaultStyle) {
            console.log('setFooterStyle called with:', defaultStyle);
            const footer = document.querySelector('.main-footer');
            if (footer) {
              // 设置 footer 背景色
              footer.style.backgroundColor = defaultStyle === 'dark' ? '#000000' : '';

              // 设置 input 样式
              footer.querySelectorAll('.main-footer__input').forEach((input) => {
                input.style.backgroundColor = defaultStyle === 'dark' ? '#111111' : '';
                input.style.color = defaultStyle === 'dark' ? '#FFFFFF' : '';
                input.style.setProperty('--placeholder-color', defaultStyle === 'dark' ? '#fff' : '#737373');
              });

              // 设置 footer-sub-title 颜色
              footer.querySelectorAll('.footer-sub-title').forEach((subTitle) => {
                subTitle.style.color = defaultStyle === 'dark' ? '#FFFFFF' : '#737373';
              });
              const footerTextColor = defaultStyle === 'dark' ? '#FFFFFF' : '#191919';
              document.documentElement.style.setProperty('--footer-item-text-color', footerTextColor);

              // 设置透明度版本
              if (defaultStyle === 'dark') {
                // 暗黑模式：白色 80% 和 20% 透明度
                document.documentElement.style.setProperty('--footer-item-text-color-80', 'rgba(255, 255, 255, 0.8)');
                document.documentElement.style.setProperty('--footer-item-text-color-20', 'rgba(255, 255, 255, 0.2)');
              } else {
                // 亮色模式：黑色 80% 和 20% 透明度
                document.documentElement.style.setProperty('--footer-item-text-color-80', 'rgba(25, 25, 25, 0.8)');
                document.documentElement.style.setProperty('--footer-item-text-color-20', 'rgba(25, 25, 25, 0.2)');
              }

              // 切换 logo 显示状态
              const logoListDark = document.querySelector('.logo-list-dark');
              const logoListLight = document.querySelector('.logo-list-light');

              if (logoListDark && logoListLight) {
                if (defaultStyle === 'dark') {
                  // 暗黑模式：显示 dark logo，隐藏 light logo
                  logoListDark.classList.remove('hidden');
                  logoListDark.classList.add('flex');
                  logoListLight.classList.remove('flex');
                  logoListLight.classList.add('hidden');
                } else {
                  // 浅色模式：显示 light logo，隐藏 dark logo
                  logoListLight.classList.remove('hidden');
                  logoListLight.classList.add('flex');
                  logoListDark.classList.remove('flex');
                  logoListDark.classList.add('hidden');
                }
              }
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-coupon-snap-up"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('marketing-coupon-snap-up')) {
      customElements.define(
        'marketing-coupon-snap-up',
        class CouponSnapUp extends HTMLElement {
          constructor() {
            super();
            this.timelineData = [];
            this.dateRange = '';
            this.countdownInterval = null;
            this.activityStatus = null; // 活动状态：2=有效，1或3=已结束
            this.businessId = null;
          }

          async connectedCallback() {
            await this.initTimeline();
            // 初始化规则弹窗
            this.initRulesDialog();
            if (window.litime && window.litime.onVisibleOnce) {
              window.litime.onVisibleOnce(this, () => {
                if (window.customTracker) {
                  window.customTracker.trackEvent({
                    eventKey: 'Show_LimitedTimeCoupons_Render_Section',
                    eventName: '限时优惠券模块曝光事件',
                    eventValue: {
                      businessId: this.businessId,
                    },
                  });
                }
              });
            }
          }

          /**
           * 等待 window.litime 加载完成
           * @returns {Promise} Promise 对象
           */
          waitForLitime() {
            return new Promise((resolve) => {
              // 如果已经存在，直接返回
              if (window.litime) {
                resolve();
                return;
              }

              // 如果不存在，等待一小段时间后重试（最多等待 2 秒）
              let attempts = 0;
              const maxAttempts = 20; // 2秒 = 20 * 100ms
              const checkInterval = setInterval(() => {
                attempts++;
                if (window.litime) {
                  clearInterval(checkInterval);
                  resolve();
                } else if (attempts >= maxAttempts) {
                  clearInterval(checkInterval);
                  console.warn('window.litime is not available after waiting 2 seconds');
                  resolve(); // 即使失败也 resolve，避免阻塞
                }
              }, 100);
            });
          }

          disconnectedCallback() {
            // 清理倒计时定时器
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
              this.countdownInterval = null;
            }
            // 清理 ResizeObserver
            if (this.timelineResizeObserver) {
              this.timelineResizeObserver.disconnect();
              this.timelineResizeObserver = null;
            }
          }

          /**
           * 初始化规则弹窗
           * 绑定规则按钮的点击事件，打开规则弹窗
           */
          initRulesDialog() {
            const rulesModal = document.querySelector('marketing-coupon-snap-up-rules');
            const rulesButton = this.querySelector('.marketing-coupon-snap-up__sub-title-rules');
            rulesButton.addEventListener('click', () => {
              if (rulesModal.showModal) {
                rulesModal.showModal();
              }
            });
          }

          /**
           * 初始化时间轴
           * 从 API 获取时间段数据并渲染
           */
          async initTimeline() {
            try {
              const response = await window.litime.http.get('/shopify/marketing/get/discount');
              if (response && response.code === 200 && response.data) {
                // 保存活动状态：2=有效，1或3=已结束
                this.activityStatus = response.data.status || null;
                const convertedData = this.convertApiDataToTimeline(response.data);
                this.timelineData = convertedData.timeSlots || [];
                this.dateRange = convertedData.dateRange || '';
                this.businessId = response.data.id;
                this.renderTimeline();
              }
            } catch (error) {
              console.error('Failed to load timeline data:', error);
              // 如果 API 失败，可以使用默认数据或显示错误
            }
          }

          /**
           * 格式化时间，使用 toLocaleString 方法
           * @param {Date|string} date - Date 对象或时间字符串
           * @param {Object} options - 格式化选项
           * @returns {Object} 格式化后的时间对象 { month, day, hour, minute, second }
           */
          formatTime(date, options = {}) {
            const dateObj = date instanceof Date ? date : new Date(date);

            // 使用 Intl.DateTimeFormat 来分别格式化各部分
            const formatter = new Intl.DateTimeFormat(undefined, {
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              ...options,
            });

            const parts = formatter.formatToParts(dateObj);
            const partsMap = {};
            parts.forEach((part) => {
              partsMap[part.type] = part.value;
            });

            return {
              month: partsMap.month,
              day: partsMap.day,
              hour: partsMap.hour,
              minute: partsMap.minute,
              second: partsMap.second,
            };
          }

          /**
           * 将 API 返回的数据转换为时间轴格式
           * @param {Object} apiData - API 返回的数据
           * @returns {Object} 转换后的时间轴数据 { timeSlots, dateRange }
           */
          convertApiDataToTimeline(apiData) {
            const now = new Date();
            const timeSlots = [];
            // 如果没有 discounts 数据，返回空数组
            if (!apiData.discounts || apiData.discounts.length === 0) {
              return {
                timeSlots: [],
                dateRange: '',
              };
            }

            // 处理每个 discount，转换为时间段
            apiData.discounts.forEach((discount) => {
              // UTC 时间转换为本地时间
              const startTime = new Date(discount.utcStartTime);
              const endTime = new Date(discount.utcEndTime);

              // 使用 toLocaleString 方式格式化时间
              const startFormatted = this.formatTime(startTime);
              const endFormatted = this.formatTime(endTime);

              const timeRange = `${startFormatted.hour}:${startFormatted.minute}-${endFormatted.hour}:${endFormatted.minute}`;

              let status = 'not_started';
              if (now >= startTime && now < endTime) {
                status = 'active';
              } else if (now >= endTime) {
                status = 'ended';
              }

              // 判断是否抢购完（剩余数量为0）
              const isFinished = discount.remainQuantity === 0;

              timeSlots.push({
                status: status,
                timeRange: timeRange,
                discount: discount, // 保存原始 discount 数据，以便后续使用
                isFinished: isFinished, // 是否抢购完
              });
            });

            // 按开始时间排序（使用 utcStartTime 的时间戳，考虑日期）
            timeSlots.sort((a, b) => {
              const aStartTime = new Date(a.discount.utcStartTime).getTime();
              const bStartTime = new Date(b.discount.utcStartTime).getTime();
              return aStartTime - bStartTime;
            });

            // 生成日期范围（使用本地时间）
            let dateRange = '';
            if (apiData.discounts && apiData.discounts.length > 0) {
              // 按 utcStartTime 排序，确保获取时间上的第一个和最后一个
              const sortedDiscounts = [...apiData.discounts].sort((a, b) => {
                return new Date(a.utcStartTime).getTime() - new Date(b.utcStartTime).getTime();
              });

              // 获取第一个 discount 的 utcStartTime
              const firstDiscount = sortedDiscounts[0];
              // 获取最后一个 discount 的 utcEndTime
              const lastDiscount = sortedDiscounts[sortedDiscounts.length - 1];

              if (firstDiscount.utcStartTime && lastDiscount.utcEndTime) {
                // UTC 时间转换为本地时间
                const activityStart = new Date(firstDiscount.utcStartTime);
                const activityEnd = new Date(lastDiscount.utcEndTime);

                // 使用 toLocaleString 方式格式化时间
                const startFormatted = this.formatTime(activityStart);
                const endFormatted = this.formatTime(activityEnd);

                dateRange = `${startFormatted.month}/${startFormatted.day} ${startFormatted.hour}:${startFormatted.minute}:${startFormatted.second}—${endFormatted.month}/${endFormatted.day} ${endFormatted.hour}:${endFormatted.minute}:${endFormatted.second}`;
              }
            }

            return {
              timeSlots: timeSlots,
              dateRange: dateRange,
            };
          }

          /**
           * 更新timeline宽度：当timeline宽度大于等于屏幕宽度时，设置width: 100%
           */
          updateTimelineWidth() {
            if (!this.timelineContainer) return;

            const screenWidth = window.innerWidth;
            const timelineScrollWidth = this.timelineContainer.scrollWidth;

            if (timelineScrollWidth >= screenWidth) {
              this.timelineContainer.style.width = '100%';
            } else {
              this.timelineContainer.style.width = 'auto';
            }
          }

          /**
           * 处理 discountName 的高亮显示
           * 如果存在 highlightName，则在 discountName 中高亮显示 highlightName
           * @param {string} discountName - 优惠券名称
           * @param {string} highlightName - 需要高亮的部分
           * @returns {string} 处理后的 HTML 字符串
           */
          highlightDiscountName(discountName, highlightName) {
            if (!discountName) return '';

            // 如果没有 highlightName，直接返回原文本
            if (!highlightName || highlightName.trim() === '') {
              return this.escapeHtml(discountName);
            }

            // 转义 HTML，防止 XSS
            const escapedDiscountName = this.escapeHtml(discountName);
            const escapedHighlightName = this.escapeHtml(highlightName);

            // 使用正则表达式查找并替换 highlightName（不区分大小写）
            const regex = new RegExp(`(${this.escapeRegex(escapedHighlightName)})`, 'gi');
            const highlightedText = escapedDiscountName.replace(
              regex,
              '<span style="color: var(--marketing-customize-color); font-weight: bold;">$1</span>'
            );

            return highlightedText;
          }

          /**
           * 转义 HTML 特殊字符，防止 XSS 攻击
           * @param {string} text - 需要转义的文本
           * @returns {string} 转义后的文本
           */
          escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
          }

          /**
           * 转义正则表达式特殊字符
           * @param {string} text - 需要转义的文本
           * @returns {string} 转义后的文本
           */
          escapeRegex(text) {
            return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          }

          /**
           * 渲染时间轴
           */
          renderTimeline(shouldInitSwiper = true) {
            const timelineContainer = this.querySelector('[data-timeline-items]');
            const dateRangeContainer = this.querySelector('[data-date-range]');

            if (!timelineContainer) return;

            // 保留连接线，只清空时间轴项目
            const existingLine = timelineContainer.querySelector('.marketing-coupon-snap-up__timeline-line');
            const itemsToRemove = timelineContainer.querySelectorAll('.marketing-coupon-snap-up__timeline-item');
            itemsToRemove.forEach((item) => item.remove());

            // 如果连接线不存在，创建它
            let timelineLine = existingLine;
            if (!timelineLine) {
              timelineLine = document.createElement('div');
              timelineLine.className = 'marketing-coupon-snap-up__timeline-line';
              timelineContainer.insertBefore(timelineLine, timelineContainer.firstChild);
            }

            // 更新连接线宽度，确保从第一个marker中心到最后一个marker中心
            const updateLineWidth = () => {
              const items = timelineContainer.querySelectorAll('.marketing-coupon-snap-up__timeline-item');

              // 如果只有一个时间段，隐藏线条
              if (items.length <= 1) {
                timelineLine.style.display = 'none';
                return;
              }

              // 显示线条
              timelineLine.style.display = '';

              if (items.length > 0) {
                const firstItem = items[0];
                const lastItem = items[items.length - 1];

                // 获取第一个和最后一个 marker
                const firstMarker = firstItem.querySelector('.marketing-coupon-snap-up__timeline-marker');
                const lastMarker = lastItem.querySelector('.marketing-coupon-snap-up__timeline-marker');

                if (firstMarker && lastMarker) {
                  // 计算第一个 marker 的中心位置（相对于 timelineContainer）
                  // 使用 offsetLeft 和 offsetWidth 来获取相对于父容器的位置
                  const firstItemLeft = firstItem.offsetLeft;
                  const firstMarkerLeft = firstMarker.offsetLeft; // 相对于 firstItem 的位置
                  const firstMarkerWidth = firstMarker.offsetWidth;
                  const firstMarkerCenter = firstItemLeft + firstMarkerLeft + firstMarkerWidth / 2;

                  // 计算最后一个 marker 的中心位置
                  const lastItemLeft = lastItem.offsetLeft;
                  const lastMarkerLeft = lastMarker.offsetLeft; // 相对于 lastItem 的位置
                  const lastMarkerWidth = lastMarker.offsetWidth;
                  const lastMarkerCenter = lastItemLeft + lastMarkerLeft + lastMarkerWidth / 2;

                  // 线条从第一个 marker 中心开始，到最后一个 marker 中心结束
                  const lineWidth = lastMarkerCenter - firstMarkerCenter;
                  timelineLine.style.width = `${lineWidth}px`;
                  timelineLine.style.left = `${firstMarkerCenter}px`;
                }
              }
            };

            // 保存timeline容器引用，供updateTimelineWidth方法使用
            this.timelineContainer = timelineContainer;

            // 等待DOM渲染完成后更新连接线宽度和timeline宽度
            setTimeout(() => {
              updateLineWidth();
              this.updateTimelineWidth();
            }, 0);

            // 设置timeline容器属性
            timelineContainer.setAttribute('data-scrollable', 'true');

            // 监听窗口大小变化，重新检查timeline宽度
            if (!this.timelineResizeObserver) {
              this.timelineResizeObserver = new ResizeObserver(() => {
                this.updateTimelineWidth();
                updateLineWidth();
              });
              this.timelineResizeObserver.observe(timelineContainer);
            }
            // 渲染每个时间段
            this.timelineData.forEach((item, index) => {
              const timelineItem = document.createElement('div');
              timelineItem.className = 'marketing-coupon-snap-up__timeline-item';

              // 判断是否为激活状态（用于status的高亮）
              const isActive = item.status === 'active';

              // 状态标签（根据当前时间点高亮）
              const statusLabel = document.createElement('div');
              statusLabel.className = `marketing-coupon-snap-up__timeline-status ${isActive ? 'status-active' : ''}`;
              statusLabel.textContent = this.getStatusText(item.status);

              // 时间轴标记点（初始状态不高亮，点击后才高亮）
              const marker = document.createElement('div');
              marker.className = 'marketing-coupon-snap-up__timeline-marker';

              // 时间范围标签（根据当前时间节点高亮，而不是 item-clicked）
              const timeLabel = document.createElement('div');
              timeLabel.className = `marketing-coupon-snap-up__timeline-time ${isActive ? 'time-active' : ''}`;
              timeLabel.textContent = item.timeRange || '';

              timelineItem.appendChild(statusLabel);
              timelineItem.appendChild(marker);
              timelineItem.appendChild(timeLabel);
              timelineContainer.appendChild(timelineItem);

              // 注意：item-clicked 类由 syncTimelineSelection 统一管理，不在这里自动添加

              // 添加点击事件
              timelineItem.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('Timeline item clicked, index:', index);

                // 移除所有item的点击高亮
                const allItems = timelineContainer.querySelectorAll('.marketing-coupon-snap-up__timeline-item');
                allItems.forEach((item) => {
                  item.classList.remove('item-clicked');
                });

                // 给当前点击的item添加高亮
                timelineItem.classList.add('item-clicked');

                // 执行滚动居中
                this.scrollItemToCenter(timelineItem, index);

                // 同步 Swiper 到对应位置
                if (this.swiper) {
                  this.swiper.slideTo(index);
                }
              });
            });

            // 渲染日期范围
            if (dateRangeContainer && this.dateRange) {
              dateRangeContainer.textContent = this.dateRange;
            }

            // 等待所有item渲染完成后，再次更新timeline宽度
            setTimeout(() => {
              this.updateTimelineWidth();
            }, 100);

            // 默认滚动到当前时间点
            // 如果设置了保持位置的标志，不自动滚动，由外部逻辑处理
            if (!this._shouldKeepPosition) {
              this.scrollToActiveItem();
            }

            // 初始化 Swiper（如果 shouldInitSwiper 为 true）
            // 当当前活动结束时，只更新 timeline 高亮，不重新渲染 swiper
            if (shouldInitSwiper !== false) {
              this.initSwiper();
            }
          }

          /**
           * 初始化 Swiper
           */
          initSwiper() {
            const swiperContainer = this.querySelector('.marketing-coupon-snap-up-swiper');
            const swiperWrapper = this.querySelector('[data-swiper-wrapper]');

            if (!swiperContainer || !swiperWrapper) return;

            // 保存当前索引，以便在重新渲染后检查
            let savedCurrentIndex = 0;
            const hadSwiperInstance = !!this.swiper; // 记录是否有之前的 swiper 实例
            if (this.swiper) {
              savedCurrentIndex = this.swiper?.activeIndex ?? this.swiper?.realIndex ?? 0;
              // 如果已有 swiper 实例，先销毁它
              this.swiper.destroy(true, true); // 销毁并清理所有事件监听器
              this.swiper = null;
            }

            // 清空现有内容
            swiperWrapper.innerHTML = '';

            // 渲染 Swiper slides
            this.timelineData.forEach((item, index) => {
              // 创建 slide 元素
              const slide = document.createElement('div');
              slide.className = 'swiper-slide';
              slide.setAttribute('data-index', index);
              slide.setAttribute('data-status', item.status);

              // 检查是否登录
              const isLoggedIn = Boolean(window.customer);

              // 判断按钮状态和文本
              const buttonInfo = this.getButtonInfo(item, index, isLoggedIn);

              // 判断是否显示倒计时
              const showCountdown = buttonInfo.showCountdown;
              const countdownLabel = buttonInfo.countdownLabel;
              const countdownTarget = buttonInfo.countdownTarget || 0;

              // 创建倒计时 HTML
              const countdownHTML = showCountdown
                ? `
              <div class="marketing-coupon-snap-up-slide-content-right-time">
                   <span class="marketing-coupon-snap-up-slide-content-right-time-title">${countdownLabel}</span>
                   <div class="marketing-coupon-snap-up-slide-content-right-time-content" data-countdown-target="${countdownTarget}" >
                      <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                        <div class="hrs marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                        <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${window.i18n.hrs}</span>
                      </div>
                      <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                        <div class="min marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                        <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${window.i18n.mins}</span>
                      </div>
                      <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                        <div class="sec marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                        <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${window.i18n.secs}</span>
                      </div>
                    </div>
                   <div class="marketing-coupon-snap-up-slide-content-right-time-content-mobile" data-countdown-target="${countdownTarget}" >
                      <div class="marketing-coupon-snap-up-slide-content-right-time-item-value">00:00:00</div>
                    </div>
              </div>
            `
                : '';

              // 处理 discountName 的高亮显示
              const discountName = item.discount.discountName || '';
              const highlightName = item.discount.highlightName || '';
              const highlightedDiscountName = this.highlightDiscountName(discountName, highlightName);

              // 创建 slide 内容结构
              slide.innerHTML = `
              <div class="marketing-coupon-snap-up-slide-content">
                 <div class="marketing-coupon-snap-up-slide-content-left">
                       <img src="${item.discount.coverUrl}" alt="${discountName}">
                 </div>
                 <div class="marketing-coupon-snap-up-slide-content-right">
                  
                         <div class="marketing-coupon-snap-up-slide-content-right-title">${highlightedDiscountName}</div>
                    ${countdownHTML}
                  
                   <div class="marketing-coupon-snap-up-slide-content-right-button-wrapper">
                    <button 
                      class="${buttonInfo.buttonClass}" 
                      data-button-type="${buttonInfo.buttonType}"
                      data-discount-id="${item.discount.id}"
                      data-item-index="${index}"
                      ${buttonInfo.disabled ? 'disabled' : ''}
                    >
                     <i class=" items-center hidden justify-center cursor-pointer rotate_icon h-[24px]">
                      <div class="loader-animation" style="border:2px solid #fff; border-left-color: transparent;"></div>
                    </i>
                    <span class="loading-button-text">${buttonInfo.buttonText}</span>
                    </button>
                                       </div>

                 </div>
              </div>
            `;

              swiperWrapper.appendChild(slide);

              // 直接给按钮绑定点击事件
              const button = slide.querySelector('button[data-button-type]');
              if (button) {
                button.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.handleButtonClick(button);
                });
              }
            });

            // 初始化倒计时
            this.initCountdown();

            // 计算容器宽度和配置
            const containerWidth = swiperContainer.offsetWidth || 1200;

            // 获取导航按钮元素
            const nextButton = this.querySelector('.marketing-coupon-snap-up-swiper-next');
            const prevButton = this.querySelector('.marketing-coupon-snap-up-swiper-prev');

            // 创建或获取 scrollbar 元素（使用用户提供的样式）
            const contentSwiperContainer = this.querySelector('.marketing-coupon-snap-up__content-swiper');
            let scrollbarContainer = null;
            let scrollbarDom = null;

            // 检查 item 数量，只有大于 1 时才显示 scrollbar
            const itemCount = this.timelineData?.length || 0;
            const shouldShowScrollbar = itemCount > 1;

            if (contentSwiperContainer) {
              // 查找已存在的 scrollbar 容器（通过查找包含 swiper-scrollbar 的父元素）
              const existingScrollbar = contentSwiperContainer.querySelector('.swiper-scrollbar');
              if (existingScrollbar) {
                scrollbarDom = existingScrollbar;
                scrollbarContainer = existingScrollbar.parentElement;
                // 根据 item 数量决定是否显示整个 scrollbarContainer
                if (shouldShowScrollbar) {
                  scrollbarContainer.classList.remove('hidden');
                } else {
                  scrollbarContainer.classList.add('hidden');
                }
              } else if (shouldShowScrollbar) {
                // 只有当 item 数量 > 1 时才创建 scrollbarContainer
                // 创建外层容器
                scrollbarContainer = document.createElement('div');
                scrollbarContainer.className =
                  'relative bottom-[0px] left-0 right-0 mx-auto w-[120px] max-w-[120px] t-[4px] max-lg:block [--swiper-scrollbar-drag-bg-color:var(--marketing-customize-color)]';

                // 创建内层 scrollbar
                scrollbarDom = document.createElement('div');
                scrollbarDom.className = 'swiper-scrollbar h-[4px]';
                scrollbarContainer.appendChild(scrollbarDom);

                // 添加到 content-swiper 容器
                contentSwiperContainer.appendChild(scrollbarContainer);
              }
            }

            // 初始化 Swiper（始终配置navigation，通过updateNavigationButtons控制显示/隐藏）
            this.swiper = new Swiper(swiperContainer, {
              effect: 'coverflow',
              slidesPerView: 'auto',
              spaceBetween: 32,
              centeredSlides: true,
              centeredSlidesBounds: false, // 不限制边界，让两侧能显示多少就显示多少
              watchOverflow: false, // 允许溢出，让两侧能显示多少就显示多少
              speed: 600, // 滑动动画速度
              // 确保居中计算正确
              normalizeSlideIndex: true,
              coverflowEffect: {
                rotate: 0, // 不旋转
                stretch: '-56', // 不拉伸
                depth: 200, // 深度，让左右两侧有3D效果
                modifier: 1, // 缩放修饰符，控制两侧的缩放程度
                slideShadows: false, // 禁用阴影
              },
              // 确保 coverflow 效果平滑
              grabCursor: true,
              navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
              },
              scrollbar: scrollbarDom
                ? {
                    el: scrollbarDom,
                    draggable: true,
                    hide: false, // 始终显示 scrollbar
                  }
                : undefined,
              breakpoints: {
                577: {
                  spaceBetween: 32,
                },
                576: {
                  spaceBetween: 0,
                },
                0: {
                  spaceBetween: 0,
                },
              },
              on: {
                init: () => {
                  // 初始化时检查按钮显示状态
                  this.updateNavigationButtons();
                  // 同步 timeline 的选中状态
                  // 如果设置了保持位置的标志，不自动同步，由外部逻辑处理
                  if (!this._shouldKeepPosition && this.swiper) {
                    const activeIndex = this.swiper?.realIndex ?? 0;
                    this.syncTimelineSelection(activeIndex);
                  }
                },
                slideChange: () => {
                  // 同步 timeline 的选中状态
                  if (this.swiper) {
                    const activeIndex = this.swiper?.realIndex ?? 0;
                    this.syncTimelineSelection(activeIndex);
                  }
                  // 每次切换后更新按钮显示状态
                  this.updateNavigationButtons();
                },
                transitionEnd: () => {
                  // 确保滑动后居中
                  if (this.swiper) {
                    // 使用 update 方法确保 coverflow 效果正确居中
                    // 这会重新计算所有 slide 的位置和 transform，确保居中
                    this.swiper.update();
                  }
                },
              },
            });

            // 初始化时更新按钮显示状态
            this.updateNavigationButtons();

            // 如果设置了保持位置的标志，保持当前位置，不切换 swiper，不更新 timeline 高亮状态
            if (this._shouldKeepPosition && this._nextActiveIndexForTimeline !== undefined) {
              // 清除标志
              this._shouldKeepPosition = false;
              this._nextActiveIndexForTimeline = undefined;
              // 保持当前位置，不进行任何操作
              return;
            }

            // 检查当前显示的活动是否已结束
            const currentItem = this.timelineData[savedCurrentIndex];

            // 如果当前活动已结束，且之前有 swiper 实例（不是首次初始化），保持原地不动
            if (currentItem && currentItem.status === 'ended' && hadSwiperInstance) {
              // 保持当前位置，不切换 swiper，不更新 timeline 高亮状态
              return;
            }

            // 默认切换到当前激活的时间点
            // 首次初始化时（没有之前的 swiper 实例），即使当前活动已结束，也应该切换到 active 活动
            const activeIndex = this.timelineData.findIndex((item) => item.status === 'active');
            if (activeIndex !== -1 && this.swiper) {
              setTimeout(() => {
                if (this.swiper) {
                  this.swiper.slideTo(activeIndex);
                  // 切换后更新按钮状态
                  this.updateNavigationButtons();
                  // 同步 timeline 的选中状态
                  this.syncTimelineSelection(activeIndex);
                  // coverflow 效果会自动居中，不需要手动调整
                }
              }, 100);
            } else if (this.swiper) {
              // 如果没有 active 状态的活动，同步当前显示的索引
              setTimeout(() => {
                if (this.swiper) {
                  const currentIndex = this.swiper?.realIndex ?? 0;
                  this.syncTimelineSelection(currentIndex);
                }
              }, 100);
            }
          }

          /**
           * 更新导航按钮的显示/隐藏状态
           * 根据当前slide位置判断是否需要显示prev/next按钮
           */
          updateNavigationButtons() {
            if (!this.swiper) return;

            const nextButton = this.querySelector('.marketing-coupon-snap-up-swiper-next');
            const prevButton = this.querySelector('.marketing-coupon-snap-up-swiper-prev');

            if (!nextButton || !prevButton) return;

            const totalSlides = this.timelineData.length;

            // 如果只有1个或更少的slide，隐藏所有按钮
            if (totalSlides <= 1) {
              nextButton.style.display = 'none';
              prevButton.style.display = 'none';
              return;
            }

            // 获取当前slide索引
            const currentIndex = this.swiper?.realIndex ?? 0;

            // 判断是否可以切换到next（不是最后一个）
            const canGoNext = currentIndex < totalSlides - 1;
            // 判断是否可以切换到prev（不是第一个）
            const canGoPrev = currentIndex > 0;

            // 显示/隐藏next按钮
            if (canGoNext) {
              nextButton.style.display = '';
            } else {
              nextButton.style.display = 'none';
            }

            // 显示/隐藏prev按钮
            if (canGoPrev) {
              prevButton.style.display = '';
            } else {
              prevButton.style.display = 'none';
            }
          }

          /**
           * 计算倒计时目标时间（下一场开始时间）
           * @param {Object} item - 当前时间段数据
           * @param {number} index - 当前索引
           * @returns {number} 目标时间戳（毫秒）
           */
          getCountdownTarget(item, index) {
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            // 如果 item 有 discount 数据，使用 discount 的 UTC 时间转换为本地时间
            if (item.discount) {
              const startTime = new Date(item.discount.utcStartTime);
              const endTime = new Date(item.discount.utcEndTime);

              if (item.status === 'active') {
                // 如果当前是活动状态，倒计时到当前时间段的结束时间（本地时间）
                return endTime.getTime();
              } else {
                // 如果当前不是活动状态，找到下一个未开始的时间段
                for (let i = index + 1; i < this.timelineData.length; i++) {
                  const nextItem = this.timelineData[i];
                  if (nextItem.status === 'not_started' && nextItem.discount) {
                    const nextStart = new Date(nextItem.discount.utcStartTime);
                    return nextStart.getTime();
                  }
                }
                // 如果没有找到下一个未开始的时间段，返回当前时间段的开始时间（作为fallback）
                return startTime.getTime();
              }
            }

            // 如果没有 discount 数据，使用 timeRange 解析（兼容旧逻辑）
            const [startTime, endTime] = item.timeRange.split('-');
            const [startHour, startMinute] = startTime.split(':').map(Number);
            const [endHour, endMinute] = endTime.split(':').map(Number);

            // 当前时间段的开始和结束时间（本地时间）
            const currentStart = new Date(today);
            currentStart.setHours(startHour, startMinute, 0, 0);

            const currentEnd = new Date(today);
            currentEnd.setHours(endHour, endMinute, 0, 0);

            if (item.status === 'active') {
              // 如果当前是活动状态，倒计时到当前时间段的结束时间
              return currentEnd.getTime();
            } else {
              // 如果当前不是活动状态，找到下一个未开始的时间段
              for (let i = index + 1; i < this.timelineData.length; i++) {
                const nextItem = this.timelineData[i];
                if (nextItem.status === 'not_started') {
                  const [nextStartTime] = nextItem.timeRange.split('-');
                  const [nextStartHour, nextStartMinute] = nextStartTime.split(':').map(Number);
                  const nextStart = new Date(today);
                  nextStart.setHours(nextStartHour, nextStartMinute, 0, 0);
                  return nextStart.getTime();
                }
              }
              // 如果没有找到下一个未开始的时间段，返回当前时间段的开始时间（作为fallback）
              return currentStart.getTime();
            }
          }

          /**
           * 初始化倒计时
           */
          initCountdown() {
            // 清除之前的定时器
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
            }

            // 更新所有倒计时
            this.updateAllCountdowns();

            // 每秒更新一次
            this.countdownInterval = setInterval(() => {
              this.updateAllCountdowns();
            }, 1000);
          }

          /**
           * 更新所有倒计时
           */
          updateAllCountdowns() {
            const swiperContainer = this.querySelector('.marketing-coupon-snap-up-swiper');
            if (!swiperContainer) return;

            const now = Date.now();

            // 在状态更新后重新获取倒计时容器，确保能获取到所有容器（包括新创建的）
            let countdownContainers = swiperContainer.querySelectorAll('[data-countdown-target]');

            // 检查并更新所有活动的状态
            if (this.swiper && this.timelineData && this.timelineData.length > 0) {
              const currentIndex = this.swiper?.activeIndex ?? 0;
              const currentItem = this.timelineData[currentIndex];
              let hasStatusChanged = false;
              let shouldSwitch = false;
              let nextActiveIndex = -1;

              // 遍历所有活动，检查并更新状态
              for (let i = 0; i < this.timelineData.length; i++) {
                const item = this.timelineData[i];
                if (!item.discount) continue;

                const startTime = new Date(item.discount.utcStartTime).getTime();
                const endTime = new Date(item.discount.utcEndTime).getTime();
                const oldStatus = item.status;

                // 检查活动是否应该开始（not_started -> active）
                if (item.status === 'not_started' && startTime <= now) {
                  item.status = 'active';
                  hasStatusChanged = true;
                }
                // 检查活动是否应该结束（active/finished -> ended）
                else if ((item.status === 'active' || item.status === 'finished') && endTime <= now) {
                  item.status = 'ended';
                  hasStatusChanged = true;
                }
              }

              // 如果有状态变化，需要重新渲染 timeline 和 swiper
              if (hasStatusChanged) {
                // 在重新渲染前，检查当前活动是否已结束
                // 如果已结束，保持当前位置，不切换 swiper，不更新 timeline 高亮状态
                const updatedCurrentItem = this.timelineData[currentIndex];
                if (updatedCurrentItem && updatedCurrentItem.status === 'ended' && updatedCurrentItem.discount) {
                  // 只重新渲染 timeline 以更新活动状态（如按钮文本等），不切换 swiper，不更新 timeline 高亮状态
                  // 传入 false 避免重新初始化 swiper，防止 swiper 重新滑动
                  this.renderTimeline(false);

                  // 更新所有 slide 的状态和按钮（包括 data-status 和按钮状态）
                  // 这样时间刚到的活动会变成抢购已结束状态，下一场活动会变成可以抢购的状态
                  if (this.swiper) {
                    this.updateAllSlidesStatusAndButtons();
                    // 确保当前 swiper 位置对应的 timeline item 保持选中状态
                    const currentSwiperIndex = this.swiper.realIndex ?? this.swiper.activeIndex ?? currentIndex;
                    this.syncTimelineSelection(currentSwiperIndex, false);
                    // 重新获取倒计时容器，确保能获取到所有容器（包括新创建的）
                    countdownContainers = swiperContainer.querySelectorAll('[data-countdown-target]');
                  }
                  return;
                }

                // 如果当前活动不是已结束状态，但状态发生了变化（如 not_started -> active）
                // 只更新 timeline 高亮状态，不重新渲染 swiper，避免 swiper 重新滑动
                // 传入 false 避免重新初始化 swiper，防止 swiper 重新滑动
                this.renderTimeline(false);

                // 更新所有 slide 的状态和按钮（包括 data-status 和按钮状态）
                if (this.swiper) {
                  this.updateAllSlidesStatusAndButtons();
                  // 确保当前 swiper 位置对应的 timeline item 保持选中状态
                  const currentSwiperIndex = this.swiper.realIndex ?? this.swiper.activeIndex ?? currentIndex;
                  this.syncTimelineSelection(currentSwiperIndex, false);
                  // 重新获取倒计时容器，确保能获取到所有容器（包括新创建的）
                  countdownContainers = swiperContainer.querySelectorAll('[data-countdown-target]');
                }
              }
            }

            countdownContainers.forEach((container) => {
              const targetTime = parseInt(container.getAttribute('data-countdown-target'));
              if (!targetTime) return;

              const timeDifference = targetTime - now;

              // 找到倒计时区域的父元素（marketing-coupon-snap-up-slide-content-right-time）
              const countdownTimeElement = container.closest('.marketing-coupon-snap-up-slide-content-right-time');

              // 判断是桌面端容器还是移动端容器
              const isMobileContainer = container.classList.contains(
                'marketing-coupon-snap-up-slide-content-right-time-content-mobile'
              );

              if (timeDifference > 0) {
                // 显示倒计时区域
                if (countdownTimeElement) {
                  countdownTimeElement.style.display = '';
                }

                // 计算时分秒
                const hours = Math.floor(timeDifference / (1000 * 60 * 60));
                const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

                if (isMobileContainer) {
                  // 更新移动端显示（时分秒合并显示 00H：50M：57S）
                  const mobileValueElement = container.querySelector(
                    '.marketing-coupon-snap-up-slide-content-right-time-item-value'
                  );
                  if (mobileValueElement) {
                    const formattedTime = `${String(hours).padStart(2, '0')}${window.i18n.abbr.hrs}：${String(
                      minutes
                    ).padStart(2, '0')}${window.i18n.abbr.mins}：${String(seconds).padStart(2, '0')}${
                      window.i18n.abbr.secs
                    }`;
                    mobileValueElement.textContent = formattedTime;
                  }
                } else {
                  // 更新桌面端显示（时分秒分开显示）
                  const hrsElement = container.querySelector('.hrs');
                  const minElement = container.querySelector('.min');
                  const secElement = container.querySelector('.sec');

                  if (hrsElement) {
                    hrsElement.textContent = String(hours).padStart(2, '0');
                  }
                  if (minElement) {
                    minElement.textContent = String(minutes).padStart(2, '0');
                  }
                  if (secElement) {
                    secElement.textContent = String(seconds).padStart(2, '0');
                  }
                }
              } else {
                // 时间已到（倒计时为0），隐藏倒计时区域
                if (countdownTimeElement) {
                  countdownTimeElement.style.display = 'none';
                }
              }
            });
          }

          /**
           * 同步 timeline 的选中状态
           * @param {number} index - Swiper 的当前索引
           * @param {boolean} shouldScroll - 是否滚动 timeline 到选中项（默认 true）
           */
          syncTimelineSelection(index, shouldScroll = true) {
            const timelineContainer = this.querySelector('[data-timeline-items]');
            if (!timelineContainer) return;

            const allItems = timelineContainer.querySelectorAll('.marketing-coupon-snap-up__timeline-item');
            allItems.forEach((item, i) => {
              if (i === index) {
                item.classList.add('item-clicked');
                // 如果需要滚动，调用居中逻辑，使 timeline item 居中显示
                if (shouldScroll) {
                  setTimeout(() => {
                    this.scrollItemToCenter(item, index);
                  }, 0);
                }
              } else {
                item.classList.remove('item-clicked');
              }
            });
          }

          /**
           * 滚动到当前激活的时间点
           */
          scrollToActiveItem() {
            const timelineContainer = this.querySelector('[data-timeline-items]');
            if (!timelineContainer) return;

            // 找到当前激活的item
            const activeIndex = this.timelineData.findIndex((item) => item.status === 'active');
            if (activeIndex === -1) {
              const screenWidth = window.innerWidth;
              if (screenWidth >= 1440) {
                timelineContainer.scrollTo({
                  left: 0,
                  behavior: 'auto',
                });
              }
              return;
            }

            const activeItem = timelineContainer.querySelectorAll('.marketing-coupon-snap-up__timeline-item')[
              activeIndex
            ];
            if (!activeItem) return;

            // 延迟执行，确保DOM已渲染
            setTimeout(() => {
              this.scrollItemToCenter(activeItem, activeIndex);
            }, 100);
          }

          /**
           * 获取当前屏幕尺寸对应的item宽度
           * @returns {number} item宽度
           */
          getItemWidth() {
            const width = window.innerWidth;
            if (width <= 576) {
              return 150;
            } else if (width <= 960) {
              return 220;
            } else {
              return 224;
            }
          }

          /**
           * 将点击的item滚动到中间位置
           * @param {HTMLElement} item - 被点击的item元素
           * @param {number} index - item的索引
           */
          scrollItemToCenter(item, index) {
            const timelineContainer = this.querySelector('[data-timeline-items]');
            if (!timelineContainer) {
              console.error('Timeline container not found');
              return;
            }

            const containerWidth = timelineContainer.offsetWidth;
            const itemWidth = this.getItemWidth();
            const totalItems = this.timelineData.length;
            const totalWidth = totalItems * itemWidth;

            // 计算item的左右边界
            const itemLeft = index * itemWidth;
            const itemRight = itemLeft + itemWidth;

            // 计算最大和最小滚动位置
            const maxScrollLeft = Math.max(0, totalWidth - containerWidth);
            const minScrollLeft = 0;

            // 计算理想居中位置（使item在容器中间）
            const idealCenter = itemLeft - (containerWidth - itemWidth) / 2;

            // 计算前后可用的item数量
            const itemsBefore = index; // 当前item之前的item数量
            const itemsAfter = totalItems - index - 1; // 当前item之后的item数量

            // 计算前面需要完整显示的item数量
            // 前面的item必须是完整的，所以需要计算能完整显示多少个
            const itemsCanShowBefore = Math.floor((containerWidth - itemWidth) / itemWidth);
            // 后面可以是半个，所以可以显示更多
            const itemsCanShowAfter = Math.ceil((containerWidth - itemWidth) / itemWidth);

            let targetScrollLeft;

            // 如果后面的数量不够支撑居中，则排在最后，但必须要在视图中显示出来
            if (itemsAfter < itemsCanShowAfter) {
              // 后面的数量不够，滚动到最后，确保当前item在视图内
              targetScrollLeft = Math.max(0, totalWidth - containerWidth);

              // 确保当前item完整显示在视图内
              if (targetScrollLeft > itemLeft) {
                // 如果滚动到最后会导致当前item的左边界超出视图，则调整到itemLeft
                targetScrollLeft = itemLeft;
              }
              // 确保当前item的右边界在视图内
              if (targetScrollLeft + containerWidth < itemRight) {
                targetScrollLeft = itemRight - containerWidth;
              }
            }
            // 如果前面的数量不够，则显示在第一位
            else if (itemsBefore < itemsCanShowBefore) {
              // 前面的数量不够，滚动到第一个位置
              targetScrollLeft = 0;

              // 确保当前item完整显示在视图内
              if (targetScrollLeft + containerWidth < itemRight) {
                // 如果滚动到第一个位置会导致当前item的右边界超出视图，则调整
                targetScrollLeft = itemRight - containerWidth;
              }
            }
            // 如果前后数量都足够，则居中显示，但确保前面的item是完整的
            else {
              // 使用理想居中位置
              targetScrollLeft = idealCenter;

              // 确保前面的item是完整的：调整到item宽度的整数倍
              // 计算前面能完整显示的item数量
              const scrollLeftForFullItemsBefore = itemLeft - itemsCanShowBefore * itemWidth;

              // 如果理想居中位置会导致前面的item被切掉一半，则调整
              if (targetScrollLeft < scrollLeftForFullItemsBefore) {
                targetScrollLeft = scrollLeftForFullItemsBefore;
              }

              // 限制在有效滚动范围内
              if (targetScrollLeft < minScrollLeft) {
                targetScrollLeft = minScrollLeft;
              } else if (targetScrollLeft > maxScrollLeft) {
                targetScrollLeft = maxScrollLeft;
              }
            }

            // 最终验证：确保item完整显示在视图内，且前面的item是完整的
            // 确保item的左边界在视图内
            if (targetScrollLeft > itemLeft) {
              targetScrollLeft = itemLeft;
              // 但需要确保不超过最大滚动位置
              if (targetScrollLeft > maxScrollLeft) {
                targetScrollLeft = maxScrollLeft;
              }
            }

            // 确保item的右边界在视图内
            if (targetScrollLeft + containerWidth < itemRight) {
              targetScrollLeft = itemRight - containerWidth;
              // 但需要确保不小于最小滚动位置
              if (targetScrollLeft < minScrollLeft) {
                targetScrollLeft = minScrollLeft;
              }
            }

            // 确保前面的item是完整的：调整到item宽度的整数倍
            // 计算当前滚动位置对应的第一个完整item的索引
            const firstVisibleItemIndex = Math.floor(targetScrollLeft / itemWidth);
            const scrollLeftForFullFirstItem = firstVisibleItemIndex * itemWidth;

            // 如果当前滚动位置不是item宽度的整数倍，调整到最近的整数倍（向下取整）
            if (targetScrollLeft !== scrollLeftForFullFirstItem) {
              targetScrollLeft = scrollLeftForFullFirstItem;

              // 但需要确保当前item仍然完整显示在视图内
              if (targetScrollLeft > itemLeft) {
                targetScrollLeft = itemLeft;
              }
              if (targetScrollLeft + containerWidth < itemRight) {
                targetScrollLeft = itemRight - containerWidth;
              }

              // 限制在有效滚动范围内
              if (targetScrollLeft < minScrollLeft) {
                targetScrollLeft = minScrollLeft;
              } else if (targetScrollLeft > maxScrollLeft) {
                targetScrollLeft = maxScrollLeft;
              }
            }

            // 执行滚动
            timelineContainer.scrollTo({
              left: targetScrollLeft,
              behavior: 'smooth',
            });
          }

          /**
           * 获取状态文本
           * @param {string} status - 状态: 'ended', 'active', 'not_started'
           * @returns {string} 状态文本
           */
          getStatusText(status) {
            const statusMap = {
              ended: this.dataset.statusEnded,
              active: this.dataset.statusActive,
              not_started: this.dataset.statusNotStarted,
            };
            return statusMap[status] || '';
          }

          /**
           * 检查活动是否已结束
           * @returns {boolean} 如果活动已结束，返回 true
           */
          isActivityEnded() {
            // 通过 API 返回的 status 判断：2=有效，3=已结束，1=未开始
            if (this.activityStatus === 2) {
              return false; // 活动有效
            }
            if (this.activityStatus === 3) {
              return true; // 活动已结束
            }
            // 如果 status 不存在或为其他值（包括1），默认返回 false
            return false;
          }

          /**
           * 获取按钮信息（文本、样式、类型等）
           * @param {Object} item - 时间段数据
           * @param {number} index - 索引
           * @param {boolean} isLoggedIn - 是否登录
           * @returns {Object} 按钮信息对象
           */
          getButtonInfo(item, index, isLoggedIn) {
            const result = {
              buttonText: '',
              buttonClass: 'not-current-snap-up-button',
              buttonType: '', // 'login', 'not_started', 'started', 'finished', 'ended'
              showCountdown: false,
              countdownLabel: '',
              countdownTarget: 0,
              disabled: false,
            };

            // 优先判断是否登录（当活动状态为 1 或 3 时，也要先判断登录状态）
            // 第一种：未登录
            if (!isLoggedIn) {
              result.buttonText = this.dataset.loginButtonText;
              result.buttonType = 'login';

              // 只有在当前时间段（active状态）的未登录按钮才使用 current-snap-up-button
              // 其他状态使用 not-current-snap-up-button
              if (item.status === 'active') {
                result.buttonClass = 'current-snap-up-button';
              } else {
                result.buttonClass = 'not-current-snap-up-button';
              }

              // 未登录时也显示倒计时
              // 如果整个活动未开始（activityStatus === 1），显示倒计时
              if (this.activityStatus === 1) {
                // 优先使用当前 item 的开始时间
                if (item.discount && item.discount.utcStartTime) {
                  result.showCountdown = true;
                  result.countdownLabel = window.i18n.start_in;
                  const startTime = new Date(item.discount.utcStartTime);
                  result.countdownTarget = startTime.getTime();
                } else if (this.timelineData && this.timelineData.length > 0) {
                  // 如果当前 item 没有 discount，查找第一个有 discount 的 item
                  const firstItem = this.timelineData.find((tItem) => tItem.discount && tItem.discount.utcStartTime);
                  if (firstItem && firstItem.discount && firstItem.discount.utcStartTime) {
                    result.showCountdown = true;
                    result.countdownLabel = window.i18n.start_in;
                    const startTime = new Date(firstItem.discount.utcStartTime);
                    result.countdownTarget = startTime.getTime();
                  }
                }
              } else if (item.status === 'not_started' && item.discount) {
                // 如果活动未开始，显示倒计时到开始时间
                result.showCountdown = true;
                result.countdownLabel = window.i18n.start_in;
                const startTime = new Date(item.discount.utcStartTime);
                result.countdownTarget = startTime.getTime();
              } else if (item.status === 'active' && !item.isFinished && item.discount) {
                // 如果活动进行中且未抢购完，显示倒计时到结束时间
                result.showCountdown = true;
                result.countdownLabel = window.i18n.end_in;
                const endTime = new Date(item.discount.utcEndTime);
                result.countdownTarget = endTime.getTime();
              } else if (item.status === 'active' && item.isFinished) {
                // 如果活动已抢购完，查找下一个未开始的活动
                const nextNotStartedItem = this.findNextNotStartedItem(index);
                if (nextNotStartedItem && nextNotStartedItem.discount) {
                  result.showCountdown = true;
                  result.countdownLabel = window.i18n.start_in;
                  const startTime = new Date(nextNotStartedItem.discount.utcStartTime);
                  result.countdownTarget = startTime.getTime();
                }
              }
              // 如果活动已结束，不显示倒计时

              return result;
            }

            // 已登录的情况下，判断活动状态
            // 如果活动状态为 1（未开始），显示 coupon_card_not_started_button_text，并显示倒计时
            if (this.activityStatus === 1) {
              result.buttonText = this.dataset.couponCardNotStartedButtonText;
              result.buttonClass = 'not-current-snap-up-button';
              result.buttonType = 'not_started';
              result.disabled = true;

              // 显示倒计时到第一个活动的开始时间
              if (item.discount && item.discount.utcStartTime) {
                result.showCountdown = true;
                result.countdownLabel = window.i18n.start_in;
                const startTime = new Date(item.discount.utcStartTime);
                result.countdownTarget = startTime.getTime();
              } else if (this.timelineData && this.timelineData.length > 0) {
                // 如果当前 item 没有 discount，查找第一个有 discount 的 item
                const firstItem = this.timelineData.find((tItem) => tItem.discount && tItem.discount.utcStartTime);
                if (firstItem && firstItem.discount && firstItem.discount.utcStartTime) {
                  result.showCountdown = true;
                  result.countdownLabel = window.i18n.start_in;
                  const startTime = new Date(firstItem.discount.utcStartTime);
                  result.countdownTarget = startTime.getTime();
                }
              }

              return result;
            }

            // 如果活动已经过了当天（status 为 3），显示 activity_ended_button_text
            if (this.isActivityEnded()) {
              result.buttonText = this.dataset.activityEndedButtonText;
              result.buttonClass = 'not-current-snap-up-button';
              result.buttonType = 'ended';
              result.disabled = true;
              return result;
            }

            // 第二种：抢购未开始
            if (item.status === 'not_started') {
              result.buttonText = this.dataset.couponCardNotStartedButtonText;
              result.buttonClass = 'not-current-snap-up-button';
              result.buttonType = 'not_started';
              // 显示倒计时到本场抢购开始时间
              result.showCountdown = true;
              result.countdownLabel = window.i18n.start_in;
              // 倒计时到本场抢购开始时间
              if (item.discount) {
                const startTime = new Date(item.discount.utcStartTime);
                result.countdownTarget = startTime.getTime();
              }
              return result;
            }

            // 第三种：抢购开始（active 状态且未抢购完）
            if (item.status === 'active' && !item.isFinished) {
              // 检查是否已经抢到该优惠券
              const discountId = item.discount?.id;
              if (discountId) {
                const storageKey = `snapUpCoupon_${discountId}`;
              }

              result.buttonText = this.dataset.couponCardStartedButtonText;
              result.buttonClass = 'current-snap-up-button';
              result.buttonType = 'started';
              // 显示距离结束还有多久
              result.showCountdown = true;
              result.countdownLabel = window.i18n.end_in;
              if (item.discount) {
                const endTime = new Date(item.discount.utcEndTime);
                result.countdownTarget = endTime.getTime();
              }
              return result;
            }

            // 第四种：抢购完（active 状态但 remainQuantity 为 0）
            if (item.status === 'active' && item.isFinished) {
              result.buttonText = this.dataset.couponCardFinishedButtonText;
              result.buttonClass = 'not-current-snap-up-button';
              result.buttonType = 'finished';
              result.disabled = true;
              // 查找下一个未开始的时间段
              const nextNotStartedItem = this.findNextNotStartedItem(index);
              if (nextNotStartedItem && nextNotStartedItem.discount) {
                // 如果有下一场，显示倒计时到下一场开始时间
                result.showCountdown = true;
                result.countdownLabel = window.i18n.start_in;
                const startTime = new Date(nextNotStartedItem.discount.utcStartTime);
                result.countdownTarget = startTime.getTime();
              }
              // 如果没有下一场，showCountdown 保持为 false，不显示倒计时
              return result;
            }

            // 第五种：已结束
            if (item.status === 'ended') {
              // 时间刚到的活动变成抢购已结束状态，使用 activityEndedButtonText
              result.buttonText = this.dataset.couponCardEndedButtonText;
              result.buttonClass = 'not-current-snap-up-button';
              result.buttonType = 'ended';

              return result;
            }

            // 默认
            result.buttonText = this.dataset.loginButtonText;
            return result;
          }

          /**
           * 查找下一个未开始的时间段
           * @param {number} currentIndex - 当前索引
           * @returns {Object|null} 下一个未开始的时间段，如果没有则返回 null
           */
          findNextNotStartedItem(currentIndex) {
            for (let i = currentIndex + 1; i < this.timelineData.length; i++) {
              const item = this.timelineData[i];
              if (item.status === 'not_started') {
                return item;
              }
            }
            return null;
          }

          /**
           * 查找下一个应该激活的活动（已开始或开始时间已到）
           * @param {number} currentIndex - 当前索引
           * @returns {Object|null} 下一个应该激活的活动，包含 item 和 index
           */
          findNextActiveItem(currentIndex) {
            const now = Date.now();
            for (let i = currentIndex + 1; i < this.timelineData.length; i++) {
              const item = this.timelineData[i];
              // 如果状态是 active，直接返回
              if (item.status === 'active') {
                return { item, index: i };
              }
              // 如果状态是 not_started，检查开始时间是否已到
              if (item.status === 'not_started' && item.discount) {
                const startTime = new Date(item.discount.utcStartTime).getTime();
                if (startTime <= now) {
                  // 更新状态为 active
                  item.status = 'active';
                  return { item, index: i };
                }
              }
            }
            return null;
          }

          /**
           * 更新当前 slide 的按钮状态（不重新渲染整个 swiper）
           * @param {number} index - 当前 slide 的索引
           */
          updateCurrentSlideButton(index) {
            if (!this.swiper || !this.timelineData || index >= this.timelineData.length) return;

            const item = this.timelineData[index];
            if (!item || !item.discount) return;

            // 获取当前 slide 元素
            const slides = this.swiper.slides;
            if (!slides || index >= slides.length) return;

            const slide = slides[index];
            if (!slide) return;

            // 检查是否登录
            const isLoggedIn = Boolean(window.customer);

            // 获取按钮信息
            const buttonInfo = this.getButtonInfo(item, index, isLoggedIn);

            // 查找按钮元素
            const button = slide.querySelector('button');
            if (!button) return;

            // 更新按钮文本
            button.textContent = buttonInfo.buttonText;

            // 更新按钮类名
            button.className = buttonInfo.buttonClass;

            // 更新按钮禁用状态
            button.disabled = buttonInfo.disabled;

            // 更新按钮的 data-type 属性
            button.setAttribute('data-type', buttonInfo.buttonType);
            if (item.discount?.id) {
              button.setAttribute('data-discount-id', item.discount.id);
            }

            // 更新倒计时区域
            const countdownContainer = slide.querySelector('.marketing-coupon-snap-up-slide-content-right-time');
            if (buttonInfo.showCountdown && buttonInfo.countdownTarget) {
              // 如果应该显示倒计时，但容器不存在，需要创建
              if (!countdownContainer) {
                const rightContent = slide.querySelector('.marketing-coupon-snap-up-slide-content-right');
                if (rightContent) {
                  const countdownHTML = `
                  <div class="marketing-coupon-snap-up-slide-content-right-time">
                    <span class="marketing-coupon-snap-up-slide-content-right-time-title">${buttonInfo.countdownLabel}</span>
                    <div class="marketing-coupon-snap-up-slide-content-right-time-content" data-countdown-target="${buttonInfo.countdownTarget}">
                      <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                        <div class="hrs marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                        <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${window.i18n.hrs}</span>
                      </div>
                      <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                        <div class="min marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                        <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${window.i18n.mins}</span>
                      </div>
                      <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                        <div class="sec marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                        <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${window.i18n.secs}</span>
                      </div>
                    </div>
                    <div class="marketing-coupon-snap-up-slide-content-right-time-content-mobile" data-countdown-target="${buttonInfo.countdownTarget}">
                      <div class="marketing-coupon-snap-up-slide-content-right-time-item-value">00${window.i18n.abbr.hrs}：00${window.i18n.abbr.mins}：00${window.i18n.abbr.secs}</div>
                    </div>
                  </div>
                `;
                  const titleElement = rightContent.querySelector(
                    '.marketing-coupon-snap-up-slide-content-right-title'
                  );
                  if (titleElement && titleElement.nextSibling) {
                    rightContent.insertBefore(
                      document.createRange().createContextualFragment(countdownHTML),
                      titleElement.nextSibling
                    );
                  } else if (titleElement) {
                    titleElement.insertAdjacentHTML('afterend', countdownHTML);
                  }
                }
              } else {
                // 更新倒计时标签
                const countdownTitle = countdownContainer.querySelector(
                  '.marketing-coupon-snap-up-slide-content-right-time-title'
                );
                if (countdownTitle) {
                  countdownTitle.textContent = buttonInfo.countdownLabel;
                }
                // 更新倒计时目标时间
                const countdownTargetElement = countdownContainer.querySelector('[data-countdown-target]');
                if (countdownTargetElement) {
                  countdownTargetElement.setAttribute('data-countdown-target', buttonInfo.countdownTarget);
                }
              }
            } else {
              // 如果不应该显示倒计时，隐藏倒计时容器
              if (countdownContainer) {
                countdownContainer.style.display = 'none';
              }
            }
          }

          /**
           * 更新所有 slide 的状态和按钮（不重新渲染整个 swiper）
           */
          updateAllSlidesStatusAndButtons() {
            if (!this.swiper || !this.timelineData) return;

            const slides = this.swiper.slides;
            if (!slides) return;

            const isLoggedIn = Boolean(window.customer);

            // 遍历所有 slide，更新状态和按钮
            this.timelineData.forEach((item, index) => {
              if (index >= slides.length) return;

              const slide = slides[index];
              if (!slide) return;

              // 更新 slide 的 data-status 属性（CSS 会根据 data-status='active' 自动高亮）
              slide.setAttribute('data-status', item.status);

              // 更新按钮状态
              const button = slide.querySelector('button');
              if (button && item.discount) {
                const buttonInfo = this.getButtonInfo(item, index, isLoggedIn);

                // 更新按钮文本
                button.textContent = buttonInfo.buttonText;

                // 更新按钮类名
                button.className = buttonInfo.buttonClass;

                // 更新按钮禁用状态
                button.disabled = buttonInfo.disabled;

                // 更新按钮的 data-button-type 属性
                button.setAttribute('data-button-type', buttonInfo.buttonType);
                if (item.discount?.id) {
                  button.setAttribute('data-discount-id', item.discount.id);
                }

                // 更新倒计时区域
                const countdownContainer = slide.querySelector('.marketing-coupon-snap-up-slide-content-right-time');
                if (buttonInfo.showCountdown && buttonInfo.countdownTarget) {
                  if (countdownContainer) {
                    countdownContainer.style.display = '';
                    // 更新倒计时标签
                    const countdownTitle = countdownContainer.querySelector(
                      '.marketing-coupon-snap-up-slide-content-right-time-title'
                    );
                    if (countdownTitle) {
                      countdownTitle.textContent = buttonInfo.countdownLabel;
                    }
                    // 更新桌面端倒计时目标时间
                    const desktopCountdownElement = countdownContainer.querySelector(
                      '.marketing-coupon-snap-up-slide-content-right-time-content[data-countdown-target]'
                    );
                    if (desktopCountdownElement) {
                      desktopCountdownElement.setAttribute('data-countdown-target', buttonInfo.countdownTarget);
                    }
                    // 更新移动端倒计时目标时间
                    const mobileCountdownElement = countdownContainer.querySelector(
                      '.marketing-coupon-snap-up-slide-content-right-time-content-mobile[data-countdown-target]'
                    );
                    if (mobileCountdownElement) {
                      mobileCountdownElement.setAttribute('data-countdown-target', buttonInfo.countdownTarget);
                    }
                  } else {
                    // 如果倒计时容器不存在，需要创建（类似 initSwiper 中的逻辑）
                    const rightContent = slide.querySelector('.marketing-coupon-snap-up-slide-content-right');
                    if (rightContent) {
                      const countdownHTML = `
                      <div class="marketing-coupon-snap-up-slide-content-right-time">
                        <span class="marketing-coupon-snap-up-slide-content-right-time-title">${buttonInfo.countdownLabel}</span>
                        <div class="marketing-coupon-snap-up-slide-content-right-time-content" data-countdown-target="${buttonInfo.countdownTarget}">
                          <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                            <div class="hrs marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                            <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${window.i18n.hrs}</span>
                          </div>
                          <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                            <div class="min marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                            <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${window.i18n.mins}</span>
                          </div>
                          <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                            <div class="sec marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                            <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${window.i18n.secs}</span>
                          </div>
                        </div>
                        <div class="marketing-coupon-snap-up-slide-content-right-time-content-mobile" data-countdown-target="${buttonInfo.countdownTarget}">
                          <div class="marketing-coupon-snap-up-slide-content-right-time-item-value">00H：00M：00S</div>
                        </div>
                      </div>
                    `;
                      const titleElement = rightContent.querySelector(
                        '.marketing-coupon-snap-up-slide-content-right-title'
                      );
                      if (titleElement && titleElement.nextSibling) {
                        rightContent.insertBefore(
                          document.createRange().createContextualFragment(countdownHTML),
                          titleElement.nextSibling
                        );
                      } else if (titleElement) {
                        titleElement.insertAdjacentHTML('afterend', countdownHTML);
                      }
                    }
                  }
                } else {
                  // 如果不应该显示倒计时，隐藏倒计时容器
                  if (countdownContainer) {
                    countdownContainer.style.display = 'none';
                  }
                }
              }
            });
          }

          /**
           * 处理按钮点击事件
           * @param {HTMLElement} button - 被点击的按钮
           */
          handleButtonClick(button) {
            // 如果按钮已禁用，直接返回
            if (button.disabled) {
              return;
            }

            const buttonType = button.getAttribute('data-button-type');
            const discountId = button.getAttribute('data-discount-id');
            const itemIndex = parseInt(button.getAttribute('data-item-index'));

            switch (buttonType) {
              case 'login':
                // 第一种：未登录，触发登录事件

                if (window.litime && window.litime.eventBus) {
                  if (window.customTracker) {
                    window.customTracker.trackEvent({
                      eventKey: 'Click_LimitedTimeCoupons_Login_Btn',
                      eventName: '限时优惠券模块登录按钮点击事件',
                      eventValue: {
                        businessId: this.businessId,
                      },
                    });
                  }
                  window.sessionStorage.setItem(
                    'auth_track_event',
                    JSON.stringify([
                      {
                        eventKey: 'Callback_Login_ByLimitedTimeCoupons_Result',
                        eventName: '通过限时优惠券模块登录结果事件',
                        eventType: 'login',
                        eventValue: {
                          businessId: this.businessId,
                        },
                      },
                      {
                        eventKey: 'Callback_Rigster_ByLimitedTimeCoupons_Result',
                        eventName: '通过限时优惠券模块注册结果事件',
                        eventType: 'register',
                        eventValue: {
                          businessId: this.businessId,
                        },
                      },
                    ])
                  );
                  window.litime.eventBus.publish('LOGIN');
                }
                break;

              case 'not_started':
                // 第二种：抢购未开始，无需操作
                // this.jumpToActiveCoupon();
                break;

              case 'started':
                // 第三种：抢购开始，调用抢购 API
                if (window.customTracker) {
                  window.customTracker.trackEvent({
                    eventKey: 'Click_LimitedTimeCoupons_GetCoupon_Btn',
                    eventName: '限时优惠券模块领取优惠券按钮点击事件',
                    eventValue: {
                      businessId: this.businessId,
                    },
                  });
                }
                this.handleSnapUp(discountId, button);
                break;

              case 'finished':
                // 第四种：抢购完，按钮已禁用，无需操作
                break;

              case 'ended':
                // 第五种：已结束，跳转到现有抢购时间段
                if (window.customTracker) {
                  window.customTracker.trackEvent({
                    eventKey: 'Click_LimitedTimeCoupons_GoNextActivity_Btn',
                    eventName: '限时优惠券模块前往下一场活动按钮点击事件',
                    eventValue: {
                      businessId: this.businessId,
                    },
                  });
                }
                this.jumpToActiveCoupon();
                break;
            }
          }

          /**
           * 处理抢购
           * @param {string} discountId - 优惠券 ID
           * @param {HTMLElement} button - 按钮元素
           */
          async handleSnapUp(discountId, button) {
            // 检查当前时间段状态，如果不是 active 状态，不请求接口
            const itemIndex = parseInt(button.getAttribute('data-item-index'));
            if (!isNaN(itemIndex) && this.timelineData && this.timelineData[itemIndex]) {
              const item = this.timelineData[itemIndex];
              // 如果时间段不是 active 状态，不请求接口（ended 状态的按钮不会调用 handleSnapUp，会调用 jumpToActiveCoupon）
              if (item.status !== 'active') {
                // 恢复按钮状态
                button.disabled = false;
                return;
              }
            }

            // 保存原始按钮文本
            const originalText = button.textContent;
            // 检查是否为 current-snap-up-button（开始抢购状态）
            const isCurrentSnapUpButton = button.classList.contains('current-snap-up-button');
            // 获取加载图标和按钮文本元素
            const rotateIcon = button.querySelector('.rotate_icon');
            const loadingButtonText = button.querySelector('.loading-button-text');

            // 如果是开始抢购状态，显示加载图标并隐藏按钮文本
            if (isCurrentSnapUpButton && rotateIcon && loadingButtonText) {
              rotateIcon.classList.remove('hidden');
              rotateIcon.classList.add('flex');
              loadingButtonText.classList.add('hidden');
              loadingButtonText.classList.remove('flex');
            }

            // 禁用按钮，防止重复点击
            button.disabled = true;
            // 标记是否为抢购限制错误
            let isLimitError = false;
            // 标记是否为余额数量不足错误
            let isStockError = false;

            try {
              // 每次抢购都重新请求接口
              let response = await window.litime.http.post('/shopify/marketing/flash/discount', {});

              if (response && response.code === 200) {
                // 显示弹窗
                // 等待一小段时间确保弹窗组件已加载
                await new Promise((resolve) => setTimeout(resolve, 100));
                if (window.customTracker) {
                  window.customTracker.trackEvent({
                    eventKey: 'Callback_LimitedTimeCoupons_GetCoupon_Result',
                    eventName: '限时优惠券模块领取优惠券结果事件',
                    eventStatus: 'success',
                    eventValue: {
                      discountCode: response.data.discountCode,
                      businessId: this.businessId,
                    },
                  });
                }
                // 先尝试在当前组件内查找，如果找不到再在整个 document 中查找
                const couponModal =
                  this.querySelector('marketing-coupon-snap-up-coupon') ||
                  document.querySelector('marketing-coupon-snap-up-coupon');

                if (couponModal && typeof couponModal.showModal === 'function' && response.data) {
                  // 将 coupon_success_title_text 添加到数据中作为标题
                  const modalData = {
                    ...response.data,
                    rewardName: this.dataset.couponSuccessTitleText || response.data.rewardName || '',
                  };
                  couponModal.showModal(modalData);
                } else {
                  // 如果弹窗组件未加载或数据不存在，显示 toast
                  if (window.litime && window.litime.showToast) {
                    window.litime.showToast('success', this.dataset.couponSuccessTitleText);
                  }
                  console.warn('Coupon modal not found or data missing:', {
                    couponModal: !!couponModal,
                    showModal: typeof couponModal?.showModal,
                    hasData: !!response.data,
                    responseData: response.data,
                  });
                }
              } else {
                // 根据错误码判断失败原因
                const errorCode = response?.code;
                if (window.customTracker) {
                  window.customTracker.trackEvent({
                    eventKey: 'Callback_LimitedTimeCoupons_GetCoupon_Result',
                    eventName: '限时优惠券模块领取优惠券结果事件',
                    eventStatus: 'fail',
                    eventValue: {
                      businessId: this.businessId,
                    },
                  });
                }
                if (errorCode === 10051427) {
                  window.litime.showToast('error', this.dataset.couponLimitTipText);
                } else if (errorCode === 10051428) {
                  // 余额数量不足
                  isStockError = true;
                  window.litime.showToast('error', this.dataset.couponFailedTipText);
                } else if (errorCode === 10051003) {
                  // 抢购失败
                  window.litime.showToast('error', window.litime.error_10051003);
                } else if (errorCode === 10051430) {
                  // 抢购失败
                  window.litime.showToast('error', window.litime.error_10051430);
                } else {
                  window.litime.showToast('error', this.dataset.couponFailedTipText);
                }
              }
            } catch (error) {
              window.litime.showToast('error', this.dataset.couponFailedTipText);
            } finally {
              // 恢复加载状态（无论成功还是失败都要恢复）
              if (isCurrentSnapUpButton && rotateIcon && loadingButtonText) {
                rotateIcon.classList.add('hidden');
                rotateIcon.classList.remove('flex');
                loadingButtonText.classList.remove('hidden');
                loadingButtonText.classList.add('flex');
              }

              // 恢复按钮状态
              if (isLimitError || isStockError) {
                // 如果是抢购限制错误或余额数量不足错误，将按钮文本改为 coupon_card_finished_button_text
                button.textContent = this.dataset.couponCardFinishedButtonText || originalText;
                // 保持按钮禁用状态，因为已经抢购完了
                button.disabled = true;
                // 更新按钮类型为 finished
                button.setAttribute('data-type', 'finished');
                // 更新按钮类名
                button.className = 'not-current-snap-up-button';

                // 更新倒计时区域，显示下一个活动的开始时间
                const itemIndex = parseInt(button.getAttribute('data-item-index'));
                if (!isNaN(itemIndex) && this.timelineData && this.timelineData[itemIndex]) {
                  // 查找下一个未开始的活动
                  const nextNotStartedItem = this.findNextNotStartedItem(itemIndex);
                  if (nextNotStartedItem && nextNotStartedItem.discount && nextNotStartedItem.discount.utcStartTime) {
                    // 获取当前 slide
                    const slide = button.closest('.swiper-slide');
                    if (slide) {
                      const countdownContainer = slide.querySelector(
                        '.marketing-coupon-snap-up-slide-content-right-time'
                      );
                      if (countdownContainer) {
                        // 显示倒计时区域
                        countdownContainer.style.display = '';

                        // 更新倒计时标签
                        const countdownTitle = countdownContainer.querySelector(
                          '.marketing-coupon-snap-up-slide-content-right-time-title'
                        );
                        if (countdownTitle) {
                          countdownTitle.textContent = window.i18n.start_in || 'Start in';
                        }

                        // 计算下一个活动的开始时间戳
                        const startTime = new Date(nextNotStartedItem.discount.utcStartTime);
                        const countdownTarget = startTime.getTime();

                        // 更新桌面端倒计时目标时间
                        const desktopCountdownElement = countdownContainer.querySelector(
                          '.marketing-coupon-snap-up-slide-content-right-time-content[data-countdown-target]'
                        );
                        if (desktopCountdownElement) {
                          desktopCountdownElement.setAttribute('data-countdown-target', countdownTarget);
                        }

                        // 更新移动端倒计时目标时间
                        const mobileCountdownElement = countdownContainer.querySelector(
                          '.marketing-coupon-snap-up-slide-content-right-time-content-mobile[data-countdown-target]'
                        );
                        if (mobileCountdownElement) {
                          mobileCountdownElement.setAttribute('data-countdown-target', countdownTarget);
                        }
                      } else {
                        // 如果倒计时容器不存在，创建它
                        const rightContent = slide.querySelector('.marketing-coupon-snap-up-slide-content-right');
                        if (rightContent) {
                          const startTime = new Date(nextNotStartedItem.discount.utcStartTime);
                          const countdownTarget = startTime.getTime();
                          const countdownHTML = `
                            <div class="marketing-coupon-snap-up-slide-content-right-time">
                              <span class="marketing-coupon-snap-up-slide-content-right-time-title">${
                                window.i18n.start_in || 'Start in'
                              }</span>
                              <div class="marketing-coupon-snap-up-slide-content-right-time-content" data-countdown-target="${countdownTarget}">
                                <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                                  <div class="hrs marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                                  <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${
                                    window.i18n.hrs
                                  }</span>
                                </div>
                                <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                                  <div class="min marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                                  <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${
                                    window.i18n.mins
                                  }</span>
                                </div>
                                <div class="marketing-coupon-snap-up-slide-content-right-time-item">
                                  <div class="sec marketing-coupon-snap-up-slide-content-right-time-item-value">00</div>
                                  <span class="marketing-coupon-snap-up-slide-content-right-time-item-text">${
                                    window.i18n.secs
                                  }</span>
                                </div>
                              </div>
                              <div class="marketing-coupon-snap-up-slide-content-right-time-content-mobile" data-countdown-target="${countdownTarget}">
                                <div class="marketing-coupon-snap-up-slide-content-right-time-item-value">00${
                                  window.i18n.abbr.hrs
                                }：00${window.i18n.abbr.mins}：00${window.i18n.abbr.secs}</div>
                              </div>
                            </div>
                          `;
                          const titleElement = rightContent.querySelector(
                            '.marketing-coupon-snap-up-slide-content-right-title'
                          );
                          if (titleElement && titleElement.nextSibling) {
                            rightContent.insertBefore(
                              document.createRange().createContextualFragment(countdownHTML),
                              titleElement.nextSibling
                            );
                          } else if (titleElement) {
                            titleElement.insertAdjacentHTML('afterend', countdownHTML);
                          }
                        }
                      }
                    }
                  } else {
                    // 如果没有下一个活动（最后一场），隐藏倒计时
                    const slide = button.closest('.swiper-slide');
                    if (slide) {
                      const countdownContainer = slide.querySelector(
                        '.marketing-coupon-snap-up-slide-content-right-time'
                      );
                      if (countdownContainer) {
                        countdownContainer.style.display = 'none';
                        // 移除 data-countdown-target 属性，防止 updateAllCountdowns 重新显示它
                        const desktopCountdownElement = countdownContainer.querySelector(
                          '.marketing-coupon-snap-up-slide-content-right-time-content[data-countdown-target]'
                        );
                        if (desktopCountdownElement) {
                          desktopCountdownElement.removeAttribute('data-countdown-target');
                        }
                        const mobileCountdownElement = countdownContainer.querySelector(
                          '.marketing-coupon-snap-up-slide-content-right-time-content-mobile[data-countdown-target]'
                        );
                        if (mobileCountdownElement) {
                          mobileCountdownElement.removeAttribute('data-countdown-target');
                        }
                      }
                    }
                  }
                } else {
                  // 如果 itemIndex 无效，也隐藏倒计时
                  const slide = button.closest('.swiper-slide');
                  if (slide) {
                    const countdownContainer = slide.querySelector(
                      '.marketing-coupon-snap-up-slide-content-right-time'
                    );
                    if (countdownContainer) {
                      countdownContainer.style.display = 'none';
                      // 移除 data-countdown-target 属性，防止 updateAllCountdowns 重新显示它
                      const desktopCountdownElement = countdownContainer.querySelector(
                        '.marketing-coupon-snap-up-slide-content-right-time-content[data-countdown-target]'
                      );
                      if (desktopCountdownElement) {
                        desktopCountdownElement.removeAttribute('data-countdown-target');
                      }
                      const mobileCountdownElement = countdownContainer.querySelector(
                        '.marketing-coupon-snap-up-slide-content-right-time-content-mobile[data-countdown-target]'
                      );
                      if (mobileCountdownElement) {
                        mobileCountdownElement.removeAttribute('data-countdown-target');
                      }
                    }
                  }
                }
              } else {
                // 其他情况，恢复按钮状态
                button.disabled = false;
                button.textContent = originalText;
              }
            }
          }

          /**
           * 跳转到现有抢购时间段的优惠券
           */
          jumpToActiveCoupon() {
            // 找到当前激活的时间段
            const activeIndex = this.timelineData.findIndex((item) => item.status === 'active');
            if (activeIndex !== -1 && this.swiper) {
              // 切换到激活的 slide
              this.swiper.slideTo(activeIndex);
              // 同步 timeline
              this.syncTimelineSelection(activeIndex);
            } else {
              // 如果没有激活的时间段，不执行任何操作
              console.log('No active coupon found');
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-coupon"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('marketing-coupon')) {
      customElements.define(
        'marketing-coupon',
        class MarketingDiscount extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initCopy();
          }
          initCopy() {
            this.copyButton = this.querySelector('.marketing-coupon__copy');
            this.codeText = this.querySelector('.marketing-coupon__code-text');
            console.log(this.copyButton, this.codeText);
            this.copyButton.addEventListener('click', () => this.copyDiscountCode());
            this.codeText.addEventListener('click', () => this.copyDiscountCode());
          }
          copyDiscountCode() {
            console.log('copyDiscountCode');
            const btn = this.copyButton;
            const codeText = this.codeText;
            const codeTrim = btn.getAttribute('data-code').trim();
            // 兼容safri浏览器 谷歌浏览器
            if (navigator.clipboard) {
              navigator.clipboard.writeText(codeTrim);
            } else {
              const textarea = document.createElement('textarea');
              textarea.value = codeTrim;
              document.body.appendChild(textarea);
              textarea.select();
              document.execCommand('copy');
              document.body.removeChild(textarea);
            }
            const copyText = this.getAttribute('data-copy-text');
            const copiedText = this.getAttribute('data-copied-text');
            btn.textContent = copiedText;
            codeText.setAttribute('data-copied', 'true');
            setTimeout(() => {
              btn.textContent = copyText;
              codeText.setAttribute('data-copied', 'false');
            }, 2000);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-media"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('marketing-media')) {
      customElements.define(
        'marketing-media',
        class referralBanner extends HTMLElement {
          constructor() {
            super();
          }
          async connectedCallback() {
            const self = this;
            const shareUrl = this.querySelector('[data-share-url]').dataset.shareUrl;
            const dataShareUrl = shareUrl ? window.location.origin + shareUrl : window.location.href;
            const dataPlatforms = this.querySelectorAll('[data-platform]');
            const discountCodeShare = this.querySelector('.marketing-media__discount-code-share');

            dataPlatforms.forEach((platform) => {
              platform.addEventListener('click', () => {
                const dataPlatform = platform.dataset.platform;

                // 执行 window.open 或复制操作
                if (dataPlatform === 'facebook') {
                  window.open(`https://www.facebook.com/sharer/sharer.php?u=${dataShareUrl}`, '_blank');
                } else if (dataPlatform === 'twitter') {
                  window.open(`https://twitter.com/intent/tweet?url=${dataShareUrl}`, '_blank');
                } else if (dataPlatform === 'instagram') {
                  window.litime.copyToClipboard(dataShareUrl);
                } else if (dataPlatform === 'pinterest') {
                  window.open(`https://pinterest.com/pin/create/button/?url=${dataShareUrl}`, '_blank');
                } else if (dataPlatform === 'tiktok') {
                  window.litime.copyToClipboard(dataShareUrl);
                } else if (dataPlatform === 'youtube') {
                  window.litime.copyToClipboard(dataShareUrl);
                }

                setTimeout(() => {
                  self.showDiscountCode();
                }, 3000);
              });
            });

            this.mediaClick();
          }

          mediaClick() {
            const self = this;
            const mediaUrlCopyBtn = this.querySelector('.media-url-copy-btn');

            if (!mediaUrlCopyBtn) {
              console.warn('[marketing-media] 未找到 .media-url-copy-btn 元素');
              return;
            }

            // 移除旧的事件监听器（如果存在）
            if (mediaUrlCopyBtn._mediaClickHandler) {
              mediaUrlCopyBtn.removeEventListener('click', mediaUrlCopyBtn._mediaClickHandler);
            }

            // 创建新的事件处理函数
            mediaUrlCopyBtn._mediaClickHandler = function () {
              const discountCode = mediaUrlCopyBtn.getAttribute('data-discount-code');
              if (discountCode && window.litime && window.litime.copyToClipboard) {
                window.litime.copyToClipboard(discountCode);
              } else {
                console.error('[marketing-media] 复制失败：折扣码或 copyToClipboard 方法不存在');
              }
            };

            // 绑定事件
            mediaUrlCopyBtn.addEventListener('click', mediaUrlCopyBtn._mediaClickHandler);
          }

          showDiscountCode() {
            const discountCodeShare = this.querySelector('.marketing-media__discount-code-share');
            if (discountCodeShare) {
              discountCodeShare.style.display = 'block';

              requestAnimationFrame(() => {
                discountCodeShare.classList.add('show');
              });
            }
          }

          hideDiscountCode() {
            const discountCodeShare = this.querySelector('.marketing-media__discount-code-share');
            if (discountCodeShare) {
              discountCodeShare.classList.remove('show');
              setTimeout(() => {
                discountCodeShare.style.display = 'none';
              }, 500); // 等待动画完成（0.5s）
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-member-benefits"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('marketing-member-benefits')) {
      customElements.define(
        'marketing-member-benefits',
        class extends HTMLElement {
          constructor() {
            super();
          }
          async connectedCallback() {
            const referralCode = new URLSearchParams(window.location.search).get('referralCode');
            if (window.customer) {
              try {
                const referralInfo = await this.getReferralInfo();
                const referralUrl = $(this.querySelector('.referral-url'));
                referralUrl.find('span').text(referralInfo?.referralInviteLink);

                const referralSignUpCount = $(this.querySelector('.referral-sign-up-count'));
                referralSignUpCount.text(referralInfo?.invitedNums);
                const referralPurchaseCount = $(this.querySelector('.referral-purchase-count'));
                referralPurchaseCount.text(referralInfo?.orderRewardNums);
                const memberRedeemModalBtnCopy = $(this.querySelector('.referral-url-copy-btn'));
                memberRedeemModalBtnCopy.on('click', () => {
                  this.copy(referralInfo?.referralInviteLink);
                });
                const referralUrlWrapper = $(this.querySelector('.referral-url-wrapper'));
                referralUrlWrapper.removeClass('opacity-0');
                const memberBannerUserInfo = $(this.querySelector('.referral-banner__user-info'));
                memberBannerUserInfo.removeClass('hidden').addClass('flex');
                const shareIconFacebook = $(this.querySelector('.share-icon-facebook'));
                shareIconFacebook.on('click', () => {
                  this.share('facebook', referralInfo?.referralInviteLink);
                });
                const shareIconTwitter = $(this.querySelector('.share-icon-twitter'));
                shareIconTwitter.on('click', () => {
                  this.share('twitter', referralInfo?.referralInviteLink);
                });
              } catch (error) {
                console.error('Referral info error:', error.message);
                if (window.litime && typeof window.litime.showToast === 'function') {
                  window.litime.showToast('error', error.message);
                }
              }
            } else {
              setTimeout(() => {
                if (referralCode) {
                  window.litime.eventBus.publish('REGISTER', {
                    referralInviterCode: referralCode,
                  });
                }
              }, 500);
            }
            const memberBannerLoginBtn = $(
              this.querySelector('.marketing-member-benefits__benefit-item-button--login')
            );
            memberBannerLoginBtn.on('click', () => {
              window.litime.eventBus.publish('LOGIN');
            });
            const referralInvitedReward = window.litime.getLocalStorage('referralInvitedReward');
            if (window.customer && referralInvitedReward && referralInvitedReward.discountReward) {
              const referralRewordModal = $(this.querySelector('.referral-reword-modal'));
              const referralRewordModalImg = $(this.querySelector('.referral-reword-modal-img'));
              referralRewordModalImg.attr('src', referralInvitedReward.discountReward.icon);
              const referralRewordModalCode = $(this.querySelector('.referral-reword-modal-code'));
              referralRewordModalCode.find('span').text(referralInvitedReward.discountReward.discountCode);
              const referralRewordModalRule = $(this.querySelector('.referral-reword-modal-rule'));
              referralRewordModalRule.on('click', () => {
                const referralRewardDetailModal = $(this.querySelector('.referral-reword-detail-modal'));
                referralRewardDetailModal
                  .find('.referral-reword-detail-modal-img')
                  .attr('src', referralInvitedReward.discountReward.icon);
                referralRewardDetailModal
                  .find('.referral-reword-detail-modal-title')
                  .text(referralInvitedReward.discountReward.rewardName);
                referralRewardDetailModal
                  .find('.referral-reword-detail-modal-rules')
                  .html(referralInvitedReward.discountReward.rule);
                referralRewardDetailModal.removeClass('hidden').addClass('flex');
              });
              referralRewordModal.removeClass('hidden').addClass('flex');
              window.litime.disableScroll();
              window.litime.clearLocalStorage('referralInvitedReward');
            }
            this.boundBindBrowserEvent = this.bindBrowserEvent.bind(this);
            document.addEventListener('click', this.boundBindBrowserEvent);
          }
          async getReferralInfo() {
            const url = '/shopify/referral/get/info';
            const { data, code } = await window.litime.http.get(url);
            if (code === 200) {
              return data;
            } else {
              return null;
            }
          }

          share(platform, url) {
            if (platform === 'facebook') {
              window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
            } else if (platform === 'twitter') {
              window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank');
            }
          }

          copy(text) {
            if (window.litime && typeof window.litime.copyToClipboard === 'function') {
              window.litime.copyToClipboard(text);
            }
          }

          bindBrowserEvent(event) {
            // 处理浏览器事件
            const target = event.target;
            if (target.classList.contains('copy-referral-link')) {
              const referralUrl = this.querySelector('.referral-url span');
              if (referralUrl) {
                this.copy(referralUrl.textContent);
              }
            }
          }

          disconnectedCallback() {
            document.removeEventListener('click', this.boundBindBrowserEvent);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-product"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('marketing-product')) {
      customElements.define(
        'marketing-product',
        class marketingProduct extends HTMLElement {
          constructor() {
            super();
          }

          async connectedCallback() {
            // 获取显示模式
            const displayMode = this.getAttribute('data-display-mode');

            // 根据模式初始化不同功能
            if (displayMode === 'slid') {
              // 左右滑动模式：初始化 Swiper
              this.initSwiper();
            } else {
              // 往下铺开模式：初始化网格和加载更多
              this.initProductGrid();
            }
          }

          /**
           * 初始化 Swiper 轮播
           */
          initSwiper() {
            const $swiper = this.querySelector('.marketing-product__swiper');
            if (!$swiper) return;

            new Swiper($swiper, {
              slidesPerView: 4,
              breakpoints: {
                1201: {
                  slidesPerView: 4,
                  spaceBetween: 24,
                },
                961: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
                0: {
                  slidesPerView: 'auto',
                  spaceBetween: 16,
                },
              },
              navigation: {
                nextEl: this.querySelector('.marketing-product_next'),
                prevEl: this.querySelector('.marketing-product_prev'),
              },
              scrollbar: {
                el: this.querySelector('.swiper-scrollbar'),
              },
            });
          }

          /**
           * 获取响应式网格配置
           * 根据屏幕宽度返回每行显示数量和每次加载数量
           */
          _getGridStep() {
            const w = window.innerWidth;
            const pcRows = parseInt(this.getAttribute('data-pc-count') || '1', 10);
            const padRows = parseInt(this.getAttribute('data-pad-count') || '1', 10);
            const smallPadRows = parseInt(this.getAttribute('data-small-pad-count') || '1', 10);
            const mobileRows = parseInt(this.getAttribute('data-mobile-count') || '1', 10);

            if (w >= 1201) {
              // PC端：4列，每次+4个
              return { perRow: 4, step: 4, init: pcRows * 4 };
            } else if (w >= 961) {
              // 平板端：3列，每次+3个
              return { perRow: 3, step: 3, init: padRows * 3 };
            } else if (w >= 577) {
              // 小平板端：2列，每次+4个
              return { perRow: 2, step: 4, init: smallPadRows * 2 };
            } else {
              // 手机端：1列，每次+4个
              return { perRow: 1, step: 4, init: mobileRows * 1 };
            }
          }

          /**
           * 初始化产品网格功能
           * 处理 down 模式下的响应式显示和点击加载更多
           */
          initProductGrid() {
            const grid = this.querySelector('.grid');
            const more = this.querySelector('.marketing-product__grid_more');

            if (!grid || !more) {
              return;
            }

            const { step, init } = this._getGridStep();
            const total = grid.querySelectorAll('.marketing-product__grid_item').length;
            const initVisible = Math.min(init, total);

            grid.dataset.visibleCount = String(initVisible);

            // 确保初始状态正确，移除可能冲突的响应式类名
            this._ensureInitialVisibility(grid, initVisible);

            this._updateMoreButtonVisibility(grid, more);

            // 移除之前的事件监听器，避免重复绑定
            if (this._handleMoreClick) {
              more.removeEventListener('click', this._handleMoreClick);
            }

            // 绑定点击事件
            this._handleMoreClick = (e) => {
              e.preventDefault();
              const { step } = this._getGridStep();
              const total = grid.querySelectorAll('.marketing-product__grid_item').length;
              const current = parseInt(grid.dataset.visibleCount || '0', 10) || 0;
              const next = Math.min(current + step, total);
              grid.dataset.visibleCount = String(next);
              this._applyGridVisibility(grid, more, true);
            };

            more.addEventListener('click', this._handleMoreClick);
          }

          /**
           * 确保初始可见性状态正确
           * @param {HTMLElement} grid - 网格容器
           * @param {number} initVisible - 初始可见数量
           */
          _ensureInitialVisibility(grid, initVisible) {
            const items = Array.from(grid.querySelectorAll('.marketing-product__grid_item'));

            items.forEach((el, idx) => {
              if (idx < initVisible) {
                // 确保应该显示的元素没有隐藏类
                el.classList.remove('hidden', 'max-lg:hidden', 'max-md:hidden');
              }
            });
          }

          /**
           * 更新"更多"按钮的可见性
           * @param {HTMLElement} grid - 网格容器
           * @param {HTMLElement} more - 更多按钮
           */
          _updateMoreButtonVisibility(grid, more) {
            const total = grid.querySelectorAll('.marketing-product__grid_item').length;
            const visible = parseInt(grid.dataset.visibleCount || '0', 10) || 0;

            // 控制按钮显隐
            if (visible >= total) {
              more.classList.add('hidden');
            } else {
              more.classList.remove('hidden');
            }
          }

          /**
           * 应用网格可见性
           * @param {HTMLElement} grid - 网格容器
           * @param {HTMLElement} more - 更多按钮
           * @param {boolean} smooth - 是否平滑过渡
           */
          _applyGridVisibility(grid, more, smooth) {
            const items = Array.from(grid.querySelectorAll('.marketing-product__grid_item'));
            const total = items.length;
            const visible = Math.min(parseInt(grid.dataset.visibleCount || '0', 10) || 0, total);

            items.forEach((el, idx) => {
              if (idx < visible) {
                // 显示元素：移除所有隐藏类，包括响应式类
                el.classList.remove('hidden', 'max-lg:hidden', 'max-md:hidden');
              } else {
                // 隐藏元素：添加基础hidden类
                el.classList.add('hidden');
              }
            });

            // 控制按钮显隐
            if (visible >= total) {
              more.classList.add('hidden');
            } else {
              more.classList.remove('hidden');
            }
          }

          disconnectedCallback() {
            // 清理事件监听器
            const more = this.querySelector('.marketing-product__grid_more');
            if (more && this._handleMoreClick) {
              more.removeEventListener('click', this._handleMoreClick);
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-scene"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marketing-scene')) {
    class MarketingScene extends HTMLElement {
      constructor() {
        super();
        this._tabs = [];
        this._panels = [];
        this._tabsWrap = null;
      }

      connectedCallback() {
        this._tabsWrap = this.querySelector('.marketing-scene__tabs');
        this._tabs = Array.from(this.querySelectorAll('.marketing-scene__tab'));
        this._panels = Array.from(this.querySelectorAll('.marketing-scene__panel'));
        this._tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this._setActive(index, true));
        });
        this.youtubeClick();
        // 小屏（<=576px）下，tabs标签默认只显示前三个，提供展开/收起
        this.addEventListener('click', (e) => this._handleMoreClick(e));
        // 完全移除 resize 监听器，避免自动收起
        // window.addEventListener('resize', () => this._handleResponsive(), { passive: true });
        // 初始化tabs高度和状态
        this._initializeTabsHeight();
        // 资源晚到（图片/字体）后再校准一次
        window.setTimeout(() => {
          this._initializeTabsHeight();
        }, 300);
        this._swipers = new WeakMap();
        this._initActivePanelSwiper();
        this._initProductGrids();
      }
      youtubeClick() {
        const youtubeWrappers = this.querySelectorAll('.youtube-wrapper');
        youtubeWrappers.forEach((youtubeWrapper) => {
          const youtubePlay = youtubeWrapper.querySelector('.youtube-play');
          if (!youtubePlay) return;
          youtubePlay.addEventListener('click', (e) => {
            e.stopPropagation(); // 防止冒泡触发到父级
            console.log('点击了播放按钮:', e.currentTarget);
            const iframe = youtubeWrapper.querySelector('iframe');
            iframe.src += '&autoplay=1';
            // 隐藏图片
            const youtubeImage = youtubeWrapper.querySelector('.youtube-image');
            youtubeImage.classList.add('hidden');
          });
        });
      }

      _initActivePanelSwiper() {
        const activeIndex = this._panels.findIndex((p) => !p.classList.contains('hidden'));
        if (activeIndex >= 0) this._initSwiperForPanel(this._panels[activeIndex]);
      }

      _initSwiperForPanel(panel) {
        if (!panel || this._swipers.has(panel)) {
          // 若已初始化则更新一次尺寸
          const inst = this._swipers.get(panel);
          if (inst && inst.update) inst.update();
          return;
        }
        const container = panel.querySelector('.marketing-scene-product-list_swiper');
        if (!container) return; // 非滑动模式时无swiper
        const nextEl = panel.querySelector('.marketing-scene-product-list_next');
        const prevEl = panel.querySelector('.marketing-scene-product-list_prev');
        const scrollbarEl = panel.querySelector('.marketing-scene-product-list_scrollbar');
        const paginationEl = panel.querySelector('.marketing-scene-product-list_swiper-pagination');

        const updateNav = (swp) => {
          if (!nextEl || !prevEl) return;
          if (swp.isBeginning) {
            prevEl.classList.add('hidden');
            prevEl.classList.remove('flex');
          } else {
            prevEl.classList.remove('hidden');
            prevEl.classList.add('flex');
          }
          if (swp.isEnd) {
            nextEl.classList.add('hidden');
          } else {
            nextEl.classList.remove('hidden');
          }
        };

        const swiper = new Swiper(container, {
          breakpoints: {
            577: { slidesPerView: 'auto', slidesPerGroup: 1, spaceBetween: 24 },
            0: { slidesPerView: 'auto', slidesPerGroup: 1, spaceBetween: 16 },
          },
          on: {
            init: function () {
              updateNav(this);
            },
            slideChange: function () {
              updateNav(this);
            },
          },
          navigation: { nextEl, prevEl },
          scrollbar: { el: scrollbarEl, draggable: true },
          pagination: {
            el: paginationEl,
            bulletClass: 'marketing-scene-product-list_bullet',
            bulletActiveClass: 'marketing-scene-product-list_bullet_active',
          },
        });
        this._swipers.set(panel, swiper);
      }

      _getGridStep(panel) {
        const w = window.innerWidth;
        const pcRows = parseInt(panel?.getAttribute('data-pc-count') || '1', 10);
        const padRows = parseInt(panel?.getAttribute('data-pad-count') || '1', 10);
        const smallPadRows = parseInt(panel?.getAttribute('data-small-pad-count') || '1', 10);
        const mobileRows = parseInt(panel?.getAttribute('data-mobile-count') || '1', 10);

        if (w >= 1201) {
          // PC端：4列，每次+4个
          return { perRow: 4, step: 4, init: pcRows * 4 };
        } else if (w >= 961) {
          // 平板端：3列，每次+3个
          return { perRow: 3, step: 3, init: padRows * 3 };
        } else if (w >= 577) {
          // 小平板端：2列，每次+4个
          return { perRow: 2, step: 4, init: smallPadRows * 2 };
        } else {
          // 手机端：1列，每次+4个
          return { perRow: 1, step: 4, init: mobileRows * 1 };
        }
      }

      _initProductGrids() {
        this._panels.forEach((panel) => {
          const grid = panel.querySelector('.marketing-scene__panel_content_product-list-grid');
          const more = panel.querySelector('.marketing-scene__panel_content_product-list-grid_more');
          if (!grid || !more) return;

          const { step, init } = this._getGridStep(panel);
          const total = grid.querySelectorAll('.marketing-scene__panel_content_product-list-grid_item').length;
          const initVisible = Math.min(init, total);
          grid.dataset.visibleCount = String(initVisible);
          this._applyGridVisibility(grid, more, false);

          more.onclick = (e) => {
            e.preventDefault();
            const { step } = this._getGridStep(panel);
            const total = grid.querySelectorAll('.marketing-scene__panel_content_product-list-grid_item').length;
            const current = parseInt(grid.dataset.visibleCount || '0', 10) || 0;
            const next = Math.min(current + step, total);
            grid.dataset.visibleCount = String(next);
            this._applyGridVisibility(grid, more, true);
          };
        });
      }

      _applyGridVisibility(grid, more, smooth) {
        const items = Array.from(grid.querySelectorAll('.marketing-scene__panel_content_product-list-grid_item'));
        const total = items.length;
        const visible = Math.min(parseInt(grid.dataset.visibleCount || '0', 10) || 0, total);
        items.forEach((el, idx) => {
          if (idx < visible) el.classList.remove('hidden');
          else el.classList.add('hidden');
        });
        // 控制按钮显隐
        if (visible >= total) {
          more.classList.add('hidden');
        } else {
          more.classList.remove('hidden');
        }
      }

      _handleResponsive() {
        // 完全禁用响应式处理，防止自动收起产品网格
        // 产品网格状态只能通过用户点击改变，不受窗口大小变化影响
        return;
      }

      _initializeTabsHeight() {
        // 新方法：只在初始化时设置tabs的高度和状态
        const isSmall = window.innerWidth <= 576;
        this._panels.forEach((panel) => {
          const grid = panel.querySelector('.marketing-scene__panel_content_tabs');
          if (!grid) return;
          const items = Array.from(grid.querySelectorAll('.marketing-scene__panel_content_tabs_item'));
          const moreBtn = panel.querySelector('.marketing-scene__panel_content_more');
          if (!items.length || !moreBtn) return;

          if (isSmall && items.length > 3) {
            // 默认折叠：保留前三个
            items.forEach((el, idx) => {
              if (idx > 2) el.classList.add('hidden');
            });
            this._applyCollapsedHeight(grid, items);
            const textEl = moreBtn.querySelector('.more-text');
            const container = this.querySelector('.marketing-scene__container');
            const learnMoreText = (container && container.getAttribute('data-learn-more-text')) || 'Learn More';
            if (textEl) textEl.textContent = learnMoreText;
            moreBtn.classList.remove('is-expanded');
            moreBtn.dataset.expanded = 'false';
            moreBtn.classList.remove('hidden');
            moreBtn.classList.add('flex');
          } else {
            // 大屏或不足3项：全部显示，隐藏按钮
            items.forEach((el) => el.classList.remove('hidden'));
            grid.style.height = '';
            moreBtn.classList.add('hidden');
            moreBtn.dataset.expanded = 'false';
            moreBtn.classList.remove('flex');
          }
        });
      }

      _applyCollapsedHeight(grid, items) {
        if (window.innerWidth > 576) {
          // 大于 576px 时，移除固定高度，让内容自然显示
          grid.style.height = 'auto';
          return;
        }
        // 取前三个中的最高高度作为容器高度
        const firstThree = items.slice(0, 3);

        // 多种方式获取高度，确保能获取到正确的值
        const heights = firstThree.map((el) => {
          const rect = el.getBoundingClientRect();
          const offsetH = el.offsetHeight;
          const scrollH = el.scrollHeight;
          // 优先使用 offsetHeight，如果为 0 则尝试其他方法
          return offsetH || rect.height || scrollH || 0;
        });

        const maxH = Math.max(0, ...heights);

        if (maxH > 0) {
          grid.style.height = `${Math.ceil(maxH)}px`;
        } else {
          // 如果获取不到高度，延迟重试
          console.warn('Could not get height for grid items, retrying...');
          setTimeout(() => {
            const retryHeights = firstThree.map((el) => {
              const rect = el.getBoundingClientRect();
              const offsetH = el.offsetHeight;
              const scrollH = el.scrollHeight;
              return offsetH || rect.height || scrollH || 0;
            });
            const retryMaxH = Math.max(0, ...retryHeights);
            if (retryMaxH > 0) {
              grid.style.height = `${Math.ceil(retryMaxH)}px`;
            } else {
              console.error('Still could not get height for grid items');
            }
          }, 100);
        }
      }

      _handleMoreClick(e) {
        const btn = e.target.closest('.marketing-scene__panel_content_more');
        if (!btn) return;
        const panel = btn.closest('.marketing-scene__panel');
        if (!panel) return;
        const grid = panel.querySelector('.marketing-scene__panel_content_tabs');
        if (!grid) return;
        const items = Array.from(grid.querySelectorAll('.marketing-scene__panel_content_tabs_item'));
        const expanded = btn.dataset.expanded === 'true';
        if (!expanded) {
          // 展开：显示全部并解除固定高度
          items.forEach((el) => el.classList.remove('hidden'));
          grid.style.height = 'auto';
          const textEl = btn.querySelector('.more-text');
          const container = this.querySelector('.marketing-scene__container');
          const viewLessText = (container && container.getAttribute('data-view-less-text')) || 'View Less';
          if (textEl) textEl.textContent = viewLessText;
          btn.classList.add('is-expanded');
          btn.dataset.expanded = 'true';
        } else {
          // 收起：仅显示前三个并恢复固定高度
          items.forEach((el, idx) => {
            if (idx > 2) el.classList.add('hidden');
            else el.classList.remove('hidden');
          });
          this._applyCollapsedHeight(grid, items);
          const textEl = btn.querySelector('.more-text');
          const container = this.querySelector('.marketing-scene__container');
          const learnMoreText = (container && container.getAttribute('data-learn-more-text')) || 'Learn More';
          if (textEl) textEl.textContent = learnMoreText;
          btn.classList.remove('is-expanded');
          btn.dataset.expanded = 'false';
        }
      }

      _setActive(index, shouldScroll = false) {
        // 动态获取当前的 tabs 和 panels
        const currentTabs = Array.from(this.querySelectorAll('.marketing-scene__tab'));
        const currentPanels = Array.from(this.querySelectorAll('.marketing-scene__panel'));

        const clickedTab = currentTabs[index];
        if (!clickedTab) return;

        // 切换选中样式
        currentTabs.forEach((t) => t.classList.toggle('active-tab', t === clickedTab));
        currentPanels.forEach((p, i) => p.classList.toggle('hidden', i !== index));

        // 初始化当前面板的swiper
        this._initSwiperForPanel(currentPanels[index]);

        // 立即为新激活的面板设置高度（所有屏幕尺寸）
        const activePanel = currentPanels[index];
        if (activePanel) {
          // 查找面板内所有的网格
          const grids = activePanel.querySelectorAll('.marketing-scene__panel_content_tabs');

          // 同时查找对应的更多按钮
          const moreBtns = activePanel.querySelectorAll('.marketing-scene__panel_content_more');

          grids.forEach((grid, gridIndex) => {
            const items = Array.from(grid.querySelectorAll('.marketing-scene__panel_content_tabs_item'));
            const moreBtn = moreBtns[gridIndex];

            if (items.length > 0) {
              // 如果有超过3个项目且在小屏幕，需要折叠处理
              if (items.length > 3 && window.innerWidth <= 576 && moreBtn) {
                // 立即重置为折叠状态
                items.forEach((el, idx) => {
                  if (idx > 2) el.classList.add('hidden');
                  else el.classList.remove('hidden');
                });

                // 重置按钮为收缩状态，但保持显示
                const textEl = moreBtn.querySelector('.more-text');
                const container = this.querySelector('.marketing-scene__container');
                const learnMoreText = (container && container.getAttribute('data-learn-more-text')) || 'Learn More';
                if (textEl) textEl.textContent = learnMoreText;
                moreBtn.classList.remove('is-expanded');
                moreBtn.dataset.expanded = 'false';
                moreBtn.classList.remove('hidden');
                moreBtn.classList.add('flex');
              } else if (items.length <= 3 || window.innerWidth > 576) {
                // 大屏或项目少于3个，隐藏按钮
                if (moreBtn) {
                  moreBtn.classList.add('hidden');
                  moreBtn.classList.remove('flex');
                }
                // 显示所有项目，并设置自动高度
                items.forEach((el) => el.classList.remove('hidden'));
                grid.style.height = 'auto';
              }

              // 使用 requestAnimationFrame 确保面板已显示
              requestAnimationFrame(() => {
                // 再用 setTimeout 确保完全渲染
                setTimeout(() => {
                  this._applyCollapsedHeight(grid, items);
                }, 100);
              });
            }
          });
        } else {
          console.warn('No active panel found for index:', index);
        }

        // 将点击的 tab 滚动到可视区域的最左侧
        if (shouldScroll && this._tabsWrap) {
          const container = this._tabsWrap;
          const tabRect = clickedTab.getBoundingClientRect();
          const boxRect = container.getBoundingClientRect();
          let targetScroll = container.scrollLeft + (tabRect.left - boxRect.left);
          const maxScroll = container.scrollWidth - container.clientWidth;
          if (targetScroll < 0) targetScroll = 0;
          if (targetScroll > maxScroll) targetScroll = maxScroll;
          container.scrollTo({ left: targetScroll, behavior: 'smooth' });
        }

        this.dispatchEvent(new CustomEvent('tabchange', { detail: { index }, bubbles: true }));
      }

      disconnectedCallback() {
        this._tabs.forEach((tab) => {
          tab.replaceWith(tab.cloneNode(true));
        });
        this._tabs = [];
      }
    }

    customElements.define('marketing-scene', MarketingScene);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-wheel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('marketing-wheel')) {
      customElements.define(
        'marketing-wheel',
        class MarketingWheel extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            this.initDialog();
          }
          init() {
            const button = this.querySelector('.marketing-wheel__content-button');
            button.addEventListener('click', () => {
              if (button.getAttribute('data-event') === 'wheel') {
                // 判断是否存在initWheelPop函数
                if (typeof initWheelPop === 'function') {
                  initWheelPop();
                } else {
                  console.error('initWheelPop is not a function');
                }
              } else if (button.getAttribute('data-event') === 'click_button') {
                if (button.getAttribute('data-link') !== '') {
                  window.location.href = button.getAttribute('data-link');
                } else {
                  console.error('button link is not set');
                }
              }
            });
          }
          initDialog() {
            const dialog = this.querySelector('dialog-simple');
            const button = this.querySelector('.marketing-wheel__content-footer-learn-more');
            if (button) {
              button.addEventListener('click', () => {
                dialog.setAttribute('data-show', 'true');
                dialog.setAttribute('data-title', button.getAttribute('data-title'));
                dialog.setAttribute('data-desc', button.getAttribute('data-desc'));
              });
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-anchor-nav-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('mini-anchor-nav-v2')) {
      customElements.define(
        'mini-anchor-nav-v2',
        class MiniAnchorNav extends HTMLElement {
          connectedCallback() {
            this._bar = this.querySelector('[data-bar]');
            this._placeholder = this.querySelector('[data-placeholder]');
            this._track = this.querySelector('[data-track]');
            this._items = Array.from(this.querySelectorAll('[data-jump]'));
            if (!this._bar || !this._placeholder || !this._track || !this._items.length) return;

            this._isFixed = false;
            this._isFixedEntering = false;
            this._fixedAnimateTimer = null;
            this._stickyStart = 0;
            this._locked = false;
            this._lockedJump = null;
            this._targetScrollY = null;
            this._lockTimer = null;
            this._maxLockTimer = null;
            this._onScrollEnd = null;
            this._onScroll = this._handleScroll.bind(this);
            this._onResize = this._handleResize.bind(this);
            this._onItemClick = this._handleItemClick.bind(this);
            this._onCompareStickyChange = this._onCompareStickyChange.bind(this);
            this._hero = document.querySelector('.mini-banner-v2__hero');
            this._sectionHost = this.parentElement;
            this._compareStickySuppressing = false;
            this._compareStickyRestoreRaf = null;
            this._skipFixedEnterAnimation = false;

            this._setVisible(false);

            this._items.forEach((item) => {
              customEventListener(item, 'click', this._onItemClick);
            });

            window.addEventListener('scroll', this._onScroll, { passive: true });
            window.addEventListener('resize', this._onResize, { passive: true });
            document.addEventListener('mini-product-compare-v2-sticky-top:change', this._onCompareStickyChange);

            this._observeHeader();
            this._updateBannerStickyState();
            this._measureStickyStart();
            this._updateFixedState();
            this._syncDocumentScrollPadding();
            this._updateActiveFromScroll();
          }

          disconnectedCallback() {
            window.removeEventListener('scroll', this._onScroll);
            window.removeEventListener('resize', this._onResize);
            document.removeEventListener('mini-product-compare-v2-sticky-top:change', this._onCompareStickyChange);
            if (this._compareStickyRestoreRaf) {
              cancelAnimationFrame(this._compareStickyRestoreRaf);
              this._compareStickyRestoreRaf = null;
            }
            if (this._onScrollEnd) {
              window.removeEventListener('scrollend', this._onScrollEnd);
              this._onScrollEnd = null;
            }
            if (this._headerObserver) {
              this._headerObserver.disconnect();
              this._headerObserver = null;
            }
            if (this._fixedAnimateTimer) {
              clearTimeout(this._fixedAnimateTimer);
              this._fixedAnimateTimer = null;
            }
            this._releaseSpyLock();
          }

          _setVisible(isVisible) {
            this.setAttribute('data-visible', isVisible ? 'true' : 'false');
            if (this._bar) {
              this._bar.style.display = isVisible ? '' : 'none';
            }
          }

          _canRevealNav() {
            return this.getAttribute('data-hero-overlay') !== 'true' && !this._isCompareStickyActive();
          }

          _isCompareStickyActive() {
            return document.querySelector('mini-product-compare-v2-sticky-top[data-show="true"]') !== null;
          }

          _onCompareStickyChange(event) {
            const isShown = event?.detail?.shown === true;

            if (this._compareStickyRestoreRaf) {
              cancelAnimationFrame(this._compareStickyRestoreRaf);
              this._compareStickyRestoreRaf = null;
            }

            if (isShown) {
              this._compareStickySuppressing = true;
              if (this._isFixed) {
                this._leaveFixedMode();
              } else {
                this._setVisible(false);
              }
            } else {
              this._compareStickyRestoreRaf = requestAnimationFrame(() => {
                this._compareStickyRestoreRaf = requestAnimationFrame(() => {
                  this._compareStickyRestoreRaf = null;
                  if (!this._isCompareStickyActive()) {
                    this._skipFixedEnterAnimation = true;
                    this._compareStickySuppressing = false;
                    this._updateFixedState();
                    this._skipFixedEnterAnimation = false;
                  }
                });
              });
            }

            this._syncDocumentScrollPadding();
            this._updateActiveFromScroll();
          }

          _syncNavVisibility() {
            this._setVisible(this._isFixed && this._canRevealNav());
          }

          _notifyStickyStackChange() {
            document.dispatchEvent(new CustomEvent('mini-anchor-nav-v2:layout-change'));
          }

          _updateBannerStickyState() {
            const hero = this._hero || document.querySelector('.mini-banner-v2__hero');
            if (!hero) {
              this.setAttribute('data-hero-overlay', 'false');
              this._updateMountPosition();
              return;
            }

            const rect = hero.getBoundingClientRect();
            const pastHero = rect.bottom <= window.innerHeight;
            const inHeroZone = rect.bottom > 0 && !pastHero;

            this.setAttribute('data-hero-overlay', inHeroZone ? 'true' : 'false');
            this._updateMountPosition();
          }

          _shouldAnimateEnter() {
            return this.getAttribute('data-visible') !== 'true';
          }

          _updateMountPosition() {
            const heroOverlay = this.getAttribute('data-hero-overlay') === 'true';
            const bannerHero = this._hero || document.querySelector('.mini-banner-v2__hero');

            if (heroOverlay && bannerHero) {
              if (this._sectionHost && !this._sectionHost.contains(this)) {
                this._sectionHost.appendChild(this);
              }
              this.setAttribute('data-banner-embed', 'false');
              this._leaveFixedMode();
              this._setVisible(false);
              return;
            }

            this.setAttribute('data-banner-embed', 'false');
            this._measureStickyStart();

            if (!this._canRevealNav()) {
              if (this._isFixed) {
                this._leaveFixedMode();
              }
              this._setVisible(false);
              return;
            }

            if (!this._isFixed) {
              this._enterFixedMode(this._shouldAnimateEnter());
            } else {
              if (this._sectionHost && !this._sectionHost.contains(this)) {
                this._sectionHost.appendChild(this);
              }
              this._syncNavVisibility();
              this._syncFixedTop();
            }
          }

          _clearFixedMotionStyles() {
            if (!this._bar) return;
            this._bar.style.transition = '';
            this._bar.style.transform = '';
            this._bar.style.opacity = '';
            this._bar.removeAttribute('data-fixed-animate');
          }

          _notifyStickyStackChange() {
            document.dispatchEvent(new CustomEvent('mini-anchor-nav-v2:layout-change'));
          }

          _syncFixedTop() {
            if (!this._bar || !this._isFixed || this._isFixedEntering) return;
            this._bar.style.top = `${this._getHeaderOffset()}px`;
            this._notifyStickyStackChange();
          }

          _leaveFixedMode() {
            if (!this._bar || !this._placeholder) return;

            if (!this._isFixed && this._bar.getAttribute('data-fixed') === 'false') {
              this._setVisible(false);
              return;
            }

            this._isFixed = false;
            this._isFixedEntering = false;
            this._placeholder.style.height = '0px';
            this._bar.setAttribute('data-fixed', 'false');
            this._clearFixedMotionStyles();
            this._bar.style.top = '0';
            this._setVisible(false);
            this._notifyStickyStackChange();

            if (this._fixedAnimateTimer) {
              clearTimeout(this._fixedAnimateTimer);
              this._fixedAnimateTimer = null;
            }
          }

          _enterFixedMode(animateEnter = false) {
            if (!this._bar || !this._placeholder) return;

            if (
              animateEnter &&
              typeof window.matchMedia === 'function' &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ) {
              animateEnter = false;
            }

            const headerOffset = this._getHeaderOffset();
            this._isFixed = true;
            this._placeholder.style.height = '0px';
            this._clearFixedMotionStyles();

            this._bar.setAttribute('data-fixed', 'true');
            this._bar.style.top = `${headerOffset}px`;
            this._notifyStickyStackChange();

            if (this._sectionHost && !this._sectionHost.contains(this)) {
              this._sectionHost.appendChild(this);
            }

            if (!animateEnter) {
              this._syncNavVisibility();
              this._notifyStickyStackChange();
              return;
            }

            this._isFixedEntering = true;
            this._setVisible(true);
            this._bar.setAttribute('data-fixed-animate', 'true');
            this._bar.style.transition = 'none';
            this._bar.style.transform = 'translate3d(0, -100%, 0)';
            this._bar.style.opacity = '0';
            void this._bar.offsetHeight;
            this._notifyStickyStackChange();

            if (this._fixedAnimateTimer) {
              clearTimeout(this._fixedAnimateTimer);
            }

            this._fixedAnimateTimer = window.setTimeout(() => {
              this._fixedAnimateTimer = null;
              if (!this._isFixed || !this._bar) return;

              let finished = false;
              const finishEnter = () => {
                if (finished) return;
                finished = true;
                this._isFixedEntering = false;
                this._clearFixedMotionStyles();
              };

              const fallbackTimer = window.setTimeout(finishEnter, 450);

              const onTransitionEnd = (event) => {
                if (event.target !== this._bar || event.propertyName !== 'transform') return;
                this._bar.removeEventListener('transitionend', onTransitionEnd);
                clearTimeout(fallbackTimer);
                finishEnter();
              };

              this._bar.addEventListener('transitionend', onTransitionEnd);
              this._bar.style.transition = 'transform 0.38s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.32s ease';
              this._bar.style.transform = 'translate3d(0, 0, 0)';
              this._bar.style.opacity = '1';
            }, 0);
          }

          _measureStickyStart() {
            const el = this._isFixed ? this._placeholder : this._bar;
            if (!el) return;
            this._stickyStart = el.getBoundingClientRect().top + window.pageYOffset;
          }

          _observeHeader() {
            const header = this._getHeader();
            if (!header || typeof MutationObserver === 'undefined') return;
            this._headerObserver = new MutationObserver(() => {
              this._updateFixedState();
              this._syncDocumentScrollPadding();
            });
            this._headerObserver.observe(header, {
              attributes: true,
              attributeFilter: ['data-scrollshow', 'class', 'style'],
            });
          }

          _updateFixedState() {
            if (!this._bar || !this._placeholder) return;

            if (this._isCompareStickyActive() || this._compareStickySuppressing) {
              if (this._isFixed) {
                this._leaveFixedMode();
              } else {
                this._setVisible(false);
              }
              return;
            }

            const heroOverlay = this.getAttribute('data-hero-overlay') === 'true';
            const bannerEmbed = this.getAttribute('data-banner-embed') === 'true';

            if (heroOverlay && bannerEmbed) {
              this._leaveFixedMode();
              return;
            }

            const canReveal = this._canRevealNav();

            if (canReveal && !this._isFixed) {
              this._enterFixedMode(this._skipFixedEnterAnimation ? false : this._shouldAnimateEnter());
              return;
            }

            if (!canReveal && this._isFixed) {
              this._leaveFixedMode();
              return;
            }

            if (this._isFixed) {
              this._syncNavVisibility();
              this._syncFixedTop();
            }
          }

          _getHeader() {
            return document.getElementById('lt-header-v2') || document.getElementById('lt-header');
          }

          _getHeaderHeight(header = this._getHeader()) {
            if (!header) return 0;

            if (header.id === 'lt-header-v2') {
              const headerMain = document.getElementById('header-v2');
              if (headerMain?.offsetHeight) return headerMain.offsetHeight;

              const cssHeight = parseFloat(getComputedStyle(header).getPropertyValue('--header-v2-height'));
              if (Number.isFinite(cssHeight) && cssHeight > 0) return cssHeight;

              return window.matchMedia('(min-width: 1201px)').matches ? 74 : 52;
            }

            return header.offsetHeight || 0;
          }

          _isHeaderVisible(header = this._getHeader()) {
            if (!header) return false;
            return header.getAttribute('data-scrollshow') === 'true';
          }

          _getHeaderOffset() {
            const header = this._getHeader();
            if (!this._isHeaderVisible(header)) return 0;
            return this._getHeaderHeight(header);
          }

          _getNavHeight() {
            return this._bar ? this._bar.offsetHeight || 0 : 0;
          }

          _getScrollOffset() {
            const navVisible = this.getAttribute('data-visible') === 'true';

            if (this._isFixed && navVisible) {
              return this._getHeaderOffset() + this._getNavHeight();
            }

            const barRect = this._bar?.getBoundingClientRect();
            const navInView = navVisible && barRect && barRect.bottom > 0 && barRect.top < window.innerHeight;
            return this._getHeaderOffset() + (navInView ? this._getNavHeight() : 0);
          }

          _getJumpOffsetFromTarget(target) {
            if (!target) return null;

            const markedTarget = target.matches('[data-jump-offset]') ? target : target.closest('[data-jump-offset]');
            if (!markedTarget) return null;

            const rawOffset = markedTarget.getAttribute('data-jump-offset');
            if (rawOffset === null || rawOffset === '') return null;

            const parsedOffset = Number.parseFloat(rawOffset);
            return Number.isFinite(parsedOffset) ? parsedOffset : null;
          }

          /**
           * 跳转专用 offset：
           * - data-jump-offset="0"：目标区块顶对齐视口顶部（如 first-innovation）
           * - 向下跳：滚动过程中 header 会隐藏，只保留 nav 高度
           * - 向上跳：滚动过程中 header 会显示，预留完整 header + nav
           */
          _getJumpScrollOffset(target = null) {
            const customOffset = this._getJumpOffsetFromTarget(target);
            if (customOffset !== null) {
              return customOffset;
            }

            const navHeight = this._getNavHeight();
            const headerHeight = this._getHeaderHeight();

            if (!target) {
              return headerHeight + navHeight;
            }

            const currentScrollY = window.scrollY;
            const targetTop = target.getBoundingClientRect().top + currentScrollY;
            const jumpingDown = targetTop > currentScrollY + 10;

            return jumpingDown ? navHeight : headerHeight + navHeight;
          }

          /** 滚动结束后按当前 header 可见状态校正 */
          _getSettledJumpScrollOffset(target = null) {
            const customOffset = this._getJumpOffsetFromTarget(target);
            if (customOffset !== null) {
              return customOffset;
            }

            return this._getHeaderOffset() + this._getNavHeight();
          }

          _prepareJumpLayout() {
            if (this._sectionHost && !this._sectionHost.contains(this)) {
              this._sectionHost.appendChild(this);
            }
            this.setAttribute('data-banner-embed', 'false');
            this.setAttribute('data-hero-overlay', 'false');
            if (!this._isFixed && this._canRevealNav()) {
              this._enterFixedMode(false);
            }
            this._syncNavVisibility();
            this._syncFixedTop();
          }

          _syncJumpTargets(jumpOffset) {
            document.dispatchEvent(
              new CustomEvent('mini-anchor-nav-v2:prepare-jump', {
                detail: { offset: jumpOffset },
              })
            );
          }

          _forceLayout() {
            void this._bar?.offsetHeight;
            void document.documentElement.offsetHeight;
          }

          _getTargetScrollTop(target, offset = this._getJumpScrollOffset(target)) {
            return Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
          }

          _syncDocumentScrollPadding() {
            document.documentElement.style.scrollPaddingTop = `${this._getJumpScrollOffset()}px`;
          }

          _runJump(target, jumpPoint) {
            this._prepareJumpLayout();

            const jumpOffset = this._getJumpScrollOffset(target);
            document.documentElement.style.scrollPaddingTop = `${jumpOffset}px`;
            this._syncJumpTargets(jumpOffset);
            this._forceLayout();

            const top = this._getTargetScrollTop(target, jumpOffset);
            this._lockSpy(jumpPoint, top);
            window.scrollTo({
              top,
              behavior: 'smooth',
            });
          }

          _correctJumpPosition(target) {
            if (!target) return;

            this._prepareJumpLayout();
            this._syncFixedTop();

            const settledOffset = this._getSettledJumpScrollOffset(target);
            document.documentElement.style.scrollPaddingTop = `${settledOffset}px`;
            this._syncJumpTargets(settledOffset);
            this._forceLayout();

            const idealTop = this._getTargetScrollTop(target, settledOffset);
            if (Math.abs(window.scrollY - idealTop) > 3) {
              window.scrollTo({
                top: idealTop,
                behavior: 'auto',
              });
            }
          }

          _resolveTarget(jumpPoint) {
            if (!jumpPoint) return null;
            return document.getElementById(jumpPoint);
          }

          _scrollItemIntoTrack(item) {
            if (!this._track || !item) return;
            const tabRect = item.getBoundingClientRect();
            const boxRect = this._track.getBoundingClientRect();
            const targetScroll =
              this._track.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;
            this._track.scrollTo({
              left: Math.max(0, targetScroll),
              behavior: 'smooth',
            });
          }

          _setActive(jumpPoint, { scrollTrack = true } = {}) {
            let activeItem = null;
            this._items.forEach((item) => {
              const isActive = item.getAttribute('data-jump') === jumpPoint;
              item.setAttribute('data-active', isActive ? 'true' : 'false');
              if (isActive) activeItem = item;
            });
            if (scrollTrack && activeItem) {
              this._scrollItemIntoTrack(activeItem);
            }
          }

          _lockSpy(jumpPoint, targetScrollY) {
            this._locked = true;
            this._lockedJump = jumpPoint;
            this._targetScrollY = targetScrollY;
            this._setActive(jumpPoint, { scrollTrack: false });

            if (this._lockTimer) clearTimeout(this._lockTimer);
            if (this._maxLockTimer) clearTimeout(this._maxLockTimer);
            if (this._onScrollEnd) {
              window.removeEventListener('scrollend', this._onScrollEnd);
              this._onScrollEnd = null;
            }

            const release = () => this._releaseSpyLock();

            if ('onscrollend' in window) {
              this._onScrollEnd = () => {
                window.removeEventListener('scrollend', this._onScrollEnd);
                this._onScrollEnd = null;
                release();
              };
              window.addEventListener('scrollend', this._onScrollEnd, { once: true });
            } else {
              let lastScrollY = window.scrollY;
              const pollIdle = () => {
                if (!this._locked) return;

                const currentScrollY = window.scrollY;
                if (Math.abs(currentScrollY - targetScrollY) <= 8) {
                  release();
                  return;
                }

                if (currentScrollY !== lastScrollY) {
                  lastScrollY = currentScrollY;
                  this._lockTimer = setTimeout(pollIdle, 100);
                  return;
                }

                release();
              };
              this._lockTimer = setTimeout(pollIdle, 150);
            }

            this._maxLockTimer = setTimeout(release, 3000);
          }

          _releaseSpyLock() {
            if (!this._locked) return;

            const lockedJump = this._lockedJump;

            this._locked = false;
            this._lockedJump = null;
            this._targetScrollY = null;

            if (this._lockTimer) {
              clearTimeout(this._lockTimer);
              this._lockTimer = null;
            }
            if (this._maxLockTimer) {
              clearTimeout(this._maxLockTimer);
              this._maxLockTimer = null;
            }
            if (this._onScrollEnd) {
              window.removeEventListener('scrollend', this._onScrollEnd);
              this._onScrollEnd = null;
            }

            if (lockedJump) {
              this._correctJumpPosition(this._resolveTarget(lockedJump));
              this._setActive(lockedJump);
            } else {
              this._updateActiveFromScroll();
            }

            this._updateBannerStickyState();
            this._updateFixedState();
            this._syncDocumentScrollPadding();
          }

          _handleItemClick(event) {
            const item = event.currentTarget;
            const jumpPoint = item.getAttribute('data-jump');
            const target = this._resolveTarget(jumpPoint);
            if (!target) return;

            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                this._runJump(target, jumpPoint);
              });
            });
          }

          _updateActiveFromScroll() {
            if (this._locked) return;

            const scrollMarker = window.scrollY + this._getScrollOffset() + 8;
            let activeJump = null;
            let activeTop = -Infinity;

            this._items.forEach((item) => {
              const jumpPoint = item.getAttribute('data-jump');
              const target = this._resolveTarget(jumpPoint);
              if (!target) return;

              const targetTop = target.getBoundingClientRect().top + window.scrollY;
              if (targetTop <= scrollMarker && targetTop > activeTop) {
                activeTop = targetTop;
                activeJump = jumpPoint;
              }
            });

            if (!activeJump && this._items[0]) {
              activeJump = this._items[0].getAttribute('data-jump');
            }

            if (activeJump) {
              const current = this.querySelector('[data-jump][data-active="true"]');
              if (!current || current.getAttribute('data-jump') !== activeJump) {
                this._setActive(activeJump);
              }
            }
          }

          _handleScroll() {
            if (this._locked) {
              if (this._lockedJump) {
                this._setActive(this._lockedJump, { scrollTrack: false });
              }
              return;
            }

            this._updateBannerStickyState();
            this._updateFixedState();
            this._updateActiveFromScroll();
          }

          _handleResize() {
            this._hero = document.querySelector('.mini-banner-v2__hero');
            this._updateBannerStickyState();
            this._measureStickyStart();
            this._updateFixedState();
            this._syncDocumentScrollPadding();
            if (this._isFixed && this._placeholder) {
              this._placeholder.style.height = `${this._getNavHeight()}px`;
            }
            this._updateActiveFromScroll();
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-app-scenario-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('mini-app-scenario-v2')) {
      customElements.define(
        'mini-app-scenario-v2',
        class MiniAppScenarioV2 extends HTMLElement {
          connectedCallback() {
            this._gridMq = window.matchMedia('(min-width: 961px)');
            this._onGridMqChange = () => this._equalizeCardHeights();
            this._gridMq.addEventListener('change', this._onGridMqChange);

            this._onResize = () => {
              clearTimeout(this._resizeTimer);
              this._resizeTimer = setTimeout(() => this._equalizeCardHeights(), 150);
            };
            window.addEventListener('resize', this._onResize, { passive: true });

            this.querySelectorAll('.mini-app-scenario-v2__card-media img').forEach((img) => {
              if (img.complete) return;
              img.addEventListener('load', () => this._equalizeCardHeights(), { once: true });
            });

            this._equalizeCardHeights();
          }

          disconnectedCallback() {
            if (this._gridMq && this._onGridMqChange) {
              this._gridMq.removeEventListener('change', this._onGridMqChange);
            }
            window.removeEventListener('resize', this._onResize);
            if (this._resizeTimer) {
              clearTimeout(this._resizeTimer);
              this._resizeTimer = null;
            }
          }

          _isGridLayout() {
            return this._gridMq?.matches ?? window.matchMedia('(min-width: 961px)').matches;
          }

          _resetCardHeights() {
            this.querySelectorAll('.mini-app-scenario-v2__card').forEach((card) => {
              card.style.minHeight = '';
            });
          }

          _equalizeCardHeights() {
            const cards = this.querySelectorAll('.mini-app-scenario-v2__card');

            this._resetCardHeights();

            if (!this._isGridLayout() || cards.length < 2) return;

            const rows = [];
            for (let index = 0; index < cards.length; index += 2) {
              rows.push([cards[index], cards[index + 1]].filter(Boolean));
            }

            rows.forEach((rowCards) => {
              if (rowCards.length < 2) return;

              let maxHeight = 0;
              rowCards.forEach((card) => {
                maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
              });

              if (maxHeight <= 0) return;

              const heightPx = `${Math.ceil(maxHeight)}px`;
              rowCards.forEach((card) => {
                card.style.minHeight = heightPx;
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-banner-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('mini-banner')) {
      customElements.define(
        'mini-banner',
        class MiniBanner extends HTMLElement {
          connectedCallback() {
            this._setFooterStyle(this.getAttribute('data-default-style'));
            this._initHeaderScrollShowControl();
            this._initBannerViewportMetrics();
          }

          disconnectedCallback() {
            this._releaseHeaderTopOnlyMode();
            if (this._headerPatchTimer) {
              clearInterval(this._headerPatchTimer);
              this._headerPatchTimer = null;
            }
            if (this._topOnlyScrollHandler) {
              window.removeEventListener('scroll', this._topOnlyScrollHandler);
              this._topOnlyScrollHandler = null;
            }
            if (this._topOnlyScrollRaf) {
              cancelAnimationFrame(this._topOnlyScrollRaf);
              this._topOnlyScrollRaf = null;
            }
            if (this._onBannerViewportResize) {
              window.removeEventListener('resize', this._onBannerViewportResize);
              this._onBannerViewportResize = null;
            }
            if (this._bannerViewportRaf) {
              cancelAnimationFrame(this._bannerViewportRaf);
              this._bannerViewportRaf = null;
            }
            this._bannerScrollMetricsKey = null;
            this._bannerLockedViewportWidth = null;
            this._bannerLockedViewportHeight = null;
            this._headerScrollShowObservers?.forEach((observer) => observer.disconnect());
            this._headerScrollShowObservers = null;
          }

          _isHeaderScrollShowEnabled() {
            return this.getAttribute('data-enable-header-scroll-show') === 'true';
          }

          _isPageAtTop() {
            const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
            return scrollTop <= 0;
          }

          _initBannerViewportMetrics() {
            this._lockBannerScrollMetrics = this._lockBannerScrollMetrics.bind(this);
            this._onBannerViewportResize = () => {
              const width = Math.round(window.innerWidth || document.documentElement.clientWidth || 0);
              if (this._bannerLockedViewportWidth === width) return;
              if (this._bannerViewportRaf) return;
              this._bannerViewportRaf = requestAnimationFrame(() => {
                this._bannerViewportRaf = null;
                this._lockBannerScrollMetrics();
              });
            };

            window.addEventListener('resize', this._onBannerViewportResize, { passive: true });
            requestAnimationFrame(() => {
              requestAnimationFrame(() => this._lockBannerScrollMetrics());
            });
          }

          _lockBannerScrollMetrics() {
            const viewportWidth = Math.round(window.innerWidth || document.documentElement.clientWidth || 0);
            let viewportHeight = Math.round(window.innerHeight || document.documentElement.clientHeight || 0);
            if (!viewportHeight) return;

            // Mobile browser chrome toggles innerHeight while scrolling without width changes.
            // Re-locking on that resize makes the sticky banner grow; keep the first measured height instead.
            if (this._bannerLockedViewportHeight && viewportWidth === this._bannerLockedViewportWidth) {
              viewportHeight = this._bannerLockedViewportHeight;
            } else {
              this._bannerLockedViewportWidth = viewportWidth;
              this._bannerLockedViewportHeight = viewportHeight;
            }

            const runwayPx = viewportHeight;
            const heroHeightPx = viewportHeight + runwayPx;
            const metricsKey = `${viewportWidth}-${viewportHeight}`;

            if (this._bannerScrollMetricsKey === metricsKey) return;
            this._bannerScrollMetricsKey = metricsKey;

            const bannerRoot = this.querySelector('.mini-banner-v2');
            const targets = [document.documentElement, bannerRoot].filter(Boolean);

            targets.forEach((target) => {
              target.style.setProperty('--mini-banner-fill-height', `${viewportHeight}px`);
              target.style.setProperty('--mini-banner-overlap-height', `${viewportHeight}px`);
              target.style.setProperty('--mini-banner-hero-height', `${heroHeightPx}px`);
            });
          }

          _initHeaderScrollShowControl() {
            if (this._isHeaderScrollShowEnabled()) {
              this._releaseHeaderTopOnlyMode();
              return;
            }

            this._applyHeaderTopOnlyMode();
          }

          _applyHeaderTopOnlyMode() {
            window.litime = window.litime || {};
            window.litime.miniBannerHeaderTopOnly = true;

            this._clearForcedHeaderStyles();
            this._patchHeaderScrollBootstrap();
            this._bindTopOnlyScrollListener();
            this._bindHeaderScrollShowObservers();
            this._syncTopOnlyHeaderScrollShow();
          }

          _releaseHeaderTopOnlyMode() {
            if (!window.litime?.miniBannerHeaderTopOnly) return;

            window.litime.miniBannerHeaderTopOnly = false;

            const bootstrap = window.__headerV2ScrollBootstrap;
            if (bootstrap?._miniBannerOriginalSetScrollShow) {
              bootstrap.setScrollShow = bootstrap._miniBannerOriginalSetScrollShow;
              delete bootstrap._miniBannerOriginalSetScrollShow;
              delete bootstrap._miniBannerScrollLockPatched;

              const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
              bootstrap.setScrollShow(scrollTop <= 0);
            }

            if (this._topOnlyScrollHandler) {
              window.removeEventListener('scroll', this._topOnlyScrollHandler);
              this._topOnlyScrollHandler = null;
            }

            this._headerScrollShowObservers?.forEach((observer) => observer.disconnect());
            this._headerScrollShowObservers = null;
            this._clearForcedHeaderStyles();
          }

          _patchHeaderScrollBootstrap() {
            const tryPatch = () => {
              const bootstrap = window.__headerV2ScrollBootstrap;
              if (!bootstrap || bootstrap._miniBannerScrollLockPatched) {
                return Boolean(bootstrap);
              }

              const originalSetScrollShow = bootstrap.setScrollShow.bind(bootstrap);
              bootstrap._miniBannerOriginalSetScrollShow = originalSetScrollShow;
              bootstrap.setScrollShow = (show) => {
                if (window.litime?.miniBannerHeaderTopOnly) {
                  originalSetScrollShow(this._isPageAtTop());
                  return;
                }
                originalSetScrollShow(show);
              };
              bootstrap._miniBannerScrollLockPatched = true;
              return true;
            };

            if (tryPatch()) return;

            this._headerPatchTimer = window.setInterval(() => {
              if (tryPatch()) {
                clearInterval(this._headerPatchTimer);
                this._headerPatchTimer = null;
                if (window.litime?.miniBannerHeaderTopOnly) {
                  this._syncTopOnlyHeaderScrollShow();
                }
              }
            }, 50);
          }

          _getSiteHeaders() {
            return [document.getElementById('lt-header-v2'), document.getElementById('lt-header')].filter(Boolean);
          }

          _clearForcedHeaderStyles() {
            const headerEl = document.querySelector('.header-v2');
            if (headerEl) {
              headerEl.style.top = '';
              headerEl.style.position = '';
            }
          }

          _syncLegacyHeaderVisual(atTop) {
            const headerLegacy = document.getElementById('lt-header');
            if (!headerLegacy) return;

            headerLegacy.setAttribute('data-scrollShow', atTop ? 'true' : 'false');

            const headerContainer = document.querySelector('.header-01');
            if (!headerContainer) return;

            if (atTop) {
              headerContainer.style.top = '0px';
              headerContainer.style.position = 'sticky';
              return;
            }

            const header = headerContainer.querySelector('.header') || headerContainer;
            const headerHeight = header?.offsetHeight || 0;
            headerContainer.style.top = headerHeight > 0 ? `-${headerHeight}px` : '-100px';
            headerContainer.style.position = 'sticky';
          }

          _syncTopOnlyHeaderScrollShow() {
            if (!window.litime?.miniBannerHeaderTopOnly) return;

            const atTop = this._isPageAtTop();
            const bootstrap = window.__headerV2ScrollBootstrap;

            if (bootstrap?.setScrollShow) {
              bootstrap.setScrollShow(atTop);
            } else {
              const headerV2 = document.getElementById('lt-header-v2');
              if (headerV2) {
                headerV2.setAttribute('data-scrollshow', atTop ? 'true' : 'false');
              }
            }

            this._syncLegacyHeaderVisual(atTop);
          }

          _bindTopOnlyScrollListener() {
            if (this._topOnlyScrollHandler) return;

            this._topOnlyScrollHandler = () => {
              if (!window.litime?.miniBannerHeaderTopOnly) return;
              if (this._topOnlyScrollRaf) return;

              this._topOnlyScrollRaf = requestAnimationFrame(() => {
                this._topOnlyScrollRaf = null;
                this._syncTopOnlyHeaderScrollShow();
              });
            };

            window.addEventListener('scroll', this._topOnlyScrollHandler, { passive: true });
          }

          _bindHeaderScrollShowObservers() {
            this._headerScrollShowObservers?.forEach((observer) => observer.disconnect());
            this._headerScrollShowObservers = [];

            this._getSiteHeaders().forEach((header) => {
              const observer = new MutationObserver(() => {
                if (!window.litime?.miniBannerHeaderTopOnly) return;

                const atTop = this._isPageAtTop();
                if (atTop) return;

                if (header.id === 'lt-header') {
                  if (header.getAttribute('data-scrollShow') !== 'false') {
                    this._syncLegacyHeaderVisual(false);
                  }
                  return;
                }

                if (header.getAttribute('data-scrollshow') !== 'false') {
                  header.setAttribute('data-scrollshow', 'false');
                }
              });

              observer.observe(header, {
                attributes: true,
                attributeFilter: ['data-scrollshow', 'data-scrollShow'],
              });

              this._headerScrollShowObservers.push(observer);
            });
          }

          _setFooterStyle(defaultStyle) {
            const footer = document.querySelector('.main-footer');
            if (!footer) return;

            footer.style.backgroundColor = defaultStyle === 'dark' ? '#000000' : '';

            footer.querySelectorAll('.main-footer__input').forEach((input) => {
              input.style.backgroundColor = defaultStyle === 'dark' ? '#111111' : '';
              input.style.color = defaultStyle === 'dark' ? '#FFFFFF' : '';
              input.style.setProperty('--placeholder-color', defaultStyle === 'dark' ? '#fff' : '#737373');
            });

            footer.querySelectorAll('.footer-sub-title').forEach((subTitle) => {
              subTitle.style.color = defaultStyle === 'dark' ? '#FFFFFF' : '#737373';
            });

            const footerTextColor = defaultStyle === 'dark' ? '#FFFFFF' : '#191919';
            document.documentElement.style.setProperty('--footer-item-text-color', footerTextColor);

            if (defaultStyle === 'dark') {
              document.documentElement.style.setProperty('--footer-item-text-color-80', 'rgba(255, 255, 255, 0.8)');
              document.documentElement.style.setProperty('--footer-item-text-color-20', 'rgba(255, 255, 255, 0.2)');
            } else {
              document.documentElement.style.setProperty('--footer-item-text-color-80', 'rgba(25, 25, 25, 0.8)');
              document.documentElement.style.setProperty('--footer-item-text-color-20', 'rgba(25, 25, 25, 0.2)');
            }

            const logoListDark = document.querySelector('.logo-list-dark');
            const logoListLight = document.querySelector('.logo-list-light');

            if (logoListDark && logoListLight) {
              if (defaultStyle === 'dark') {
                logoListDark.classList.remove('hidden');
                logoListDark.classList.add('flex');
                logoListLight.classList.remove('flex');
                logoListLight.classList.add('hidden');
              } else {
                logoListLight.classList.remove('hidden');
                logoListLight.classList.add('flex');
                logoListDark.classList.remove('flex');
                logoListDark.classList.add('hidden');
              }
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-core-value-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('mini-core-value-v2')) {
      customElements.define(
        'mini-core-value-v2',
        class MiniCoreValueV2 extends HTMLElement {
          connectedCallback() {
            this._sectionEl = this.closest('.section-mini-core-value-v2');
            this._onLayoutChange = () => {
              if (this._layoutChangeRaf) return;
              this._layoutChangeRaf = requestAnimationFrame(() => {
                this._layoutChangeRaf = null;
                this._updateStickyPhase();
              });
            };
            window.addEventListener('scroll', this._onLayoutChange, { passive: true });
            window.addEventListener('resize', this._onLayoutChange, { passive: true });
            this._observeHeader();
            this._updateStickyPhase();
          }

          disconnectedCallback() {
            window.removeEventListener('scroll', this._onLayoutChange);
            window.removeEventListener('resize', this._onLayoutChange);
            if (this._layoutChangeRaf) {
              cancelAnimationFrame(this._layoutChangeRaf);
              this._layoutChangeRaf = null;
            }
            if (this._headerObserver) {
              this._headerObserver.disconnect();
              this._headerObserver = null;
            }
          }

          _observeHeader() {
            const header = document.getElementById('lt-header-v2') || document.getElementById('lt-header');
            if (!header || typeof MutationObserver === 'undefined') return;

            this._headerObserver = new MutationObserver(() => {
              this._updateStickyPhase();
            });

            this._headerObserver.observe(header, {
              attributes: true,
              attributeFilter: ['data-scrollshow', 'class', 'style'],
            });
          }

          _syncStickyTop() {
            this.style.setProperty('--mini-core-value-v2-sticky-top', `${this._getHeaderOffset()}px`);
          }

          _getHeaderOffset() {
            const header = document.getElementById('lt-header-v2') || document.getElementById('lt-header');
            if (!header || header.getAttribute('data-scrollshow') !== 'true') {
              return 0;
            }

            if (header.id === 'lt-header-v2') {
              const headerMain = document.getElementById('header-v2');
              if (headerMain?.offsetHeight) return headerMain.offsetHeight;

              const cssHeight = parseFloat(getComputedStyle(header).getPropertyValue('--header-v2-height'));
              if (Number.isFinite(cssHeight) && cssHeight > 0) return cssHeight;

              return window.matchMedia('(min-width: 1201px)').matches ? 74 : 52;
            }

            return header.offsetHeight || 0;
          }

          _resolveStickyPhase() {
            const stickyTop = this._getHeaderOffset();
            const sectionRect = this._sectionEl?.getBoundingClientRect();
            const rect = this.getBoundingClientRect();

            if (sectionRect && sectionRect.bottom <= stickyTop + 1) {
              return 'passed';
            }

            if (
              sectionRect &&
              sectionRect.top <= stickyTop + 1 &&
              sectionRect.bottom > stickyTop + 1 &&
              rect.top <= stickyTop + 1
            ) {
              return 'pinned';
            }

            return 'before';
          }

          _updateStickyPhase() {
            this._syncStickyTop();

            const nextPhase = this._resolveStickyPhase();
            const currentPhase = this.getAttribute('data-sticky-phase') || 'before';

            if (nextPhase === currentPhase) return;

            this.setAttribute('data-sticky-phase', nextPhase);
            document.dispatchEvent(
              new CustomEvent('mini-core-value-v2:phase-change', {
                detail: { phase: nextPhase },
              })
            );
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-easy-compare-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('mini-product-compare-v2')) {
      customElements.define(
        'mini-product-compare-v2',
        class CompareMain extends HTMLElement {
          constructor() {
            super();
            this.productIds = [];
            this.collectionId = '';
            this.type = '';
            this.specGroupIconTemplate = null;
            this._mobileMq = null;
            this._lastMobileCompare = null;
            this._onMobileMqChange = null;
            this._hasLoadedOnce = false;
            this._loadingOverlayTracking = false;
            this._loadingOverlayRaf = null;
            this._onLoadingOverlayLayout = null;
          }
          connectedCallback() {
            this.specGroupIconTemplate = this.querySelector('[data-spec-group-icon-template]');
            this._mobileMq = window.matchMedia('(max-width: 576px)');
            this._lastMobileCompare = this._mobileMq.matches;
            this._onMobileMqChange = () => {
              const isMobile = this._mobileMq.matches;
              if (isMobile === this._lastMobileCompare) return;
              this._lastMobileCompare = isMobile;
              this.initPageData();
            };
            this._mobileMq.addEventListener('change', this._onMobileMqChange);
            this.init();
          }
          disconnectedCallback() {
            if (this._mobileMq && this._onMobileMqChange) {
              this._mobileMq.removeEventListener('change', this._onMobileMqChange);
            }
            this._stopLoadingOverlayTracking();
          }
          _getLoadingOverlayTopBound() {
            let topBound = 0;
            const anchorBar = document.querySelector('mini-anchor-nav-v2 .mini-anchor-nav-v2__bar[data-fixed="true"]');
            if (anchorBar) {
              topBound = Math.max(topBound, anchorBar.getBoundingClientRect().bottom);
            }
            const stickyBar = document.querySelector(
              'mini-product-compare-v2-sticky-top[data-show="true"] .mini-product-compare-v2-sticky-top'
            );
            if (stickyBar) {
              topBound = Math.max(topBound, stickyBar.getBoundingClientRect().bottom);
            }
            return topBound;
          }
          _updateLoadingOverlayLayout() {
            const overlay = this.querySelector('.mini-product-compare-v2__loading-overlay');
            if (!overlay || this.getAttribute('data-loading') !== 'overlay') return;

            const rect = this.getBoundingClientRect();
            const topBound = this._getLoadingOverlayTopBound();
            const visibleTop = Math.max(rect.top, topBound, 0);
            const visibleBottom = Math.min(rect.bottom, window.innerHeight);
            const visibleHeight = visibleBottom - visibleTop;

            if (visibleHeight <= 0 || rect.bottom <= topBound || rect.top >= window.innerHeight) {
              overlay.hidden = true;
              return;
            }

            overlay.hidden = false;
            overlay.style.top = `${visibleTop}px`;
            overlay.style.left = `${Math.max(rect.left, 0)}px`;
            overlay.style.width = `${Math.min(rect.width, window.innerWidth - Math.max(rect.left, 0))}px`;
            overlay.style.height = `${visibleHeight}px`;
          }
          _startLoadingOverlayTracking() {
            if (this._loadingOverlayTracking) return;
            this._loadingOverlayTracking = true;

            if (!this._onLoadingOverlayLayout) {
              this._onLoadingOverlayLayout = () => {
                if (this._loadingOverlayRaf) {
                  cancelAnimationFrame(this._loadingOverlayRaf);
                }
                this._loadingOverlayRaf = requestAnimationFrame(() => this._updateLoadingOverlayLayout());
              };
            }

            this._updateLoadingOverlayLayout();
            window.addEventListener('scroll', this._onLoadingOverlayLayout, { passive: true });
            window.addEventListener('resize', this._onLoadingOverlayLayout);
          }
          _stopLoadingOverlayTracking() {
            if (!this._loadingOverlayTracking) return;
            this._loadingOverlayTracking = false;

            window.removeEventListener('scroll', this._onLoadingOverlayLayout);
            window.removeEventListener('resize', this._onLoadingOverlayLayout);

            if (this._loadingOverlayRaf) {
              cancelAnimationFrame(this._loadingOverlayRaf);
              this._loadingOverlayRaf = null;
            }

            const overlay = this.querySelector('.mini-product-compare-v2__loading-overlay');
            if (overlay) {
              overlay.hidden = false;
              overlay.style.top = '';
              overlay.style.left = '';
              overlay.style.width = '';
              overlay.style.height = '';
            }
          }
          isMobileCompare() {
            return window.matchMedia('(max-width: 576px)').matches;
          }
          getDisplayCount() {
            return this.isMobileCompare() ? Math.min(2, this.productIds.length) : this.productIds.length;
          }
          getDisplayProductIds() {
            return this.productIds.slice(0, this.getDisplayCount());
          }
          getCompareProductIds() {
            return this.getDisplayProductIds();
          }
          getDisplayProductDataList() {
            const ids = this.getDisplayProductIds();
            return (this.productDataList || [])
              .filter((product) => ids.includes(product.shopifyProductId))
              .sort((a, b) => ids.indexOf(a.shopifyProductId) - ids.indexOf(b.shopifyProductId));
          }
          refreshCompareView() {
            if (!this.productDataList?.length) return;
            this.style.setProperty('--compare-size', this.getDisplayCount());
            this.initProductData();
            this.initSpecData();
            this.bindSpecGroupToggle();
            const stickyTopElement =
              this.querySelector('mini-product-compare-v2-sticky-top') ||
              document.querySelector('mini-product-compare-v2-sticky-top');
            if (stickyTopElement) {
              stickyTopElement.init(this.getDisplayProductDataList());
            }
            this.initCustomSelect();
            this.initProductButtonEvent();
            this.bindCustomCheckboxEvents();
            this.applyCustomCheckboxFilter();
          }
          init() {
            this.initData();
            this.bindEvents();
          }
          initData() {
            // 判断url中是否携带了ids，如果是ids参数，那就是自选产品对比，如果没有配置参数就是系列中产品对比
            const ids = new URLSearchParams(window.location.search).get('ids');
            if (ids) {
              this.type = 'custom';
              this.productIds = ids.split(',');
            } else {
              this.type = 'series';
              this.collectionId = this.getAttribute('data-collection-id');
              this.productIds = this.getAttribute('data-series-ids')?.split(',') || [];
            }
            this.initPageData();
          }
          async initPageData() {
            if (this.productIds.length <= 1) {
              return;
            }
            // 设置对比数量css变量（576 以下仅显示 2 个产品）
            this.style.setProperty('--compare-size', this.getDisplayCount());
            try {
              const loadingMode = this._hasLoadedOnce ? 'overlay' : 'skeleton';
              this.setAttribute('data-loading', loadingMode);
              if (loadingMode === 'overlay') {
                this._startLoadingOverlayTracking();
              }
              this.querySelectorAll('.mini-product-compare-v2__custom-checkbox-item').forEach((item) => {
                item.setAttribute('data-value', 'false');
                item.setAttribute('aria-pressed', 'false');
              });
              // 并行调用两个接口（576 以下仅传前 2 个产品 ID）
              const compareProductIds = this.getCompareProductIds();
              const [listRes, compareRes, selectionRes] = await Promise.all([
                window.litime.request(
                  '/shopify/product/compare/list',
                  {
                    data: {
                      shopifyProductIds: compareProductIds,
                    },
                    method: 'GET',
                  },
                  'business-api'
                ),
                window.litime.request(
                  '/shopify/product/compare',
                  {
                    data: {
                      productIds: compareProductIds,
                    },
                    method: 'GET',
                  },
                  'business-api'
                ),
                this.type === 'series'
                  ? window.litime.request(
                      `/shopify/product/compare/selection/${this.collectionId}`,
                      {
                        method: 'GET',
                      },
                      'business-api'
                    )
                  : null,
              ]);

              if (listRes.code === 200) {
                this.productDataList = listRes.data
                  .filter((product) => compareProductIds.includes(product.shopifyProductId))
                  .sort(
                    (a, b) =>
                      compareProductIds.indexOf(a.shopifyProductId) - compareProductIds.indexOf(b.shopifyProductId)
                  );

                // 处理 compare 接口返回的数据
                if (compareRes.code === 200) {
                  this.specData = compareRes.data;
                }
                if (selectionRes && selectionRes.code === 200) {
                  this.selectionData = selectionRes.data;
                }
                this.refreshCompareView();
              }
            } catch (error) {
              console.log(error, 'error');
              this.setAttribute('data-show', 'false');
            } finally {
              this.setAttribute('data-loading', 'false');
              this._stopLoadingOverlayTracking();
              this._hasLoadedOnce = true;
            }
          }
          // 参数dom生成
          initSpecData() {
            const specDom = this.querySelector('.mini-product-compare-v2__content-spec');
            let startDom = '<div class="mini-product-compare-v2__content-spec">';
            let endDom = '</div>';
            let specDomList = '';
            this.specData.forEach((item, index) => {
              const isActive = index === 0;
              specDomList += `
              <div class="mini-product-compare-v2__content-spec-group" id="${item.name}" data-active="${
                isActive ? 'true' : 'false'
              }">
                  ${this.initSpecGroupHeader(item, isActive)}
                  ${this.initSpecGroupRows(item)}
               </div>
              `;
            });
            let newEl = startDom + specDomList + endDom;
            specDom.outerHTML = newEl;
          }
          initSpecGroupHeader(item, isActive = false) {
            const expanded = isActive ? 'true' : 'false';
            let startDom = `<button type="button" class="mini-product-compare-v2__content-spec-group-header" aria-expanded="${expanded}">`;
            let endDom = '</button>';
            let specGroupHeaderDom = `
              <div class="mini-product-compare-v2__content-spec-group-header-title">
                ${item.name}
              </div>
              <div class="mini-product-compare-v2__content-spec-group-header-icon"></div>
            `;
            return startDom + specGroupHeaderDom + endDom;
          }
          initSpecGroupRows(item) {
            let startDom = '<div class="mini-product-compare-v2__content-spec-group-body">';
            let innerStartDom = '<div class="mini-product-compare-v2__content-spec-rows-inner">';
            let rowsStartDom = '<div class="mini-product-compare-v2__content-spec-rows">';
            let rowsEndDom = '</div>';
            let innerEndDom = '</div>';
            let endDom = '</div>';
            let specGroupRowsDom = `
              ${item.items.map((row) => this.initSpecRow(row)).join('')}
            `;
            return startDom + innerStartDom + rowsStartDom + specGroupRowsDom + rowsEndDom + innerEndDom + endDom;
          }
          fillSpecGroupHeaderIcons() {
            if (!this.specGroupIconTemplate?.content) return;
            this.querySelectorAll('.mini-product-compare-v2__content-spec-group-header-icon').forEach((icon) => {
              if (icon.childElementCount > 0) return;
              icon.appendChild(this.specGroupIconTemplate.content.cloneNode(true));
            });
          }
          setSpecGroupActive(group, active) {
            if (!group) return;
            group.setAttribute('data-active', active ? 'true' : 'false');
            const header = group.querySelector('.mini-product-compare-v2__content-spec-group-header');
            if (header) {
              header.setAttribute('aria-expanded', active ? 'true' : 'false');
            }
          }
          bindSpecGroupToggle() {
            this.querySelectorAll('.mini-product-compare-v2__content-spec-group-header').forEach((header) => {
              if (header.dataset.specToggleBound === 'true') return;
              header.dataset.specToggleBound = 'true';
              header.addEventListener('click', () => {
                const group = header.closest('.mini-product-compare-v2__content-spec-group');
                if (!group) return;
                const isActive = group.getAttribute('data-active') === 'true';
                this.setSpecGroupActive(group, !isActive);
              });
            });
            this.fillSpecGroupHeaderIcons();
          }
          initSpecRow(item) {
            const isSame = item.isSame === true || item.isSame === 'true';
            let startDom = `<div class="mini-product-compare-v2__content-spec-row" data-same="${isSame}">`;
            let endDom = '</div>';
            let specRowDom = `
              ${this.initSpecRowHeader(item)}
              ${this.initSpecRowValues(item)}
            `;
            return startDom + specRowDom + endDom;
          }
          initSpecRowHeader(item) {
            let startDom = '<div class="mini-product-compare-v2__content-spec-row-header">';
            let endDom = '</div>';
            let specRowHeaderDom = `
              <div class="mini-product-compare-v2__content-spec-row-header-title">
              ${item.name}
              </div>
            `;
            return startDom + specRowHeaderDom + endDom;
          }
          initSpecRowValues(item) {
            let startDom = '<div class="mini-product-compare-v2__content-spec-row-values">';
            let endDom = '</div>';
            // 根据当前展示的产品顺序对 item.products 进行排序（576 以下仅 2 个）
            const sortedProducts = this.getDisplayProductIds().map((productId) => {
              const product = item.products.find((p) => p.id === productId);
              // 如果找不到对应的产品，返回一个默认值
              return product || { id: productId, value: 'N/A' };
            });
            let specRowValuesDom = `
              ${sortedProducts.map((product) => this.initSpecRowValue(product)).join('')}
            `;
            return startDom + specRowValuesDom + endDom;
          }
          initSpecRowValue(item) {
            let startDom = '<div class="mini-product-compare-v2__content-spec-row-value">';
            let endDom = '</div>';
            let specRowValueDom = `
              ${item.value}
            `;
            return startDom + specRowValueDom + endDom;
          }
          // 产品dom生成
          initProductData() {
            const productDom = this.querySelector('.mini-product-compare-v2__content-product');
            let startDom = '<div class="mini-product-compare-v2__content-product" id="productMain">';
            let endDom = '</div>';
            let productDomList = '';
            this.getDisplayProductDataList().forEach((item) => {
              productDomList += `
                <div  class="mini-product-compare-v2__content-product-item">
                ${this.initProductHeader(item)}
                ${this.initProductContent(item)}
                </div>
              `;
            });
            let newEl = startDom + productDomList + endDom;
            productDom.outerHTML = newEl;
          }
          initProductHeader(item) {
            let startDom = '<div class="mini-product-compare-v2__content-product-item-header">';
            let endDom = '</div>';
            let productHeaderDom = `${this.initProductHeaderProductSelect(item)}`;
            return startDom + productHeaderDom + endDom;
          }
          initProductHeaderProductSelect(item) {
            let startDom =
              '<div class="mini-product-compare-v2__custom-select mini-product-compare-v2__content-product-item-product-select" data-active="false">';
            let endDom = '</div>';
            let productHeaderProductSelectDom = `
            `;
            if (this.type === 'custom') {
              return '';
            } else {
              let productHeaderProductSelectDom = `
                ${this.initProductHeaderProductSelectTrigger(item)}
                ${this.initProductHeaderProductSelectOptions(item)}
              `;
              return startDom + productHeaderProductSelectDom + endDom;
            }
          }

          initProductHeaderProductSelectTrigger(item) {
            let startDom = '<div class="mini-product-compare-v2__custom-select-trigger">';
            let endDom = '</div>';
            let productHeaderProductSelectTriggerDom = `
              ${this.initProductHeaderProductSelectTriggerTitle(item)}
              ${this.initProductHeaderProductSelectTriggerIcon(item)}
            `;
            return startDom + productHeaderProductSelectTriggerDom + endDom;
          }
          initProductHeaderProductSelectTriggerTitle(item) {
            let startDom = '<div class="mini-product-compare-v2__custom-select-trigger-title">';
            let endDom = '</div>';
            let productHeaderProductSelectTriggerTitleDom = `
              ${item.shortTitle || item.title}
            `;
            return startDom + productHeaderProductSelectTriggerTitleDom + endDom;
          }
          initProductHeaderProductSelectTriggerIcon(item) {
            return `
                <svg
                  class="mini-product-compare-v2__custom-select-trigger-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  fill="none"
                  version="1.1"
                  width="14"
                  height="14.232421875"
                  viewBox="0 0 14 14.232421875"
                >
                  <g><g><rect x="0" y="0.232421875" width="14" height="14" rx="0" fill="#D9D9D9" fill-opacity="0"/></g><g transform="matrix(-0.7071067094802856,-0.7071067094802856,-0.7071067094802856,0.7071067094802856,22.47805441892706,9.310715064639226)"><path d="" fill="#D9D9D9" fill-opacity="0"/><path d="M10.30013996,5.232421875Q10.30014002,5.163491681,10.31358761,5.095885965Q10.32703525,5.028280245,10.3534137,4.964597045Q10.37979209,4.900913835,10.41808772,4.843600485Q10.45638323,4.786287125,10.50512424,4.737546115Q10.55386525,4.688805105,10.61117864,4.650509535Q10.66849196,4.6122139650000005,10.73217517,4.585835575Q10.79585837,4.559457125,10.86346409,4.546009485Q10.931069806,4.532561895,11,4.532561835Q11.068930194,4.532561895,11.13653591,4.546009485Q11.20414163,4.559457125,11.26782483,4.585835575Q11.33150804,4.6122139650000005,11.38882139,4.650509595Q11.44613475,4.688805105,11.49487576,4.737546115Q11.54361677,4.786287125,11.58191234,4.843600515Q11.62020791,4.900913835,11.6465863,4.964597045Q11.67296475,5.028280245,11.68641239,5.095885965Q11.69985998,5.163491681,11.69986004,5.232421875L11.69999999,5.232421875L11.69999999,10.532422075L17,10.532422075L17,10.532561775Q17.068929699999998,10.532561775,17.1365352,10.546009075Q17.2041407,10.559456875,17.2678242,10.585834975000001Q17.3315067,10.612213175,17.388820199999998,10.650509375Q17.4461336,10.688804675,17.494875,10.737545975Q17.5436158,10.786286375,17.581911599999998,10.843600275Q17.6202068,10.900913275,17.6465855,10.964596775Q17.6729641,11.028279775,17.6864119,11.095885775Q17.6998596,11.163491275,17.699860100000002,11.232421875Q17.6998596,11.301351575,17.6864123,11.368957075Q17.6729641,11.436562575,17.646585899999998,11.500246075Q17.6202078,11.563928575,17.581912,11.621242075Q17.5436168,11.678555475,17.4948759,11.727296875Q17.4461346,11.776037675000001,17.3888211,11.814333475Q17.3315077,11.852628675,17.2678242,11.879007375Q17.2041407,11.905385975,17.1365352,11.918833775Q17.068929699999998,11.932281475,17,11.932281975L17,11.932421675L11,11.932421675Q10.931056023,11.932421175,10.86343679,11.918970575Q10.79581757,11.905520475,10.73212165,11.879136575Q10.66842571,11.852752675,10.61110088,11.814450274999999Q10.55377603,11.776146875,10.50502527,11.727395975Q10.45627457,11.678645175,10.41797137,11.621320675Q10.37966812,11.563995875,10.35328442,11.500299975Q10.32690072,11.436603975,10.31345034,11.368984675Q10.30000007,11.301365875,10.30000001,11.232421875L10.30000001,5.232421875L10.30013996,5.232421875Z" fill-rule="evenodd" fill="#191919" fill-opacity="1"/></g></g>
                </svg>
            `;
          }

          initProductHeaderProductSelectOptions(item) {
            let startDom = '<div class="mini-product-compare-v2__custom-select-options overflow-beautify">';
            let endDom = '</div>';
            let productHeaderProductSelectOptionsDom = `
              ${this.initProductHeaderProductSelectOptionsItems(item)}
            `;
            return startDom + productHeaderProductSelectOptionsDom + endDom;
          }
          initProductHeaderProductSelectOptionsItems(item) {
            let productHeaderProductSelectOptionsItemsDom = `
              ${this.selectionData
                .map(
                  (selection) => `
                <div class="mini-product-compare-v2__custom-select-option" data-product-id="${
                  item.shopifyProductId
                }" data-value="${selection.shopifyProductId}" data-selected="${
                    selection.shopifyProductId === item.shopifyProductId ? 'true' : 'false'
                  }" data-disabled="${
                    this.getCompareProductIds().includes(selection.shopifyProductId) &&
                    selection.shopifyProductId !== item.shopifyProductId
                      ? 'true'
                      : 'false'
                  }">
                  <span class="mini-product-compare-v2__custom-select-option-label">${
                    selection.shortTitle || selection.title
                  }</span>
                </div>
              `
                )
                .join('')}
            `;
            return productHeaderProductSelectOptionsItemsDom;
          }
          initProductHeaderImage(item) {
            let imageSrc = item.guideImageSrc || item.imageSrc;
            const alt = (item.shortTitle || item.title || '').replace(/"/g, '&quot;');
            return `
              <a href="/products/${item.handle}" class="mini-product-compare-v2__content-product-item-image-link">
                <img class="mini-product-compare-v2__content-product-item-image" src="${imageSrc}" width="120" height="120" alt="${alt}">
              </a>
            `;
          }
          initProductContent(item) {
            let startDom = '<div class="mini-product-compare-v2__content-product-item-content">';
            let productContentDom = `
              <div class="mini-product-compare-v2__content-product-item-media">
                ${this.initProductHeaderImage(item)}
              </div>
              <div class="mini-product-compare-v2__content-product-item-details">
                ${this.initProductContentInfo(item)}
                ${this.initProductContentVariant(item)}
                <div class="mini-product-compare-v2__content-product-item-actions">
                  ${this.initProductContentButton(item)}
                  ${this.initLearnMoreLink(item)}
                </div>
              </div>
            `;
            let endDom = '</div>';
            return startDom + productContentDom + endDom;
          }
          initLearnMoreLink(item) {
            const text = this.getAttribute('data-i18n-learn-more') || 'Learn More';
            return `
              <a href="/products/${item.handle}" class="mini-product-compare-v2__content-product-item-learn-more">
                <span class="mini-product-compare-v2__content-product-item-learn-more-text">${text}</span>
                <svg class="mini-product-compare-v2__content-product-item-learn-more-icon icon-sprite" width="12" height="12" style="color: var(--theme-color)" aria-hidden="true" focusable="false">
                  <use xlink:href="#icon-right-v2"></use>
                </svg>
              </a>
            `;
          }
          initProductContentInfo(item) {
            let startDom = '<div class="mini-product-compare-v2__content-product-item-info">';
            let productContentInfoDom = `${this.initProductContentInfoPrice(item)}`;
            let endDom = '</div>';
            return startDom + productContentInfoDom + endDom;
          }
          initProductContentInfoTitle(item) {
            let startDom = '<div class="mini-product-compare-v2__content-product-item-info-title">';
            let productContentInfoTitleDom = `
              ${item.shortTitle || item.title}
            `;
            let endDom = '</div>';
            return startDom + productContentInfoTitleDom + endDom;
          }
          initProductContentInfoPrice(item) {
            let startDom = '<div class="mini-product-compare-v2__content-product-item-info-price">';
            let defaultVariant = this.getDefaultVariant(item);
            let newPrice = this.getDiscountPrice(defaultVariant.price, defaultVariant.discount) * 100;
            let oldPrice = defaultVariant.compareAtPrice * 100;
            let productContentInfoPriceDom = `
              ${this.initProductContentInfoPriceNew(item, newPrice)}
              ${this.initProductContentInfoPriceOld(item, newPrice, oldPrice)}
            `;
            let endDom = '</div>';
            return startDom + productContentInfoPriceDom + endDom;
          }
          initProductContentInfoPriceNew(item, price) {
            let startDom = `<div class="mini-product-compare-v2__content-product-item-info-price-new" data-product-id="${item.shopifyProductId}">`;
            let productContentInfoPriceNewDom = `
              ${window.Shopify.formatMoney(price, window.shopMoneyFormat)}
            `;
            let endDom = '</div>';
            return startDom + productContentInfoPriceNewDom + endDom;
          }
          initProductContentInfoPriceOld(item, price, oldPrice) {
            let stauts = 'true';
            if (oldPrice < price) {
              stauts = 'false';
            }
            let startDom = `<div class="mini-product-compare-v2__content-product-item-info-price-old" data-show="${stauts}" data-product-id="${item.shopifyProductId}">`;
            let productContentInfoPriceOldDom = `
              ${window.Shopify.formatMoney(oldPrice, window.shopMoneyFormat)}
            `;
            let endDom = '</div>';

            return startDom + productContentInfoPriceOldDom + endDom;
          }
          initProductContentVariant(item) {
            if (this.getAttribute('data-show-sku') === 'false' || item.variants.length <= 1) {
              return '';
            } else {
              let startDom =
                '<div class="mini-product-compare-v2__custom-select mini-product-compare-v2__content-product-item-variant" data-active="false">';
              let endDom = '</div>';
              let productContentVariantDom = `
                ${this.initProductContentVariantTrigger(item)}
                ${this.initProductContentVariantOptions(item)}
              `;
              return startDom + productContentVariantDom + endDom;
            }
          }
          initProductContentVariantTrigger(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let startDom = '<div class="mini-product-compare-v2__custom-select-trigger">';
            let endDom = '</div>';
            let productContentVariantTriggerDom = `
              ${this.initProductContentVariantTriggerTitle(item)}
              ${this.initProductContentVariantTriggerIcon(item)}
            `;
            return startDom + productContentVariantTriggerDom + endDom;
          }
          initProductContentVariantTriggerTitle(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let startDom = '<div class="mini-product-compare-v2__custom-select-trigger-title">';
            let endDom = '</div>';
            let productContentVariantTriggerTitleDom = `
              ${defaultVariant.title}
            `;
            return startDom + productContentVariantTriggerTitleDom + endDom;
          }
          initProductContentVariantTriggerIcon(item) {
            return `
                <svg
                  class="mini-product-compare-v2__custom-select-trigger-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  fill="none"
                  version="1.1"
                  width="14"
                  height="14.232421875"
                  viewBox="0 0 14 14.232421875"
                >
                  <g><g><rect x="0" y="0.232421875" width="14" height="14" rx="0" fill="#D9D9D9" fill-opacity="0"/></g><g transform="matrix(-0.7071067094802856,-0.7071067094802856,-0.7071067094802856,0.7071067094802856,22.47805441892706,9.310715064639226)"><path d="" fill="#D9D9D9" fill-opacity="0"/><path d="M10.30013996,5.232421875Q10.30014002,5.163491681,10.31358761,5.095885965Q10.32703525,5.028280245,10.3534137,4.964597045Q10.37979209,4.900913835,10.41808772,4.843600485Q10.45638323,4.786287125,10.50512424,4.737546115Q10.55386525,4.688805105,10.61117864,4.650509535Q10.66849196,4.6122139650000005,10.73217517,4.585835575Q10.79585837,4.559457125,10.86346409,4.546009485Q10.931069806,4.532561895,11,4.532561835Q11.068930194,4.532561895,11.13653591,4.546009485Q11.20414163,4.559457125,11.26782483,4.585835575Q11.33150804,4.6122139650000005,11.38882139,4.650509595Q11.44613475,4.688805105,11.49487576,4.737546115Q11.54361677,4.786287125,11.58191234,4.843600515Q11.62020791,4.900913835,11.6465863,4.964597045Q11.67296475,5.028280245,11.68641239,5.095885965Q11.69985998,5.163491681,11.69986004,5.232421875L11.69999999,5.232421875L11.69999999,10.532422075L17,10.532422075L17,10.532561775Q17.068929699999998,10.532561775,17.1365352,10.546009075Q17.2041407,10.559456875,17.2678242,10.585834975000001Q17.3315067,10.612213175,17.388820199999998,10.650509375Q17.4461336,10.688804675,17.494875,10.737545975Q17.5436158,10.786286375,17.581911599999998,10.843600275Q17.6202068,10.900913275,17.6465855,10.964596775Q17.6729641,11.028279775,17.6864119,11.095885775Q17.6998596,11.163491275,17.699860100000002,11.232421875Q17.6998596,11.301351575,17.6864123,11.368957075Q17.6729641,11.436562575,17.646585899999998,11.500246075Q17.6202078,11.563928575,17.581912,11.621242075Q17.5436168,11.678555475,17.4948759,11.727296875Q17.4461346,11.776037675000001,17.3888211,11.814333475Q17.3315077,11.852628675,17.2678242,11.879007375Q17.2041407,11.905385975,17.1365352,11.918833775Q17.068929699999998,11.932281475,17,11.932281975L17,11.932421675L11,11.932421675Q10.931056023,11.932421175,10.86343679,11.918970575Q10.79581757,11.905520475,10.73212165,11.879136575Q10.66842571,11.852752675,10.61110088,11.814450274999999Q10.55377603,11.776146875,10.50502527,11.727395975Q10.45627457,11.678645175,10.41797137,11.621320675Q10.37966812,11.563995875,10.35328442,11.500299975Q10.32690072,11.436603975,10.31345034,11.368984675Q10.30000007,11.301365875,10.30000001,11.232421875L10.30000001,5.232421875L10.30013996,5.232421875Z" fill-rule="evenodd" fill="#191919" fill-opacity="1"/></g></g>
                </svg>
            `;
          }

          initProductContentVariantOptions(item) {
            let startDom = '<div class="mini-product-compare-v2__custom-select-options overflow-beautify">';
            let endDom = '</div>';
            let productContentVariantOptionsDom = `
              ${this.initProductContentVariantOptionsItems(item)}
            `;
            return startDom + productContentVariantOptionsDom + endDom;
          }
          initProductContentVariantOptionsItems(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let productContentVariantOptionsItemsDom = `
              ${item.variants
                .map((variant) => {
                  let newPrice = this.getDiscountPrice(variant.price, variant.discount);
                  return `
                <div class="mini-product-compare-v2__custom-select-option" 
                  data-price="${newPrice}" 
                  data-compare-price="${variant.compareAtPrice}" 
                  data-title="${variant.title}"
                  data-product-id="${item.shopifyProductId}"
                  data-product-title="${item.shortTitle || item.title}"
                  data-value="${variant.id}" 
                  data-inventory-quantity="${variant.inventoryQuantity}"
                  data-inventory-policy="${variant.inventoryPolicy}"
                  data-selected="${variant.id === defaultVariant.id ? 'true' : 'false'}"
                >
                  <span class="mini-product-compare-v2__custom-select-option-label">${variant.title}</span>
                </div>
              `;
                })
                .join('')}
            `;
            return productContentVariantOptionsItemsDom;
          }
          initProductContentButton(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let noStockout = defaultVariant.inventoryQuantity > 0 || defaultVariant.inventoryPolicy === 'continue';
            return `          
             <div class="mini-product-compare-v2__content-product-item-buttons" data-stockout="${
               noStockout ? 'false' : 'true'
             }">
                <div class="mini-product-compare-v2__content-product-item-add" 
                  data-product-id="${item.shopifyProductId}" 
                  data-action="add" 
                  data-loading="false" 
                  data-variant-id="${defaultVariant.id}"
                >
                  <div class="mini-product-compare-v2__content-product-item-add-text">${this.getAttribute(
                    'data-i18n-add-to-cart'
                  )}</div>
                  <div class="mini-product-compare-v2__content-product-item-add-icon">
                    <i class="items-center justify-center rotate_icon">
                      <div
                        class="loader-animation"
                        style="border:2px solid #fff; border-left-color: transparent;"
                      ></div>
                    </i>
                  </div>
                </div>
                <div class="mini-product-compare-v2__content-product-item-stockout">
                  <div class="mini-product-compare-v2__content-product-item-stockout-text">${this.getAttribute(
                    'data-i18n-stockout'
                  )}</div>
                  <klaviyo-bis-trigger class="w-full h-full left-0 top-0 absolute">
                    <div
                      class="klaviyo-bis-wrapper w-full h-full flex items-center justify-center text-[14px] transition-colors duration-300"
                      data-product="${item.shopifyProductId}"
                      data-variant="${defaultVariant.id}"
                      data-product-title="${item.shortTitle || item.title}"
                    >
                      <div class="add-to-cart-text w-full h-full flex items-center justify-center  text-[14px]   transition-colors duration-300">
                      </div>
                    </div>
                  </klaviyo-bis-trigger>
                </div>
              </div>
            `;
          }

          // 获取默认变体
          getDefaultVariant(item) {
            if (this.type === 'custom') {
              const ltCompareData = window.litime.getLocalStorage('ltCompareData') || [];
              // 找到对应的 compare 项
              const compareItem = ltCompareData.find((compareItem) => compareItem.id === item.shopifyProductId);

              // 如果 localstorage 里有记录的默认变体
              if (compareItem && compareItem.variantId) {
                const matchVariant = item.variants.find((variant) => variant.id == compareItem.variantId);
                if (matchVariant) return matchVariant;
              }

              // 否则返回第一个
              return item.variants[0];
            }

            // 非 custom
            const availableVariant = item.variants.find(
              (variant) => variant.inventoryQuantity > 0 || variant.inventoryPolicy === 'continue'
            );

            return availableVariant || item.variants[0];
          }

          initCustomSelect() {
            this.customSelectItems = [...this.querySelectorAll('.mini-product-compare-v2__custom-select')];

            this.customSelectItems.forEach((item) => {
              const trigger = item.querySelector('.mini-product-compare-v2__custom-select-trigger');
              const options = item.querySelector('.mini-product-compare-v2__custom-select-options');
              if (!trigger || trigger.dataset.selectTriggerBound === 'true') return;
              trigger.dataset.selectTriggerBound = 'true';
              trigger.addEventListener('click', (e) => {
                e.preventDefault(); // 阻止跳转
                e.stopPropagation();
                this.customSelectItems.forEach((itemItem) => {
                  if (itemItem !== item && itemItem.getAttribute('data-active') === 'true') {
                    itemItem.setAttribute('data-active', 'false');
                  }
                });
                item.setAttribute('data-active', item.getAttribute('data-active') === 'true' ? 'false' : 'true');
              });
            });
            if (!this._customSelectOutsideBound) {
              this._customSelectOutsideBound = true;
              this.addEventListener('click', (e) => {
                if (!this.customSelectItems.some((itemItem) => itemItem.contains(e.target))) {
                  this.customSelectItems.forEach((item) => {
                    if (item.getAttribute('data-active') === 'true') {
                      item.setAttribute('data-active', 'false');
                    }
                  });
                }
              });
            }
            // 给mini-product-compare-v2__content-product-item-product-select下面的mini-product-compare-v2__custom-select-optionz增加点击事件
            this.querySelectorAll(
              '.mini-product-compare-v2__content-product-item-product-select .mini-product-compare-v2__custom-select-option'
            ).forEach((item) => {
              if (item.dataset.selectOptionBound === 'true') return;
              item.dataset.selectOptionBound = 'true';
              item.addEventListener('click', (e) => {
                e.preventDefault(); // 阻止跳转
                e.stopPropagation();
                if (item.getAttribute('data-disabled') == 'true') {
                  return;
                }
                let productId = item.getAttribute('data-value');
                let oldProductId = item.getAttribute('data-product-id');
                if (productId === oldProductId) {
                  return;
                }
                // 替换原本的productId
                this.productIds = this.productIds.map((item) => {
                  if (item === oldProductId) {
                    return productId;
                  }
                  return item;
                });

                this.initPageData();
              });
            });
            // 给变体选择框增加点击事件
            this.querySelectorAll(
              '.mini-product-compare-v2__content-product-item-variant .mini-product-compare-v2__custom-select-option'
            ).forEach((item) => {
              if (item.dataset.selectOptionBound === 'true') return;
              item.dataset.selectOptionBound = 'true';
              item.addEventListener('click', (e) => {
                e.preventDefault(); // 阻止跳转
                e.stopPropagation();
                if (item.getAttribute('data-disabled') == 'true') {
                  return;
                }
                // 找到父级，把active属性设置为false
                let parent = item.closest('.mini-product-compare-v2__content-product-item-variant');
                parent.setAttribute('data-active', 'false');
                // 将同级的option的selected属性设置为false
                parent.querySelectorAll('.mini-product-compare-v2__custom-select-option').forEach((itemItem) => {
                  itemItem.setAttribute('data-selected', 'false');
                });
                // 将当前option的selected属性设置为true
                item.setAttribute('data-selected', 'true');
                // 将当前option的title设置为触发器的文案
                let title = item.getAttribute('data-title');
                let productTitle = item.getAttribute('data-product-title');
                let trigger = parent.querySelector('.mini-product-compare-v2__custom-select-trigger-title');
                trigger.innerHTML = title;
                // 加购按钮需要修改变体,productId相同并且action为add的进行修改
                let variantId = item.getAttribute('data-value');
                let productId = item.getAttribute('data-product-id');
                this.querySelectorAll('[data-product-id="' + productId + '"][data-action="add"]').forEach(
                  (itemItem) => {
                    // 判断当前的变体库存，进行切换按钮的显示隐藏
                    let inventoryQuantity = item.getAttribute('data-inventory-quantity');
                    let inventoryPolicy = item.getAttribute('data-inventory-policy');
                    let noStockout = inventoryQuantity > 0 || inventoryPolicy === 'continue';
                    if (noStockout) {
                      itemItem
                        .closest('.mini-product-compare-v2__content-product-item-buttons')
                        ?.setAttribute('data-stockout', 'false');
                    } else {
                      itemItem
                        .closest('.mini-product-compare-v2__content-product-item-buttons')
                        ?.setAttribute('data-stockout', 'true');
                    }
                    itemItem.setAttribute('data-variant-id', variantId);
                    const stockoutDom = itemItem.parentElement.querySelector(
                      '.mini-product-compare-v2__content-product-item-stockout'
                    );

                    if (stockoutDom) {
                      stockoutDom.querySelector('.klaviyo-bis-wrapper').setAttribute('data-variant', variantId);
                      stockoutDom.querySelector('.klaviyo-bis-wrapper').setAttribute('data-product', productId);
                      stockoutDom
                        .querySelector('.klaviyo-bis-wrapper')
                        .setAttribute('data-product-title', productTitle);
                    }
                  }
                );
                // 价格变化
                let price = item.getAttribute('data-price');
                let comparePrice = item.getAttribute('data-compare-price');
                const priceNewEl = this.querySelector(
                  `.mini-product-compare-v2__content-product-item-info-price-new[data-product-id="${productId}"]`
                );
                const priceOldEl = this.querySelector(
                  `.mini-product-compare-v2__content-product-item-info-price-old[data-product-id="${productId}"]`
                );
                if (priceNewEl) {
                  priceNewEl.innerHTML = window.Shopify.formatMoney(price * 100, window.shopMoneyFormat);
                }
                if (priceOldEl) {
                  priceOldEl.innerHTML = window.Shopify.formatMoney(comparePrice * 100, window.shopMoneyFormat);
                  priceOldEl.setAttribute('data-show', comparePrice > price ? 'true' : 'false');
                }
              });
            });
          }
          initProductButtonEvent() {
            this.querySelectorAll('[data-action="add"]').forEach((item) => {
              item.addEventListener('click', async (e) => {
                e.preventDefault(); // 阻止跳转
                e.stopPropagation();
                try {
                  if (item.getAttribute('data-loading') === 'true') {
                    return;
                  }
                  item.setAttribute('data-loading', 'true');
                  let params = [
                    {
                      id: item.getAttribute('data-variant-id'),
                      quantity: 1,
                    },
                  ];
                  await window.litime.addCart(params);
                } catch (error) {
                  console.log(error, 'error');
                } finally {
                  item.setAttribute('data-loading', 'false');
                }
              });
            });
          }
          bindEvents() {
            this.bindSpecGroupToggle();
            this.bindCustomCheckboxEvents();
          }
          bindCustomCheckboxEvents() {
            this.querySelectorAll('.mini-product-compare-v2__custom-checkbox-item[data-option="hide"]').forEach(
              (item) => {
                if (item.dataset.checkboxBound === 'true') return;
                item.dataset.checkboxBound = 'true';

                item.addEventListener('click', (event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  this.toggleCustomCheckbox(item);
                });

                item.addEventListener('keydown', (event) => {
                  if (event.key !== 'Enter' && event.key !== ' ') return;
                  event.preventDefault();
                  this.toggleCustomCheckbox(item);
                });
              }
            );
          }
          applyCustomCheckboxFilter() {
            const isChecked = this.querySelector(
              '.mini-product-compare-v2__custom-checkbox-item[data-option="hide"][data-value="true"]'
            );
            this.applyDifferenceFilter(Boolean(isChecked));
          }
          applyDifferenceFilter(isChecking) {
            this.querySelectorAll('.mini-product-compare-v2__content-spec-row').forEach((row) => {
              if (!isChecking) {
                row.removeAttribute('data-show');
                return;
              }

              if (row.getAttribute('data-same') == 'true') {
                row.setAttribute('data-show', 'false');
              } else {
                row.setAttribute('data-show', 'true');
              }
            });
          }
          toggleCustomCheckbox(item) {
            const isChecking = item.getAttribute('data-value') != 'true';

            this.querySelectorAll('.mini-product-compare-v2__custom-checkbox-item[data-option="hide"]').forEach(
              (optionItem) => {
                optionItem.setAttribute('data-value', isChecking ? 'true' : 'false');
                optionItem.setAttribute('aria-pressed', isChecking ? 'true' : 'false');
              }
            );

            this.applyDifferenceFilter(isChecking);
          }
          getDiscountPrice(price, discount) {
            if (!discount) return price;

            // 安全兜底
            const percentageArr = Array.isArray(discount.percentage) ? discount.percentage : [];

            const amountArr = Array.isArray(discount.amount) ? discount.amount : [];

            // 拿最大折扣 quota
            const percentageMax = percentageArr.reduce((max, item) => Math.max(max, item.discountQuota || 0), 0);

            const amountMax = amountArr.reduce((max, item) => Math.max(max, item.discountQuota || 0), 0);

            // 计算两种折扣后的价格
            const p1 = price - amountMax; // 减金额
            const p2 = price * (1 - percentageMax / 100); // 按百分比
            return this.ceilToTwo(Math.min(p1, p2));
          }
          ceilToTwo(num) {
            return Math.ceil(num * 100) / 100;
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-h2-innovation-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('mini-h2-innovation-v2')) {
      customElements.define(
        'mini-h2-innovation-v2',
        class MiniH2ZoomOut extends HTMLElement {
          static STACK_MQ = '(max-width: 960px)';
          static STACK_TEXT_REVEAL_DELAY_MS = 900;

          connectedCallback() {
            this._section = this.querySelector('.mini-h2-innovation-v2__section');
            this._animationModule = this.querySelector('[data-animation-module]');
            this._zoomBgBox = this.querySelector('[data-zoom-bg]');
            this._headline = this.querySelector('[data-headline]');
            this._description = this.querySelector('[data-description]');
            this._hasDescription = this.getAttribute('data-has-description') === 'true';

            this._layout = { marginTop: 0, bgWidth: 0, bgHeight: 0 };
            this._jumpNavOffsetOverride = null;
            this._onScroll = this._handleScroll.bind(this);
            this._onResize = this._handleResize.bind(this);
            this._onPrepareJump = this._handlePrepareJump.bind(this);
            this._mqStack = window.matchMedia(MiniH2ZoomOut.STACK_MQ);
            this._onStackMqChange = this._handleStackMqChange.bind(this);

            document.addEventListener('mini-anchor-nav-v2:prepare-jump', this._onPrepareJump);
            this._mqStack.addEventListener('change', this._onStackMqChange);
            window.addEventListener('resize', this._onResize, { passive: true });

            if (!this._section || !this._animationModule || !this._zoomBgBox) return;

            this._initStackTextInview();

            if (!this._isStackMode()) {
              window.addEventListener('scroll', this._onScroll, { passive: true });
              this._syncJumpAnchor();
              this._updateLayout();
              this._applyAnimation();
            }
          }

          disconnectedCallback() {
            window.removeEventListener('scroll', this._onScroll);
            window.removeEventListener('resize', this._onResize);
            document.removeEventListener('mini-anchor-nav-v2:prepare-jump', this._onPrepareJump);
            if (this._mqStack) {
              this._mqStack.removeEventListener('change', this._onStackMqChange);
            }
            if (this._stackTextObserver) {
              this._stackTextObserver.disconnect();
              this._stackTextObserver = null;
            }
            if (this._stackTextRevealTimer) {
              window.clearTimeout(this._stackTextRevealTimer);
              this._stackTextRevealTimer = null;
            }
            this._stackRevealStarted = false;
            this._stackTextRevealed = false;
          }

          _resetStackRevealInlineStyles(element) {
            if (!element) return;

            element.removeAttribute('lt-scroll-inview');
            element.style.removeProperty('opacity');
            element.style.removeProperty('transform');
            element.style.removeProperty('transition');
          }

          /** stack 模式：标题入场后再延迟显示描述 */
          _initStackTextInview() {
            const stackContent = this.querySelector('.mini-h2-innovation-v2__stack-content');
            const headline = this.querySelector('.mini-h2-innovation-v2__stack-headline');
            const textGroup = this.querySelector('.mini-h2-innovation-v2__stack-text-group');

            if (!headline && !textGroup) return;

            this._resetStackRevealInlineStyles(headline);
            this._resetStackRevealInlineStyles(textGroup);

            const lockInviewState = (element) => {
              if (!element || element.classList.contains('is-inview-done')) return;
              element.classList.add('is-inview-done');
            };

            const bindInviewDone = (element) => {
              if (!element || element.classList.contains('is-inview-done')) return;

              let pending = 2;

              const onTransitionEnd = (event) => {
                if (event.target !== element) return;
                if (event.propertyName !== 'opacity' && event.propertyName !== 'transform') {
                  return;
                }

                pending -= 1;
                if (pending > 0) return;

                element.removeEventListener('transitionend', onTransitionEnd);
                lockInviewState(element);
              };

              element.addEventListener('transitionend', onTransitionEnd);
              window.setTimeout(() => {
                element.removeEventListener('transitionend', onTransitionEnd);
                lockInviewState(element);
              }, 700);
            };

            const revealTextGroup = () => {
              if (!textGroup || this._stackTextRevealed) return;

              this._stackTextRevealed = true;
              this._resetStackRevealInlineStyles(textGroup);
              textGroup.classList.add('is-inview');
              bindInviewDone(textGroup);
            };

            const scheduleTextReveal = () => {
              if (this._stackTextRevealTimer) {
                window.clearTimeout(this._stackTextRevealTimer);
              }

              if (!textGroup) return;

              this._stackTextRevealTimer = window.setTimeout(() => {
                this._stackTextRevealTimer = null;
                revealTextGroup();
              }, MiniH2ZoomOut.STACK_TEXT_REVEAL_DELAY_MS);
            };

            const startStackReveal = () => {
              if (this._stackRevealStarted) return;
              this._stackRevealStarted = true;

              if (headline) {
                this._resetStackRevealInlineStyles(headline);
                headline.classList.add('is-inview');
                bindInviewDone(headline);
              }

              scheduleTextReveal();
            };

            if (!stackContent) {
              startStackReveal();
              return;
            }

            if (this._stackTextObserver) {
              this._stackTextObserver.disconnect();
            }

            this._stackTextObserver = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;

                  this._stackTextObserver?.disconnect();
                  this._stackTextObserver = null;
                  startStackReveal();
                });
              },
              {
                threshold: 0.1,
                rootMargin: '0px 0px -10% 0px',
              }
            );

            this._stackTextObserver.observe(stackContent);
          }

          _handlePrepareJump(event) {
            if (this._isStackMode()) return;
            if (event?.detail?.offset != null) {
              this._jumpNavOffsetOverride = event.detail.offset;
            }
            this._syncJumpAnchor();
            this._jumpNavOffsetOverride = null;
          }

          _isStackMode() {
            return this._mqStack?.matches ?? window.matchMedia(MiniH2ZoomOut.STACK_MQ).matches;
          }

          _handleStackMqChange() {
            if (this._isStackMode()) {
              window.removeEventListener('scroll', this._onScroll);
              return;
            }

            window.addEventListener('scroll', this._onScroll, { passive: true });
            this._syncJumpAnchor();
            this._updateLayout();
            this._applyAnimation();
          }

          /** 与锚点导航 header + nav 高度对齐 */
          _getJumpNavOffset() {
            if (this._jumpNavOffsetOverride != null) {
              return this._jumpNavOffsetOverride;
            }

            const padding = parseInt(document.documentElement.style.scrollPaddingTop, 10);
            if (!Number.isNaN(padding) && padding > 0) return padding;

            const header = document.getElementById('lt-header');
            let headerOffset = 0;
            if (header?.getAttribute('data-scrollshow') === 'true') {
              headerOffset = header.offsetHeight || 0;
            }

            const navBar = document.querySelector('mini-anchor-nav-v2 [data-bar]');
            return headerOffset + (navBar?.offsetHeight || 0);
          }

          /**
           * 锚点落在背景放大吸顶态（progressK = 1）
           * section.top = -0.2vh → anchor.top = navOffset + 0.2vh
           */
          _syncJumpAnchor() {
            const anchor = this.querySelector('[data-jump-anchor]');
            if (!anchor) return;

            const navOffset = this._getJumpNavOffset();
            const vh = window.innerHeight;
            anchor.style.top = `${navOffset + vh * 0.2}px`;
          }

          _clamp(value, min, max) {
            return Math.min(max, Math.max(min, value));
          }

          _interpolate(value, inputRange, outputRange) {
            if (value <= inputRange[0]) return outputRange[0];
            if (value >= inputRange[inputRange.length - 1]) {
              return outputRange[outputRange.length - 1];
            }
            for (let i = 0; i < inputRange.length - 1; i += 1) {
              if (value >= inputRange[i] && value <= inputRange[i + 1]) {
                const t = (value - inputRange[i]) / (inputRange[i + 1] - inputRange[i]);
                return outputRange[i] + t * (outputRange[i + 1] - outputRange[i]);
              }
            }
            return outputRange[outputRange.length - 1];
          }

          /** animation-module 300vh，滚动距离 200vh */
          _getProgressY() {
            const rect = this._section.getBoundingClientRect();
            const vh = window.innerHeight;
            const scrollRange = 2 * vh;
            return this._clamp(-rect.top / scrollRange, 0, 1);
          }

          /** 背景 offset ["start 80%", "100vh 80%"] */
          _getProgressK() {
            const rect = this._section.getBoundingClientRect();
            const vh = window.innerHeight;
            return this._clamp((vh * 0.8 - rect.top) / vh, 0, 1);
          }

          _updateLayout() {
            const sectionWidth = this._section.clientWidth || window.innerWidth;
            const vh = window.innerHeight;

            this._layout.bgHeight = (vh + 1) / 1.5;
            this._layout.bgWidth = (sectionWidth + 1) / 1.5;
            this._layout.marginTop = (vh - this._layout.bgHeight) / 2;

            this._zoomBgBox.style.width = `${Math.ceil(this._layout.bgWidth)}px`;
            this._zoomBgBox.style.height = `${Math.ceil(this._layout.bgHeight)}px`;
            this._zoomBgBox.style.marginTop = `${Math.ceil(this._layout.marginTop)}px`;

            this._animationModule.style.height = `${3 * vh}px`;
          }

          _applyAnimation() {
            const y = this._getProgressY();
            const k = this._getProgressK();
            const layout = this._layout;

            const bgOpacity = k >= 0.3 ? 1 : k / 0.3;
            const bgScale = 1 + 0.5 * k;
            const bgY = layout.marginTop * (k < 0.5 ? k / 0.5 : 1);

            this._zoomBgBox.style.opacity = String(bgOpacity);
            this._zoomBgBox.style.transform = `translate3d(0,${bgY}px,0) scale(${bgScale})`;

            if (this._headline) {
              const titleOpacity = this._interpolate(y, [0.2, 0.35, 0.55, 0.6], [0, 1, 1, 0]);
              const titleY = this._interpolate(y, [0.2, 0.4, 0.55, 0.62], [15, 0, 0, -10]);
              this._headline.style.opacity = String(titleOpacity);
              this._headline.style.transform = `translate3d(0,${titleY}px,0)`;
            }

            if (this._description) {
              const descOpacity = this._interpolate(y, [0.6, 0.7], [0, 1]);
              const descY = this._interpolate(descOpacity, [0, 1], [15, 0]);
              this._description.style.opacity = String(descOpacity);
              this._description.style.transform = `translate3d(0,${descY}px,0)`;
            } else if (this._headline) {
              const titleOpacity = this._interpolate(y, [0.2, 0.35, 0.55, 0.9], [0, 1, 1, 0]);
              const titleY = this._interpolate(y, [0.2, 0.4, 0.55, 0.62], [15, 0, 0, -10]);
              this._headline.style.opacity = String(titleOpacity);
              this._headline.style.transform = `translate3d(0,${titleY}px,0)`;
            }
          }

          _handleResize() {
            if (this._isStackMode()) return;
            this._syncJumpAnchor();
            this._updateLayout();
            this._applyAnimation();
          }

          _handleScroll() {
            if (this._isStackMode()) return;
            if (this._scrollRaf) return;
            this._scrollRaf = requestAnimationFrame(() => {
              this._applyAnimation();
              this._scrollRaf = null;
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-product-feature-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('mini-product-feature-v2')) {
      customElements.define(
        'mini-product-feature-v2',
        class MiniFeatureCarousel extends HTMLElement {
          connectedCallback() {
            this.$dialog = $(this).find('dialog-simple-v2');
            this._onExpandClick = (e) => {
              const $card = $(e.currentTarget).closest('.mini-product-feature-v2__card');
              const $desc = $card.find('.mini-product-feature-v2__card-desc');
              this.$dialog.attr({
                'data-title': $card.find('.mini-product-feature-v2__card-title').text(),
                'data-desc': $desc.html() || '',
                'data-img': $card.attr('data-dialog-img') || '',
                'data-button-text': $card.attr('data-button-text') || '',
                'data-button-link': $card.attr('data-button-link') || '',
              });
              /* 内容更新后再打开，确保触发 disableScroll */
              this.$dialog.attr('data-show', 'true');
            };
            this._$expandButtons = $(this).find('[data-expand]');
            this._$expandButtons.on('click', this._onExpandClick);

            this._swiperEl = this.querySelector('.mini-product-feature-v2__swiper');
            if (!this._swiperEl || typeof Swiper === 'undefined') return;

            const slideCount = this.querySelectorAll(
              '.mini-product-feature-v2__swiper > .swiper-wrapper > .mini-product-feature-v2__slide'
            ).length;

            if (slideCount <= 1) {
              const controls = this.querySelector('.mini-product-feature-v2__controls');
              if (controls) controls.style.display = 'none';
            }

            this._onResize = () => {
              clearTimeout(this._resizeTimer);
              this._resizeTimer = setTimeout(() => {
                this._applySlideOffset();
                this._equalizeCardHeights();
              }, 150);
            };
            window.addEventListener('resize', this._onResize, { passive: true });

            this._bindCardImageLoad();

            this._swiper = new Swiper(this._swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              centeredSlides: false,
              loop: false,
              watchOverflow: true,
              slidesOffsetBefore: this._getSlideOffsetBefore(),
              slidesOffsetAfter: this._getSlideOffsetAfter(),
              navigation: {
                prevEl: this.querySelector('.mini-product-feature-v2__nav-btn--prev'),
                nextEl: this.querySelector('.mini-product-feature-v2__nav-btn--next'),
              },
              breakpoints: {
                577: {
                  slidesPerView: 'auto',
                  spaceBetween: 16,
                },
                961: {
                  slidesPerView: 'auto',
                  spaceBetween: 16,
                },
                1200: {
                  slidesPerView: 'auto',
                  spaceBetween: 24,
                },
              },
              on: {
                init: (swiper) => {
                  this._applySlideOffset(swiper);
                  this._equalizeCardHeights();
                },
                resize: (swiper) => {
                  this._applySlideOffset(swiper);
                  this._equalizeCardHeights();
                },
                breakpoint: (swiper) => {
                  this._applySlideOffset(swiper);
                  this._equalizeCardHeights();
                },
              },
            });
          }

          _isCompactLayout() {
            return window.matchMedia('(max-width: 1200px)').matches;
          }

          _bindCardImageLoad() {
            this.querySelectorAll('.mini-product-feature-v2__card-media img').forEach((img) => {
              if (img.complete) return;
              img.addEventListener('load', () => this._equalizeCardHeights(), { once: true });
            });
          }

          _equalizeCardHeights() {
            const cards = this.querySelectorAll('.mini-product-feature-v2__card');
            const slides = this.querySelectorAll('.mini-product-feature-v2__slide');

            cards.forEach((card) => {
              card.style.minHeight = '';
            });
            slides.forEach((slide) => {
              slide.style.height = '';
            });

            if (!this._isCompactLayout() || !cards.length) return;

            let maxHeight = 0;
            cards.forEach((card) => {
              maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
            });

            if (maxHeight <= 0) return;

            const heightPx = `${Math.ceil(maxHeight)}px`;
            cards.forEach((card) => {
              card.style.minHeight = heightPx;
            });
            slides.forEach((slide) => {
              slide.style.height = heightPx;
            });
          }

          _getSlideOffsetBefore() {
            const width = window.innerWidth;
            if (width <= 576) return 0;
            if (width <= 1200) return 24;
            return Math.max(24, (width - 1200) / 2 + 24);
          }

          _getSlideOffsetAfter() {
            const width = window.innerWidth;
            if (width <= 576) return 16;
            if (width <= 1200) return 24;
            return Math.max(24, (width - 1200) / 2 + 24);
          }

          _applySlideOffset(swiper = this._swiper) {
            if (!swiper) return;
            const offsetBefore = this._getSlideOffsetBefore();
            const offsetAfter = this._getSlideOffsetAfter();
            if (swiper.params.slidesOffsetBefore === offsetBefore && swiper.params.slidesOffsetAfter === offsetAfter) {
              return;
            }
            swiper.params.slidesOffsetBefore = offsetBefore;
            swiper.params.slidesOffsetAfter = offsetAfter;
            swiper.update();
          }

          disconnectedCallback() {
            window.removeEventListener('resize', this._onResize);
            if (this._resizeTimer) {
              clearTimeout(this._resizeTimer);
              this._resizeTimer = null;
            }
            if (this._swiper) {
              this._swiper.destroy(true, true);
              this._swiper = null;
            }
            if (this._$expandButtons) {
              this._$expandButtons.off('click', this._onExpandClick);
              this._$expandButtons = null;
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-product-intro-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mini-product-intro-v2')) {
    customElements.define(
      'mini-product-intro-v2',
      class MiniProductIntroV2 extends HTMLElement {
        static _popupScriptPromise = null;

        constructor() {
          super();
          this.swiper = null;
          this._swiperMq = null;
          this._onSwiperMqChange = null;
        }

        connectedCallback() {
          this.initSwiper();
        }

        disconnectedCallback() {
          this.destroySwiper();
          if (this._swiperMq && this._onSwiperMqChange) {
            this._swiperMq.removeEventListener('change', this._onSwiperMqChange);
          }
        }

        initSwiper() {
          const swiperEl = this.querySelector('.mini-product-intro-v2__swiper');
          if (!swiperEl) return;

          this._swiperMq = window.matchMedia('(min-width: 961px)');
          this._onSwiperMqChange = () => this.toggleSwiper(swiperEl);
          this._swiperMq.addEventListener('change', this._onSwiperMqChange);
          this.toggleSwiper(swiperEl);
        }

        toggleSwiper(swiperEl) {
          if (!this._swiperMq?.matches) {
            this.destroySwiper();
            return;
          }

          if (this.swiper) return;

          this.swiper = new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            watchOverflow: true,
          });
        }

        destroySwiper() {
          if (!this.swiper) return;
          this.swiper.destroy(true, true);
          this.swiper = null;
        }

        openProductDetailModal(element, inventoryPolicy, view) {
          const productHandle = element?.dataset?.productHandle;
          if (!productHandle) {
            console.error('mini-product-intro-v2: missing product handle');
            return;
          }

          if (window.litime?.disableScroll) window.litime.disableScroll();
          if (window.litime?.showLoading) window.litime.showLoading(false);

          if (
            window.litime.tryOpenProductModalV2?.(productHandle, undefined, {
              onBefore: () => window.litime.showLoading(false),
              onFinally: () => window.litime.hideLoading(false),
            })
          ) {
            return;
          }

          this.ensureProductDetailPopupScript()
            .then(() =>
              fetch(`/products/${productHandle}?view=modal`).then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text();
              })
            )
            .then((html) => this.renderProductDetailModal(html, inventoryPolicy, view))
            .catch((error) => {
              console.error('mini-product-intro-v2: open modal failed', error);
              window.litime?.enableScroll?.();
            })
            .finally(() => {
              if (window.litime?.hideLoading) window.litime.hideLoading(false);
            });
        }

        ensureProductDetailPopupScript() {
          if (window.customElements?.get('product-detail-data-popup')) {
            return Promise.resolve();
          }

          const scriptUrl = this.dataset.productDetailPopupScript;
          if (!scriptUrl) {
            return Promise.reject(new Error('mini-product-intro-v2: missing popup script url'));
          }

          if (MiniProductIntroV2._popupScriptPromise) {
            return MiniProductIntroV2._popupScriptPromise;
          }

          MiniProductIntroV2._popupScriptPromise = new Promise((resolve, reject) => {
            const existingScript = document.querySelector('script[data-product-detail-popup-script]');
            if (existingScript) {
              if (window.customElements?.get('product-detail-data-popup')) {
                resolve();
                return;
              }

              existingScript.addEventListener('load', () => resolve(), { once: true });
              existingScript.addEventListener(
                'error',
                () => reject(new Error('mini-product-intro-v2: popup script load failed')),
                { once: true }
              );
              return;
            }

            const script = document.createElement('script');
            script.src = scriptUrl;
            script.dataset.productDetailPopupScript = 'true';
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('mini-product-intro-v2: popup script load failed'));
            document.head.appendChild(script);
          });

          return MiniProductIntroV2._popupScriptPromise;
        }

        initProductDetailPopup(popupEl) {
          if (!popupEl) return;

          window.customElements?.upgrade(popupEl);

          try {
            if (popupEl.applyPreferentialMode) {
              popupEl.applyPreferentialMode();
            }
          } catch (error) {
            console.warn('mini-product-intro-v2: applyPreferentialMode failed', error);
          }

          if (typeof popupEl.init === 'function') {
            popupEl.init();
            popupEl.initBuyNowButton?.();
            popupEl.initDefaultData?.();
          }
        }

        renderProductDetailModal(html, inventoryPolicy, view) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('script').forEach((script) => {
            script.textContent = '';
          });
          const quickshopPopup = doc.getElementById('quickshop-popup')?.innerHTML;
          const popupRoot = document.getElementById('global-product-card-popup');
          if (!popupRoot || !quickshopPopup) return;

          popupRoot.innerHTML = quickshopPopup;

          this.initProductDetailPopup(popupRoot.querySelector('product-detail-data-popup'));

          const modalWrapper = popupRoot.querySelector('.product-detail-modal_wrapper');
          if (!modalWrapper) return;

          const isPreorder = inventoryPolicy === 'continue' && view === 'buy_now_to_cart';

          const preOrderButton = modalWrapper.querySelector(
            '.product-detail-popup_button .buy-now-btn-card-button-popup'
          );
          const preOrderSubmit = modalWrapper.querySelector(
            '.product-detail-popup_form_wrapper .buy-now-btn-card-submit-button'
          );

          if (isPreorder) {
            if (preOrderButton) {
              preOrderButton.classList.remove('hidden');
              preOrderButton.classList.add('flex');
            }
            if (preOrderSubmit) {
              preOrderSubmit.classList.add('hidden');
              preOrderSubmit.classList.remove('flex');
            }
          } else {
            if (preOrderButton) {
              preOrderButton.classList.add('hidden');
              preOrderButton.classList.remove('flex');
            }
            if (preOrderSubmit) {
              preOrderSubmit.classList.remove('hidden');
              preOrderSubmit.classList.add('flex');
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-scroll-story-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('mini-scroll-story-v2')) {
      customElements.define(
        'mini-scroll-story-v2',
        class MiniScrollStory extends HTMLElement {
          static SPRITE_FRAME_COUNT = 50;
          static SPRITE_WIDTH = 1760;
          static SPRITE_HEIGHT = 1360;
          static TEXT_ENTER_OFFSET = 80;
          static TEXT_SLIDE_OFFSET = 80;
          /** 每段：展示(hold) + 切换(switch)，合计 1.0 timeline 单位（原 2.0 偏长） */
          static SEGMENT_HOLD = 0.5;
          static SEGMENT_SWITCH = 0.5;
          /** 渐暗峰值，仅由 __dim 控制 */
          static DIM_MAX_OPACITY = 0.7;
          /** hold 段进度到此值后开始渐暗（与文案上滑同步） */
          static DIM_HOLD_LEAD = 0.45;
          static STACK_MQ = '(max-width: 960px)';

          static get SEGMENT_TOTAL() {
            return MiniScrollStory.SEGMENT_HOLD + MiniScrollStory.SEGMENT_SWITCH;
          }

          _segmentStart(index) {
            return index * MiniScrollStory.SEGMENT_TOTAL;
          }

          _segmentSwitchStart(index) {
            return this._segmentStart(index) + MiniScrollStory.SEGMENT_HOLD;
          }

          _segmentSwitchEnd(index) {
            return this._segmentStart(index) + MiniScrollStory.SEGMENT_TOTAL;
          }

          _totalTimeline(sceneCount) {
            if (sceneCount <= 1) return MiniScrollStory.SEGMENT_HOLD;
            return (sceneCount - 1) * MiniScrollStory.SEGMENT_TOTAL;
          }

          connectedCallback() {
            this._stage = this.querySelector('[data-stage]');
            this._sticky = this.querySelector('.mini-scroll-story-v2__sticky');
            this._dimOverlay = this.querySelector('[data-dim-overlay]');
            this._textSlot = this.querySelector('[data-text-slot]');
            this._textItems = Array.from(this.querySelectorAll('[data-text-item]'));
            this._scenes = Array.from(this.querySelectorAll('[data-image-scene]'));
            if (!this._stage || this._scenes.length === 0) return;

            this._sceneCount = this._scenes.length;
            this._spriteCache = new Map();
            this._onScroll = this._handleScroll.bind(this);
            this._onResize = this._handleResize.bind(this);
            this._mqStack = window.matchMedia(MiniScrollStory.STACK_MQ);
            this._onStackMqChange = this._handleStackMqChange.bind(this);

            this._mqStack.addEventListener('change', this._onStackMqChange);

            if (!this._isStackMode()) {
              window.addEventListener('scroll', this._onScroll, { passive: true });
            }
            window.addEventListener('resize', this._onResize, { passive: true });

            this._measureTextLayout();
            this._initSpriteObserver();
            if (!this._isStackMode()) {
              this._handleScroll();
            }
          }

          disconnectedCallback() {
            window.removeEventListener('scroll', this._onScroll);
            window.removeEventListener('resize', this._onResize);
            if (this._mqStack) {
              this._mqStack.removeEventListener('change', this._onStackMqChange);
            }
            if (this._spriteObserver) {
              this._spriteObserver.disconnect();
              this._spriteObserver = null;
            }
          }

          _isStackMode() {
            return this._mqStack?.matches ?? window.matchMedia(MiniScrollStory.STACK_MQ).matches;
          }

          _handleStackMqChange() {
            if (this._isStackMode()) {
              window.removeEventListener('scroll', this._onScroll);
            } else {
              window.addEventListener('scroll', this._onScroll, { passive: true });
              this._measureTextLayout();
              this._handleScroll();
            }
          }

          _handleResize() {
            if (this._isStackMode()) return;
            this._measureTextLayout();
            this._handleScroll();
          }

          /**
           * 槽位高度取最大段高；离场距离取视口高，确保文案划出 sticky 外侧。
           */
          _measureTextLayout() {
            if (!this._textSlot || this._textItems.length === 0) return;

            let maxHeight = 0;
            this._textItems.forEach((item) => {
              maxHeight = Math.max(maxHeight, item.offsetHeight);
            });

            this._textSlot.style.minHeight = `${maxHeight}px`;

            const slotHeight = this._textSlot.offsetHeight;
            this._textSlideDistance = Math.max(slotHeight * 0.55, window.innerHeight * 0.28);
          }

          _setLeftSlotState(translateY) {
            if (!this._textSlot) return;
            if (translateY === 0) {
              this._textSlot.style.removeProperty('transform');
            } else {
              this._textSlot.style.transform = `translateY(${translateY}px)`;
            }
          }

          _getCoupledTransition(timeline, segmentIndex, sceneCount) {
            if (segmentIndex >= sceneCount - 1) return null;

            const segmentStart = this._segmentStart(segmentIndex);
            const switchEnd = this._segmentSwitchEnd(segmentIndex);
            const transitionStart = segmentStart + MiniScrollStory.SEGMENT_HOLD * MiniScrollStory.DIM_HOLD_LEAD;

            if (timeline < transitionStart || timeline >= switchEnd) return null;

            const span = switchEnd - transitionStart;
            if (span <= 0) return null;

            return {
              fromIndex: segmentIndex,
              t: this._clamp((timeline - transitionStart) / span, 0, 1),
            };
          }

          /**
           * 左侧文案区随遮罩上滑滚出；右侧图片保持不动，仅在切换点换图。
           */
          _setCoupledTransition(fromIndex, progress) {
            const t = this._clamp(progress, 0, 1);
            const dim = Math.sin(t * Math.PI);
            const slideDistance = this._textSlideDistance || window.innerHeight * 0.28;

            this._setDimOverlay(dim);

            if (t < 0.5) {
              const exitP = t / 0.5;
              this._setLeftSlotState(-slideDistance * exitP);
              this._setTextHold(fromIndex);
              this._showImageScene(fromIndex);
              return;
            }

            const enterP = (t - 0.5) / 0.5;
            this._setLeftSlotState(slideDistance * (1 - enterP));
            this._setTextHold(fromIndex + 1);
            this._showImageScene(fromIndex + 1);
          }

          _setTextItemState(item, opacity, translateY) {
            const visible = opacity > 0.01;
            item.style.opacity = String(opacity);
            item.style.visibility = visible ? 'visible' : 'hidden';
            item.style.transform = `translateY(${translateY}px)`;
            item.setAttribute('data-active', visible ? 'true' : 'false');
          }

          /** 单段展示：当前文案居中，其余离场/待命 */
          _setTextHold(index) {
            const slide = MiniScrollStory.TEXT_SLIDE_OFFSET;
            const enter = MiniScrollStory.TEXT_ENTER_OFFSET;

            this._textItems.forEach((item, idx) => {
              if (idx === index) {
                this._setTextItemState(item, 1, 0);
              } else if (idx < index) {
                this._setTextItemState(item, 0, -slide);
              } else {
                this._setTextItemState(item, 0, enter);
              }
            });
          }

          _getScrollProgress() {
            const rect = this._stage.getBoundingClientRect();
            const scrollable = this._stage.offsetHeight - window.innerHeight;
            if (scrollable <= 0) return 0;

            const scrolled = Math.min(Math.max(-rect.top, 0), scrollable);
            return scrolled / scrollable;
          }

          _clamp(value, min, max) {
            return Math.min(max, Math.max(min, value));
          }

          _easePower3(t) {
            return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          }

          _setDimOverlay(progress) {
            if (!this._dimOverlay) return;
            const scaled = this._clamp(progress, 0, 1) * MiniScrollStory.DIM_MAX_OPACITY;
            this._dimOverlay.style.opacity = String(scaled);
          }

          /** image-scene 只做显示/隐藏，不做透明度渐暗 */
          _setImageSceneActive(scene, active) {
            scene.setAttribute('data-active', active ? 'true' : 'false');
            scene.style.removeProperty('opacity');
          }

          _hideAllImageScenes() {
            this._scenes.forEach((scene) => {
              this._setImageSceneActive(scene, false);
            });
          }

          _showImageScene(index) {
            this._hideAllImageScenes();
            const scene = this._scenes[index];
            if (scene) {
              this._setImageSceneActive(scene, true);
            }
          }

          _drawSpriteFrame(scene, frameIndex) {
            const cache = this._spriteCache.get(scene);
            if (!cache?.ready || !cache.frames?.length) return;

            const canvas = scene.querySelector('[data-sprite-canvas]');
            if (!canvas) return;

            const ctx = canvas.getContext('2d');
            const index = Math.min(cache.frames.length - 1, Math.max(0, frameIndex));
            const frame = cache.frames[index];
            if (!ctx || !frame) return;

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(frame, 0, 0, canvas.width, canvas.height);
          }

          _preloadSprites(scene) {
            if (scene.getAttribute('data-sprite-enabled') !== 'true') return Promise.resolve();
            if (this._spriteCache.get(scene)?.ready) return Promise.resolve();

            const pattern = scene.getAttribute('data-sprite-pattern');
            const count = MiniScrollStory.SPRITE_FRAME_COUNT;
            if (!pattern) return Promise.resolve();

            const frames = [];
            let loaded = 0;

            return new Promise((resolve, reject) => {
              for (let i = 0; i < count; i += 1) {
                const img = new Image();
                const index = String(i).padStart(2, '0');
                img.src = pattern.replace(/\{index\}/g, index);
                img.onload = () => {
                  loaded += 1;
                  if (loaded >= count) {
                    this._spriteCache.set(scene, { ready: true, frames });
                    this._drawSpriteFrame(scene, 0);
                    resolve();
                  }
                };
                img.onerror = reject;
                frames[i] = img;
              }
            }).catch((error) => {
              console.error('[mini-scroll-story-v2] sprite preload failed', error);
            });
          }

          _initSpriteObserver() {
            if (this._isStackMode()) return;

            if (typeof IntersectionObserver === 'undefined') {
              this._scenes.forEach((scene) => this._preloadSprites(scene));
              return;
            }

            this._spriteObserver = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    this._preloadSprites(entry.target);
                  }
                });
              },
              { rootMargin: '500px 0px 0px 0px' }
            );

            this._scenes.forEach((scene) => {
              if (scene.getAttribute('data-sprite-enabled') === 'true') {
                this._spriteObserver.observe(scene);
              }
            });
          }

          /**
           * 场景子效果：仅序列帧，渐暗/遮罩不作用在 image-scene 上
           */
          _applySceneSubEffects(scene, phaseProgress) {
            const spriteEnabled = scene.getAttribute('data-sprite-enabled') === 'true';

            if (spriteEnabled) {
              const frameProgress = this._clamp(phaseProgress * 2, 0, 1);
              const frameIndex = Math.floor(frameProgress * (MiniScrollStory.SPRITE_FRAME_COUNT - 1));
              this._drawSpriteFrame(scene, frameIndex);
            }
          }

          _applyTimeline(progress) {
            const sceneCount = this._sceneCount;

            if (sceneCount === 1) {
              const scene = this._scenes[0];
              const timeline = progress * MiniScrollStory.SEGMENT_HOLD;
              this._setLeftSlotState(0);
              this._setTextHold(0);
              this._setDimOverlay(0);
              this._showImageScene(0);
              this._applySceneSubEffects(scene, this._clamp(timeline / MiniScrollStory.SEGMENT_HOLD, 0, 1));
              return;
            }

            const totalTimeline = this._totalTimeline(sceneCount);
            const timeline = progress * totalTimeline;

            for (let i = 0; i < sceneCount - 1; i += 1) {
              const coupled = this._getCoupledTransition(timeline, i, sceneCount);
              if (coupled) {
                this._setCoupledTransition(coupled.fromIndex, coupled.t);
                return;
              }
            }

            for (let i = 0; i < sceneCount; i += 1) {
              const scene = this._scenes[i];
              const segmentStart = this._segmentStart(i);
              const switchStart = this._segmentSwitchStart(i);

              if (i < sceneCount - 1 && timeline >= segmentStart && timeline < switchStart) {
                this._setLeftSlotState(0);
                this._setTextHold(i);
                this._setDimOverlay(0);
                this._showImageScene(i);
                const holdSpan = MiniScrollStory.SEGMENT_HOLD;
                const phaseProgress = this._clamp((timeline - segmentStart) / holdSpan, 0, 1);
                this._applySceneSubEffects(scene, phaseProgress);
                return;
              }

              if (i === sceneCount - 1 && timeline >= segmentStart) {
                this._setLeftSlotState(0);
                this._setTextHold(i);
                this._setDimOverlay(0);
                this._showImageScene(i);
                const holdSpan = MiniScrollStory.SEGMENT_HOLD;
                const phaseProgress = this._clamp((timeline - segmentStart) / holdSpan, 0, 1);
                this._applySceneSubEffects(scene, phaseProgress);
                return;
              }
            }

            if (timeline <= 0) {
              this._setLeftSlotState(0);
              this._setTextHold(0);
              this._setDimOverlay(0);
              this._showImageScene(0);
              return;
            }

            this._setLeftSlotState(0);
            this._setTextHold(sceneCount - 1);
            this._setDimOverlay(0);
            this._showImageScene(sceneCount - 1);
          }

          _handleScroll() {
            if (this._isStackMode()) return;
            if (this._scrollRaf) return;
            this._scrollRaf = requestAnimationFrame(() => {
              this._applyTimeline(this._getScrollProgress());
              this._scrollRaf = null;
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-series-evolution-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mini-series-evolution-v2')) {
    customElements.define('mini-series-evolution-v2', class MiniSeriesEvolutionV2 extends HTMLElement {});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-video-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('mini-video-v2')) {
      customElements.define(
        'mini-video-v2',
        class MiniVideo extends HTMLElement {
          static PROGRESS_RADIUS = 17;
          static PROGRESS_CIRCUMFERENCE = 2 * Math.PI * MiniVideo.PROGRESS_RADIUS;

          connectedCallback() {
            this._video = this.querySelector('.mini-video-v2__video');
            this._toggleBtn = this.querySelector('[data-toggle]');
            this._progressFill = this.querySelector('[data-progress-fill]');

            if (!this._video) return;

            this._userPaused = false;
            this._onToggle = this._handleToggle.bind(this);
            this._onTimeUpdate = this._updateProgress.bind(this);
            this._onLoadedMetadata = this._updateProgress.bind(this);
            this._onPlay = this._syncToggleState.bind(this);
            this._onPause = this._syncToggleState.bind(this);

            if (this._toggleBtn) {
              customEventListener(this._toggleBtn, 'click', this._onToggle);
            }

            this._video.addEventListener('timeupdate', this._onTimeUpdate);
            this._video.addEventListener('loadedmetadata', this._onLoadedMetadata);
            this._video.addEventListener('play', this._onPlay);
            this._video.addEventListener('pause', this._onPause);

            this._initProgressRing();
            this._initVisibilityObserver();
            this._tryAutoplay();
          }

          disconnectedCallback() {
            if (this._video) {
              this._video.removeEventListener('timeupdate', this._onTimeUpdate);
              this._video.removeEventListener('loadedmetadata', this._onLoadedMetadata);
              this._video.removeEventListener('play', this._onPlay);
              this._video.removeEventListener('pause', this._onPause);
            }
            if (this._visibilityObserver) {
              this._visibilityObserver.disconnect();
              this._visibilityObserver = null;
            }
          }

          _initProgressRing() {
            if (!this._progressFill) return;

            const circumference = MiniVideo.PROGRESS_CIRCUMFERENCE;
            this._progressFill.style.strokeDasharray = `${circumference}`;
            this._progressFill.style.strokeDashoffset = `${circumference}`;
          }

          _initVisibilityObserver() {
            this._visibilityObserver = new IntersectionObserver(
              (entries) => {
                if (!this._video) return;

                const isVisible = entries.some((entry) => entry.isIntersecting);
                if (!isVisible) {
                  this._video.pause();
                  return;
                }

                if (!this._userPaused) {
                  this._video.play().catch(() => {});
                }
              },
              {
                threshold: 0.35,
              }
            );

            this._visibilityObserver.observe(this);
          }

          _tryAutoplay() {
            if (!this._video) return;
            this._video.play().catch(() => {});
          }

          _handleToggle() {
            if (!this._video) return;

            if (this._video.paused) {
              this._userPaused = false;
              this._video.play().catch(() => {});
            } else {
              this._userPaused = true;
              this._video.pause();
            }
          }

          _syncToggleState() {
            if (!this._toggleBtn || !this._video) return;

            const isPlaying = !this._video.paused;
            this._toggleBtn.setAttribute('data-playing', isPlaying ? 'true' : 'false');
            this._toggleBtn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
          }

          _updateProgress() {
            if (!this._progressFill || !this._video) return;

            const duration = this._video.duration;
            if (!duration || !Number.isFinite(duration)) return;

            const progress = Math.min(1, Math.max(0, this._video.currentTime / duration));
            const offset = MiniVideo.PROGRESS_CIRCUMFERENCE * (1 - progress);
            this._progressFill.style.strokeDashoffset = `${offset}`;
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-benefits-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('partners-benefits-v2')) {
    class PartnersBenefitsV2 extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this._modal = this.querySelector('partners-benefits-v2-modal');
        this._openBtn = this.querySelector('[data-open-benefits-modal]');
        this._onOpen = this._onOpen.bind(this);
        this._onClose = this._onClose.bind(this);
        this._onKeydown = this._onKeydown.bind(this);

        if (this._openBtn) {
          this._openBtn.addEventListener('click', this._onOpen);
        }
        this.querySelectorAll('[data-modal-close]').forEach((el) => {
          el.addEventListener('click', this._onClose);
        });
      }

      _onOpen() {
        if (!this._modal) return;
        this._modal.setAttribute('data-show', 'true');
        document.addEventListener('keydown', this._onKeydown);
        this._setupModalStickyHead();
        if (window.litime && typeof window.litime.disableScroll === 'function') {
          window.litime.disableScroll();
        }
      }

      _onClose() {
        if (!this._modal) return;
        this._modal.setAttribute('data-show', 'false');
        document.removeEventListener('keydown', this._onKeydown);
        this._teardownModalStickyHead();
        if (window.litime && typeof window.litime.enableScroll === 'function') {
          window.litime.enableScroll();
        }
      }

      _setupModalStickyHead() {
        if (!this._modal) return;
        this._teardownModalStickyHead();

        const scroller = this._modal.querySelector('.partners-benefits-v2-modal__body');
        const head = this._modal.querySelector('.partners-benefits-v2-table__head');
        if (!scroller || !head) return;

        scroller.scrollTop = 0;
        head.setAttribute('data-stuck', 'false');

        this._modalTableScroller = scroller;
        this._updateModalStickyHead = () => {
          head.setAttribute('data-stuck', scroller.scrollTop > 0 ? 'true' : 'false');
        };

        scroller.addEventListener('scroll', this._updateModalStickyHead, { passive: true });
        this._updateModalStickyHead();
      }

      _teardownModalStickyHead() {
        if (this._modalTableScroller && this._updateModalStickyHead) {
          this._modalTableScroller.removeEventListener('scroll', this._updateModalStickyHead);
        }
        this._modalTableScroller = null;
        this._updateModalStickyHead = null;
        const head = this._modal?.querySelector('.partners-benefits-v2-table__head');
        head?.setAttribute('data-stuck', 'false');
      }

      _onKeydown(event) {
        if (event.key === 'Escape') this._onClose();
      }
    }
    customElements.define('partners-benefits-v2', PartnersBenefitsV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-hub-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('partners-hub-v2')) {
      customElements.define(
        'partners-hub-v2',
        class PartnersHubV2 extends HTMLElement {
          constructor() {
            super();
            this.stores = [];
            this.state = {
              view: 'list',
              search: '',
              countries: [],
              applications: [],
              page: 1,
              pageSize: 6,
              totalList: [],
              pageList: [],
            };
            this.map = null;
            this.mapPopup = null;
            this.storeMarkers = new Map();
            this.mapLibreLoading = null;
            this.mapHandlersBound = false;
            this.mapLoadToken = 0;
            this._draft = null;
          }

          async fetchStores() {
            const res = await window.litime.http.get(
              '/shopify-form/records/certified_store',
              {
                headers: { brand: 'LiTime' },
              },
              'business-api'
            );

            if (res?.code !== 200 || !Array.isArray(res.data)) {
              throw new Error(res?.message || 'Failed to load certified stores');
            }

            return res.data.map((item) => this.normalizeStore(item));
          }

          normalizeStore(item) {
            const latitude = parseFloat(item.latitude);
            const longitude = parseFloat(item.longitude);

            return {
              id: String(item.id),
              cert_id: item.cert_id || '',
              name: item.name || '',
              cover_image: item.cover_image || '',
              full_address: item.full_address || '',
              latitude: Number.isFinite(latitude) ? latitude : NaN,
              longitude: Number.isFinite(longitude) ? longitude : NaN,
              country: item.country || '',
              applications: (item.applications || '')
                .split(',')
                .map((app) => app.trim())
                .filter(Boolean),
              phone: item.phone || '',
              website: item.website || '',
            };
          }

          async connectedCallback() {
            this.cacheEls();
            this.bindEvents();
            this.mountSearchRoots();
            this.setListLoading(true);

            try {
              this.stores = await this.fetchStores();
            } catch (error) {
              console.warn('[partners-hub-v2] fetch stores failed', error);
              this.stores = [];
            }

            this.mountFilterRoots();
            this.applyFilters();
            this.setListLoading(false);
          }

          disconnectedCallback() {
            if (this.getAttribute('data-filter-open') === 'true') {
              window.litime?.enableScroll?.();
            }
            this.destroyMap();
            if (this._onResize) window.removeEventListener('resize', this._onResize);
          }

          cacheEls() {
            this.gridEl = this.querySelector('[data-grid]');
            this.paginationEl = this.querySelector('[data-pagination]');
            this.mapEl = this.querySelector('[data-map]');
          }

          bindEvents() {
            this.addEventListener('click', (e) => {
              const tab = e.target.closest('.partners-hub-v2__tab');
              if (tab) {
                this.setView(tab.getAttribute('data-view'));
                return;
              }
              if (e.target.closest('[data-open-filter]')) {
                this.openFilterDialog();
                return;
              }
              if (e.target.closest('[data-close-filter]')) {
                this.closeFilterDialog();
                return;
              }
              if (e.target.closest('[data-reset-filter]')) {
                this.resetFilters(true);
                return;
              }
              if (e.target.closest('[data-apply-filter]')) {
                this.applyDraftFilters();
                return;
              }
              const groupHead = e.target.closest('.partners-hub-v2__filter-group-head');
              if (groupHead) {
                e.preventDefault();
                const group = groupHead.closest('.partners-hub-v2__filter-group');
                if (group) {
                  const expanded = group.getAttribute('data-expanded') !== 'true';
                  group.setAttribute('data-expanded', expanded ? 'true' : 'false');
                }
                return;
              }
              const pageBtn = e.target.closest('[data-page]');
              if (pageBtn && pageBtn.getAttribute('data-disabled') !== 'true') {
                const page = parseInt(pageBtn.getAttribute('data-page'), 10);
                if (!isNaN(page) && page !== this.state.page) {
                  this.state.page = page;
                  this.applyPagination();
                  this.scrollListIntoView();
                }
              }
            });

            this.addEventListener('change', (e) => {
              const option = e.target.closest('.partners-hub-v2__filter-option input');
              if (!option) return;
              const root = option.closest('[data-filter-root]');
              const isDialog = root && root.getAttribute('data-filter-root') === 'dialog';
              const type = option.getAttribute('data-type');
              const value = option.value;
              const checked = option.checked;
              const target = isDialog ? this._draft : this.state;
              if (!target[type]) target[type] = [];
              if (checked) {
                if (!target[type].includes(value)) target[type].push(value);
              } else {
                target[type] = target[type].filter((v) => v !== value);
              }
              if (!isDialog) {
                this.state.page = 1;
                this.applyFilters();
              } else {
                this.syncFilterCounts();
              }
            });

            this.addEventListener('input', (e) => {
              const input = e.target.closest('.partners-hub-v2__search-input');
              if (!input) return;
              this.state.search = input.value.trim();
              this.state.page = 1;
              this.syncSearchInputs();
              this.applyFilters();
            });

            this._onResize = () => {
              if (this.state.view === 'map' && this.map) this.map.resize();
              this.applyPagination();
            };
            window.addEventListener('resize', this._onResize);
          }

          isMobile() {
            return window.matchMedia('(max-width: 576px)').matches;
          }

          setListLoading(loading) {
            this.setAttribute('data-list-loading', loading ? 'true' : 'false');
          }

          setMapLoading(loading) {
            this.setAttribute('data-map-loading', loading ? 'true' : 'false');
          }

          waitMapIdle() {
            if (!this.map) return Promise.resolve();
            return new Promise((resolve) => {
              let settled = false;
              const finish = () => {
                if (settled) return;
                settled = true;
                resolve();
              };
              this.map.once('idle', finish);
              setTimeout(finish, 800);
            });
          }

          async prepareMapView() {
            const token = ++this.mapLoadToken;
            const isFirstLoad = !this.map;
            if (isFirstLoad) this.setMapLoading(true);
            try {
              await this.renderMapMarkers({ animate: !isFirstLoad });
              if (isFirstLoad) await this.waitMapIdle();
            } catch (err) {
              console.warn('[partners-hub-v2] map prepare failed', err);
            } finally {
              if (token === this.mapLoadToken) this.setMapLoading(false);
            }
          }

          setView(view) {
            const nextView = view === 'map' ? 'map' : 'list';
            const viewChanged = nextView !== this.state.view;
            this.state.view = nextView;
            this.setAttribute('data-view', this.state.view);
            this.querySelectorAll('.partners-hub-v2__tab').forEach((tab) => {
              tab.setAttribute('data-active', tab.getAttribute('data-view') === this.state.view ? 'true' : 'false');
            });
            this.querySelectorAll('.partners-hub-v2__view').forEach((panel) => {
              panel.setAttribute('data-active', panel.getAttribute('data-view') === this.state.view ? 'true' : 'false');
            });
            if (viewChanged) {
              this.state.search = '';
              this.state.countries = [];
              this.state.applications = [];
              this.state.page = 1;
              this._draft = null;
              this.syncSearchInputs();
              this.applyFilters({ skipMap: true });
            }
            if (this.state.view === 'map') {
              requestAnimationFrame(() => {
                this.prepareMapView();
              });
            } else {
              this.mapLoadToken += 1;
              this.setMapLoading(false);
            }
          }

          mountSearchRoots() {
            const html = this.renderSearchHtml();
            this.querySelectorAll('[data-search-root]').forEach((el) => {
              el.innerHTML = html;
            });
          }

          icon(name) {
            return this.getAttribute(`data-icon-${name}`) || '';
          }

          getInlineIconMarkup(name) {
            const tpl = this.querySelector(`.partners-hub-v2__icon-template[data-icon="${name}"]`);
            return tpl ? tpl.innerHTML.trim() : '';
          }

          label(key, fallback = '') {
            return this.getAttribute(`data-label-${key}`) || fallback;
          }

          renderSearchHtml() {
            const searchIcon = this.getInlineIconMarkup('search');
            return `
            <div class="partners-hub-v2__search-box">
              ${searchIcon}
              <input class="partners-hub-v2__search-input" type="text" placeholder="${this.escapeAttr(
                this.label('search-placeholder', 'Search name or Cert. ID')
              )}" value="${this.escapeAttr(this.state.search)}" />
            </div>
          `;
          }

          syncSearchInputs() {
            this.querySelectorAll('.partners-hub-v2__search-input').forEach((input) => {
              if (input !== document.activeElement) input.value = this.state.search;
            });
          }

          mountFilterRoots() {
            const sidebar = this.querySelector('[data-filter-root="sidebar"]');
            const dialog = this.querySelector('[data-filter-root="dialog"]');
            if (sidebar) sidebar.innerHTML = this.renderFilterPanelHtml(false);
            if (dialog) dialog.innerHTML = this.renderFilterPanelHtml(true);
            this.syncFilterUI();
          }

          getFacetCounts(list) {
            const countries = {};
            const applications = {};
            list.forEach((store) => {
              countries[store.country] = (countries[store.country] || 0) + 1;
              (store.applications || []).forEach((app) => {
                applications[app] = (applications[app] || 0) + 1;
              });
            });
            return { countries, applications };
          }

          renderFilterPanelHtml(hideSearchTitle) {
            const facets = this.getFacetCounts(this.stores);
            const countryKeys = Object.keys(facets.countries).sort();
            const appKeys = Object.keys(facets.applications).sort();
            const searchIcon = this.getInlineIconMarkup('search');
            const findShop = this.escapeHtml(this.label('find-shop', 'Find a Shop'));
            const searchPlaceholder = this.escapeAttr(this.label('search-placeholder', 'Search name or Cert. ID'));
            const filterLabel = this.escapeHtml(this.label('filter', 'Filter'));
            const resetLabel = this.escapeHtml(this.label('reset', 'Reset'));
            const countryLabel = this.escapeHtml(this.label('country', 'Country'));
            const applicationsLabel = this.escapeHtml(this.label('applications', 'Applications'));
            const groupToggle = `
              <div class="partners-hub-v2__filter-group-toggle">
                <i class="partners-hub-v2__filter-group-toggle-plus">${this.getInlineIconMarkup('plus-small')}</i>
                <i class="partners-hub-v2__filter-group-toggle-minus">${this.getInlineIconMarkup('minus-small')}</i>
              </div>
            `;
            const optionHtml = (type, name, count) => `
            <label class="partners-hub-v2__filter-option">
              <input type="checkbox" data-type="${type}" value="${this.escapeAttr(name)}" />
              <span class="partners-hub-v2__filter-option-box"></span>
              <span class="partners-hub-v2__filter-option-label">
                <span>${this.escapeHtml(name)}</span>
                <span class="partners-hub-v2__filter-option-count">(${count})</span>
              </span>
            </label>
          `;
            return `
            <div class="partners-hub-v2__filter-stack">
              ${
                hideSearchTitle
                  ? ''
                  : `<div class="partners-hub-v2__filter-block">
                       <div class="partners-hub-v2__search-label">${findShop}</div>
                       <div class="partners-hub-v2__search-box">
                         ${searchIcon}
                         <input class="partners-hub-v2__search-input" type="text" placeholder="${searchPlaceholder}" value="${this.escapeAttr(
                      this.state.search
                    )}" />
                       </div>
                     </div>
                     <hr class="partners-hub-v2__filter-divider" />`
              }
              <div class="partners-hub-v2__filter-block partners-hub-v2__filter-block--groups">
                ${
                  hideSearchTitle
                    ? ''
                    : `<div class="partners-hub-v2__filter-head">
                         <div class="partners-hub-v2__filter-title-wrap">
                           <h3 class="partners-hub-v2__filter-title">${filterLabel}</h3>
                           <span class="partners-hub-v2__filter-count" data-filter-total>0</span>
                         </div>
                         <button type="button" class="partners-hub-v2__filter-reset" data-inline-reset>${resetLabel}</button>
                       </div>`
                }
                <div class="partners-hub-v2__filter-scroll">
                  <div class="partners-hub-v2__filter-group" data-expanded="true">
                    <div class="partners-hub-v2__filter-group-head">
                      <div class="partners-hub-v2__filter-group-title">${countryLabel}</div>
                      ${groupToggle}
                    </div>
                    <div class="partners-hub-v2__filter-group-list">
                      <div class="partners-hub-v2__filter-group-list-inner">
                        <div class="partners-hub-v2__filter-options">
                          ${countryKeys.map((name) => optionHtml('countries', name, facets.countries[name])).join('')}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="partners-hub-v2__filter-group" data-expanded="true">
                    <div class="partners-hub-v2__filter-group-head">
                      <div class="partners-hub-v2__filter-group-title">${applicationsLabel}</div>
                      ${groupToggle}
                    </div>
                    <div class="partners-hub-v2__filter-group-list">
                      <div class="partners-hub-v2__filter-group-list-inner">
                        <div class="partners-hub-v2__filter-options">
                          ${appKeys.map((name) => optionHtml('applications', name, facets.applications[name])).join('')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `;
          }

          openFilterDialog() {
            this._draft = {
              countries: [...this.state.countries],
              applications: [...this.state.applications],
            };
            this.setAttribute('data-filter-open', 'true');
            window.litime?.disableScroll?.();
            this.syncFilterUI(true);
          }

          closeFilterDialog() {
            this.setAttribute('data-filter-open', 'false');
            window.litime?.enableScroll?.();
            this._draft = null;
            this.syncFilterUI(false);
          }

          applyDraftFilters() {
            if (this._draft) {
              this.state.countries = [...this._draft.countries];
              this.state.applications = [...this._draft.applications];
            }
            this.state.page = 1;
            this.closeFilterDialog();
            this.applyFilters();
          }

          resetFilters(fromDialog) {
            if (fromDialog && this._draft) {
              this._draft.countries = [];
              this._draft.applications = [];
              this.syncFilterUI(true);
              return;
            }
            this.state.countries = [];
            this.state.applications = [];
            this.state.search = '';
            this.state.page = 1;
            this.syncSearchInputs();
            this.applyFilters();
          }

          syncFilterUI(useDraft) {
            const source = useDraft && this._draft ? this._draft : this.state;
            this.querySelectorAll('.partners-hub-v2__filter-option input').forEach((input) => {
              const type = input.getAttribute('data-type');
              const root = input.closest('[data-filter-root]');
              const isDialog = root && root.getAttribute('data-filter-root') === 'dialog';
              const list = isDialog && this._draft ? this._draft[type] : this.state[type];
              input.checked = Array.isArray(list) && list.includes(input.value);
            });
            this.syncFilterCounts(source);
            this.querySelectorAll('[data-inline-reset]').forEach((btn) => {
              btn.onclick = (e) => {
                e.preventDefault();
                const root = btn.closest('[data-filter-root]');
                const isDialog = root && root.getAttribute('data-filter-root') === 'dialog';
                this.resetFilters(isDialog);
                if (!isDialog) this.applyFilters();
              };
            });
          }

          syncFilterCounts(source) {
            const s = source || this.state;
            const total = (s.countries?.length || 0) + (s.applications?.length || 0);
            this.querySelectorAll('[data-filter-total]').forEach((el) => {
              el.textContent = String(total);
            });
          }

          applyFilters({ skipMap = false } = {}) {
            const search = (this.state.search || '').toLowerCase();
            let list = this.stores.filter((store) => {
              if (search) {
                const cert = (store.cert_id || '').toLowerCase();
                const name = (store.name || '').toLowerCase();
                if (!cert.includes(search) && !name.includes(search)) return false;
              }
              if (this.state.countries.length && !this.state.countries.includes(store.country)) return false;
              if (
                this.state.applications.length &&
                !this.state.applications.some((app) => (store.applications || []).includes(app))
              ) {
                return false;
              }
              return true;
            });
            this.state.totalList = list;
            this.syncFilterUI(false);
            this.applyPagination();
            if (!skipMap && this.state.view === 'map') this.prepareMapView();
          }

          applyPagination() {
            const list = this.state.totalList || [];
            const mobile = this.isMobile();
            this.setAttribute('data-empty', list.length ? 'false' : 'true');
            if (mobile) {
              this.state.pageList = list;
              this.renderCards();
              if (this.paginationEl) this.paginationEl.innerHTML = '';
              return;
            }
            const pageSize = this.state.pageSize;
            const totalPages = Math.max(1, Math.ceil(list.length / pageSize));
            if (this.state.page > totalPages) this.state.page = totalPages;
            const start = (this.state.page - 1) * pageSize;
            this.state.pageList = list.slice(start, start + pageSize);
            this.renderCards();
            this.renderPagination(totalPages);
          }

          scrollListIntoView() {
            if (this.isMobile()) return;
            // 滚到列表舞台顶部，并在 sticky 头/锚点导航下方留出间距
            const target =
              this.querySelector('.partners-hub-v2__stage') ||
              this.gridEl ||
              this.querySelector('[data-view="list"]') ||
              this;
            const header = document.getElementById('lt-header');
            const headerH = header && header.getAttribute('data-scrollshow') === 'true' ? header.offsetHeight || 0 : 0;
            const navBar = document.querySelector('common-anchor-nav-v2 .common-anchor-nav-v2__bar');
            const navH = navBar ? navBar.offsetHeight || 0 : 0;
            const gap = 48;
            const top = target.getBoundingClientRect().top + window.pageYOffset - headerH - navH - gap;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'smooth',
            });
          }

          renderCards() {
            if (!this.gridEl) return;
            const checkIcon = `<img src="${this.escapeAttr(this.icon('check'))}" alt="" width="16" height="16" />`;
            const pinIcon = this.getInlineIconMarkup('pin');
            const shieldIcon = this.getInlineIconMarkup('shield');
            this.gridEl.innerHTML = this.state.pageList
              .map((store) => {
                const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  store.full_address || `${store.latitude},${store.longitude}`
                )}`;
                const apps = (store.applications || [])
                  .map(
                    (app) =>
                      `<div class="partners-hub-v2__card-app">${checkIcon}<span>${this.escapeHtml(app)}</span></div>`
                  )
                  .join('');
                return `
                <article class="partners-hub-v2__card" data-id="${this.escapeAttr(store.id)}">
                  <div class="partners-hub-v2__card-media">
                    <img class="partners-hub-v2__card-image" src="${this.escapeAttr(
                      store.cover_image
                    )}" alt="${this.escapeAttr(store.name)}" loading="lazy" width="564" height="346" />
                  </div>
                  <div class="partners-hub-v2__card-body">
                    <div class="partners-hub-v2__card-head">
                      <h3 class="partners-hub-v2__card-name">${this.escapeHtml(store.name)}</h3>
                      <div class="partners-hub-v2__card-cert">${shieldIcon}<span>${this.escapeHtml(
                  this.label('cert-id', 'Cert. ID:')
                )} ${this.escapeHtml(store.cert_id)}</span></div>
                    </div>
                    <div class="partners-hub-v2__card-address">
                      ${pinIcon}
                      <a href="${mapsUrl}" target="_blank" rel="noopener noreferrer">${this.escapeHtml(
                  store.full_address
                )}</a>
                    </div>
                    <div>
                      <p class="partners-hub-v2__card-apps-title">${this.escapeHtml(
                        this.label('applications', 'Applications')
                      )}</p>
                      <div class="partners-hub-v2__card-apps">${apps}</div>
                    </div>
                  </div>
                </article>
              `;
              })
              .join('');
          }

          renderPagination(totalPages) {
            if (!this.paginationEl) return;
            if (totalPages <= 1) {
              this.paginationEl.innerHTML = '';
              return;
            }
            const page = this.state.page;
            const arrow = this.escapeAttr(this.icon('page-arrow'));
            const arrowImg = `<img src="${arrow}" alt="" width="7" height="13" />`;
            let html = `<button type="button" class="partners-hub-v2__page-btn partners-hub-v2__page-btn--nav" data-dir="prev" data-page="${
              page - 1
            }" data-disabled="${page <= 1}" aria-label="Previous">${arrowImg}</button>`;
            for (let i = 1; i <= totalPages; i++) {
              html += `<button type="button" class="partners-hub-v2__page-btn" data-page="${i}" data-active="${
                i === page
              }">${i}</button>`;
            }
            html += `<button type="button" class="partners-hub-v2__page-btn partners-hub-v2__page-btn--nav" data-dir="next" data-page="${
              page + 1
            }" data-disabled="${page >= totalPages}" aria-label="Next">${arrowImg}</button>`;
            this.paginationEl.innerHTML = html;
          }

          loadMapLibre() {
            if (window.maplibregl) return Promise.resolve(window.maplibregl);
            if (this.mapLibreLoading) return this.mapLibreLoading;
            const src = this.getAttribute('data-maplibre-js');
            if (!src) return Promise.reject(new Error('MapLibre asset URL missing'));
            this.mapLibreLoading = new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = src;
              script.async = true;
              script.onload = () => resolve(window.maplibregl);
              script.onerror = reject;
              document.head.appendChild(script);
            });
            return this.mapLibreLoading;
          }

          storesToGeoJSON(list) {
            return {
              type: 'FeatureCollection',
              features: (list || [])
                .filter((s) => Number.isFinite(s.longitude) && Number.isFinite(s.latitude))
                .map((store) => ({
                  type: 'Feature',
                  properties: {
                    id: store.id,
                    name: store.name,
                    cert_id: store.cert_id,
                  },
                  geometry: {
                    type: 'Point',
                    coordinates: [Number(store.longitude), Number(store.latitude)],
                  },
                })),
            };
          }

          waitForMapReady() {
            if (!this.map) return Promise.reject(new Error('map missing'));
            if (this.map.loaded()) return Promise.resolve();
            return new Promise((resolve) => this.map.once('load', resolve));
          }

          createStoreMarkerElement(store) {
            const el = document.createElement('div');
            el.className = 'partners-hub-v2__map-marker';
            el.setAttribute('role', 'button');
            el.setAttribute('tabindex', '0');
            el.setAttribute('aria-label', store.name || 'Store');

            const tpl = this.querySelector('template[data-icon="map-pin"]');
            if (tpl?.content) {
              el.appendChild(tpl.content.cloneNode(true));
            }

            el.addEventListener('click', (event) => {
              event.stopPropagation();
              this.openStorePopup(store);
            });

            el.addEventListener('keydown', (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              event.preventDefault();
              this.openStorePopup(store);
            });

            return el;
          }

          openStorePopup(store) {
            const maplibregl = window.maplibregl;
            if (!this.map || !maplibregl || !store) return;
            if (!Number.isFinite(store.longitude) || !Number.isFinite(store.latitude)) return;

            if (this.mapPopup) this.mapPopup.remove();
            this.mapPopup = new maplibregl.Popup({
              offset: 28,
              maxWidth: '300px',
              closeButton: false,
              closeOnClick: true,
              className: 'partners-hub-v2__map-popup-wrap',
            })
              .setLngLat([store.longitude, store.latitude])
              .setHTML(this.renderPopupHtml(store))
              .addTo(this.map);
          }

          clearStoreMarkers() {
            if (!this.storeMarkers) return;
            this.storeMarkers.forEach((marker) => marker.remove());
            this.storeMarkers.clear();
          }

          syncStoreMarkers(list) {
            const maplibregl = window.maplibregl;
            if (!this.map || !maplibregl) return;
            if (!this.storeMarkers) this.storeMarkers = new Map();

            const nextIds = new Set();
            (list || []).forEach((store) => {
              if (!Number.isFinite(store.longitude) || !Number.isFinite(store.latitude)) return;
              nextIds.add(store.id);

              let marker = this.storeMarkers.get(store.id);
              if (!marker) {
                const el = this.createStoreMarkerElement(store);
                marker = new maplibregl.Marker({ element: el, anchor: 'bottom' })
                  .setLngLat([store.longitude, store.latitude])
                  .addTo(this.map);
                this.storeMarkers.set(store.id, marker);
              } else {
                marker.setLngLat([store.longitude, store.latitude]);
              }
            });

            this.storeMarkers.forEach((marker, id) => {
              if (nextIds.has(id)) return;
              marker.remove();
              this.storeMarkers.delete(id);
            });

            this.updateStoreMarkerVisibility();
          }

          updateStoreMarkerVisibility() {
            if (!this.map || !this.storeMarkers?.size) return;

            const visibleIds = new Set();
            try {
              const features = this.map.querySourceFeatures('ph-stores', {
                filter: ['!', ['has', 'point_count']],
              });
              features.forEach((feature) => {
                const id = feature.properties?.id;
                if (id != null) visibleIds.add(String(id));
              });
            } catch (err) {
              this.storeMarkers.forEach((_, id) => visibleIds.add(id));
            }

            this.storeMarkers.forEach((marker, id) => {
              marker.getElement().style.display = visibleIds.has(id) ? '' : 'none';
            });
          }

          scheduleStoreMarkerVisibilityUpdate() {
            if (!this.map) return;
            if (this._markerVisibilityFrame) cancelAnimationFrame(this._markerVisibilityFrame);
            this._markerVisibilityFrame = requestAnimationFrame(() => {
              this._markerVisibilityFrame = 0;
              this.updateStoreMarkerVisibility();
            });
          }

          async ensureMap() {
            const maplibregl = await this.loadMapLibre();
            if (this.map) {
              this.map.resize();
              return this.map;
            }
            this.map = new maplibregl.Map({
              container: this.mapEl,
              style: 'https://static.progusmaps.com/styles/default.json',
              center: [-117.5, 33.7],
              zoom: 3.2,
              attributionControl: false,
              cooperativeGestures: true,
            });
            const homeUrl = this.getAttribute('data-home-url') || '/';
            this.map.addControl(
              new maplibregl.AttributionControl({
                compact: true,
                customAttribution: `<a href="${this.escapeAttr(homeUrl)}">LiTime</a>`,
              }),
              'bottom-right'
            );
            this.map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
            this.map.dragRotate.disable();
            if (this.map.touchZoomRotate) this.map.touchZoomRotate.disableRotation();
            await this.waitForMapReady();
            await this.setupMapLayers();
            this.bindMapHandlers();
            this.map.resize();
            this.collapseAttributionOnce();
            return this.map;
          }

          collapseAttributionOnce() {
            if (!this.map || this._attribCollapsed) return;
            const run = () => {
              if (this._attribCollapsed) return;
              const attrib = this.mapEl?.querySelector('.maplibregl-ctrl-attrib');
              const btn = this.mapEl?.querySelector('.maplibregl-ctrl-attrib-button');
              if (!attrib || !btn) return;
              if (attrib.classList.contains('maplibregl-compact-show')) {
                btn.click();
                this._attribCollapsed = true;
              }
            };
            this.map.once('idle', run);
            setTimeout(run, 300);
          }

          async setupMapLayers() {
            if (!this.map || this.map.getSource('ph-stores')) return;

            const pinColor = '#EA5405';

            this.map.addSource('ph-stores', {
              type: 'geojson',
              data: this.storesToGeoJSON([]),
              cluster: true,
              clusterMaxZoom: 14,
              clusterRadius: 50,
            });

            this.map.addLayer({
              id: 'ph-clusters-halo',
              type: 'circle',
              source: 'ph-stores',
              filter: ['has', 'point_count'],
              paint: {
                'circle-color': pinColor,
                'circle-radius': ['step', ['get', 'point_count'], 17, 5, 21, 15, 25],
                'circle-opacity': 0.4,
              },
            });

            this.map.addLayer({
              id: 'ph-clusters',
              type: 'circle',
              source: 'ph-stores',
              filter: ['has', 'point_count'],
              paint: {
                'circle-color': pinColor,
                'circle-radius': ['step', ['get', 'point_count'], 14, 5, 18, 15, 22],
                'circle-opacity': 1,
              },
            });

            this.map.addLayer({
              id: 'ph-cluster-count',
              type: 'symbol',
              source: 'ph-stores',
              filter: ['has', 'point_count'],
              layout: {
                'text-field': ['get', 'point_count_abbreviated'],
                'text-font': ['NotoSansRegular'],
                'text-size': 13,
                'text-allow-overlap': true,
                'text-ignore-placement': true,
              },
              paint: {
                'text-color': '#ffffff',
              },
            });
          }

          bindMapHandlers() {
            if (!this.map || this.mapHandlersBound) return;
            this.mapHandlersBound = true;

            this.map.on('click', 'ph-clusters', async (e) => {
              const features = this.map.queryRenderedFeatures(e.point, { layers: ['ph-clusters'] });
              const feature = features[0];
              const clusterId = feature?.properties?.cluster_id;
              const source = this.map.getSource('ph-stores');
              if (clusterId == null || !source) return;
              try {
                const zoom = await source.getClusterExpansionZoom(clusterId);
                this.map.easeTo({
                  center: feature.geometry.coordinates,
                  zoom: Math.min(Number(zoom) || this.map.getZoom() + 2, 16),
                });
              } catch (err) {
                this.map.easeTo({
                  center: feature.geometry.coordinates,
                  zoom: Math.min(this.map.getZoom() + 2, 16),
                });
              }
            });

            this.map.on('moveend', () => this.scheduleStoreMarkerVisibilityUpdate());
            this.map.on('zoomend', () => this.scheduleStoreMarkerVisibilityUpdate());
            this.map.on('sourcedata', (event) => {
              if (event.sourceId === 'ph-stores') this.scheduleStoreMarkerVisibilityUpdate();
            });

            this.map.on('mouseenter', 'ph-clusters', () => {
              this.map.getCanvas().style.cursor = 'pointer';
            });
            this.map.on('mouseleave', 'ph-clusters', () => {
              this.map.getCanvas().style.cursor = '';
            });
          }

          destroyMap() {
            if (this.mapPopup) {
              this.mapPopup.remove();
              this.mapPopup = null;
            }
            this.clearStoreMarkers();
            if (this.map) {
              this.map.remove();
              this.map = null;
            }
            this.mapHandlersBound = false;
            this._attribCollapsed = false;
          }

          fitMapToStores(list, { animate = true } = {}) {
            const maplibregl = window.maplibregl;
            if (!this.map || !maplibregl) return;
            const bounds = new maplibregl.LngLatBounds();
            let hasPoint = false;
            (list || []).forEach((store) => {
              if (!Number.isFinite(store.longitude) || !Number.isFinite(store.latitude)) return;
              bounds.extend([store.longitude, store.latitude]);
              hasPoint = true;
            });
            if (!hasPoint) return;
            const duration = animate ? 800 : 0;
            if (list.length === 1) {
              const camera = { center: [list[0].longitude, list[0].latitude], zoom: 11, duration };
              if (animate) this.map.flyTo(camera);
              else this.map.jumpTo(camera);
              return;
            }
            this.map.fitBounds(bounds, {
              padding: 64,
              maxZoom: 10,
              duration,
            });
          }

          async renderMapMarkers({ animate = true } = {}) {
            if (!this.mapEl) return;
            await this.ensureMap();
            this.map.resize();
            const list = this.state.totalList || [];
            if (!this.map.getSource('ph-stores')) await this.setupMapLayers();
            const source = this.map.getSource('ph-stores');
            if (!source) return;
            source.setData(this.storesToGeoJSON(list));
            this.syncStoreMarkers(list);
            if (this.mapPopup) {
              this.mapPopup.remove();
              this.mapPopup = null;
            }
            this.fitMapToStores(list, { animate });
          }

          renderPopupHtml(store) {
            const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              store.full_address || `${store.latitude},${store.longitude}`
            )}`;
            const certIcon = `<svg class="partners-hub-v2__map-popup-cert-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 1.333 3.333 3.333v4.667c0 2.667 2 5.067 4.667 6.333 2.667-1.266 4.667-3.666 4.667-6.333V3.333L8 1.333Z" stroke="#6B7280" stroke-width="1.2" stroke-linejoin="round"/><path d="M6 8.333 7.333 9.667 10.333 6.667" stroke="#6B7280" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            const pinIcon = `<svg class="partners-hub-v2__map-popup-link-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5.47414 16.0227C3.8037 16.5238 2.77051 17.2162 2.77051 17.9808C2.77051 19.5102 6.90327 20.7501 12.0013 20.7501C17.0993 20.7501 21.2321 19.5102 21.2321 17.9808C21.2321 17.2162 20.1989 16.5238 18.5284 16.0227" stroke="#EA5504" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.0005 17.0578C12.0005 17.0578 18.0005 13.1366 18.0005 8.60327C18.0005 5.37067 15.3142 2.75012 12.0005 2.75012C8.68679 2.75012 6.00049 5.37067 6.00049 8.60327C6.00049 13.1366 12.0005 17.0578 12.0005 17.0578Z" stroke="#EA5504" stroke-width="1.5" stroke-linejoin="round"/><path d="M12.0011 11.0577C13.2756 11.0577 14.3088 10.0245 14.3088 8.74996C14.3088 7.47546 13.2756 6.44226 12.0011 6.44226C10.7266 6.44226 9.69336 7.47546 9.69336 8.74996C9.69336 10.0245 10.7266 11.0577 12.0011 11.0577Z" stroke="#EA5504" stroke-width="1.5" stroke-linejoin="round"/></svg>`;
            const phoneIcon = `<svg class="partners-hub-v2__map-popup-link-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M17.152 21.375C17.1518 21.375 17.152 21.375 17.1518 21.375C16.8153 21.375 16.5018 21.3226 16.2191 21.2189C15.8826 21.1294 12.6818 20.1892 8.32717 15.8344C4.10648 11.6139 3.06351 8.29837 2.96248 7.94912C2.56742 6.96419 2.85643 5.59907 3.62648 4.82924L5.26535 3.19037C5.62988 2.82564 6.09945 2.625 6.58749 2.625C7.15267 2.625 7.68651 2.89514 8.05183 3.36652L10.4549 6.4645C10.8345 6.95376 10.8805 7.75311 10.5601 8.28432L9.36392 10.2662C9.45029 10.5799 9.80719 11.541 11.1821 12.9959C12.685 14.419 13.5963 14.7352 13.8855 14.8034L15.8772 13.6016C16.3972 13.2871 17.2186 13.3365 17.697 13.7064L20.795 16.1097C21.2377 16.453 21.5 16.9334 21.5331 17.4622C21.5665 17.9912 21.367 18.5005 20.9712 18.8962L19.3323 20.5351C18.8141 21.0532 17.9786 21.375 17.152 21.375ZM6.58747 3.44766C6.31914 3.44766 6.05626 3.56273 5.84697 3.77201L4.2081 5.41088C3.67807 5.94111 3.45553 6.99071 3.73189 7.65751L3.74856 7.7059C3.7576 7.73904 4.71039 11.0541 8.90879 15.2527C13.2568 19.6005 16.4102 20.419 16.4416 20.4268L16.4882 20.4413C16.6804 20.514 16.9099 20.5523 17.1519 20.5523C17.7591 20.5523 18.3867 20.3174 18.7506 19.9534L20.3895 18.3146C20.6159 18.0882 20.7303 17.8038 20.7122 17.514C20.694 17.224 20.5443 16.9563 20.2909 16.7596L17.1929 14.3566C16.9778 14.1898 16.5368 14.1644 16.3022 14.306L14.0827 15.6452L13.9662 15.6441C13.8436 15.6429 12.7095 15.5753 10.6003 13.5771C8.68904 11.5554 8.53077 10.3584 8.51893 10.2285L8.50687 10.0943L9.85572 7.85932C10.0021 7.6163 9.97802 7.19193 9.80489 6.96857L7.40182 3.87059C7.19019 3.59787 6.90098 3.44766 6.58747 3.44766Z" fill="#EA5504" stroke="#EA5504" stroke-width="0.551589"/></svg>`;

            const parts = [
              `<div class="partners-hub-v2__map-popup">`,
              `<div class="partners-hub-v2__map-popup-head">`,
              `<p class="partners-hub-v2__map-popup-name">${this.escapeHtml(store.name)}</p>`,
            ];
            if (store.cert_id) {
              parts.push(
                `<div class="partners-hub-v2__map-popup-cert">${certIcon}<span>${this.escapeHtml(
                  this.label('cert-id', 'Cert. ID:')
                )} ${this.escapeHtml(store.cert_id)}</span></div>`
              );
            }
            parts.push(`</div>`);
            parts.push(`<div class="partners-hub-v2__map-popup-info">`);
            if (store.full_address) {
              parts.push(
                `<a class="partners-hub-v2__map-popup-link partners-hub-v2__map-popup-link--address" href="${this.escapeAttr(
                  mapsUrl
                )}" target="_blank" rel="noopener noreferrer">${pinIcon}<span class="partners-hub-v2__map-popup-link-text">${this.escapeHtml(
                  store.full_address
                )}</span></a>`
              );
            }
            if (store.phone) {
              parts.push(
                `<a class="partners-hub-v2__map-popup-link partners-hub-v2__map-popup-link--phone" href="tel:${this.escapeAttr(
                  store.phone
                )}">${phoneIcon}<span class="partners-hub-v2__map-popup-link-text">${this.escapeHtml(
                  store.phone
                )}</span></a>`
              );
            }
            parts.push(`</div>`);
            parts.push(`<div class="partners-hub-v2__map-popup-actions">`);
            parts.push(
              `<a class="partners-hub-v2__map-popup-btn partners-hub-v2__map-popup-btn--primary" href="${this.escapeAttr(
                mapsUrl
              )}" target="_blank" rel="noopener noreferrer">${this.escapeHtml(
                this.label('get-directions', 'Get Directions')
              )}</a>`
            );
            if (store.website) {
              parts.push(
                `<a class="partners-hub-v2__map-popup-btn partners-hub-v2__map-popup-btn--ghost" href="${this.escapeAttr(
                  store.website
                )}" target="_blank" rel="noopener noreferrer">${this.escapeHtml(
                  this.label('open-website', 'Open Website')
                )}</a>`
              );
            }
            parts.push(`</div></div>`);
            return parts.join('');
          }

          escapeHtml(str) {
            return String(str ?? '')
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;');
          }

          escapeAttr(str) {
            return this.escapeHtml(str).replace(/'/g, '&#39;');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-step-guidance"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('pro-step-guidance')) {
      customElements.define(
        'pro-step-guidance',
        class ProStepGuidance extends HTMLElement {
          constructor() {
            super();
            this.rafId = null;
            this.resizeTimer = null;
            this.lastWidth = 0;
            this.lastHeight = 0;
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initLine();
          }
          initLine() {
            const content = this.querySelector('.pro-step-guidance__content');
            const lineSvg = this.querySelector('.pro-step-guidance__line');
            if (!content || !lineSvg) return;

            const line = lineSvg.querySelector('line');
            const items = this.querySelectorAll('.pro-step-guidance__content-item');

            if (items.length < 2) return;

            this.updateLine = () => {
              // 取消之前的动画帧
              if (this.rafId) {
                cancelAnimationFrame(this.rafId);
              }

              this.rafId = requestAnimationFrame(() => {
                const firstItem = items[0];
                const lastItem = items[items.length - 1];

                const firstIndex = firstItem.querySelector('.pro-step-guidance__content-item-index');
                const lastIndex = lastItem.querySelector('.pro-step-guidance__content-item-index');

                if (!firstIndex || !lastIndex) return;

                const firstRect = firstIndex.getBoundingClientRect();
                const lastRect = lastIndex.getBoundingClientRect();
                const contentRect = content.getBoundingClientRect();

                // 检查尺寸是否真的变化了
                const currentWidth = contentRect.width;
                const currentHeight = contentRect.height;
                if (
                  this.lastWidth === currentWidth &&
                  this.lastHeight === currentHeight &&
                  Math.abs(firstRect.left - lastRect.left) < 1 &&
                  Math.abs(firstRect.top - lastRect.top) < 1
                ) {
                  return; // 尺寸没有变化，跳过更新
                }
                this.lastWidth = currentWidth;
                this.lastHeight = currentHeight;

                // 计算第一个和最后一个圆圈的中心点（相对于content容器）
                const firstCenterX = firstRect.left + firstRect.width / 2 - contentRect.left;
                const firstCenterY = firstRect.top + firstRect.height / 2 - contentRect.top;
                const lastCenterX = lastRect.left + lastRect.width / 2 - contentRect.left;
                const lastCenterY = lastRect.top + lastRect.height / 2 - contentRect.top;

                // 设置线的起点和终点（从第一个圆圈中心到最后一个圆圈中心）
                line.setAttribute('x1', firstCenterX);
                line.setAttribute('y1', firstCenterY);
                line.setAttribute('x2', lastCenterX);
                line.setAttribute('y2', lastCenterY);

                // 设置SVG容器大小和位置
                lineSvg.setAttribute('width', contentRect.width);
                lineSvg.setAttribute('height', contentRect.height);
              });
            };

            // 初始绘制（延迟确保DOM完全渲染）
            setTimeout(() => {
              this.updateLine();
            }, 100);

            // 使用 ResizeObserver 替代 MutationObserver，性能更好
            if (window.ResizeObserver) {
              this.resizeObserver = new ResizeObserver(() => {
                if (this.resizeTimer) {
                  clearTimeout(this.resizeTimer);
                }
                this.resizeTimer = setTimeout(() => {
                  this.updateLine();
                }, 150);
              });
              this.resizeObserver.observe(content);
            } else {
              // 降级方案：只监听窗口resize
              window.addEventListener('resize', () => {
                if (this.resizeTimer) {
                  clearTimeout(this.resizeTimer);
                }
                this.resizeTimer = setTimeout(() => {
                  this.updateLine();
                }, 150);
              });
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-adsorption"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('product-adsorption')) {
      customElements.define(
        'product-adsorption',
        class ProductAdsorption extends HTMLElement {
          sticky_start = 0;
          changeStatus = false;
          _this = null;
          clickPoint = false;
          constructor() {
            super();
          }
          connectedCallback() {
            const _this = this;
            this.init();
            $(window).on('scroll', _this.scrollHandler.bind(_this));
          }
          disconnectedCallback() {
            const _this = this;
            $(window).off('scroll', _this.scrollHandler.bind(_this));
          }

          scrollHandler() {
            if (this.clickPoint) return;

            const adsorption = $('#adsorption');
            const Points = $(`[data-jump]`);
            let sticky = adsorption.offset().top;
            const scrollTop = $(window).scrollTop();
            const scrollingDown = scrollTop > (this.lastScrollTop || 0);
            this.lastScrollTop = scrollTop;

            if (scrollTop > sticky && !this.changeStatus) {
              this.changeStatus = true;
              this.sticky_start = sticky;
              adsorption.addClass('adsorption_sticky');
              adsorption.css('top', '0');
            }
            if (this.changeStatus && $(window).scrollTop() < this.sticky_start - 10) {
              this.changeStatus = false;
              adsorption.removeClass('adsorption_sticky');
              adsorption.css('top', '0');
            } else if (this.changeStatus) {
              adsorption.css('top', '0');
            }

            // 精确视口顶部对齐检测
            const scrollY = $(window).scrollTop();
            const headerHeight = $('#lt-header').outerHeight() || 0;
            const activationThreshold = 50; // 允许50像素的误差范围

            let closestSection = null;
            let minOffset = Infinity;

            $('a[href^="#"]').each(function () {
              const targetId = $(this).attr('href').replace('#', '');
              if (!targetId) return;

              const $target = $(`#${targetId}`);
              if (!$target.length) return;

              // 计算目标区块顶部位置（考虑固定头部）
              const targetTop = $target.offset().top - headerHeight;

              // 计算与视口顶部的距离差
              const offset = Math.abs(targetTop - scrollY);

              // 找到最接近视口顶部的区块
              if (offset < minOffset) {
                minOffset = offset;
                closestSection = this;
              }
            });

            // 仅在达到阈值时更新状态
            if (closestSection) {
              $('a[href^="#"]').removeClass('adsorption_active');
              $(closestSection).addClass('adsorption_active');
            }
          }

          init() {
            const _this = this;
            let adsorption = $('#adsorption');
            this.sticky_start = adsorption.offset().top;

            // 修改点击事件处理
            $('a[href^="#"]').on('click', function (e) {
              e.preventDefault();
              const targetId = $(this).attr('href').replace('#', '');
              const $target = $(`#${targetId}`);

              if ($target.length) {
                const headerHeight = $('#lt-header').outerHeight() || 0;
                const targetTop = $target.offset().top - headerHeight;

                _this.clickPoint = false;
                _this.scrollHandler();
              }
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-brand-advantage"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('product-brand-advantage')) {
      customElements.define(
        'product-brand-advantage',
        class ProductBrandAdvantage extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            this.initDialog();
          }
          init() {
            let root = $(this);
            let $swiperDom = this.querySelector('.mySwiper');

            // 获取子元素数量
            const slidesCount = $swiperDom.querySelectorAll('.swiper-slide').length;
            // 根据子元素数量决定大屏幕下的 slidesOffsetAfter 值
            const largeScreenOffset = slidesCount > 5 ? 558 : 342;

            // 如果slides小于等于4个且屏幕宽度大于1400px，隐藏导航按钮

            if (slidesCount <= 4 && window.innerWidth >= 1400) {
              root.find('.swiper-button-next, .swiper-button-prev').hide();
            }

            new Swiper($swiperDom, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              enabled: !(slidesCount <= 4 && window.innerWidth >= 1400), // 如果slides小于等于4个且屏幕宽度大于1400px，禁用swiper
              navigation: {
                nextEl: root.find('.swiper-button-next')[0],
                prevEl: root.find('.swiper-button-prev')[0],
              },
              scrollbar: {
                el: $swiperDom.querySelector('.swiper-scrollbar'),
                draggable: true,
              },
              breakpoints: {
                576: {
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
                1200: {
                  slidesOffsetBefore: 48,
                  slidesOffsetAfter: 48,
                },
                1400: {
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: largeScreenOffset,
                },
              },
            });
          }
          initDialog() {
            const $items = $(this).find('.advantage-item');
            this.$dialog = $(this).find('dialog-simple');
            // 检查每个item的desc属性
            $items.each(function () {
              const $item = $(this);
              if (!$item.attr('data-desc')) {
                $item.css('pointer-events', 'none');
              }
            });
            $items.on('click', (e) => {
              const $item = $(e.currentTarget);
              this.$dialog.attr({
                'data-show': 'true',
                'data-title': $item.attr('data-title'),
                'data-desc': $item.attr('data-desc'),
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-download"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('product-download')) {
      customElements.define(
        'product-download',
        class ProductDownload extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.initDownloadButtons();
          }

          /**
           * 初始化下载按钮功能
           */
          initDownloadButtons() {
            const downloadBtns = this.querySelectorAll('.download-btn');

            downloadBtns.forEach((btn) => {
              btn.addEventListener('click', (e) => {
                e.stopPropagation(); // 防止触发父级事件

                const downloadUrl = btn.getAttribute('data-download-url');
                if (downloadUrl) {
                  // 检测是否为 iOS Safari
                  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                  if (isIOS) {
                    // iOS Safari 使用简单的下载方式
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = this.getCleanFilename(downloadUrl);
                    link.target = '_blank';
                    link.click();
                  } else {
                    // 其他浏览器使用 fetch 强制下载
                    fetch(downloadUrl)
                      .then((response) => response.blob())
                      .then((blob) => {
                        // 创建临时 URL
                        const blobUrl = window.URL.createObjectURL(blob);

                        // 创建下载链接
                        const link = document.createElement('a');
                        link.href = blobUrl;

                        // 提取干净的文件名
                        link.download = this.getCleanFilename(downloadUrl);

                        // 触发下载
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        // 清理临时 URL
                        window.URL.revokeObjectURL(blobUrl);
                      })
                      .catch((error) => {
                        console.error('下载失败:', error);
                        // 回退到简单的 a 标签下载
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = this.getCleanFilename(downloadUrl);
                        link.target = '_blank';
                        link.click();
                      });
                  }
                }
              });
            });
          }

          /**
           * 从 URL 中提取干净的文件名（去掉查询参数）
           */
          getCleanFilename(url) {
            return (url.split('/').pop() || 'download').replace(/\?.*$/, '');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('product-faq')) {
      customElements.define(
        'product-faq',
        class ProductFaq extends HTMLElement {
          constructor() {
            super();
            this.$element = $(this);
            this.handleResize = this.handleResize.bind(this);
            this.bindEvents();
          }

          bindEvents() {
            $(window).on('resize', this.handleResize);
            this.$element.on('click', '.faq-trigger', this.toggleFAQ.bind(this));
          }

          disconnectedCallback() {
            $(window).off('resize', this.handleResize);
            this.$element.off('click', '.faq-trigger');
          }

          toggleFAQ(event) {
            const $trigger = $(event.currentTarget);
            const $item = $trigger.closest('.faq-item');
            const $answer = $trigger.siblings('.faq-answer');
            const $content = $answer.children();

            // 关闭其他所有打开的FAQ
            this.$element.find('.faq-answer').not($answer).css('height', '0');
            this.$element.find('.faq-item').not($item).removeClass('active');

            // 切换当前FAQ的状态
            if ($answer.height() > 0) {
              $answer.css('height', '0');
              $item.removeClass('active');
            } else {
              const height = $content.outerHeight();
              $answer.css('height', height + 'px');
              $item.addClass('active');
            }
          }

          handleResize() {
            const $openAnswer = this.$element.find('.faq-answer').filter(function () {
              return $(this).height() > 0;
            });

            if ($openAnswer.length) {
              const height = $openAnswer.children().outerHeight();
              $openAnswer.css('height', height + 'px');
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('product-features')) {
      customElements.define(
        'product-features',
        class ProductFeatures extends HTMLElement {
          connectedCallback() {
            const container = this.querySelector('.product-features-lazy');
            if (!container) return;

            const observer = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  // 加载图片
                  const images = entry.target.querySelectorAll('img');
                  images.forEach((img) => {
                    if (img.dataset.src) {
                      img.src = img.dataset.src;
                      img.removeAttribute('data-src');
                    }
                  });
                  observer.unobserve(entry.target);
                }
              });
            });

            observer.observe(container);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-media-endorsement"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('product-media-endorsement')) {
      customElements.define(
        'product-media-endorsement',
        class ProductMediaEndorsement extends HTMLElement {
          constructor() {
            super();
            this.init();
          }

          init() {
            // 初始化tab切换
            this.initTabs();
            // 初始化所有swiper
            this.initSwipers();
            // 初始化媒体列表顺序
            this.initMediaOrder();
          }

          initMediaOrder() {
            const mediaContainers = this.querySelectorAll('.media-list-container');
            if (!mediaContainers.length) return;

            mediaContainers.forEach((mediaContainer) => {
              const mediaItems = [...mediaContainer.querySelectorAll('.media-item')];
              if (mediaItems.length === 0) return;

              // 如果总数大于等于5，保留5个
              if (mediaItems.length >= 5) {
                // 先克隆所有元素，避免直接操作原始DOM
                const clonedItems = mediaItems.map((item) => item.cloneNode(true));
                const activeItem = mediaContainer.querySelector('[data-active="true"]');
                if (!activeItem) return;

                const activeIndex = mediaItems.indexOf(activeItem);

                // 重新计算要显示的5个项目
                let selectedItems = [];

                // 确保激活项前有两个项目
                for (let i = 2; i > 0; i--) {
                  const index = (activeIndex - i + mediaItems.length) % mediaItems.length;
                  selectedItems.push(clonedItems[index]);
                }

                // 添加激活项
                selectedItems.push(clonedItems[activeIndex]);

                // 确保激活项后有两个项目
                for (let i = 1; i <= 2; i++) {
                  const index = (activeIndex + i) % mediaItems.length;
                  selectedItems.push(clonedItems[index]);
                }

                // 清空容器并添加重排后的元素
                mediaContainer.innerHTML = '';
                selectedItems.forEach((item) => {
                  mediaContainer.appendChild(item);
                });
              }
              // 处理4个项目的情况
              else if (mediaItems.length === 4) {
                // 先克隆所有元素，避免直接操作原始DOM
                const clonedItems = mediaItems.map((item) => item.cloneNode(true));
                const activeItem = mediaContainer.querySelector('[data-active="true"]');
                if (!activeItem) return;

                const activeIndex = mediaItems.indexOf(activeItem);
                let selectedItems = [];

                if (activeIndex === 0) {
                  // 如果第一个是激活项，将最后一个移到最前面
                  selectedItems = [
                    clonedItems[3], // 最后一个
                    clonedItems[0], // 激活项
                    clonedItems[1],
                    clonedItems[2],
                  ];
                } else if (activeIndex === 3) {
                  // 如果最后一个是激活项，将第一个移到最后面
                  selectedItems = [
                    clonedItems[1],
                    clonedItems[2], // 激活项
                    clonedItems[3],
                    clonedItems[0],
                  ];
                } else {
                  // 其他情况保持原始顺序
                  selectedItems = [...clonedItems];
                }

                // 清空容器并添加重排后的元素
                mediaContainer.innerHTML = '';
                selectedItems.forEach((item) => {
                  mediaContainer.appendChild(item);
                });
              }
              // 处理3个项目的情况
              else if (mediaItems.length === 3) {
                // 先克隆所有元素，避免直接操作原始DOM
                const clonedItems = mediaItems.map((item) => item.cloneNode(true));
                const activeItem = mediaContainer.querySelector('[data-active="true"]');
                if (!activeItem) return;

                const activeIndex = mediaItems.indexOf(activeItem);
                let selectedItems = [];

                if (activeIndex === 0) {
                  // 如果第一个是激活项，将最后一个移到最前面
                  selectedItems = [
                    clonedItems[2], // 最后一个
                    clonedItems[0], // 激活项
                    clonedItems[1],
                  ];
                } else if (activeIndex === 2) {
                  // 如果最后一个是激活项，将第一个移到最后面
                  selectedItems = [
                    clonedItems[1],
                    clonedItems[2], // 激活项
                    clonedItems[0],
                  ];
                } else {
                  // 其他情况保持原始顺序
                  selectedItems = [...clonedItems];
                }

                // 清空容器并添加重排后的元素
                mediaContainer.innerHTML = '';
                selectedItems.forEach((item) => {
                  mediaContainer.appendChild(item);
                });
              }
            });
          }

          // 滚动元素到容器中间的通用函数
          scrollToCenter(element) {
            if (!element) return;

            // 获取最外层的可滚动容器
            const container = element.closest('.overflow-x-auto');
            if (!container) return;

            // 获取元素相对于可滚动容器的位置
            const containerRect = container.getBoundingClientRect();
            const elementRect = element.getBoundingClientRect();
            const elementRelativeLeft = elementRect.left - containerRect.left + container.scrollLeft;

            // 计算需要滚动的位置，使元素居中
            const scrollPosition = elementRelativeLeft - containerRect.width / 2 + elementRect.width / 2;

            // 使用平滑滚动
            container.scrollTo({
              left: scrollPosition,
              behavior: 'smooth',
            });
          }

          initTabs() {
            const tabItems = this.querySelectorAll('.tabs-item');
            const tabSwiper = new Swiper(this.querySelector('.tab-swiper'), {
              allowTouchMove: false,
              on: {
                slideChange: function () {
                  tabItems.forEach((tab, index) => {
                    if (index === this.realIndex) {
                      tab.classList.add('active');
                    } else {
                      tab.classList.remove('active');
                    }
                  });
                },
              },
            });

            // 设置第一个tab为激活状态
            tabItems[0]?.classList.add('active');

            tabItems.forEach((tab, index) => {
              tab.addEventListener('click', () => {
                // 移除所有tab的激活状态
                tabItems.forEach((item) => item.classList.remove('active'));
                // 添加当前tab的激活状态
                tab.classList.add('active');
                // 切换到对应的slide
                tabSwiper.slideTo(index);
                // 将点击的tab滚动到中间
                this.scrollToCenter(tab);
              });
            });
          }

          initSwipers() {
            const mediaSliders = this.querySelectorAll('.swiper-media');

            mediaSliders.forEach((slider) => {
              const mediaSwiper = new Swiper(slider, {
                loop: true,
                spaceBetween: 300,

                navigation: {
                  nextEl: slider.querySelector('.swiper-button-next'),
                  prevEl: slider.querySelector('.swiper-button-prev'),
                },
              });

              // 获取当前slider对应的logo容器组
              const mediaLogos = slider.closest('.swiper-slide').querySelectorAll('.media-logo');

              // 设置第一个logo的激活状态
              mediaLogos[0]?.classList.add('active');

              // 为每个logo添加点击事件
              mediaLogos.forEach((logo, index) => {
                logo.addEventListener('click', () => {
                  mediaLogos.forEach((item) => item.classList.remove('active'));
                  logo.classList.add('active');
                  mediaSwiper.slideToLoop(index);
                });
              });

              // 监听slide切换事件
              mediaSwiper.on('slideChange', () => {
                mediaLogos.forEach((item) => item.classList.remove('active'));
                mediaLogos[mediaSwiper.realIndex]?.classList.add('active');
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-official-welfare"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('product-official-welfare')) {
      customElements.define(
        'product-official-welfare',
        class ProductOfficialWelfare extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            this.bindEvent();
          }
          init() {
            let root = $(this);
            let $swiperDom = this.querySelector('.mySwiper');
            let $scrollbarDom = this.querySelector('.swiper-scrollbar');
            // 获取子元素数量
            const slidesCount = $swiperDom.querySelectorAll('.swiper-slide').length;
            // 根据子元素数量决定大屏幕下的 slidesOffsetAfter 值
            const largeScreenOffset = slidesCount > 5 ? 558 : 342;

            // 如果slides小于等于4个且屏幕宽度大于1400px，隐藏导航按钮

            if (slidesCount <= 4 && window.innerWidth >= 1400) {
              root.find('.swiper-button-next, .swiper-button-prev').hide();
            }

            new Swiper($swiperDom, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              enabled: !(slidesCount <= 4 && window.innerWidth >= 1400), // 如果slides小于等于4个且屏幕宽度大于1400px，禁用swiper
              navigation: {
                nextEl: root.find('.swiper-button-next')[0],
                prevEl: root.find('.swiper-button-prev')[0],
              },
              scrollbar: {
                el: $scrollbarDom,
                draggable: true,
              },
              breakpoints: {
                576: {
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
                1200: {
                  slidesOffsetBefore: 48,
                  slidesOffsetAfter: 48,
                },
                1400: {
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: largeScreenOffset,
                },
                385: {
                  slidesPerView: 'auto',
                  slidesPerGroup: 1,
                  spaceBetween: 16,
                },
                0: {
                  slidesPerView: 'auto',
                  slidesPerGroup: 1,
                  spaceBetween: 16,
                },
              },
            });
          }
          bindEvent() {
            const $items = $(this).find('.welfare-item');
            this.$dialog = $(this).find('dialog-simple');
            // 检查每个item的desc属性
            $items.on('click', (e) => {
              const $item = $(e.currentTarget);
              this.$dialog.attr({
                'data-show': 'true',
                'data-title': $item.attr('data-title'),
                'data-desc': $item.attr('data-desc'),
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-screening"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('product-screening')) {
      customElements.define(
        'product-screening',
        class ProductScreening extends HTMLElement {
          constructor() {
            super();
            this.currentSelections = { 1: null, 2: null, 3: null, 4: null };
            this.selectData = { brand: [], voltage: [] };
            this.selectWrappers = [];
            this.searchBtn = null;
            this.searchResultsContainer = null;
            this.globalLoadingContainer = null;
            this.globalLoading = null;
            this.noProductsDiv = null;
            this.productsFoundDiv = null;
            this.productSwiper = null;
          }

          connectedCallback() {
            this.initializeElements();
            this.loadInitialData();
            this.bindEvents();
            this.initializeselectData();

            // 检查URL参数，恢复选择状态
            this.checkUrlParameters();
          }

          async initializeselectData(isRetry = false) {
            let baseUrl = '';
            if (base_info.url == 'dev-askstarry.myshopify.com') {
              baseUrl = 'https://dev-api.askstarry.com/business-api/shopify';
            } else {
              baseUrl = 'https://api.askstarry.com/business-api/shopify';
            }
            const headers_config = {
              shop: window.Shopify.shop,
            };
            try {
              const response = await fetch(baseUrl + '/product-recommend/config', {
                method: 'GET',
                headers: headers_config,
              });

              if (response.status != 200) {
                console.error('Failed to fetch data');
                if (!isRetry) {
                  this.initializeselectData(true);
                }
                return;
              }

              const data = await response.json();

              if (data && data.data) {
                // 处理API返回的数据结构
                this.selectData = this.processApiData(data.data);

                // 重新加载初始数据
                this.loadInitialData();
              }
            } catch (error) {
              console.error('Error fetching data:', error);
              if (!isRetry) {
                this.initializeselectData(true);
              }
            }
          }
          processApiData(apiData) {
            const processedData = {
              brand: [],
              voltage: [],
            };

            // 处理 brands 数据 (Step 1)
            if (apiData.brands && Array.isArray(apiData.brands)) {
              processedData.brand = apiData.brands.map((brand) => ({
                id: brand.key,
                name: brand.value,
                value: brand.key,
              }));
            }

            // 处理 tree 数据 (Step 2, 3, 4)
            if (apiData.tree && Array.isArray(apiData.tree)) {
              processedData.voltage = apiData.tree.map((voltageItem) => {
                const voltage = {
                  id: voltageItem.key,
                  name: voltageItem.value,
                  value: voltageItem.key,
                  power: [],
                };

                // 处理 Step 3: Power (voltage 的 children)
                if (voltageItem.children && Array.isArray(voltageItem.children)) {
                  voltage.power = voltageItem.children.map((powerItem) => {
                    const power = {
                      id: powerItem.key,
                      name: powerItem.value,
                      value: powerItem.key,
                      charger: [],
                    };

                    // 处理 Step 4: Function/Charger (power 的 children)
                    if (powerItem.children && Array.isArray(powerItem.children)) {
                      power.charger = powerItem.children.map((chargerItem) => ({
                        id: chargerItem.key,
                        name: chargerItem.value,
                        value: chargerItem.key,
                      }));
                    }

                    return power;
                  });
                }

                return voltage;
              });
            }

            return processedData;
          }
          initializeElements() {
            this.selectWrappers = Array.from(this.querySelectorAll('.select-wrapper'));
            this.searchBtns = Array.from(this.querySelectorAll('.product-screening-search-btn'));
            this.searchResultsContainer = this.querySelector('.search-results-container');
            this.globalLoadingContainer = this.querySelector('.global-loading-container');
            this.globalLoading = this.querySelector('.global-loading');
            this.noProductsDiv = this.querySelector('.no-products-found');
            this.productsFoundDiv = this.querySelector('.products-found');

            document.addEventListener('click', (e) => {
              if (
                !this.contains(e.target) ||
                !e.target.closest('.select-display, .select-options, .select-option, .product-screening-search-btn')
              ) {
                this.closeAllDropdowns();
              }
            });
          }

          async loadInitialData() {
            try {
              // 只启用Step 1并加载数据
              const firstSelect = this.selectWrappers[0];
              if (firstSelect && this.selectData && this.selectData.brand && this.selectData.brand.length > 0) {
                this.populateSelect(firstSelect, this.selectData.brand);
                this.enableSelect(firstSelect);
              }

              // 禁用其他步骤
              for (let i = 1; i < 4; i++) {
                this.disableSelect(this.selectWrappers[i]);
              }
            } catch (error) {
              console.error('Failed to load initial data:', error);
            }
          }

          bindEvents() {
            this.selectWrappers.forEach((wrapper) => {
              const level = parseInt(wrapper.getAttribute('data-level'));
              const selectDisplay = wrapper.querySelector('.select-display');
              const selectOptions = wrapper.querySelector('.select-options');

              selectDisplay.addEventListener('click', (e) => {
                e.stopPropagation();
                this.handleSelectClick(wrapper);
              });

              selectOptions.addEventListener('click', (e) => {
                const option = e.target.closest('.select-option');
                if (option) {
                  e.stopPropagation();
                  this.handleOptionSelect(wrapper, option, level);
                }
              });
            });

            // 为所有搜索按钮绑定事件
            this.searchBtns.forEach((searchBtn) => {
              searchBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                try {
                  // 检查是否四个step都已选择
                  const allSelected = Object.values(this.currentSelections).every((selection) => selection !== null);
                  if (!allSelected) {
                    if (window.litime?.showToast) {
                      window.litime.showToast('warning', this.getAttribute('data-search-error-text'));
                    }
                    return;
                  }

                  // 显示搜索结果容器和loading
                  this.searchResultsContainer.classList.remove('hidden');
                  this.globalLoadingContainer.classList.remove('hidden');
                  this.globalLoading.classList.remove('hidden');
                  this.noProductsDiv.classList.add('hidden');
                  this.productsFoundDiv.classList.add('hidden');

                  // 禁用所有搜索按钮
                  this.searchBtns.forEach((btn) => (btn.disabled = true));

                  // 获取当前选中的Step 3内容
                  const step3Content = this.getCurrentStep3Selection();

                  const foundProducts = await this.searchProducts();

                  // 隐藏loading
                  this.globalLoading.classList.add('hidden');
                  this.globalLoadingContainer.classList.add('hidden');

                  foundProducts.length > 0 ? this.showProductsFound(foundProducts) : this.showNoProducts();
                } catch (error) {
                  console.error('Search error:', error);
                  // 出错时也要隐藏loading
                  this.globalLoading.classList.add('hidden');
                  this.globalLoadingContainer.classList.add('hidden');
                } finally {
                  // 重新启用所有搜索按钮
                  this.searchBtns.forEach((btn) => (btn.disabled = false));
                }
              });
            });
          }

          handleSelectClick(wrapper) {
            if (wrapper.classList.contains('disabled')) return;

            const isOpen = wrapper.classList.contains('open');
            this.closeAllDropdowns();
            if (!isOpen) {
              wrapper.classList.add('open');
              const dropdown = wrapper.querySelector('.select-dropdown');
              if (dropdown && wrapper.classList.contains('open')) {
                dropdown.classList.add('show-scroll');
              }
            }
          }

          async handleOptionSelect(wrapper, option, level) {
            try {
              const value = option.getAttribute('data-value');
              const name = option.querySelector('.option-text').textContent.trim();

              this.currentSelections[level] = { value, name };
              this.updateOptionSelection(wrapper, option);
              this.updateSelectDisplay(wrapper, name);
              wrapper.classList.remove('open');

              // 添加selected类，表示该step已完成选择
              wrapper.classList.add('selected');
              this.clearSubsequentSelections(level);
              await this.loadNextLevelData(level, value);

              // 自动打开下一个step的下拉菜单
              this.autoOpenNextStep(level);
            } catch (error) {
              console.error('Option selection error:', error);
            }
          }

          autoOpenNextStep(currentLevel) {
            // 只有当前level小于4时才自动打开下一个
            if (currentLevel < 4) {
              const nextLevel = currentLevel + 1;
              const nextWrapper = this.selectWrappers[nextLevel - 1];

              if (nextWrapper && !nextWrapper.classList.contains('disabled')) {
                // 延迟一点时间，让当前step的关闭动画完成
                setTimeout(() => {
                  // 关闭所有其他打开的下拉菜单
                  this.closeAllDropdowns();

                  // 打开下一个step的下拉菜单
                  nextWrapper.classList.add('open');

                  // 添加滚动条显示延迟
                  setTimeout(() => {
                    const dropdown = nextWrapper.querySelector('.select-dropdown');
                    if (dropdown) {
                      dropdown.classList.add('show-scroll');
                    }
                  }, 300);
                }, 200);
              }
            }
          }

          updateOptionSelection(wrapper, selectedOption) {
            // 移除所有选项的选中状态
            wrapper.querySelectorAll('.select-option').forEach((option) => {
              option.classList.remove('selected');
              const checkIcon = option.querySelector('.option-check-icon');
              if (checkIcon) {
                checkIcon.style.display = 'none';
              }
            });

            // 设置选中状态
            selectedOption.classList.add('selected');
            const checkIcon = selectedOption.querySelector('.option-check-icon');
            if (checkIcon) {
              checkIcon.style.display = 'block';
            }
          }

          updateSelectDisplay(wrapper, text) {
            const selectText = wrapper.querySelector('.select-text');
            if (selectText) selectText.textContent = text;
          }

          clearSubsequentSelections(level) {
            // 获取动态的步骤文本
            const getStepText = (stepNumber) => {
              return this.getAttribute(`data-step${stepNumber}-text`) || `Step ${stepNumber}`;
            };

            for (let i = level + 1; i <= 4; i++) {
              this.currentSelections[i] = null;
              const wrapper = this.selectWrappers[i - 1];
              if (wrapper) {
                const selectText = wrapper.querySelector('.select-text');
                if (selectText) {
                  selectText.textContent = getStepText(i);
                }
                this.disableSelect(wrapper);
                wrapper.querySelector('.select-options').innerHTML = '';

                // 移除selected类，因为该step已被重置
                wrapper.classList.remove('selected');
              }
            }
          }

          async loadNextLevelData(currentLevel, selectedValue) {
            try {
              if (currentLevel === 1) {
                // Step 1选择后启用Step 2
                const secondSelect = this.selectWrappers[1];
                if (secondSelect && this.selectData && this.selectData.voltage && this.selectData.voltage.length > 0) {
                  this.populateSelect(secondSelect, this.selectData.voltage);
                  this.enableSelect(secondSelect);
                }
                this.resetLevelsFrom(3);
              } else if (currentLevel === 2) {
                // Step 2选择后启用Step 3
                if (this.selectData && this.selectData.voltage) {
                  const selectedVoltage = this.selectData.voltage.find((v) => v.value === selectedValue);
                  if (selectedVoltage?.power && selectedVoltage.power.length > 0) {
                    await this.loadDataForLevel(3, selectedVoltage.power);
                  }
                }
                this.resetLevelsFrom(4);
              } else if (currentLevel === 3) {
                // Step 3选择后启用Step 4
                const currentVoltageSelection = this.currentSelections[2];
                if (currentVoltageSelection && this.selectData && this.selectData.voltage) {
                  const selectedVoltage = this.selectData.voltage.find(
                    (v) => v.value === currentVoltageSelection.value
                  );
                  if (selectedVoltage?.power) {
                    const selectedPower = selectedVoltage.power.find((p) => p.value === selectedValue);
                    if (selectedPower?.charger && selectedPower.charger.length > 0) {
                      await this.loadDataForLevel(4, selectedPower.charger);
                    }
                  }
                }
              }
            } catch (error) {
              console.error('Failed to load next level data:', error);
            }
          }

          async loadDataForLevel(level, data) {
            if (level > 4) return;
            const wrapper = this.selectWrappers[level - 1];
            if (!wrapper) return;

            try {
              wrapper.classList.add('loading');

              if (data?.length > 0) {
                this.populateSelect(wrapper, data);
                this.enableSelect(wrapper);
              } else {
                this.disableSelect(wrapper);
              }
            } catch (error) {
              console.error('Failed to load data for level:', level, error);
            } finally {
              wrapper.classList.remove('loading');
            }
          }

          resetLevelsFrom(startLevel) {
            for (let i = startLevel; i <= 4; i++) {
              const wrapper = this.selectWrappers[i - 1];
              if (wrapper) {
                this.currentSelections[i] = null;
                this.disableSelect(wrapper);
                wrapper.querySelector('.select-options').innerHTML = '';
              }
            }
          }

          populateSelect(wrapper, data) {
            const selectOptions = wrapper.querySelector('.select-options');
            if (!selectOptions || !data?.length) return;

            selectOptions.innerHTML = data
              .map(
                (item) => `
              <div class="select-option" data-value="${item.value}">
                <span class="option-text">${item.name}</span>
                <i class="option-check-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="14.5" height="9.5" viewBox="0 0 14.5 9.5">
                    <path d="M14.5,0.75C14.5,0.94891244,14.420982,1.139678,14.28033,1.2803302L14.28033,1.2803302L6.2803302,9.2803297C6.139678,9.4209814,5.9489126,9.499999,5.75,9.499999C5.5510874,9.499999,5.3603215,9.4209814,5.2196698,9.2803297L0.21967,4.2803302C0.079017639,4.139678,0,3.9489124,0,3.75C0,3.3357863,0.3357864,3,0.75,3C0.94891238,3,1.1396778,3.0790176,1.2803301,3.2196698L5.75,7.6893396L13.219208,0.22013211L13.219208,0.22013211C13.360322,0.07901758,13.551087,0,13.75,0C14.164213,0,14.5,0.3357864,14.5,0.75Z" fill="#EA5504"/>
                  </svg>
                </i>
              </div>
            `
              )
              .join('');
          }

          enableSelect(wrapper) {
            wrapper.classList.remove('disabled');
            wrapper.classList.add('enabled');
            const selectBox = wrapper.querySelector('.select-box');
            if (selectBox) {
              selectBox.style.cursor = 'pointer';
              selectBox.style.opacity = '1';
              selectBox.style.backgroundColor = 'white';
            }
          }

          disableSelect(wrapper) {
            wrapper.classList.remove('enabled');
            wrapper.classList.add('disabled');
            wrapper.classList.remove('open');
            const selectBox = wrapper.querySelector('.select-box');
            if (selectBox) {
              selectBox.style.cursor = 'not-allowed';
              selectBox.style.opacity = '0.4';
            }
          }

          closeAllDropdowns() {
            this.selectWrappers.forEach((wrapper) => {
              wrapper.classList.remove('open');
              const dropdown = wrapper.querySelector('.select-dropdown');
              if (dropdown) {
                dropdown.classList.remove('show-scroll');
              }
            });
          }

          async searchProducts() {
            try {
              // 先通过推荐接口获取产品handle数组
              const productHandles = await this.fetchProductHandles();
              if (!productHandles || productHandles.length === 0) {
                return [];
              }

              // 并行获取所有产品的详情
              const productPromises = productHandles.map(async (handle) => {
                try {
                  const response = await fetch(`/products/${handle.handle}.js`, {
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json',
                      Accept: 'application/json',
                    },
                  });

                  if (!response.ok) {
                    console.error(`Failed to fetch product ${handle.handle}`);
                    return null;
                  }

                  const productData = await response.json();

                  // 合并API返回的增强数据和Shopify产品数据
                  const enhancedProductData = {
                    ...productData,
                    // 添加API返回的增强字段
                    selling_point_1: handle.sellingPoint1,
                    selling_point_2: handle.sellingPoint2,
                    selling_point_3: handle.sellingPoint3,
                    'size-info': handle.size,
                    size: handle.size,
                    functions: handle.functions || [],
                    discount: handle.discount,
                  };

                  return enhancedProductData;
                } catch (error) {
                  console.error(`Error fetching product ${handle.handle}:`, error);
                  return null;
                }
              });

              // 等待所有产品请求完成
              const products = await Promise.all(productPromises);

              // 过滤掉获取失败的产品
              const validProducts = products.filter((product) => product !== null);

              return validProducts;
            } catch (error) {
              console.error('Search products error:', error);
              return [];
            }
          }

          async fetchProductHandles() {
            try {
              // 获取Step 4选择的key
              const step4Selection = this.currentSelections[4];
              if (!step4Selection || !step4Selection.value) {
                console.error('Step 4 selection not found');
                return [];
              }

              let baseUrl = '';
              if (base_info.url == 'dev-askstarry.myshopify.com') {
                baseUrl = 'https://dev-api.askstarry.com/business-api/shopify';
              } else {
                baseUrl = 'https://api.askstarry.com/business-api/shopify';
              }

              const headers_config = {
                shop: window.Shopify.shop,
              };

              // 请求产品推荐接口
              const response = await fetch(
                baseUrl + `/product-recommend/get?key=${encodeURIComponent(step4Selection.value)}`,
                {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    ...headers_config,
                  },
                }
              );

              if (response.status !== 200) {
                console.error('Failed to fetch product recommendations');
                return [];
              }

              const data = await response.json();

              // 返回产品handle列表
              if (data && Array.isArray(data)) {
                return data;
              } else if (data && data.data && Array.isArray(data.data)) {
                return data.data;
              }

              return [];
            } catch (error) {
              console.error('Error fetching product handles:', error);
              return [];
            }
          }

          showProductsFound(products) {
            this.noProductsDiv.classList.replace('flex', 'hidden');
            this.productsFoundDiv.classList.replace('hidden', 'block');

            const productsSwiper = this.productsFoundDiv.querySelector('#productScreening .swiper-wrapper');
            if (productsSwiper) {
              // 第一步：生成所有产品的HTML内容
              const allProductsHTML = [];

              for (let i = 0; i < products.length; i++) {
                const product = products[i];

                const productHTML = this.renderGlobalProduct(product);
                const slideHTML = `<div class="swiper-slide h-auto overflow-hidden relative box-border flex flex-col max-md:w-[352px] max-xs:w-[290px]">${productHTML}</div>`;

                allProductsHTML.push(slideHTML);
              }

              // 第二步：一次性设置所有HTML到swiper-wrapper
              const finalHTML = allProductsHTML.join('');
              productsSwiper.innerHTML = finalHTML;

              // 第三步：产品渲染完成后，更新Step 3内容显示
              setTimeout(() => {
                const step3ContentDisplays = this.querySelectorAll('.step3-content-display');
                const step3Content = this.getCurrentStep3Selection();

                if (step3ContentDisplays.length > 0 && step3Content) {
                  step3ContentDisplays.forEach((display, index) => {
                    display.textContent = step3Content;
                  });
                }
              }, 100);

              // 初始化Swiper
              this.initializeProductSwiper();

              // 绑定产品链接点击事件
              this.bindProductLinkEvents();
            }
          }

          async checkUrlParameters() {
            try {
              const urlParams = new URLSearchParams(window.location.search);

              // 检查是否有step参数
              const hasStepParams = ['step1', 'step2', 'step3', 'step4'].some((param) => urlParams.has(param));

              if (hasStepParams) {
                // 滚动到product-screening组件位置
                this.scrollToProductScreening();

                // 等待数据加载完成
                await this.waitForDataLoaded();

                // 恢复每个step的选择状态
                for (let i = 1; i <= 4; i++) {
                  const stepValue = urlParams.get(`step${i}`);
                  if (stepValue) {
                    await this.restoreStepSelection(i, stepValue);
                  }
                }

                // 如果所有4个step都有值，自动执行搜索
                const allStepsSelected = Object.values(this.currentSelections).every((selection) => selection !== null);
                if (allStepsSelected) {
                  setTimeout(() => {
                    this.executeSearch();
                  }, 500);
                }
              }
            } catch (error) {
              console.error('Error checking URL parameters:', error);
            }
          }

          scrollToProductScreening() {
            // 滚动到product-screening组件位置
            const productScreeningElement = document.getElementById('product-screening');
            if (productScreeningElement) {
              // 检测是否有固定头部
              const header =
                document.querySelector('header') ||
                document.querySelector('.header') ||
                document.querySelector('[data-section-type="header"]');
              let headerHeight = 0;

              if (header) {
                const headerRect = header.getBoundingClientRect();
                const headerStyle = window.getComputedStyle(header);
                if (headerStyle.position === 'fixed' || headerStyle.position === 'sticky') {
                  headerHeight = headerRect.height;
                }
              }

              // 直接跳转到元素位置，不使用平滑滚动
              // 使用location.hash来直接定位
              window.location.hash = '#product-screening';
            }
          }

          async waitForDataLoaded() {
            // 等待selectData加载完成
            let attempts = 0;
            while (
              (!this.selectData || !this.selectData.brand || this.selectData.brand.length === 0) &&
              attempts < 50
            ) {
              await new Promise((resolve) => setTimeout(resolve, 100));
              attempts++;
            }
          }

          async restoreStepSelection(level, value) {
            try {
              const wrapper = this.selectWrappers[level - 1];
              if (!wrapper) return;

              // 根据level获取对应的数据
              let data = [];
              if (level === 1) {
                data = this.selectData.brand || [];
              } else if (level === 2) {
                data = this.selectData.voltage || [];
              } else if (level === 3) {
                const currentVoltageSelection = this.currentSelections[2];
                if (currentVoltageSelection && this.selectData.voltage) {
                  const selectedVoltage = this.selectData.voltage.find(
                    (v) => v.value === currentVoltageSelection.value
                  );
                  data = selectedVoltage?.power || [];
                }
              } else if (level === 4) {
                const currentVoltageSelection = this.currentSelections[2];
                const currentPowerSelection = this.currentSelections[3];
                if (currentVoltageSelection && currentPowerSelection && this.selectData.voltage) {
                  const selectedVoltage = this.selectData.voltage.find(
                    (v) => v.value === currentVoltageSelection.value
                  );
                  const selectedPower = selectedVoltage?.power?.find((p) => p.value === currentPowerSelection.value);
                  data = selectedPower?.charger || [];
                }
              }

              // 查找匹配的选项
              const matchedOption = data.find((item) => item.value === value);
              if (matchedOption) {
                // 填充选择框
                this.populateSelect(wrapper, data);
                this.enableSelect(wrapper);

                // 设置选中状态
                this.currentSelections[level] = { value: matchedOption.value, name: matchedOption.name };

                // 更新显示
                const selectText = wrapper.querySelector('.select-text');
                if (selectText) {
                  selectText.textContent = matchedOption.name;
                }

                // 高亮选中的选项
                this.highlightSelectedOption(wrapper, value);

                // 添加selected类，表示该step已完成选择
                wrapper.classList.add('selected');

                // 加载下一级数据
                if (level < 4) {
                  await this.loadNextLevelData(level, value);
                }
              }
            } catch (error) {
              console.error(`Error restoring step ${level}:`, error);
            }
          }

          highlightSelectedOption(wrapper, selectedValue) {
            // 移除所有选项的选中状态
            const allOptions = wrapper.querySelectorAll('.select-option');
            allOptions.forEach((option) => {
              option.classList.remove('selected');
              const checkIcon = option.querySelector('.option-check-icon');
              if (checkIcon) {
                checkIcon.style.display = 'none';
              }
            });

            // 高亮选中的选项
            const selectedOption = wrapper.querySelector(`.select-option[data-value="${selectedValue}"]`);
            if (selectedOption) {
              selectedOption.classList.add('selected');
              const checkIcon = selectedOption.querySelector('.option-check-icon');
              if (checkIcon) {
                checkIcon.style.display = 'block';
              }
            }
          }

          async executeSearch() {
            // 模拟点击搜索按钮
            if (this.searchBtns && this.searchBtns.length > 0) {
              const searchBtn = this.searchBtns[0];
              searchBtn.click();
            }
          }

          bindProductLinkEvents() {
            // 为所有产品链接按钮绑定点击事件
            const productLinkBtns = this.productsFoundDiv.querySelectorAll('.product-link-btn');
            productLinkBtns.forEach((btn) => {
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                const productUrl = btn.getAttribute('data-product-url');
                this.handleProductClick(productUrl);
              });
            });
          }

          handleProductClick(productUrl) {
            // 保存当前所有step的选择状态到URL
            const currentUrl = new URL(window.location);

            // 保存每个step的key
            for (let i = 1; i <= 4; i++) {
              const selection = this.currentSelections[i];
              if (selection && selection.value) {
                currentUrl.searchParams.set(`step${i}`, selection.value);
              }
            }

            // 使用pushState更新URL，保存当前状态
            window.history.pushState(null, '', currentUrl.toString());

            // 跳转到产品页面
            window.location.href = productUrl;
          }

          renderGlobalProduct(product) {
            try {
              // 根据is_show配置获取变体（true=最后一个变体，false=第一个可用变体）
              const availableVariant = this.getFirstAvailableVariant(product);

              // 构建带变体ID的产品URL
              const baseUrl = product.url || `/products/${product.handle}`;
              const productUrl = availableVariant?.id ? `${baseUrl}?variant=${availableVariant.id}` : baseUrl;

              // 获取变体图片，优先使用变体的 featured_media，fallback 到产品的 featured_image
              const productImage = availableVariant?.featured_media?.preview_image?.src || product.featured_image;
              const productTitle = product.title;

              // 添加完整功能
              const productPrice = window.Shopify.formatMoney(availableVariant?.price, window.shopMoneyFormat);
              const compareAtPrice = window.Shopify.formatMoney(
                availableVariant?.compare_at_price,
                window.shopMoneyFormat
              );

              // 计算折扣信息
              const discountPercent = this.calculateDiscount(
                availableVariant?.compare_at_price,
                availableVariant?.price
              );

              // 获取折扣显示类型
              const discountType = this.getAttribute('data-global_product-type') || 'percentage';
              const isAfterMode = this.getAttribute('data-global-preferential-type') === 'after';

              // 统一折扣显示逻辑：先判断显示格式，再判断价格来源
              let discountDisplay = '';
              let hasDiscount = false;

              if (discountType === 'quota') {
                // 显示实际金额格式
                if (isAfterMode) {
                  // after模式：基于 price_cents 和 final_cents 计算折扣金额
                  const priceCents = availableVariant?.compare_at_price || 0;
                  const finalCents = availableVariant?.final_cents || 0;
                  const discountAmount = priceCents - finalCents;
                  hasDiscount = discountAmount > 0;
                  if (hasDiscount) {
                    if (finalCents > 0) {
                      discountDisplay = `${window.Shopify.formatMoney(discountAmount, window.shopMoneyFormat)} OFF`;
                    } else {
                      const discountAmount = availableVariant?.compare_at_price - availableVariant?.price;
                      const formattedDiscountAmount = window.Shopify.formatMoney(
                        discountAmount,
                        window.shopMoneyFormat
                      );
                      discountDisplay = `${formattedDiscountAmount} OFF`;
                    }
                  }
                } else {
                  // before模式：使用原生价格比较
                  hasDiscount = discountPercent > 0;
                  if (hasDiscount) {
                    const discountAmount = availableVariant?.compare_at_price - availableVariant?.price;
                    const formattedDiscountAmount = window.Shopify.formatMoney(discountAmount, window.shopMoneyFormat);
                    discountDisplay = `${formattedDiscountAmount} OFF`;
                  }
                }
              } else {
                // 显示百分比格式
                if (isAfterMode) {
                  // after模式：基于 price_cents 和 final_cents 计算折扣百分比
                  const priceCents = availableVariant?.compare_at_price || 0;
                  const finalCents = availableVariant?.final_cents || availableVariant?.price || 0;
                  const discountAmount = priceCents - finalCents;
                  hasDiscount = discountAmount > 0 && priceCents > 0;

                  if (hasDiscount) {
                    const discountPercentValue = Math.floor((discountAmount / priceCents) * 100);
                    discountDisplay = `${discountPercentValue}% OFF`;
                  }
                } else {
                  // before模式：使用原生价格比较计算百分比
                  const compareAtPrice = availableVariant?.compare_at_price || 0;
                  const currentPrice = availableVariant?.price || 0;
                  hasDiscount = compareAtPrice > currentPrice;
                  if (hasDiscount) {
                    const discountPercentValue = Math.floor(((compareAtPrice - currentPrice) / compareAtPrice) * 100);
                    discountDisplay = `${discountPercentValue}% OFF`;
                  }
                }
              }

              return `
              <global-product style="background-color: #F5F5F5;" class="rounded-[4px] w-full h-full overflow-hidden flex flex-col px-[1rem] pb-[16px] global-product justify-between">
               <div class="relative">
                  <div class="absolute top-[16px] left-[0px] z-50 w-full h-[27px] box-border flex justify-between items-center gap-[10px]">
                    ${
                      // 使用统一的hasDiscount变量和discountDisplay
                      hasDiscount
                        ? `
                      <div class="text-[12px] px-[6px] py-[2px] ml-auto rounded-[2px] flex justify-center items-center bg-primary text-white">
                        ${discountDisplay}
                      </div>
                    `
                        : ''
                    }
                  </div>
                  
                  <div class="flex justify-center relative group/outer  w-[calc(100%+32px)] translate-x-[-16px] pt-[50px] mb-[11px]">
                    <div class="flex items-center justify-center">
                      <div class="overflow-hidden flex flex-col gap-[12px]"  
                      style="width: ${this.getAttribute('data-image-size')}px; height: ${this.getAttribute(
                'data-image-size'
              )}px;">
                        <div class="min-lg:group-hover/outer:scale-110 transition-scale linear duration-300">
                          <img src="${productImage}" alt="${productTitle}" loading="lazy" class="w-[100%] h-[100%] object-cover" width="100%" height="100%">
                        </div>
                      </div>
                    </div>
                  </div>
           
                   ${this.renderProductFunctions(product)}
                 <div class="w-full flex flex-col gap-[12px]">
                    <div class="text-[16px] font-bold text-[#181818] line-clamp-2">${product.title}</div>
                    <div class="text-[#737373] text-annotate-1 pb-[12px]">
                        ${
                          product.selling_point_1
                            ? `
                        <div class="flex items-center gap-[8px]">
                        <div class="w-[5px] h-[5px] bg-[#737373] rounded-[50%] flex-shrink-0"></div>
                        <div class="line-clamp-1">${product.selling_point_1}</div>
                        </div>
                        `
                            : ''
                        }
                        ${
                          product.selling_point_2
                            ? `
                        <div class="flex items-center gap-[8px]">
                        <div class="w-[5px] h-[5px] bg-[#737373] rounded-[50%] flex-shrink-0"></div>
                        <div class="line-clamp-1">${product.selling_point_2}</div>
                        </div>
                        `
                            : ''
                        }
                        ${
                          product.selling_point_3
                            ? `
                        <div class="flex items-center gap-[8px]">
                        <div class="w-[5px] h-[5px] bg-[#737373] rounded-[50%] flex-shrink-0"></div>
                        <div class="line-clamp-1">${product.selling_point_3}</div>
                        </div>
                        `
                            : ''
                        }
                    </div>
                 
                  
           
                      </div>
               </div>
                  <div class="form_wrapper flex-1 h-full  flex  justify-end overflow-hidden text-white rounded-[2px] flex-col items-start">
                     <div class="w-full pt-[12px] flex flex-col items-center border-t border-[#cdcdcd] border-solid">
                         <div class="w-full flex flex-col gap-[12px] pb-[12px]">
                                        <div class="box-border flex items-center gap-[12px] size-container">
                                            <div class="w-[24px] h-[24px] flex-shrink-0">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="18.666667938232422" height="18.666667938232422" viewBox="0 0 18.666667938232422 18.666667938232422"><g><path d="M0,10.012121L0,17.478788Q0,17.970825,0.34792203,18.318747Q0.69584149,18.666668,1.1878788,18.666668L17.478788,18.666668Q17.970823,18.666668,18.318745,18.318747Q18.666668,17.970825,18.666668,17.478788L18.666668,11.369697Q18.666668,10.877662,18.318745,10.529739Q17.970825,10.181818,17.478788,10.181818L8.484848,10.181818L8.4848499,1.1878788Q8.4848499,0.6958434,8.1369267,0.34792137Q7.7890043,0,7.2969685,0L1.1878788,0Q0.69584405,0,0.34792203,0.34792137Q0,0.6958434,0,1.1878788L0,10.012121ZM1.0181818,10.521213L3.9030304,10.521213C4.1841936,10.521213,4.4121213,10.293284,4.4121213,10.012121C4.4121213,9.7309589,4.1841936,9.5030308,3.9030304,9.5030308L1.0181818,9.5030308L1.0181818,6.4484854L2.8848484,6.4484854C3.1660116,6.4484854,3.3939395,6.2205572,3.3939395,5.939394C3.3939395,5.6582313,3.1660116,5.4303031,2.8848484,5.4303031L1.0181818,5.4303031L1.0181818,1.1878788Q1.0181818,1.0181818,1.1878788,1.0181818L7.2969685,1.0181818Q7.4666667,1.0181818,7.4666667,1.1878788L7.4666667,10.690909C7.4666667,10.972072,7.6945949,11.2,7.9757576,11.2L17.478788,11.2Q17.648485,11.2,17.648485,11.369697L17.648485,17.478788Q17.648485,17.54908,17.598782,17.598782Q17.54908,17.648485,17.478788,17.648485L14.59394,17.648485L14.59394,15.781818C14.59394,15.500655,14.366012,15.272727,14.084848,15.272727C13.803686,15.272727,13.575758,15.500655,13.575758,15.781818L13.575758,17.648485L10.521213,17.648487L10.521213,14.763637C10.521213,14.482473,10.293284,14.254545,10.012121,14.254545C9.7309589,14.254545,9.5030308,14.482473,9.5030308,14.763637L9.5030308,17.648487L6.4484854,17.648487L6.4484854,15.781818C6.4484854,15.500655,6.2205572,15.272727,5.939394,15.272727C5.6582313,15.272727,5.4303031,15.500655,5.4303031,15.781818L5.4303031,17.648487L1.1878788,17.648487Q1.1030307,17.648487,1.060606,17.60606Q1.0553001,17.600758,1.0506623,17.594793Q1.0181813,17.553032,1.0181818,17.478788L1.0181818,14.59394L2.8848484,14.59394C3.1660116,14.59394,3.3939395,14.366012,3.3939395,14.084848C3.3939395,13.803686,3.1660116,13.575758,2.8848484,13.575758L1.0181818,13.575758L1.0181818,10.521213Z" fill-rule="evenodd" fill="#737373" fill-opacity="1"/></g></svg>
                                            </div>
                                            <div class="flex flex-col gap-[2px]">
                                                <div class="text-default text-[14px] text-left font-medium line-clamp-1">
                                                   ${product['size-info'] || '--'}
                                                </div>
                                                <div class="text-[#737373] text-[12px] text-left font-normal line-clamp-1 w-full">
                                                    ${this.getAttribute('data-size-description')}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="box-border flex items-center gap-[12px] power-container">
                                            <div class="w-[24px] h-[24px] flex-shrink-0">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="18" height="21.33333396911621" viewBox="0 0 18 21.33333396911621"><g><path d="M0.058715209,10.938917L5.715858,0.27225035C5.8046255,0.10487713,5.9801216,-4.0367166e-8,6.1714282,0L15.42857,0C15.712603,0,15.942856,0.22741088,15.942856,0.50793648C15.942856,0.62174666,15.904155,0.73225951,15.832962,0.82175058L10.829554,7.1111107L17.485714,7.1111107C17.769747,7.1111107,18,7.338522,18,7.6190467C18,7.7467375,17.951305,7.8697429,17.863613,7.9635706L5.5207558,21.169918C5.3281026,21.376051,5.0027351,21.388905,4.7940273,21.198627C4.6542125,21.071161,4.5970807,20.877867,4.6455045,20.696129L7.0471525,11.682539L0.51428568,11.682539C0.2302535,11.682539,0,11.455128,0,11.174603C4.087175e-8,11.092509,0.020146912,11.011638,0.058715209,10.938917ZM7.7142859,10.666666L1.3642416,10.666666L6.4826088,1.015873L14.370445,1.015873L9.3670368,7.3052325C9.191555,7.525815,9.2303524,7.8451319,9.4536915,8.0184469C9.544301,8.0887613,9.6561956,8.1269836,9.7714291,8.1269836L16.311094,8.1269836L6.1658173,18.98201L8.2116385,11.303869C8.2463503,11.173591,8.2272406,11.035029,8.158514,10.918669C8.0897884,10.802305,7.9770737,10.717673,7.8451686,10.683391C7.8024492,10.672287,7.7584591,10.666666,7.7142859,10.666666Z" fill-rule="evenodd" fill="#737373" fill-opacity="1"/></g></svg>                                            </div>
                                            <div class="flex flex-col gap-[2px]">
                                                <div class="text-default text-[14px] text-left font-medium line-clamp-1 step3-content-display">
                                                 
                                                </div>
                                                <div class="text-[#737373] text-[12px] text-left font-normal line-clamp-1 w-full">
                                                   ${this.getAttribute('data-power-description')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                          </div>
               

                  </div>
                   <div class="border-t border-[#cdcdcd] border-solid py-[12px] flex flex-col  justify-end mt-auto">
                      ${
                        this.getAttribute('data-is-show-review-stars') === 'true'
                          ? this.renderReviewStars(product.review_value, product.review_count)
                          : ''
                      }                   
                            <div class="flex items-end justify-start gap-[16px] pt-[12px]  w-full">
                      <span class="text-[20px] font-bold text-[#D14C46]">
                        ${
                          // 根据global_preferential_type决定显示方式
                          this.getAttribute('data-global-preferential-type') === 'after' &&
                          availableVariant?.best_discount_cents > 0
                            ? // after模式且有折扣，显示折后价(final_cents)
                              window.Shopify.formatMoney(availableVariant.final_cents, window.shopMoneyFormat)
                            : // before模式或没有折扣，显示原价
                              productPrice
                        }
                      </span>
                         ${
                           // 根据global_preferential_type决定显示方式
                           this.getAttribute('data-global-preferential-type') === 'after' &&
                           availableVariant?.best_discount_cents > 0
                             ? // after模式且有折扣，显示compare_at_price
                               `<span class="text-[16px] text-[#737373] line-through">${compareAtPrice}</span>`
                             : // before模式或没有折扣，使用原来的逻辑
                             availableVariant?.compare_at_price &&
                               availableVariant?.compare_at_price > availableVariant?.price
                             ? `<span class="text-[16px] text-[#737373] line-through">${compareAtPrice}</span>`
                             : ''
                         }
                    </div>
                    </div>
                                              <button 
                             type="button" 
                             data-product-url="${productUrl}" 
                             data-global-preferential-type="${this.getAttribute('data-global-preferential-type')}"
                             class=" cursor-pointer
                             product-link-btn fill-primary relative inline-flex w-full h-[33px] font-semibold items-center justify-center overflow-hidden tracking-tighter text-white bg-black hover:bg-primary rounded-[2px] group/add_to_cart transition-colors duration-[600ms]">
                            <svg
                                class="
                                absolute scale-50 opacity-0 transition-all duration-[1200ms] ease-out max-lg:hidden
                                group-hover/add_to_cart:opacity-100 group-hover/add_to_cart:scale-100 group-hover/add_to_cart:w-[100%] group-hover/add_to_cart:h-[100%]
                            
                                "
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                version="1.1"
                                viewBox="0 0 22 32"
                            >
                                <g>
                                <path
                                    d="M21.1366,14.6468L15.2607,14.6468C14.7312,14.6468,14.3266,14.1744,14.4127,13.6595L16.5048,0.991084C16.6425,0.161274,15.6051,-0.340867,15.024,0.271915L0.232959,15.9191C-0.279302,16.4638,0.108122,17.3532,0.861448,17.3532L6.73738,17.3532C7.26686,17.3532,7.6715,17.8256,7.58541,18.3405L5.49332,31.0089C5.35557,31.8387,6.393,32.3409,6.97414,31.7281L21.7651,16.0809C22.2817,15.5362,21.89,14.6468,21.1366,14.6468Z" fill-opacity="1" style="mix-blend-mode:passthrough" />
                                </g>
                            </svg>
                            <div class="h-full relative z-10 flex items-center justify-center">
                                <i
                                class=" items-center hidden justify-center cursor-pointer rotate_icon "
                                >
                                </i>
                                <span class="relative z-10 text-[14px] loading-button-text">${this.getAttribute(
                                  'data-buy-btn-text'
                                )}</span>
                            </div>
                        </button>
                  </div>
              
              </global-product>
            `;
            } catch (error) {
              console.error('Error in renderGlobalProduct:', error);
              return '<div style="color: red; padding: 20px;">Error rendering product</div>';
            }
          }

          calculateDiscount(compareAtPrice, price) {
            if (!compareAtPrice || !price || compareAtPrice <= price) return 0;
            const discount = compareAtPrice - price;
            return Math.floor((discount * 100.0) / compareAtPrice);
          }

          /**
           * 渲染评分星级（与 snippets/judgeme-badge.liquid 对齐）
           * - 评论数：仅 data-is-show-review-stars 开启且 count > 0，格式 (count)（对应 show_count && review_count > 0）
           * @param {number} reviewValue - 评分值 (0-5)
           * @param {number} reviewCount - 评论数量
           * @returns {string} HTML字符串
           */
          renderReviewStars(reviewValue, reviewCount) {
            const rating = parseFloat(reviewValue) || 0;
            const count = parseInt(reviewCount, 10) || 0;
            const showReviewUi = this.getAttribute('data-is-show-review-stars') === 'true';

            if (!showReviewUi) {
              return '';
            }

            const showStarsAndRating = rating > 0;
            const showCount = count > 0;

            if (!showStarsAndRating && !showCount) {
              return '';
            }

            let starsHtml = '';
            if (showStarsAndRating) {
              for (let i = 1; i <= 5; i++) {
                const starFraction = rating - (i - 1);
                let starType = 'empty';

                if (rating >= i) {
                  starType = 'full';
                } else if (starFraction > 0.25 && starFraction <= 0.75) {
                  starType = 'half';
                } else if (starFraction > 0.75 && starFraction < 1) {
                  starType = 'full';
                }

                starsHtml += this.renderStarSvg(starType);
              }
            }

            const roundedRating = Math.round(rating * 10) / 10;
            const ratingText = showStarsAndRating
              ? `<span class="text-[14px] text-[#737373]">${roundedRating.toFixed(1)}</span>`
              : '';
            const countText = showCount ? `<span class="text-[14px] text-[#737373]">(${count})</span>` : '';

            return `
              <div class="flex items-center gap-[8px]">
                ${showStarsAndRating ? `<div class="flex items-center gap-[4px]">${starsHtml}</div>` : ''}
                ${ratingText}
                ${countText}
              </div>
            `;
          }

          /**
           * 渲染单个星星SVG
           * @param {string} type - 星星类型: 'full', 'half', 'empty'
           * @returns {string} SVG HTML字符串
           */
          renderStarSvg(type) {
            const fullStar = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16" height="16" viewBox="0 0 16 16"><path d="M10.336074,4.4105449Q10.390301,4.5129271,10.484031,4.5810251Q10.577761,4.6491237,10.691888,4.6690588L14.678524,5.3654275Q14.711935,5.3712635,14.744252,5.3815584Q14.776569,5.3918533,14.807201,5.4064188Q14.837832,5.4209838,14.866216,5.4395523Q14.8946,5.4581208,14.920216,5.4803524Q14.945831,5.5025835,14.968209,5.5280704Q14.990589,5.5535574,15.009321,5.5818338Q15.028052,5.6101098,15.042793,5.6406565Q15.057535,5.6712036,15.068017,5.7034612Q15.078497,5.7357187,15.084526,5.7690959Q15.090555,5.8024735,15.092022,5.83636Q15.093487,5.8702459,15.090364,5.9040194Q15.08724,5.9377933,15.079584,5.9708357Q15.071927,6.0038776,15.059878,6.0355835Q15.04783,6.0672894,15.03161,6.0970774Q15.01539,6.1268649,14.995296,6.1541896Q14.975202,6.1815138,14.951602,6.2058749L12.13566,9.1125355Q12.055046,9.1957474,12.019245,9.305933Q11.983444,9.4161186,11.999751,9.5308199L12.569404,13.537526Q12.574177,13.571105,12.574372,13.605022Q12.574568,13.638939,12.570182,13.672573Q12.565794,13.706205,12.556906,13.738937Q12.548018,13.771669,12.53479,13.802902Q12.521563,13.834134,12.504238,13.863294Q12.486914,13.892452,12.46581,13.919005Q12.444706,13.945559,12.42021,13.969019Q12.395714,13.992477,12.368275,14.012415Q12.340834,14.032351,12.310953,14.048398Q12.281073,14.064445,12.249298,14.076312Q12.217524,14.088177,12.184438,14.095642Q12.151352,14.103107,12.11756,14.106037Q12.083769,14.108965,12.049891,14.107305Q12.016014,14.105642,11.982672,14.099422Q11.949329,14.093201,11.917133,14.082534Q11.884937,14.071867,11.854476,14.056951L8.2199049,12.27704Q8.1158562,12.226085,8,12.226085Q7.8841438,12.226085,7.7800946,12.27704L4.1455231,14.056952Q4.1150618,14.071869,4.0828648,14.082535Q4.0506678,14.093202,4.0173259,14.099423Q3.9839835,14.105644,3.9501066,14.107305Q3.9162297,14.108967,3.8824391,14.106038Q3.8486481,14.103108,3.815562,14.095643Q3.7824759,14.088177,3.7507017,14.076312Q3.7189269,14.064445,3.6890459,14.048398Q3.6591651,14.032351,3.6317253,14.012414Q3.6042852,13.992477,3.5797889,13.969018Q3.5552926,13.945559,3.5341892,13.919006Q3.5130854,13.892454,3.4957609,13.863295Q3.4784365,13.834135,3.465209,13.802903Q3.4519811,13.771671,3.4430923,13.738938Q3.4342036,13.706205,3.4298172,13.672573Q3.4254303,13.63894,3.4256258,13.605022Q3.4258213,13.571106,3.4305959,13.537526L4.0002475,9.5308199Q4.0165558,9.4161186,3.9807544,9.305933Q3.9449527,9.1957474,3.8643389,9.1125355L1.0483978,6.2058754Q1.0247974,6.1815147,1.0047033,6.1541901Q0.98460907,6.1268654,0.96838921,6.0970774Q0.9521693,6.0672894,0.94012082,6.035584Q0.92807233,6.0038786,0.92041612,5.9708366Q0.91275978,5.9377942,0.90963602,5.9040208Q0.90651214,5.8702469,0.90797806,5.8363614Q0.90944391,5.802475,0.91547263,5.7690978Q0.9215014,5.7357202,0.93198258,5.7034626Q0.9424637,5.6712046,0.95720518,5.6406584Q0.97194666,5.6101112,0.99067843,5.5818357Q1.0094101,5.5535593,1.0317889,5.5280724Q1.0541677,5.5025854,1.0797837,5.4803538Q1.1053994,5.4581223,1.1337829,5.4395533Q1.1621664,5.4209852,1.1927974,5.4064202Q1.2234285,5.3918548,1.2557461,5.3815594Q1.2880635,5.3712645,1.3214755,5.3654284L5.3081112,4.6690588Q5.4222388,4.6491232,5.5159683,4.5810246Q5.6096978,4.5129261,5.6639252,4.4105449L7.5581508,0.83421808Q7.5740261,0.804245,7.5938034,0.7766906Q7.6135817,0.74913609,7.6368999,0.72450507Q7.6602173,0.69987404,7.6866484,0.67861772Q7.7130785,0.65736139,7.7421379,0.63986921Q7.7711968,0.62237704,7.802352,0.60896951Q7.8335075,0.59556198,7.866188,0.58648479Q7.8988681,0.5774076,7.9324746,0.57282704Q7.9660816,0.56824648,7.9999995,0.56824648Q8.0339165,0.56824648,8.067524,0.57282704Q8.1011314,0.5774076,8.133812,0.58648479Q8.1664925,0.59556198,8.1976471,0.60896957Q8.2288017,0.62237704,8.2578621,0.63986927Q8.2869205,0.65736139,8.3133516,0.67861778Q8.3397827,0.6998741,8.3631001,0.72450519Q8.3864174,0.74913621,8.4061947,0.77669072Q8.4259729,0.80424511,8.4418488,0.8342182L10.336074,4.4105449Z" fill="#EA5504" fill-opacity="1"/></svg>`;

            const halfStar = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16" height="16" viewBox="0 0 16 16"><g><path d="M8.000284276655577,0.5681336331927954L8.000284276655577,12.225971483802795Q7.884428176655579,12.225971483802795,7.780378976655578,12.276926483802795L4.145807376655579,14.056838483802796Q4.0846034766555785,14.086810483802795,4.017610676655579,14.099310483802796Q3.9506178766555786,14.111810483802795,3.8827236766555786,14.105926483802795Q3.8148289766555785,14.100040483802795,3.7509861766555788,14.076199483802796Q3.6871431766555784,14.052358483802795,3.6320095766555784,14.012302483802795Q3.5768757766555788,13.972243483802796,3.5344732766555786,13.918893483802796Q3.4920707766555785,13.865542483802795,3.465493276655579,13.802789483802796Q3.4389155766555786,13.740035483802796,3.4301014766555786,13.672460483802796Q3.4212876766555786,13.604882483802795,3.4308801766555788,13.537413483802796L4.000531776655579,9.530706983802796Q4.0168395766555784,9.416004783802796,3.9810381766555785,9.305819183802795Q3.9452367766555785,9.195633483802796,3.8646231766555785,9.112422583802795L1.0486820966555785,6.205762483802795Q1.0012633576555787,6.156816083802795,0.9686735416555786,6.096964483802795Q0.9360837286555787,6.037112783802796,0.9207003576555786,5.970723283802795Q0.9053169852555786,5.904332783802795,0.9082623263855786,5.836247583802796Q0.9112076675555786,5.768162383802795,0.9322668496555786,5.703349183802795Q0.9533260316555786,5.6385355838027955,0.9909627216555786,5.581722383802796Q1.0285994066555786,5.524908683802796,1.0800678866555786,5.480240483802795Q1.1315363666555787,5.435571283802795,1.1930818266555785,5.406306883802795Q1.2546272866555785,5.377041483802795,1.3217598166555786,5.365315583802795L5.308395476655579,4.668945883802795Q5.422523176655579,4.649010283802795,5.516252676655578,4.5809117838027955Q5.609982176655579,4.512813683802795,5.664209476655579,4.410431983802795L7.558435076655579,0.8341051938027955Q7.590332176655578,0.7738820438027953,7.637183276655579,0.7243922238027954Q7.684034476655579,0.6749023938027954,7.742421776655578,0.6397563068027954Q7.800808076655579,0.6046102268027954,7.8664713766555785,0.5863719228027954Q7.9321347766555785,0.5681336194127954,8.000284276655577,0.5681336331927954Z" fill-rule="evenodd" fill="#EA5504" fill-opacity="1"/></g><path d="M10.691888,4.6690588Q10.577761,4.6491237,10.484031,4.5810251Q10.390301,4.5129271,10.336074,4.4105449L8.4418488,0.83421814Q8.4099522,0.77399504,8.363101,0.72450519Q8.3162498,0.67501539,8.257863,0.63986933Q8.1994762,0.60472322,8.133812,0.58648485Q8.0681496,0.56824654,8,0.56824648Q7.9318504,0.56824648,7.8661871,0.58648473Q7.8005242,0.60472298,7.7421374,0.63986909Q7.6837502,0.67501515,7.636899,0.72450501Q7.5900478,0.77399486,7.5581503,0.83421808L5.6639252,4.4105449Q5.6096973,4.5129261,5.5159683,4.5810246Q5.4222383,4.6491232,5.3081112,4.6690588L1.3214755,5.3654284Q1.2543429,5.3771548,1.1927974,5.4064198Q1.1312521,5.4356847,1.0797836,5.4803534Q1.0283151,5.5250216,0.99067843,5.5818353Q0.95304179,5.638648,0.93198258,5.7034616Q0.91092342,5.7682753,0.90797806,5.8363609Q0.90503275,5.9044461,0.92041612,5.9708366Q0.93579942,6.0372267,0.96838921,6.0970778Q1.0009789,6.156929,1.0483978,6.2058754L3.8643386,9.1125355Q3.9449525,9.1957474,3.9807539,9.305932Q4.0165558,9.4161177,4.0002475,9.5308189L3.4305956,13.537525Q3.4210026,13.604995,3.4298165,13.672571Q3.4386306,13.740149,3.4652085,13.802901Q3.491786,13.865654,3.5341885,13.919004Q3.576591,13.972356,3.6317251,14.012414Q3.6868589,14.052471,3.7507019,14.076312Q3.8145447,14.100153,3.8824391,14.106039Q3.9503334,14.111923,4.0173259,14.099423Q4.0843191,14.086924,4.1455231,14.056951L7.7800946,12.27704Q7.8841438,12.226084,8,12.226085Q8.1158562,12.226084,8.2199049,12.27704L11.854476,14.056951Q11.915679,14.086923,11.982672,14.099422Q12.049664,14.111922,12.117559,14.106037Q12.185453,14.100151,12.249296,14.076311Q12.313139,14.052469,12.368273,14.012412Q12.423407,13.972355,12.465809,13.919004Q12.508211,13.865653,12.534789,13.8029Q12.561367,13.740149,12.570181,13.672572Q12.578996,13.604996,12.569404,13.537525L11.999751,9.5308189Q11.983444,9.4161177,12.019245,9.305932Q12.055046,9.1957474,12.13566,9.1125355L14.951602,6.2058749Q14.99902,6.1569281,15.03161,6.0970769Q15.064198,6.0372257,15.079582,5.9708357Q15.094965,5.9044452,15.092019,5.83636Q15.089073,5.7682743,15.068015,5.7034612Q15.046956,5.638648,15.009319,5.5818343Q14.971684,5.5250211,14.920215,5.4803524Q14.868747,5.4356837,14.807202,5.4064188Q14.745657,5.3771539,14.678525,5.3654275L10.691888,4.6690588ZM8,2.1364927L9.4523754,4.8786016Q9.7961988,5.5277452,10.519818,5.6541433L13.576526,6.1880765L11.417434,8.4167261Q10.90631,8.9443188,11.009707,9.6715784L11.446482,12.743675L8.6597157,11.378948Q8,11.055872,7.340282,11.378949L4.5535173,12.743675L4.9902916,9.6715784Q5.0936904,8.9443169,4.5825648,8.4167252L2.4234741,6.188077L5.4801817,5.6541433Q6.2037992,5.5277452,6.5476236,4.8786016L8,2.1364927Z" fill-rule="evenodd" fill="#EA5504" fill-opacity="1"/></svg>`;

            const emptyStar = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16" height="16" viewBox="0 0 16 16"><path d="M10.691888,4.6690588Q10.577761,4.6491237,10.484031,4.5810251Q10.390301,4.5129271,10.336074,4.4105449L8.4418488,0.83421814Q8.4099522,0.77399504,8.363101,0.72450519Q8.3162498,0.67501539,8.257863,0.63986933Q8.1994762,0.60472322,8.133812,0.58648485Q8.0681496,0.56824654,8,0.56824648Q7.9318504,0.56824648,7.8661871,0.58648473Q7.8005242,0.60472298,7.7421374,0.63986909Q7.6837502,0.67501515,7.636899,0.72450501Q7.5900478,0.77399486,7.5581503,0.83421808L5.6639252,4.4105449Q5.6096973,4.5129261,5.5159683,4.5810246Q5.4222383,4.6491232,5.3081112,4.6690588L1.3214755,5.3654284Q1.2543429,5.3771548,1.1927974,5.4064198Q1.1312521,5.4356847,1.0797836,5.4803534Q1.0283151,5.5250216,0.99067843,5.5818353Q0.95304179,5.638648,0.93198258,5.7034616Q0.91092342,5.7682753,0.90797806,5.8363609Q0.90503275,5.9044461,0.92041612,5.9708366Q0.93579942,6.0372267,0.96838921,6.0970778Q1.0009789,6.156929,1.0483978,6.2058754L3.8643386,9.1125355Q3.9449525,9.1957474,3.9807539,9.305932Q4.0165558,9.4161177,4.0002475,9.5308189L3.4305956,13.537525Q3.4210026,13.604995,3.4298165,13.672571Q3.4386306,13.740149,3.4652085,13.802901Q3.491786,13.865654,3.5341885,13.919004Q3.576591,13.972356,3.6317251,14.012414Q3.6868589,14.052471,3.7507019,14.076312Q3.8145447,14.100153,3.8824391,14.106039Q3.9503334,14.111923,4.0173259,14.099423Q4.0843191,14.086924,4.1455231,14.056951L7.7800946,12.27704Q7.8841438,12.226084,8,12.226085Q8.1158562,12.226084,8.2199049,12.27704L11.854476,14.056951Q11.915679,14.086923,11.982672,14.099422Q12.049664,14.111922,12.117559,14.106037Q12.185453,14.100151,12.249296,14.076311Q12.313139,14.052469,12.368273,14.012412Q12.423407,13.972355,12.465809,13.919004Q12.508211,13.865653,12.534789,13.8029Q12.561367,13.740149,12.570181,13.672572Q12.578996,13.604996,12.569404,13.537525L11.999751,9.5308189Q11.983444,9.4161177,12.019245,9.305932Q12.055046,9.1957474,12.13566,9.1125355L14.951602,6.2058749Q14.99902,6.1569281,15.03161,6.0970769Q15.064198,6.0372257,15.079582,5.9708357Q15.094965,5.9044452,15.092019,5.83636Q15.089073,5.7682743,15.068015,5.7034612Q15.046956,5.638648,15.009319,5.5818343Q14.971684,5.5250211,14.920215,5.4803524Q14.868747,5.4356837,14.807202,5.4064188Q14.745657,5.3771539,14.678525,5.3654275L10.691888,4.6690588ZM8,2.1364927L9.4523754,4.8786016Q9.7961988,5.5277452,10.519818,5.6541433L13.576526,6.1880765L11.417434,8.4167261Q10.90631,8.9443188,11.009707,9.6715784L11.446482,12.743675L8.6597157,11.378948Q8,11.055872,7.340282,11.378949L4.5535173,12.743675L4.9902916,9.6715784Q5.0936904,8.9443169,4.5825648,8.4167252L2.4234741,6.188077L5.4801817,5.6541433Q6.2037992,5.5277452,6.5476236,4.8786016L8,2.1364927Z" fill-rule="evenodd" fill="#e0e0e0" fill-opacity="1"/></svg>`;

            switch (type) {
              case 'full':
                return fullStar;
              case 'half':
                return halfStar;
              case 'empty':
              default:
                return emptyStar;
            }
          }

          /**
           * 根据is_show配置获取产品变体
           * @param {Object} product - 产品对象
           * @returns {Object|null} 返回选中的变体对象
           * - 如果is_show为true: 返回最后一个变体
           * - 如果is_show为false: 返回第一个可用（available）的变体，如果都不可用则返回第一个变体
           */
          getFirstAvailableVariant(product) {
            // 时区转换函数：将UTC时间转换为用户当地时区
            const convertToLocalTimezone = (utcTimeString) => {
              if (!utcTimeString) return null;

              try {
                // 直接使用UTC时间戳，不需要时区转换
                const utcDate = new Date(utcTimeString);
                const utcTimestamp = Math.floor(utcDate.getTime() / 1000);
                return utcTimestamp;
              } catch (error) {
                console.error('时区转换错误:', error);
                return null;
              }
            };

            // 根据is_show配置决定使用第一个还是最后一个变体
            const isShowLast = this.getAttribute('data-is-show') === 'true';
            let selectedVariant;

            if (isShowLast) {
              // 如果is_show为true，获取最后一个变体
              selectedVariant = product.variants[product.variants.length - 1];
            } else {
              // 如果is_show为false，获取第一个可用（available）的变体
              selectedVariant = product.variants.find((variant) => variant.available) || product.variants[0];
            }

            const lastVariant = selectedVariant;

            // 直接从product.discount获取折扣数据
            if (product && product.discount && lastVariant) {
              // 将折扣数据添加到变体对象中，方便后续使用
              lastVariant.discount_data = product.discount;

              // 计算最佳折扣
              try {
                const now = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
                let bestPercentCents = 0; // 最佳百分比折扣（分）
                let bestPercentTitle = ''; // 最佳百分比折扣标题

                // 处理百分比折扣
                if (product.discount.percentage && Array.isArray(product.discount.percentage)) {
                  product.discount.percentage.forEach((item) => {
                    // 检查折扣是否在有效期内 - 转换为当地时区
                    const start = convertToLocalTimezone(item.validityStart);
                    // 如果validityEnd为空，表示永久有效
                    const hasEndDate = item.validityEnd != null && item.validityEnd !== '';
                    const end = hasEndDate ? convertToLocalTimezone(item.validityEnd) : Infinity;

                    // 检查折扣是否在有效期内
                    if ((start === null || now >= start) && (!hasEndDate || now <= end)) {
                      // 计算折扣金额（分）
                      const quota = parseInt(item.discountQuota || 0, 10);
                      const discountAmount = Math.floor((lastVariant.price * quota) / 100);

                      // 如果这个折扣更大，则更新最佳折扣
                      if (discountAmount > bestPercentCents) {
                        bestPercentCents = discountAmount;
                        bestPercentTitle = item.discountTitle || '';
                      }
                    }
                  });
                }

                // 处理固定金额折扣
                let bestAmountCents = 0; // 最佳固定金额折扣（分）
                let bestAmountTitle = ''; // 最佳固定金额折扣标题

                if (product.discount.amount && Array.isArray(product.discount.amount)) {
                  product.discount.amount.forEach((item) => {
                    // 检查折扣是否在有效期内 - 转换为当地时区
                    const start = convertToLocalTimezone(item.validityStart);
                    // 如果validityEnd为空，表示永久有效
                    const hasEndDate = item.validityEnd != null && item.validityEnd !== '';
                    const end = hasEndDate ? convertToLocalTimezone(item.validityEnd) : Infinity;

                    // 检查折扣是否在有效期内
                    if ((start === null || now >= start) && (!hasEndDate || now <= end)) {
                      // 计算折扣金额（分）
                      const quota = parseInt(item.discountQuota || 0, 10);
                      const discountAmount = quota * 100; // 转换为分

                      // 如果这个折扣更大，则更新最佳折扣
                      if (discountAmount > bestAmountCents) {
                        bestAmountCents = discountAmount;
                        bestAmountTitle = item.discountTitle || '';
                      }
                    }
                  });
                }

                // 比较两种类型的折扣，选择最大的
                let bestDiscountCents = 0;
                let bestDiscountTitle = '';
                let finalQuota = 0;

                if (bestPercentCents > bestAmountCents) {
                  bestDiscountCents = bestPercentCents;
                  bestDiscountTitle = bestPercentTitle;
                  // 从百分比折扣中找到对应的quota
                  if (product.discount.percentage && Array.isArray(product.discount.percentage)) {
                    product.discount.percentage.forEach((item) => {
                      const start = convertToLocalTimezone(item.validityStart);
                      const hasEndDate = item.validityEnd != null && item.validityEnd !== '';
                      const end = hasEndDate ? convertToLocalTimezone(item.validityEnd) : Infinity;
                      const quota = parseInt(item.discountQuota || 0, 10);
                      const discountAmount = Math.floor((lastVariant.price * quota) / 100);

                      if (
                        (start === null || now >= start) &&
                        (!hasEndDate || now <= end) &&
                        discountAmount === bestPercentCents
                      ) {
                        finalQuota = quota;
                      }
                    });
                  }
                } else {
                  bestDiscountCents = bestAmountCents;
                  bestDiscountTitle = bestAmountTitle;
                  // 从固定金额折扣中找到对应的quota
                  if (product.discount.amount && Array.isArray(product.discount.amount)) {
                    product.discount.amount.forEach((item) => {
                      const start = convertToLocalTimezone(item.validityStart);
                      const hasEndDate = item.validityEnd != null && item.validityEnd !== '';
                      const end = hasEndDate ? convertToLocalTimezone(item.validityEnd) : Infinity;
                      const quota = parseInt(item.discountQuota || 0, 10);
                      const discountAmount = quota * 100;

                      if (
                        (start === null || now >= start) &&
                        (!hasEndDate || now <= end) &&
                        discountAmount === bestAmountCents
                      ) {
                        finalQuota = quota;
                      }
                    });
                  }
                }

                // 确保折扣不超过原价
                if (bestDiscountCents > lastVariant.price) {
                  bestDiscountCents = lastVariant.price;
                }

                // 计算最终价格
                const finalCents = lastVariant.price - bestDiscountCents;

                // 将计算结果添加到变体对象中
                lastVariant.best_discount_cents = bestDiscountCents;
                lastVariant.best_discount_title = bestDiscountTitle;
                lastVariant.final_cents = finalCents;
                lastVariant.price_cents = lastVariant.price;
                lastVariant.quota = finalQuota;
              } catch (error) {
                console.error('计算折扣时出错:', error);
              }
            }

            // 返回最后一个variant，包含其 compare_at_price 和 price 以及折扣数据
            return lastVariant || null;
          }

          renderProductFunctions(product) {
            // 优先使用API返回的functions数据
            let functions = product.functions;

            // 如果API没有返回functions，则检查metafield
            if (!functions || !Array.isArray(functions) || functions.length === 0) {
              functions = product.metafields?.custom?.function?.value;
            }

            // 如果没有functions数据，返回空字符串，不渲染任何内容
            if (!functions || !Array.isArray(functions) || functions.length === 0) {
              return '';
            }

            return this.renderFunctionIcons(functions);
          }

          renderFunctionIcons(functions) {
            const functionIcons = functions
              .slice(0, 5)
              .map((item) => {
                const hasDescription = item.description && item.description.trim() !== '';
                const iconUrl = item.icon || '/assets/icon-product-package.svg';

                return `
                <div data-hover-status="false" class="function_icon_wrapper">
                  <div class="peer relative group/function">
                    <div
                      style="box-shadow: 0 3px 8px 0 #00000029;"
                      class="
                        function_icon
                        p-[5px] rounded-full bg-white flex items-center justify-center
                        relative cursor-pointer
                          ${
                            hasDescription
                              ? "before:content-[''] before:w-0 before:h-0 before:opacity-0 before:border-t-black before:border-l-transparent before:border-r-transparent before:border-solid before:border-l-[5px] before:border-t-[5px] before:border-r-[5px] before:bg-opacity-80 before:absolute before:top-[-1px] before:left-1/2 before:-translate-x-1/2 before:transition-top before:linear before:duration-300 min-lg:group-hover/function:before:top-[-13px] min-lg:group-hover/function:before:opacity-100"
                              : ''
                          }
                      "
                    >
                      <picture class="w-[20px] h-[20px] overflow-hidden">
                        <img
                          src="${iconUrl}"
                          alt="${item.icon?.alt || 'Function Icon'}"
                          loading="lazy"
                          class="w-[100%] h-[100%] object-cover min-lg:hover:opacity-60"
                          width="20"
                          height="20"
                        />
                      </picture>
                    </div>
                  </div>
                   ${
                     hasDescription
                       ? `<div class="function_text_wrapper w-full px-[1rem] pointer-events-none absolute z-50 opacity-0 min-lg:peer-hover:opacity-100 min-lg:peer-hover:block min-lg:peer-hover:top-[-12px] top-0 left-1/2 -translate-x-1/2 -translate-y-full bg-black text-white rounded py-2 bg-opacity-80 backdrop-blur-[10px] transition-top linear duration-300"><div class="line-clamp-4">${item.description}</div></div>`
                       : ''
                   }
                </div>
              `;
              })
              .join('');

            const containerHtml = `
              <div class="flex items-center gap-[12px] rounded-[0.25rem] relative mb-[12px]">
                ${functionIcons}
              </div>
            `;

            // 添加hover事件监听器
            setTimeout(() => {
              this.bindFunctionHoverEvents();
            }, 100);

            return containerHtml;
          }

          bindFunctionHoverEvents() {
            const functionWrappers = this.querySelectorAll('.function_icon_wrapper');
            functionWrappers.forEach((wrapper) => {
              const icon = wrapper.querySelector('.function_icon');
              if (icon) {
                icon.addEventListener('mouseenter', () => {
                  wrapper.setAttribute('data-hover-status', 'true');
                });

                icon.addEventListener('mouseleave', () => {
                  wrapper.setAttribute('data-hover-status', 'false');
                });
              }
            });
          }

          initializeProductSwiper() {
            // 销毁现有的Swiper实例（如果存在）
            if (this.productSwiper) {
              this.productSwiper.destroy(true, true);
            }

            // 初始化新的Swiper实例
            const swiperContainer = this.productsFoundDiv.querySelector('#productScreening');
            if (swiperContainer && window.Swiper) {
              this.productSwiper = new Swiper(swiperContainer, {
                slidesPerView: 'auto',
                spaceBetween: 24,
                loop: false,
                navigation: {
                  nextEl: '.scenario-rv-product_next',
                  prevEl: '.scenario-rv-product_prev',
                },
                pagination: {
                  el: '.scenario-rv-product_swiper-pagination',
                  clickable: true,
                },
                scrollbar: {
                  el: '.scenario-rv-product-scrollbar',
                  draggable: true,
                },
                breakpoints: {
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                  },
                },
                on: {
                  init: () => {
                    this.updateNavigationButtons();
                  },
                  slideChange: () => {
                    this.updateNavigationButtons();
                  },
                  resize: () => {
                    this.updateNavigationButtons();
                  },
                },
              });
            }
          }

          updateNavigationButtons() {
            if (!this.productSwiper) return;

            const prevButton = this.productsFoundDiv.querySelector('.scenario-rv-product_prev');
            const nextButton = this.productsFoundDiv.querySelector('.scenario-rv-product_next');

            if (!prevButton || !nextButton) return;

            // 检查是否在第一页
            if (this.productSwiper.isBeginning) {
              prevButton.classList.add('hidden');
              prevButton.classList.remove('flex');
            } else {
              prevButton.classList.remove('hidden');
              prevButton.classList.add('flex');
            }

            // 检查是否在最后一页
            if (this.productSwiper.isEnd) {
              nextButton.classList.add('hidden');
              nextButton.classList.remove('flex');
            } else {
              nextButton.classList.remove('hidden');
              nextButton.classList.add('flex');
            }
          }

          // 获取当前选中的Step 3内容
          getCurrentStep3Selection() {
            const step3Selection = this.currentSelections[3];
            if (step3Selection) {
              return step3Selection.name;
            }
            return null;
          }

          // 获取任意步骤的当前选中内容
          getCurrentSelection(step) {
            if (step >= 1 && step <= 4) {
              const selection = this.currentSelections[step];
              if (selection) {
                return selection.name;
              }
            }
            return null;
          }

          // 获取所有当前选中的内容
          getAllCurrentSelections() {
            const selections = {};
            for (let i = 1; i <= 4; i++) {
              const selection = this.currentSelections[i];
              selections[`step${i}`] = selection ? selection.name : null;
            }
            return selections;
          }

          showNoProducts() {
            this.productsFoundDiv.classList.replace('block', 'hidden');
            this.noProductsDiv.classList.replace('hidden', 'flex');
          }
          hideSearchResults() {
            this.noProductsDiv.classList.replace('flex', 'hidden');
            this.productsFoundDiv.classList.replace('block', 'hidden');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-form"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('product-sticky-form')) {
      customElements.define(
        'product-sticky-form',
        class productStickyForm extends HTMLElement {
          constructor() {
            super();
            this.$productInfo = null;
            this.$myThumbs = null;
            this.$myThumbsPackage = null;
            this.$myThumbsVideo = null;
            this.$myGallery = null;
            this.$myGalleryVideo = null;
            this.$myGalleryPackage = null;
            this.$galleryThumbsSwiper = null;
            this.$galleryPackageThumbsSwiper = null;
            this.$galleryMainSwiper = null;
            this.$galleryVideoMainSwiper = null;
            this.$galleryPackageMainSwiper = null;
            this.$galleryVideoThumbsSwiper = null;
            this.$thumbsImage = null;
            this.$thumbsVideo = null;
            this.$thumbsPackage = null;
            this.thumbsSwiper = null;
            this.mainSwiper = null;
            this.currentIndex = 0;
            this.$productMedia = null;
            this.imagesArray = [];
            this.destroyStatus = false;
            this.activeThumbsIndex = 0;
            this.hasUserInteracted = false;
          }

          connectedCallback() {
            const _this = this;
            try {
              // 初始化所有元素
              this.initElements();

              // 立即执行 productInfoFunction，确保在渲染前应用样式
              if (this.$productInfo) {
                requestAnimationFrame(() => {
                  this.productInfoFunction();
                });
              }

              // 检查必要元素是否存在
              if (!this.$myGallery || !this.$myThumbsPackage) {
                console.warn('Some required elements are missing');
                return;
              }

              // 获取并解析图片数据
              this.imagesArray = this.getImagesArray();

              // 按顺序初始化其他功能
              this.swiperInit();
              this.mainGallery();
              this.galleryThumbs();
              // 只有当存在视频数据时才初始化视频轮播
              if (this.$myGalleryVideo && this.$myGalleryVideo.querySelector('.swiper-slide')) {
                this.mainGalleryVideo();
              }
              // 只有当存在package数据时才初始化package轮播
              if (this.$myGalleryPackage && this.$myGalleryPackage.querySelector('.swiper-slide')) {
                this.mainGalleryPackage();
              }
              this.positionListener();
              this.changeGallery();
              // 初始化移动端图标点击弹出详情功能
              this.initMobileFunction();

              // 获取function_icon_wrapper
              const $functionIconWrapper = $(this).find('.function_icon_wrapper');
              const function_icon = $(this).find('.function_icon');

              const resetFunctionTooltipLayout = ($item) => {
                $item.find('.function_text_wrapper').attr('style', '');
              };

              const positionFunctionTooltip = ($item) => {
                const container = $item.closest('.product-sticky-form__function-container')[0];
                const itemEl = $item[0];
                const $tip = $item.find('.function_text_wrapper');
                if (!container || !itemEl || !$tip.length) return;
                const cRect = container.getBoundingClientRect();
                const iRect = itemEl.getBoundingClientRect();
                const topPx = iRect.top - cRect.top + container.scrollTop;
                $tip.css({
                  top: topPx,
                  left: 0,
                  right: 0,
                  transform: 'translateY(calc(-100% - 12px))',
                });
              };

              // 统一状态管理：保存当前激活项
              let activeFunctionItem = null;

              // 激活某个项的 tooltip
              const activateFunctionItem = ($item) => {
                // 关闭之前激活的项
                if (activeFunctionItem && activeFunctionItem !== $item[0]) {
                  const $prev = $(activeFunctionItem);
                  $prev.removeClass('function-item--function-tooltip-active');
                  $prev.attr('data-click-status', 'false');
                  resetFunctionTooltipLayout($prev);
                }
                // 激活当前项
                $item.addClass('function-item--function-tooltip-active');
                $item.attr('data-click-status', 'true');
                $item.find('.function_icon').addClass('hover_icon');
                positionFunctionTooltip($item);
                activeFunctionItem = $item[0];
              };

              // 关闭所有 tooltip
              const deactivateAllFunctionItems = () => {
                if (activeFunctionItem) {
                  const $prev = $(activeFunctionItem);
                  $prev.removeClass('function-item--function-tooltip-active');
                  $prev.attr('data-click-status', 'false');
                  resetFunctionTooltipLayout($prev);
                  $prev.find('.function_icon').removeClass('hover_icon');
                }
                activeFunctionItem = null;
              };
              $functionIconWrapper.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                const $item = $(this);
                if (window.innerWidth <= 1200) {
                  if (activeFunctionItem === this) {
                    deactivateAllFunctionItems();
                  } else {
                    activateFunctionItem($item);
                  }
                }
              });

              // hover 事件（PC端）
              $functionIconWrapper.on('mouseover', function () {
                if (window.innerWidth > 1200) {
                  activateFunctionItem($(this));
                }
              });

              // 容器级别的 mouseleave 确保鼠标移到空白处时关闭
              $(this)
                .find('.product-sticky-form__function-container')
                .on('mouseleave', function () {
                  if (window.innerWidth > 1200) {
                    deactivateAllFunctionItems();
                  }
                });

              // 点击页面其他区域关闭（仅移动端）
              document.addEventListener('click', (e) => {
                if (window.innerWidth <= 1200) {
                  const isClickOnFunctionItem = $(e.target).closest('.function_icon_wrapper').length > 0;
                  if (!isClickOnFunctionItem && activeFunctionItem) {
                    deactivateAllFunctionItems();
                  }
                }
              });

              // 窗口大小改变时重置状态
              let resizeTimer;
              $(window).on('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                  deactivateAllFunctionItems();
                }, 100);
              });
            } catch (error) {
              console.error('Error in connectedCallback:', error);
            }
          }
          // 添加 initElements 方法
          initElements() {
            this.$thumbsImage = this.querySelectorAll('.thumbs-image');
            this.$thumbsVideo = this.querySelectorAll('.thumbs-video');
            this.$thumbsPackage = this.querySelectorAll('.thumbs-package');
            this.$productInfo = this.querySelector('#product-info');
            this.$myThumbs = this.querySelector('.myThumbs');
            this.$myThumbsPackage = this.querySelector('.myThumbsPackage');
            this.$myThumbsVideo = this.querySelector('.myThumbsVideo');
            this.$myGallery = this.querySelector('.myGallery');
            this.$myGalleryPackage = this.querySelector('.myGalleryPackage');
            this.$myGalleryVideo = this.querySelector('.myGalleryVideo');
            this.$productMedia = this.querySelector('.product-media[type="application/json"]');
            this.$mainImageSwiperContainer = this.querySelector('.main-image-swiper-container');
            // read autoplay options from dataset
            this.$container = this.querySelector('.product-sticky-form-container');
            if (this.$container) {
              const attrAutoplay = this.$container.getAttribute('data-autoplay');
              const attrInterval = this.$container.getAttribute('data-autoplay-interval');
              this.autoplayEnabled = attrAutoplay === 'true' || attrAutoplay === true;
              const numericInterval = Number(attrInterval);
              if (Number.isFinite(numericInterval) && numericInterval > 0) {
                // Treat incoming value as seconds; if a legacy millisecond value (>=1000) is detected, use it directly
                this.autoplayIntervalMs = Math.floor(numericInterval * 1000);
              }
            }
          }

          disconnectedCallback() {
            this.destroyStatus = true;
            if (this.$galleryMainSwiper) {
              this.$galleryMainSwiper.destroy(true, true);
            }
            if (this.$galleryVideoMainSwiper) {
              this.$galleryVideoMainSwiper.destroy(true, true);
            }
            if (this.thumbsSwiper) {
              this.thumbsSwiper.destroy();
            }
            if (this.mainSwiper) {
              this.mainSwiper.destroy();
            }
            if (this.headerObserver) {
              this.headerObserver.disconnect();
            }
            document.removeEventListener('click', this.clearClickStatus);
            const mobileFunctionContainer = this.querySelector('.mobile-function-container');
            if (mobileFunctionContainer) {
              mobileFunctionContainer.removeEventListener('scroll', this.mobileFunctionScrollBar.bind(this));
            }
          }
          swiperInit() {
            this.$thumbsImage.forEach((img) => img.classList.add('flex'));
            this.$thumbsVideo.forEach((video) => video.classList.add('custom-hidden'));
            this.$thumbsPackage.forEach((packages) => packages.classList.add('custom-hidden'));
          }
          positionListener() {
            window.addEventListener('current_positionChange', (event) => {
              const current_position = event.detail.current_position;
              this.$galleryMainSwiper.slideToLoop(Number(current_position));
            });
          }

          productInfoFunction() {
            const view = this.$productInfo.querySelector('#view');
            const arrow = this.$productInfo.querySelector('.arrow');
            const productContent = this.$productInfo.querySelector('#product-content');
            const viewControl = this.$productInfo.querySelector('.product-sticky-form__view_control');

            if (!productContent) return;

            // 添加状态标记
            let isExpanded = false;

            // 立即设置初始样式，避免闪烁
            const maxHeight = 200;
            productContent.style.maxHeight = `${maxHeight}px`;
            productContent.style.overflow = 'hidden';
            productContent.style.transition = 'none'; // 初始化时不使用过渡

            const checkContent = () => {
              if (!productContent) return;

              // 临时移除限制以测量实际高度
              const originalMaxHeight = productContent.style.maxHeight;
              const originalOverflow = productContent.style.overflow;
              productContent.style.maxHeight = 'none';
              productContent.style.overflow = 'visible';

              // 强制重排以获取准确高度
              const contentHeight = productContent.scrollHeight;

              // 立即恢复限制，避免内容显示
              productContent.style.maxHeight = originalMaxHeight || `${maxHeight}px`;
              productContent.style.overflow = originalOverflow || 'hidden';

              if (contentHeight > maxHeight) {
                if (view) {
                  view.classList.remove('hidden');
                  view.classList.add('block');
                }

                // 设置初始状态
                if (!isExpanded) {
                  productContent.style.maxHeight = `${maxHeight}px`;
                  productContent.style.overflow = 'hidden';
                  if (viewControl) {
                    viewControl.innerHTML = viewControl.dataset.more;
                  }
                }
                // 延迟添加过渡效果，避免初始化时的动画
                setTimeout(() => {
                  productContent.style.transition = 'max-height 0.3s ease';
                }, 100);
                productContent.dataset.fullHeight = contentHeight;
              } else {
                if (view) {
                  view.classList.add('hidden');
                  view.classList.remove('block');
                }
                productContent.style.maxHeight = 'none';
                productContent.style.overflow = 'visible';
                if (viewControl) {
                  viewControl.innerHTML = viewControl.dataset.less;
                }
              }
            };

            // 立即执行一次检查
            checkContent();

            // 延迟再次检查，确保内容已完全加载（包括图片等）
            setTimeout(checkContent, 200);

            let resizeTimeout;
            window.addEventListener('resize', () => {
              clearTimeout(resizeTimeout);
              resizeTimeout = setTimeout(checkContent, 100);
            });

            if (view) {
              view.addEventListener('click', (e) => {
                // 阻止事件冒泡
                e.stopPropagation();
                e.preventDefault();

                // 确保过渡效果已应用
                if (!productContent.style.transition || productContent.style.transition === 'none') {
                  productContent.style.transition = 'max-height 0.3s ease';
                }

                isExpanded = !isExpanded;
                const fullHeight = parseInt(productContent.dataset.fullHeight, 10);

                if (!isExpanded) {
                  // 收起
                  arrow.style.transform = 'rotate(45deg)';
                  arrow.style.margin = '3px auto';
                  // 先获取当前实际高度（需要临时移除限制）
                  const originalMaxHeight = productContent.style.maxHeight;
                  const originalOverflow = productContent.style.overflow;
                  productContent.style.maxHeight = 'none';
                  productContent.style.overflow = 'visible';
                  const currentHeight = productContent.scrollHeight;
                  // 恢复限制并设置当前高度作为起始点
                  productContent.style.maxHeight = `${currentHeight}px`;
                  productContent.style.overflow = 'hidden';
                  // 强制重排，确保样式应用
                  productContent.offsetHeight;
                  // 使用 setTimeout 确保在下一帧设置目标高度，触发平滑过渡
                  setTimeout(() => {
                    productContent.style.maxHeight = '200px';
                  }, 10);
                  if (viewControl) {
                    viewControl.innerHTML = viewControl.dataset.more;
                  }
                } else {
                  // 展开
                  arrow.style.transform = 'rotate(-135deg)';
                  arrow.style.margin = '-2px auto';
                  // 先设置当前高度作为起始点
                  const currentHeight = productContent.scrollHeight;
                  productContent.style.maxHeight = `${currentHeight}px`;
                  // 强制重排，确保样式应用
                  productContent.offsetHeight;
                  // 使用 setTimeout 确保在下一帧设置目标高度，触发平滑过渡
                  setTimeout(() => {
                    productContent.style.maxHeight = `${fullHeight}px`;
                  }, 10);
                  if (viewControl) {
                    viewControl.innerHTML = viewControl.dataset.less;
                  }
                }
              });

              // 防止滚动事件影响展开状态
              productContent.addEventListener('touchmove', (e) => {
                e.stopPropagation();
              });

              // 添加过渡结束事件监听
              productContent.addEventListener('transitionend', () => {
                if (isExpanded) {
                  // 如果是展开状态，移除最大高度限制
                  productContent.style.maxHeight = 'none';
                }
              });
            }
          }
          updateCounter(current, total, container) {
            const paginationElement = this.querySelector(container);
            if (paginationElement) {
              paginationElement.innerHTML = `${current} / ${total}`;
            }
          }
          // 轮播主图
          mainGallery() {
            if (this.$myGallery) {
              this.$galleryMainSwiper = new Swiper(this.$myGallery, {
                spaceBetween: 10,
                loop: false, // 启用循环模式
                autoplay: this.autoplayEnabled
                  ? { delay: this.autoplayIntervalMs, disableOnInteraction: false }
                  : false,
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                watchOverflow: true,
                observer: true,
                observeParents: true,
                preloadImages: false,
                thumbs: {
                  swiper: this.$galleryThumbsSwiper, // 确保关联到缩略图实 例
                },
                lazy: {
                  loadPrevNext: true,
                  loadPrevNextAmount: 1,
                  loadOnTransitionStart: false,
                },
                simulateTouch: true,
                touchRatio: 0.6,
                speed: 300,
                on: {
                  init: (swiper) => {
                    this.currentIndex = swiper.realIndex; // 使用 realIndex
                    this.updateCounter(swiper.realIndex + 1, swiper.slides.length, '.image-index-container');
                  },
                  slideChange: (swiper) => {
                    this.updateCounter(
                      swiper.realIndex + 1, // 始终用 realIndex
                      swiper.slides.length,
                      '.image-index-container'
                    );
                  },
                },
              });
              // 修改点击事件，只在点击图片时触发预览
              this.$myGallery.addEventListener('click', (e) => {
                const clickedImage = e.target.closest('.swiper-slide img');
                const isNavigationClick = e.target.closest(
                  '.swiper-button-next, .swiper-button-prev, .swiper-pagination'
                );

                if (clickedImage && !isNavigationClick) {
                  const imageZoom = document.querySelector('product-image-zoom');
                  if (!imageZoom) return;

                  // 设置为非 package 模式
                  imageZoom.setMode(false);

                  // 设置图片数据并打开预览
                  imageZoom.setImages(this.imagesArray);
                  const currentIndex = this.$galleryMainSwiper.realIndex;
                  imageZoom.openPreview(currentIndex);
                }
              });
              const mainGallery = this.$myGallery; // 使用已定义的 this.$myGallery
              if (mainGallery) {
                mainGallery.addEventListener('mouseenter', () => {
                  this.$myThumbs.classList.add('show-thumbnails');
                });
              }
            }
          }

          galleryThumbs() {
            if (this.$myThumbs && !this.$galleryThumbsSwiper) {
              this.$thumbsSwiper = this.querySelector('.thumbs-swiper .swiper-wrapper');
              this.$galleryThumbsSwiper = new Swiper(this.$myThumbs, {
                slidesPerView: 8,
                spaceBetween: 12,
                watchSlidesProgress: true,
                lazy: {
                  loadPrevNext: true,
                  loadPrevNextAmount: 1,
                  loadOnTransitionStart: true,
                },
                on: {
                  init: (swiper) => {
                    const packageLength = swiper.slides.length;
                    if (packageLength < 8) {
                      this.$thumbsSwiper.style.justifyContent = 'center';
                    }
                    // 然后默认第一个激活
                    this.$thumbsSwiper.children[0].classList.add('swiper-slide-thumb-active');
                    setTimeout(() => {
                      const mainImageSwiper = this.querySelector('.main-image-swiper');
                      const thumbsSwiper = this.querySelector('.thumbs-swiper');
                      mainImageSwiper.style.opacity = 1;
                      thumbsSwiper.style.opacity = 1;
                    }, 100);
                  },
                  click: (swiper) => {
                    const clickedImage = swiper.clickedIndex;

                    // 更新缩略图激活状态
                    if (clickedImage === 0 || (clickedImage && this.$galleryMainSwiper)) {
                      swiper.slides.forEach((slide, index) => {
                        if (index === clickedImage) {
                          slide.classList.add('swiper-slide-thumb-active');
                        } else {
                          slide.classList.remove('swiper-slide-thumb-active');
                        }
                      });

                      // 切换主轮播并同步缩略图位置
                      this.$galleryMainSwiper.slideTo(clickedImage);
                      this.$galleryThumbsSwiper.slideTo(clickedImage);
                    }
                  },
                },
              });

              // 监听主轮播切换事件，同步缩略图状态
              this.$galleryMainSwiper.on('slideChange', () => {
                const activeIndex = this.$galleryMainSwiper.activeIndex;

                // 更新缩略图激活状态
                this.$galleryThumbsSwiper.slides.forEach((slide, index) => {
                  if (index === activeIndex) {
                    slide.classList.add('swiper-slide-thumb-active');
                  } else {
                    slide.classList.remove('swiper-slide-thumb-active');
                  }
                });

                // 同步缩略图位置
                this.$galleryThumbsSwiper.slideTo(activeIndex);
              });
            }
          }

          mainGalleryVideo() {
            const videoSwiper = this.$myGalleryVideo.querySelector('.video-swiper');
            this.$videoMainSwiper = new Swiper(videoSwiper, {
              spaceBetween: 10,
              loop: false,
              navigation: {
                nextEl: videoSwiper.querySelector('.swiper-button-next'),
                prevEl: videoSwiper.querySelector('.swiper-button-prev'),
              },
              preloadImages: false,
              lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
              },
              on: {
                init: (swiper) => {
                  this.updateVideoPagination(swiper);
                  // 初始化移动端点击视频任意区域播放/暂停
                  this.initMobileVideoControl();
                },
                slideChange: (swiper) => {
                  // 停止上一个video
                  const swiperPrev = swiper.slides[swiper.activeIndex - 1];
                  if (swiperPrev) {
                    swiperPrev.querySelector('video').pause();
                  }
                  this.updateVideoPagination(swiper);
                },
              },
            });
          }
          // 移动端：点击视频任意区域播放/暂停
          initMobileVideoControl() {
            if (!this.$myGalleryVideo) return;

            const isMobile = () => window.innerWidth <= 768;
            const bindToggle = (slide) => {
              const video = slide.querySelector('video');
              if (!video) return;

              const handler = (e) => {
                if (!isMobile()) return;
                e.preventDefault();
                e.stopPropagation();
                if (video.paused) {
                  video.play();
                } else {
                  video.pause();
                }
              };

              // 绑定到整个视频滑块区域，保证点击任意位置均可
              slide.addEventListener('click', handler);
              slide.addEventListener('touchend', handler);
            };

            // 初次绑定
            this.$myGalleryVideo.querySelectorAll('.swiper-slide-video').forEach(bindToggle);

            // 在窗口尺寸变化时保持仅移动端生效（无需重复绑定，判断在handler内部）
            // 无额外监听即可
          }
          updateVideoPagination(swiper) {
            const paginationEl = swiper.el.querySelector('.video-index-container');
            if (!paginationEl) {
              return;
            }
            if (swiper.slides && swiper.slides.length > 0) {
              const currentIndex = swiper.activeIndex + 1;
              const total = swiper.slides.length;
              paginationEl.innerText = `${currentIndex} / ${total}`;
            }
          }

          // 轮播Package主图
          mainGalleryPackage() {
            // 检查必要的元素是否存在
            if (!this.$myGalleryPackage) {
              return;
            }

            // 检查元素是否可见（不是 hidden 状态）
            if (
              this.$myGalleryPackage.classList.contains('hidden') ||
              this.$myGalleryPackage.style.display === 'none' ||
              getComputedStyle(this.$myGalleryPackage).display === 'none'
            ) {
              return;
            }

            // 然后初始化主图 Swiper
            this.$galleryPackageMainSwiper = new Swiper(this.$myGalleryPackage, {
              spaceBetween: 0,
              navigation: {
                nextEl: this.$myGalleryPackage.querySelector('.package-nav-btn__next'),
                prevEl: this.$myGalleryPackage.querySelector('.package-nav-btn__prev'),
              },
              thumbs: {
                swiper: this.$galleryPackageThumbsSwiper,
              },
              slidesPerView: 1,
              preloadImages: false,
              lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
              },
              watchSlidesProgress: true,
              observer: true, // 启用观察者模式
              observeParents: true, // 观察父元素
              observeSlideChildren: true, // 观察子元素
              on: {
                init: (swiper) => {
                  this.updatePackagePagination(swiper);
                },
                observerUpdate: (swiper) => {
                  this.updatePackagePagination(swiper);
                },
                slideChange: (swiper) => {
                  this.updatePackagePagination(swiper);

                  if (this.$galleryPackageThumbsSwiper) {
                    this.$galleryPackageThumbsSwiper.slideTo(swiper.activeIndex);

                    this.$galleryPackageThumbsSwiper.slides.forEach((slide, index) => {
                      if (index === swiper.activeIndex) {
                        slide.classList.add('swiper-slide-thumb-active');
                      } else {
                        slide.classList.remove('swiper-slide-thumb-active');
                      }
                    });
                  }
                },
              },
            });
            // 添加点击事件，仿照 mainGallery 的处理方式
            this.$myGalleryPackage.addEventListener('click', (e) => {
              const clickedImage = e.target.closest('.swiper-slide img');
              const isNavigationClick = e.target.closest(
                '.swiper-button-next, .swiper-button-prev, .swiper-pagination, .package-nav-btn'
              );

              if (clickedImage && !isNavigationClick) {
                const imageZoom = document.querySelector('product-image-zoom');
                if (!imageZoom) return;

                // 首先尝试获取 package-media 数据
                const packageMediaScript = imageZoom.querySelector('.package-media[type="application/json"]');
                if (packageMediaScript && packageMediaScript.textContent) {
                  try {
                    const packageData = JSON.parse(packageMediaScript.textContent);
                    if (packageData && Object.keys(packageData).length > 0) {
                      // 设置为 package 模式
                      imageZoom.setMode(true);

                      const formattedPackageData = Object.entries(packageData).map(([index, url]) => ({
                        [`${parseInt(index) + 1}.img`]: url.startsWith('//') ? `https:${url}` : url,
                      }));
                      imageZoom.setImages(formattedPackageData);
                      const currentIndex = this.$galleryPackageMainSwiper.realIndex;
                      imageZoom.openPreview(currentIndex);
                      return;
                    }
                  } catch (error) {
                    console.error('Error parsing package media data:', error);
                  }
                }

                // 如果没有 package 数据，回退到 product 数据
                imageZoom.setMode(false); // 设置为非 package 模式
                // 如果没有 package 数据或解析失败，回退到使用 product-media 数据
                const productMediaScript = imageZoom.querySelector('.product-media[type="application/json"]');
                if (!productMediaScript) return;

                try {
                  const productData = JSON.parse(productMediaScript.textContent);
                  const formattedProductData = productData
                    .filter((media) => media.media_type === 'image')
                    .map((media, index) => ({
                      [`${index + 1}.img`]: media.preview_image.src,
                    }));

                  if (formattedProductData.length > 0) {
                    imageZoom.setImages(formattedProductData);
                    const currentIndex = this.$galleryPackageMainSwiper.realIndex;
                    imageZoom.openPreview(currentIndex);
                  }
                } catch (error) {
                  console.error('Error parsing product media data:', error);
                }
              }
            });
          }

          // 添加更新分页的方法
          updatePackagePagination(swiper) {
            const paginationEl = swiper.el.querySelector('.package-index-container');
            if (!paginationEl) {
              return;
            }

            // 等待下一帧更新
            requestAnimationFrame(() => {
              if (swiper.slides && swiper.slides.length > 0) {
                const currentIndex = swiper.activeIndex + 1;
                const total = swiper.slides.length;
                paginationEl.textContent = `${currentIndex} / ${total}`;
              } else {
              }
            });
          }

          // 轮播Package缩略图
          mainGalleryPackageThumbs() {
            this.$thumbsPackageSwiper = this.querySelector('.thumbs-package-swiper .swiper-wrapper');

            this.$galleryPackageThumbsSwiper = new Swiper(this.$myThumbsPackage, {
              watchSlidesProgress: true,
              slidesPerView: 8,
              preloadImages: false,
              lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
              },
              breakpoints: {
                960: {
                  spaceBetween: 15,
                },
                0: {
                  spaceBetween: 10,
                },
              },
              on: {
                init: (swiper) => {
                  // 获取当前缩略图中所有得length
                  setTimeout(() => {
                    const packageLength = swiper.slides.length;
                    if (packageLength < 8) {
                      this.$thumbsPackageSwiper.style.justifyContent = 'center';
                    }
                    // 然后默认第一个激活
                    this.$thumbsPackageSwiper.children[0].classList.add('swiper-slide-thumb-active');
                  }, 100);
                },
                click: (swiper) => {
                  const clickedImage = swiper.clickedIndex;

                  // 更新缩略图激活状态
                  if (clickedImage === 0 || (clickedImage && this.$galleryPackageMainSwiper)) {
                    swiper.slides.forEach((slide, index) => {
                      if (index === clickedImage) {
                        slide.classList.add('swiper-slide-thumb-active');
                      } else {
                        slide.classList.remove('swiper-slide-thumb-active');
                      }
                    });

                    // 切换主轮播并同步缩略图位置

                    this.$galleryPackageMainSwiper.slideTo(clickedImage);
                    this.$galleryPackageThumbsSwiper.slideTo(clickedImage);
                  }
                },
              },
            });
          }

          changeGallery() {
            const productTabsContainer = this.querySelector('.product-sticky-form__tabs-container');
            if (!productTabsContainer) return;
            const tabs = productTabsContainer.querySelectorAll('.product-tabs-item');
            const mainImageSwiper = this.querySelector('.main-image-swiper');
            const mainPackageSwiper = this.querySelector('.thumbs-package-swiper');
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                // 移除所有选项的 active 类
                tabs.forEach((t) => t.classList.remove('active'));
                // 为当前点击的选项添加 active 类
                tab.classList.add('active');
                // 获取对应的内容区域标识
                const tabContent = tab.dataset.tab;

                if (tabContent == 'features') {
                  this.$thumbsImage.forEach((img) => {
                    img.classList.remove('custom-hidden');
                  });
                  mainPackageSwiper.classList.add('custom-hidden');
                  this.$mainImageSwiperContainer.classList.remove('custom-hidden');
                  this.$thumbsVideo.forEach((video) => {
                    video.classList.add('custom-hidden');
                    video.classList.remove('flex');
                  });
                  this.$thumbsPackage.forEach((packages) => {
                    packages.classList.add('custom-hidden');
                    packages.classList.remove('flex');
                  });
                } else if (tabContent == 'videos') {
                  mainImageSwiper.style.width = '100%';
                  this.$thumbsImage.forEach((img) => {
                    img.classList.add('custom-hidden');
                    img.classList.remove('flex');
                  });
                  mainPackageSwiper.classList.add('custom-hidden');
                  this.$mainImageSwiperContainer.classList.add('custom-hidden');
                  this.$mainImageSwiperContainer.classList.remove('flex');
                  this.$thumbsPackage.forEach((packages) => {
                    packages.classList.add('custom-hidden');
                    packages.classList.remove('flex');
                  });
                  this.$thumbsVideo.forEach((video) => {
                    video.classList.add('flex');
                    video.classList.remove('custom-hidden');
                  });
                } else if (tabContent == 'package') {
                  mainPackageSwiper.classList.remove('custom-hidden');
                  this.$mainImageSwiperContainer.classList.add('custom-hidden');
                  this.$mainImageSwiperContainer.classList.remove('flex');
                  this.$thumbsImage.forEach((img) => {
                    img.classList.add('custom-hidden');
                    img.classList.remove('flex');
                  });
                  this.$thumbsPackage.forEach((packages) => {
                    packages.classList.add('flex');
                    packages.classList.remove('custom-hidden');
                  });
                  this.$thumbsVideo.forEach((video) => {
                    video.classList.add('custom-hidden');
                    video.classList.remove('flex');
                  });
                  this.mainGalleryPackage();
                  this.mainGalleryPackageThumbs();
                }
              });
            });
          }

          // 修改 getImagesArray 方法，添加更多错误处理和日志
          getImagesArray() {
            if (!this.$productMedia) {
              console.warn('productMedia element not found');
              return [];
            }

            try {
              const mediaJson = JSON.parse(this.$productMedia.textContent);

              if (!Array.isArray(mediaJson)) {
                console.warn('mediaJson is not an array:', mediaJson);
                return [];
              }

              const formattedImages = mediaJson
                .filter((media) => {
                  if (!media || !media.media_type) {
                    console.warn('Invalid media item:', media);
                    return false;
                  }
                  return media.media_type === 'image';
                })
                .map((media, index) => {
                  if (!media.preview_image || !media.preview_image.src) {
                    console.warn('Invalid preview image:', media);
                    return null;
                  }
                  return {
                    [`${index + 1}.img`]: media.preview_image.src,
                  };
                })
                .filter(Boolean); // 移除任何 null 值

              return formattedImages;
            } catch (error) {
              console.error('Error parsing media JSON:', error);
              return [];
            }
          }

          initMobileFunction() {
            const row_1 = this.querySelector('[data-row="1"]');
            const row_2 = this.querySelector('[data-row="2"]');
            const functionItem = this.querySelectorAll('[data-row-item]');
            functionItem.forEach((item) => {
              item.addEventListener('click', function (e) {
                e.stopPropagation();
                const currentRow = $(this).data('row-item');
                const currentDesc = $(this).data('desc-value');
                if ($(this).attr('data-click-status') == 'false') {
                  functionItem.forEach((e) => {
                    $(e).attr('data-click-status', 'false');
                  });
                  $(this).attr('data-click-status', 'true');
                  if (currentRow == '1') {
                    $(row_1).addClass('block').removeClass('hidden');
                    $(row_2).addClass('hidden');
                    $(row_1).html(currentDesc);
                  } else {
                    $(row_1).addClass('hidden');
                    $(row_2).addClass('block').removeClass('hidden');
                    $(row_2).html(currentDesc);
                  }
                } else {
                  _this.clearClickStatus();
                }
              });
            });
            document.addEventListener('click', this.clearClickStatus);
            const mobileFunctionContainer = this.querySelector('.mobile-function-container');
            mobileFunctionContainer.addEventListener('scroll', this.mobileFunctionScrollBar.bind(this));
          }

          mobileFunctionScrollBar() {
            const mobileFunctionContainer = this.querySelector('.mobile-function-container');
            const mobileFunctionScrollBarItem = this.querySelector('.mobile-function-scroll-bar-item');
            const widthGap = mobileFunctionContainer.scrollWidth - mobileFunctionContainer.offsetWidth;
            mobileFunctionScrollBarItem.style.left = `${(mobileFunctionContainer.scrollLeft / widthGap) * 50}%`;
          }

          clearClickStatus() {
            const row_1 = this.querySelector('[data-row="1"]');
            const row_2 = this.querySelector('[data-row="2"]');
            const functionItem = this.querySelectorAll('[data-row-item]');
            functionItem.forEach((e) => {
              $(e).attr('data-click-status', 'false');
            });
            $(row_1).addClass('hidden');
            $(row_2).addClass('hidden');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-content-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('product-tabs-content-v2')) {
      customElements.define(
        'product-tabs-content-v2',
        /**
         * 商品详情页吸附 Tab V2
         * - 默认居中排列，数量少时填满居中
         * - 超出屏幕时可横向滑动，点击后确保 Tab 在可视区域内
         * - 选中态：加粗 + 黑色下划线；悬浮态：主题橙色
         * - 点击 Tab 切换对应内容面板，非当前 Tab 的内容隐藏
         * - 滚动页面时 Tab 栏吸顶固定
         */
        class ProductAdsorptionV2 extends HTMLElement {
          constructor() {
            super();
            this.stickyStart = 0;
            this.isSticky = false;
            this.clickLock = false;
            this.lastScrollTop = 0;
            this.resizeTimer = null;
          }

          /** metafield item.type 与内容面板 data-panel-type 的对应关系 */
          static TAB_PANEL_MAP = {
            FEATURE: '_product-tabs-content-v2-feature',
            SPEC: '_product-tabs-content-v2-spec',
            USER_MANUAL: '_product-tabs-content-v2-user-manual',
            PACKAGE: '_product-tabs-content-v2-package',
            FAQ: '_product-tabs-content-v2-faq',
            REVIEW: '_product-tabs-content-v2-review',
          };

          connectedCallback() {
            this.bar = this.querySelector('.product-tabs-content-v2__bar');
            this.scrollEl = this.querySelector('.product-tabs-content-v2__scroll');
            this.panelsEl = this.querySelector('.product-tabs-content-v2__panels');
            this.links = Array.from(this.querySelectorAll('.product-tabs-content-v2__link'));

            if (!this.bar) return;

            this._onScroll = this.handleScroll.bind(this);
            this._onClick = this.handleClick.bind(this);
            this._onResize = this.handleResize.bind(this);

            window.addEventListener('scroll', this._onScroll, { passive: true });
            window.addEventListener('resize', this._onResize);
            this.addEventListener('click', this._onClick);

            this.updateLayoutMode();
            this.initActivePanel();
            this.syncHeaderForTabsZone();
          }

          /** 获取站点 Header（商品页为 #lt-header） */
          getSiteHeader() {
            return document.getElementById('lt-header');
          }

          /** 是否已进入 product-tabs-content-v2 吸顶/内容区域 */
          isWithinTabsZone() {
            if (this.isSticky) return true;
            if (!this.bar) return false;

            const scrollTop = window.scrollY;
            const barTop = this.bar.getBoundingClientRect().top + scrollTop;

            return scrollTop >= barTop - 10;
          }

          /** Tab 区域内同步隐藏 Header（点击 Tab / 刷新落点 / 滚动吸顶） */
          syncHeaderForTabsZone() {
            if (this.isWithinTabsZone()) {
              window.hideSiteHeader();
            }
          }

          /** Header 隐藏后不再占用滚动偏移 */
          getSiteHeaderOffset() {
            const ltHeader = this.getSiteHeader();
            if (!ltHeader) return 0;

            return ltHeader.getAttribute('data-scrollshow') === 'true' ? ltHeader.offsetHeight || 0 : 0;
          }

          getPanelTypeForTab(tabType) {
            return ProductAdsorptionV2.TAB_PANEL_MAP[tabType] || '';
          }

          hasPanelForTab(link) {
            const panelType = this.getPanelTypeForTab(link.dataset.tabType);
            if (!panelType || !this.panelsEl) return false;

            return Boolean(this.panelsEl.querySelector(`[data-panel-type="${panelType}"]`));
          }

          /**
           * 初始化：显示第一个有对应内容面板的 Tab
           */
          initActivePanel() {
            const defaultLink = this.links.find((link) => this.hasPanelForTab(link));

            if (defaultLink) {
              this.setActiveLink(defaultLink);
            } else {
              this.showFirstPanel();
            }

            this.panelsEl?.setAttribute('data-initialized', 'true');
          }

          showFirstPanel() {
            if (!this.panelsEl) return;

            const panels = this.panelsEl.querySelectorAll('.product-tabs-content-v2__panel');
            panels.forEach((panel, index) => {
              const isActive = index === 0;
              panel.classList.toggle('product-tabs-content-v2__panel--active', isActive);
              panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            });
          }

          disconnectedCallback() {
            window.removeEventListener('scroll', this._onScroll);
            window.removeEventListener('resize', this._onResize);
            if (this._onClick) {
              this.removeEventListener('click', this._onClick);
            }
            clearTimeout(this.resizeTimer);
          }

          handleResize() {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
              this.updateLayoutMode();
            }, 200);
          }

          /**
           * 内容未溢出时居中；溢出时改为左对齐以便横向滑动
           */
          updateLayoutMode() {
            if (!this.scrollEl) return;

            const track = this.scrollEl.querySelector('.product-tabs-content-v2__track');
            if (!track) return;

            const isOverflow = track.scrollWidth > this.scrollEl.clientWidth + 1;

            this.scrollEl.style.justifyContent = isOverflow ? 'flex-start' : 'center';
          }

          /**
           * 按 Tab 类型显示对应内容面板，隐藏其余面板
           * @param {string} tabType
           * @returns {boolean}
           */
          setActivePanel(tabType) {
            const panelType = this.getPanelTypeForTab(tabType);
            if (!this.panelsEl || !panelType) return false;

            let matched = false;
            const panels = this.panelsEl.querySelectorAll('.product-tabs-content-v2__panel');

            panels.forEach((panel) => {
              const isActive = panel.dataset.panelType === panelType;
              panel.classList.toggle('product-tabs-content-v2__panel--active', isActive);
              panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
              if (isActive) matched = true;
            });

            return matched;
          }

          scrollToPanels() {
            if (!this.panelsEl) return;

            window.hideSiteHeader();

            const headerHeight = this.getSiteHeaderOffset();
            const barHeight = this.bar.offsetHeight || 0;
            const panelsTop = this.panelsEl.getBoundingClientRect().top + window.scrollY - headerHeight - barHeight;

            window.scrollTo({ top: Math.max(0, panelsTop), behavior: 'smooth' });
          }

          handleClick(event) {
            const link = event.target.closest('.product-tabs-content-v2__link');
            if (!link || !this.contains(link)) return;

            event.preventDefault();

            if (!this.hasPanelForTab(link)) return;

            this.clickLock = true;
            window.hideSiteHeader();
            this.setActiveLink(link);
            this.scrollTabIntoView(link);
            this.scrollToPanels();

            clearTimeout(this.clickUnlockTimer);
            this.clickUnlockTimer = setTimeout(() => {
              this.clickLock = false;
            }, 600);
          }

          handleScroll() {
            if (this.clickLock) return;

            const scrollTop = window.scrollY;

            if (!this.isSticky) {
              const barTop = this.bar.getBoundingClientRect().top + scrollTop;

              if (scrollTop >= barTop) {
                this.stickyStart = barTop;
                this.isSticky = true;
                this.bar.classList.add('product-tabs-content-v2__bar--sticky');
                window.hideSiteHeader();
              }
            } else if (scrollTop < this.stickyStart - 10) {
              this.isSticky = false;
              this.bar.classList.remove('product-tabs-content-v2__bar--sticky');
            }

            this.lastScrollTop = scrollTop;
          }

          setActiveLink(activeLink) {
            this.links.forEach((link) => {
              const isActive = link === activeLink;
              link.classList.toggle('product-tabs-content-v2__link--active', isActive);
              link.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            this.setActivePanel(activeLink.dataset.tabType);
          }

          /**
           * 将 Tab 滚动到可视区域内（不强制居中，避免边缘留白）
           * @param {HTMLElement} link
           * @param {boolean} smooth
           */
          scrollTabIntoView(link, smooth = true) {
            if (!this.scrollEl || !link) return;

            const scrollRect = this.scrollEl.getBoundingClientRect();
            const linkRect = link.getBoundingClientRect();
            const edgePadding = 16;
            let delta = 0;

            if (linkRect.left < scrollRect.left + edgePadding) {
              delta = linkRect.left - scrollRect.left - edgePadding;
            } else if (linkRect.right > scrollRect.right - edgePadding) {
              delta = linkRect.right - scrollRect.right + edgePadding;
            }

            if (delta !== 0) {
              this.scrollEl.scrollBy({
                left: delta,
                behavior: smooth ? 'smooth' : 'auto',
              });
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["public-benefit-activities"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('public-benefit-activities')) {
      customElements.define(
        'public-benefit-activities',
        class publicBenefitActivities extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.bindEvent();
          }
          bindEvent() {
            this.items = this.querySelectorAll('.public-benefit-activity');
            // 列表页事件
            // 打开弹窗
            this.items.forEach((item) => {
              item.addEventListener('click', () => {
                const popupId = item.dataset.popupId;
                const popup = this.querySelector(`.public-benefit-activity-popup[data-popup-id="${popupId}"]`);
                popup.dataset.show = 'true';
                console.log('window.litime', window.litime);
                window.litime.disableScroll();
              });
            });
            // 关闭弹窗
            this.closeButtons = this.querySelectorAll('.public-benefit-activity-popup__content-close');
            this.closeButtons.forEach((button) => {
              button.addEventListener('click', () => {
                const popupId = button.dataset.popupId;
                const popup = this.querySelector(`.public-benefit-activity-popup[data-popup-id="${popupId}"]`);
                popup.dataset.show = 'false';
                window.litime.enableScroll();
              });
            });
            // 详情页事件
            this.detailButtons = this.querySelectorAll('.public-benefit-activity-item__content-main-button');
            this.detailButtons.forEach((button) => {
              button.addEventListener('click', () => {
                const popupId = button.dataset.popupId;
                const popup = this.querySelector(`public-benefit-activity-detail[data-popup-id="${popupId}"]`);
                popup.dataset.show = 'true';
              });
            });
            // 关闭详情页事件
            this.detailCloseButtons = this.querySelectorAll('.public-benefit-activity-detail__content-close');
            this.detailCloseButtons.forEach((button) => {
              button.addEventListener('click', () => {
                const popupId = button.dataset.popupId;
                const popup = this.querySelector(`public-benefit-activity-detail[data-popup-id="${popupId}"]`);
                popup.dataset.show = 'false';
              });
            });
            // 列表页更多事件：初始显示前 10 条，点击每次显示 4 条，全部显示后隐藏 more 按钮
            this.listMoreButtons = this.querySelectorAll('.public-benefit-activity-popup__content-list-more');
            this.listMoreButtons.forEach((button) => {
              const listId = button.dataset.listId;
              const list = Array.from(
                this.querySelectorAll(
                  `.public-benefit-activity-popup__content-list[data-list-id="${listId}"] .public-benefit-activity-item-wrapper`
                )
              );
              const total = list.length;
              const INITIAL_SHOW = 10;
              const LOAD_MORE_COUNT = 4;

              function setMoreButtonVisible(visible) {
                button.style.display = visible ? '' : 'none';
              }

              // 绑定前：先显示前 10 条，若已全部显示则隐藏 more
              list.forEach((item, index) => {
                item.dataset.show = index < INITIAL_SHOW ? 'true' : 'false';
              });
              if (total <= INITIAL_SHOW) {
                setMoreButtonVisible(false);
              }

              button.addEventListener('click', () => {
                const hidden = list.filter((el) => el.dataset.show !== 'true');
                if (hidden.length === 0) {
                  setMoreButtonVisible(false);
                  return;
                }
                const toShow = hidden.slice(0, LOAD_MORE_COUNT);
                toShow.forEach((el) => {
                  el.dataset.show = 'true';
                });
                if (hidden.length <= LOAD_MORE_COUNT) {
                  setMoreButtonVisible(false);
                }
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referral-banner"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('referral-banner')) {
      customElements.define(
        'referral-banner',
        class referralBanner extends HTMLElement {
          constructor() {
            super();
            window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
            this.modalManager = window.litime.ModalControllerState;
            this.referralLogModal = null;
            this.firstOpen = true;
            this.memberBannerRewardsTabs = null;
            this.code = null;
            this.token =
              'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjkwMDAwMTY4MywiYWNjZXNzIjoiYWNjZXNzIiwiZXhwIjoxOTAwODA4NTgyfQ.6hdmN-fLW-pOBoQQsGn1DO2JmV8odkekYh2_aH4Rwak';
          }
          async connectedCallback() {
            this.initModal();
            this.init();
            const ltHeader = $(document.querySelector('#lt-header'));
            ltHeader.data('screen', 'true');
            const referralCode = new URLSearchParams(window.location.search).get('referralCode');
            if (window.customer) {
              try {
                const referralInfo = await this.getReferralInfo();
                const referralUrl = $(this.querySelector('.referral-url'));
                referralUrl.find('span').text(referralInfo?.referralInviteLink);

                const referralSignUpCount = $(this.querySelector('.referral-sign-up-count'));
                referralSignUpCount.text(referralInfo?.invitedNums);
                const referralPurchaseCount = $(this.querySelector('.referral-purchase-count'));
                referralPurchaseCount.text(referralInfo?.orderRewardNums);
                const memberRedeemModalBtnCopy = $(this.querySelector('.referral-url-copy-btn'));
                memberRedeemModalBtnCopy.on('click', () => {
                  this.copy(referralInfo?.referralInviteLink);
                });
                const referralUrlWrapper = $(this.querySelector('.referral-url-wrapper'));
                referralUrlWrapper.removeClass('opacity-0');
                const memberBannerUserInfo = $(this.querySelector('.referral-banner__user-info'));
                memberBannerUserInfo.removeClass('hidden').addClass('flex');
                const shareIconFacebook = $(this.querySelector('.share-icon-facebook'));
                shareIconFacebook.on('click', () => {
                  this.share('facebook', referralInfo?.referralInviteLink);
                });
                const shareIconTwitter = $(this.querySelector('.share-icon-twitter'));
                shareIconTwitter.on('click', () => {
                  this.share('twitter', referralInfo?.referralInviteLink);
                });
              } catch (error) {
                window.litime.showToast('error', error.message);
              }
            } else {
              setTimeout(() => {
                if (referralCode) {
                  window.litime.eventBus.publish('REGISTER', {
                    referralInviterCode: referralCode,
                  });
                }
              }, 500);
            }
            const memberBannerLoginBtn = $(this.querySelector('.referral-banner-login-btn'));
            memberBannerLoginBtn.on('click', () => {
              window.litime.eventBus.publish('LOGIN');
            });
            const referralInvitedReward = window.litime.getLocalStorage('referralInvitedReward');
            if (window.customer && referralInvitedReward && referralInvitedReward.mode == 1) {
              const referralRewordModal = $(this.querySelector('.referral-reword-modal'));
              const referralRewordModalImg = $(this.querySelector('.referral-reword-modal-img'));
              referralRewordModalImg.attr('src', referralInvitedReward.discountReward.icon);
              const referralRewordModalCode = $(this.querySelector('.referral-reword-modal-code'));
              referralRewordModalCode.find('span').text(referralInvitedReward.discountReward.discountCode);
              const referralRewordModalRule = $(this.querySelector('.referral-reword-modal-rule'));

              referralRewordModalRule.on('click', () => {
                const referralRewardDetailModal = $(this.querySelector('.referral-reword-detail-modal'));
                referralRewardDetailModal
                  .find('.referral-reword-detail-modal-img')
                  .attr('src', referralInvitedReward.discountReward.icon);
                referralRewardDetailModal
                  .find('.referral-reword-detail-modal-title')
                  .text(referralInvitedReward.discountReward.rewardName);
                referralRewardDetailModal
                  .find('.referral-reword-detail-modal-rules')
                  .html(referralInvitedReward.discountReward.rule);
                referralRewardDetailModal.removeClass('hidden').addClass('flex');
              });
              referralRewordModal.removeClass('hidden').addClass('flex');
              window.litime.disableScroll();
              window.litime.clearLocalStorage('referralInvitedReward');
            } else if (window.customer && referralInvitedReward && referralInvitedReward.mode == 2) {
              const referralIntegrationModal = $(this.querySelector('.referral-integration-modal'));
              referralIntegrationModal.removeClass('hidden').addClass('flex');
              window.litime.disableScroll();
              window.litime.clearLocalStorage('referralInvitedReward');
            }
            document.addEventListener('click', this.bindBrowserEvent.bind(this));
          }

          disconnectedCallback() {
            document.removeEventListener('click', this.bindBrowserEvent.bind(this));
          }

          copy(text) {
            window.litime.copyToClipboard(text);
          }

          share(platform, url) {
            if (platform === 'facebook') {
              window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
            } else if (platform === 'twitter') {
              window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank');
            }
          }

          // 获取Referral邀请码和邀请信息
          async getReferralInfo() {
            const url = '/shopify/referral/get/info';
            const { data, code } = await window.litime.http.get(url);
            if (code === 200) {
              return data;
            } else {
              return null;
              // throw new Error(window.i18n.error_message_timeout);
            }
          }

          // 邀请用户日志
          async getReferralRewards(data) {
            const url = '/shopify/referral/page/log/invite';
            const res = await window.litime.http.get(url, {
              data,
            });
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }

          // 下单奖励日志
          async getReferralLogs() {
            const url = '/shopify/referral/page/log/order';
            const res = await window.litime.http.get(url);
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }

          showButtonLoading(button) {
            button.attr('data-show-loading', 'true');
          }

          hideButtonLoading(button) {
            button.attr('data-show-loading', 'false');
          }

          init() {
            const _this = this;
            const rewardBtn = this.querySelector('.reward-btn');
            const activityBtn = this.querySelector('.activity-btn');
            const referralLogModal = this.modalManager.getModal('referral-log-modal');
            activityBtn?.addEventListener('click', async () => {
              this.showButtonLoading($(activityBtn).find('button'));
              try {
                const res = await this.getReferralRewards({
                  page: 1,
                  pageSize: 999,
                });
                if (res.records.length > 0) {
                  this.addTableRow(res.records, referralLogModal);
                  setTimeout(() => {
                    referralLogModal.querySelector('.referral-log-modal').setAttribute('data-referral-type', 'sign-up');
                  }, 100);
                } else {
                  setTimeout(() => {
                    referralLogModal.querySelector('.referral-log-modal').setAttribute('data-referral-type', 'empty');
                  }, 100);
                }
                referralLogModal.querySelector('.referral-log-modal').setAttribute('data-tab-type', 'sign-up');
                this.hideButtonLoading($(activityBtn).find('button'));
                this.modalManager.open('referral-log-modal');
              } catch (error) {
                this.hideButtonLoading($(activityBtn).find('button'));
                window.litime.showToast('error', error.message);
              }
            });
          }

          // 添加数据示例
          addTableRow(data, container) {
            const tbody = container.querySelector('tbody');
            tbody.innerHTML = '';
            data.forEach((item) => {
              const tr = document.createElement('tr');
              const userDate = this.switchTimeZone(item.createdTime);
              tr.innerHTML = `
                <td>${item.referralInvitedEmail}</td>
                <td>${item.actionName}</td>
                <td class="text-primary">
                   <div class="flex items-center">
                    <span>${item.reward}</span>
                           ${
                             !item.isLimit && item.discountCode
                               ? `
                      <i class="copy-icon flex justify-center items-center flex-shrink-0 cursor-pointer" style="width: 24px; height: 24px; fill: #EA5504;">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="" version="1.1" width="24" height="24" viewBox="0 0 24 24"><g><g><rect x="0" y="0" width="24" height="24" rx="0" fill="none" fill-opacity="0"/></g><g><path d="M8.40349,5L16.6575,5C17.569000000000003,5,18.3095,5.740462,18.3126,6.65515L18.3126,15.9389C18.3126,16.2812,18.032600000000002,16.5612,17.6904,16.5612C17.348100000000002,16.5612,17.0681,16.2812,17.0681,15.9389L17.0681,6.65515C17.0681,6.42803,16.8846,6.24447,16.6575,6.24447L8.40349,6.24447C8.06126,6.24447,7.78125,5.964468,7.78125,5.622237C7.78125,5.280007,8.06126,5,8.40349,5ZM5.933356,7.996090000000001L14.38023,7.996090000000001C14.89621,7.996090000000001,15.315,8.41347,15.3167,8.92945L15.3167,18.067C15.3167,18.5835,14.8998,19.0004,14.38334,19.0004L5.933356,19.0004C5.416899,19.0004,5,18.5835,5,18.067L5,8.92945C5,8.41299,5.416899,7.996090000000001,5.933356,7.996090000000001ZM6.24448,17.7559L14.07222,17.7559L14.07222,9.24057L6.24448,9.24057L6.24448,17.7559Z" fill-rule="evenodd" fill="" fill-opacity="1"/></g></g></svg>
                      </i>
                      `
                               : ''
                           }
                    ${
                      item.isLimit == 1
                        ? `
                      <div style="margin-left: 8px;" class="relative limit-icon-wrapper">
                        <i style="width: 12px; height: 12px;">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="12" height="12" viewBox="0 0 12 12"><g><path d="M6.0000014,1.1175874e-7C2.6625009,1.1175874e-7,0,2.6625009,0,6.0000014C0,9.3375025,2.6625004,12,6.0000014,12C9.3375034,12,12,9.3375025,12,6C12,2.6625004,9.3375025,-4.4703495e-7,6.0000014,1.1175874e-7ZM5.4225006,2.3475006C5.5800009,2.1900003,5.7150002,2.0850008,5.9700007,2.0850008C6.2550015,2.0625012,6.5175009,2.1975002,6.6225004,2.4000006C6.7425013,2.542501,6.8100004,2.857501,6.7800007,3.0450013C6.7800007,3.0975015,6.7425013,3.4500015,6.7275009,3.5475013L6.5175009,6.2100024C6.5175009,6.4725018,6.4650011,6.7350025,6.3600011,6.9375029C6.3075013,7.0950027,6.150001,7.2000022,5.9400015,7.2000022C5.7825007,7.2000022,5.6250014,7.0950022,5.5725002,6.9375029C5.4675007,6.6750026,5.4150009,6.4650025,5.4150009,6.2100024L5.272501,3.6000009C5.2200012,3.1275003,5.2200012,3.2850008,5.2200012,3.0225008C5.2200012,2.7675006,5.272501,2.5575008,5.4225006,2.3475006ZM6.5775013,9.7050009C6.4200015,9.8625021,6.2100005,9.9150009,6.0525012,9.9150009C5.8425007,9.9150009,5.6325006,9.8625021,5.4750004,9.7050009C5.3175006,9.5475025,5.212501,9.3375025,5.212501,9.0825005C5.212501,8.8725014,5.2650008,8.6625004,5.4225001,8.505003C5.5799999,8.3475008,5.7900009,8.2425013,6,8.2425013C6.2100005,8.2425013,6.4200015,8.3475018,6.5775008,8.505003C6.7350006,8.6625004,6.7875004,8.8725014,6.7875004,9.0825005C6.7799997,9.3375034,6.7275,9.5475025,6.5775013,9.7050009Z" fill="#ea5504" fill-opacity="1"/></g></svg>
                        </i>
                        <div class="limit-text-wrapper">
                          <div class="limti_text">
                            ${window.i18n.limit_reached}
                          </div>
                        </div>
                      </div>
                      `
                        : ''
                    }
                  </div>
                </td>
                <td>${userDate.toLocaleString()}</td>
                `;

              tbody.append(tr);
            });
          }
          // 添加下单奖励日志
          addReferralLogs(data, container) {
            const tbody = container.querySelector('tbody');
            tbody.innerHTML = '';
            data.forEach((item) => {
              const tr = document.createElement('tr');
              const userDate = this.switchTimeZone(item.createdTime);
              tr.innerHTML = `
                <td>${item.referralInvitedEmail}</td>
                <td>${item.actionName}</td>
                <td class="text-primary">
                  <div class="flex items-center gap-[4px]">
                    <span class="text-primary">${item.reward}</span>
                       ${
                         item.isLimit
                           ? `
                      <div style="margin-left: 8px;" class="relative limit-icon-wrapper">
                        <i style="width: 12px; height: 12px;">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="12" height="12" viewBox="0 0 12 12"><g><path d="M6.0000014,1.1175874e-7C2.6625009,1.1175874e-7,0,2.6625009,0,6.0000014C0,9.3375025,2.6625004,12,6.0000014,12C9.3375034,12,12,9.3375025,12,6C12,2.6625004,9.3375025,-4.4703495e-7,6.0000014,1.1175874e-7ZM5.4225006,2.3475006C5.5800009,2.1900003,5.7150002,2.0850008,5.9700007,2.0850008C6.2550015,2.0625012,6.5175009,2.1975002,6.6225004,2.4000006C6.7425013,2.542501,6.8100004,2.857501,6.7800007,3.0450013C6.7800007,3.0975015,6.7425013,3.4500015,6.7275009,3.5475013L6.5175009,6.2100024C6.5175009,6.4725018,6.4650011,6.7350025,6.3600011,6.9375029C6.3075013,7.0950027,6.150001,7.2000022,5.9400015,7.2000022C5.7825007,7.2000022,5.6250014,7.0950022,5.5725002,6.9375029C5.4675007,6.6750026,5.4150009,6.4650025,5.4150009,6.2100024L5.272501,3.6000009C5.2200012,3.1275003,5.2200012,3.2850008,5.2200012,3.0225008C5.2200012,2.7675006,5.272501,2.5575008,5.4225006,2.3475006ZM6.5775013,9.7050009C6.4200015,9.8625021,6.2100005,9.9150009,6.0525012,9.9150009C5.8425007,9.9150009,5.6325006,9.8625021,5.4750004,9.7050009C5.3175006,9.5475025,5.212501,9.3375025,5.212501,9.0825005C5.212501,8.8725014,5.2650008,8.6625004,5.4225001,8.505003C5.5799999,8.3475008,5.7900009,8.2425013,6,8.2425013C6.2100005,8.2425013,6.4200015,8.3475018,6.5775008,8.505003C6.7350006,8.6625004,6.7875004,8.8725014,6.7875004,9.0825005C6.7799997,9.3375034,6.7275,9.5475025,6.5775013,9.7050009Z" fill="#ea5504" fill-opacity="1"/></g></svg>
                        </i>
                        <div class="limit-text-wrapper">
                          <div class="limti_text">
                            ${window.i18n.limit_reached}
                          </div>
                        </div>
                      </div>
                      `
                           : ''
                       }
                  </div>
                </td>
                <td>${userDate.toLocaleString()}</td>
                `;
              tbody.append(tr);
            });
          }

          showLoading() {
            const ContentList = $(this.rewardsContainer.querySelectorAll(`[data-reward-tab-content]`));
            ContentList.addClass('hidden');
            $(this.rewardsContainer.querySelector('.member-redeem_empty')).addClass('hidden');
            const memberRedeemLoading = $(this.rewardsContainer.querySelector('.member-redeem_reward_loading'));
            memberRedeemLoading.removeClass('hidden').addClass('flex');
          }

          hideLoading() {
            const memberRedeemLoading = $(this.rewardsContainer.querySelector('.member-redeem_reward_loading'));
            memberRedeemLoading.addClass('hidden').removeClass('flex');
          }

          initModal() {
            if (!this.modalManager.getModal('referral-log-modal')) {
              this.modalManager.register('referral-log-modal', {
                onOpen: (container) => {
                  if (!this.referralLogModal) {
                    this.referralLogModal = container;
                    const dataReferralType = this.referralLogModal.getAttribute('data-referral-type');
                    const referralLogModal = this.referralLogModal.querySelector('.referral-log-modal');
                    this.referralLogModal.querySelectorAll('[data-type]').forEach((item) => {
                      item.addEventListener('click', async () => {
                        const type = item.getAttribute('data-type');
                        if (type === referralLogModal.getAttribute('data-referral-type')) return;
                        referralLogModal.setAttribute('data-referral-type', 'loading');
                        if (type === 'sign-up') {
                          referralLogModal.setAttribute('data-tab-type', 'sign-up');
                          const res = await this.getReferralRewards({
                            page: 1,
                            pageSize: 999,
                          });
                          if (res.records.length > 0) {
                            this.addTableRow(res.records, this.referralLogModal);
                            referralLogModal.setAttribute('data-referral-type', 'sign-up');
                          } else {
                            referralLogModal.setAttribute('data-referral-type', 'empty');
                          }
                        } else {
                          referralLogModal.setAttribute('data-tab-type', 'purchase');
                          const res = await this.getReferralLogs();
                          if (res.records.length > 0) {
                            this.addReferralLogs(
                              res.records,
                              this.referralLogModal.querySelector('[data-table-type="purchase"]')
                            );
                            referralLogModal.setAttribute('data-referral-type', 'purchase');
                          } else {
                            referralLogModal.setAttribute('data-referral-type', 'empty');
                          }
                        }
                      });
                    });
                    // 事件委托
                    referralLogModal.addEventListener('click', (e) => {
                      const isMobile = this.isMobileDevice();
                      const target = e.target;
                      if (target.closest('.copy-icon')) {
                        window.litime.copyToClipboard(
                          target
                            .closest('.copy-icon')
                            .parentElement.querySelector('span')
                            .textContent.trim()
                            .replace(/\n/g, '')
                        );
                      }
                      if (target.closest('.limit-icon-wrapper') && isMobile) {
                        e.stopPropagation();
                        e.preventDefault();
                        const allLimitIconWrapper = this.referralLogModal.querySelectorAll('.limit-icon-wrapper');
                        allLimitIconWrapper.forEach((item) => {
                          item.querySelector('.limit-text-wrapper').style.display = 'none';
                        });
                        const iconWrapper = target.closest('.limit-icon-wrapper');
                        const limitTextWrapper = iconWrapper.querySelector('.limit-text-wrapper');
                        if (iconWrapper && limitTextWrapper.style.display === 'none') {
                          limitTextWrapper.style.display = 'block';
                        }
                        // 表格滚动到最右侧
                        const tableContainer = this.referralLogModal.querySelector('.table-container_wrapper');
                        tableContainer.scrollTo({
                          left: tableContainer.scrollWidth,
                          behavior: 'smooth',
                        });
                      }
                    });
                  }
                },
                onClose: () => {},
              });
            }
          }
          // 判断设备为移动端设备
          isMobileDevice() {
            const userAgent = navigator.userAgent.toLowerCase();
            return /mobile|android|iphone|ipad|phone/i.test(userAgent);
          }

          // 浏览器绑定事件
          bindBrowserEvent() {
            const isMobile = this.isMobileDevice();
            if (this.referralLogModal && isMobile) {
              const allLimitTextWrapper = this.referralLogModal.querySelectorAll('.limit-text-wrapper');
              allLimitTextWrapper.forEach((item) => {
                item.style.display = 'none';
              });
            }
          }

          closeModal() {
            const memberRedeemModal = $(this.querySelector('.account-redeem-modal'));
            memberRedeemModal.addClass('hidden').removeClass('flex');
          }

          handleScroll() {
            const memberRedeemScrollContainer = this.querySelector('.member-redeem-scroll-container');
            const memberRedeemModalBtnRedeemWrapper = this.querySelector('.account-redeem-modal-btn-redeem_wrapper');
            const memberRedeemModalBtn = this.querySelector('.account-redeem-modal-btn');
            if (
              memberRedeemScrollContainer.scrollTop + memberRedeemScrollContainer.clientHeight >=
              memberRedeemScrollContainer.scrollHeight
            ) {
              memberRedeemModalBtnRedeemWrapper.classList.add('border-t');
              memberRedeemModalBtn.style.boxShadow = 'none';
            } else {
              memberRedeemModalBtnRedeemWrapper.classList.remove('border-t');
              memberRedeemModalBtn.style.boxShadow = '0 0 4px 0px #0000001a';
            }
          }

          // 切换时区时间
          switchTimeZone(cnTime) {
            // 创建北京时间对象
            const cnDate = new Date(cnTime);

            // 获取用户时区偏移（分钟）
            const userOffset = new Date().getTimezoneOffset();

            // 将用户偏移转换为小时（注意：getTimezoneOffset 返回的是负值）
            const userOffsetHours = -userOffset / 60;

            // 计算时差（小时）
            const diffHours = 8 - userOffsetHours;

            // 转换为用户本地时间
            return new Date(cnDate.getTime() - diffHours * 60 * 60 * 1000);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-ads"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('scenario-rv-ads')) {
      customElements.define(
        'scenario-rv-ads',
        class ScenarioRvAds extends HTMLElement {
          swiper = null;
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            const $mySwiper = this.querySelector('.scenario-rv-ads_swiper');
            const advantagePrev = this.querySelector('.scenario-rv-ads_prev');
            const advantageNext = this.querySelector('.scenario-rv-ads_next');
            const $scrollbarDom = this.querySelector('.swiper-scrollbar');
            const $pagination = this.querySelector('.scenario-rv-ads__pagination');
            // 自动轮播
            this.swiper = new Swiper($mySwiper, {
              loop: true,
              slidesPerView: 1,
              spaceBetween: 16,
              centeredSlides: true,
              effect: 'fade',
              speed: 600,
              fadeEffect: {
                crossFade: true,
              },
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: advantageNext,
                prevEl: advantagePrev,
              },
              pagination: {
                el: $pagination,
                clickable: false,
                type: 'bullets',
              },
              scrollbar: {
                el: $scrollbarDom,
                draggable: true,
              },
              on: {
                autoplayTimeLeft(_s, _time, progress) {
                  requestAnimationFrame(() => {
                    $($pagination).css('--progress', `${(1 - progress) * 100}%`);
                  });
                },
              },
            });

            // 自动轮播
            this.swiper.autoplay.start();
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-adsorption"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('scenario-rv-adsorption')) {
      customElements.define(
        'scenario-rv-adsorption',
        class ScenarioRvAdsorption extends HTMLElement {
          sticky_start = 0;
          changeStatus = true;
          _this = null;
          constructor() {
            super();
          }
          connectedCallback() {
            const _this = this;
            this.init();
            $(window).scroll(_this.scrollHandler);
          }
          disconnectedCallback() {
            const _this = this;
            $(window).off('scroll', _this.scrollHandler);
            if (this.resizeHandler) {
              $(window).off('resize', this.resizeHandler);
            }
            // 断开所有 observers
            if (this.observers) {
              this.observers.forEach((observer) => observer.disconnect());
            }
            if (this.headerObserver) {
              this.headerObserver.disconnect();
            }
          }

          scrollHandler() {
            const adsorption = $('#adsorption');
            const Points = $(`[data-jump]`);
            const ltHeader = $('#lt-header');
            const headerHeight = ltHeader.length ? ltHeader.outerHeight() : 0;
            const isHeaderVisible = ltHeader.attr('data-scrollshow') === 'true';
            let sticky = adsorption.offset().top;

            const scrollTop = $(window).scrollTop();
            const scrollingDown = scrollTop > (this.lastScrollTop || 0);
            this.lastScrollTop = scrollTop;

            if (scrollTop > sticky - 10 && !this.changeStatus) {
              this.changeStatus = true;
              this.sticky_start = sticky;
              adsorption.css('position', 'fixed');
              adsorption.css('top', isHeaderVisible ? `${headerHeight}px` : '0');
              adsorption.css('left', '0');
            }

            if (this.changeStatus && scrollTop < this.sticky_start - 10) {
              this.changeStatus = false;
              adsorption.css('position', 'relative');
              adsorption.css('top', '0');
              adsorption.css('left', '0');
            } else if (this.changeStatus) {
              adsorption.css('top', isHeaderVisible ? `${headerHeight}px` : '0');
            }

            Points.each(function () {
              const targetPoint = $(this).attr('data-jump');
              if (!targetPoint) return;
              const $targetElement = $(`[data-point="${targetPoint}"]`);
              if (!$targetElement.length) return;
              var targetOffset = $targetElement.offset().top;
              var targetHeight = $targetElement.outerHeight();

              if ($(window).scrollTop() >= targetOffset - 50 && $(window).scrollTop() < targetOffset + targetHeight) {
                Points.css('border-color', 'transparent');
                $(this).css('border-color', 'var(--text-color)');

                // 添加滚动到居中的逻辑
                const tabBox = $(this).closest('.tab-box')[0];
                if (tabBox) {
                  const tab = this;
                  const tabRect = tab.getBoundingClientRect();
                  const boxRect = tabBox.getBoundingClientRect();
                  const targetScroll =
                    tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;

                  tabBox.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth',
                  });
                }
              }
            });
          }

          init() {
            this.initStickyBehavior();
            this.initTabPoints();
            this.initScrollButtons();
            this.initResizeHandler();
          }

          // 初始化吸顶行为
          initStickyBehavior() {
            const adsorption = $('#adsorption');
            this.sticky_start = adsorption.offset().top;
          }

          // 初始化标签点击和滚动行为
          initTabPoints() {
            const Points = $(`[data-jump]`);

            // 处理点击样式和居中
            Points.on(
              'click',
              function (e) {
                e.preventDefault();
                Points.css('border-color', 'none');
                $(this).css('border-color', 'var(--text-color)');

                this.scrollTabToCenter(this);
              }.bind(this)
            );

            // 处理点击跳转
            Points.each(function () {
              $(this).on('click', function () {
                const dataPoint = $(this).data('jump');
                if (!dataPoint) return;

                const $markerPoint = $(`[data-point="${dataPoint}"]`);
                if ($markerPoint.length) {
                  $markerPoint[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest',
                  });
                }
              });
            });
          }

          // 初始化左右滚动按钮
          initScrollButtons() {
            const $tabBox = $(this).find('.tab-box');
            const $handleLeft = $(this).find('.handle-left');
            const $handleRight = $(this).find('.handle-right');

            $handleLeft.on('click', function () {
              if ($(this).attr('data-disabled') === 'true') return;
              $tabBox.animate({ scrollLeft: '-=300' }, 300);
            });

            $handleRight.on('click', function () {
              if ($(this).attr('data-disabled') === 'true') return;
              $tabBox.animate({ scrollLeft: '+=300' }, 300);
            });

            // 初始检查溢出状态
            this.checkTabOverflow();
          }

          // 初始化窗口大小变化监听
          initResizeHandler() {
            this.resizeHandler = () => this.checkTabOverflow();
            $(window).on('resize', this.resizeHandler);
          }

          // 滚动标签到中心位置的辅助函数
          scrollTabToCenter(tab) {
            const tabBox = $(tab).closest('.tab-box')[0];
            if (!tabBox) return;

            const tabRect = tab.getBoundingClientRect();
            const boxRect = tabBox.getBoundingClientRect();
            const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;

            tabBox.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          }

          checkTabOverflow() {
            const $tabContainer = $(this).find('.tab-box');
            const $handle = $(this).find('.handle');

            if (!$tabContainer.length || !$handle.length) return;

            // 添加窗口宽度判断
            const windowWidth = $(window).width();
            if (windowWidth <= 1200) {
              $handle.css('display', 'none');
              // 小屏幕时移除观察者
              if (this.observers) {
                this.observers.forEach((observer) => observer.disconnect());
              }
              return;
            }

            // 检查是否有溢出
            const isOverflowing = $tabContainer[0].scrollWidth > $tabContainer[0].clientWidth;

            // 根据是否溢出来显示/隐藏handle
            $handle.css('display', isOverflowing ? 'flex' : 'none');

            // 重新添加观察者
            if (isOverflowing && (!this.observers || !this.observers[0].takeRecords().length)) {
              this.setupObservers($tabContainer);
            }
          }

          // 添加新方法用于设置观察者
          setupObservers($tabBox) {
            const $handleLeft = $(this).find('.handle-left');
            const $handleRight = $(this).find('.handle-right');

            // 创建 Intersection Observer
            const options = {
              root: $tabBox[0],
              threshold: 1.0,
            };

            const firstObserver = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                $handleLeft.attr('data-disabled', entry.isIntersecting ? 'true' : 'false');
              });
            }, options);

            const lastObserver = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                $handleRight.attr('data-disabled', entry.isIntersecting ? 'true' : 'false');
              });
            }, options);

            // 观察第一个和最后一个元素
            const $firstTab = $tabBox.find('[data-jump]').first();
            const $lastTab = $tabBox.find('[data-jump]').last();

            firstObserver.observe($firstTab[0]);
            lastObserver.observe($lastTab[0]);

            // 更新 observers 引用
            if (this.observers) {
              this.observers.forEach((observer) => observer.disconnect());
            }
            this.observers = [firstObserver, lastObserver];
          }

          // 添加新的方法
          initHeaderObserver() {
            const ltHeader = document.querySelector('#lt-header');
            if (!ltHeader) return;

            // 创建 MutationObserver
            this.headerObserver = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.attributeName === 'data-scrollshow') {
                  this.updateHeaderPosition();
                }
              });
            });

            // 开始观察
            this.headerObserver.observe(ltHeader, {
              attributes: true,
              attributeFilter: ['data-scrollshow'],
            });

            // 初始化位置
            this.updateHeaderPosition();
          }

          updateHeaderPosition() {
            const adsorption = $('#adsorption');
            const ltHeader = $('#lt-header');
            const headerHeight = ltHeader.length ? ltHeader.outerHeight() : 0;
            const isHeaderVisible = ltHeader.attr('data-scrollshow') === 'true';

            if (this.changeStatus) {
              adsorption.css('top', isHeaderVisible ? `${headerHeight}px` : '0');
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-blog"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('scenario-rv-blog')) {
      customElements.define(
        'scenario-rv-blog',
        class ScenarioRvBlog extends HTMLElement {
          swiper = null;
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            const $mySwiper = this.querySelector('.scenario-rv-blog_swiper');
            const $scrollbarDom = this.querySelector('.scenario-rv-blog-scrollbar');

            this.swiper = new Swiper($mySwiper, {
              slidesPerView: 4,
              spaceBetween: 16,
              scrollbar: {
                el: $scrollbarDom,
                draggable: true,
              },
              breakpoints: {
                1200: {
                  slidesPerView: 4,
                },
                0: {
                  slidesPerView: 'auto',
                },
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-brand-activity"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('scenario-rv-brand-activity')) {
      customElements.define(
        'scenario-rv-brand-activity',
        class ScenarioRvBrandActivity extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          disconnectedCallback() {}
          init() {
            gsapLazy(() => {
              this.initImg();
            });
            this.initTab();
            this.initPanel();
            this.initSwiper();
            this.initSwiperMobile();
            this.initVideo();
          }
          initSwiper() {
            const root = $(this);
            const $swiper = root.find('.my-swiper');
            $swiper.each((index, item) => {
              const $swiper = $(item);
              const $swiperSlide = $swiper.find('.swiper-slide');
              const $swiperPagination = $swiper.find('.swiper-pagination');
              let config = {
                effect: 'creative',
                centeredSlides: false,
                slidesPerView: 'auto',
                loop: true,
                loopedSlides: 10,
                loopAdditionalSlides: 2,
                creativeEffect: {
                  limitProgress: 2,
                  prev: {
                    translate: ['-5%', 0, 0],
                    origin: 'center center',
                    scale: 0.8,
                  },
                  next: {
                    translate: ['15%', 0, 0],
                    origin: 'center center',
                    scale: 0.8,
                  },
                },
                pagination: {
                  el: $swiperPagination[0],
                  clickable: false,
                },
              };
              if ($swiperSlide.length <= 5) {
                config.loop = false;
              }
              new Swiper(item, config);
            });
          }
          initSwiperMobile() {
            const root = $(this);
            const $swiper = root.find('.my-swiper-mobile');
            $swiper.each((index, item) => {
              const $swiper = $(item);
              const $swiperSlide = $swiper.find('.swiper-slide');
              const $swiperPagination = $swiper.find('.swiper-pagination');
              let config = {
                effect: 'creative',
                centeredSlides: true,
                slidesPerView: 'auto',
                loop: true,
                loopedSlides: 10,
                loopAdditionalSlides: 2,
                creativeEffect: {
                  limitProgress: 2,
                  prev: {
                    translate: ['-18%', 0, 0],
                    origin: 'center center',
                    scale: 0.8,
                  },
                  next: {
                    translate: ['18%', 0, 0],
                    origin: 'center center',
                    scale: 0.8,
                  },
                },
                pagination: {
                  el: $swiperPagination[0],
                  clickable: false,
                },
              };
              if ($swiperSlide.length <= 5) {
                config.loop = false;
              }
              new Swiper(item, config);
            });
          }
          initPanel() {
            const root = $(this);
            const $panels = root.find('.panel');

            // 为每个panel单独初始化
            $panels.each(function () {
              const $panelBox = $(this).closest('.panel-box');
              const $panel = $(this);
              const $panelItems = $panel.find('.panel-item');
              const $panelDesc = $panel.find('.panel-item-desc');

              // 初始化时先隐藏所有描述
              $panelDesc.each(function () {
                const $desc = $(this);
                // 存储实际高度
                $desc.data('fullHeight', $desc[0].scrollHeight);
                // 设置初始状态
                $desc.css({
                  height: 0,
                  overflow: 'hidden',
                  transition: 'height 0.3s ease',
                });
              });

              // 处理当前panel内的卡片点击事件
              $panelItems.on('click', function (e) {
                const $currentItem = $(this);
                const $currentDesc = $currentItem.find('.panel-item-desc');
                const currentIndex = $currentItem.index(); // 获取当前点击项的索引
                // 如果当前卡片已经是激活状态，则收起
                if ($currentItem.hasClass('active')) {
                  return;
                }

                // 收起当前panel内其他所有展开的项
                $panel.find('.panel-item').removeClass('active');
                $panel.find('.panel-item-desc').css('height', '0');

                // 处理图片显示
                $panelBox.find('.image-item').removeClass('active');
                $panelBox.find(`.image-item:eq(${currentIndex})`).addClass('active');

                // 激活当前点击的卡片并展开描述
                $currentItem.addClass('active');
                // 使用存储的高度值
                const contentHeight = $currentDesc.data('fullHeight');
                $currentDesc.css('height', contentHeight + 'px');
              });

              // 为每个panel默认激活第一个卡片
              if ($panelItems.length > 0) {
                $panelItems.first().trigger('click');
              }
            });
          }
          initTab() {
            const root = $(this);
            const $tabBox = root.find('.tab-box');
            const $tabItems = $tabBox.find('.tab-item');
            const $tabContent = root.find('.tab-content');
            const $tabContentItems = $tabContent.find('.tab-content-item');
            $tabContentItems.first().addClass('active');
            function handleTabClick(e) {
              const $tab = $(e.currentTarget);
              const index = $tab.index();

              $tab.addClass('active');
              $tab.siblings().removeClass('active');

              $tabContent.css({
                transform: `translateX(-${index * 100}%)`,
              });

              $tabContentItems.eq(index).addClass('active');
              $tabContentItems.each((eindex, item) => {
                if (eindex !== index) {
                  $(item).removeClass('active');
                }
              });
            }
            $tabItems.on('click', handleTabClick);
            $tabItems.on('click', this.scrollTabToView);
          }
          scrollTabToView(tab) {
            const tabBox = $(this).closest('.tab-box')[0];
            const tabRect = tab.target.getBoundingClientRect();
            const boxRect = tabBox.getBoundingClientRect();

            // 计算目标滚动位置，使tab居中显示
            const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;

            tabBox.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          }
          initImg() {
            const root = $(this);
            const $imgContainer = root.find('.avatar-group');
            const $imgContainerWrapper = root.find('.avatar-container');
            const $imgScroll = root.find('.avatar-scroll');
            let $imgs = $imgContainer.find('img');
            const imgWidth = $($imgs[0]).width();
            const leftOffset = 6;
            const containerWidth = $imgContainer.width() - imgWidth - leftOffset * 2;
            const containerHeight = $imgContainer.height();

            $imgContainerWrapper.css('width', containerWidth + 'px');
            $imgContainerWrapper.css('height', containerHeight + 'px');
            $imgContainer.css('width', containerWidth + 'px');
            $imgScroll.addClass('absolute');
            $imgs = $imgContainer.find('img');
            $imgs.each((index, img) => {
              img.style.left = -index * leftOffset + 'px';
            });
            if ($imgs.length < 5) {
              $imgContainerWrapper.css('width', $imgContainerWrapper.width() + leftOffset + 4 + 'px');
              return;
            } else {
              const $clonedContainer = $imgContainer.clone();
              $imgScroll.append($clonedContainer);
              this.initCarousel(containerWidth);
            }
          }
          initCarousel(width) {
            const root = $(this);
            const scrollWrapper = root.find('.avatar-scroll');
            const container = this.querySelector('.avatar-container');
            const avatars = this.querySelectorAll('.avatar');
            const groupWidth = width;

            function checkFade(avatars, container) {
              const containerRect = container.getBoundingClientRect();
              avatars.forEach((avatar) => {
                const rect = avatar.getBoundingClientRect();
                if (rect.left < containerRect.left + 30) {
                  avatar.classList.add('fade');
                } else {
                  avatar.classList.remove('fade');
                }
              });
              requestAnimationFrame(() => {
                checkFade(avatars, container);
              });
            }

            gsap.to(scrollWrapper, {
              x: -groupWidth,
              duration: 10,
              ease: 'none',
              repeat: -1,
              onRepeat: () => {
                // 添加no-transition类来禁用过渡效果
                avatars.forEach((avatar) => {
                  avatar.classList.add('no-transition');
                  avatar.classList.remove('fade');
                });

                gsap.set(scrollWrapper, { x: 0 });

                // 使用requestAnimationFrame确保DOM更新后再移除no-transition类
                requestAnimationFrame(() => {
                  avatars.forEach((avatar) => {
                    avatar.classList.remove('no-transition');
                  });
                });
              },
            });

            checkFade(avatars, container);
          }
          initVideo() {
            const root = $(this);
            const $videoId = root.find('[data-video-id]');
            $videoId.on('click', function () {
              const videoId = $(this).attr('data-video-id');
              const $videoModal = root.find(`[data-video-modal-id="${videoId}"]`).eq(0);
              $videoModal.find('[data-video-show]').attr('data-video-show', 'true');
              $videoModal.find('video').trigger('play');
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-brand-advantage"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('scenario-rv-brand-advantage')) {
      customElements.define(
        'scenario-rv-brand-advantage',
        class ScenarioRvBrandAdvantage extends HTMLElement {
          constructor() {
            super();
            this.init();
          }

          init() {
            // 初始化tab切换
            this.initTabs();
            // 初始化内容切换
            this.initContent();
            this.initCard();
          }
          initCard() {
            const cards = this.querySelectorAll('.card-detail-btn');
            cards.forEach((card) => {
              card.addEventListener('click', () => {
                card.classList.toggle('active');
                card.closest('.card').classList.toggle('active');
              });
            });
          }
          initContent() {
            const contentSwipers = this.querySelectorAll('.content-swiper');
            contentSwipers.forEach((contentSwiper) => {
              const slidesCount = contentSwiper.querySelectorAll('.swiper-slide').length;
              const largeScreenOffset = slidesCount > 4 ? 432 + 24 + 100 : 456;
              if (slidesCount <= 3 && window.innerWidth >= 1400) {
                $(contentSwiper).find('.swiper-button-next, .swiper-button-prev').hide();
              }
              new Swiper(contentSwiper, {
                slidesPerView: 'auto',
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                enabled: !(slidesCount <= 3 && window.innerWidth >= 1400),
                navigation: {
                  nextEl: contentSwiper.querySelector('.swiper-button-next'),
                  prevEl: contentSwiper.querySelector('.swiper-button-prev'),
                },
                scrollbar: {
                  el: contentSwiper.querySelector('.swiper-scrollbar'),
                  draggable: true,
                },
                breakpoints: {
                  576: {
                    slidesOffsetBefore: 32,
                    slidesOffsetAfter: 32,
                    spaceBetween: 24,
                  },
                  1200: {
                    slidesOffsetBefore: 48,
                    slidesOffsetAfter: 48,
                    spaceBetween: 24,
                  },
                  1400: {
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: largeScreenOffset,
                    spaceBetween: 24,
                  },
                  385: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                  },
                  0: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                  },
                },
              });
            });
          }

          // 滚动元素到容器中间的通用函数
          scrollToCenter(element) {
            if (!element) return;

            // 获取最外层的可滚动容器
            const container = element.closest('.overflow-x-auto');
            if (!container) return;

            // 获取元素相对于可滚动容器的位置
            const containerRect = container.getBoundingClientRect();
            const elementRect = element.getBoundingClientRect();
            const elementRelativeLeft = elementRect.left - containerRect.left + container.scrollLeft;

            // 计算需要滚动的位置，使元素居中
            const scrollPosition = elementRelativeLeft - containerRect.width / 2 + elementRect.width / 2;

            // 使用平滑滚动
            container.scrollTo({
              left: scrollPosition,
              behavior: 'smooth',
            });
          }

          initTabs() {
            const tabItems = this.querySelectorAll('.tabs-item');
            const tabSwiper = new Swiper(this.querySelector('.tab-swiper'), {
              spaceBetween: 300,
              allowTouchMove: false,
            });

            // 设置第一个tab为激活状态
            tabItems[0]?.classList.add('active');

            tabItems.forEach((tab, index) => {
              tab.addEventListener('click', () => {
                // 移除所有tab的激活状态
                tabItems.forEach((item) => item.classList.remove('active'));
                // 添加当前tab的激活状态
                tab.classList.add('active');
                // 切换到对应的slide
                tabSwiper.slideTo(index);
                // 将点击的tab滚动到中间
                this.scrollToCenter(tab);
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-brand"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('scenario-rv-brand-activity')) {
      customElements.define(
        'scenario-rv-brand-activity',
        class ScenarioRvBrandActivity extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          disconnectedCallback() {}
          init() {
            gsapLazy(() => {
              this.initImg();
            });

            this.initTab();
            this.initPanel();
            this.initSwiper();
            this.initSwiperMobile();
            this.initVideo();
          }
          initSwiper() {
            const root = $(this);
            const $swiper = root.find('.my-swiper');
            $swiper.each((index, item) => {
              const $swiper = $(item);
              const $swiperSlide = $swiper.find('.swiper-slide');
              const $swiperPagination = $swiper.find('.swiper-pagination');
              let config = {
                effect: 'creative',
                centeredSlides: false,
                slidesPerView: 'auto',
                loop: true,
                loopedSlides: 10,
                loopAdditionalSlides: 2,
                creativeEffect: {
                  limitProgress: 2,
                  prev: {
                    translate: ['-5%', 0, 0],
                    origin: 'center center',
                    scale: 0.8,
                  },
                  next: {
                    translate: ['15%', 0, 0],
                    origin: 'center center',
                    scale: 0.8,
                  },
                },
                pagination: {
                  el: $swiperPagination[0],
                  clickable: false,
                },
              };
              if ($swiperSlide.length <= 5) {
                config.loop = false;
              }
              new Swiper(item, config);
            });
          }
          initSwiperMobile() {
            const root = $(this);
            const $swiper = root.find('.my-swiper-mobile');
            $swiper.each((index, item) => {
              const $swiper = $(item);
              const $swiperSlide = $swiper.find('.swiper-slide');
              const $swiperPagination = $swiper.find('.swiper-pagination');
              let config = {
                effect: 'creative',
                centeredSlides: true,
                slidesPerView: 'auto',
                loop: true,
                loopedSlides: 10,
                loopAdditionalSlides: 2,
                creativeEffect: {
                  limitProgress: 2,
                  prev: {
                    translate: ['-18%', 0, 0],
                    origin: 'center center',
                    scale: 0.8,
                  },
                  next: {
                    translate: ['18%', 0, 0],
                    origin: 'center center',
                    scale: 0.8,
                  },
                },
                pagination: {
                  el: $swiperPagination[0],
                  clickable: false,
                },
              };
              if ($swiperSlide.length <= 5) {
                config.loop = false;
              }
              new Swiper(item, config);
            });
          }
          initPanel() {
            const root = $(this);
            const $panels = root.find('.panel');

            // 为每个panel单独初始化
            $panels.each(function () {
              const $panelBox = $(this).closest('.panel-box');
              const $panel = $(this);
              const $panelItems = $panel.find('.panel-item');
              const $panelDesc = $panel.find('.panel-item-desc');

              // 初始化时先隐藏所有描述
              $panelDesc.each(function () {
                const $desc = $(this);
                // 存储实际高度
                $desc.data('fullHeight', $desc[0].scrollHeight);
                // 设置初始状态
                $desc.css({
                  height: 0,
                  overflow: 'hidden',
                  transition: 'height 0.3s ease',
                });
              });

              // 处理当前panel内的卡片点击事件
              $panelItems.on('click', function (e) {
                const $currentItem = $(this);
                const $currentDesc = $currentItem.find('.panel-item-desc');
                const currentIndex = $currentItem.index(); // 获取当前点击项的索引
                // 如果当前卡片已经是激活状态，则收起
                if ($currentItem.hasClass('active')) {
                  return;
                }

                // 收起当前panel内其他所有展开的项
                $panel.find('.panel-item').removeClass('active');
                $panel.find('.panel-item-desc').css('height', '0');

                // 处理图片显示
                $panelBox.find('.image-item').removeClass('active');
                $panelBox.find(`.image-item:eq(${currentIndex})`).addClass('active');

                // 激活当前点击的卡片并展开描述
                $currentItem.addClass('active');
                // 使用存储的高度值
                const contentHeight = $currentDesc.data('fullHeight');
                $currentDesc.css('height', contentHeight + 'px');
              });

              // 为每个panel默认激活第一个卡片
              if ($panelItems.length > 0) {
                $panelItems.first().trigger('click');
              }
            });
          }
          initTab() {
            const root = $(this);
            const $tabBox = root.find('.tab-box');
            const $tabItems = $tabBox.find('.tab-item');
            const $tabContent = root.find('.tab-content');
            const $tabContentItems = $tabContent.find('.tab-content-item');
            $tabContentItems.first().addClass('active');
            function handleTabClick(e) {
              const $tab = $(e.currentTarget);
              const index = $tab.index();

              $tab.addClass('active');
              $tab.siblings().removeClass('active');

              $tabContent.css({
                transform: `translateX(-${index * 100}%)`,
              });

              $tabContentItems.eq(index).addClass('active');
              setTimeout(() => {
                $tabContentItems.each((eindex, item) => {
                  if (eindex !== index) {
                    $(item).removeClass('active');
                  }
                });
              }, 300);
            }
            $tabItems.on('click', handleTabClick);
            $tabItems.on('click', this.scrollTabToView);
          }
          scrollTabToView(tab) {
            const tabBox = $(this).closest('.tab-box')[0];
            const tabRect = tab.target.getBoundingClientRect();
            const boxRect = tabBox.getBoundingClientRect();

            // 计算目标滚动位置，使tab居中显示
            const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;

            tabBox.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          }
          initImg() {
            const root = $(this);
            const $imgContainer = root.find('.avatar-group');
            const $imgContainerWrapper = root.find('.avatar-container');
            const $imgScroll = root.find('.avatar-scroll');
            let $imgs = $imgContainer.find('img');
            const imgWidth = $($imgs[0]).width();
            const leftOffset = 6;
            const containerWidth = $imgContainer.width() - imgWidth - leftOffset * 2;
            const containerHeight = $imgContainer.height();

            $imgContainerWrapper.css('width', containerWidth + 'px');
            $imgContainerWrapper.css('height', containerHeight + 'px');
            $imgContainer.css('width', containerWidth + 'px');
            $imgScroll.addClass('absolute');
            $imgs = $imgContainer.find('img');
            $imgs.each((index, img) => {
              img.style.left = -index * leftOffset + 'px';
            });
            if ($imgs.length < 5) {
              $imgContainerWrapper.css('width', $imgContainerWrapper.width() + leftOffset + 4 + 'px');
              return;
            } else {
              const $clonedContainer = $imgContainer.clone();
              $imgScroll.append($clonedContainer);
              this.initCarousel(containerWidth);
            }
          }
          initCarousel(width) {
            const root = $(this);
            const scrollWrapper = root.find('.avatar-scroll');
            const container = this.querySelector('.avatar-container');
            const avatars = this.querySelectorAll('.avatar');
            const groupWidth = width;

            function checkFade(avatars, container) {
              const containerRect = container.getBoundingClientRect();
              avatars.forEach((avatar) => {
                const rect = avatar.getBoundingClientRect();
                if (rect.left < containerRect.left + 30) {
                  avatar.classList.add('fade');
                } else {
                  avatar.classList.remove('fade');
                }
              });
              requestAnimationFrame(() => {
                checkFade(avatars, container);
              });
            }

            gsap.to(scrollWrapper, {
              x: -groupWidth,
              duration: 10,
              ease: 'none',
              repeat: -1,
              onRepeat: () => {
                // 添加no-transition类来禁用过渡效果
                avatars.forEach((avatar) => {
                  avatar.classList.add('no-transition');
                  avatar.classList.remove('fade');
                });

                gsap.set(scrollWrapper, { x: 0 });

                // 使用requestAnimationFrame确保DOM更新后再移除no-transition类
                requestAnimationFrame(() => {
                  avatars.forEach((avatar) => {
                    avatar.classList.remove('no-transition');
                  });
                });
              },
            });

            checkFade(avatars, container);
          }
          initVideo() {
            const root = $(this);
            const $videoId = root.find('[data-video-id]');
            $videoId.on('click', function () {
              const videoId = $(this).attr('data-video-id');
              const $videoModal = root.find(`[data-video-modal-id="${videoId}"]`).eq(0);
              $videoModal.find('[data-video-show]').attr('data-video-show', 'true');
              $videoModal.find('video').trigger('play');
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-compare"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('scenario-rv-compare')) {
      customElements.define(
        'scenario-rv-compare',
        class ScenarioRvCompare extends HTMLElement {
          constructor() {
            super();
            this.init();
          }

          init() {
            // 获取需要的DOM元素
            this.fixedProductList = this.querySelector('.fixed-product-list');
            if (!this.fixedProductList) return;
            this.container = this.querySelector('.scenario-rv-compare');
            this.scrollContainer = this.querySelector('.scroll-container');
            this.contentWrapper = this.querySelector('.content-wrapper');
            this.fixedWrapper = this.fixedProductList.querySelector('.fixed-wrapper');

            // 必要元素缺失则不初始化，避免空元素事件绑定
            if (!this.scrollContainer || !this.contentWrapper) return;

            // 添加滑块相关元素
            this.slider = this.querySelector('.slider');
            this.sliderBar = this.querySelector('.slider-bar');

            // 初始化滚动相关变量
            this.translateX = 0;
            this.maxScroll = 0;

            // 初始化滚动相关
            this.initScrolling();

            // 初始化滑块拖动
            this.initSliderDrag();

            // 初始化时先运行一次
            requestAnimationFrame(() => {
              this.updateMaxScroll();
            });

            // 初始化时更新滑块
            this.updateSliderBar();

            // 监听窗口大小变化
            window.addEventListener('resize', () => {
              this.updateMaxScroll();
            });
          }

          initScrolling() {
            let startX = 0;
            let startTranslateX = 0;
            let isDragging = false;

            const handleStart = (e) => {
              startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
              startTranslateX = this.translateX;
              isDragging = true;

              if (e.type.includes('mouse')) {
                document.addEventListener('mousemove', handleMove);
                document.addEventListener('mouseup', handleEnd);
              }
            };

            const handleMove = (e) => {
              if (!isDragging) return;

              const currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
              const diff = startX - currentX;

              // 只在水平方向拖动时阻止默认行为
              if (Math.abs(diff) > 5) {
                // 添加一个小的阈值
              }

              // 计算新的位移，并添加边界限制
              let newTranslateX = startTranslateX - diff;
              newTranslateX = Math.max(Math.min(0, newTranslateX), -this.maxScroll);

              this.updateTranslate(newTranslateX);
            };

            const handleEnd = () => {
              isDragging = false;
              document.removeEventListener('mousemove', handleMove);
              document.removeEventListener('mouseup', handleEnd);
            };

            // 添加鼠标事件
            [this.scrollContainer, this.fixedProductList].forEach((element) => {
              element.addEventListener('mousedown', handleStart);
              // 防止拖动时选中文本
              element.addEventListener('selectstart', (e) => e.preventDefault());
            });

            // 添加触摸事件
            [this.scrollContainer, this.fixedProductList].forEach((element) => {
              element.addEventListener('touchstart', handleStart, { passive: true });
              element.addEventListener('touchmove', handleMove, { passive: true });
              element.addEventListener('touchend', handleEnd);
            });
          }

          initSliderDrag() {
            if (!this.slider || !this.sliderBar) return;

            let isDragging = false;
            let startX = 0;
            let startLeft = 0;

            const handleStart = (e) => {
              isDragging = true;
              startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
              startLeft = this.getTranslateX(this.sliderBar);

              this.sliderBar.style.cursor = 'grabbing';

              if (e.type.includes('mouse')) {
                document.addEventListener('mousemove', handleMove);
                document.addEventListener('mouseup', handleEnd);
              }
            };

            const handleMove = (e) => {
              if (!isDragging) return;

              const currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
              const diff = currentX - startX;

              // 只在水平方向拖动时阻止默认行为
              if (Math.abs(diff) > 5) {
                // 添加一个小的阈值
                e.preventDefault();
              }

              // 计算滑块的新位置
              const sliderWidth = this.slider.clientWidth;
              const barWidth = this.sliderBar.clientWidth;
              const maxTranslate = sliderWidth - barWidth;

              let newLeft = Math.max(0, Math.min(maxTranslate, startLeft + diff));
              this.sliderBar.style.transform = `translateX(${newLeft}px)`;

              // 根据滑块位置更新内容滚动
              const scrollPercent = newLeft / maxTranslate;
              const contentWidth = this.contentWrapper.scrollWidth;
              const containerWidth = this.scrollContainer.clientWidth;
              const newTranslateX = -scrollPercent * (contentWidth - containerWidth);

              // 更新内容位置（不触发滑块更新）
              this.translateX = newTranslateX;
              this.contentWrapper.style.transform = `translateX(${newTranslateX}px)`;
              this.fixedWrapper.style.transform = `translateX(${newTranslateX}px)`;
            };

            const handleEnd = () => {
              if (!isDragging) return;

              isDragging = false;
              this.sliderBar.style.cursor = '';

              document.removeEventListener('mousemove', handleMove);
              document.removeEventListener('mouseup', handleEnd);
            };

            // 获取元素的 translateX 值
            this.getTranslateX = (element) => {
              const style = window.getComputedStyle(element);
              const matrix = new WebKitCSSMatrix(style.transform);
              return matrix.m41;
            };

            // 添加鼠标事件
            this.sliderBar.addEventListener('mousedown', handleStart);

            // 添加触摸事件
            this.sliderBar.addEventListener('touchstart', handleStart, { passive: false });
            this.sliderBar.addEventListener('touchmove', handleMove, { passive: false });
            this.sliderBar.addEventListener('touchend', handleEnd);

            // 防止拖动时选中文本
            this.sliderBar.addEventListener('selectstart', (e) => e.preventDefault());
          }

          updateMaxScroll() {
            // 计算最大可滚动距离
            const containerWidth = this.scrollContainer.clientWidth;
            const contentWidth = this.contentWrapper.scrollWidth;
            this.maxScroll = Math.max(0, contentWidth - containerWidth);

            // 确保当前偏移量不超出范围
            if (this.translateX < -this.maxScroll) {
              this.updateTranslate(-this.maxScroll);
            }
          }

          updateTranslate(value) {
            this.translateX = value;
            // 更新内容和固定列表的偏移
            this.contentWrapper.style.transform = `translateX(${value}px)`;
            this.fixedWrapper.style.transform = `translateX(${value}px)`;

            // 更新滑块位置
            this.updateSliderBar();
          }

          updateSliderBar() {
            if (!this.slider || !this.sliderBar) return;

            // 计算滑块宽度比例
            const containerWidth = this.scrollContainer.clientWidth;
            const contentWidth = this.contentWrapper.scrollWidth;
            const sliderWidth = this.slider.clientWidth;

            // 计算滑块宽度 (容器宽度占内容总宽度的比例)
            const barWidthPercent = (containerWidth / contentWidth) * 100;
            const barWidth = Math.max(30, (sliderWidth * barWidthPercent) / 100);
            this.sliderBar.style.width = `${barWidth}px`;

            // 计算滑块位置
            const scrollPercent = Math.abs(this.translateX) / (contentWidth - containerWidth);
            const maxTranslate = sliderWidth - barWidth;
            const barTranslate = maxTranslate * scrollPercent;

            this.sliderBar.style.transform = `translateX(${barTranslate}px)`;
          }

          disconnectedCallback() {
            window.removeEventListener('resize', this.handleScroll);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-customer"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('scenario-rv-customer')) {
      customElements.define(
        'scenario-rv-customer',
        class ScenarioRvCustomer extends HTMLElement {
          constructor() {
            super();
            this.init();
          }

          init() {
            const scenarioRvCustomerChatBtn = this.querySelector('.scenario-rv-customer_chat-btn');
            scenarioRvCustomerChatBtn.addEventListener('click', () => {
              window.litime.openChatApp();
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-events"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('scenario-rv-events')) {
      customElements.define(
        'scenario-rv-events',
        class ScenarioRvEvents extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          disconnectedCallback() {
            window.removeEventListener('resize', this.initPanelBox.bind(this));
          }
          init() {
            gsapLazy(() => {
              this.initImg();
            });

            this.initTab();
            this.initPanel();
            this.initSwiper();
            this.initSwiperMobile();
            this.initVideo();
            this.initPanelBox();
            // 监听risize事件
            window.addEventListener('resize', this.initPanelBox.bind(this));
            const $showMore = this.querySelectorAll('[data-show-more]');
            if ($showMore) {
              $showMore.forEach((item) => {
                item.addEventListener('click', function () {
                  const year = $(item).closest('[data-year]');
                  console.log(year);
                  const dataEventIndex = year.find('[data-event-index]');
                  const showMore = $(this).attr('data-show-more');
                  if (showMore === 'true') {
                    $(this).attr('data-show-more', 'false');
                    dataEventIndex.each(function () {
                      if ($(this).attr('data-event-index') > 6) {
                        $(this).removeClass('max-lg:hidden');
                      }
                    });
                  } else {
                    $(this).attr('data-show-more', 'true');
                    dataEventIndex.each(function () {
                      if ($(this).attr('data-event-index') > 6) {
                        $(this).addClass('max-lg:hidden');
                      }
                    });
                  }
                });
              });
            }
          }
          initPanelBox() {
            if (window.innerWidth > 1200) {
              const panelBoxRightContent = this.querySelector('.panel-box__right__content');
              const panelBoxLeftContent = this.querySelectorAll('.panel-box__left__content');
              const rightHeight = panelBoxRightContent.offsetHeight;
              panelBoxLeftContent.forEach((item) => {
                item.style.height = rightHeight + 'px';
              });
            }
          }
          initSwiper() {
            const root = $(this);
            const $swiper = root.find('.my-swiper');
            $swiper.each((index, item) => {
              const $swiper = $(item);
              const $swiperSlide = $swiper.find('.swiper-slide');
              const $swiperPagination = $swiper.find('.swiper-pagination');
              const $swiperPrev = $swiper.find('.scenario-rv-ads_prev');
              const $swiperNext = $swiper.find('.scenario-rv-ads_next');
              let config = {
                slidesPerView: 1,
                loop: true,
                loopedSlides: 10,
                effect: 'fade',
                speed: 600,
                fadeEffect: {
                  crossFade: true,
                },
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                navigation: {
                  nextEl: $swiperNext[0],
                  prevEl: $swiperPrev[0],
                },
                pagination: {
                  el: $swiperPagination[0],
                  clickable: false,
                  type: 'bullets',
                },
                on: {
                  autoplayTimeLeft(_s, _time, progress) {
                    requestAnimationFrame(() => {
                      $swiperPagination.css('--progress', `${(1 - progress) * 100}%`);
                    });
                  },
                },
              };
              if ($swiperSlide.length <= 5) {
                config.loop = false;
              }
              new Swiper(item, config);
            });
          }
          initSwiperMobile() {
            const root = $(this);
            const $swiper = root.find('.my-swiper-mobile');
            $swiper.each((index, item) => {
              const $swiper = $(item);
              const $swiperSlide = $swiper.find('.swiper-slide');
              const $swiperPagination = $swiper.find('.swiper-pagination');
              let config = {
                slidesPerView: 1,
                loop: true,
                loopedSlides: 10,
                centeredSlides: true,
                effect: 'fade',
                speed: 600,
                fadeEffect: {
                  crossFade: true,
                },
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                pagination: {
                  el: $swiperPagination[0],
                  clickable: false,
                  type: 'bullets',
                },
                on: {
                  autoplayTimeLeft(_s, _time, progress) {
                    requestAnimationFrame(() => {
                      $swiperPagination.css('--progress', `${(1 - progress) * 100}%`);
                    });
                  },
                },
              };
              if ($swiperSlide.length <= 5) {
                config.loop = false;
              }
              new Swiper(item, config);
            });
          }
          initPanel() {
            const root = $(this);
            const $panels = root.find('.panel');

            // 为每个panel单独初始化
            $panels.each(function () {
              const $panelBox = $(this).closest('.panel-box');
              const $panel = $(this);
              const $panelItems = $panel.find('.panel-item');
              const $panelDesc = $panel.find('.panel-item-desc');

              // 初始化时先隐藏所有描述
              $panelDesc.each(function () {
                const $desc = $(this);
                // 存储实际高度
                $desc.data('fullHeight', $desc[0].scrollHeight);
                // 设置初始状态
                $desc.css({
                  height: 0,
                  overflow: 'hidden',
                  transition: 'height 0.3s ease',
                });
              });

              // 处理当前panel内的卡片点击事件
              $panelItems.on('click', function (e) {
                const $currentItem = $(this);
                const $currentDesc = $currentItem.find('.panel-item-desc');
                const currentIndex = $currentItem.index(); // 获取当前点击项的索引
                // 如果当前卡片已经是激活状态，则收起
                if ($currentItem.hasClass('active')) {
                  $currentItem.removeClass('active');
                  $currentDesc.css('height', '0');
                  return;
                }

                // 收起当前panel内其他所有展开的项
                $panel.find('.panel-item').removeClass('active');
                $panel.find('.panel-item-desc').css('height', '0');

                // 处理图片显示
                $panelBox.find('.image-item').removeClass('active');
                $panelBox.find(`.image-item:eq(${currentIndex})`).addClass('active');

                // 激活当前点击的卡片并展开描述
                $currentItem.addClass('active');
                // 使用存储的高度值
                const contentHeight = $currentDesc.data('fullHeight');
                $currentDesc.css('height', contentHeight + 'px');
              });

              // 为每个panel默认激活第一个卡片
              if ($panelItems.length > 0) {
                $panelItems.first().trigger('click');
              }
            });
          }
          initTab() {
            const root = $(this);
            const $tabBox = root.find('.tab-box');
            const $tabItems = $tabBox.find('.tab-item');
            const $tabContent = root.find('.tab-content');
            const $tabContentItems = $tabContent.find('.tab-content-item');
            $tabContentItems.first().addClass('active');
            function handleTabClick(e) {
              const $tab = $(e.currentTarget);
              const index = $tab.index();

              $tab.addClass('active');
              $tab.siblings().removeClass('active');

              $tabContent.css({
                transform: `translateX(-${index * 100}%)`,
              });

              $tabContentItems.eq(index).addClass('active');
              $tabContentItems.each((eindex, item) => {
                if (eindex !== index) {
                  $(item).removeClass('active');
                }
              });
            }
            $tabItems.on('click', handleTabClick);
            $tabItems.on('click', this.scrollTabToView);
          }
          scrollTabToView(tab) {
            const tabBox = $(this).closest('.tab-box')[0];
            const tabRect = tab.target.getBoundingClientRect();
            const boxRect = tabBox.getBoundingClientRect();

            // 计算目标滚动位置，使tab居中显示
            const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;

            tabBox.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          }
          initImg() {
            const root = $(this);
            const $imgContainer = root.find('.avatar-group');
            const $imgContainerWrapper = root.find('.avatar-container');
            const $imgScroll = root.find('.avatar-scroll');
            let $imgs = $imgContainer.find('img');
            const imgWidth = $($imgs[0]).width();
            const leftOffset = 6;
            const containerWidth = $imgContainer.width() - imgWidth - leftOffset * 2;
            const containerHeight = $imgContainer.height();

            $imgContainerWrapper.css('width', containerWidth + 'px');
            $imgContainerWrapper.css('height', containerHeight + 'px');
            $imgContainer.css('width', containerWidth + 'px');
            $imgScroll.addClass('absolute');
            $imgs = $imgContainer.find('img');
            $imgs.each((index, img) => {
              img.style.left = -index * leftOffset + 'px';
            });
            if ($imgs.length < 5) {
              $imgContainerWrapper.css('width', $imgContainerWrapper.width() + leftOffset + 4 + 'px');
              return;
            } else {
              const $clonedContainer = $imgContainer.clone();
              $imgScroll.append($clonedContainer);
              this.initCarousel(containerWidth);
            }
          }
          initCarousel(width) {
            const root = $(this);
            const scrollWrapper = root.find('.avatar-scroll');
            const container = this.querySelector('.avatar-container');
            const avatars = this.querySelectorAll('.avatar');
            const groupWidth = width;

            function checkFade(avatars, container) {
              const containerRect = container.getBoundingClientRect();
              avatars.forEach((avatar) => {
                const rect = avatar.getBoundingClientRect();
                if (rect.left < containerRect.left + 30) {
                  avatar.classList.add('fade');
                } else {
                  avatar.classList.remove('fade');
                }
              });
              requestAnimationFrame(() => {
                checkFade(avatars, container);
              });
            }

            gsap.to(scrollWrapper, {
              x: -groupWidth,
              duration: 10,
              ease: 'none',
              repeat: -1,
              onRepeat: () => {
                // 添加no-transition类来禁用过渡效果
                avatars.forEach((avatar) => {
                  avatar.classList.add('no-transition');
                  avatar.classList.remove('fade');
                });

                gsap.set(scrollWrapper, { x: 0 });

                // 使用requestAnimationFrame确保DOM更新后再移除no-transition类
                requestAnimationFrame(() => {
                  avatars.forEach((avatar) => {
                    avatar.classList.remove('no-transition');
                  });
                });
              },
            });

            checkFade(avatars, container);
          }
          initVideo() {
            const root = $(this);
            const $videoId = root.find('[data-video-id]');
            $videoId.on('click', function () {
              const videoId = $(this).attr('data-video-id');
              const $videoModal = root.find(`[data-video-modal-id="${videoId}"]`).eq(0);
              $videoModal.find('[data-video-show]').attr('data-video-show', 'true');
              $videoModal.find('video').trigger('play');
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-hot"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('scenario-rv-hot')) {
      customElements.define(
        'scenario-rv-hot',
        class ScenarioRvHot extends HTMLElement {
          constructor() {
            super();
            this.tl = null;
          }

          connectedCallback() {
            this.init();
          }

          async init() {
            this.eventInit();
          }

          eventInit() {
            const root = $(this);
            const $points = root.find('.rv-hot-point');
            $points.on('click', (e) => {
              const $point = $(e.currentTarget);
              $point.toggleClass('active');
              const $content = $point.next('.rv-hot-content');
              $content.toggleClass('active');
              $points.not($point).removeClass('active');
              $points.not($point).next('.rv-hot-content').removeClass('active');
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-navigation"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('scenario-rv-navigation')) {
      customElements.define(
        'scenario-rv-navigation',
        class ScenarioRvNavigation extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            this.addResizeListener();
          }
          init() {
            let $swiperDom = this.querySelector('.mySwiper');
            let $scrollbarDom = this.querySelector('.swiper-scrollbar');
            const $scrollbar = this.querySelector('.swiper-scrollbar');

            new Swiper($swiperDom, {
              slidesPerView: 'auto',
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              scrollbar: {
                el: $scrollbar,
                draggable: true,
              },
              breakpoints: {
                576: {
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
                0: {
                  slidesPerView: 'auto',
                  spaceBetween: 12,

                  grid: {
                    rows: 2,
                  },
                },
              },
              scrollbar: {
                el: $scrollbarDom,
                draggable: true,
              },
            });
          }
          addResizeListener() {
            window.addEventListener('resize', () => {
              clearTimeout(this.resizeTimer);
              this.resizeTimer = setTimeout(() => {
                this.init(); // 300ms防抖后重新初始化
              }, 300);
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-scene"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('scenario-rv-scene')) {
      customElements.define(
        'scenario-rv-scene',
        class ScenarioRvScene extends HTMLElement {
          productDetailModalBigPictrueSwiper = null;
          productDetailModalSmallPictrueSwiper = null;
          shopMoneyFormat = null;
          productInventoryQuantity = null;
          productDetailModalCopy = null;
          swiper = null;
          constructor() {
            super();
          }

          connectedCallback() {
            const _this = this;
            this.init();
            this.initSwiper();
            this.shopMoneyFormat = window.shopMoneyFormat;
            gsapLazy(() => {
              this.scrollbarMove();
            });
          }

          scrollbarMove() {
            gsap.registerPlugin(ScrollTrigger);
            const contentWrapper = $('.content-wrapper');
            const scrollbarMove = $('.scrollbar-move');

            gsap.to(scrollbarMove, {
              y: 42, // 最大移动距离
              ease: 'none',
              force3D: true,
              scrollTrigger: {
                trigger: contentWrapper,
                start: 'top bottom', // 当内容顶部碰到视窗底部时开始
                end: 'bottom top', // 当内容底部碰到视窗顶部时结束
                scrub: true, // 实时跟随滚动
                // markers: true,    // 调试用，显示触发点
                onUpdate: (self) => {
                  // 根据滚动进度计算位置
                  const progress = self.progress;
                  const y = progress < 0.5 ? (1 - progress * 2) * 42 : -(progress * 2 - 1) * 42;

                  gsap.set(scrollbarMove, { y });
                },
              },
            });
          }

          init() {
            const _this = this;

            const learnMoreIndex = $(this.querySelectorAll('[data-learn-index]'));
            learnMoreIndex.on('click', function () {
              const index = $(this).data('learn-index');
              const allCollectionModal = $(_this).find('.all-collection_modal');
              allCollectionModal.removeClass('hidden');
              window.litime.disableScroll();
              const $mySwiper = $(_this).find('.modal-tab_swiper');
              const swiperWidth = $($mySwiper).width();
              const swiperWrapperWidth = $mySwiper.parent().width();
              if (swiperWidth >= swiperWrapperWidth - 64) {
                $mySwiper.parent().find('.modal-tab_swiper_next').removeClass('hidden').addClass('flex');
              }
              // _this.changeTav(index, allCollectionModal.find(`[data-tab-index="${index}"]`));
            });
          }

          initSwiper() {
            new Swiper(this.querySelector('.scenario-rv-scene_swiper'), {
              slidesPerView: 'auto',
              spaceBetween: 16,
              scrollbar: {
                el: this.querySelector('.swiper-scrollbar'),
                draggable: true,
              },
              breakpoints: {
                768: {
                  spaceBetween: 24,
                },
                0: {
                  spaceBetween: 16,
                },
              },
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-shopping-guide"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('scenario-rv-shopping-guide')) {
      customElements.define(
        'scenario-rv-shopping-guide',
        class ScenarioRvShoppingGuide extends HTMLElement {
          constructor() {
            super();
            this.currentImageIndex = 0;
            this.imageInterval = null;
          }
          connectedCallback() {
            this.init();
          }
          init() {
            // 检查是否存在img-container元素
            const imgContainer = this.querySelector('.img-container');
            const imgMobileContainer = this.querySelector('.img-mobile-container');
            if (imgContainer && imgContainer.children.length > 1) {
              this.initImage();
            }
            if (window.innerWidth > 1200) {
              // this.initContent();
            } else {
              this.startImageRotation(imgMobileContainer);
            }
            this.initDialog();
            this.initTab();
            if (window.innerWidth <= 960) {
              this.initSwiper();
            }
          }
          initSwiper() {
            const $swiper = $(this).find('.swiper-reserved');
            const $swiperWrapper = $(this).find('.swiper-wrapper-reserved');
            const $swiperSlide = $(this).find('.swiper-slide-reserved');
            $swiper.addClass('swiper');
            $swiperWrapper.addClass('swiper-wrapper');
            $swiperSlide.addClass('swiper-slide');
            const swiper = new Swiper($swiper[0], {
              slidesPerView: 'auto',
              spaceBetween: 16,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              scrollbar: {
                el: $swiper.find('.swiper-scrollbar')[0],
                draggable: true,
              },
              breakpoints: {
                576: {
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
                385: {
                  slidesPerView: 'auto',
                  slidesPerGroup: 1,
                  spaceBetween: 16,
                },
                0: {
                  slidesPerView: 'auto',
                  slidesPerGroup: 1,
                  spaceBetween: 16,
                },
              },
            });
          }
          initTab() {
            const $tabs = $(this).find('.tab-item');
            const $mobileTabs = $(this).find('.tab-mobile-item');
            const $tabContent = $(this).find('.tab-content');
            const $tableContainers = $(this).find('.tab-content-container');

            // 初始化滚动阴影
            $tableContainers.each((_, container) => {
              this.checkScrollShadow(container);

              // 监听滚动事件
              container.addEventListener('scroll', () => {
                this.checkScrollShadow(container);
              });
            });

            function handleTabClick(e) {
              const $tab = $(e.currentTarget);
              const index = $tab.index();

              $tab.addClass('active');
              $tab.siblings().removeClass('active');

              $tabContent.css({
                transform: `translateX(-${index * 100}%)`,
              });
            }
            $mobileTabs.on('click', handleTabClick);
            $mobileTabs.on('click', this.scrollTabToView);
            $tabs.on('click', handleTabClick);
          }
          scrollTabToView(tab) {
            const tabBox = $(this).closest('.tab-mobile-box')[0];
            const tabRect = tab.target.getBoundingClientRect();
            const boxRect = tabBox.getBoundingClientRect();

            // 计算目标滚动位置，使tab居中显示
            const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;

            tabBox.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          }
          initDialog() {
            const $items = $(this).find('.step-1-btn');
            this.$dialog = $(this).find('dialog-simple');
            $items.on('click', (e) => {
              const $item = $(e.currentTarget);
              this.$dialog.attr({
                'data-show': 'true',
                'data-title': $item.attr('data-title'),
                'data-desc': $item.attr('data-desc'),
              });
            });
          }
          initImage() {
            // 创建Intersection Observer实例
            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    // 当元素进入视口时
                    const imgContainer = entry.target.querySelector('.img-container');
                    if (imgContainer) {
                      // 先设置宽度
                      imgContainer.style.width = '92px';

                      // 添加过渡类
                      requestAnimationFrame(() => {
                        setTimeout(() => {
                          imgContainer.children[0].style.transform = 'scale(100%)';
                        }, 300);
                      });

                      // 开始图片轮播
                      this.startImageRotation(imgContainer);
                    }
                    // 元素已显示动画，移除观察
                    observer.unobserve(entry.target);
                  }
                });
              },
              {
                threshold: 0.1, // 当10%的元素可见时触发
              }
            );

            // 观察标题区域
            const titleElement = this.querySelector('.title-element');
            if (titleElement) {
              observer.observe(titleElement);
            }
          }
          startImageRotation(imgContainer) {
            const images = imgContainer.querySelectorAll('img');
            if (images.length < 2) return;

            // 初始化所有图片的样式
            images.forEach((img, index) => {
              img.style.position = 'absolute';
              img.style.top = '0';
              img.style.left = '0';
              img.style.opacity = index === 0 ? '1' : '0';
              img.style.transition = 'opacity 0.5s ease-in-out';
            });

            // 设置轮播间隔
            this.imageInterval = setInterval(() => {
              // 当前图片淡出
              images[this.currentImageIndex].style.opacity = '0';

              // 更新索引
              this.currentImageIndex = (this.currentImageIndex + 1) % images.length;

              // 下一张图片淡入
              images[this.currentImageIndex].style.opacity = '1';
            }, 1000); // 每1.5秒切换一次
          }

          disconnectedCallback() {
            // 组件移除时清除定时器
            if (this.imageInterval) {
              clearInterval(this.imageInterval);
            }
          }
          // 检查是否需要显示滚动阴影
          checkScrollShadow(container) {
            // 检查是否有横向滚动
            const hasHorizontalScroll = container.scrollWidth > container.clientWidth;
            // 检查是否已经开始滚动
            const hasScrolled = container.scrollLeft > 0;

            if (hasHorizontalScroll && hasScrolled) {
              container.classList.add('sticky-shadow');
            } else {
              container.classList.remove('sticky-shadow');
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-rv-user-backmap"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    const defineScenarioRvUserBackmap = () => {
      customElements.define(
        'scenario-rv-user-backmap',
        class scenarioRvUserBackmap extends HTMLElement {
          constructor() {
            super();
            this.eventListeners = [];
            this.swiperInstance = null;
            this.isDragging = false;
          }

          connectedCallback() {
            gsapLazy(() => {
              this.querySelectorAll('.marquee-track').forEach((track) => {
                // 清理已有 timeline
                if (track._gsapTimeline) {
                  track._gsapTimeline.kill();
                  track._gsapTimeline = null;
                }

                // 只 clone 一次
                if (!track.dataset.cloned) {
                  track.insertAdjacentHTML('beforeend', track.innerHTML);
                  track.dataset.cloned = 'true';
                }

                // 移除旧事件监听器的彻底方法
                const newTrack = track.cloneNode(true);
                track.replaceWith(newTrack);

                this.initMarquee(newTrack);
              });

              this.bindDragEvents();
            });

            this.initSwiper();
          }

          disconnectedCallback() {
            // 清理 GSAP timelines
            this.querySelectorAll('.marquee-track').forEach((track) => {
              if (track._gsapTimeline) {
                track._gsapTimeline.kill();
                track._gsapTimeline = null;
              }
            });

            // 清理 Swiper 实例
            if (this.swiperInstance && this.swiperInstance.destroy) {
              this.swiperInstance.destroy(true, true);
              this.swiperInstance = null;
            }

            // 移除所有追踪的事件监听器
            this.eventListeners.forEach(({ element, event, handler }) => {
              element.removeEventListener(event, handler);
            });
            this.eventListeners = [];
          }

          bindDragEvents() {
            // 监听拖动开始
            const dragStartHandler = () => {
              this.isDragging = true;
              this.pauseAllAnimations();
            };

            // 监听拖动结束
            const dragEndHandler = () => {
              this.isDragging = false;
              this.resumeAllAnimations();
            };

            // 绑定拖动事件
            this.addEventListener('dragstart', dragStartHandler);
            this.addEventListener('dragend', dragEndHandler);

            // 也监听鼠标事件（Shopify编辑器可能使用鼠标拖动）
            this.addEventListener('mousedown', dragStartHandler);
            document.addEventListener('mouseup', dragEndHandler);

            // 记录事件监听器
            this.eventListeners.push(
              { element: this, event: 'dragstart', handler: dragStartHandler },
              { element: this, event: 'dragend', handler: dragEndHandler },
              { element: this, event: 'mousedown', handler: dragStartHandler },
              { element: document, event: 'mouseup', handler: dragEndHandler }
            );
          }

          pauseAllAnimations() {
            this.querySelectorAll('.marquee-track').forEach((track) => {
              if (track._gsapTimeline && track._gsapTimeline.pause) {
                track._gsapTimeline.pause();
              }
            });
          }

          resumeAllAnimations() {
            this.querySelectorAll('.marquee-track').forEach((track) => {
              if (track._gsapTimeline && track._gsapTimeline.resume) {
                track._gsapTimeline.resume();
              }
            });
          }
          initSwiper() {
            const root = $(this);
            const $swiper = root.find('.my-swiper');
            const $scrollbarDom = root.find('.swiper-scrollbar');

            // 清理已有的 Swiper 实例
            if (this.swiperInstance && this.swiperInstance.destroy) {
              this.swiperInstance.destroy(true, true);
              this.swiperInstance = null;
            }

            this.swiperInstance = new Swiper($swiper[0], {
              slidesPerView: 'auto',
              spaceBetween: 16,
              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              scrollbar: {
                el: $scrollbarDom,
                draggable: true,
              },
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              breakpoints: {
                576: {
                  spaceBetween: 24,
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
                385: {
                  slidesPerView: 'auto',
                  slidesPerGroup: 1,
                  spaceBetween: 16,
                },
                0: {
                  slidesPerView: 'auto',
                  slidesPerGroup: 1,
                  spaceBetween: 16,
                },
              },
            });
          }
          initMarquee(track) {
            const direction = track.dataset.direction || 'left';
            const pauseType = track.dataset.pauseType || 'smooth';
            const totalTime = track.dataset.totalTime || 15;
            const itemsLength = Math.floor(track.children.length / 2); // 只计算原始长度
            const computedGap = getComputedStyle(track);
            const trackGap = parseFloat(computedGap.gap);

            requestAnimationFrame(() => {
              const itemsWidth = Array.from(track.children)
                .slice(0, itemsLength)
                .reduce((total, item) => total + item.offsetWidth + trackGap, 0);

              const speed = parseFloat(track.dataset.speed) || 1;
              const duration = totalTime / speed;

              let startX, endX;
              if (direction === 'right') {
                startX = -itemsWidth;
                endX = 0;
              } else {
                startX = 0;
                endX = -itemsWidth;
              }

              gsap.set(track, { x: startX });

              const tl = gsap.to(track, {
                x: endX,
                duration: duration,
                ease: 'none',
                repeat: -1,
                onUpdate: function () {
                  const currentX = this.targets()[0]._gsap.x;
                  const absX = Math.abs(currentX);

                  const shouldReset =
                    direction === 'right'
                      ? currentX >= -1 // 向右滚动即将到达0时
                      : absX >= itemsWidth - 1; // 向左滚动即将超过一组宽度时

                  if (shouldReset) {
                    requestAnimationFrame(() => {
                      this.targets()[0].style.transition = 'none';
                      gsap.set(track, { x: startX });
                      this.restart();
                    });
                  }
                },
              });

              track._gsapTimeline = tl;

              // 创建事件处理函数
              const mouseEnterHandler = () => {
                if (pauseType === 'immediate') {
                  tl.pause();
                } else {
                  gsap.to(tl, {
                    timeScale: 0,
                    duration: 1,
                    ease: 'power2.inOut',
                  });
                }
              };

              const mouseLeaveHandler = () => {
                if (pauseType === 'immediate') {
                  tl.resume();
                } else {
                  gsap.to(tl, {
                    timeScale: 1,
                    duration: 1,
                    ease: 'power2.inOut',
                  });
                }
              };

              // 添加事件监听器
              track.addEventListener('mouseenter', mouseEnterHandler);
              track.addEventListener('mouseleave', mouseLeaveHandler);
            });
          }
        }
      );
    };

    // Shopify 设计模式下使用全局变量防止重复定义
    if (Shopify.designMode) {
      if (!window.__scenarioRvUserBackmapInit) {
        window.__scenarioRvUserBackmapInit = true;
        defineScenarioRvUserBackmap();
      }
    } else {
      // 正常前台页面
      if (!customElements.get('scenario-rv-user-backmap')) {
        defineScenarioRvUserBackmap();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-endorsement-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('service-endorsement-v2')) {
      customElements.define(
        'service-endorsement-v2',
        class ServiceEndorsementV2 extends HTMLElement {
          constructor() {
            super();
            this.DURATION = 30;
            this.CONTENT_MAX_WIDTH = 1600;
            this.rafId = null;
            this.contentOffset = 0;
            this.loopDistance = 0;
            this.leadWidth = 0;
            this.introDone = false;
            this.lastTime = 0;
            this.cloneGroups = [];
            this.resizeTimer = null;
            this._onResize = this._handleResize.bind(this);
            this._tick = this.tick.bind(this);
          }

          connectedCallback() {
            this.root = this.querySelector('.service-endorsement-v2');
            this.viewport = this.querySelector('[data-marquee-viewport]');
            this.track = this.querySelector('[data-marquee-track]');
            this.lead = this.querySelector('[data-marquee-lead]');
            this.sourceGroup = this.querySelector('[data-marquee-group]');

            if (!this.root || !this.viewport || !this.track || !this.lead || !this.sourceGroup) return;
            if (!this.sourceGroup.children.length) return;

            this.initMarquee();
            window.addEventListener('resize', this._onResize);
          }

          disconnectedCallback() {
            window.removeEventListener('resize', this._onResize);
            clearTimeout(this.resizeTimer);
            this.stopScroll();
            this.removeClones();
          }

          getLeftPadding() {
            const windowWidth = document.documentElement.clientWidth;
            const minPadding = windowWidth <= 576 ? 16 : 32;
            return Math.max((windowWidth - this.CONTENT_MAX_WIDTH) / 2, minPadding);
          }

          updatePadding() {
            const padding = this.getLeftPadding();
            this.root.style.setProperty('--marquee-padding', `${padding}px`);
            return padding;
          }

          applyTransform() {
            const x = this.introDone ? this.leadWidth + this.contentOffset : this.contentOffset;
            this.track.style.transform = `translate3d(${-x}px, 0, 0)`;
          }

          stopScroll() {
            if (this.rafId !== null) {
              cancelAnimationFrame(this.rafId);
              this.rafId = null;
            }
            this.lastTime = 0;
            this.contentOffset = 0;
            this.introDone = false;
            if (this.track) {
              this.track.style.transform = 'translate3d(0, 0, 0)';
            }
          }

          tick(time) {
            if (!this.lastTime) this.lastTime = time;

            const delta = time - this.lastTime;
            this.lastTime = time;
            const speed = this.loopDistance / (this.DURATION * 1000);
            this.contentOffset += speed * delta;

            if (!this.introDone) {
              if (this.contentOffset >= this.leadWidth) {
                this.introDone = true;
                this.contentOffset -= this.leadWidth;
              }
            } else if (this.contentOffset >= this.loopDistance) {
              this.contentOffset -= this.loopDistance;
            }

            this.applyTransform();
            this.rafId = requestAnimationFrame(this._tick);
          }

          startScroll(distance) {
            this.stopScroll();
            this.loopDistance = distance;
            this.applyTransform();
            this.rafId = requestAnimationFrame(this._tick);
          }

          removeClones() {
            this.cloneGroups.forEach((node) => node.remove());
            this.cloneGroups = [];
          }

          ensureClones() {
            this.removeClones();

            const firstClone = this.sourceGroup.cloneNode(true);
            firstClone.setAttribute('aria-hidden', 'true');
            firstClone.removeAttribute('data-marquee-group');
            this.track.appendChild(firstClone);
            this.cloneGroups.push(firstClone);

            const distance = firstClone.offsetLeft - this.sourceGroup.offsetLeft;
            if (distance <= 0) return distance;

            while (this.track.scrollWidth < distance + this.viewport.clientWidth + 1) {
              const clone = this.sourceGroup.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              clone.removeAttribute('data-marquee-group');
              this.track.appendChild(clone);
              this.cloneGroups.push(clone);
            }

            return distance;
          }

          resetMarquee() {
            this.stopScroll();
            this.lead.style.width = '0px';
            this.removeClones();
            this.root.classList.remove('is-scroll');
          }

          initMarquee() {
            this.resetMarquee();
            const padding = this.updatePadding();

            const isOverflow = this.track.scrollWidth > this.viewport.clientWidth;
            if (!isOverflow) return;

            this.root.classList.add('is-scroll');
            this.leadWidth = padding;
            this.lead.style.width = `${this.leadWidth}px`;

            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                const distance = this.ensureClones();
                if (distance <= 0) return;
                this.startScroll(distance);
              });
            });
          }

          _handleResize() {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
              this.initMarquee();
            }, 150);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["share-your-story-commitment"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('share-your-story-commitment')) {
      customElements.define(
        'share-your-story-commitment',
        class ShareYourStoryCommitment extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            const $mySwiper = this.querySelector('.share-your-story-commitment__swiper');
            const $next = this.querySelector('.share-your-story-commitment__next');
            const $prev = this.querySelector('.share-your-story-commitment__prev');
            const $pagination = this.querySelector('.share-your-story-commitment__pagination');
            const $scrollbar = this.querySelector('.share-your-story-commitment__scrollbar');

            if ($mySwiper) {
              const swiper = new Swiper($mySwiper, {
                slidesPerView: 'auto',
                centeredSlides: false,
                navigation: {
                  prevEl: $prev,
                  nextEl: $next,
                },
                scrollbar: {
                  el: $scrollbar,
                  draggable: true,
                },
                pagination: {
                  el: $pagination,
                  bulletClass: 'share-your-story-commitment__bullet',
                  bulletActiveClass: 'share-your-story-commitment__bullet_active',
                },
                breakpoints: {
                  0: {
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                    spaceBetween: 16,
                  },
                  769: {
                    slidesOffsetBefore: 32,
                    slidesOffsetAfter: 32,
                    spaceBetween: 24,
                  },
                  1201: {
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    spaceBetween: 24,
                  },
                },
                on: {
                  slideChange: function () {
                    if (this.isBeginning) {
                      $($prev).removeClass('flex').addClass('hidden');
                    } else {
                      $($prev).removeClass('hidden').addClass('flex');
                    }
                    if (this.isEnd) {
                      $($next).addClass('hidden');
                    } else {
                      $($next).removeClass('hidden');
                    }
                  },
                },
              });
            }
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tailgate-purchase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tailgate-purchase')) {
    class TailgateScene extends HTMLElement {
      constructor() {
        super();
        this._pickWrap = null;
        this._tabs = [];
        this._suits = [];
        this._panels = [];
        this._tabsWrap = null;
        this._swipers = new WeakMap();
        this._resizeTimer = null;
      }

      connectedCallback() {
        this._pickWrap = this.querySelector('tailgate-pubchase-pick');
        this._tabsWrap = this._pickWrap ? this._pickWrap.querySelector('.tailgate-purchase__tabs') : null;
        this._tabs = Array.from(this.querySelectorAll('.tailgate-tabs__item'));
        this._suits = Array.from(this.querySelectorAll('tailgate-purchase-suit'));
        this._panels = [...this._suits];

        this._setPickVisibility();
        if (this._tabs.length > 0 && this._suits.length > 0) {
          this.setActiveTab(0);
          this.setVisiblePanel(0);
        }

        this._boundClick = (e) => {
          if (e.target.closest('.tailgate-tabs__item')) this._onTabClick(e);
          else if (e.target.closest('.tailgate-purchase__panel_content_more')) this._handleMoreClick(e);
        };
        this.addEventListener('click', this._boundClick);

        this.youtubeClick();

        this._initActivePanelSwiper();
        this._initContentMaxHeight();
        // 监听窗口大小变化，切换到桌面端时重新初始化swiper
        window.addEventListener('resize', () => {
          clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(() => {
            this._initContentMaxHeight();
            this._handleResizeSwiper();
          }, 200);
        });

        // 监听卡片宽度变化事件
        this._boundCardWidthChange = (e) => {
          const panel = e.target.closest('.tailgate-purchase-suit__panel');
          if (panel) {
            const inst = this._swipers.get(panel);
            if (inst && inst.update) {
              inst.update();
            }
          }
        };
        this.addEventListener('card-width-changed', this._boundCardWidthChange);
      }

      _setPickVisibility() {
        if (!this._pickWrap) return;
        const hasTabs = this._tabs.length > 0;
        this._pickWrap.classList.toggle('hidden', !hasTabs);
      }

      setActiveTab(index) {
        this._tabs.forEach((t, i) => t.classList.toggle('tailgate-tabs__item--active', i === index));
      }

      setVisiblePanel(index) {
        this._panels.forEach((p, i) => {
          p.classList.toggle('hidden', i !== index);
        });
      }

      _onTabClick(e) {
        const tab = e.target.closest('.tailgate-tabs__item');
        if (!tab) return;
        const tabIndex = this._tabs.indexOf(tab);
        if (tabIndex === -1) return;
        this.setActiveTab(tabIndex);
        this.setVisiblePanel(tabIndex);
        const visiblePanel = this._panels[tabIndex];
        if (visiblePanel) this._initSwiperForPanel(visiblePanel);
        if (this._tabsWrap) {
          const tabRect = tab.getBoundingClientRect();
          const boxRect = this._tabsWrap.getBoundingClientRect();
          const tabCenter = tabRect.left + tabRect.width / 2;
          const boxCenter = boxRect.left + boxRect.width / 2;
          let targetScroll = this._tabsWrap.scrollLeft + tabCenter - boxCenter;
          const maxScroll = this._tabsWrap.scrollWidth - this._tabsWrap.clientWidth;
          targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
          this._tabsWrap.scrollTo({ left: targetScroll, behavior: 'smooth' });
        }
        this.dispatchEvent(new CustomEvent('tabchange', { detail: { tabIndex }, bubbles: true }));
      }

      //  youtube视频显示
      youtubeClick() {
        const youtubeWrappers = this.querySelectorAll('.youtube-wrapper');
        youtubeWrappers.forEach((youtubeWrapper) => {
          const youtubePlay = youtubeWrapper.querySelector('.youtube-play');
          if (!youtubePlay) return;
          youtubePlay.addEventListener('click', (e) => {
            e.stopPropagation(); // 防止冒泡触发到父级
            const iframe = youtubeWrapper.querySelector('iframe');
            iframe.src += '&autoplay=1';
            // 隐藏图片
            const youtubeImage = youtubeWrapper.querySelector('.youtube-image');
            youtubeImage.classList.add('hidden');
          });
        });
      }

      _initActivePanelSwiper() {
        const visible = this._panels.find((p) => !p.classList.contains('hidden'));
        if (visible) this._initSwiperForPanel(visible);
      }
      // 推荐产品列表swiper
      _initSwiperForPanel(panel) {
        // 屏幕宽度在960及以下时，禁用swiper逻辑
        if (window.innerWidth <= 768) {
          return;
        }

        if (!panel || this._swipers.has(panel)) {
          // 若已初始化则更新一次尺寸
          const inst = this._swipers.get(panel);
          if (inst && inst.update) inst.update();
          return;
        }
        const container = panel.querySelector('.tailgate-purchase-product-list_swiper');
        if (!container) return; // 非滑动模式时无swiper
        const nextEl = panel.querySelector('.tailgate-purchase-product-list_next');
        const prevEl = panel.querySelector('.tailgate-purchase-product-list_prev');
        const scrollbarEl = panel.querySelector('.tailgate-purchase-product-list_scrollbar');
        const paginationEl = panel.querySelector('.tailgate-purchase-product-list_swiper-pagination');

        const updateNav = (swp) => {
          if (!nextEl || !prevEl) return;
          if (swp.isBeginning) {
            prevEl.classList.add('hidden');
            prevEl.classList.remove('flex');
          } else {
            prevEl.classList.remove('hidden');
            prevEl.classList.add('flex');
          }
          if (swp.isEnd) {
            nextEl.classList.add('hidden');
          } else {
            nextEl.classList.remove('hidden');
          }
        };

        const swiper = new Swiper(container, {
          breakpoints: {
            577: { slidesPerView: 'auto', slidesPerGroup: 1, spaceBetween: 24 },
            0: { slidesPerView: 'auto', slidesPerGroup: 1, spaceBetween: 16 },
          },
          on: {
            init: function () {
              updateNav(this);
            },
            slideChange: function () {
              updateNav(this);
            },
          },
          navigation: { nextEl, prevEl },
          scrollbar: { el: scrollbarEl, draggable: true },
          pagination: {
            el: paginationEl,
            bulletClass: 'tailgate-purchase-product-list_bullet',
            bulletActiveClass: 'tailgate-purchase-product-list_bullet_active',
          },
        });
        this._swipers.set(panel, swiper);
      }

      // 计算1200及以上得滑条高度
      _initContentMaxHeight() {
        this._panels.forEach((panel) => {
          // 只处理 tailgate-purchase-suit 类型的 panel
          if (!panel.classList.contains('tailgate-purchase-suit__panel')) return;

          const imgWrapper = panel.querySelector('.tailgate-purchase-suit__panel_img');
          const content = panel.querySelector('.mtailgate-purchase-suit__content');
          if (!imgWrapper || !content) return;

          if (window.innerWidth <= 960) {
            content.style.maxHeight = '';
            return;
          }

          const imgRect = imgWrapper.getBoundingClientRect();
          const imgHeight = imgRect.height;
          if (imgHeight > 0) {
            content.style.maxHeight = `${imgHeight - 16}px`;
          }
        });
      }

      // 处理窗口大小变化时的swiper初始化
      _handleResizeSwiper() {
        this._panels.forEach((panel) => {
          const existingSwiper = this._swipers.get(panel);
          const nextEl = panel.querySelector('.tailgate-purchase-product-list_next');
          const prevEl = panel.querySelector('.tailgate-purchase-product-list_prev');
          const scrollbarEl = panel.querySelector('.tailgate-purchase-product-list_scrollbar');

          // 移动端：销毁swiper并隐藏导航按钮
          if (window.innerWidth <= 768) {
            if (existingSwiper) {
              existingSwiper.destroy(true, true);
              this._swipers.delete(panel);
            }
            if (nextEl) nextEl.classList.add('hidden');
            if (prevEl) prevEl.classList.add('hidden');
            if (scrollbarEl) scrollbarEl.classList.add('hidden');
            return;
          }
          // 桌面端：隐藏按钮在非首尾时由swiper内部控制，未初始化则创建
          if (nextEl) nextEl.classList.remove('hidden');
          if (prevEl) prevEl.classList.remove('hidden');
          if (scrollbarEl) scrollbarEl.classList.remove('hidden');
          this._initSwiperForPanel(panel);
        });
      }
    }

    customElements.define('tailgate-purchase', TailgateScene);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-my-order"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('track-my-order')) {
      customElements.define(
        'track-my-order',
        class extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.querySelector('.lt-track-order__button').addEventListener('click', () => {
              this.doTrack();
            });
          }

          doTrack() {
            var num = document.getElementById('YQNum').value;
            if (num === '') {
              alert('Enter your number.');
              return;
            }

            // 显示容器
            const container = document.getElementById('YQContainer');
            if (container) {
              container.style.display = 'block';
            }

            YQV5.trackSingle({
              YQ_ContainerId: 'YQContainer',
              YQ_Height: 560,
              YQ_Fc: '0',
              YQ_Lang: 'en',
              YQ_Num: num,
              YQ_Num: num,
              YQ_RmAD: true,
              YQ_RmHeader: true,
              YQ_RmLink: true,
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unpowered-ship-recan-v2"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('unpowered-ship-recan-v2')) {
      customElements.define(
        'unpowered-ship-recan-v2',
        class UnpoweredShipRecanV2 extends HTMLElement {
          constructor() {
            super();
            this._swiper = null;
            this._onFeaturedClick = this._handleFeaturedClick.bind(this);
            this._onFeaturedKeydown = this._handleFeaturedKeydown.bind(this);
            this._onCardClick = this._handleCardClick.bind(this);
            this._onCardKeydown = this._handleCardKeydown.bind(this);
          }

          connectedCallback() {
            this._featuredTrigger = this.querySelector('.unpowered-ship-recan-v2__featured-trigger[data-modal-id]');
            if (this._featuredTrigger) {
              this._featuredTrigger.addEventListener('click', this._onFeaturedClick);
              this._featuredTrigger.addEventListener('keydown', this._onFeaturedKeydown);
            }

            this.querySelectorAll('.unpowered-ship-recan-v2__card[data-modal-id]').forEach((card) => {
              card.addEventListener('click', this._onCardClick);
              card.addEventListener('keydown', this._onCardKeydown);
            });

            this._initSwiper();
          }

          disconnectedCallback() {
            if (this._featuredTrigger) {
              this._featuredTrigger.removeEventListener('click', this._onFeaturedClick);
              this._featuredTrigger.removeEventListener('keydown', this._onFeaturedKeydown);
            }

            this.querySelectorAll('.unpowered-ship-recan-v2__card[data-modal-id]').forEach((card) => {
              card.removeEventListener('click', this._onCardClick);
              card.removeEventListener('keydown', this._onCardKeydown);
            });

            if (this._swiper) {
              this._swiper.destroy(true, true);
              this._swiper = null;
            }
          }

          _initSwiper() {
            const swiperEl = this.querySelector('.unpowered-ship-recan-v2__swiper');
            if (!swiperEl || typeof Swiper === 'undefined') return;

            const slideCount = swiperEl.querySelectorAll('.unpowered-ship-recan-v2__slide').length;
            const centerSlides = slideCount > 0 && slideCount < 4;

            swiperEl.classList.toggle('unpowered-ship-recan-v2__swiper--few-slides', centerSlides);

            this._swiper = new Swiper(swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              slidesPerGroup: 1,
              centerInsufficientSlides: centerSlides,
              breakpoints: {
                0: { spaceBetween: 16 },
                577: { spaceBetween: 24 },
              },
            });
          }

          _handleFeaturedKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this._openModal(this._featuredTrigger.dataset.modalId);
          }

          _handleFeaturedClick() {
            this._openModal(this._featuredTrigger.dataset.modalId);
          }

          _handleCardKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this._openModal(event.currentTarget.dataset.modalId);
          }

          _handleCardClick(event) {
            this._openModal(event.currentTarget.dataset.modalId);
          }

          _getModalManager() {
            window.litime = window.litime || {};
            if (!window.litime.ModalControllerState) {
              window.litime.ModalControllerState = new ModalController();
            }
            return window.litime.ModalControllerState;
          }

          _openModal(modalId) {
            if (!modalId) return;

            const manager = this._getModalManager();
            if (!manager) return;

            if (!manager.getModal(modalId)) {
              manager.register(modalId, {
                onOpen: (container) => this._onModalOpen(container),
                onClose: (container) => this._onModalClose(container),
              });
            }

            manager.open(modalId);
          }

          _onModalOpen(container) {
            const iframe = container?.querySelector('.social-video-embed__iframe');
            if (!iframe) return;

            const platform = iframe.closest('.social-video-embed')?.dataset.platform;
            if (!iframe.dataset.originalSrc) {
              iframe.dataset.originalSrc = iframe.getAttribute('src') || '';
            }

            let src = iframe.dataset.originalSrc;
            if (!src) return;

            if (platform === 'youtube' && !src.includes('autoplay=1')) {
              src = `${src}${src.includes('?') ? '&' : '?'}autoplay=1&mute=1&enablejsapi=1`;
            }

            if (platform === 'facebook' && !src.includes('autoplay=true')) {
              src = `${src}&autoplay=true`;
            }

            iframe.setAttribute('src', src);
          }

          _onModalClose(container) {
            const iframe = container?.querySelector('.social-video-embed__iframe');
            if (!iframe) return;
            iframe.setAttribute('src', '');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-story-latest-videos"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    if (!customElements.get('user-story-latest-videos')) {
      customElements.define(
        'user-story-latest-videos',
        class UserStoryLatestVideos extends HTMLElement {
          swiper = null;

          constructor() {
            super();
            window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
            this.modalManager = window.litime.ModalControllerState;
          }

          connectedCallback() {
            this.init();
          }

          disconnectedCallback() {
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
          }

          init() {
            const $root = $(this);
            const _this = this;
            const $videoItems = $root.find('.video_item');
            $videoItems.on('click', function (event) {
              _this.handlePlayClick(event);
            });

            const $mySwiper = this.querySelector('.user-story-latest-videos_swiper');
            if (!$mySwiper) return;

            const slideCount = $mySwiper.querySelectorAll('.swiper-slide').length;
            if (slideCount <= 1) return;

            const $controls = this.querySelector('.user-story-latest-videos__controls');
            const $prev = this.querySelector('.swiper-button-prev');
            const $next = this.querySelector('.swiper-button-next');
            const $progressFill = this.querySelector('.user-story-latest-videos__progress-fill');
            const $progressBar = this.querySelector('.user-story-latest-videos__progress');

            if ($controls) {
              $controls.hidden = true;
            }

            const updateProgress = (swiper) => {
              if (!$progressFill || !swiper) return;
              const snapCount = swiper.snapGrid?.length || slideCount;
              const currentIndex = typeof swiper.snapIndex === 'number' ? swiper.snapIndex : swiper.activeIndex;
              const segmentWidth = 100 / snapCount;
              $progressFill.style.width = `${segmentWidth}%`;
              $progressFill.style.transform = `translateX(${currentIndex * 100}%)`;
              if ($progressBar) {
                $progressBar.setAttribute('aria-valuemax', String(snapCount));
                $progressBar.setAttribute('aria-valuenow', String(currentIndex + 1));
              }
            };

            this.swiper = new Swiper($mySwiper, {
              slidesPerView: 1,
              spaceBetween: 24,
              slidesPerGroup: 1,
              speed: 400,
              watchOverflow: true,
              observer: true,
              observeParents: true,
              navigation: {
                nextEl: $next,
                prevEl: $prev,
              },
              breakpoints: {
                1201: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                  slidesPerGroup: 1,
                },
              },
              on: {
                init: (swiper) => {
                  updateProgress(swiper);
                  this.updateControlsVisibility(swiper);
                },
                slideChange: (swiper) => {
                  updateProgress(swiper);
                  this.updateControlsVisibility(swiper);
                },
                breakpoint: (swiper) => {
                  updateProgress(swiper);
                  this.updateControlsVisibility(swiper);
                },
                resize: (swiper) => {
                  updateProgress(swiper);
                  this.updateControlsVisibility(swiper);
                },
              },
            });
          }

          updateControlsVisibility(swiper) {
            const controls = this.querySelector('.user-story-latest-videos__controls');
            if (!controls || !swiper) return;
            controls.hidden = swiper.isLocked;
          }

          handlePlayClick(event) {
            const $video = $(event.currentTarget);
            const modalId = $video.data('id');
            const _this = this;
            if (!this.modalManager.getModal(modalId)) {
              this.modalManager.register(modalId, {
                onOpen: (container) => {
                  const iframe = $(container).find('iframe');
                  const currentSrc = iframe.attr('src');
                  const newSrc = currentSrc + '&autoplay=1&playsinline=1&mute=1&enablejsapi=1';
                  setTimeout(() => {
                    iframe.attr('src', newSrc);
                    try {
                      const iframeElement = iframe[0];
                      iframeElement.contentWindow.postMessage(
                        JSON.stringify({
                          event: 'command',
                          func: 'playVideo',
                        }),
                        '*'
                      );
                    } catch (error) {
                      console.error('Failed to post play message:', error);
                    }
                  }, 0);
                  _this.initMobileYouTubeControl(container, modalId);
                },
                onClose: (container) => {
                  const $container = $(container);
                  $container.off('.userStoryLatestVideos');
                  const youtubeMessageHandler = $container.data('userStoryYouTubeMessage');
                  if (youtubeMessageHandler) {
                    window.removeEventListener('message', youtubeMessageHandler);
                    $container.removeData('userStoryYouTubeMessage');
                  }
                  const iframe = $container.find('iframe');
                  const currentSrc = iframe.attr('src');
                  iframe.attr('src', currentSrc.replace('&autoplay=1&playsinline=1&mute=1&enablejsapi=1', ''));
                },
              });
            }
            this.modalManager.open(modalId);
          }

          initMobileYouTubeControl(container, modalId) {
            const $container = $(container);
            const $modalContent = $container.find('.user-story-latest-videos__modal-content');
            const $videoArea = $modalContent.find('.user-story-latest-videos__modal-video');
            const $closeBtn = $modalContent.find('.global-modal__close_btn');
            const iframe = $videoArea.find('iframe')[0];
            if (!iframe || !$closeBtn.length) return;

            $container.off('.userStoryLatestVideos');

            let isMobile = window.innerWidth <= 768;
            let isPlaying = true;

            const togglePlayback = () => {
              try {
                const func = isPlaying ? 'pauseVideo' : 'playVideo';
                iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func }), '*');
                isPlaying = !isPlaying;
              } catch (error) {
                console.error('Failed to control YouTube video:', error);
              }
            };

            let closeTriggered = false;
            const handleClose = (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (closeTriggered) return;
              closeTriggered = true;
              this.modalManager.close(modalId);
            };

            $closeBtn.on('touchend.userStoryLatestVideos', handleClose);

            $videoArea.on('click.userStoryLatestVideos', (e) => {
              if (!isMobile) return;
              e.preventDefault();
              e.stopPropagation();
              togglePlayback();
            });

            $videoArea.on('touchend.userStoryLatestVideos', (e) => {
              if (!isMobile) return;
              e.preventDefault();
              e.stopPropagation();
              togglePlayback();
            });

            const onYouTubeMessage = (event) => {
              if (event.origin !== 'https://www.youtube.com') return;
              try {
                const data = JSON.parse(event.data);
                if (data.event === 'video-progress' && data.info && data.info.playerState !== undefined) {
                  isPlaying = data.info.playerState === 1;
                }
              } catch (error) {
                // ignore parse errors
              }
            };

            window.addEventListener('message', onYouTubeMessage);
            $container.data('userStoryYouTubeMessage', onYouTubeMessage);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();
})();
